import { jsxs as K, jsx as b, Fragment as wi } from "react/jsx-runtime";
import * as ie from "react";
import xr, { createContext as Bv, useContext as Yo, forwardRef as Z, useMemo as _e, memo as Wv, createElement as $n, Children as Ya, isValidElement as td, cloneElement as rd, useRef as at, useLayoutEffect as Jw, useEffect as Ce, useState as We, useCallback as lt, useInsertionEffect as Zw, useId as Hn, useSyncExternalStore as Qw, Fragment as eS, PureComponent as tS } from "react";
import { useAccount as Kr, useWaitForTransactionReceipt as Hv, useWriteContract as rS, useBalance as nS, useSendTransaction as iS, useReadContract as jv, useChains as Uv, useSwitchChain as oS, WagmiContext as sS } from "wagmi";
import aS, { flushSync as nd, createPortal as lS } from "react-dom";
import cS from "react-dom/server";
import { useQuery as vn, useQueryClient as Gv } from "@tanstack/react-query";
const Yt = (...e) => e.filter(Boolean).map((t) => t.trim()).join(" ");
function uS(e, t) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${t}`;
}
function Io(e = {}) {
  const {
    name: t,
    strict: r = !0,
    hookName: n = "useContext",
    providerName: i = "Provider",
    errorMessage: o,
    defaultValue: s
  } = e, a = Bv(s);
  a.displayName = t;
  function l() {
    var u;
    const c = Yo(a);
    if (!c && r) {
      const f = new Error(
        o != null ? o : uS(n, i)
      );
      throw f.name = "ContextError", (u = Error.captureStackTrace) == null || u.call(Error, f, l), f;
    }
    return c;
  }
  return [a.Provider, l, a];
}
function dS(...e) {
  return function(...r) {
    e.forEach((n) => n == null ? void 0 : n(...r));
  };
}
const fS = (...e) => e.map((t) => {
  var r;
  return (r = t == null ? void 0 : t.trim) == null ? void 0 : r.call(t);
}).filter(Boolean).join(" "), hS = /^on[A-Z]/;
function Fo(...e) {
  var r, n;
  let t = {};
  for (let i of e) {
    for (let o in t) {
      if (hS.test(o) && typeof t[o] == "function" && typeof i[o] == "function") {
        t[o] = dS(t[o], i[o]);
        continue;
      }
      if (o === "className" || o === "class") {
        t[o] = fS(t[o], i[o]);
        continue;
      }
      if (o === "style") {
        t[o] = Object.assign({}, (r = t[o]) != null ? r : {}, (n = i[o]) != null ? n : {});
        continue;
      }
      t[o] = i[o] !== void 0 ? i[o] : t[o];
    }
    for (let o in i)
      t[o] === void 0 && (t[o] = i[o]);
  }
  return t;
}
const pS = Object.freeze({}), gS = Object.freeze(
  {}
);
function qv(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var mS = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, vS = /* @__PURE__ */ qv(
  function(e) {
    return mS.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
function bS(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function yS(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var xS = /* @__PURE__ */ function() {
  function e(r) {
    var n = this;
    this._insertTag = function(i) {
      var o;
      n.tags.length === 0 ? n.insertionPoint ? o = n.insertionPoint.nextSibling : n.prepend ? o = n.container.firstChild : o = n.before : o = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(i, o), n.tags.push(i);
    }, this.isSpeedy = r.speedy === void 0 ? !0 : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(yS(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var o = bS(i);
      try {
        o.insertRule(n, o.cssRules.length);
      } catch (s) {
      }
    } else
      i.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      var i;
      return (i = n.parentNode) == null ? void 0 : i.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), ft = "-ms-", fa = "-moz-", be = "-webkit-", Kv = "comm", id = "rule", od = "decl", _S = "@import", Yv = "@keyframes", wS = "@layer", SS = Math.abs, Xa = String.fromCharCode, ES = Object.assign;
function CS(e, t) {
  return st(e, 0) ^ 45 ? (((t << 2 ^ st(e, 0)) << 2 ^ st(e, 1)) << 2 ^ st(e, 2)) << 2 ^ st(e, 3) : 0;
}
function Xv(e) {
  return e.trim();
}
function kS(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function ye(e, t, r) {
  return e.replace(t, r);
}
function zc(e, t) {
  return e.indexOf(t);
}
function st(e, t) {
  return e.charCodeAt(t) | 0;
}
function $o(e, t, r) {
  return e.slice(t, r);
}
function pr(e) {
  return e.length;
}
function sd(e) {
  return e.length;
}
function gs(e, t) {
  return t.push(e), e;
}
function IS(e, t) {
  return e.map(t).join("");
}
var Ja = 1, Si = 1, Jv = 0, Tt = 0, Ge = 0, Ri = "";
function Za(e, t, r, n, i, o, s) {
  return { value: e, root: t, parent: r, type: n, props: i, children: o, line: Ja, column: Si, length: s, return: "" };
}
function Ki(e, t) {
  return ES(Za("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function OS() {
  return Ge;
}
function PS() {
  return Ge = Tt > 0 ? st(Ri, --Tt) : 0, Si--, Ge === 10 && (Si = 1, Ja--), Ge;
}
function zt() {
  return Ge = Tt < Jv ? st(Ri, Tt++) : 0, Si++, Ge === 10 && (Si = 1, Ja++), Ge;
}
function _r() {
  return st(Ri, Tt);
}
function Ws() {
  return Tt;
}
function Xo(e, t) {
  return $o(Ri, e, t);
}
function Lo(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Zv(e) {
  return Ja = Si = 1, Jv = pr(Ri = e), Tt = 0, [];
}
function Qv(e) {
  return Ri = "", e;
}
function Hs(e) {
  return Xv(Xo(Tt - 1, Dc(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function TS(e) {
  for (; (Ge = _r()) && Ge < 33; )
    zt();
  return Lo(e) > 2 || Lo(Ge) > 3 ? "" : " ";
}
function RS(e, t) {
  for (; --t && zt() && !(Ge < 48 || Ge > 102 || Ge > 57 && Ge < 65 || Ge > 70 && Ge < 97); )
    ;
  return Xo(e, Ws() + (t < 6 && _r() == 32 && zt() == 32));
}
function Dc(e) {
  for (; zt(); )
    switch (Ge) {
      // ] ) " '
      case e:
        return Tt;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && Dc(Ge);
        break;
      // (
      case 40:
        e === 41 && Dc(e);
        break;
      // \
      case 92:
        zt();
        break;
    }
  return Tt;
}
function AS(e, t) {
  for (; zt() && e + Ge !== 57; )
    if (e + Ge === 84 && _r() === 47)
      break;
  return "/*" + Xo(t, Tt - 1) + "*" + Xa(e === 47 ? e : zt());
}
function NS(e) {
  for (; !Lo(_r()); )
    zt();
  return Xo(e, Tt);
}
function FS(e) {
  return Qv(js("", null, null, null, [""], e = Zv(e), 0, [0], e));
}
function js(e, t, r, n, i, o, s, a, l) {
  for (var c = 0, u = 0, f = s, d = 0, p = 0, g = 0, h = 1, m = 1, v = 1, y = 0, x = "", S = i, _ = o, I = n, O = x; m; )
    switch (g = y, y = zt()) {
      // (
      case 40:
        if (g != 108 && st(O, f - 1) == 58) {
          zc(O += ye(Hs(y), "&", "&\f"), "&\f") != -1 && (v = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        O += Hs(y);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        O += TS(g);
        break;
      // \
      case 92:
        O += RS(Ws() - 1, 7);
        continue;
      // /
      case 47:
        switch (_r()) {
          case 42:
          case 47:
            gs($S(AS(zt(), Ws()), t, r), l);
            break;
          default:
            O += "/";
        }
        break;
      // {
      case 123 * h:
        a[c++] = pr(O) * v;
      // } ; \0
      case 125 * h:
      case 59:
      case 0:
        switch (y) {
          // \0 }
          case 0:
          case 125:
            m = 0;
          // ;
          case 59 + u:
            v == -1 && (O = ye(O, /\f/g, "")), p > 0 && pr(O) - f && gs(p > 32 ? Df(O + ";", n, r, f - 1) : Df(ye(O, " ", "") + ";", n, r, f - 2), l);
            break;
          // @ ;
          case 59:
            O += ";";
          // { rule/at-rule
          default:
            if (gs(I = zf(O, t, r, c, u, i, a, x, S = [], _ = [], f), o), y === 123)
              if (u === 0)
                js(O, t, I, I, S, o, f, a, _);
              else
                switch (d === 99 && st(O, 3) === 110 ? 100 : d) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    js(e, I, I, n && gs(zf(e, I, I, 0, 0, i, a, x, i, S = [], f), _), i, _, f, a, n ? S : _);
                    break;
                  default:
                    js(O, I, I, I, [""], _, 0, a, _);
                }
        }
        c = u = p = 0, h = v = 1, x = O = "", f = s;
        break;
      // :
      case 58:
        f = 1 + pr(O), p = g;
      default:
        if (h < 1) {
          if (y == 123)
            --h;
          else if (y == 125 && h++ == 0 && PS() == 125)
            continue;
        }
        switch (O += Xa(y), y * h) {
          // &
          case 38:
            v = u > 0 ? 1 : (O += "\f", -1);
            break;
          // ,
          case 44:
            a[c++] = (pr(O) - 1) * v, v = 1;
            break;
          // @
          case 64:
            _r() === 45 && (O += Hs(zt())), d = _r(), u = f = pr(x = O += NS(Ws())), y++;
            break;
          // -
          case 45:
            g === 45 && pr(O) == 2 && (h = 0);
        }
    }
  return o;
}
function zf(e, t, r, n, i, o, s, a, l, c, u) {
  for (var f = i - 1, d = i === 0 ? o : [""], p = sd(d), g = 0, h = 0, m = 0; g < n; ++g)
    for (var v = 0, y = $o(e, f + 1, f = SS(h = s[g])), x = e; v < p; ++v)
      (x = Xv(h > 0 ? d[v] + " " + y : ye(y, /&\f/g, d[v]))) && (l[m++] = x);
  return Za(e, t, r, i === 0 ? id : a, l, c, u);
}
function $S(e, t, r) {
  return Za(e, t, r, Kv, Xa(OS()), $o(e, 2, -2), 0);
}
function Df(e, t, r, n) {
  return Za(e, t, r, od, $o(e, 0, n), $o(e, n + 1, -1), n);
}
function vi(e, t) {
  for (var r = "", n = sd(e), i = 0; i < n; i++)
    r += t(e[i], i, e, t) || "";
  return r;
}
function LS(e, t, r, n) {
  switch (e.type) {
    case wS:
      if (e.children.length) break;
    case _S:
    case od:
      return e.return = e.return || e.value;
    case Kv:
      return "";
    case Yv:
      return e.return = e.value + "{" + vi(e.children, n) + "}";
    case id:
      e.value = e.props.join(",");
  }
  return pr(r = vi(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function VS(e) {
  var t = sd(e);
  return function(r, n, i, o) {
    for (var s = "", a = 0; a < t; a++)
      s += e[a](r, n, i, o) || "";
    return s;
  };
}
function zS(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var Mf = function(t) {
  var r = /* @__PURE__ */ new WeakMap();
  return function(n) {
    if (r.has(n))
      return r.get(n);
    var i = t(n);
    return r.set(n, i), i;
  };
}, DS = function(t, r, n) {
  for (var i = 0, o = 0; i = o, o = _r(), i === 38 && o === 12 && (r[n] = 1), !Lo(o); )
    zt();
  return Xo(t, Tt);
}, MS = function(t, r) {
  var n = -1, i = 44;
  do
    switch (Lo(i)) {
      case 0:
        i === 38 && _r() === 12 && (r[n] = 1), t[n] += DS(Tt - 1, r, n);
        break;
      case 2:
        t[n] += Hs(i);
        break;
      case 4:
        if (i === 44) {
          t[++n] = _r() === 58 ? "&\f" : "", r[n] = t[n].length;
          break;
        }
      // fallthrough
      default:
        t[n] += Xa(i);
    }
  while (i = zt());
  return t;
}, BS = function(t, r) {
  return Qv(MS(Zv(t), r));
}, Bf = /* @__PURE__ */ new WeakMap(), WS = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var r = t.value, n = t.parent, i = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(t.props.length === 1 && r.charCodeAt(0) !== 58 && !Bf.get(n)) && !i) {
      Bf.set(t, !0);
      for (var o = [], s = BS(r, o), a = n.props, l = 0, c = 0; l < s.length; l++)
        for (var u = 0; u < a.length; u++, c++)
          t.props[c] = o[l] ? s[l].replace(/&\f/g, a[u]) : a[u] + " " + s[l];
    }
  }
}, HS = function(t) {
  if (t.type === "decl") {
    var r = t.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function eb(e, t) {
  switch (CS(e, t)) {
    // color-adjust
    case 5103:
      return be + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return be + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return be + e + fa + e + ft + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return be + e + ft + e + e;
    // order
    case 6165:
      return be + e + ft + "flex-" + e + e;
    // align-items
    case 5187:
      return be + e + ye(e, /(\w+).+(:[^]+)/, be + "box-$1$2" + ft + "flex-$1$2") + e;
    // align-self
    case 5443:
      return be + e + ft + "flex-item-" + ye(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return be + e + ft + "flex-line-pack" + ye(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return be + e + ft + ye(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return be + e + ft + ye(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return be + "box-" + ye(e, "-grow", "") + be + e + ft + ye(e, "grow", "positive") + e;
    // transition
    case 4554:
      return be + ye(e, /([^-])(transform)/g, "$1" + be + "$2") + e;
    // cursor
    case 6187:
      return ye(ye(ye(e, /(zoom-|grab)/, be + "$1"), /(image-set)/, be + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return ye(e, /(image-set\([^]*)/, be + "$1$`$1");
    // justify-content
    case 4968:
      return ye(ye(e, /(.+:)(flex-)?(.*)/, be + "box-pack:$3" + ft + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + be + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ye(e, /(.+)-inline(.+)/, be + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (pr(e) - 1 - t > 6) switch (st(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (st(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return ye(e, /(.+:)(.+)-([^]+)/, "$1" + be + "$2-$3$1" + fa + (st(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~zc(e, "stretch") ? eb(ye(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (st(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (st(e, pr(e) - 3 - (~zc(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return ye(e, ":", ":" + be) + e;
        // (inline-)?fl(e)x
        case 101:
          return ye(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + be + (st(e, 14) === 45 ? "inline-" : "") + "box$3$1" + be + "$2$3$1" + ft + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (st(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return be + e + ft + ye(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return be + e + ft + ye(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return be + e + ft + ye(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return be + e + ft + e + e;
  }
  return e;
}
var jS = function(t, r, n, i) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case od:
      t.return = eb(t.value, t.length);
      break;
    case Yv:
      return vi([Ki(t, {
        value: ye(t.value, "@", "@" + be)
      })], i);
    case id:
      if (t.length) return IS(t.props, function(o) {
        switch (kS(o, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return vi([Ki(t, {
              props: [ye(o, /:(read-\w+)/, ":" + fa + "$1")]
            })], i);
          // :placeholder
          case "::placeholder":
            return vi([Ki(t, {
              props: [ye(o, /:(plac\w+)/, ":" + be + "input-$1")]
            }), Ki(t, {
              props: [ye(o, /:(plac\w+)/, ":" + fa + "$1")]
            }), Ki(t, {
              props: [ye(o, /:(plac\w+)/, ft + "input-$1")]
            })], i);
        }
        return "";
      });
  }
}, US = [jS], ad = function(t) {
  var r = t.key;
  if (r === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(h) {
      var m = h.getAttribute("data-emotion");
      m.indexOf(" ") !== -1 && (document.head.appendChild(h), h.setAttribute("data-s", ""));
    });
  }
  var i = t.stylisPlugins || US, o = {}, s, a = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(h) {
      for (var m = h.getAttribute("data-emotion").split(" "), v = 1; v < m.length; v++)
        o[m[v]] = !0;
      a.push(h);
    }
  );
  var l, c = [WS, HS];
  {
    var u, f = [LS, zS(function(h) {
      u.insert(h);
    })], d = VS(c.concat(i, f)), p = function(m) {
      return vi(FS(m), d);
    };
    l = function(m, v, y, x) {
      u = y, p(m ? m + "{" + v.styles + "}" : v.styles), x && (g.inserted[v.name] = !0);
    };
  }
  var g = {
    key: r,
    sheet: new xS({
      key: r,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: o,
    registered: {},
    insert: l
  };
  return g.sheet.hydrate(a), g;
};
const GS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ad
}, Symbol.toStringTag, { value: "Module" }));
function Vo() {
  return Vo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vo.apply(null, arguments);
}
var Wf = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function ld(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function tb(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var ms = { exports: {} }, Se = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hf;
function qS() {
  if (Hf) return Se;
  Hf = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function x(_) {
    if (typeof _ == "object" && _ !== null) {
      var I = _.$$typeof;
      switch (I) {
        case t:
          switch (_ = _.type, _) {
            case l:
            case c:
            case n:
            case o:
            case i:
            case f:
              return _;
            default:
              switch (_ = _ && _.$$typeof, _) {
                case a:
                case u:
                case g:
                case p:
                case s:
                  return _;
                default:
                  return I;
              }
          }
        case r:
          return I;
      }
    }
  }
  function S(_) {
    return x(_) === c;
  }
  return Se.AsyncMode = l, Se.ConcurrentMode = c, Se.ContextConsumer = a, Se.ContextProvider = s, Se.Element = t, Se.ForwardRef = u, Se.Fragment = n, Se.Lazy = g, Se.Memo = p, Se.Portal = r, Se.Profiler = o, Se.StrictMode = i, Se.Suspense = f, Se.isAsyncMode = function(_) {
    return S(_) || x(_) === l;
  }, Se.isConcurrentMode = S, Se.isContextConsumer = function(_) {
    return x(_) === a;
  }, Se.isContextProvider = function(_) {
    return x(_) === s;
  }, Se.isElement = function(_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === t;
  }, Se.isForwardRef = function(_) {
    return x(_) === u;
  }, Se.isFragment = function(_) {
    return x(_) === n;
  }, Se.isLazy = function(_) {
    return x(_) === g;
  }, Se.isMemo = function(_) {
    return x(_) === p;
  }, Se.isPortal = function(_) {
    return x(_) === r;
  }, Se.isProfiler = function(_) {
    return x(_) === o;
  }, Se.isStrictMode = function(_) {
    return x(_) === i;
  }, Se.isSuspense = function(_) {
    return x(_) === f;
  }, Se.isValidElementType = function(_) {
    return typeof _ == "string" || typeof _ == "function" || _ === n || _ === c || _ === o || _ === i || _ === f || _ === d || typeof _ == "object" && _ !== null && (_.$$typeof === g || _.$$typeof === p || _.$$typeof === s || _.$$typeof === a || _.$$typeof === u || _.$$typeof === m || _.$$typeof === v || _.$$typeof === y || _.$$typeof === h);
  }, Se.typeOf = x, Se;
}
var Ee = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jf;
function KS() {
  return jf || (jf = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function x(U) {
      return typeof U == "string" || typeof U == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      U === n || U === c || U === o || U === i || U === f || U === d || typeof U == "object" && U !== null && (U.$$typeof === g || U.$$typeof === p || U.$$typeof === s || U.$$typeof === a || U.$$typeof === u || U.$$typeof === m || U.$$typeof === v || U.$$typeof === y || U.$$typeof === h);
    }
    function S(U) {
      if (typeof U == "object" && U !== null) {
        var se = U.$$typeof;
        switch (se) {
          case t:
            var we = U.type;
            switch (we) {
              case l:
              case c:
              case n:
              case o:
              case i:
              case f:
                return we;
              default:
                var ze = we && we.$$typeof;
                switch (ze) {
                  case a:
                  case u:
                  case g:
                  case p:
                  case s:
                    return ze;
                  default:
                    return se;
                }
            }
          case r:
            return se;
        }
      }
    }
    var _ = l, I = c, O = a, w = s, E = t, T = u, G = n, k = g, j = p, F = r, L = o, D = i, N = f, B = !1;
    function q(U) {
      return B || (B = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), P(U) || S(U) === l;
    }
    function P(U) {
      return S(U) === c;
    }
    function C(U) {
      return S(U) === a;
    }
    function W(U) {
      return S(U) === s;
    }
    function H(U) {
      return typeof U == "object" && U !== null && U.$$typeof === t;
    }
    function V(U) {
      return S(U) === u;
    }
    function Q(U) {
      return S(U) === n;
    }
    function X(U) {
      return S(U) === g;
    }
    function ne(U) {
      return S(U) === p;
    }
    function R(U) {
      return S(U) === r;
    }
    function M(U) {
      return S(U) === o;
    }
    function z(U) {
      return S(U) === i;
    }
    function Y(U) {
      return S(U) === f;
    }
    Ee.AsyncMode = _, Ee.ConcurrentMode = I, Ee.ContextConsumer = O, Ee.ContextProvider = w, Ee.Element = E, Ee.ForwardRef = T, Ee.Fragment = G, Ee.Lazy = k, Ee.Memo = j, Ee.Portal = F, Ee.Profiler = L, Ee.StrictMode = D, Ee.Suspense = N, Ee.isAsyncMode = q, Ee.isConcurrentMode = P, Ee.isContextConsumer = C, Ee.isContextProvider = W, Ee.isElement = H, Ee.isForwardRef = V, Ee.isFragment = Q, Ee.isLazy = X, Ee.isMemo = ne, Ee.isPortal = R, Ee.isProfiler = M, Ee.isStrictMode = z, Ee.isSuspense = Y, Ee.isValidElementType = x, Ee.typeOf = S;
  }()), Ee;
}
var Uf;
function cd() {
  return Uf || (Uf = 1, process.env.NODE_ENV === "production" ? ms.exports = qS() : ms.exports = KS()), ms.exports;
}
var Dl, Gf;
function YS() {
  if (Gf) return Dl;
  Gf = 1;
  var e = cd(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, r = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, n = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, i = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, o = {};
  o[e.ForwardRef] = n, o[e.Memo] = i;
  function s(g) {
    return e.isMemo(g) ? i : o[g.$$typeof] || t;
  }
  var a = Object.defineProperty, l = Object.getOwnPropertyNames, c = Object.getOwnPropertySymbols, u = Object.getOwnPropertyDescriptor, f = Object.getPrototypeOf, d = Object.prototype;
  function p(g, h, m) {
    if (typeof h != "string") {
      if (d) {
        var v = f(h);
        v && v !== d && p(g, v, m);
      }
      var y = l(h);
      c && (y = y.concat(c(h)));
      for (var x = s(g), S = s(h), _ = 0; _ < y.length; ++_) {
        var I = y[_];
        if (!r[I] && !(m && m[I]) && !(S && S[I]) && !(x && x[I])) {
          var O = u(h, I);
          try {
            a(g, I, O);
          } catch (w) {
          }
        }
      }
    }
    return g;
  }
  return Dl = p, Dl;
}
var XS = YS();
const JS = /* @__PURE__ */ ld(XS);
var ZS = function(e, t) {
  return JS(e, t);
}, QS = !0;
function ud(e, t, r) {
  var n = "";
  return r.split(" ").forEach(function(i) {
    e[i] !== void 0 ? t.push(e[i] + ";") : i && (n += i + " ");
  }), n;
}
var Qa = function(t, r, n) {
  var i = t.key + "-" + r.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  QS === !1) && t.registered[i] === void 0 && (t.registered[i] = r.styles);
}, el = function(t, r, n) {
  Qa(t, r, n);
  var i = t.key + "-" + r.name;
  if (t.inserted[r.name] === void 0) {
    var o = r;
    do
      t.insert(r === o ? "." + i : "", o, t.sheet, !0), o = o.next;
    while (o !== void 0);
  }
};
function e1(e) {
  for (var t = 0, r, n = 0, i = e.length; i >= 4; ++n, i -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var t1 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, r1 = /[A-Z]|^ms/g, n1 = /_EMO_([^_]+?)_([^]*?)_EMO_/g, rb = function(t) {
  return t.charCodeAt(1) === 45;
}, qf = function(t) {
  return t != null && typeof t != "boolean";
}, Ml = /* @__PURE__ */ qv(function(e) {
  return rb(e) ? e : e.replace(r1, "-$&").toLowerCase();
}), Kf = function(t, r) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace(n1, function(n, i, o) {
          return gr = {
            name: i,
            styles: o,
            next: gr
          }, i;
        });
  }
  return t1[t] !== 1 && !rb(t) && typeof r == "number" && r !== 0 ? r + "px" : r;
};
function zo(e, t, r) {
  if (r == null)
    return "";
  var n = r;
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      var i = r;
      if (i.anim === 1)
        return gr = {
          name: i.name,
          styles: i.styles,
          next: gr
        }, i.name;
      var o = r;
      if (o.styles !== void 0) {
        var s = o.next;
        if (s !== void 0)
          for (; s !== void 0; )
            gr = {
              name: s.name,
              styles: s.styles,
              next: gr
            }, s = s.next;
        var a = o.styles + ";";
        return a;
      }
      return i1(e, t, r);
    }
    case "function": {
      if (e !== void 0) {
        var l = gr, c = r(e);
        return gr = l, zo(e, t, c);
      }
      break;
    }
  }
  var u = r;
  if (t == null)
    return u;
  var f = t[u];
  return f !== void 0 ? f : u;
}
function i1(e, t, r) {
  var n = "";
  if (Array.isArray(r))
    for (var i = 0; i < r.length; i++)
      n += zo(e, t, r[i]) + ";";
  else
    for (var o in r) {
      var s = r[o];
      if (typeof s != "object") {
        var a = s;
        t != null && t[a] !== void 0 ? n += o + "{" + t[a] + "}" : qf(a) && (n += Ml(o) + ":" + Kf(o, a) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
        for (var l = 0; l < s.length; l++)
          qf(s[l]) && (n += Ml(o) + ":" + Kf(o, s[l]) + ";");
      else {
        var c = zo(e, t, s);
        switch (o) {
          case "animation":
          case "animationName": {
            n += Ml(o) + ":" + c + ";";
            break;
          }
          default:
            n += o + "{" + c + "}";
        }
      }
    }
  return n;
}
var Yf = /label:\s*([^\s;{]+)\s*(;|$)/g, gr;
function Jo(e, t, r) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var n = !0, i = "";
  gr = void 0;
  var o = e[0];
  if (o == null || o.raw === void 0)
    n = !1, i += zo(r, t, o);
  else {
    var s = o;
    i += s[0];
  }
  for (var a = 1; a < e.length; a++)
    if (i += zo(r, t, e[a]), n) {
      var l = o;
      i += l[a];
    }
  Yf.lastIndex = 0;
  for (var c = "", u; (u = Yf.exec(i)) !== null; )
    c += "-" + u[1];
  var f = e1(i) + c;
  return {
    name: f,
    styles: i,
    next: gr
  };
}
var o1 = function(t) {
  return t();
}, nb = ie.useInsertionEffect ? ie.useInsertionEffect : !1, dd = nb || o1, Xf = nb || ie.useLayoutEffect, fd = /* @__PURE__ */ ie.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement != "undefined" ? /* @__PURE__ */ ad({
    key: "css"
  }) : null
), ib = fd.Provider, s1 = function() {
  return Yo(fd);
}, Zo = function(t) {
  return /* @__PURE__ */ Z(function(r, n) {
    var i = Yo(fd);
    return t(r, i, n);
  });
}, Hr = /* @__PURE__ */ ie.createContext({}), a1 = function() {
  return ie.useContext(Hr);
}, l1 = function(t, r) {
  if (typeof r == "function") {
    var n = r(t);
    return n;
  }
  return Vo({}, t, r);
}, c1 = /* @__PURE__ */ Mf(function(e) {
  return Mf(function(t) {
    return l1(e, t);
  });
}), u1 = function(t) {
  var r = ie.useContext(Hr);
  return t.theme !== r && (r = c1(r)(t.theme)), /* @__PURE__ */ ie.createElement(Hr.Provider, {
    value: r
  }, t.children);
};
function d1(e) {
  var t = e.displayName || e.name || "Component", r = /* @__PURE__ */ ie.forwardRef(function(i, o) {
    var s = ie.useContext(Hr);
    return /* @__PURE__ */ ie.createElement(e, Vo({
      theme: s,
      ref: o
    }, i));
  });
  return r.displayName = "WithTheme(" + t + ")", ZS(r, e);
}
var hd = {}.hasOwnProperty, Mc = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", f1 = function(t, r) {
  var n = {};
  for (var i in r)
    hd.call(r, i) && (n[i] = r[i]);
  return n[Mc] = t, n;
}, h1 = function(t) {
  var r = t.cache, n = t.serialized, i = t.isStringTag;
  return Qa(r, n, i), dd(function() {
    return el(r, n, i);
  }), null;
}, p1 = /* @__PURE__ */ Zo(function(e, t, r) {
  var n = e.css;
  typeof n == "string" && t.registered[n] !== void 0 && (n = t.registered[n]);
  var i = e[Mc], o = [n], s = "";
  typeof e.className == "string" ? s = ud(t.registered, o, e.className) : e.className != null && (s = e.className + " ");
  var a = Jo(o, void 0, ie.useContext(Hr));
  s += t.key + "-" + a.name;
  var l = {};
  for (var c in e)
    hd.call(e, c) && c !== "css" && c !== Mc && (l[c] = e[c]);
  return l.className = s, r && (l.ref = r), /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement(h1, {
    cache: t,
    serialized: a,
    isStringTag: typeof i == "string"
  }), /* @__PURE__ */ ie.createElement(i, l));
}), g1 = p1, ha = function(t, r) {
  var n = arguments;
  if (r == null || !hd.call(r, "css"))
    return ie.createElement.apply(void 0, n);
  var i = n.length, o = new Array(i);
  o[0] = g1, o[1] = f1(t, r);
  for (var s = 2; s < i; s++)
    o[s] = n[s];
  return ie.createElement.apply(null, o);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(ha || (ha = {}));
var Bc = /* @__PURE__ */ Zo(function(e, t) {
  var r = e.styles, n = Jo([r], void 0, ie.useContext(Hr)), i = ie.useRef();
  return Xf(function() {
    var o = t.key + "-global", s = new t.sheet.constructor({
      key: o,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), a = !1, l = document.querySelector('style[data-emotion="' + o + " " + n.name + '"]');
    return t.sheet.tags.length && (s.before = t.sheet.tags[0]), l !== null && (a = !0, l.setAttribute("data-emotion", o), s.hydrate([l])), i.current = [s, a], function() {
      s.flush();
    };
  }, [t]), Xf(function() {
    var o = i.current, s = o[0], a = o[1];
    if (a) {
      o[1] = !1;
      return;
    }
    if (n.next !== void 0 && el(t, n.next, !0), s.tags.length) {
      var l = s.tags[s.tags.length - 1].nextElementSibling;
      s.before = l, s.flush();
    }
    t.insert("", n, s, !1);
  }, [t, n.name]), null;
});
function ob() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return Jo(t);
}
function m1() {
  var e = ob.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var v1 = function e(t) {
  for (var r = t.length, n = 0, i = ""; n < r; n++) {
    var o = t[n];
    if (o != null) {
      var s = void 0;
      switch (typeof o) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(o))
            s = e(o);
          else {
            s = "";
            for (var a in o)
              o[a] && a && (s && (s += " "), s += a);
          }
          break;
        }
        default:
          s = o;
      }
      s && (i && (i += " "), i += s);
    }
  }
  return i;
};
function b1(e, t, r) {
  var n = [], i = ud(e, n, r);
  return n.length < 2 ? r : i + t(n);
}
var y1 = function(t) {
  var r = t.cache, n = t.serializedArr;
  return dd(function() {
    for (var i = 0; i < n.length; i++)
      el(r, n[i], !1);
  }), null;
}, x1 = /* @__PURE__ */ Zo(function(e, t) {
  var r = [], n = function() {
    for (var l = arguments.length, c = new Array(l), u = 0; u < l; u++)
      c[u] = arguments[u];
    var f = Jo(c, t.registered);
    return r.push(f), Qa(t, f, !1), t.key + "-" + f.name;
  }, i = function() {
    for (var l = arguments.length, c = new Array(l), u = 0; u < l; u++)
      c[u] = arguments[u];
    return b1(t.registered, n, v1(c));
  }, o = {
    css: n,
    cx: i,
    theme: ie.useContext(Hr)
  }, s = e.children(o);
  return /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement(y1, {
    cache: t,
    serializedArr: r
  }), s);
});
const _1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CacheProvider: ib,
  ClassNames: x1,
  Global: Bc,
  ThemeContext: Hr,
  ThemeProvider: u1,
  __unsafe_useEmotionCache: s1,
  get createElement() {
    return ha;
  },
  css: ob,
  get jsx() {
    return ha;
  },
  keyframes: m1,
  useTheme: a1,
  withEmotionCache: Zo,
  withTheme: d1
}, Symbol.toStringTag, { value: "Module" }));
function w1(e, t) {
  if (e != null) {
    if (typeof e == "function") {
      e(t);
      return;
    }
    try {
      e.current = t;
    } catch (r) {
      throw new Error(`Cannot assign value '${t}' to ref '${e}'`);
    }
  }
}
function S1(...e) {
  return (t) => {
    e.forEach((r) => {
      w1(r, t);
    });
  };
}
function Qo(e) {
  const t = Object.assign({}, e);
  for (let r in t)
    t[r] === void 0 && delete t[r];
  return t;
}
function E1(e) {
  return e.default || e;
}
const St = (e) => e != null && typeof e == "object" && !Array.isArray(e), Er = (e) => typeof e == "string", pd = (e) => typeof e == "function";
function C1(e) {
  var r;
  const t = ie.version;
  return !Er(t) || t.startsWith("18.") ? e == null ? void 0 : e.ref : (r = e == null ? void 0 : e.props) == null ? void 0 : r.ref;
}
const sb = (...e) => {
  const t = e.reduce((r, n) => (n != null && n.forEach((i) => r.add(i)), r), /* @__PURE__ */ new Set([]));
  return Array.from(t);
}, [k1, tl] = Io({
  name: "ChakraContext",
  strict: !0,
  providerName: "<ChakraProvider />"
});
function I1(e) {
  const { value: t, children: r } = e;
  return /* @__PURE__ */ K(k1, { value: t, children: [
    !t._config.disableLayers && /* @__PURE__ */ b(Bc, { styles: t.layers.atRule }),
    /* @__PURE__ */ b(Bc, { styles: t._global }),
    r
  ] });
}
const O1 = (e, t) => {
  const r = {}, n = {}, i = Object.keys(e);
  for (const o of i)
    t(o) ? n[o] = e[o] : r[o] = e[o];
  return [n, r];
}, bi = (e, t) => {
  const r = pd(t) ? t : (n) => t.includes(n);
  return O1(e, r);
}, P1 = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function T1(e) {
  return typeof e == "string" && P1.has(e);
}
function R1(e, t, r) {
  const { css: n, isValidProperty: i } = tl(), { children: o, ...s } = e, a = _e(() => {
    const [d, p] = bi(
      s,
      (y) => r(y, t.variantKeys)
    ), [g, h] = bi(
      p,
      t.variantKeys
    ), [m, v] = bi(h, i);
    return {
      forwardedProps: d,
      variantProps: g,
      styleProps: m,
      elementProps: v
    };
  }, [t.variantKeys, r, s, i]), { css: l, ...c } = a.styleProps, u = _e(() => {
    const d = { ...a.variantProps };
    return t.variantKeys.includes("colorPalette") || (d.colorPalette = s.colorPalette), t.variantKeys.includes("orientation") || (d.orientation = s.orientation), t(d);
  }, [t, a.variantProps, s.colorPalette, s.orientation]);
  return {
    styles: _e(() => n(u, ...A1(l), c), [n, u, l, c]),
    props: {
      ...a.forwardedProps,
      ...a.elementProps,
      children: o
    }
  };
}
const A1 = (e) => (Array.isArray(e) ? e : [e]).filter(Boolean).flat(), N1 = E1(vS), F1 = N1, $1 = (e) => e !== "theme", L1 = (e, t, r) => {
  let n;
  if (t) {
    const i = t.shouldForwardProp;
    n = e.__emotion_forwardProp && i ? (o) => e.__emotion_forwardProp(o) && i(o) : i;
  }
  return typeof n != "function" && r && (n = e.__emotion_forwardProp), n;
};
let V1 = typeof document != "undefined";
const Jf = ({ cache: e, serialized: t, isStringTag: r }) => {
  Qa(e, t, r);
  const n = dd(
    () => el(e, t, r)
  );
  if (!V1 && n !== void 0) {
    let i = t.name, o = t.next;
    for (; o !== void 0; )
      i = Yt(i, o.name), o = o.next;
    return /* @__PURE__ */ b(
      "style",
      {
        "data-emotion": Yt(e.key, i),
        dangerouslySetInnerHTML: { __html: n },
        nonce: e.sheet.nonce
      }
    );
  }
  return null;
}, Zf = {
  path: ["d"],
  text: ["x", "y"],
  circle: ["cx", "cy", "r"],
  rect: ["width", "height", "x", "y", "rx", "ry"],
  ellipse: ["cx", "cy", "rx", "ry"],
  g: ["transform"],
  stop: ["offset", "stopOpacity"]
}, z1 = (e, t) => Object.prototype.hasOwnProperty.call(e, t), D1 = (e, t = {}, r = {}) => {
  if (process.env.NODE_ENV !== "production" && e === void 0)
    throw new Error(
      `You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`
    );
  if (z1(Zf, e)) {
    r.forwardProps || (r.forwardProps = []);
    const c = Zf[e];
    r.forwardProps = sb([...r.forwardProps, ...c]);
  }
  const n = e.__emotion_real === e, i = n && e.__emotion_base || e;
  let o, s;
  r !== void 0 && (o = r.label, s = r.target);
  let a = [];
  const l = Zo((c, u, f) => {
    var F;
    const { cva: d, isValidProperty: p } = tl(), g = t.__cva__ ? t : d(t), h = B1(e.__emotion_cva, g), m = (L) => (D, N) => L.includes(D) ? !0 : !(N != null && N.includes(D)) && !p(D);
    !r.shouldForwardProp && r.forwardProps && (r.shouldForwardProp = m(r.forwardProps));
    const v = (L, D) => {
      const N = typeof e == "string" && e.charCodeAt(0) > 96 ? F1 : $1, B = !(D != null && D.includes(L)) && !p(L);
      return N(L) && B;
    }, y = L1(e, r, n) || v, x = ie.useMemo(
      () => Object.assign({}, r.defaultProps, Qo(c)),
      [c]
    ), { props: S, styles: _ } = R1(
      x,
      h,
      y
    );
    let I = "", O = [_], w = S;
    if (S.theme == null) {
      w = {};
      for (let L in S)
        w[L] = S[L];
      w.theme = ie.useContext(Hr);
    }
    typeof S.className == "string" ? I = ud(
      u.registered,
      O,
      S.className
    ) : S.className != null && (I = Yt(I, S.className));
    const E = Jo(
      a.concat(O),
      u.registered,
      w
    );
    I = Yt(I, `${u.key}-${E.name}`), s !== void 0 && (I = Yt(I, s));
    const T = !y("as");
    let G = T && S.as || i, k = {};
    for (let L in S)
      if (!(T && L === "as")) {
        if (T1(L)) {
          const D = L.replace("html", "").toLowerCase();
          k[D] = S[L];
          continue;
        }
        y(L) && (k[L] = S[L]);
      }
    k.className = I.trim(), k.ref = f;
    const j = r.forwardAsChild || ((F = r.forwardProps) == null ? void 0 : F.includes("asChild"));
    if (S.asChild && !j) {
      const L = ie.Children.only(S.children);
      G = L.type, k.children = null, Reflect.deleteProperty(k, "asChild"), k = Fo(k, L.props), k.ref = S1(f, C1(L));
    }
    return k.as && j ? (k.as = void 0, /* @__PURE__ */ K(ie.Fragment, { children: [
      /* @__PURE__ */ b(
        Jf,
        {
          cache: u,
          serialized: E,
          isStringTag: typeof G == "string"
        }
      ),
      /* @__PURE__ */ b(G, { asChild: !0, ...k, children: /* @__PURE__ */ b(S.as, { children: k.children }) })
    ] })) : /* @__PURE__ */ K(ie.Fragment, { children: [
      /* @__PURE__ */ b(
        Jf,
        {
          cache: u,
          serialized: E,
          isStringTag: typeof G == "string"
        }
      ),
      /* @__PURE__ */ b(G, { ...k })
    ] });
  });
  return l.displayName = o !== void 0 ? o : `chakra(${typeof i == "string" ? i : i.displayName || i.name || "Component"})`, l.__emotion_real = l, l.__emotion_base = i, l.__emotion_forwardProp = r.shouldForwardProp, l.__emotion_cva = t, Object.defineProperty(l, "toString", {
    value() {
      return s === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : `.${s}`;
    }
  }), l;
}, Bl = D1.bind(), Wl = /* @__PURE__ */ new Map(), M1 = new Proxy(Bl, {
  apply(e, t, r) {
    return Bl(...r);
  },
  get(e, t) {
    return Wl.has(t) || Wl.set(t, Bl(t)), Wl.get(t);
  }
}), qe = M1, B1 = (e, t) => e && !t ? e : !e && t ? t : e.merge(t);
function W1(e) {
  const { key: t, recipe: r } = e, n = tl();
  return _e(() => {
    const i = r || (t != null ? n.getRecipe(t) : {});
    return n.cva(structuredClone(i));
  }, [t, r, n]);
}
const H1 = (e) => e.charAt(0).toUpperCase() + e.slice(1);
function jn(e) {
  const { key: t, recipe: r } = e, n = H1(
    t || r.className || "Component"
  ), [i, o] = Io({
    strict: !1,
    name: `${n}PropsContext`,
    providerName: `${n}PropsContext`
  });
  function s(c) {
    const { unstyled: u, ...f } = c, d = W1({
      key: t,
      recipe: f.recipe || r
    }), [p, g] = _e(
      () => d.splitVariantProps(f),
      [d, f]
    );
    return {
      styles: u ? pS : d(p),
      className: d.className,
      props: g
    };
  }
  const a = (c, u) => {
    const f = qe(c, {}, u), d = Z((p, g) => {
      const h = o(), m = _e(
        () => Fo(h, p),
        [p, h]
      ), { styles: v, className: y, props: x } = s(m);
      return /* @__PURE__ */ b(
        f,
        {
          ...x,
          ref: g,
          css: [v, m.css],
          className: Yt(y, m.className)
        }
      );
    });
    return d.displayName = c.displayName || c.name, d;
  };
  function l() {
    return i;
  }
  return {
    withContext: a,
    PropsProvider: i,
    withPropsProvider: l,
    usePropsContext: o,
    useRecipeResult: s
  };
}
function j1(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var ab = (e) => e[0], lb = (e) => e[e.length - 1], U1 = (e, t) => e.indexOf(t) !== -1, cb = (e, ...t) => e.concat(t), gd = (e, ...t) => e.filter((r) => !t.includes(r)), pa = (e, t) => U1(e, t) ? gd(e, t) : cb(e, t);
function ub(e, t, r = {}) {
  const { step: n = 1, loop: i = !0 } = r, o = t + n, s = e.length, a = s - 1;
  return t === -1 ? n > 0 ? 0 : a : o < 0 ? i ? a : 0 : o >= s ? i ? 0 : t > s ? s : t : o;
}
function G1(e, t, r = {}) {
  return e[ub(e, t, r)];
}
function q1(e, t, r = {}) {
  const { step: n = 1, loop: i = !0 } = r;
  return ub(e, t, { step: -n, loop: i });
}
function K1(e, t, r = {}) {
  return e[q1(e, t, r)];
}
var Qf = (e) => (e == null ? void 0 : e.constructor.name) === "Array", Y1 = (e, t) => {
  if (e.length !== t.length) return !1;
  for (let r = 0; r < e.length; r++)
    if (!Ai(e[r], t[r])) return !1;
  return !0;
}, Ai = (e, t) => {
  if (Object.is(e, t)) return !0;
  if (e == null && t != null || e != null && t == null) return !1;
  if (typeof (e == null ? void 0 : e.isEqual) == "function" && typeof (t == null ? void 0 : t.isEqual) == "function")
    return e.isEqual(t);
  if (typeof e == "function" && typeof t == "function")
    return e.toString() === t.toString();
  if (Qf(e) && Qf(t))
    return Y1(Array.from(e), Array.from(t));
  if (typeof e != "object" || typeof t != "object") return !1;
  const r = Object.keys(t != null ? t : /* @__PURE__ */ Object.create(null)), n = r.length;
  for (let i = 0; i < n; i++)
    if (!Reflect.has(e, r[i])) return !1;
  for (let i = 0; i < n; i++) {
    const o = r[i];
    if (!Ai(e[o], t[o])) return !1;
  }
  return !0;
}, X1 = (e) => Array.isArray(e), J1 = (e) => e === !0 || e === !1, Z1 = (e) => e != null && typeof e == "object", Hl = (e) => Z1(e) && !X1(e), db = (e) => typeof e == "number" && !Number.isNaN(e), Us = (e) => typeof e == "string", sn = (e) => typeof e == "function", Q1 = (e) => e == null, jl = (e, t) => Object.prototype.hasOwnProperty.call(e, t), eE = Function.prototype.toString;
eE.call(Object);
var ho = (e, ...t) => {
  const r = typeof e == "function" ? e(...t) : e;
  return r != null ? r : void 0;
}, tE = (e) => e(), rE = () => {
}, ga = (...e) => (...t) => {
  e.forEach(function(r) {
    r == null || r(...t);
  });
}, fb = /* @__PURE__ */ (() => {
  let e = 0;
  return () => (e++, e.toString(36));
})();
function Oo(e, t, ...r) {
  var i;
  if (e in t) {
    const o = t[e];
    return sn(o) ? o(...r) : o;
  }
  const n = new Error(`No matching key: ${JSON.stringify(e)} in ${JSON.stringify(Object.keys(t))}`);
  throw (i = Error.captureStackTrace) == null || i.call(Error, n, Oo), n;
}
var hb = (e, t) => {
  var r;
  try {
    return e();
  } catch (n) {
    return n instanceof Error && ((r = Error.captureStackTrace) == null || r.call(Error, n, hb)), t == null ? void 0 : t();
  }
}, { floor: Wc, abs: eh, round: rl, min: nE, max: iE, pow: oE, sign: sE } = Math, po = (e) => Number.isNaN(e), jr = (e) => po(e) ? 0 : e, pb = (e, t) => (e % t + t) % t, aE = (e, t) => (e % t + t) % t, lE = (e, t) => jr(e) >= t, cE = (e, t) => jr(e) <= t, uE = (e, t, r) => jr(e) >= t && jr(e) <= r, dE = (e, t, r) => rl((jr(e) - t) / r) * r + t, Et = (e, t, r) => nE(iE(jr(e), t), r), gb = (e, t, r) => (jr(e) - t) / (r - t), fE = (e, t, r, n) => Et(dE(e * (r - t) + t, t, n), t, r), vs = (e, t) => {
  let r = e, n = t.toString(), i = n.indexOf("."), o = i >= 0 ? n.length - i : 0;
  if (o > 0) {
    let s = oE(10, o);
    r = rl(r * s) / s;
  }
  return r;
}, Ul = (e, t) => typeof t == "number" ? Wc(e * t + 0.5) / t : rl(e), th = (e, t, r, n) => {
  t = Number(t), r = Number(r);
  let i = (e - (po(t) ? 0 : t)) % n, o = vs(
    eh(i) * 2 >= n ? e + sE(i) * (n - eh(i)) : e - i,
    n
  );
  return po(t) ? !po(r) && o > r && (o = t + Wc(vs((r - t) / n, n)) * n) : o < t ? o = t : !po(r) && o > r && (o = t + Wc(vs((r - t) / n, n)) * n), vs(o, n);
}, Re = (e, t = 0, r = 10) => {
  const n = Math.pow(r, t);
  return rl(e * n) / n;
}, rh = (e) => {
  if (!Number.isFinite(e)) return 0;
  let t = 1, r = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, r += 1;
  return r;
}, mb = (e, t, r) => {
  let n = t === "+" ? e + r : e - r;
  if (e % 1 !== 0 || r % 1 !== 0) {
    const i = 10 ** Math.max(rh(e), rh(r));
    e = Math.round(e * i), r = Math.round(r * i), n = t === "+" ? e + r : e - r, n /= i;
  }
  return n;
}, hE = (e, t) => mb(jr(e), "+", t), pE = (e, t) => mb(jr(e), "-", t);
function nl(e) {
  if (!gE(e) || e === void 0) return e;
  const t = Reflect.ownKeys(e).filter((n) => typeof n == "string"), r = {};
  for (const n of t) {
    const i = e[n];
    i !== void 0 && (r[n] = nl(i));
  }
  return r;
}
var gE = (e) => e && typeof e == "object" && e.constructor === Object;
function Gs(e, t) {
  const r = performance.now();
  let n;
  function i(o) {
    n = requestAnimationFrame(i), o - r >= t && e();
  }
  return n = requestAnimationFrame(i), () => cancelAnimationFrame(n);
}
function Do(...e) {
  const t = e.length === 1 ? e[0] : e[1];
  (e.length === 2 ? e[0] : !0) && process.env.NODE_ENV !== "production" && console.warn(t);
}
function vb(e, t) {
  if (e == null) throw new Error(t());
}
function mE(e, t, r) {
  let n = [];
  for (const i of t)
    e[i] == null && n.push(i);
  if (n.length > 0)
    throw new Error(`[zag-js${` > ${r}`}] missing required props: ${n.join(", ")}`);
}
function vE(e, t) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${t}`;
}
function Bt(e = {}) {
  const {
    name: t,
    strict: r = !0,
    hookName: n = "useContext",
    providerName: i = "Provider",
    errorMessage: o,
    defaultValue: s
  } = e, a = Bv(s);
  a.displayName = t;
  function l() {
    var u;
    const c = Yo(a);
    if (!c && r) {
      const f = new Error(o != null ? o : vE(n, i));
      throw f.name = "ContextError", (u = Error.captureStackTrace) == null || u.call(Error, f, l), f;
    }
    return c;
  }
  return [a.Provider, l, a];
}
const [bE, bn] = Bt({
  name: "EnvironmentContext",
  hookName: "useEnvironmentContext",
  providerName: "<EnvironmentProvider />",
  strict: !1,
  defaultValue: {
    getRootNode: () => document,
    getDocument: () => document,
    getWindow: () => window
  }
});
function yE(e) {
  var n, i;
  if (!e) return;
  const t = (n = e.selectionStart) != null ? n : 0, r = (i = e.selectionEnd) != null ? i : 0;
  Math.abs(r - t) === 0 && t === 0 && e.setSelectionRange(e.value.length, e.value.length);
}
var nh = (e) => Math.max(0, Math.min(1, e)), xE = (e, t) => e.map((r, n) => e[(Math.max(t, 0) + n) % e.length]), bb = () => {
}, il = (e) => typeof e == "object" && e !== null, yb = 2147483647, me = (e) => e ? "" : void 0, _E = (e) => e ? "true" : void 0, wE = 1, SE = 9, EE = 11, vt = (e) => il(e) && e.nodeType === wE && typeof e.nodeName == "string", md = (e) => il(e) && e.nodeType === SE, CE = (e) => il(e) && e === e.window, xb = (e) => vt(e) ? e.localName || "" : "#document";
function kE(e) {
  return ["html", "body", "#document"].includes(xb(e));
}
var IE = (e) => il(e) && e.nodeType !== void 0, Ei = (e) => IE(e) && e.nodeType === EE && "host" in e, OE = (e) => vt(e) && e.localName === "input", PE = (e) => vt(e) ? e.offsetWidth > 0 || e.offsetHeight > 0 || e.getClientRects().length > 0 : !1, TE = /(textarea|select)/;
function vd(e) {
  if (e == null || !vt(e)) return !1;
  try {
    return OE(e) && e.selectionStart != null || TE.test(e.localName) || e.isContentEditable || e.getAttribute("contenteditable") === "true" || e.getAttribute("contenteditable") === "";
  } catch (t) {
    return !1;
  }
}
function fn(e, t) {
  var n;
  if (!e || !t || !vt(e) || !vt(t)) return !1;
  const r = (n = t.getRootNode) == null ? void 0 : n.call(t);
  if (e === t || e.contains(t)) return !0;
  if (r && Ei(r)) {
    let i = t;
    for (; i; ) {
      if (e === i) return !0;
      i = i.parentNode || i.host;
    }
  }
  return !1;
}
function Wt(e) {
  var t;
  return md(e) ? e : CE(e) ? e.document : (t = e == null ? void 0 : e.ownerDocument) != null ? t : document;
}
function RE(e) {
  return Wt(e).documentElement;
}
function ct(e) {
  var t, r, n;
  return Ei(e) ? ct(e.host) : md(e) ? (t = e.defaultView) != null ? t : window : vt(e) && (n = (r = e.ownerDocument) == null ? void 0 : r.defaultView) != null ? n : window;
}
function _b(e) {
  let t = e.activeElement;
  for (; t != null && t.shadowRoot; ) {
    const r = t.shadowRoot.activeElement;
    if (r === t) break;
    t = r;
  }
  return t;
}
function AE(e) {
  if (xb(e) === "html") return e;
  const t = e.assignedSlot || e.parentNode || Ei(e) && e.host || RE(e);
  return Ei(t) ? t.host : t;
}
var Gl = /* @__PURE__ */ new WeakMap();
function wb(e) {
  return Gl.has(e) || Gl.set(e, ct(e).getComputedStyle(e)), Gl.get(e);
}
var ol = () => typeof document != "undefined";
function NE() {
  var t;
  const e = navigator.userAgentData;
  return (t = e == null ? void 0 : e.platform) != null ? t : navigator.platform;
}
function FE() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map(({ brand: t, version: r }) => `${t}/${r}`).join(" ") : navigator.userAgent;
}
var bd = (e) => ol() && e.test(NE()), Sb = (e) => ol() && e.test(FE()), $E = (e) => ol() && e.test(navigator.vendor), ih = () => ol() && !!navigator.maxTouchPoints, LE = () => bd(/^iPhone/i), VE = () => bd(/^iPad/i) || al() && navigator.maxTouchPoints > 1, sl = () => LE() || VE(), zE = () => al() || sl(), al = () => bd(/^Mac/i), yd = () => zE() && $E(/apple/i), DE = () => Sb(/Firefox/i), ME = () => Sb(/Android/i);
function BE(e) {
  var t, r, n, i;
  return (i = (t = e.composedPath) == null ? void 0 : t.call(e)) != null ? i : (n = (r = e.nativeEvent) == null ? void 0 : r.composedPath) == null ? void 0 : n.call(r);
}
function Ct(e) {
  var r;
  const t = BE(e);
  return (r = t == null ? void 0 : t[0]) != null ? r : e.target;
}
var WE = (e) => fn(e.currentTarget, Ct(e));
function HE(e) {
  return KE(e).isComposing || e.keyCode === 229;
}
function jE(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : ME() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
var UE = (e) => e.button === 2 || al() && e.ctrlKey && e.button === 0, GE = (e) => "touches" in e && e.touches.length > 0, qE = {
  Up: "ArrowUp",
  Down: "ArrowDown",
  Esc: "Escape",
  " ": "Space",
  ",": "Comma",
  Left: "ArrowLeft",
  Right: "ArrowRight"
}, oh = {
  ArrowLeft: "ArrowRight",
  ArrowRight: "ArrowLeft"
};
function sh(e, t = {}) {
  var s;
  const { dir: r = "ltr", orientation: n = "horizontal" } = t;
  let i = e.key;
  return i = (s = qE[i]) != null ? s : i, r === "rtl" && n === "horizontal" && i in oh && (i = oh[i]), i;
}
function KE(e) {
  var t;
  return (t = e.nativeEvent) != null ? t : e;
}
function YE(e, t = "client") {
  const r = GE(e) ? e.touches[0] || e.changedTouches[0] : e;
  return { x: r[`${t}X`], y: r[`${t}Y`] };
}
var Ae = (e, t, r, n) => {
  const i = typeof e == "function" ? e() : e;
  return i == null || i.addEventListener(t, r, n), () => {
    i == null || i.removeEventListener(t, r, n);
  };
};
function XE(e, t) {
  var o;
  const { type: r = "HTMLInputElement", property: n = "value" } = t, i = ct(e)[r].prototype;
  return (o = Object.getOwnPropertyDescriptor(i, n)) != null ? o : {};
}
function JE(e) {
  if (e.localName === "input") return "HTMLInputElement";
  if (e.localName === "textarea") return "HTMLTextAreaElement";
  if (e.localName === "select") return "HTMLSelectElement";
}
function es(e, t, r = "value") {
  var i;
  if (!e) return;
  const n = JE(e);
  n && ((i = XE(e, { type: n, property: r }).set) == null || i.call(e, t)), e.setAttribute(r, t);
}
function ZE(e, t) {
  const { value: r, bubbles: n = !0 } = t;
  if (!e) return;
  const i = ct(e);
  e instanceof i.HTMLInputElement && (es(e, `${r}`), e.dispatchEvent(new i.Event("input", { bubbles: n })));
}
function QE(e) {
  return eC(e) ? e.form : e.closest("form");
}
function eC(e) {
  return e.matches("textarea, input, select, button");
}
function tC(e, t) {
  if (!e) return;
  const r = QE(e), n = (i) => {
    i.defaultPrevented || t();
  };
  return r == null || r.addEventListener("reset", n, { passive: !0 }), () => r == null ? void 0 : r.removeEventListener("reset", n);
}
function rC(e, t) {
  const r = e == null ? void 0 : e.closest("fieldset");
  if (!r) return;
  t(r.disabled);
  const n = ct(r), i = new n.MutationObserver(() => t(r.disabled));
  return i.observe(r, {
    attributes: !0,
    attributeFilter: ["disabled"]
  }), () => i.disconnect();
}
function xd(e, t) {
  if (!e) return;
  const { onFieldsetDisabledChange: r, onFormReset: n } = t, i = [tC(e, n), rC(e, r)];
  return () => i.forEach((o) => o == null ? void 0 : o());
}
var Eb = (e) => vt(e) && e.tagName === "IFRAME", nC = (e) => !Number.isNaN(parseInt(e.getAttribute("tabindex") || "0", 10)), iC = (e) => parseInt(e.getAttribute("tabindex") || "0", 10) < 0, _d = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false']), details > summary:first-of-type", Cb = (e, t = !1) => {
  if (!e) return [];
  const r = Array.from(e.querySelectorAll(_d));
  (t == !0 || t == "if-empty" && r.length === 0) && vt(e) && ln(e) && r.unshift(e);
  const i = r.filter(ln);
  return i.forEach((o, s) => {
    if (Eb(o) && o.contentDocument) {
      const a = o.contentDocument.body;
      i.splice(s, 1, ...Cb(a));
    }
  }), i;
};
function ln(e) {
  return !e || e.closest("[inert]") ? !1 : e.matches(_d) && PE(e);
}
function ts(e, t) {
  if (!e) return [];
  const r = Array.from(e.querySelectorAll(_d)), n = r.filter(on);
  return t && on(e) && n.unshift(e), n.forEach((i, o) => {
    if (Eb(i) && i.contentDocument) {
      const s = i.contentDocument.body, a = ts(s);
      n.splice(o, 1, ...a);
    }
  }), !n.length && t ? r : n;
}
function on(e) {
  return e != null && e.tabIndex > 0 ? !0 : ln(e) && !iC(e);
}
function kb(e, t) {
  const r = ts(e, t), n = r[0] || null, i = r[r.length - 1] || null;
  return [n, i];
}
function oC(e, t) {
  const r = ts(e), n = (e == null ? void 0 : e.ownerDocument) || document, i = t != null ? t : n.activeElement;
  if (!i) return null;
  const o = r.indexOf(i);
  return r[o + 1] || null;
}
function Yi(e) {
  return e.tabIndex < 0 && (/^(audio|video|details)$/.test(e.localName) || vd(e)) && !nC(e) ? 0 : e.tabIndex;
}
function Mo(e) {
  const { root: t, getInitialEl: r, filter: n, enabled: i = !0 } = e;
  if (!i) return;
  let o = null;
  if (o || (o = typeof r == "function" ? r() : r), o || (o = t == null ? void 0 : t.querySelector("[data-autofocus],[autofocus]")), !o) {
    const s = ts(t);
    o = n ? s.filter(n)[0] : s[0];
  }
  return o || t || void 0;
}
function sC(e) {
  const t = e.currentTarget;
  if (!t) return !1;
  const [r, n] = kb(t), i = t.ownerDocument || document;
  return !(i.activeElement === r && e.shiftKey || i.activeElement === n && !e.shiftKey || !r && !n);
}
function Ib(e) {
  const t = /* @__PURE__ */ new Set();
  function r(n) {
    const i = globalThis.requestAnimationFrame(n);
    t.add(() => globalThis.cancelAnimationFrame(i));
  }
  return r(() => r(e)), function() {
    t.forEach((i) => i());
  };
}
function de(e) {
  let t;
  const r = globalThis.requestAnimationFrame(() => {
    t = e();
  });
  return () => {
    globalThis.cancelAnimationFrame(r), t == null || t();
  };
}
function aC(e, t, r) {
  const n = de(() => {
    e.removeEventListener(t, i, !0), r();
  }), i = () => {
    n(), r();
  };
  return e.addEventListener(t, i, { once: !0, capture: !0 }), n;
}
function lC(e, t) {
  if (!e) return;
  const { attributes: r, callback: n } = t, i = e.ownerDocument.defaultView || window, o = new i.MutationObserver((s) => {
    for (const a of s)
      a.type === "attributes" && a.attributeName && r.includes(a.attributeName) && n(a);
  });
  return o.observe(e, { attributes: !0, attributeFilter: r }), () => o.disconnect();
}
function ll(e, t) {
  const { defer: r } = t, n = r ? de : (o) => o(), i = [];
  return i.push(
    n(() => {
      const o = typeof e == "function" ? e() : e;
      i.push(lC(o, t));
    })
  ), () => {
    i.forEach((o) => o == null ? void 0 : o());
  };
}
function cC(e, t) {
  const { callback: r } = t;
  if (!e) return;
  const n = e.ownerDocument.defaultView || window, i = new n.MutationObserver(r);
  return i.observe(e, { childList: !0, subtree: !0 }), () => i.disconnect();
}
function uC(e, t) {
  const r = de, n = [];
  return n.push(
    r(() => {
      const i = typeof e == "function" ? e() : e;
      n.push(cC(i, t));
    })
  ), () => {
    n.forEach((i) => i == null ? void 0 : i());
  };
}
function Ob(e) {
  const t = () => e.click();
  DE() ? aC(e, "keyup", t) : queueMicrotask(t);
}
function ma(e) {
  const t = AE(e);
  return kE(t) ? Wt(t).body : vt(t) && wd(t) ? t : ma(t);
}
function Pb(e, t = []) {
  const r = ma(e), n = r === e.ownerDocument.body, i = ct(r);
  return n ? t.concat(i, i.visualViewport || [], wd(r) ? r : []) : t.concat(r, Pb(r, []));
}
var dC = /auto|scroll|overlay|hidden|clip/;
function wd(e) {
  const t = ct(e), { overflow: r, overflowX: n, overflowY: i, display: o } = t.getComputedStyle(e);
  return dC.test(r + i + n) && !["inline", "contents"].includes(o);
}
function fC(e) {
  return e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth;
}
function Sd(e, t) {
  const { rootEl: r, ...n } = t || {};
  !e || !r || !wd(r) || !fC(r) || e.scrollIntoView(n);
}
function Tb(e, t) {
  const { left: r, top: n, width: i, height: o } = t.getBoundingClientRect(), s = { x: e.x - r, y: e.y - n }, a = { x: nh(s.x / i), y: nh(s.y / o) };
  function l(c = {}) {
    const { dir: u = "ltr", orientation: f = "horizontal", inverted: d } = c, p = typeof d == "object" ? d.x : d, g = typeof d == "object" ? d.y : d;
    return f === "horizontal" ? u === "rtl" || p ? 1 - a.x : a.x : g ? 1 - a.y : a.y;
  }
  return { offset: s, percent: a, getPercentValue: l };
}
function hC(e, t) {
  const r = e.body, n = "pointerLockElement" in e || "mozPointerLockElement" in e, i = () => !!e.pointerLockElement;
  function o() {
  }
  function s(l) {
    i(), console.error("PointerLock error occurred:", l), e.exitPointerLock();
  }
  if (!n) return;
  try {
    r.requestPointerLock();
  } catch (l) {
  }
  const a = [
    Ae(e, "pointerlockchange", o, !1),
    Ae(e, "pointerlockerror", s, !1)
  ];
  return () => {
    a.forEach((l) => l()), e.exitPointerLock();
  };
}
var fi = "default", Hc = "", qs = /* @__PURE__ */ new WeakMap();
function pC(e = {}) {
  const { target: t, doc: r } = e, n = r != null ? r : document, i = n.documentElement;
  return sl() ? (fi === "default" && (Hc = i.style.webkitUserSelect, i.style.webkitUserSelect = "none"), fi = "disabled") : t && (qs.set(t, t.style.userSelect), t.style.userSelect = "none"), () => gC({ target: t, doc: n });
}
function gC(e = {}) {
  const { target: t, doc: r } = e, i = (r != null ? r : document).documentElement;
  if (sl()) {
    if (fi !== "disabled") return;
    fi = "restoring", setTimeout(() => {
      Ib(() => {
        fi === "restoring" && (i.style.webkitUserSelect === "none" && (i.style.webkitUserSelect = Hc || ""), Hc = "", fi = "default");
      });
    }, 300);
  } else if (t && qs.has(t)) {
    const o = qs.get(t);
    t.style.userSelect === "none" && (t.style.userSelect = o != null ? o : ""), t.getAttribute("style") === "" && t.removeAttribute("style"), qs.delete(t);
  }
}
function Rb(e = {}) {
  const { defer: t, target: r, ...n } = e, i = t ? de : (s) => s(), o = [];
  return o.push(
    i(() => {
      const s = typeof r == "function" ? r() : r;
      o.push(pC({ ...n, target: s }));
    })
  ), () => {
    o.forEach((s) => s == null ? void 0 : s());
  };
}
function mC(e, t) {
  const { onPointerMove: r, onPointerUp: n } = t, o = [
    Ae(e, "pointermove", (s) => {
      const a = YE(s), l = Math.sqrt(a.x ** 2 + a.y ** 2), c = s.pointerType === "touch" ? 10 : 5;
      if (!(l < c)) {
        if (s.pointerType === "mouse" && s.button === 0) {
          n();
          return;
        }
        r({ point: a, event: s });
      }
    }, !1),
    Ae(e, "pointerup", n, !1),
    Ae(e, "pointercancel", n, !1),
    Ae(e, "contextmenu", n, !1),
    Rb({ doc: e })
  ];
  return () => {
    o.forEach((s) => s());
  };
}
function vC(e, t = {}) {
  const { triggerElement: r, onFocus: n, onFocusEnter: i } = t, o = (e == null ? void 0 : e.ownerDocument) || document, s = o.body;
  function a(l) {
    if (l.key !== "Tab") return;
    let c = null;
    const [u, f] = kb(e, !0), d = oC(s, r), p = !u && !f;
    l.shiftKey && d === o.activeElement ? (i == null || i(), c = f) : l.shiftKey && (o.activeElement === u || p) ? c = r : !l.shiftKey && o.activeElement === r ? (i == null || i(), c = u) : !l.shiftKey && (o.activeElement === f || p) && (c = d), c && (l.preventDefault(), typeof n == "function" ? n(c) : c.focus());
  }
  return Ae(o, "keydown", a, !0);
}
function bC(e, t) {
  const { defer: r, triggerElement: n, ...i } = t, o = r ? de : (a) => a(), s = [];
  return s.push(
    o(() => {
      const a = typeof e == "function" ? e() : e, l = typeof n == "function" ? n() : n;
      s.push(vC(a, { triggerElement: l, ...i }));
    })
  ), () => {
    s.forEach((a) => a == null ? void 0 : a());
  };
}
function va(e, t) {
  var r;
  return Array.from((r = e == null ? void 0 : e.querySelectorAll(t)) != null ? r : []);
}
function yC(e, t) {
  var r;
  return (r = e == null ? void 0 : e.querySelector(t)) != null ? r : null;
}
var Ed = (e) => e.id;
function xC(e, t, r = Ed) {
  return e.find((n) => r(n) === t);
}
function Cd(e, t, r = Ed) {
  const n = xC(e, t, r);
  return n ? e.indexOf(n) : -1;
}
function _C(e, t, r = !0) {
  let n = Cd(e, t);
  return n = r ? (n + 1) % e.length : Math.min(n + 1, e.length - 1), e[n];
}
function wC(e, t, r = !0) {
  let n = Cd(e, t);
  return n === -1 ? r ? e[e.length - 1] : null : (n = r ? (n - 1 + e.length) % e.length : Math.max(0, n - 1), e[n]);
}
var SC = (e) => e.split("").map((t) => {
  const r = t.charCodeAt(0);
  return r > 0 && r < 128 ? t : r >= 128 && r <= 255 ? `/x${r.toString(16)}`.replace("/", "\\") : "";
}).join("").trim(), EC = (e) => {
  var t, r, n;
  return SC((n = (r = (t = e.dataset) == null ? void 0 : t.valuetext) != null ? r : e.textContent) != null ? n : "");
}, CC = (e, t) => e.trim().toLowerCase().startsWith(t.toLowerCase());
function kC(e, t, r, n = Ed) {
  const i = r ? Cd(e, r, n) : -1;
  let o = r ? xE(e, i) : e;
  return t.length === 1 && (o = o.filter((a) => n(a) !== r)), o.find((a) => CC(EC(a), t));
}
function ba(e, t) {
  if (!e) return bb;
  const r = Object.keys(t).reduce((n, i) => (n[i] = e.style.getPropertyValue(i), n), {});
  return Object.assign(e.style, t), () => {
    Object.assign(e.style, r), e.style.length === 0 && e.removeAttribute("style");
  };
}
function IC(e, t, r) {
  if (!e) return bb;
  const n = e.style.getPropertyValue(t);
  return e.style.setProperty(t, r), () => {
    e.style.setProperty(t, n), e.style.length === 0 && e.removeAttribute("style");
  };
}
function OC(e, t) {
  const { state: r, activeId: n, key: i, timeout: o = 350, itemToId: s } = t, a = r.keysSoFar + i, c = a.length > 1 && Array.from(a).every((g) => g === a[0]) ? a[0] : a;
  let u = e.slice();
  const f = kC(u, c, n, s);
  function d() {
    clearTimeout(r.timer), r.timer = -1;
  }
  function p(g) {
    r.keysSoFar = g, d(), g !== "" && (r.timer = +setTimeout(() => {
      p(""), d();
    }, o));
  }
  return p(a), f;
}
var Bo = /* @__PURE__ */ Object.assign(OC, {
  defaultOptions: { keysSoFar: "", timer: -1 },
  isValidEvent: PC
});
function PC(e) {
  return e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
var TC = {
  border: "0",
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: "0",
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}, RC = 1e3 / 60;
function AC(e, t) {
  const r = e();
  if (vt(r) && r.isConnected)
    return t(r), () => {
    };
  {
    const n = setInterval(() => {
      const i = e();
      vt(i) && i.isConnected && (t(i), clearInterval(n));
    }, RC);
    return () => clearInterval(n);
  }
}
function NC(e, t) {
  const r = [];
  return e == null || e.forEach((n) => {
    const i = AC(n, t);
    r.push(i);
  }), () => {
    r.forEach((n) => n());
  };
}
var FC = (...e) => e.map((t) => {
  var r;
  return (r = t == null ? void 0 : t.trim) == null ? void 0 : r.call(t);
}).filter(Boolean).join(" "), $C = /((?:--)?(?:\w+-?)+)\s*:\s*([^;]*)/g, ah = (e) => {
  const t = {};
  let r;
  for (; r = $C.exec(e); )
    t[r[1]] = r[2];
  return t;
}, LC = (e, t) => {
  if (Us(e)) {
    if (Us(t)) return `${e};${t}`;
    e = ah(e);
  } else Us(t) && (t = ah(t));
  return Object.assign({}, e != null ? e : {}, t != null ? t : {});
};
function oe(...e) {
  let t = {};
  for (let r of e) {
    for (let n in t) {
      if (n.startsWith("on") && typeof t[n] == "function" && typeof r[n] == "function") {
        t[n] = ga(r[n], t[n]);
        continue;
      }
      if (n === "className" || n === "class") {
        t[n] = FC(t[n], r[n]);
        continue;
      }
      if (n === "style") {
        t[n] = LC(t[n], r[n]);
        continue;
      }
      t[n] = r[n] !== void 0 ? r[n] : t[n];
    }
    for (let n in r)
      t[n] === void 0 && (t[n] = r[n]);
  }
  return t;
}
function jc(e, t, r) {
  let n = [], i;
  return (o) => {
    const s = e(o);
    return (s.length !== n.length || s.some((l, c) => !Ai(n[c], l))) && (n = s, i = t(...s)), i;
  };
}
function Yr() {
  return {
    and: (...e) => function(r) {
      return e.every((n) => r.guard(n));
    },
    or: (...e) => function(r) {
      return e.some((n) => r.guard(n));
    },
    not: (e) => function(r) {
      return !r.guard(e);
    }
  };
}
function VC() {
  return {
    guards: Yr(),
    createMachine: (e) => e,
    choose: (e) => function({ choose: r }) {
      var n;
      return (n = r(e)) == null ? void 0 : n.actions;
    }
  };
}
var ai = /* @__PURE__ */ ((e) => (e.NotStarted = "Not Started", e.Started = "Started", e.Stopped = "Stopped", e))(ai || {}), ql = "__init__";
function zC(e) {
  const t = () => {
    var a, l;
    return (l = (a = e.getRootNode) == null ? void 0 : a.call(e)) != null ? l : document;
  }, r = () => Wt(t()), n = () => {
    var a;
    return (a = r().defaultView) != null ? a : window;
  }, i = () => _b(t());
  return {
    ...e,
    getRootNode: t,
    getDoc: r,
    getWin: n,
    getActiveElement: i,
    isActiveElement: (a) => a === i(),
    getById: (a) => t().getElementById(a)
  };
}
function cl(...e) {
  return (t) => {
    const r = [];
    for (const n of e)
      if (typeof n == "function") {
        const i = n(t);
        typeof i == "function" && r.push(i);
      } else n && (n.current = t);
    if (r.length)
      return () => {
        for (const n of r)
          n();
      };
  };
}
function DC(e) {
  var n, i;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
const Kl = (e) => {
  const t = Wv(
    Z((r, n) => {
      const { asChild: i, children: o, ...s } = r;
      if (!i)
        return $n(e, { ...s, ref: n }, o);
      const a = Ya.only(o);
      if (!td(a))
        return null;
      const l = DC(a);
      return rd(a, {
        ...oe(s, a.props),
        ref: n ? cl(n, l) : l
      });
    })
  );
  return t.displayName = e.displayName || e.name, t;
}, MC = () => {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(Kl, {
    apply(t, r, n) {
      return Kl(n[0]);
    },
    get(t, r) {
      const n = r;
      return e.has(n) || e.set(n, Kl(n)), e.get(n);
    }
  });
}, ae = MC(), [E3, rs] = Bt({
  name: "LocaleContext",
  hookName: "useLocaleContext",
  providerName: "<LocaleProvider />",
  strict: !1,
  defaultValue: { dir: "ltr", locale: "en-US" }
}), Xr = () => (e, t) => t.reduce(
  (r, n) => {
    const [i, o] = r, s = n;
    return o[s] !== void 0 && (i[s] = o[s]), delete o[s], [i, o];
  },
  [{}, { ...e }]
), Ni = (e) => Xr()(e, [
  "immediate",
  "lazyMount",
  "onExitComplete",
  "present",
  "skipAnimationOnMount",
  "unmountOnExit"
]);
function BC(e) {
  return new Proxy({}, {
    get(t, r) {
      return r === "style" ? (n) => e({ style: n }).style : e;
    }
  });
}
var ue = () => (e) => Array.from(new Set(e));
function WC(e, t) {
  const { state: r, send: n, context: i } = e, o = r.matches("mounted", "unmountSuspended");
  return {
    skip: !i.get("initial"),
    present: o,
    setNode(s) {
      s && n({ type: "NODE.SET", node: s });
    },
    unmount() {
      n({ type: "UNMOUNT" });
    }
  };
}
var HC = {
  props({ props: e }) {
    return { ...e, present: !!e.present };
  },
  initialState({ prop: e }) {
    return e("present") ? "mounted" : "unmounted";
  },
  refs() {
    return {
      node: null,
      styles: null
    };
  },
  context({ bindable: e }) {
    return {
      unmountAnimationName: e(() => ({ defaultValue: null })),
      prevAnimationName: e(() => ({ defaultValue: null })),
      present: e(() => ({ defaultValue: !1 })),
      initial: e(() => ({
        sync: !0,
        defaultValue: !1
      }))
    };
  },
  exit: ["clearInitial", "cleanupNode"],
  watch({ track: e, action: t, prop: r }) {
    e([() => r("present")], () => {
      t(["setInitial", "syncPresence"]);
    });
  },
  on: {
    "NODE.SET": {
      actions: ["setNode", "setStyles"]
    }
  },
  states: {
    mounted: {
      on: {
        UNMOUNT: {
          target: "unmounted",
          actions: ["clearPrevAnimationName", "invokeOnExitComplete"]
        },
        "UNMOUNT.SUSPEND": {
          target: "unmountSuspended"
        }
      }
    },
    unmountSuspended: {
      effects: ["trackAnimationEvents"],
      on: {
        MOUNT: {
          target: "mounted",
          actions: ["setPrevAnimationName"]
        },
        UNMOUNT: {
          target: "unmounted",
          actions: ["clearPrevAnimationName", "invokeOnExitComplete"]
        }
      }
    },
    unmounted: {
      on: {
        MOUNT: {
          target: "mounted",
          actions: ["setPrevAnimationName"]
        }
      }
    }
  },
  implementations: {
    actions: {
      setInitial: ({ context: e }) => {
        e.get("initial") || queueMicrotask(() => {
          e.set("initial", !0);
        });
      },
      clearInitial: ({ context: e }) => {
        e.set("initial", !1);
      },
      cleanupNode: ({ refs: e }) => {
        e.set("node", null), e.set("styles", null);
      },
      invokeOnExitComplete: ({ prop: e }) => {
        var t;
        (t = e("onExitComplete")) == null || t();
      },
      setNode: ({ refs: e, event: t }) => {
        e.set("node", t.node);
      },
      setStyles: ({ refs: e, event: t }) => {
        e.set("styles", wb(t.node));
      },
      syncPresence: ({ context: e, refs: t, send: r, prop: n }) => {
        const i = n("present");
        if (i)
          return r({ type: "MOUNT", src: "presence.changed" });
        const o = t.get("node");
        if (!i && (o == null ? void 0 : o.ownerDocument.visibilityState) === "hidden")
          return r({ type: "UNMOUNT", src: "visibilitychange" });
        de(() => {
          var a, l;
          const s = bs(t.get("styles"));
          e.set("unmountAnimationName", s), s === "none" || s === e.get("prevAnimationName") || ((a = t.get("styles")) == null ? void 0 : a.display) === "none" || ((l = t.get("styles")) == null ? void 0 : l.animationDuration) === "0s" ? r({ type: "UNMOUNT", src: "presence.changed" }) : r({ type: "UNMOUNT.SUSPEND" });
        });
      },
      setPrevAnimationName: ({ context: e, refs: t }) => {
        de(() => {
          e.set("prevAnimationName", bs(t.get("styles")));
        });
      },
      clearPrevAnimationName: ({ context: e }) => {
        e.set("prevAnimationName", null);
      }
    },
    effects: {
      trackAnimationEvents: ({ context: e, refs: t, send: r }) => {
        const n = t.get("node");
        if (!n) return;
        const i = (a) => {
          var c, u, f;
          ((f = (u = (c = a.composedPath) == null ? void 0 : c.call(a)) == null ? void 0 : u[0]) != null ? f : a.target) === n && e.set("prevAnimationName", bs(t.get("styles")));
        }, o = (a) => {
          const l = bs(t.get("styles"));
          Ct(a) === n && l === e.get("unmountAnimationName") && r({ type: "UNMOUNT", src: "animationend" });
        };
        n.addEventListener("animationstart", i), n.addEventListener("animationcancel", o), n.addEventListener("animationend", o);
        const s = ba(n, { animationFillMode: "forwards" });
        return () => {
          n.removeEventListener("animationstart", i), n.removeEventListener("animationcancel", o), n.removeEventListener("animationend", o), Ib(() => s());
        };
      }
    }
  }
};
function bs(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
ue()(["onExitComplete", "present", "immediate"]);
var Ab = typeof globalThis.document != "undefined" ? Jw : Ce;
function ya(e) {
  var f, d;
  const t = (f = e().value) != null ? f : e().defaultValue, r = (d = e().isEqual) != null ? d : Object.is, [n] = We(t), [i, o] = We(n), s = e().value !== void 0, a = at(i);
  a.current = s ? e().value : i;
  const l = at(a.current);
  Ab(() => {
    l.current = a.current;
  }, [i, e().value]);
  const c = (p) => {
    var m, v;
    const g = l.current, h = sn(p) ? p(g) : p;
    e().debug && console.log(`[bindable > ${e().debug}] setValue`, { next: h, prev: g }), s || o(h), r(h, g) || (v = (m = e()).onChange) == null || v.call(m, h, g);
  };
  function u() {
    return s ? e().value : i;
  }
  return {
    initial: n,
    ref: a,
    get: u,
    set(p) {
      (e().sync ? nd : tE)(() => c(p));
    },
    invoke(p, g) {
      var h, m;
      (m = (h = e()).onChange) == null || m.call(h, p, g);
    },
    hash(p) {
      var g, h, m;
      return (m = (h = (g = e()).hash) == null ? void 0 : h.call(g, p)) != null ? m : String(p);
    }
  };
}
ya.cleanup = (e) => {
  Ce(() => e, []);
};
ya.ref = (e) => {
  const t = at(e);
  return {
    get: () => t.current,
    set: (r) => {
      t.current = r;
    }
  };
};
function jC(e) {
  const t = at(e);
  return {
    get(r) {
      return t.current[r];
    },
    set(r, n) {
      t.current[r] = n;
    }
  };
}
var UC = (e, t) => {
  const r = at(!1), n = at(!1);
  Ce(() => {
    if (r.current && n.current) return t();
    n.current = !0;
  }, [...(e != null ? e : []).map((i) => typeof i == "function" ? i() : i)]), Ce(() => (r.current = !0, () => {
    r.current = !1;
  }), []);
};
function yn(e, t = {}) {
  var G, k, j, F, L, D;
  const r = _e(() => {
    const { id: N, ids: B, getRootNode: q } = t;
    return zC({ id: N, ids: B, getRootNode: q });
  }, [t]), n = (...N) => {
    e.debug && console.log(...N);
  }, i = (k = (G = e.props) == null ? void 0 : G.call(e, { props: nl(t), scope: r })) != null ? k : t, o = GC(i), s = (j = e.context) == null ? void 0 : j.call(e, {
    prop: o,
    bindable: ya,
    scope: r,
    flush: lh,
    getContext() {
      return l;
    },
    getComputed() {
      return _;
    },
    getRefs() {
      return h;
    }
  }), a = Nb(s), l = {
    get(N) {
      var B;
      return (B = a.current) == null ? void 0 : B[N].ref.current;
    },
    set(N, B) {
      var q;
      (q = a.current) == null || q[N].set(B);
    },
    initial(N) {
      var B;
      return (B = a.current) == null ? void 0 : B[N].initial;
    },
    hash(N) {
      var q, P;
      const B = (q = a.current) == null ? void 0 : q[N].get();
      return (P = a.current) == null ? void 0 : P[N].hash(B);
    }
  }, c = at(/* @__PURE__ */ new Map()), u = at(null), f = at(null), d = at({ type: "" }), p = () => ({
    ...d.current,
    current() {
      return d.current;
    },
    previous() {
      return f.current;
    }
  }), g = () => ({
    ...I,
    matches(...N) {
      return N.includes(I.ref.current);
    },
    hasTag(N) {
      var B, q;
      return !!((q = (B = e.states[I.ref.current]) == null ? void 0 : B.tags) != null && q.includes(N));
    }
  }), h = jC((L = (F = e.refs) == null ? void 0 : F.call(e, { prop: o, context: l })) != null ? L : {}), m = () => ({
    state: g(),
    context: l,
    event: p(),
    prop: o,
    send: T,
    action: v,
    guard: y,
    track: UC,
    refs: h,
    computed: _,
    flush: lh,
    scope: r,
    choose: S
  }), v = (N) => {
    const B = sn(N) ? N(m()) : N;
    if (!B) return;
    const q = B.map((P) => {
      var W, H;
      const C = (H = (W = e.implementations) == null ? void 0 : W.actions) == null ? void 0 : H[P];
      return C || Do(`[zag-js] No implementation found for action "${JSON.stringify(P)}"`), C;
    });
    for (const P of q)
      P == null || P(m());
  }, y = (N) => {
    var B, q;
    return sn(N) ? N(m()) : (q = (B = e.implementations) == null ? void 0 : B.guards) == null ? void 0 : q[N](m());
  }, x = (N) => {
    const B = sn(N) ? N(m()) : N;
    if (!B) return;
    const q = B.map((C) => {
      var H, V;
      const W = (V = (H = e.implementations) == null ? void 0 : H.effects) == null ? void 0 : V[C];
      return W || Do(`[zag-js] No implementation found for effect "${JSON.stringify(C)}"`), W;
    }), P = [];
    for (const C of q) {
      const W = C == null ? void 0 : C(m());
      W && P.push(W);
    }
    return () => P.forEach((C) => C == null ? void 0 : C());
  }, S = (N) => j1(N).find((B) => {
    let q = !B.guard;
    return Us(B.guard) ? q = !!y(B.guard) : sn(B.guard) && (q = B.guard(m())), q;
  }), _ = (N) => {
    vb(e.computed, () => "[zag-js] No computed object found on machine");
    const B = e.computed[N];
    return B({
      context: l,
      event: p(),
      prop: o,
      refs: h,
      scope: r,
      computed: _
    });
  }, I = ya(() => ({
    defaultValue: e.initialState({ prop: o }),
    onChange(N, B) {
      var P, C, W, H;
      if (B) {
        const V = c.current.get(B);
        V == null || V(), c.current.delete(B);
      }
      B && v((P = e.states[B]) == null ? void 0 : P.exit), v((C = u.current) == null ? void 0 : C.actions);
      const q = x((W = e.states[N]) == null ? void 0 : W.effects);
      if (q && c.current.set(N, q), B === ql) {
        v(e.entry);
        const V = x(e.effects);
        V && c.current.set(ql, V);
      }
      v((H = e.states[N]) == null ? void 0 : H.entry);
    }
  })), O = at(void 0), w = at(ai.NotStarted);
  Ab(() => {
    queueMicrotask(() => {
      var C;
      const q = w.current === ai.Started;
      w.current = ai.Started, n(q ? "rehydrating..." : "initializing...");
      const P = (C = O.current) != null ? C : I.initial;
      I.invoke(P, q ? I.get() : ql);
    });
    const N = c.current, B = I.ref.current;
    return () => {
      n("unmounting..."), O.current = B, w.current = ai.Stopped, N.forEach((q) => q == null ? void 0 : q()), c.current = /* @__PURE__ */ new Map(), u.current = null, queueMicrotask(() => {
        v(e.exit);
      });
    };
  }, []);
  const E = () => "ref" in I ? I.ref.current : I.get(), T = (N) => {
    queueMicrotask(() => {
      var H, V, Q, X, ne;
      if (w.current !== ai.Started) return;
      f.current = d.current, d.current = N, n("send", N);
      let B = E();
      const q = (
        // @ts-ignore
        (Q = (H = e.states[B].on) == null ? void 0 : H[N.type]) != null ? Q : (
          // @ts-ignore
          (V = e.on) == null ? void 0 : V[N.type]
        )
      ), P = S(q);
      if (!P) return;
      u.current = P;
      const C = (X = P.target) != null ? X : B;
      n("transition", P);
      const W = C !== B;
      W ? nd(() => I.set(C)) : P.reenter && !W ? I.invoke(B, B) : v((ne = P.actions) != null ? ne : []);
    });
  };
  return (D = e.watch) == null || D.call(e, m()), {
    state: g(),
    send: T,
    context: l,
    prop: o,
    scope: r,
    refs: h,
    computed: _,
    event: p(),
    getStatus: () => w.current
  };
}
function Nb(e) {
  const t = at(e);
  return t.current = e, t;
}
function GC(e) {
  const t = Nb(e);
  return function(n) {
    return t.current[n];
  };
}
function lh(e) {
  queueMicrotask(() => {
    nd(() => e());
  });
}
var Un = BC((e) => e);
function qC(e, t = {}) {
  const { sync: r = !1 } = t, n = KC(e);
  return lt(
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    (...i) => {
      var o;
      return r ? queueMicrotask(() => {
        var s;
        return (s = n.current) == null ? void 0 : s.call(n, ...i);
      }) : (o = n.current) == null ? void 0 : o.call(n, ...i);
    },
    [r, n]
  );
}
function KC(e) {
  const t = at(e);
  return t.current = e, t;
}
const Fi = (e = {}) => {
  const { lazyMount: t, unmountOnExit: r, present: n, skipAnimationOnMount: i = !1, ...o } = e, s = at(!1), a = {
    ...o,
    present: n,
    onExitComplete: qC(e.onExitComplete)
  }, l = yn(HC, a), c = WC(l);
  c.present && (s.current = !0);
  const u = !c.present && !s.current && t || r && !c.present && s.current, f = () => ({
    "data-state": c.skip && i ? void 0 : n ? "open" : "closed",
    hidden: !c.present
  });
  return {
    ref: c.setNode,
    getPresenceProps: f,
    present: c.present,
    unmounted: u
  };
}, [$i, Gn] = Bt({
  name: "PresenceContext",
  hookName: "usePresenceContext",
  providerName: "<PresenceProvider />"
});
function YC(e) {
  const { key: t, recipe: r } = e, n = tl();
  return _e(() => {
    const i = r || (t != null ? n.getSlotRecipe(t) : {});
    return n.sva(structuredClone(i));
  }, [t, r, n]);
}
const XC = (e) => e.charAt(0).toUpperCase() + e.slice(1), Li = (e) => {
  const { key: t, recipe: r } = e, n = XC(
    t || r.className || "Component"
  ), [i, o] = Io({
    name: `${n}StylesContext`,
    errorMessage: `use${n}Styles returned is 'undefined'. Seems you forgot to wrap the components in "<${n}.Root />" `
  }), [s, a] = Io({
    name: `${n}ClassNameContext`,
    errorMessage: `use${n}ClassNames returned is 'undefined'. Seems you forgot to wrap the components in "<${n}.Root />" `,
    strict: !1
  }), [l, c] = Io({
    strict: !1,
    name: `${n}PropsContext`,
    providerName: `${n}PropsContext`,
    defaultValue: {}
  });
  function u(g) {
    const { unstyled: h, ...m } = g, v = YC({
      key: t,
      recipe: m.recipe || r
    }), [y, x] = _e(
      () => v.splitVariantProps(m),
      [m, v]
    );
    return {
      styles: _e(
        () => h ? gS : v(y),
        [h, y, v]
      ),
      classNames: v.classNameMap,
      props: x
    };
  }
  function f(g, h = {}) {
    const { defaultProps: m } = h, v = (y) => {
      const x = c(), S = _e(
        () => Fo(m, x, y),
        [x, y]
      ), { styles: _, classNames: I, props: O } = u(S);
      return /* @__PURE__ */ b(i, { value: _, children: /* @__PURE__ */ b(s, { value: I, children: /* @__PURE__ */ b(g, { ...O }) }) });
    };
    return v.displayName = g.displayName || g.name, v;
  }
  return {
    StylesProvider: i,
    ClassNamesProvider: s,
    PropsProvider: l,
    usePropsContext: c,
    useRecipeResult: u,
    withProvider: (g, h, m) => {
      const { defaultProps: v, ...y } = m != null ? m : {}, x = qe(g, {}, y), S = Z((_, I) => {
        var F, L;
        const O = c(), w = _e(
          () => Fo(v != null ? v : {}, O, _),
          [O, _]
        ), { styles: E, props: T, classNames: G } = u(w), k = G[h], j = /* @__PURE__ */ b(i, { value: E, children: /* @__PURE__ */ b(s, { value: G, children: /* @__PURE__ */ b(
          x,
          {
            ref: I,
            ...T,
            css: [E[h], w.css],
            className: Yt(w.className, k)
          }
        ) }) });
        return (L = (F = m == null ? void 0 : m.wrapElement) == null ? void 0 : F.call(m, j, w)) != null ? L : j;
      });
      return S.displayName = g.displayName || g.name, S;
    },
    withContext: (g, h, m) => {
      const v = qe(g, {}, m), y = Z((x, S) => {
        const _ = o(), I = a(), O = I == null ? void 0 : I[h];
        return /* @__PURE__ */ b(
          v,
          {
            ...x,
            css: [h ? _[h] : void 0, x.css],
            ref: S,
            className: Yt(x.className, O)
          }
        );
      });
      return y.displayName = g.displayName || g.name, y;
    },
    withRootProvider: f,
    useStyles: o,
    useClassNames: a
  };
};
function ch(e, t = []) {
  const r = at(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return Zw(() => {
    r.current = e;
  }), lt((...n) => {
    var i;
    return (i = r.current) == null ? void 0 : i.call(r, ...n);
  }, t);
}
function JC(e = {}) {
  const t = ch(e.onOpen), r = ch(e.onClose), [n, i] = We(e.defaultOpen || !1), o = e.open !== void 0 ? e.open : n, s = e.open !== void 0, a = lt(() => {
    s || i(!1), r == null || r();
  }, [s, r]), l = lt(() => {
    s || i(!0), t == null || t();
  }, [s, t]), c = lt(() => {
    o ? a() : l();
  }, [o, l, a]);
  return {
    open: o,
    onOpen: l,
    onClose: a,
    onToggle: c,
    setOpen: i
  };
}
var le = (e, t = []) => ({
  parts: (...r) => {
    if (ZC(t))
      return le(e, r);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...r) => le(e, [...t, ...r]),
  rename: (r) => le(r, t),
  keys: () => t,
  build: () => [...new Set(t)].reduce(
    (r, n) => Object.assign(r, {
      [n]: {
        selector: [
          `&[data-scope="${Jn(e)}"][data-part="${Jn(n)}"]`,
          `& [data-scope="${Jn(e)}"][data-part="${Jn(n)}"]`
        ].join(", "),
        attrs: { "data-scope": Jn(e), "data-part": Jn(n) }
      }
    }),
    {}
  )
}), Jn = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), ZC = (e) => e.length === 0, Fb = le("collapsible").parts("root", "trigger", "content", "indicator");
Fb.build();
ue()([
  "dir",
  "disabled",
  "getRootNode",
  "id",
  "ids",
  "onExitComplete",
  "onOpenChange",
  "defaultOpen",
  "open"
]);
var QC = Object.defineProperty, ek = (e, t, r) => t in e ? QC(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, kd = (e, t, r) => ek(e, t + "", r), tk = (e, t) => {
  if (Object.keys(e).length !== Object.keys(t).length) return !1;
  for (let r in e) if (e[r] !== t[r]) return !1;
  return !0;
}, Id = class {
  toHexInt() {
    return this.toFormat("rgba").toHexInt();
  }
  getChannelValue(e) {
    if (e in this) return this[e];
    throw new Error("Unsupported color channel: " + e);
  }
  getChannelValuePercent(e, t) {
    const r = t != null ? t : this.getChannelValue(e), { minValue: n, maxValue: i } = this.getChannelRange(e);
    return gb(r, n, i);
  }
  getChannelPercentValue(e, t) {
    const { minValue: r, maxValue: n, step: i } = this.getChannelRange(e), o = fE(t, r, n, i);
    return th(o, r, n, i);
  }
  withChannelValue(e, t) {
    const { minValue: r, maxValue: n } = this.getChannelRange(e);
    if (e in this) {
      let i = this.clone();
      return i[e] = Et(t, r, n), i;
    }
    throw new Error("Unsupported color channel: " + e);
  }
  getColorAxes(e) {
    let { xChannel: t, yChannel: r } = e, n = t || this.getChannels().find((s) => s !== r), i = r || this.getChannels().find((s) => s !== n), o = this.getChannels().find((s) => s !== n && s !== i);
    return { xChannel: n, yChannel: i, zChannel: o };
  }
  incrementChannel(e, t) {
    const { minValue: r, maxValue: n, step: i } = this.getChannelRange(e), o = th(
      Et(this.getChannelValue(e) + t, r, n),
      r,
      n,
      i
    );
    return this.withChannelValue(e, o);
  }
  decrementChannel(e, t) {
    return this.incrementChannel(e, -t);
  }
  isEqual(e) {
    return tk(this.toJSON(), e.toJSON()) && this.getChannelValue("alpha") === e.getChannelValue("alpha");
  }
}, $b = class Ks extends Id {
  constructor(t, r, n, i) {
    super(), this.red = t, this.green = r, this.blue = n, this.alpha = i;
  }
  static parse(t) {
    var i;
    let r = [];
    if (/^#[\da-f]+$/i.test(t) && [4, 5, 7, 9].includes(t.length)) {
      const o = (t.length < 6 ? t.replace(/[^#]/gi, "$&$&") : t).slice(1).split("");
      for (; o.length > 0; )
        r.push(parseInt(o.splice(0, 2).join(""), 16));
      r[3] = r[3] !== void 0 ? r[3] / 255 : void 0;
    }
    const n = t.match(/^rgba?\((.*)\)$/);
    return n != null && n[1] && (r = n[1].split(",").map((o) => Number(o.trim())).map((o, s) => Et(o, 0, s < 3 ? 255 : 1))), r.length < 3 ? void 0 : new Ks(r[0], r[1], r[2], (i = r[3]) != null ? i : 1);
  }
  toString(t) {
    switch (t) {
      case "hex":
        return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0")).toUpperCase();
      case "hexa":
        return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0") + Math.round(this.alpha * 255).toString(16).padStart(2, "0")).toUpperCase();
      case "rgb":
        return `rgb(${this.red}, ${this.green}, ${this.blue})`;
      case "css":
      case "rgba":
        return `rgba(${this.red}, ${this.green}, ${this.blue}, ${this.alpha})`;
      case "hsl":
        return this.toHSL().toString("hsl");
      case "hsb":
        return this.toHSB().toString("hsb");
      default:
        return this.toFormat(t).toString(t);
    }
  }
  toFormat(t) {
    switch (t) {
      case "rgba":
        return this;
      case "hsba":
        return this.toHSB();
      case "hsla":
        return this.toHSL();
      default:
        throw new Error("Unsupported color conversion: rgb -> " + t);
    }
  }
  toHexInt() {
    return this.red << 16 | this.green << 8 | this.blue;
  }
  /**
   * Converts an RGB color value to HSB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
   * @returns An HSBColor object.
   */
  toHSB() {
    const t = this.red / 255, r = this.green / 255, n = this.blue / 255, i = Math.min(t, r, n), o = Math.max(t, r, n), s = o - i, a = o === 0 ? 0 : s / o;
    let l = 0;
    if (s !== 0) {
      switch (o) {
        case t:
          l = (r - n) / s + (r < n ? 6 : 0);
          break;
        case r:
          l = (n - t) / s + 2;
          break;
        case n:
          l = (t - r) / s + 4;
          break;
      }
      l /= 6;
    }
    return new Td(
      Re(l * 360, 2),
      Re(a * 100, 2),
      Re(o * 100, 2),
      Re(this.alpha, 2)
    );
  }
  /**
   * Converts an RGB color value to HSL.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
   * @returns An HSLColor object.
   */
  toHSL() {
    const t = this.red / 255, r = this.green / 255, n = this.blue / 255, i = Math.min(t, r, n), o = Math.max(t, r, n), s = (o + i) / 2, a = o - i;
    let l = -1, c = -1;
    if (a === 0)
      l = c = 0;
    else {
      switch (c = a / (s < 0.5 ? o + i : 2 - o - i), o) {
        case t:
          l = (r - n) / a + (r < n ? 6 : 0);
          break;
        case r:
          l = (n - t) / a + 2;
          break;
        case n:
          l = (t - r) / a + 4;
          break;
      }
      l /= 6;
    }
    return new Pd(
      Re(l * 360, 2),
      Re(c * 100, 2),
      Re(s * 100, 2),
      Re(this.alpha, 2)
    );
  }
  clone() {
    return new Ks(this.red, this.green, this.blue, this.alpha);
  }
  getChannelFormatOptions(t) {
    switch (t) {
      case "red":
      case "green":
      case "blue":
        return { style: "decimal" };
      case "alpha":
        return { style: "percent" };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  formatChannelValue(t, r) {
    let n = this.getChannelFormatOptions(t), i = this.getChannelValue(t);
    return new Intl.NumberFormat(r, n).format(i);
  }
  getChannelRange(t) {
    switch (t) {
      case "red":
      case "green":
      case "blue":
        return { minValue: 0, maxValue: 255, step: 1, pageSize: 17 };
      case "alpha":
        return { minValue: 0, maxValue: 1, step: 0.01, pageSize: 0.1 };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  toJSON() {
    return { r: this.red, g: this.green, b: this.blue, a: this.alpha };
  }
  getFormat() {
    return "rgba";
  }
  getChannels() {
    return Ks.colorChannels;
  }
};
kd($b, "colorChannels", ["red", "green", "blue"]);
var Od = $b, rk = /hsl\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsla\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/, Lb = class Ys extends Id {
  constructor(t, r, n, i) {
    super(), this.hue = t, this.saturation = r, this.lightness = n, this.alpha = i;
  }
  static parse(t) {
    var n;
    let r;
    if (r = t.match(rk)) {
      const [i, o, s, a] = ((n = r[1]) != null ? n : r[2]).split(",").map((l) => Number(l.trim().replace("%", "")));
      return new Ys(pb(i, 360), Et(o, 0, 100), Et(s, 0, 100), Et(a != null ? a : 1, 0, 1));
    }
  }
  toString(t) {
    switch (t) {
      case "hex":
        return this.toRGB().toString("hex");
      case "hexa":
        return this.toRGB().toString("hexa");
      case "hsl":
        return `hsl(${this.hue}, ${Re(this.saturation, 2)}%, ${Re(this.lightness, 2)}%)`;
      case "css":
      case "hsla":
        return `hsla(${this.hue}, ${Re(this.saturation, 2)}%, ${Re(this.lightness, 2)}%, ${this.alpha})`;
      case "hsb":
        return this.toHSB().toString("hsb");
      case "rgb":
        return this.toRGB().toString("rgb");
      default:
        return this.toFormat(t).toString(t);
    }
  }
  toFormat(t) {
    switch (t) {
      case "hsla":
        return this;
      case "hsba":
        return this.toHSB();
      case "rgba":
        return this.toRGB();
      default:
        throw new Error("Unsupported color conversion: hsl -> " + t);
    }
  }
  /**
   * Converts a HSL color to HSB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_HSV.
   * @returns An HSBColor object.
   */
  toHSB() {
    let t = this.saturation / 100, r = this.lightness / 100, n = r + t * Math.min(r, 1 - r);
    return t = n === 0 ? 0 : 2 * (1 - r / n), new Td(
      Re(this.hue, 2),
      Re(t * 100, 2),
      Re(n * 100, 2),
      Re(this.alpha, 2)
    );
  }
  /**
   * Converts a HSL color to RGB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative.
   * @returns An RGBColor object.
   */
  toRGB() {
    let t = this.hue, r = this.saturation / 100, n = this.lightness / 100, i = r * Math.min(n, 1 - n), o = (s, a = (s + t / 30) % 12) => n - i * Math.max(Math.min(a - 3, 9 - a, 1), -1);
    return new Od(
      Math.round(o(0) * 255),
      Math.round(o(8) * 255),
      Math.round(o(4) * 255),
      Re(this.alpha, 2)
    );
  }
  clone() {
    return new Ys(this.hue, this.saturation, this.lightness, this.alpha);
  }
  getChannelFormatOptions(t) {
    switch (t) {
      case "hue":
        return { style: "unit", unit: "degree", unitDisplay: "narrow" };
      case "saturation":
      case "lightness":
      case "alpha":
        return { style: "percent" };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  formatChannelValue(t, r) {
    let n = this.getChannelFormatOptions(t), i = this.getChannelValue(t);
    return (t === "saturation" || t === "lightness") && (i /= 100), new Intl.NumberFormat(r, n).format(i);
  }
  getChannelRange(t) {
    switch (t) {
      case "hue":
        return { minValue: 0, maxValue: 360, step: 1, pageSize: 15 };
      case "saturation":
      case "lightness":
        return { minValue: 0, maxValue: 100, step: 1, pageSize: 10 };
      case "alpha":
        return { minValue: 0, maxValue: 1, step: 0.01, pageSize: 0.1 };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  toJSON() {
    return { h: this.hue, s: this.saturation, l: this.lightness, a: this.alpha };
  }
  getFormat() {
    return "hsla";
  }
  getChannels() {
    return Ys.colorChannels;
  }
};
kd(Lb, "colorChannels", ["hue", "saturation", "lightness"]);
var Pd = Lb, nk = /hsb\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsba\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/, Vb = class Xs extends Id {
  constructor(t, r, n, i) {
    super(), this.hue = t, this.saturation = r, this.brightness = n, this.alpha = i;
  }
  static parse(t) {
    var n;
    let r;
    if (r = t.match(nk)) {
      const [i, o, s, a] = ((n = r[1]) != null ? n : r[2]).split(",").map((l) => Number(l.trim().replace("%", "")));
      return new Xs(pb(i, 360), Et(o, 0, 100), Et(s, 0, 100), Et(a != null ? a : 1, 0, 1));
    }
  }
  toString(t) {
    switch (t) {
      case "css":
        return this.toHSL().toString("css");
      case "hex":
        return this.toRGB().toString("hex");
      case "hexa":
        return this.toRGB().toString("hexa");
      case "hsb":
        return `hsb(${this.hue}, ${Re(this.saturation, 2)}%, ${Re(this.brightness, 2)}%)`;
      case "hsba":
        return `hsba(${this.hue}, ${Re(this.saturation, 2)}%, ${Re(this.brightness, 2)}%, ${this.alpha})`;
      case "hsl":
        return this.toHSL().toString("hsl");
      case "rgb":
        return this.toRGB().toString("rgb");
      default:
        return this.toFormat(t).toString(t);
    }
  }
  toFormat(t) {
    switch (t) {
      case "hsba":
        return this;
      case "hsla":
        return this.toHSL();
      case "rgba":
        return this.toRGB();
      default:
        throw new Error("Unsupported color conversion: hsb -> " + t);
    }
  }
  /**
   * Converts a HSB color to HSL.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_HSL.
   * @returns An HSLColor object.
   */
  toHSL() {
    let t = this.saturation / 100, r = this.brightness / 100, n = r * (1 - t / 2);
    return t = n === 0 || n === 1 ? 0 : (r - n) / Math.min(n, 1 - n), new Pd(
      Re(this.hue, 2),
      Re(t * 100, 2),
      Re(n * 100, 2),
      Re(this.alpha, 2)
    );
  }
  /**
   * Converts a HSV color value to RGB.
   * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_RGB_alternative.
   * @returns An RGBColor object.
   */
  toRGB() {
    let t = this.hue, r = this.saturation / 100, n = this.brightness / 100, i = (o, s = (o + t / 60) % 6) => n - r * n * Math.max(Math.min(s, 4 - s, 1), 0);
    return new Od(
      Math.round(i(5) * 255),
      Math.round(i(3) * 255),
      Math.round(i(1) * 255),
      Re(this.alpha, 2)
    );
  }
  clone() {
    return new Xs(this.hue, this.saturation, this.brightness, this.alpha);
  }
  getChannelFormatOptions(t) {
    switch (t) {
      case "hue":
        return { style: "unit", unit: "degree", unitDisplay: "narrow" };
      case "saturation":
      case "brightness":
      case "alpha":
        return { style: "percent" };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  formatChannelValue(t, r) {
    let n = this.getChannelFormatOptions(t), i = this.getChannelValue(t);
    return (t === "saturation" || t === "brightness") && (i /= 100), new Intl.NumberFormat(r, n).format(i);
  }
  getChannelRange(t) {
    switch (t) {
      case "hue":
        return { minValue: 0, maxValue: 360, step: 1, pageSize: 15 };
      case "saturation":
      case "brightness":
        return { minValue: 0, maxValue: 100, step: 1, pageSize: 10 };
      case "alpha":
        return { minValue: 0, maxValue: 1, step: 0.01, pageSize: 0.1 };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  toJSON() {
    return { h: this.hue, s: this.saturation, b: this.brightness, a: this.alpha };
  }
  getFormat() {
    return "hsba";
  }
  getChannels() {
    return Xs.colorChannels;
  }
};
kd(Vb, "colorChannels", ["hue", "saturation", "brightness"]);
var Td = Vb, ik = "aliceblue:f0f8ff,antiquewhite:faebd7,aqua:00ffff,aquamarine:7fffd4,azure:f0ffff,beige:f5f5dc,bisque:ffe4c4,black:000000,blanchedalmond:ffebcd,blue:0000ff,blueviolet:8a2be2,brown:a52a2a,burlywood:deb887,cadetblue:5f9ea0,chartreuse:7fff00,chocolate:d2691e,coral:ff7f50,cornflowerblue:6495ed,cornsilk:fff8dc,crimson:dc143c,cyan:00ffff,darkblue:00008b,darkcyan:008b8b,darkgoldenrod:b8860b,darkgray:a9a9a9,darkgreen:006400,darkkhaki:bdb76b,darkmagenta:8b008b,darkolivegreen:556b2f,darkorange:ff8c00,darkorchid:9932cc,darkred:8b0000,darksalmon:e9967a,darkseagreen:8fbc8f,darkslateblue:483d8b,darkslategray:2f4f4f,darkturquoise:00ced1,darkviolet:9400d3,deeppink:ff1493,deepskyblue:00bfff,dimgray:696969,dodgerblue:1e90ff,firebrick:b22222,floralwhite:fffaf0,forestgreen:228b22,fuchsia:ff00ff,gainsboro:dcdcdc,ghostwhite:f8f8ff,gold:ffd700,goldenrod:daa520,gray:808080,green:008000,greenyellow:adff2f,honeydew:f0fff0,hotpink:ff69b4,indianred:cd5c5c,indigo:4b0082,ivory:fffff0,khaki:f0e68c,lavender:e6e6fa,lavenderblush:fff0f5,lawngreen:7cfc00,lemonchiffon:fffacd,lightblue:add8e6,lightcoral:f08080,lightcyan:e0ffff,lightgoldenrodyellow:fafad2,lightgrey:d3d3d3,lightgreen:90ee90,lightpink:ffb6c1,lightsalmon:ffa07a,lightseagreen:20b2aa,lightskyblue:87cefa,lightslategray:778899,lightsteelblue:b0c4de,lightyellow:ffffe0,lime:00ff00,limegreen:32cd32,linen:faf0e6,magenta:ff00ff,maroon:800000,mediumaquamarine:66cdaa,mediumblue:0000cd,mediumorchid:ba55d3,mediumpurple:9370d8,mediumseagreen:3cb371,mediumslateblue:7b68ee,mediumspringgreen:00fa9a,mediumturquoise:48d1cc,mediumvioletred:c71585,midnightblue:191970,mintcream:f5fffa,mistyrose:ffe4e1,moccasin:ffe4b5,navajowhite:ffdead,navy:000080,oldlace:fdf5e6,olive:808000,olivedrab:6b8e23,orange:ffa500,orangered:ff4500,orchid:da70d6,palegoldenrod:eee8aa,palegreen:98fb98,paleturquoise:afeeee,palevioletred:d87093,papayawhip:ffefd5,peachpuff:ffdab9,peru:cd853f,pink:ffc0cb,plum:dda0dd,powderblue:b0e0e6,purple:800080,rebeccapurple:663399,red:ff0000,rosybrown:bc8f8f,royalblue:4169e1,saddlebrown:8b4513,salmon:fa8072,sandybrown:f4a460,seagreen:2e8b57,seashell:fff5ee,sienna:a0522d,silver:c0c0c0,skyblue:87ceeb,slateblue:6a5acd,slategray:708090,snow:fffafa,springgreen:00ff7f,steelblue:4682b4,tan:d2b48c,teal:008080,thistle:d8bfd8,tomato:ff6347,turquoise:40e0d0,violet:ee82ee,wheat:f5deb3,white:ffffff,whitesmoke:f5f5f5,yellow:ffff00,yellowgreen:9acd32", ok = (e) => {
  const t = /* @__PURE__ */ new Map(), r = e.split(",");
  for (let n = 0; n < r.length; n++) {
    const [i, o] = r[n].split(":");
    t.set(i, `#${o}`), i.includes("gray") && t.set(i.replace("gray", "grey"), `#${o}`);
  }
  return t;
}, uh = ok(ik), xa = (e) => {
  var r;
  if (uh.has(e))
    return xa(uh.get(e));
  const t = Od.parse(e) || Td.parse(e) || Pd.parse(e);
  if (!t) {
    const n = new Error("Invalid color value: " + e);
    throw (r = Error.captureStackTrace) == null || r.call(Error, n, xa), n;
  }
  return t;
};
const sk = ["top", "right", "bottom", "left"], hn = Math.min, Lt = Math.max, _a = Math.round, ys = Math.floor, wr = (e) => ({
  x: e,
  y: e
}), ak = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, lk = {
  start: "end",
  end: "start"
};
function Uc(e, t, r) {
  return Lt(e, hn(t, r));
}
function Ur(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Gr(e) {
  return e.split("-")[0];
}
function Vi(e) {
  return e.split("-")[1];
}
function Rd(e) {
  return e === "x" ? "y" : "x";
}
function Ad(e) {
  return e === "y" ? "height" : "width";
}
function mr(e) {
  return ["top", "bottom"].includes(Gr(e)) ? "y" : "x";
}
function Nd(e) {
  return Rd(mr(e));
}
function ck(e, t, r) {
  r === void 0 && (r = !1);
  const n = Vi(e), i = Nd(e), o = Ad(i);
  let s = i === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (s = wa(s)), [s, wa(s)];
}
function uk(e) {
  const t = wa(e);
  return [Gc(e), t, Gc(t)];
}
function Gc(e) {
  return e.replace(/start|end/g, (t) => lk[t]);
}
function dk(e, t, r) {
  const n = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? i : n : t ? n : i;
    case "left":
    case "right":
      return t ? o : s;
    default:
      return [];
  }
}
function fk(e, t, r, n) {
  const i = Vi(e);
  let o = dk(Gr(e), r === "start", n);
  return i && (o = o.map((s) => s + "-" + i), t && (o = o.concat(o.map(Gc)))), o;
}
function wa(e) {
  return e.replace(/left|right|bottom|top/g, (t) => ak[t]);
}
function hk(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function zb(e) {
  return typeof e != "number" ? hk(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Sa(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: i
  } = e;
  return {
    width: n,
    height: i,
    top: r,
    left: t,
    right: t + n,
    bottom: r + i,
    x: t,
    y: r
  };
}
function dh(e, t, r) {
  let {
    reference: n,
    floating: i
  } = e;
  const o = mr(t), s = Nd(t), a = Ad(s), l = Gr(t), c = o === "y", u = n.x + n.width / 2 - i.width / 2, f = n.y + n.height / 2 - i.height / 2, d = n[a] / 2 - i[a] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: u,
        y: n.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: n.y + n.height
      };
      break;
    case "right":
      p = {
        x: n.x + n.width,
        y: f
      };
      break;
    case "left":
      p = {
        x: n.x - i.width,
        y: f
      };
      break;
    default:
      p = {
        x: n.x,
        y: n.y
      };
  }
  switch (Vi(t)) {
    case "start":
      p[s] -= d * (r && c ? -1 : 1);
      break;
    case "end":
      p[s] += d * (r && c ? -1 : 1);
      break;
  }
  return p;
}
const pk = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = r, a = o.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: u,
    y: f
  } = dh(c, n, l), d = n, p = {}, g = 0;
  for (let h = 0; h < a.length; h++) {
    const {
      name: m,
      fn: v
    } = a[h], {
      x: y,
      y: x,
      data: S,
      reset: _
    } = await v({
      x: u,
      y: f,
      initialPlacement: n,
      placement: d,
      strategy: i,
      middlewareData: p,
      rects: c,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = y != null ? y : u, f = x != null ? x : f, p = {
      ...p,
      [m]: {
        ...p[m],
        ...S
      }
    }, _ && g <= 50 && (g++, typeof _ == "object" && (_.placement && (d = _.placement), _.rects && (c = _.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : _.rects), {
      x: u,
      y: f
    } = dh(c, d, l)), h = -1);
  }
  return {
    x: u,
    y: f,
    placement: d,
    strategy: i,
    middlewareData: p
  };
};
async function Wo(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: i,
    platform: o,
    rects: s,
    elements: a,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: f = "floating",
    altBoundary: d = !1,
    padding: p = 0
  } = Ur(t, e), g = zb(p), m = a[d ? f === "floating" ? "reference" : "floating" : f], v = Sa(await o.getClippingRect({
    element: (r = await (o.isElement == null ? void 0 : o.isElement(m))) == null || r ? m : m.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), y = f === "floating" ? {
    x: n,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, x = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), S = await (o.isElement == null ? void 0 : o.isElement(x)) ? await (o.getScale == null ? void 0 : o.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, _ = Sa(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: y,
    offsetParent: x,
    strategy: l
  }) : y);
  return {
    top: (v.top - _.top + g.top) / S.y,
    bottom: (_.bottom - v.bottom + g.bottom) / S.y,
    left: (v.left - _.left + g.left) / S.x,
    right: (_.right - v.right + g.right) / S.x
  };
}
const gk = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: i,
      rects: o,
      platform: s,
      elements: a,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = Ur(e, t) || {};
    if (c == null)
      return {};
    const f = zb(u), d = {
      x: r,
      y: n
    }, p = Nd(i), g = Ad(p), h = await s.getDimensions(c), m = p === "y", v = m ? "top" : "left", y = m ? "bottom" : "right", x = m ? "clientHeight" : "clientWidth", S = o.reference[g] + o.reference[p] - d[p] - o.floating[g], _ = d[p] - o.reference[p], I = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let O = I ? I[x] : 0;
    (!O || !await (s.isElement == null ? void 0 : s.isElement(I))) && (O = a.floating[x] || o.floating[g]);
    const w = S / 2 - _ / 2, E = O / 2 - h[g] / 2 - 1, T = hn(f[v], E), G = hn(f[y], E), k = T, j = O - h[g] - G, F = O / 2 - h[g] / 2 + w, L = Uc(k, F, j), D = !l.arrow && Vi(i) != null && F !== L && o.reference[g] / 2 - (F < k ? T : G) - h[g] / 2 < 0, N = D ? F < k ? F - k : F - j : 0;
    return {
      [p]: d[p] + N,
      data: {
        [p]: L,
        centerOffset: F - L - N,
        ...D && {
          alignmentOffset: N
        }
      },
      reset: D
    };
  }
}), mk = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: i,
        middlewareData: o,
        rects: s,
        initialPlacement: a,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: d,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: h = !0,
        ...m
      } = Ur(e, t);
      if ((r = o.arrow) != null && r.alignmentOffset)
        return {};
      const v = Gr(i), y = mr(a), x = Gr(a) === a, S = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), _ = d || (x || !h ? [wa(a)] : uk(a)), I = g !== "none";
      !d && I && _.push(...fk(a, h, g, S));
      const O = [a, ..._], w = await Wo(t, m), E = [];
      let T = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (u && E.push(w[v]), f) {
        const F = ck(i, s, S);
        E.push(w[F[0]], w[F[1]]);
      }
      if (T = [...T, {
        placement: i,
        overflows: E
      }], !E.every((F) => F <= 0)) {
        var G, k;
        const F = (((G = o.flip) == null ? void 0 : G.index) || 0) + 1, L = O[F];
        if (L && (!(f === "alignment" ? y !== mr(L) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        T.every((B) => B.overflows[0] > 0 && mr(B.placement) === y)))
          return {
            data: {
              index: F,
              overflows: T
            },
            reset: {
              placement: L
            }
          };
        let D = (k = T.filter((N) => N.overflows[0] <= 0).sort((N, B) => N.overflows[1] - B.overflows[1])[0]) == null ? void 0 : k.placement;
        if (!D)
          switch (p) {
            case "bestFit": {
              var j;
              const N = (j = T.filter((B) => {
                if (I) {
                  const q = mr(B.placement);
                  return q === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  q === "y";
                }
                return !0;
              }).map((B) => [B.placement, B.overflows.filter((q) => q > 0).reduce((q, P) => q + P, 0)]).sort((B, q) => B[1] - q[1])[0]) == null ? void 0 : j[0];
              N && (D = N);
              break;
            }
            case "initialPlacement":
              D = a;
              break;
          }
        if (i !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
};
function fh(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function hh(e) {
  return sk.some((t) => e[t] >= 0);
}
const vk = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: n = "referenceHidden",
        ...i
      } = Ur(e, t);
      switch (n) {
        case "referenceHidden": {
          const o = await Wo(t, {
            ...i,
            elementContext: "reference"
          }), s = fh(o, r.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: hh(s)
            }
          };
        }
        case "escaped": {
          const o = await Wo(t, {
            ...i,
            altBoundary: !0
          }), s = fh(o, r.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: hh(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function bk(e, t) {
  const {
    placement: r,
    platform: n,
    elements: i
  } = e, o = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), s = Gr(r), a = Vi(r), l = mr(r) === "y", c = ["left", "top"].includes(s) ? -1 : 1, u = o && l ? -1 : 1, f = Ur(t, e);
  let {
    mainAxis: d,
    crossAxis: p,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return a && typeof g == "number" && (p = a === "end" ? g * -1 : g), l ? {
    x: p * u,
    y: d * c
  } : {
    x: d * c,
    y: p * u
  };
}
const yk = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: i,
        y: o,
        placement: s,
        middlewareData: a
      } = t, l = await bk(t, e);
      return s === ((r = a.offset) == null ? void 0 : r.placement) && (n = a.arrow) != null && n.alignmentOffset ? {} : {
        x: i + l.x,
        y: o + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, xk = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (m) => {
            let {
              x: v,
              y
            } = m;
            return {
              x: v,
              y
            };
          }
        },
        ...l
      } = Ur(e, t), c = {
        x: r,
        y: n
      }, u = await Wo(t, l), f = mr(Gr(i)), d = Rd(f);
      let p = c[d], g = c[f];
      if (o) {
        const m = d === "y" ? "top" : "left", v = d === "y" ? "bottom" : "right", y = p + u[m], x = p - u[v];
        p = Uc(y, p, x);
      }
      if (s) {
        const m = f === "y" ? "top" : "left", v = f === "y" ? "bottom" : "right", y = g + u[m], x = g - u[v];
        g = Uc(y, g, x);
      }
      const h = a.fn({
        ...t,
        [d]: p,
        [f]: g
      });
      return {
        ...h,
        data: {
          x: h.x - r,
          y: h.y - n,
          enabled: {
            [d]: o,
            [f]: s
          }
        }
      };
    }
  };
}, _k = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: i,
        rects: o,
        middlewareData: s
      } = t, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = Ur(e, t), u = {
        x: r,
        y: n
      }, f = mr(i), d = Rd(f);
      let p = u[d], g = u[f];
      const h = Ur(a, t), m = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (l) {
        const x = d === "y" ? "height" : "width", S = o.reference[d] - o.floating[x] + m.mainAxis, _ = o.reference[d] + o.reference[x] - m.mainAxis;
        p < S ? p = S : p > _ && (p = _);
      }
      if (c) {
        var v, y;
        const x = d === "y" ? "width" : "height", S = ["top", "left"].includes(Gr(i)), _ = o.reference[f] - o.floating[x] + (S && ((v = s.offset) == null ? void 0 : v[f]) || 0) + (S ? 0 : m.crossAxis), I = o.reference[f] + o.reference[x] + (S ? 0 : ((y = s.offset) == null ? void 0 : y[f]) || 0) - (S ? m.crossAxis : 0);
        g < _ ? g = _ : g > I && (g = I);
      }
      return {
        [d]: p,
        [f]: g
      };
    }
  };
}, wk = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: i,
        rects: o,
        platform: s,
        elements: a
      } = t, {
        apply: l = () => {
        },
        ...c
      } = Ur(e, t), u = await Wo(t, c), f = Gr(i), d = Vi(i), p = mr(i) === "y", {
        width: g,
        height: h
      } = o.floating;
      let m, v;
      f === "top" || f === "bottom" ? (m = f, v = d === (await (s.isRTL == null ? void 0 : s.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (v = f, m = d === "end" ? "top" : "bottom");
      const y = h - u.top - u.bottom, x = g - u.left - u.right, S = hn(h - u[m], y), _ = hn(g - u[v], x), I = !t.middlewareData.shift;
      let O = S, w = _;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (w = x), (n = t.middlewareData.shift) != null && n.enabled.y && (O = y), I && !d) {
        const T = Lt(u.left, 0), G = Lt(u.right, 0), k = Lt(u.top, 0), j = Lt(u.bottom, 0);
        p ? w = g - 2 * (T !== 0 || G !== 0 ? T + G : Lt(u.left, u.right)) : O = h - 2 * (k !== 0 || j !== 0 ? k + j : Lt(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: w,
        availableHeight: O
      });
      const E = await s.getDimensions(a.floating);
      return g !== E.width || h !== E.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ul() {
  return typeof window != "undefined";
}
function zi(e) {
  return Db(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Dt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ir(e) {
  var t;
  return (t = (Db(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Db(e) {
  return ul() ? e instanceof Node || e instanceof Dt(e).Node : !1;
}
function or(e) {
  return ul() ? e instanceof Element || e instanceof Dt(e).Element : !1;
}
function Cr(e) {
  return ul() ? e instanceof HTMLElement || e instanceof Dt(e).HTMLElement : !1;
}
function ph(e) {
  return !ul() || typeof ShadowRoot == "undefined" ? !1 : e instanceof ShadowRoot || e instanceof Dt(e).ShadowRoot;
}
function ns(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: i
  } = sr(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(i);
}
function Sk(e) {
  return ["table", "td", "th"].includes(zi(e));
}
function dl(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch (r) {
      return !1;
    }
  });
}
function Fd(e) {
  const t = $d(), r = or(e) ? sr(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function Ek(e) {
  let t = pn(e);
  for (; Cr(t) && !Ci(t); ) {
    if (Fd(t))
      return t;
    if (dl(t))
      return null;
    t = pn(t);
  }
  return null;
}
function $d() {
  return typeof CSS == "undefined" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ci(e) {
  return ["html", "body", "#document"].includes(zi(e));
}
function sr(e) {
  return Dt(e).getComputedStyle(e);
}
function fl(e) {
  return or(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function pn(e) {
  if (zi(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    ph(e) && e.host || // Fallback.
    Ir(e)
  );
  return ph(t) ? t.host : t;
}
function Mb(e) {
  const t = pn(e);
  return Ci(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Cr(t) && ns(t) ? t : Mb(t);
}
function Ho(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const i = Mb(e), o = i === ((n = e.ownerDocument) == null ? void 0 : n.body), s = Dt(i);
  if (o) {
    const a = qc(s);
    return t.concat(s, s.visualViewport || [], ns(i) ? i : [], a && r ? Ho(a) : []);
  }
  return t.concat(i, Ho(i, [], r));
}
function qc(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Bb(e) {
  const t = sr(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const i = Cr(e), o = i ? e.offsetWidth : r, s = i ? e.offsetHeight : n, a = _a(r) !== o || _a(n) !== s;
  return a && (r = o, n = s), {
    width: r,
    height: n,
    $: a
  };
}
function Ld(e) {
  return or(e) ? e : e.contextElement;
}
function yi(e) {
  const t = Ld(e);
  if (!Cr(t))
    return wr(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: i,
    $: o
  } = Bb(t);
  let s = (o ? _a(r.width) : r.width) / n, a = (o ? _a(r.height) : r.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const Ck = /* @__PURE__ */ wr(0);
function Wb(e) {
  const t = Dt(e);
  return !$d() || !t.visualViewport ? Ck : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function kk(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== Dt(e) ? !1 : t;
}
function Vn(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const i = e.getBoundingClientRect(), o = Ld(e);
  let s = wr(1);
  t && (n ? or(n) && (s = yi(n)) : s = yi(e));
  const a = kk(o, r, n) ? Wb(o) : wr(0);
  let l = (i.left + a.x) / s.x, c = (i.top + a.y) / s.y, u = i.width / s.x, f = i.height / s.y;
  if (o) {
    const d = Dt(o), p = n && or(n) ? Dt(n) : n;
    let g = d, h = qc(g);
    for (; h && n && p !== g; ) {
      const m = yi(h), v = h.getBoundingClientRect(), y = sr(h), x = v.left + (h.clientLeft + parseFloat(y.paddingLeft)) * m.x, S = v.top + (h.clientTop + parseFloat(y.paddingTop)) * m.y;
      l *= m.x, c *= m.y, u *= m.x, f *= m.y, l += x, c += S, g = Dt(h), h = qc(g);
    }
  }
  return Sa({
    width: u,
    height: f,
    x: l,
    y: c
  });
}
function Vd(e, t) {
  const r = fl(e).scrollLeft;
  return t ? t.left + r : Vn(Ir(e)).left + r;
}
function Hb(e, t, r) {
  r === void 0 && (r = !1);
  const n = e.getBoundingClientRect(), i = n.left + t.scrollLeft - (r ? 0 : (
    // RTL <body> scrollbar.
    Vd(e, n)
  )), o = n.top + t.scrollTop;
  return {
    x: i,
    y: o
  };
}
function Ik(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: i
  } = e;
  const o = i === "fixed", s = Ir(n), a = t ? dl(t.floating) : !1;
  if (n === s || a && o)
    return r;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = wr(1);
  const u = wr(0), f = Cr(n);
  if ((f || !f && !o) && ((zi(n) !== "body" || ns(s)) && (l = fl(n)), Cr(n))) {
    const p = Vn(n);
    c = yi(n), u.x = p.x + n.clientLeft, u.y = p.y + n.clientTop;
  }
  const d = s && !f && !o ? Hb(s, l, !0) : wr(0);
  return {
    width: r.width * c.x,
    height: r.height * c.y,
    x: r.x * c.x - l.scrollLeft * c.x + u.x + d.x,
    y: r.y * c.y - l.scrollTop * c.y + u.y + d.y
  };
}
function Ok(e) {
  return Array.from(e.getClientRects());
}
function Pk(e) {
  const t = Ir(e), r = fl(e), n = e.ownerDocument.body, i = Lt(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), o = Lt(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let s = -r.scrollLeft + Vd(e);
  const a = -r.scrollTop;
  return sr(n).direction === "rtl" && (s += Lt(t.clientWidth, n.clientWidth) - i), {
    width: i,
    height: o,
    x: s,
    y: a
  };
}
function Tk(e, t) {
  const r = Dt(e), n = Ir(e), i = r.visualViewport;
  let o = n.clientWidth, s = n.clientHeight, a = 0, l = 0;
  if (i) {
    o = i.width, s = i.height;
    const c = $d();
    (!c || c && t === "fixed") && (a = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a,
    y: l
  };
}
function Rk(e, t) {
  const r = Vn(e, !0, t === "fixed"), n = r.top + e.clientTop, i = r.left + e.clientLeft, o = Cr(e) ? yi(e) : wr(1), s = e.clientWidth * o.x, a = e.clientHeight * o.y, l = i * o.x, c = n * o.y;
  return {
    width: s,
    height: a,
    x: l,
    y: c
  };
}
function gh(e, t, r) {
  let n;
  if (t === "viewport")
    n = Tk(e, r);
  else if (t === "document")
    n = Pk(Ir(e));
  else if (or(t))
    n = Rk(t, r);
  else {
    const i = Wb(e);
    n = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return Sa(n);
}
function jb(e, t) {
  const r = pn(e);
  return r === t || !or(r) || Ci(r) ? !1 : sr(r).position === "fixed" || jb(r, t);
}
function Ak(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = Ho(e, [], !1).filter((a) => or(a) && zi(a) !== "body"), i = null;
  const o = sr(e).position === "fixed";
  let s = o ? pn(e) : e;
  for (; or(s) && !Ci(s); ) {
    const a = sr(s), l = Fd(s);
    !l && a.position === "fixed" && (i = null), (o ? !l && !i : !l && a.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || ns(s) && !l && jb(e, s)) ? n = n.filter((u) => u !== s) : i = a, s = pn(s);
  }
  return t.set(e, n), n;
}
function Nk(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: i
  } = e;
  const s = [...r === "clippingAncestors" ? dl(t) ? [] : Ak(t, this._c) : [].concat(r), n], a = s[0], l = s.reduce((c, u) => {
    const f = gh(t, u, i);
    return c.top = Lt(f.top, c.top), c.right = hn(f.right, c.right), c.bottom = hn(f.bottom, c.bottom), c.left = Lt(f.left, c.left), c;
  }, gh(t, a, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Fk(e) {
  const {
    width: t,
    height: r
  } = Bb(e);
  return {
    width: t,
    height: r
  };
}
function $k(e, t, r) {
  const n = Cr(t), i = Ir(t), o = r === "fixed", s = Vn(e, !0, o, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = wr(0);
  if (n || !n && !o)
    if ((zi(t) !== "body" || ns(i)) && (a = fl(t)), n) {
      const d = Vn(t, !0, o, t);
      l.x = d.x + t.clientLeft, l.y = d.y + t.clientTop;
    } else i && (l.x = Vd(i));
  const c = i && !n && !o ? Hb(i, a) : wr(0), u = s.left + a.scrollLeft - l.x - c.x, f = s.top + a.scrollTop - l.y - c.y;
  return {
    x: u,
    y: f,
    width: s.width,
    height: s.height
  };
}
function Yl(e) {
  return sr(e).position === "static";
}
function mh(e, t) {
  if (!Cr(e) || sr(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return Ir(e) === r && (r = r.ownerDocument.body), r;
}
function Ub(e, t) {
  const r = Dt(e);
  if (dl(e))
    return r;
  if (!Cr(e)) {
    let i = pn(e);
    for (; i && !Ci(i); ) {
      if (or(i) && !Yl(i))
        return i;
      i = pn(i);
    }
    return r;
  }
  let n = mh(e, t);
  for (; n && Sk(n) && Yl(n); )
    n = mh(n, t);
  return n && Ci(n) && Yl(n) && !Fd(n) ? r : n || Ek(e) || r;
}
const Lk = async function(e) {
  const t = this.getOffsetParent || Ub, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: $k(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Vk(e) {
  return sr(e).direction === "rtl";
}
const zk = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ik,
  getDocumentElement: Ir,
  getClippingRect: Nk,
  getOffsetParent: Ub,
  getElementRects: Lk,
  getClientRects: Ok,
  getDimensions: Fk,
  getScale: yi,
  isElement: or,
  isRTL: Vk
};
function Gb(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Dk(e, t) {
  let r = null, n;
  const i = Ir(e);
  function o() {
    var a;
    clearTimeout(n), (a = r) == null || a.disconnect(), r = null;
  }
  function s(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), o();
    const c = e.getBoundingClientRect(), {
      left: u,
      top: f,
      width: d,
      height: p
    } = c;
    if (a || t(), !d || !p)
      return;
    const g = ys(f), h = ys(i.clientWidth - (u + d)), m = ys(i.clientHeight - (f + p)), v = ys(u), x = {
      rootMargin: -g + "px " + -h + "px " + -m + "px " + -v + "px",
      threshold: Lt(0, hn(1, l)) || 1
    };
    let S = !0;
    function _(I) {
      const O = I[0].intersectionRatio;
      if (O !== l) {
        if (!S)
          return s();
        O ? s(!1, O) : n = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      O === 1 && !Gb(c, e.getBoundingClientRect()) && s(), S = !1;
    }
    try {
      r = new IntersectionObserver(_, {
        ...x,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch (I) {
      r = new IntersectionObserver(_, x);
    }
    r.observe(e);
  }
  return s(!0), o;
}
function Mk(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, c = Ld(e), u = i || o ? [...c ? Ho(c) : [], ...Ho(t)] : [];
  u.forEach((v) => {
    i && v.addEventListener("scroll", r, {
      passive: !0
    }), o && v.addEventListener("resize", r);
  });
  const f = c && a ? Dk(c, r) : null;
  let d = -1, p = null;
  s && (p = new ResizeObserver((v) => {
    let [y] = v;
    y && y.target === c && p && (p.unobserve(t), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      var x;
      (x = p) == null || x.observe(t);
    })), r();
  }), c && !l && p.observe(c), p.observe(t));
  let g, h = l ? Vn(e) : null;
  l && m();
  function m() {
    const v = Vn(e);
    h && !Gb(h, v) && r(), h = v, g = requestAnimationFrame(m);
  }
  return r(), () => {
    var v;
    u.forEach((y) => {
      i && y.removeEventListener("scroll", r), o && y.removeEventListener("resize", r);
    }), f == null || f(), (v = p) == null || v.disconnect(), p = null, l && cancelAnimationFrame(g);
  };
}
const Bk = yk, Wk = xk, Hk = mk, jk = wk, Uk = vk, Gk = gk, qk = _k, Kk = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), i = {
    platform: zk,
    ...r
  }, o = {
    ...i.platform,
    _c: n
  };
  return pk(e, t, {
    ...i,
    platform: o
  });
};
function vh(e = 0, t = 0, r = 0, n = 0) {
  if (typeof DOMRect == "function")
    return new DOMRect(e, t, r, n);
  const i = {
    x: e,
    y: t,
    width: r,
    height: n,
    top: t,
    right: e + r,
    bottom: t + n,
    left: e
  };
  return { ...i, toJSON: () => i };
}
function Yk(e) {
  if (!e) return vh();
  const { x: t, y: r, width: n, height: i } = e;
  return vh(t, r, n, i);
}
function Xk(e, t) {
  return {
    contextElement: vt(e) ? e : void 0,
    getBoundingClientRect: () => {
      const r = e, n = t == null ? void 0 : t(r);
      return n || !r ? Yk(n) : r.getBoundingClientRect();
    }
  };
}
var Xi = (e) => ({ variable: e, reference: `var(${e})` }), $r = {
  arrowSize: Xi("--arrow-size"),
  arrowSizeHalf: Xi("--arrow-size-half"),
  arrowBg: Xi("--arrow-background"),
  transformOrigin: Xi("--transform-origin"),
  arrowOffset: Xi("--arrow-offset")
}, Jk = (e) => ({
  top: "bottom center",
  "top-start": e ? `${e.x}px bottom` : "left bottom",
  "top-end": e ? `${e.x}px bottom` : "right bottom",
  bottom: "top center",
  "bottom-start": e ? `${e.x}px top` : "top left",
  "bottom-end": e ? `${e.x}px top` : "top right",
  left: "right center",
  "left-start": e ? `right ${e.y}px` : "right top",
  "left-end": e ? `right ${e.y}px` : "right bottom",
  right: "left center",
  "right-start": e ? `left ${e.y}px` : "left top",
  "right-end": e ? `left ${e.y}px` : "left bottom"
}), Zk = {
  name: "transformOrigin",
  fn({ placement: e, elements: t, middlewareData: r }) {
    const { arrow: n } = r, i = Jk(n)[e], { floating: o } = t;
    return o.style.setProperty($r.transformOrigin.variable, i), {
      data: { transformOrigin: i }
    };
  }
}, Qk = {
  name: "rects",
  fn({ rects: e }) {
    return {
      data: e
    };
  }
}, eI = (e) => {
  if (e)
    return {
      name: "shiftArrow",
      fn({ placement: t, middlewareData: r }) {
        if (!r.arrow) return {};
        const { x: n, y: i } = r.arrow, o = t.split("-")[0];
        return Object.assign(e.style, {
          left: n != null ? `${n}px` : "",
          top: i != null ? `${i}px` : "",
          [o]: `calc(100% + ${$r.arrowOffset.reference})`
        }), {};
      }
    };
};
function tI(e) {
  const [t, r] = e.split("-");
  return { side: t, align: r, hasAlign: r != null };
}
function rI(e) {
  return e.split("-")[0];
}
var nI = {
  strategy: "absolute",
  placement: "bottom",
  listeners: !0,
  gutter: 8,
  flip: !0,
  slide: !0,
  overlap: !1,
  sameWidth: !1,
  fitViewport: !1,
  overflowPadding: 8,
  arrowPadding: 4
};
function bh(e, t) {
  const r = e.devicePixelRatio || 1;
  return Math.round(t * r) / r;
}
function qb(e) {
  return ho(e.boundary);
}
function iI(e, t) {
  if (e)
    return Gk({
      element: e,
      padding: t.arrowPadding
    });
}
function oI(e, t) {
  var r;
  if (!Q1((r = t.offset) != null ? r : t.gutter))
    return Bk(({ placement: n }) => {
      var u, f, d, p;
      const i = ((e == null ? void 0 : e.clientHeight) || 0) / 2, o = (f = (u = t.offset) == null ? void 0 : u.mainAxis) != null ? f : t.gutter, s = typeof o == "number" ? o + i : o != null ? o : i, { hasAlign: a } = tI(n), l = a ? void 0 : t.shift, c = (p = (d = t.offset) == null ? void 0 : d.crossAxis) != null ? p : l;
      return nl({
        crossAxis: c,
        mainAxis: s,
        alignmentAxis: t.shift
      });
    });
}
function sI(e) {
  if (e.flip)
    return Hk({
      boundary: qb(e),
      padding: e.overflowPadding,
      fallbackPlacements: e.flip === !0 ? void 0 : e.flip
    });
}
function aI(e) {
  if (!(!e.slide && !e.overlap))
    return Wk({
      boundary: qb(e),
      mainAxis: e.slide,
      crossAxis: e.overlap,
      padding: e.overflowPadding,
      limiter: qk()
    });
}
function lI(e) {
  return jk({
    padding: e.overflowPadding,
    apply({ elements: t, rects: r, availableHeight: n, availableWidth: i }) {
      const o = t.floating, s = Math.round(r.reference.width);
      i = Math.floor(i), n = Math.floor(n), o.style.setProperty("--reference-width", `${s}px`), o.style.setProperty("--available-width", `${i}px`), o.style.setProperty("--available-height", `${n}px`);
    }
  });
}
function cI(e) {
  var t, r;
  if (e.hideWhenDetached)
    return Uk({ strategy: "referenceHidden", boundary: (r = (t = e.boundary) == null ? void 0 : t.call(e)) != null ? r : "clippingAncestors" });
}
function uI(e) {
  return e ? e === !0 ? { ancestorResize: !0, ancestorScroll: !0, elementResize: !0, layoutShift: !0 } : e : {};
}
function dI(e, t, r = {}) {
  const n = Xk(e, r.getAnchorRect);
  if (!t || !n) return;
  const i = Object.assign({}, nI, r), o = t.querySelector("[data-part=arrow]"), s = [
    oI(o, i),
    sI(i),
    aI(i),
    iI(o, i),
    eI(o),
    Zk,
    lI(i),
    cI(i),
    Qk
  ], { placement: a, strategy: l, onComplete: c, onPositioned: u } = i, f = async () => {
    var S;
    if (!n || !t) return;
    const h = await Kk(n, t, {
      placement: a,
      middleware: s,
      strategy: l
    });
    c == null || c(h), u == null || u({ placed: !0 });
    const m = ct(t), v = bh(m, h.x), y = bh(m, h.y);
    t.style.setProperty("--x", `${v}px`), t.style.setProperty("--y", `${y}px`), i.hideWhenDetached && (((S = h.middlewareData.hide) == null ? void 0 : S.referenceHidden) ? (t.style.setProperty("visibility", "hidden"), t.style.setProperty("pointer-events", "none")) : (t.style.removeProperty("visibility"), t.style.removeProperty("pointer-events")));
    const x = t.firstElementChild;
    if (x) {
      const _ = wb(x);
      t.style.setProperty("--z-index", _.zIndex);
    }
  }, d = async () => {
    r.updatePosition ? (await r.updatePosition({ updatePosition: f }), u == null || u({ placed: !0 })) : await f();
  }, p = uI(i.listeners), g = i.listeners ? Mk(n, t, d, p) : rE;
  return d(), () => {
    g == null || g(), u == null || u({ placed: !1 });
  };
}
function Mt(e, t, r = {}) {
  const { defer: n, ...i } = r, o = n ? de : (a) => a(), s = [];
  return s.push(
    o(() => {
      const a = typeof e == "function" ? e() : e, l = typeof t == "function" ? t() : t;
      s.push(dI(a, l, i));
    })
  ), () => {
    s.forEach((a) => a == null ? void 0 : a());
  };
}
var fI = {
  bottom: "rotate(45deg)",
  left: "rotate(135deg)",
  top: "rotate(225deg)",
  right: "rotate(315deg)"
};
function zd(e = {}) {
  const { placement: t, sameWidth: r, fitViewport: n, strategy: i = "absolute" } = e;
  return {
    arrow: {
      position: "absolute",
      width: $r.arrowSize.reference,
      height: $r.arrowSize.reference,
      [$r.arrowSizeHalf.variable]: `calc(${$r.arrowSize.reference} / 2)`,
      [$r.arrowOffset.variable]: `calc(${$r.arrowSizeHalf.reference} * -1)`
    },
    arrowTip: {
      // @ts-expect-error - Fix this
      transform: t ? fI[t.split("-")[0]] : void 0,
      background: $r.arrowBg.reference,
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      position: "absolute",
      zIndex: "inherit"
    },
    floating: {
      position: i,
      isolation: "isolate",
      minWidth: r ? void 0 : "max-content",
      width: r ? "var(--reference-width)" : void 0,
      maxWidth: n ? "var(--available-width)" : void 0,
      maxHeight: n ? "var(--available-height)" : void 0,
      pointerEvents: t ? void 0 : "none",
      top: "0px",
      left: "0px",
      // move off-screen if placement is not defined
      transform: t ? "translate3d(var(--x), var(--y), 0)" : "translate3d(0, -100vh, 0)",
      zIndex: "var(--z-index)"
    }
  };
}
function hI(e) {
  const t = {
    each(r) {
      var n;
      for (let i = 0; i < ((n = e.frames) == null ? void 0 : n.length); i += 1) {
        const o = e.frames[i];
        o && r(o);
      }
    },
    addEventListener(r, n, i) {
      return t.each((o) => {
        try {
          o.document.addEventListener(r, n, i);
        } catch (s) {
        }
      }), () => {
        try {
          t.removeEventListener(r, n, i);
        } catch (o) {
        }
      };
    },
    removeEventListener(r, n, i) {
      t.each((o) => {
        try {
          o.document.removeEventListener(r, n, i);
        } catch (s) {
        }
      });
    }
  };
  return t;
}
function pI(e) {
  const t = e.frameElement != null ? e.parent : null;
  return {
    addEventListener: (r, n, i) => {
      try {
        t == null || t.addEventListener(r, n, i);
      } catch (o) {
      }
      return () => {
        try {
          t == null || t.removeEventListener(r, n, i);
        } catch (o) {
        }
      };
    },
    removeEventListener: (r, n, i) => {
      try {
        t == null || t.removeEventListener(r, n, i);
      } catch (o) {
      }
    }
  };
}
var yh = "pointerdown.outside", xh = "focus.outside";
function gI(e) {
  for (const t of e)
    if (vt(t) && ln(t)) return !0;
  return !1;
}
var Kb = (e) => "clientY" in e;
function mI(e, t) {
  if (!Kb(t) || !e) return !1;
  const r = e.getBoundingClientRect();
  return r.width === 0 || r.height === 0 ? !1 : r.top <= t.clientY && t.clientY <= r.top + r.height && r.left <= t.clientX && t.clientX <= r.left + r.width;
}
function vI(e, t) {
  return e.y <= t.y && t.y <= e.y + e.height && e.x <= t.x && t.x <= e.x + e.width;
}
function _h(e, t) {
  if (!t || !Kb(e)) return !1;
  const r = t.scrollHeight > t.clientHeight, n = r && e.clientX > t.offsetLeft + t.clientWidth, i = t.scrollWidth > t.clientWidth, o = i && e.clientY > t.offsetTop + t.clientHeight, s = {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: t.clientWidth + (r ? 16 : 0),
    height: t.clientHeight + (i ? 16 : 0)
  }, a = {
    x: e.clientX,
    y: e.clientY
  };
  return vI(s, a) ? n || o : !1;
}
function bI(e, t) {
  const { exclude: r, onFocusOutside: n, onPointerDownOutside: i, onInteractOutside: o, defer: s } = t;
  if (!e) return;
  const a = Wt(e), l = ct(e), c = hI(l), u = pI(l);
  function f(y, x) {
    if (!vt(x) || !x.isConnected || fn(e, x) || mI(e, y)) return !1;
    const S = a.querySelector(`[aria-controls="${e.id}"]`);
    if (S) {
      const I = ma(S);
      if (_h(y, I)) return !1;
    }
    const _ = ma(e);
    return _h(y, _) ? !1 : !(r != null && r(x));
  }
  const d = /* @__PURE__ */ new Set(), p = Ei(e == null ? void 0 : e.getRootNode());
  function g(y) {
    function x(S) {
      var w, E;
      const _ = s && !ih() ? de : (T) => T(), I = S != null ? S : y, O = (E = (w = I == null ? void 0 : I.composedPath) == null ? void 0 : w.call(I)) != null ? E : [I == null ? void 0 : I.target];
      _(() => {
        const T = p ? O[0] : Ct(y);
        if (!(!e || !f(y, T))) {
          if (i || o) {
            const G = ga(i, o);
            e.addEventListener(yh, G, { once: !0 });
          }
          wh(e, yh, {
            bubbles: !1,
            cancelable: !0,
            detail: {
              originalEvent: I,
              contextmenu: UE(I),
              focusable: gI(O),
              target: T
            }
          });
        }
      });
    }
    y.pointerType === "touch" ? (d.forEach((S) => S()), d.add(Ae(a, "click", x, { once: !0 })), d.add(u.addEventListener("click", x, { once: !0 })), d.add(c.addEventListener("click", x, { once: !0 }))) : x();
  }
  const h = /* @__PURE__ */ new Set(), m = setTimeout(() => {
    h.add(Ae(a, "pointerdown", g, !0)), h.add(u.addEventListener("pointerdown", g, !0)), h.add(c.addEventListener("pointerdown", g, !0));
  }, 0);
  function v(y) {
    (s ? de : (S) => S())(() => {
      const S = Ct(y);
      if (!(!e || !f(y, S))) {
        if (n || o) {
          const _ = ga(n, o);
          e.addEventListener(xh, _, { once: !0 });
        }
        wh(e, xh, {
          bubbles: !1,
          cancelable: !0,
          detail: {
            originalEvent: y,
            contextmenu: !1,
            focusable: ln(S),
            target: S
          }
        });
      }
    });
  }
  return ih() || (h.add(Ae(a, "focusin", v, !0)), h.add(u.addEventListener("focusin", v, !0)), h.add(c.addEventListener("focusin", v, !0))), () => {
    clearTimeout(m), d.forEach((y) => y()), h.forEach((y) => y());
  };
}
function yI(e, t) {
  const { defer: r } = t, n = r ? de : (o) => o(), i = [];
  return i.push(
    n(() => {
      const o = typeof e == "function" ? e() : e;
      i.push(bI(o, t));
    })
  ), () => {
    i.forEach((o) => o == null ? void 0 : o());
  };
}
function wh(e, t, r) {
  const n = e.ownerDocument.defaultView || window, i = new n.CustomEvent(t, r);
  return e.dispatchEvent(i);
}
function xI(e, t) {
  const r = (n) => {
    n.key === "Escape" && (n.isComposing || t == null || t(n));
  };
  return Ae(Wt(e), "keydown", r, { capture: !0 });
}
var $t = {
  layers: [],
  branches: [],
  count() {
    return this.layers.length;
  },
  pointerBlockingLayers() {
    return this.layers.filter((e) => e.pointerBlocking);
  },
  topMostPointerBlockingLayer() {
    return [...this.pointerBlockingLayers()].slice(-1)[0];
  },
  hasPointerBlockingLayer() {
    return this.pointerBlockingLayers().length > 0;
  },
  isBelowPointerBlockingLayer(e) {
    var n;
    const t = this.indexOf(e), r = this.topMostPointerBlockingLayer() ? this.indexOf((n = this.topMostPointerBlockingLayer()) == null ? void 0 : n.node) : -1;
    return t < r;
  },
  isTopMost(e) {
    const t = this.layers[this.count() - 1];
    return (t == null ? void 0 : t.node) === e;
  },
  getNestedLayers(e) {
    return Array.from(this.layers).slice(this.indexOf(e) + 1);
  },
  isInNestedLayer(e, t) {
    return this.getNestedLayers(e).some((r) => fn(r.node, t));
  },
  isInBranch(e) {
    return Array.from(this.branches).some((t) => fn(t, e));
  },
  add(e) {
    const t = this.layers.push(e);
    e.node.style.setProperty("--layer-index", `${t}`);
  },
  addBranch(e) {
    this.branches.push(e);
  },
  remove(e) {
    const t = this.indexOf(e);
    t < 0 || (t < this.count() - 1 && this.getNestedLayers(e).forEach((n) => n.dismiss()), this.layers.splice(t, 1), e.style.removeProperty("--layer-index"));
  },
  removeBranch(e) {
    const t = this.branches.indexOf(e);
    t >= 0 && this.branches.splice(t, 1);
  },
  indexOf(e) {
    return this.layers.findIndex((t) => t.node === e);
  },
  dismiss(e) {
    var t;
    (t = this.layers[this.indexOf(e)]) == null || t.dismiss();
  },
  clear() {
    this.remove(this.layers[0].node);
  }
}, Sh;
function Eh() {
  $t.layers.forEach(({ node: e }) => {
    e.style.pointerEvents = $t.isBelowPointerBlockingLayer(e) ? "none" : "auto";
  });
}
function _I(e) {
  e.style.pointerEvents = "";
}
function wI(e, t) {
  const r = Wt(e), n = [];
  if ($t.hasPointerBlockingLayer() && !r.body.hasAttribute("data-inert") && (Sh = document.body.style.pointerEvents, queueMicrotask(() => {
    r.body.style.pointerEvents = "none", r.body.setAttribute("data-inert", "");
  })), t) {
    const i = NC(t, (o) => {
      n.push(ba(o, { pointerEvents: "auto" }));
    });
    n.push(i);
  }
  return () => {
    $t.hasPointerBlockingLayer() || (queueMicrotask(() => {
      r.body.style.pointerEvents = Sh, r.body.removeAttribute("data-inert"), r.body.style.length === 0 && r.body.removeAttribute("style");
    }), n.forEach((i) => i()));
  };
}
function SI(e, t) {
  const { warnOnMissingNode: r = !0 } = t;
  if (r && !e) {
    Do("[@zag-js/dismissable] node is `null` or `undefined`");
    return;
  }
  if (!e)
    return;
  const { onDismiss: n, pointerBlocking: i, exclude: o, debug: s } = t, a = { dismiss: n, node: e, pointerBlocking: i };
  $t.add(a), Eh();
  function l(p) {
    var h, m;
    const g = Ct(p.detail.originalEvent);
    $t.isBelowPointerBlockingLayer(e) || $t.isInBranch(g) || ((h = t.onPointerDownOutside) == null || h.call(t, p), (m = t.onInteractOutside) == null || m.call(t, p), !p.defaultPrevented && (s && console.log("onPointerDownOutside:", p.detail.originalEvent), n == null || n()));
  }
  function c(p) {
    var h, m;
    const g = Ct(p.detail.originalEvent);
    $t.isInBranch(g) || ((h = t.onFocusOutside) == null || h.call(t, p), (m = t.onInteractOutside) == null || m.call(t, p), !p.defaultPrevented && (s && console.log("onFocusOutside:", p.detail.originalEvent), n == null || n()));
  }
  function u(p) {
    var g;
    $t.isTopMost(e) && ((g = t.onEscapeKeyDown) == null || g.call(t, p), !p.defaultPrevented && n && (p.preventDefault(), n()));
  }
  function f(p) {
    var v;
    if (!e) return !1;
    const g = typeof o == "function" ? o() : o, h = Array.isArray(g) ? g : [g], m = (v = t.persistentElements) == null ? void 0 : v.map((y) => y()).filter(vt);
    return m && h.push(...m), h.some((y) => fn(y, p)) || $t.isInNestedLayer(e, p);
  }
  const d = [
    i ? wI(e, t.persistentElements) : void 0,
    xI(e, u),
    yI(e, { exclude: f, onFocusOutside: c, onPointerDownOutside: l, defer: t.defer })
  ];
  return () => {
    $t.remove(e), Eh(), _I(e), d.forEach((p) => p == null ? void 0 : p());
  };
}
function Di(e, t) {
  const { defer: r } = t, n = r ? de : (o) => o(), i = [];
  return i.push(
    n(() => {
      const o = sn(e) ? e() : e;
      i.push(SI(o, t));
    })
  ), () => {
    i.forEach((o) => o == null ? void 0 : o());
  };
}
function EI(e, t = {}) {
  const { defer: r } = t, n = r ? de : (o) => o(), i = [];
  return i.push(
    n(() => {
      const o = sn(e) ? e() : e;
      if (!o) {
        Do("[@zag-js/dismissable] branch node is `null` or `undefined`");
        return;
      }
      $t.addBranch(o), i.push(() => {
        $t.removeBranch(o);
      });
    })
  ), () => {
    i.forEach((o) => o == null ? void 0 : o());
  };
}
var Yb = le("color-picker", [
  "root",
  "label",
  "control",
  "trigger",
  "positioner",
  "content",
  "area",
  "areaThumb",
  "valueText",
  "areaBackground",
  "channelSlider",
  "channelSliderLabel",
  "channelSliderTrack",
  "channelSliderThumb",
  "channelSliderValueText",
  "channelInput",
  "transparencyGrid",
  "swatchGroup",
  "swatchTrigger",
  "swatchIndicator",
  "swatch",
  "eyeDropperTrigger",
  "formatTrigger",
  "formatSelect"
]);
Yb.build();
var CI = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.hiddenInput) != null ? r : `color-picker:${e.id}:hidden-input`;
}, kI = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.control) != null ? r : `color-picker:${e.id}:control`;
}, II = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.trigger) != null ? r : `color-picker:${e.id}:trigger`;
}, OI = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.content) != null ? r : `color-picker:${e.id}:content`;
}, PI = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.positioner) != null ? r : `color-picker:${e.id}:positioner`;
}, TI = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.formatSelect) != null ? r : `color-picker:${e.id}:format-select`;
}, RI = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.area) != null ? r : `color-picker:${e.id}:area`;
}, AI = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.areaThumb) != null ? r : `color-picker:${e.id}:area-thumb`;
}, NI = (e, t) => {
  var r, n, i;
  return (i = (n = (r = e.ids) == null ? void 0 : r.channelSliderTrack) == null ? void 0 : n.call(r, t)) != null ? i : `color-picker:${e.id}:slider-track:${t}`;
}, FI = (e, t) => {
  var r, n, i;
  return (i = (n = (r = e.ids) == null ? void 0 : r.channelSliderThumb) == null ? void 0 : n.call(r, t)) != null ? i : `color-picker:${e.id}:slider-thumb:${t}`;
}, Js = (e) => e.getById(OI(e)), $I = (e) => e.getById(AI(e)), LI = (e, t) => e.getById(FI(e, t)), VI = (e) => e.getById(TI(e)), Ch = (e) => e.getById(CI(e)), zI = (e) => e.getById(RI(e)), DI = (e, t) => {
  const r = zI(e);
  if (!r) return;
  const { percent: n } = Tb(t, r);
  return n;
}, MI = (e) => e.getById(kI(e)), Xl = (e) => e.getById(II(e)), BI = (e) => e.getById(PI(e)), WI = (e, t) => e.getById(NI(e, t)), HI = (e, t, r) => {
  const n = WI(e, r);
  if (!n) return;
  const { percent: i } = Tb(t, n);
  return i;
}, jI = (e) => [
  ...va(Js(e), "input[data-channel]"),
  ...va(MI(e), "input[data-channel]")
];
function UI(e, t) {
  if (t == null) return "";
  if (t === "hex")
    return e.toString("hex");
  if (t === "css")
    return e.toString("css");
  if (t in e)
    return e.getChannelValue(t).toString();
  const r = e.getFormat() === "hsla";
  switch (t) {
    case "hue":
      return r ? e.toFormat("hsla").getChannelValue("hue").toString() : e.toFormat("hsba").getChannelValue("hue").toString();
    case "saturation":
      return r ? e.toFormat("hsla").getChannelValue("saturation").toString() : e.toFormat("hsba").getChannelValue("saturation").toString();
    case "lightness":
      return e.toFormat("hsla").getChannelValue("lightness").toString();
    case "brightness":
      return e.toFormat("hsba").getChannelValue("brightness").toString();
    case "red":
    case "green":
    case "blue":
      return e.toFormat("rgba").getChannelValue(t).toString();
    default:
      return e.getChannelValue(t).toString();
  }
}
var kh = (e) => xa(e), { and: GI } = Yr();
GI("isOpenControlled", "closeOnSelect");
function Ih(e, t, r) {
  const n = jI(e);
  de(() => {
    n.forEach((i) => {
      const o = i.dataset.channel;
      es(i, UI(r || t, o));
    });
  });
}
function qI(e, t) {
  const r = VI(e);
  r && de(() => es(r, t));
}
ue()([
  "closeOnSelect",
  "dir",
  "disabled",
  "format",
  "defaultFormat",
  "getRootNode",
  "id",
  "ids",
  "initialFocusEl",
  "name",
  "positioning",
  "onFocusOutside",
  "onFormatChange",
  "onInteractOutside",
  "onOpenChange",
  "onPointerDownOutside",
  "onValueChange",
  "onValueChangeEnd",
  "defaultOpen",
  "open",
  "positioning",
  "required",
  "readOnly",
  "value",
  "defaultValue",
  "invalid",
  "openAutoFocus"
]);
ue()(["xChannel", "yChannel"]);
ue()(["channel", "orientation"]);
ue()(["value", "disabled"]);
ue()(["value", "respectAlpha"]);
ue()(["size"]);
var Xb = le("accordion").parts("root", "item", "itemTrigger", "itemContent", "itemIndicator");
Xb.build();
var Jb = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.root) != null ? r : `accordion:${e.id}`;
}, Zb = (e, t) => {
  var r, n, i;
  return (i = (n = (r = e.ids) == null ? void 0 : r.itemTrigger) == null ? void 0 : n.call(r, t)) != null ? i : `accordion:${e.id}:trigger:${t}`;
}, KI = (e) => e.getById(Jb(e)), hl = (e) => {
  const r = `[aria-controls][data-ownedby='${CSS.escape(Jb(e))}']:not([disabled])`;
  return va(KI(e), r);
}, YI = (e) => ab(hl(e)), XI = (e) => lb(hl(e)), JI = (e, t) => _C(hl(e), Zb(e, t)), ZI = (e, t) => wC(hl(e), Zb(e, t)), { and: QI, not: eO } = Yr();
QI("isExpanded", "canToggle"), eO("isExpanded");
ue()([
  "collapsible",
  "dir",
  "disabled",
  "getRootNode",
  "id",
  "ids",
  "multiple",
  "onFocusChange",
  "onValueChange",
  "orientation",
  "value",
  "defaultValue"
]);
ue()(["value", "disabled"]);
var go = (e, t) => ({ x: e, y: t });
function tO(e) {
  const { x: t, y: r, width: n, height: i } = e, o = t + n / 2, s = r + i / 2;
  return {
    x: t,
    y: r,
    width: n,
    height: i,
    minX: t,
    minY: r,
    maxX: t + n,
    maxY: r + i,
    midX: o,
    midY: s,
    center: go(o, s)
  };
}
function rO(e) {
  const t = go(e.minX, e.minY), r = go(e.maxX, e.minY), n = go(e.maxX, e.maxY), i = go(e.minX, e.maxY);
  return { top: t, right: r, bottom: n, left: i };
}
function nO(e, t) {
  const r = tO(e), { top: n, right: i, left: o, bottom: s } = rO(r), [a] = t.split("-");
  return {
    top: [o, n, i, s],
    right: [n, i, s, o],
    bottom: [n, o, s, i],
    left: [i, n, o, s]
  }[a];
}
function iO(e, t) {
  const { x: r, y: n } = t;
  let i = !1;
  for (let o = 0, s = e.length - 1; o < e.length; s = o++) {
    const a = e[o].x, l = e[o].y, c = e[s].x, u = e[s].y;
    l > n != u > n && r < (c - a) * (n - l) / (u - l) + a && (i = !i);
  }
  return i;
}
var Qb = le("avatar").parts("root", "image", "fallback");
Qb.build();
ue()(["dir", "id", "ids", "onStatusChange", "getRootNode"]);
function oO(e) {
  return !(e.metaKey || !al() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
var sO = /* @__PURE__ */ new Set(["checkbox", "radio", "range", "color", "file", "image", "button", "submit", "reset"]);
function aO(e, t, r) {
  const n = r ? Ct(r) : null, i = ct(n);
  return e = e || n instanceof i.HTMLInputElement && !sO.has(n == null ? void 0 : n.type) || n instanceof i.HTMLTextAreaElement || n instanceof i.HTMLElement && n.isContentEditable, !(e && t === "keyboard" && r instanceof i.KeyboardEvent && !Reflect.has(lO, r.key));
}
var qn = null, Kc = /* @__PURE__ */ new Set(), Po = /* @__PURE__ */ new Map(), zn = !1, Yc = !1, lO = {
  Tab: !0,
  Escape: !0
};
function pl(e, t) {
  for (let r of Kc)
    r(e, t);
}
function Ea(e) {
  zn = !0, oO(e) && (qn = "keyboard", pl("keyboard", e));
}
function qt(e) {
  qn = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (zn = !0, pl("pointer", e));
}
function ey(e) {
  jE(e) && (zn = !0, qn = "virtual");
}
function ty(e) {
  const t = Ct(e);
  t === ct(t) || t === Wt(t) || (!zn && !Yc && (qn = "virtual", pl("virtual", e)), zn = !1, Yc = !1);
}
function ry() {
  zn = !1, Yc = !0;
}
function cO(e) {
  if (typeof window == "undefined" || Po.get(ct(e)))
    return;
  const t = ct(e), r = Wt(e);
  let n = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    qn = "virtual", pl("virtual", null), zn = !0, n.apply(this, arguments);
  }, r.addEventListener("keydown", Ea, !0), r.addEventListener("keyup", Ea, !0), r.addEventListener("click", ey, !0), t.addEventListener("focus", ty, !0), t.addEventListener("blur", ry, !1), typeof t.PointerEvent != "undefined" ? (r.addEventListener("pointerdown", qt, !0), r.addEventListener("pointermove", qt, !0), r.addEventListener("pointerup", qt, !0)) : (r.addEventListener("mousedown", qt, !0), r.addEventListener("mousemove", qt, !0), r.addEventListener("mouseup", qt, !0)), t.addEventListener(
    "beforeunload",
    () => {
      uO(e);
    },
    { once: !0 }
  ), Po.set(t, { focus: n });
}
var uO = (e, t) => {
  const r = ct(e), n = Wt(e);
  Po.has(r) && (r.HTMLElement.prototype.focus = Po.get(r).focus, n.removeEventListener("keydown", Ea, !0), n.removeEventListener("keyup", Ea, !0), n.removeEventListener("click", ey, !0), r.removeEventListener("focus", ty, !0), r.removeEventListener("blur", ry, !1), typeof r.PointerEvent != "undefined" ? (n.removeEventListener("pointerdown", qt, !0), n.removeEventListener("pointermove", qt, !0), n.removeEventListener("pointerup", qt, !0)) : (n.removeEventListener("mousedown", qt, !0), n.removeEventListener("mousemove", qt, !0), n.removeEventListener("mouseup", qt, !0)), Po.delete(r));
};
function Xc() {
  return qn === "keyboard";
}
function dO(e = {}) {
  const { isTextInput: t, autoFocus: r, onChange: n, root: i } = e;
  cO(i), n == null || n({ isFocusVisible: r || Xc(), modality: qn });
  const o = (s, a) => {
    aO(!!t, s, a) && (n == null || n({ isFocusVisible: Xc(), modality: s }));
  };
  return Kc.add(o), () => {
    Kc.delete(o);
  };
}
var ny = le("checkbox").parts("root", "label", "control", "indicator");
ny.build();
ue()([
  "defaultChecked",
  "checked",
  "dir",
  "disabled",
  "form",
  "getRootNode",
  "id",
  "ids",
  "invalid",
  "name",
  "onCheckedChange",
  "readOnly",
  "required",
  "value"
]);
const fO = ny.extendWith("group"), [C3, Dd] = Bt({
  name: "FieldContext",
  hookName: "useFieldContext",
  providerName: "<FieldProvider />",
  strict: !1
}), [iy, Mi] = Bt({
  name: "ClipboardContext",
  hookName: "useClipboardContext",
  providerName: "<ClipboardProvider />"
}), oy = Z((e, t) => {
  const r = Mi(), n = oe(r.getControlProps(), e);
  return /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
oy.displayName = "ClipboardControl";
const sy = Z((e, t) => {
  const { children: r, copied: n, ...i } = e, o = Mi(), s = oe(o.getIndicatorProps({ copied: o.copied }), i);
  return /* @__PURE__ */ b(ae.div, { ...s, ref: t, children: o.copied ? n : r });
});
sy.displayName = "ClipboardIndicator";
const ay = Z((e, t) => {
  const r = Mi(), n = oe(r.getInputProps(), e);
  return /* @__PURE__ */ b(ae.input, { ...n, ref: t });
});
ay.displayName = "ClipboardInput";
const ly = Z((e, t) => {
  const r = Mi(), n = oe(r.getLabelProps(), e);
  return /* @__PURE__ */ b(ae.label, { ...n, ref: t });
});
ly.displayName = "ClipboardLabel";
var hO = le("clipboard").parts("root", "control", "trigger", "indicator", "input", "label"), Zn = hO.build(), pO = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.root) != null ? r : `clip:${e.id}`;
}, Jc = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.input) != null ? r : `clip:${e.id}:input`;
}, gO = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.label) != null ? r : `clip:${e.id}:label`;
}, mO = (e) => e.getById(Jc(e)), vO = (e, t) => xO(e.getDoc(), t);
function bO(e, t) {
  const r = e.createElement("pre");
  return Object.assign(r.style, {
    width: "1px",
    height: "1px",
    position: "fixed",
    top: "5px"
  }), r.textContent = t, r;
}
function yO(e) {
  const r = ct(e).getSelection();
  if (r == null)
    return Promise.reject(new Error());
  r.removeAllRanges();
  const n = e.ownerDocument, i = n.createRange();
  return i.selectNodeContents(e), r.addRange(i), n.execCommand("copy"), r.removeAllRanges(), Promise.resolve();
}
function xO(e, t) {
  var i;
  const r = e.defaultView || window;
  if (((i = r.navigator.clipboard) == null ? void 0 : i.writeText) !== void 0)
    return r.navigator.clipboard.writeText(t);
  if (!e.body)
    return Promise.reject(new Error());
  const n = bO(e, t);
  return e.body.appendChild(n), yO(n), e.body.removeChild(n), Promise.resolve();
}
function _O(e, t) {
  const { state: r, send: n, context: i, scope: o } = e, s = r.matches("copied");
  return {
    copied: s,
    value: i.get("value"),
    setValue(a) {
      n({ type: "VALUE.SET", value: a });
    },
    copy() {
      n({ type: "COPY" });
    },
    getRootProps() {
      return t.element({
        ...Zn.root.attrs,
        "data-copied": me(s),
        id: pO(o)
      });
    },
    getLabelProps() {
      return t.label({
        ...Zn.label.attrs,
        htmlFor: Jc(o),
        "data-copied": me(s),
        id: gO(o)
      });
    },
    getControlProps() {
      return t.element({
        ...Zn.control.attrs,
        "data-copied": me(s)
      });
    },
    getInputProps() {
      return t.input({
        ...Zn.input.attrs,
        defaultValue: i.get("value"),
        "data-copied": me(s),
        readOnly: !0,
        "data-readonly": "true",
        id: Jc(o),
        onFocus(a) {
          a.currentTarget.select();
        },
        onCopy() {
          n({ type: "INPUT.COPY" });
        }
      });
    },
    getTriggerProps() {
      return t.button({
        ...Zn.trigger.attrs,
        type: "button",
        "aria-label": s ? "Copied to clipboard" : "Copy to clipboard",
        "data-copied": me(s),
        onClick() {
          n({ type: "COPY" });
        }
      });
    },
    getIndicatorProps(a) {
      return t.element({
        ...Zn.indicator.attrs,
        hidden: a.copied !== s
      });
    }
  };
}
var wO = {
  props({ props: e }) {
    return {
      timeout: 3e3,
      defaultValue: "",
      ...e
    };
  },
  initialState() {
    return "idle";
  },
  context({ prop: e, bindable: t }) {
    return {
      value: t(() => ({
        defaultValue: e("defaultValue"),
        value: e("value"),
        onChange(r) {
          var n;
          (n = e("onValueChange")) == null || n({ value: r });
        }
      }))
    };
  },
  watch({ track: e, context: t, action: r }) {
    e([() => t.get("value")], () => {
      r(["syncInputElement"]);
    });
  },
  on: {
    "VALUE.SET": {
      actions: ["setValue"]
    },
    COPY: {
      target: "copied",
      actions: ["copyToClipboard", "invokeOnCopy"]
    }
  },
  states: {
    idle: {
      on: {
        "INPUT.COPY": {
          target: "copied",
          actions: ["invokeOnCopy"]
        }
      }
    },
    copied: {
      effects: ["waitForTimeout"],
      on: {
        "COPY.DONE": {
          target: "idle"
        },
        COPY: {
          target: "copied",
          actions: ["copyToClipboard", "invokeOnCopy"]
        },
        "INPUT.COPY": {
          actions: ["invokeOnCopy"]
        }
      }
    }
  },
  implementations: {
    effects: {
      waitForTimeout({ prop: e, send: t }) {
        return Gs(() => {
          t({ type: "COPY.DONE" });
        }, e("timeout"));
      }
    },
    actions: {
      setValue({ context: e, event: t }) {
        e.set("value", t.value);
      },
      copyToClipboard({ context: e, scope: t }) {
        vO(t, e.get("value"));
      },
      invokeOnCopy({ prop: e }) {
        var t;
        (t = e("onStatusChange")) == null || t({ copied: !0 });
      },
      syncInputElement({ context: e, scope: t }) {
        const r = mO(t);
        r && es(r, e.get("value"));
      }
    }
  }
};
ue()([
  "getRootNode",
  "id",
  "ids",
  "value",
  "defaultValue",
  "timeout",
  "onStatusChange",
  "onValueChange"
]);
ue()(["copied"]);
const SO = (e) => {
  const t = Hn(), { getRootNode: r } = bn(), n = {
    id: t,
    getRootNode: r,
    ...e
  }, i = yn(wO, n);
  return _O(i, Un);
}, cy = Z((e, t) => {
  const [r, n] = Xr()(e, [
    "defaultValue",
    "id",
    "ids",
    "onStatusChange",
    "onValueChange",
    "timeout",
    "value"
  ]), i = SO(r), o = oe(i.getRootProps(), n);
  return /* @__PURE__ */ b(iy, { value: i, children: /* @__PURE__ */ b(ae.div, { ref: t, ...o }) });
});
cy.displayName = "ClipboardRoot";
const uy = Z((e, t) => {
  const [{ value: r }, n] = Xr()(e, ["value"]), i = oe(r.getRootProps(), n);
  return /* @__PURE__ */ b(iy, { value: r, children: /* @__PURE__ */ b(ae.div, { ref: t, ...i }) });
});
uy.displayName = "ClipboardRootProvider";
const dy = Z((e, t) => {
  const r = Mi(), n = oe(r.getTriggerProps(), e);
  return /* @__PURE__ */ b(ae.button, { ...n, ref: t });
});
dy.displayName = "ClipboardTrigger";
const fy = Z((e, t) => {
  const r = Mi();
  return /* @__PURE__ */ b(ae.span, { ...e, ref: t, children: e.children || r.value });
});
fy.displayName = "ClipboardValueText";
const EO = Yb.extendWith("view");
var CO = Object.defineProperty, kO = (e, t, r) => t in e ? CO(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, he = (e, t, r) => kO(e, typeof t != "symbol" ? t + "" : t, r), Zs = {
  itemToValue(e) {
    return typeof e == "string" ? e : Hl(e) && jl(e, "value") ? e.value : "";
  },
  itemToString(e) {
    return typeof e == "string" ? e : Hl(e) && jl(e, "label") ? e.label : Zs.itemToValue(e);
  },
  isItemDisabled(e) {
    return Hl(e) && jl(e, "disabled") ? !!e.disabled : !1;
  }
}, is = class hy {
  constructor(t) {
    this.options = t, he(this, "items"), he(this, "copy", (r) => new hy({ ...this.options, items: r != null ? r : [...this.items] })), he(this, "isEqual", (r) => Ai(this.items, r.items)), he(this, "setItems", (r) => this.copy(r)), he(this, "getValues", (r = this.items) => Array.from(r).map((n) => this.getItemValue(n)).filter(Boolean)), he(this, "find", (r) => {
      if (r == null) return null;
      const n = this.indexOf(r);
      return n != null ? this.at(n) : null;
    }), he(this, "findMany", (r) => Array.from(r).map((n) => this.find(n)).filter((n) => n != null)), he(this, "at", (r) => {
      var o;
      if (!this.options.groupBy && !this.options.groupSort)
        return (o = this.items[r]) != null ? o : null;
      let n = 0;
      const i = this.group();
      for (const [, s] of i)
        for (const a of s) {
          if (n === r) return a;
          n++;
        }
      return null;
    }), he(this, "sortFn", (r, n) => {
      const i = this.indexOf(r), o = this.indexOf(n);
      return (i != null ? i : 0) - (o != null ? o : 0);
    }), he(this, "sort", (r) => [...r].sort(this.sortFn.bind(this))), he(this, "getItemValue", (r) => {
      var n, i, o;
      return r == null ? null : (o = (i = (n = this.options).itemToValue) == null ? void 0 : i.call(n, r)) != null ? o : Zs.itemToValue(r);
    }), he(this, "getItemDisabled", (r) => {
      var n, i, o;
      return r == null ? !1 : (o = (i = (n = this.options).isItemDisabled) == null ? void 0 : i.call(n, r)) != null ? o : Zs.isItemDisabled(r);
    }), he(this, "stringifyItem", (r) => {
      var n, i, o;
      return r == null ? null : (o = (i = (n = this.options).itemToString) == null ? void 0 : i.call(n, r)) != null ? o : Zs.itemToString(r);
    }), he(this, "stringify", (r) => r == null ? null : this.stringifyItem(this.find(r))), he(this, "stringifyItems", (r, n = ", ") => Array.from(r).map((i) => this.stringifyItem(i)).filter(Boolean).join(n)), he(this, "stringifyMany", (r, n) => this.stringifyItems(this.findMany(r), n)), he(this, "has", (r) => this.indexOf(r) !== -1), he(this, "hasItem", (r) => r == null ? !1 : this.has(this.getItemValue(r))), he(this, "group", () => {
      const { groupBy: r, groupSort: n } = this.options;
      if (!r) return [["", [...this.items]]];
      const i = /* @__PURE__ */ new Map();
      this.items.forEach((s, a) => {
        const l = r(s, a);
        i.has(l) || i.set(l, []), i.get(l).push(s);
      });
      let o = Array.from(i.entries());
      return n && o.sort(([s], [a]) => {
        if (typeof n == "function") return n(s, a);
        if (Array.isArray(n)) {
          const l = n.indexOf(s), c = n.indexOf(a);
          return l === -1 ? 1 : c === -1 ? -1 : l - c;
        }
        return n === "asc" ? s.localeCompare(a) : n === "desc" ? a.localeCompare(s) : 0;
      }), o;
    }), he(this, "getNextValue", (r, n = 1, i = !1) => {
      let o = this.indexOf(r);
      if (o === -1) return null;
      for (o = i ? Math.min(o + n, this.size - 1) : o + n; o <= this.size && this.getItemDisabled(this.at(o)); ) o++;
      return this.getItemValue(this.at(o));
    }), he(this, "getPreviousValue", (r, n = 1, i = !1) => {
      let o = this.indexOf(r);
      if (o === -1) return null;
      for (o = i ? Math.max(o - n, 0) : o - n; o >= 0 && this.getItemDisabled(this.at(o)); ) o--;
      return this.getItemValue(this.at(o));
    }), he(this, "indexOf", (r) => {
      if (r == null) return -1;
      if (!this.options.groupBy && !this.options.groupSort)
        return this.items.findIndex((o) => this.getItemValue(o) === r);
      let n = 0;
      const i = this.group();
      for (const [, o] of i)
        for (const s of o) {
          if (this.getItemValue(s) === r) return n;
          n++;
        }
      return -1;
    }), he(this, "getByText", (r, n) => {
      let i = n != null ? OO(this.items, this.indexOf(n)) : this.items;
      return r.length === 1 && (i = i.filter((s) => this.getItemValue(s) !== n)), i.find((s) => IO(this.stringifyItem(s), r));
    }), he(this, "search", (r, n) => {
      const { state: i, currentValue: o, timeout: s = 350 } = n, a = i.keysSoFar + r, c = a.length > 1 && Array.from(a).every((g) => g === a[0]) ? a[0] : a, u = this.getByText(c, o), f = this.getItemValue(u);
      function d() {
        clearTimeout(i.timer), i.timer = -1;
      }
      function p(g) {
        i.keysSoFar = g, d(), g !== "" && (i.timer = +setTimeout(() => {
          p(""), d();
        }, s));
      }
      return p(a), f;
    }), he(this, "update", (r, n) => {
      let i = this.items.findIndex((o) => this.getItemValue(o) === r);
      return i === -1 ? this : this.copy([...this.items.slice(0, i), n, ...this.items.slice(i + 1)]);
    }), he(this, "insert", (r, ...n) => this.copy(Ji(this.items, r, ...n))), he(this, "insertBefore", (r, ...n) => {
      let i = this.indexOf(r);
      if (i === -1)
        if (this.items.length === 0) i = 0;
        else return this;
      return this.copy(Ji(this.items, i, ...n));
    }), he(this, "insertAfter", (r, ...n) => {
      let i = this.indexOf(r);
      if (i === -1)
        if (this.items.length === 0) i = 0;
        else return this;
      return this.copy(Ji(this.items, i + 1, ...n));
    }), he(this, "prepend", (...r) => this.copy(Ji(this.items, 0, ...r))), he(this, "append", (...r) => this.copy(Ji(this.items, this.items.length, ...r))), he(this, "filter", (r) => {
      const n = this.items.filter((i, o) => r(this.stringifyItem(i), o));
      return this.copy(n);
    }), he(this, "remove", (...r) => {
      const n = r.map(
        (i) => typeof i == "string" ? i : this.getItemValue(i)
      );
      return this.copy(
        this.items.filter((i) => {
          const o = this.getItemValue(i);
          return o == null ? !1 : !n.includes(o);
        })
      );
    }), he(this, "move", (r, n) => {
      const i = this.indexOf(r);
      return i === -1 ? this : this.copy(xs(this.items, [i], n));
    }), he(this, "moveBefore", (r, ...n) => {
      let i = this.items.findIndex((s) => this.getItemValue(s) === r);
      if (i === -1) return this;
      let o = n.map((s) => this.items.findIndex((a) => this.getItemValue(a) === s)).sort((s, a) => s - a);
      return this.copy(xs(this.items, o, i));
    }), he(this, "moveAfter", (r, ...n) => {
      let i = this.items.findIndex((s) => this.getItemValue(s) === r);
      if (i === -1) return this;
      let o = n.map((s) => this.items.findIndex((a) => this.getItemValue(a) === s)).sort((s, a) => s - a);
      return this.copy(xs(this.items, o, i + 1));
    }), he(this, "reorder", (r, n) => this.copy(xs(this.items, [r], n))), he(this, "compareValue", (r, n) => {
      const i = this.indexOf(r), o = this.indexOf(n);
      return i < o ? -1 : i > o ? 1 : 0;
    }), he(this, "range", (r, n) => {
      let i = [], o = r;
      for (; o != null; ) {
        if (this.find(o) && i.push(o), o === n) return i;
        o = this.getNextValue(o);
      }
      return [];
    }), he(this, "getValueRange", (r, n) => r && n ? this.compareValue(r, n) <= 0 ? this.range(r, n) : this.range(n, r) : []), he(this, "toString", () => {
      let r = "";
      for (const n of this.items) {
        const i = this.getItemValue(n), o = this.stringifyItem(n), s = this.getItemDisabled(n), a = [i, o, s].filter(Boolean).join(":");
        r += a + ",";
      }
      return r;
    }), he(this, "toJSON", () => ({
      size: this.size,
      first: this.firstValue,
      last: this.lastValue
    })), this.items = [...t.items];
  }
  /**
   * Returns the number of items in the collection
   */
  get size() {
    return this.items.length;
  }
  /**
   * Returns the first value in the collection
   */
  get firstValue() {
    let t = 0;
    for (; this.getItemDisabled(this.at(t)); ) t++;
    return this.getItemValue(this.at(t));
  }
  /**
   * Returns the last value in the collection
   */
  get lastValue() {
    let t = this.size - 1;
    for (; this.getItemDisabled(this.at(t)); ) t--;
    return this.getItemValue(this.at(t));
  }
  *[Symbol.iterator]() {
    yield* this.items;
  }
}, IO = (e, t) => !!(e != null && e.toLowerCase().startsWith(t.toLowerCase())), OO = (e, t) => e.map((r, n) => e[(Math.max(t, 0) + n) % e.length]);
function Ji(e, t, ...r) {
  return [...e.slice(0, t), ...r, ...e.slice(t)];
}
function xs(e, t, r) {
  t = [...t].sort((i, o) => i - o);
  const n = t.map((i) => e[i]);
  for (let i = t.length - 1; i >= 0; i--)
    e = [...e.slice(0, t[i]), ...e.slice(t[i] + 1)];
  return r = Math.max(0, r - t.filter((i) => i < r).length), [...e.slice(0, r), ...n, ...e.slice(r)];
}
const Md = (e) => new is(e);
var Qn = /* @__PURE__ */ new WeakMap(), _s = /* @__PURE__ */ new WeakMap(), ws = {}, Jl = 0, py = (e) => e && (e.host || py(e.parentNode)), PO = (e, t) => t.map((r) => {
  if (e.contains(r)) return r;
  const n = py(r);
  return n && e.contains(n) ? n : (console.error("[zag-js > ariaHidden] target", r, "in not contained inside", e, ". Doing nothing"), null);
}).filter((r) => !!r), TO = (e) => e.localName === "next-route-announcer" || e.localName === "script" || e.hasAttribute("aria-live") ? !0 : e.matches("[data-live-announcer]"), RO = (e, t) => {
  const { parentNode: r, markerName: n, controlAttribute: i } = t, o = PO(r, Array.isArray(e) ? e : [e]);
  ws[n] || (ws[n] = /* @__PURE__ */ new WeakMap());
  const s = ws[n], a = [], l = /* @__PURE__ */ new Set(), c = new Set(o), u = (d) => {
    !d || l.has(d) || (l.add(d), u(d.parentNode));
  };
  o.forEach(u);
  const f = (d) => {
    !d || c.has(d) || Array.prototype.forEach.call(d.children, (p) => {
      if (l.has(p))
        f(p);
      else
        try {
          if (TO(p)) return;
          const h = p.getAttribute(i) === "true", m = (Qn.get(p) || 0) + 1, v = (s.get(p) || 0) + 1;
          Qn.set(p, m), s.set(p, v), a.push(p), m === 1 && h && _s.set(p, !0), v === 1 && p.setAttribute(n, ""), h || p.setAttribute(i, "true");
        } catch (g) {
          console.error("[zag-js > ariaHidden] cannot operate on ", p, g);
        }
    });
  };
  return f(r), l.clear(), Jl++, () => {
    a.forEach((d) => {
      const p = Qn.get(d) - 1, g = s.get(d) - 1;
      Qn.set(d, p), s.set(d, g), p || (_s.has(d) || d.removeAttribute(i), _s.delete(d)), g || d.removeAttribute(n);
    }), Jl--, Jl || (Qn = /* @__PURE__ */ new WeakMap(), Qn = /* @__PURE__ */ new WeakMap(), _s = /* @__PURE__ */ new WeakMap(), ws = {});
  };
}, AO = (e) => (Array.isArray(e) ? e[0] : e).ownerDocument.body, NO = (e, t = AO(e), r = "data-aria-hidden") => {
  if (t)
    return RO(e, {
      parentNode: t,
      markerName: r,
      controlAttribute: "aria-hidden"
    });
}, FO = (e) => {
  const t = requestAnimationFrame(() => e());
  return () => cancelAnimationFrame(t);
};
function gy(e, t = {}) {
  const { defer: r = !0 } = t, n = r ? FO : (o) => o(), i = [];
  return i.push(
    n(() => {
      const s = (typeof e == "function" ? e() : e).filter(Boolean);
      s.length !== 0 && i.push(NO(s));
    })
  ), () => {
    i.forEach((o) => o == null ? void 0 : o());
  };
}
var my = le("combobox").parts(
  "root",
  "clearTrigger",
  "content",
  "control",
  "input",
  "item",
  "itemGroup",
  "itemGroupLabel",
  "itemIndicator",
  "itemText",
  "label",
  "list",
  "positioner",
  "trigger"
);
my.build();
var vy = (e) => new is(e);
vy.empty = () => new is({ items: [] });
var $O = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.control) != null ? r : `combobox:${e.id}:control`;
}, LO = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.input) != null ? r : `combobox:${e.id}:input`;
}, VO = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.content) != null ? r : `combobox:${e.id}:content`;
}, zO = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.positioner) != null ? r : `combobox:${e.id}:popper`;
}, DO = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.trigger) != null ? r : `combobox:${e.id}:toggle-btn`;
}, MO = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.clearTrigger) != null ? r : `combobox:${e.id}:clear-btn`;
}, tn = (e) => e.getById(VO(e)), li = (e) => e.getById(LO(e)), Oh = (e) => e.getById(zO(e)), Ph = (e) => e.getById($O(e)), mo = (e) => e.getById(DO(e)), Th = (e) => e.getById(MO(e)), BO = (e, t) => {
  if (t == null) return;
  const r = `[role=option][data-value="${CSS.escape(t)}"]`;
  return yC(tn(e), r);
}, Rh = (e) => {
  const t = li(e);
  e.isActiveElement(t) || t == null || t.focus({ preventScroll: !0 });
}, WO = (e) => {
  const t = mo(e);
  e.isActiveElement(t) || t == null || t.focus({ preventScroll: !0 });
}, { and: et, not: Ft } = Yr();
et("isOpenControlled", "openOnChange"), et("isCustomValue", Ft("allowCustomValue")), et("isOpenControlled", "autoComplete"), et("autoComplete", "isLastItemHighlighted"), et("autoComplete", "isFirstItemHighlighted"), et("isOpenControlled", "isCustomValue", Ft("hasHighlightedItem"), Ft("allowCustomValue")), et("isCustomValue", Ft("hasHighlightedItem"), Ft("allowCustomValue")), et("isOpenControlled", "closeOnSelect"), et("isOpenControlled", "closeOnSelect"), et("isOpenControlled", "autoComplete"), et("isOpenControlled", "isCustomValue", Ft("allowCustomValue")), et("isCustomValue", Ft("allowCustomValue")), et("isOpenControlled", "isCustomValue", Ft("hasHighlightedItem"), Ft("allowCustomValue")), et("isCustomValue", Ft("hasHighlightedItem"), Ft("allowCustomValue")), et("isOpenControlled", "closeOnSelect"), et("isOpenControlled", "isCustomValue", Ft("allowCustomValue")), et("isCustomValue", Ft("allowCustomValue")), et("isOpenControlled", "closeOnSelect");
function Zi({ context: e, prop: t }) {
  return Oo(t("selectionBehavior"), {
    preserve: e.get("inputValue"),
    replace: e.get("valueAsString"),
    clear: ""
  });
}
function HO({ context: e, prop: t }) {
  const r = t("collection");
  return e.get("value").map((n) => {
    const i = e.get("selectedItems").find((o) => r.getItemValue(o) === n);
    return i || r.find(n);
  });
}
ue()([
  "allowCustomValue",
  "autoFocus",
  "closeOnSelect",
  "collection",
  "composite",
  "defaultHighlightedValue",
  "defaultInputValue",
  "defaultOpen",
  "defaultValue",
  "dir",
  "disabled",
  "disableLayer",
  "form",
  "getRootNode",
  "highlightedValue",
  "id",
  "ids",
  "inputBehavior",
  "inputValue",
  "invalid",
  "loopFocus",
  "multiple",
  "name",
  "navigate",
  "onFocusOutside",
  "onHighlightChange",
  "onInputValueChange",
  "onInteractOutside",
  "onOpenChange",
  "onOpenChange",
  "onPointerDownOutside",
  "onSelect",
  "onValueChange",
  "open",
  "openOnChange",
  "openOnClick",
  "openOnKeyPress",
  "placeholder",
  "positioning",
  "readOnly",
  "required",
  "scrollToIndexFn",
  "selectionBehavior",
  "translations",
  "value"
]);
ue()(["htmlFor"]);
ue()(["id"]);
ue()(["item", "persistFocus"]);
var jO = Object.defineProperty, UO = (e, t, r) => t in e ? jO(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, $e = (e, t, r) => UO(e, typeof t != "symbol" ? t + "" : t, r), Ah = {
  activateTrap(e, t) {
    if (e.length > 0) {
      const n = e[e.length - 1];
      n !== t && n.pause();
    }
    const r = e.indexOf(t);
    r === -1 || e.splice(r, 1), e.push(t);
  },
  deactivateTrap(e, t) {
    const r = e.indexOf(t);
    r !== -1 && e.splice(r, 1), e.length > 0 && e[e.length - 1].unpause();
  }
}, GO = [], qO = class {
  constructor(e, t) {
    $e(this, "trapStack"), $e(this, "config"), $e(this, "doc"), $e(this, "state", {
      containers: [],
      containerGroups: [],
      tabbableGroups: [],
      nodeFocusedBeforeActivation: null,
      mostRecentlyFocusedNode: null,
      active: !1,
      paused: !1,
      delayInitialFocusTimer: void 0,
      recentNavEvent: void 0
    }), $e(this, "listenerCleanups", []), $e(this, "handleFocus", (n) => {
      const i = Ct(n), o = this.findContainerIndex(i, n) >= 0;
      if (o || md(i))
        o && (this.state.mostRecentlyFocusedNode = i);
      else {
        n.stopImmediatePropagation();
        let s, a = !0;
        if (this.state.mostRecentlyFocusedNode)
          if (Yi(this.state.mostRecentlyFocusedNode) > 0) {
            const l = this.findContainerIndex(this.state.mostRecentlyFocusedNode), { tabbableNodes: c } = this.state.containerGroups[l];
            if (c.length > 0) {
              const u = c.findIndex((f) => f === this.state.mostRecentlyFocusedNode);
              u >= 0 && (this.config.isKeyForward(this.state.recentNavEvent) ? u + 1 < c.length && (s = c[u + 1], a = !1) : u - 1 >= 0 && (s = c[u - 1], a = !1));
            }
          } else
            this.state.containerGroups.some((l) => l.tabbableNodes.some((c) => Yi(c) > 0)) || (a = !1);
        else
          a = !1;
        a && (s = this.findNextNavNode({
          // move FROM the MRU node, not event-related node (which will be the node that is
          //  outside the trap causing the focus escape we're trying to fix)
          target: this.state.mostRecentlyFocusedNode,
          isBackward: this.config.isKeyBackward(this.state.recentNavEvent)
        })), s ? this.tryFocus(s) : this.tryFocus(this.state.mostRecentlyFocusedNode || this.getInitialFocusNode());
      }
      this.state.recentNavEvent = void 0;
    }), $e(this, "handlePointerDown", (n) => {
      const i = Ct(n);
      if (!(this.findContainerIndex(i, n) >= 0)) {
        if (eo(this.config.clickOutsideDeactivates, n)) {
          this.deactivate({ returnFocus: this.config.returnFocusOnDeactivate });
          return;
        }
        eo(this.config.allowOutsideClick, n) || n.preventDefault();
      }
    }), $e(this, "handleClick", (n) => {
      const i = Ct(n);
      this.findContainerIndex(i, n) >= 0 || eo(this.config.clickOutsideDeactivates, n) || eo(this.config.allowOutsideClick, n) || (n.preventDefault(), n.stopImmediatePropagation());
    }), $e(this, "handleTabKey", (n) => {
      if (this.config.isKeyForward(n) || this.config.isKeyBackward(n)) {
        this.state.recentNavEvent = n;
        const i = this.config.isKeyBackward(n), o = this.findNextNavNode({ event: n, isBackward: i });
        if (!o) return;
        Qi(n) && n.preventDefault(), this.tryFocus(o);
      }
    }), $e(this, "handleEscapeKey", (n) => {
      KO(n) && eo(this.config.escapeDeactivates, n) !== !1 && (n.preventDefault(), this.deactivate());
    }), $e(this, "_mutationObserver"), $e(this, "setupMutationObserver", () => {
      const n = this.doc.defaultView || window;
      this._mutationObserver = new n.MutationObserver((i) => {
        i.some((s) => Array.from(s.removedNodes).some((l) => l === this.state.mostRecentlyFocusedNode)) && this.tryFocus(this.getInitialFocusNode());
      });
    }), $e(this, "updateObservedNodes", () => {
      var n;
      (n = this._mutationObserver) == null || n.disconnect(), this.state.active && !this.state.paused && this.state.containers.map((i) => {
        var o;
        (o = this._mutationObserver) == null || o.observe(i, { subtree: !0, childList: !0 });
      });
    }), $e(this, "getInitialFocusNode", () => {
      let n = this.getNodeForOption("initialFocus", { hasFallback: !0 });
      if (n === !1)
        return !1;
      if (n === void 0 || n && !ln(n))
        if (this.findContainerIndex(this.doc.activeElement) >= 0)
          n = this.doc.activeElement;
        else {
          const i = this.state.tabbableGroups[0];
          n = i && i.firstTabbableNode || this.getNodeForOption("fallbackFocus");
        }
      else n === null && (n = this.getNodeForOption("fallbackFocus"));
      if (!n)
        throw new Error("Your focus-trap needs to have at least one focusable element");
      return n.isConnected || (n = this.getNodeForOption("fallbackFocus")), n;
    }), $e(this, "tryFocus", (n) => {
      if (n !== !1 && n !== _b(this.doc)) {
        if (!n || !n.focus) {
          this.tryFocus(this.getInitialFocusNode());
          return;
        }
        n.focus({ preventScroll: !!this.config.preventScroll }), this.state.mostRecentlyFocusedNode = n, YO(n) && n.select();
      }
    }), $e(this, "deactivate", (n) => {
      if (!this.state.active) return this;
      const i = {
        onDeactivate: this.config.onDeactivate,
        onPostDeactivate: this.config.onPostDeactivate,
        checkCanReturnFocus: this.config.checkCanReturnFocus,
        ...n
      };
      clearTimeout(this.state.delayInitialFocusTimer), this.state.delayInitialFocusTimer = void 0, this.removeListeners(), this.state.active = !1, this.state.paused = !1, this.updateObservedNodes(), Ah.deactivateTrap(this.trapStack, this);
      const o = this.getOption(i, "onDeactivate"), s = this.getOption(i, "onPostDeactivate"), a = this.getOption(i, "checkCanReturnFocus"), l = this.getOption(i, "returnFocus", "returnFocusOnDeactivate");
      o == null || o();
      const c = () => {
        Nh(() => {
          if (l) {
            const u = this.getReturnFocusNode(this.state.nodeFocusedBeforeActivation);
            this.tryFocus(u);
          }
          s == null || s();
        });
      };
      if (l && a) {
        const u = this.getReturnFocusNode(this.state.nodeFocusedBeforeActivation);
        return a(u).then(c, c), this;
      }
      return c(), this;
    }), $e(this, "pause", (n) => {
      if (this.state.paused || !this.state.active)
        return this;
      const i = this.getOption(n, "onPause"), o = this.getOption(n, "onPostPause");
      return this.state.paused = !0, i == null || i(), this.removeListeners(), this.updateObservedNodes(), o == null || o(), this;
    }), $e(this, "unpause", (n) => {
      if (!this.state.paused || !this.state.active)
        return this;
      const i = this.getOption(n, "onUnpause"), o = this.getOption(n, "onPostUnpause");
      return this.state.paused = !1, i == null || i(), this.updateTabbableNodes(), this.addListeners(), this.updateObservedNodes(), o == null || o(), this;
    }), $e(this, "updateContainerElements", (n) => (this.state.containers = Array.isArray(n) ? n.filter(Boolean) : [n].filter(Boolean), this.state.active && this.updateTabbableNodes(), this.updateObservedNodes(), this)), $e(this, "getReturnFocusNode", (n) => {
      const i = this.getNodeForOption("setReturnFocus", {
        params: [n]
      });
      return i || (i === !1 ? !1 : n);
    }), $e(this, "getOption", (n, i, o) => n && n[i] !== void 0 ? n[i] : (
      // @ts-expect-error
      this.config[o || i]
    )), $e(this, "getNodeForOption", (n, { hasFallback: i = !1, params: o = [] } = {}) => {
      let s = this.config[n];
      if (typeof s == "function" && (s = s(...o)), s === !0 && (s = void 0), !s) {
        if (s === void 0 || s === !1)
          return s;
        throw new Error(`\`${n}\` was specified but was not a node, or did not return a node`);
      }
      let a = s;
      if (typeof s == "string") {
        try {
          a = this.doc.querySelector(s);
        } catch (l) {
          throw new Error(`\`${n}\` appears to be an invalid selector; error="${l.message}"`);
        }
        if (!a && !i)
          throw new Error(`\`${n}\` as selector refers to no known node`);
      }
      return a;
    }), $e(this, "findNextNavNode", (n) => {
      const { event: i, isBackward: o = !1 } = n, s = n.target || Ct(i);
      this.updateTabbableNodes();
      let a = null;
      if (this.state.tabbableGroups.length > 0) {
        const l = this.findContainerIndex(s, i), c = l >= 0 ? this.state.containerGroups[l] : void 0;
        if (l < 0)
          o ? a = this.state.tabbableGroups[this.state.tabbableGroups.length - 1].lastTabbableNode : a = this.state.tabbableGroups[0].firstTabbableNode;
        else if (o) {
          let u = this.state.tabbableGroups.findIndex(
            ({ firstTabbableNode: f }) => s === f
          );
          if (u < 0 && ((c == null ? void 0 : c.container) === s || ln(s) && !on(s) && !(c != null && c.nextTabbableNode(s, !1))) && (u = l), u >= 0) {
            const f = u === 0 ? this.state.tabbableGroups.length - 1 : u - 1, d = this.state.tabbableGroups[f];
            a = Yi(s) >= 0 ? d.lastTabbableNode : d.lastDomTabbableNode;
          } else Qi(i) || (a = c == null ? void 0 : c.nextTabbableNode(s, !1));
        } else {
          let u = this.state.tabbableGroups.findIndex(
            ({ lastTabbableNode: f }) => s === f
          );
          if (u < 0 && ((c == null ? void 0 : c.container) === s || ln(s) && !on(s) && !(c != null && c.nextTabbableNode(s))) && (u = l), u >= 0) {
            const f = u === this.state.tabbableGroups.length - 1 ? 0 : u + 1, d = this.state.tabbableGroups[f];
            a = Yi(s) >= 0 ? d.firstTabbableNode : d.firstDomTabbableNode;
          } else Qi(i) || (a = c == null ? void 0 : c.nextTabbableNode(s));
        }
      } else
        a = this.getNodeForOption("fallbackFocus");
      return a;
    }), this.trapStack = t.trapStack || GO;
    const r = {
      returnFocusOnDeactivate: !0,
      escapeDeactivates: !0,
      delayInitialFocus: !0,
      isKeyForward(n) {
        return Qi(n) && !n.shiftKey;
      },
      isKeyBackward(n) {
        return Qi(n) && n.shiftKey;
      },
      ...t
    };
    this.doc = r.document || Wt(Array.isArray(e) ? e[0] : e), this.config = r, this.updateContainerElements(e), this.setupMutationObserver();
  }
  get active() {
    return this.state.active;
  }
  get paused() {
    return this.state.paused;
  }
  findContainerIndex(e, t) {
    const r = typeof (t == null ? void 0 : t.composedPath) == "function" ? t.composedPath() : void 0;
    return this.state.containerGroups.findIndex(
      ({ container: n, tabbableNodes: i }) => n.contains(e) || (r == null ? void 0 : r.includes(n)) || i.find((o) => o === e)
    );
  }
  updateTabbableNodes() {
    if (this.state.containerGroups = this.state.containers.map((e) => {
      const t = ts(e), r = Cb(e), n = t.length > 0 ? t[0] : void 0, i = t.length > 0 ? t[t.length - 1] : void 0, o = r.find((c) => on(c)), s = r.slice().reverse().find((c) => on(c)), a = !!t.find((c) => Yi(c) > 0);
      function l(c, u = !0) {
        const f = t.indexOf(c);
        return f < 0 ? u ? r.slice(r.indexOf(c) + 1).find((d) => on(d)) : r.slice(0, r.indexOf(c)).reverse().find((d) => on(d)) : t[f + (u ? 1 : -1)];
      }
      return {
        container: e,
        tabbableNodes: t,
        focusableNodes: r,
        posTabIndexesFound: a,
        firstTabbableNode: n,
        lastTabbableNode: i,
        firstDomTabbableNode: o,
        lastDomTabbableNode: s,
        nextTabbableNode: l
      };
    }), this.state.tabbableGroups = this.state.containerGroups.filter((e) => e.tabbableNodes.length > 0), this.state.tabbableGroups.length <= 0 && !this.getNodeForOption("fallbackFocus"))
      throw new Error(
        "Your focus-trap must have at least one container with at least one tabbable node in it at all times"
      );
    if (this.state.containerGroups.find((e) => e.posTabIndexesFound) && this.state.containerGroups.length > 1)
      throw new Error(
        "At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps."
      );
  }
  addListeners() {
    if (this.state.active)
      return Ah.activateTrap(this.trapStack, this), this.state.delayInitialFocusTimer = this.config.delayInitialFocus ? Nh(() => {
        this.tryFocus(this.getInitialFocusNode());
      }) : this.tryFocus(this.getInitialFocusNode()), this.listenerCleanups.push(
        Ae(this.doc, "focusin", this.handleFocus, !0),
        Ae(this.doc, "mousedown", this.handlePointerDown, { capture: !0, passive: !1 }),
        Ae(this.doc, "touchstart", this.handlePointerDown, { capture: !0, passive: !1 }),
        Ae(this.doc, "click", this.handleClick, { capture: !0, passive: !1 }),
        Ae(this.doc, "keydown", this.handleTabKey, { capture: !0, passive: !1 }),
        Ae(this.doc, "keydown", this.handleEscapeKey)
      ), this;
  }
  removeListeners() {
    if (this.state.active)
      return this.listenerCleanups.forEach((e) => e()), this.listenerCleanups = [], this;
  }
  activate(e) {
    if (this.state.active)
      return this;
    const t = this.getOption(e, "onActivate"), r = this.getOption(e, "onPostActivate"), n = this.getOption(e, "checkCanFocusTrap");
    n || this.updateTabbableNodes(), this.state.active = !0, this.state.paused = !1, this.state.nodeFocusedBeforeActivation = this.doc.activeElement || null, t == null || t();
    const i = () => {
      n && this.updateTabbableNodes(), this.addListeners(), this.updateObservedNodes(), r == null || r();
    };
    return n ? (n(this.state.containers.concat()).then(i, i), this) : (i(), this);
  }
}, Qi = (e) => e.key === "Tab", eo = (e, ...t) => typeof e == "function" ? e(...t) : e, KO = (e) => !e.isComposing && e.key === "Escape", Nh = (e) => setTimeout(e, 0), YO = (e) => e.localName === "input" && "select" in e && typeof e.select == "function";
function XO(e, t = {}) {
  let r;
  const n = de(() => {
    const i = typeof e == "function" ? e() : e;
    if (i) {
      r = new qO(i, {
        escapeDeactivates: !1,
        allowOutsideClick: !0,
        preventScroll: !0,
        returnFocusOnDeactivate: !0,
        delayInitialFocus: !1,
        fallbackFocus: i,
        ...t,
        document: Wt(i)
      });
      try {
        r.activate();
      } catch (o) {
      }
    }
  });
  return function() {
    r == null || r.deactivate(), n();
  };
}
var Zl = "data-scroll-lock";
function JO(e) {
  const t = e.getBoundingClientRect().left;
  return Math.round(t) + e.scrollLeft ? "paddingLeft" : "paddingRight";
}
function ZO(e) {
  var d;
  const t = e != null ? e : document, r = (d = t.defaultView) != null ? d : window, { documentElement: n, body: i } = t;
  if (i.hasAttribute(Zl)) return;
  i.setAttribute(Zl, "");
  const s = r.innerWidth - n.clientWidth, a = () => IC(n, "--scrollbar-width", `${s}px`), l = JO(n), c = () => ba(i, {
    overflow: "hidden",
    [l]: `${s}px`
  }), u = () => {
    var x, S;
    const { scrollX: p, scrollY: g, visualViewport: h } = r, m = (x = h == null ? void 0 : h.offsetLeft) != null ? x : 0, v = (S = h == null ? void 0 : h.offsetTop) != null ? S : 0, y = ba(i, {
      position: "fixed",
      overflow: "hidden",
      top: `${-(g - Math.floor(v))}px`,
      left: `${-(p - Math.floor(m))}px`,
      right: "0",
      [l]: `${s}px`
    });
    return () => {
      y == null || y(), r.scrollTo({ left: p, top: g, behavior: "instant" });
    };
  }, f = [a(), sl() ? u() : c()];
  return () => {
    f.forEach((p) => p == null ? void 0 : p()), i.removeAttribute(Zl);
  };
}
var Bd = le("dialog").parts(
  "trigger",
  "backdrop",
  "positioner",
  "content",
  "title",
  "description",
  "closeTrigger"
);
Bd.build();
ue()([
  "aria-label",
  "closeOnEscape",
  "closeOnInteractOutside",
  "dir",
  "finalFocusEl",
  "getRootNode",
  "getRootNode",
  "id",
  "id",
  "ids",
  "initialFocusEl",
  "modal",
  "onEscapeKeyDown",
  "onFocusOutside",
  "onInteractOutside",
  "onOpenChange",
  "onPointerDownOutside",
  "defaultOpen",
  "open",
  "persistentElements",
  "preventScroll",
  "restoreFocus",
  "role",
  "trapFocus"
]);
var by = le("editable").parts(
  "root",
  "area",
  "label",
  "preview",
  "input",
  "editTrigger",
  "submitTrigger",
  "cancelTrigger",
  "control"
);
by.build();
ue()([
  "activationMode",
  "autoResize",
  "dir",
  "disabled",
  "finalFocusEl",
  "form",
  "getRootNode",
  "id",
  "ids",
  "invalid",
  "maxLength",
  "name",
  "onEditChange",
  "onFocusOutside",
  "onInteractOutside",
  "onPointerDownOutside",
  "onValueChange",
  "onValueCommit",
  "onValueRevert",
  "placeholder",
  "readOnly",
  "required",
  "selectOnFocus",
  "edit",
  "defaultEdit",
  "submitMode",
  "translations",
  "defaultValue",
  "value"
]);
const yy = Z((e, t) => {
  const r = Dd(), n = oe(r == null ? void 0 : r.getInputProps(), e);
  return /* @__PURE__ */ b(ae.input, { ...n, ref: t });
});
yy.displayName = "FieldInput";
const xy = le("field").parts(
  "root",
  "errorText",
  "helperText",
  "input",
  "label",
  "select",
  "textarea",
  "requiredIndicator"
);
xy.build();
const _y = le("fieldset").parts("root", "errorText", "helperText", "legend");
_y.build();
var wy = le("file-upload").parts(
  "root",
  "dropzone",
  "item",
  "itemDeleteTrigger",
  "itemGroup",
  "itemName",
  "itemPreview",
  "itemPreviewImage",
  "itemSizeText",
  "label",
  "trigger",
  "clearTrigger"
);
wy.build();
ue()([
  "accept",
  "allowDrop",
  "capture",
  "dir",
  "directory",
  "disabled",
  "getRootNode",
  "id",
  "ids",
  "locale",
  "maxFiles",
  "maxFileSize",
  "minFileSize",
  "name",
  "invalid",
  "onFileAccept",
  "onFileReject",
  "onFileChange",
  "preventDocumentDrop",
  "required",
  "translations",
  "validate"
]);
ue()(["file"]);
const QO = Symbol(), Fh = Object.getPrototypeOf, Zc = /* @__PURE__ */ new WeakMap(), eP = (e) => e && (Zc.has(e) ? Zc.get(e) : Fh(e) === Object.prototype || Fh(e) === Array.prototype), tP = (e) => eP(e) && e[QO] || null, $h = (e, t = !0) => {
  Zc.set(e, t);
};
function rP() {
  if (typeof globalThis != "undefined") return globalThis;
  if (typeof self != "undefined") return self;
  if (typeof window != "undefined") return window;
  if (typeof global != "undefined") return global;
}
function Sy(e, t) {
  const r = rP();
  return r ? (r[e] || (r[e] = t()), r[e]) : t();
}
var Qs = Sy("__zag__refSet", () => /* @__PURE__ */ new WeakSet()), nP = (e) => typeof e == "object" && e !== null && "$$typeof" in e && "props" in e, iP = (e) => typeof e == "object" && e !== null && "__v_isVNode" in e, oP = (e) => typeof e == "object" && e !== null && "nodeType" in e && typeof e.nodeName == "string", sP = (e) => nP(e) || iP(e) || oP(e), Qc = (e) => e !== null && typeof e == "object", Lh = (e) => Qc(e) && !Qs.has(e) && (Array.isArray(e) || !(Symbol.iterator in e)) && !sP(e) && !(e instanceof WeakMap) && !(e instanceof WeakSet) && !(e instanceof Error) && !(e instanceof Number) && !(e instanceof Date) && !(e instanceof String) && !(e instanceof RegExp) && !(e instanceof ArrayBuffer) && !(e instanceof Promise), Ca = () => process.env.NODE_ENV !== "production", Rn = Sy("__zag__proxyStateMap", () => /* @__PURE__ */ new WeakMap()), aP = (e = Object.is, t = (a, l) => new Proxy(a, l), r = /* @__PURE__ */ new WeakMap(), n = (a, l) => {
  const c = r.get(a);
  if ((c == null ? void 0 : c[0]) === l)
    return c[1];
  const u = Array.isArray(a) ? [] : Object.create(Object.getPrototypeOf(a));
  return $h(u, !0), r.set(a, [l, u]), Reflect.ownKeys(a).forEach((f) => {
    const d = Reflect.get(a, f);
    Qs.has(d) ? ($h(d, !1), u[f] = d) : Rn.has(d) ? u[f] = uP(d) : u[f] = d;
  }), Object.freeze(u);
}, i = /* @__PURE__ */ new WeakMap(), o = [1, 1], s = (a) => {
  if (!Qc(a))
    throw new Error("object required");
  const l = i.get(a);
  if (l)
    return l;
  let c = o[0];
  const u = /* @__PURE__ */ new Set(), f = (O, w = ++o[0]) => {
    c !== w && (c = w, u.forEach((E) => E(O, w)));
  };
  let d = o[1];
  const p = (O = ++o[1]) => (d !== O && !u.size && (d = O, h.forEach(([w]) => {
    const E = w[1](O);
    E > c && (c = E);
  })), c), g = (O) => (w, E) => {
    const T = [...w];
    T[1] = [O, ...T[1]], f(T, E);
  }, h = /* @__PURE__ */ new Map(), m = (O, w) => {
    if (Ca() && h.has(O))
      throw new Error("prop listener already exists");
    if (u.size) {
      const E = w[3](g(O));
      h.set(O, [w, E]);
    } else
      h.set(O, [w]);
  }, v = (O) => {
    var E;
    const w = h.get(O);
    w && (h.delete(O), (E = w[1]) == null || E.call(w));
  }, y = (O) => (u.add(O), u.size === 1 && h.forEach(([E, T], G) => {
    if (Ca() && T)
      throw new Error("remove already exists");
    const k = E[3](g(G));
    h.set(G, [E, k]);
  }), () => {
    u.delete(O), u.size === 0 && h.forEach(([E, T], G) => {
      T && (T(), h.set(G, [E]));
    });
  }), x = Array.isArray(a) ? [] : Object.create(Object.getPrototypeOf(a)), _ = t(x, {
    deleteProperty(O, w) {
      const E = Reflect.get(O, w);
      v(w);
      const T = Reflect.deleteProperty(O, w);
      return T && f(["delete", [w], E]), T;
    },
    set(O, w, E, T) {
      var F;
      const G = Reflect.has(O, w), k = Reflect.get(O, w, T);
      if (G && (e(k, E) || i.has(E) && e(k, i.get(E))))
        return !0;
      v(w), Qc(E) && (E = tP(E) || E);
      let j = E;
      if (!((F = Object.getOwnPropertyDescriptor(O, w)) != null && F.set)) {
        !Rn.has(E) && Lh(E) && (j = Ey(E));
        const L = !Qs.has(j) && Rn.get(j);
        L && m(w, L);
      }
      return Reflect.set(O, w, j, T), f(["set", [w], E, k]), !0;
    }
  });
  i.set(a, _);
  const I = [x, p, n, y];
  return Rn.set(_, I), Reflect.ownKeys(a).forEach((O) => {
    const w = Object.getOwnPropertyDescriptor(a, O);
    w.get || w.set ? Object.defineProperty(x, O, w) : _[O] = a[O];
  }), _;
}) => [
  // public functions
  s,
  // shared state
  Rn,
  Qs,
  // internal things
  e,
  t,
  Lh,
  r,
  n,
  i,
  o
], [lP] = aP();
function Ey(e = {}) {
  return lP(e);
}
function cP(e, t, r) {
  const n = Rn.get(e);
  Ca() && !n && console.warn("Please use proxy object");
  let i;
  const o = [], s = n[3];
  let a = !1;
  const c = s((u) => {
    o.push(u), i || (i = Promise.resolve().then(() => {
      i = void 0, a && t(o.splice(0));
    }));
  });
  return a = !0, () => {
    a = !1, c();
  };
}
function uP(e) {
  const t = Rn.get(e);
  Ca() && !t && console.warn("Please use proxy object");
  const [r, n, i] = t;
  return i(r, n());
}
const dP = (e) => typeof e == "function", fP = (e, ...t) => dP(e) ? e(...t) : e, hP = (e) => {
  const { value: t, children: r } = e, [n, i] = We(), o = _e(() => () => {
    var a, l;
    return (l = (a = fP(t)) != null ? a : n == null ? void 0 : n.ownerDocument) != null ? l : document;
  }, [t, n]), s = _e(
    () => ({
      getRootNode: o,
      getWindow: () => ct(o()),
      getDocument: () => Wt(o())
    }),
    [o]
  );
  return /* @__PURE__ */ K(bE, { value: s, children: [
    r,
    !t && /* @__PURE__ */ b("span", { hidden: !0, ref: i })
  ] });
};
var Cy = le("hoverCard").parts("arrow", "arrowTip", "trigger", "positioner", "content");
Cy.build();
var pP = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.trigger) != null ? r : `hover-card:${e.id}:trigger`;
}, gP = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.content) != null ? r : `hover-card:${e.id}:content`;
}, mP = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.positioner) != null ? r : `hover-card:${e.id}:popper`;
}, Ql = (e) => e.getById(pP(e)), vP = (e) => e.getById(gP(e)), Vh = (e) => e.getById(mP(e)), { not: Ss, and: zh } = Yr();
zh("isOpenControlled", Ss("isPointer")), Ss("isPointer"), zh("isOpenControlled", Ss("isPointer")), Ss("isPointer");
ue()([
  "closeDelay",
  "dir",
  "getRootNode",
  "id",
  "ids",
  "onOpenChange",
  "defaultOpen",
  "open",
  "openDelay",
  "positioning",
  "onInteractOutside",
  "onPointerDownOutside",
  "onFocusOutside"
]);
var ky = le("menu").parts(
  "arrow",
  "arrowTip",
  "content",
  "contextTrigger",
  "indicator",
  "item",
  "itemGroup",
  "itemGroupLabel",
  "itemIndicator",
  "itemText",
  "positioner",
  "separator",
  "trigger",
  "triggerItem"
);
ky.build();
var Iy = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.trigger) != null ? r : `menu:${e.id}:trigger`;
}, bP = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.contextTrigger) != null ? r : `menu:${e.id}:ctx-trigger`;
}, Oy = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.content) != null ? r : `menu:${e.id}:content`;
}, yP = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.positioner) != null ? r : `menu:${e.id}:popper`;
}, eu = (e, t) => `${e.id}/${t}`, _n = (e) => {
  var t;
  return (t = e == null ? void 0 : e.dataset.value) != null ? t : null;
}, rn = (e) => e.getById(Oy(e)), Dh = (e) => e.getById(yP(e)), Es = (e) => e.getById(Iy(e)), xP = (e, t) => t ? e.getById(eu(e, t)) : null, Mh = (e) => e.getById(bP(e)), os = (e) => {
  const r = `[role^="menuitem"][data-ownedby=${CSS.escape(Oy(e))}]:not([data-disabled])`;
  return va(rn(e), r);
}, _P = (e) => ab(os(e)), wP = (e) => lb(os(e)), Wd = (e, t) => t ? e.id === t || e.dataset.value === t : !1, SP = (e, t) => {
  var i;
  const r = os(e), n = r.findIndex((o) => Wd(o, t.value));
  return G1(r, n, { loop: (i = t.loop) != null ? i : t.loopFocus });
}, EP = (e, t) => {
  var i;
  const r = os(e), n = r.findIndex((o) => Wd(o, t.value));
  return K1(r, n, { loop: (i = t.loop) != null ? i : t.loopFocus });
}, CP = (e, t) => {
  var i;
  const r = os(e), n = r.find((o) => Wd(o, t.value));
  return Bo(r, { state: t.typeaheadState, key: t.key, activeId: (i = n == null ? void 0 : n.id) != null ? i : null });
}, kP = (e) => {
  var t;
  return !!((t = e == null ? void 0 : e.getAttribute("role")) != null && t.startsWith("menuitem")) && !!(e != null && e.hasAttribute("aria-controls"));
}, IP = "menu:select";
function OP(e, t) {
  if (!e) return;
  const r = ct(e), n = new r.CustomEvent(IP, { detail: { value: t } });
  e.dispatchEvent(n);
}
var { not: Ut, and: ei, or: PP } = Yr();
Ut("isSubmenu"), PP("isOpenAutoFocusEvent", "isArrowDownEvent"), ei(Ut("isTriggerItem"), "isOpenControlled"), Ut("isTriggerItem"), ei("isSubmenu", "isOpenControlled"), Ut("isPointerSuspended"), ei(Ut("isPointerSuspended"), Ut("isTriggerItem")), ei(
  Ut("isTriggerItemHighlighted"),
  Ut("isHighlightedItemEditable"),
  "closeOnSelect",
  "isOpenControlled"
), ei(Ut("isTriggerItemHighlighted"), Ut("isHighlightedItemEditable"), "closeOnSelect"), ei(Ut("isTriggerItemHighlighted"), Ut("isHighlightedItemEditable"));
function Bh(e) {
  let t = e.parent;
  for (; t && t.computed("isSubmenu"); )
    t = t.refs.get("parent");
  t == null || t.send({ type: "CLOSE" });
}
function TP(e, t) {
  return e ? iO(e, t) : !1;
}
function RP(e, t, r) {
  const n = Object.keys(e).length > 0;
  if (!t) return null;
  if (!n)
    return eu(r, t);
  for (const i in e) {
    const o = e[i], s = Iy(o.scope);
    if (s === t)
      return s;
  }
  return eu(r, t);
}
ue()([
  "anchorPoint",
  "aria-label",
  "closeOnSelect",
  "composite",
  "defaultHighlightedValue",
  "defaultOpen",
  "dir",
  "getRootNode",
  "highlightedValue",
  "id",
  "ids",
  "loopFocus",
  "navigate",
  "onEscapeKeyDown",
  "onFocusOutside",
  "onHighlightChange",
  "onInteractOutside",
  "onOpenChange",
  "onPointerDownOutside",
  "onSelect",
  "open",
  "positioning",
  "typeahead"
]);
ue()(["closeOnSelect", "disabled", "value", "valueText"]);
ue()(["htmlFor"]);
ue()(["id"]);
ue()([
  "checked",
  "closeOnSelect",
  "disabled",
  "onCheckedChange",
  "type",
  "value",
  "valueText"
]);
let ec = /* @__PURE__ */ new Map(), tu = !1;
try {
  tu = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch (e) {
}
let ka = !1;
try {
  ka = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch (e) {
}
const Py = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class AP {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(t) {
    let r = "";
    if (!tu && this.options.signDisplay != null ? r = FP(this.numberFormatter, this.options.signDisplay, t) : r = this.numberFormatter.format(t), this.options.style === "unit" && !ka) {
      var n;
      let { unit: i, unitDisplay: o = "short", locale: s } = this.resolvedOptions();
      if (!i) return r;
      let a = (n = Py[i]) === null || n === void 0 ? void 0 : n[o];
      r += a[s] || a.default;
    }
    return r;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(t) {
    return this.numberFormatter.formatToParts(t);
  }
  /** Formats a number range as a string. */
  formatRange(t, r) {
    if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(t, r);
    if (r < t) throw new RangeError("End date must be >= start date");
    return `${this.format(t)} – ${this.format(r)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(t, r) {
    if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(t, r);
    if (r < t) throw new RangeError("End date must be >= start date");
    let n = this.numberFormatter.formatToParts(t), i = this.numberFormatter.formatToParts(r);
    return [
      ...n.map((o) => ({
        ...o,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...i.map((o) => ({
        ...o,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.numberFormatter.resolvedOptions();
    return !tu && this.options.signDisplay != null && (t = {
      ...t,
      signDisplay: this.options.signDisplay
    }), !ka && this.options.style === "unit" && (t = {
      ...t,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), t;
  }
  constructor(t, r = {}) {
    this.numberFormatter = NP(t, r), this.options = r;
  }
}
function NP(e, t = {}) {
  let { numberingSystem: r } = t;
  if (r && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${r}`), t.style === "unit" && !ka) {
    var n;
    let { unit: s, unitDisplay: a = "short" } = t;
    if (!s) throw new Error('unit option must be provided with style: "unit"');
    if (!(!((n = Py[s]) === null || n === void 0) && n[a])) throw new Error(`Unsupported unit ${s} with unitDisplay = ${a}`);
    t = {
      ...t,
      style: "decimal"
    };
  }
  let i = e + (t ? Object.entries(t).sort((s, a) => s[0] < a[0] ? -1 : 1).join() : "");
  if (ec.has(i)) return ec.get(i);
  let o = new Intl.NumberFormat(e, t);
  return ec.set(i, o), o;
}
function FP(e, t, r) {
  if (t === "auto") return e.format(r);
  if (t === "never") return e.format(Math.abs(r));
  {
    let n = !1;
    if (t === "always" ? n = r > 0 || Object.is(r, 0) : t === "exceptZero" && (Object.is(r, -0) || Object.is(r, 0) ? r = Math.abs(r) : n = r > 0), n) {
      let i = e.format(-r), o = e.format(r), s = i.replace(o, "").replace(/\u200e|\u061C/, "");
      return [
        ...s
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), i.replace(o, "!!!").replace(s, "+").replace("!!!", o);
    } else return e.format(r);
  }
}
const $P = new RegExp("^.*\\(.*\\).*$"), LP = [
  "latn",
  "arab",
  "hanidec",
  "deva",
  "beng"
];
class Ty {
  /**
  * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
  */
  parse(t) {
    return tc(this.locale, this.options, t).parse(t);
  }
  /**
  * Returns whether the given string could potentially be a valid number. This should be used to
  * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
  * of the minus/plus sign characters can be checked.
  */
  isValidPartialNumber(t, r, n) {
    return tc(this.locale, this.options, t).isValidPartialNumber(t, r, n);
  }
  /**
  * Returns a numbering system for which the given string is valid in the current locale.
  * If no numbering system could be detected, the default numbering system for the current
  * locale is returned.
  */
  getNumberingSystem(t) {
    return tc(this.locale, this.options, t).options.numberingSystem;
  }
  constructor(t, r = {}) {
    this.locale = t, this.options = r;
  }
}
const Wh = /* @__PURE__ */ new Map();
function tc(e, t, r) {
  let n = Hh(e, t);
  if (!e.includes("-nu-") && !n.isValidPartialNumber(r)) {
    for (let i of LP) if (i !== n.options.numberingSystem) {
      let o = Hh(e + (e.includes("-u-") ? "-nu-" : "-u-nu-") + i, t);
      if (o.isValidPartialNumber(r)) return o;
    }
  }
  return n;
}
function Hh(e, t) {
  let r = e + (t ? Object.entries(t).sort((i, o) => i[0] < o[0] ? -1 : 1).join() : ""), n = Wh.get(r);
  return n || (n = new VP(e, t), Wh.set(r, n)), n;
}
class VP {
  parse(t) {
    let r = this.sanitize(t);
    if (this.symbols.group && (r = to(r, this.symbols.group, "")), this.symbols.decimal && (r = r.replace(this.symbols.decimal, ".")), this.symbols.minusSign && (r = r.replace(this.symbols.minusSign, "-")), r = r.replace(this.symbols.numeral, this.symbols.index), this.options.style === "percent") {
      let s = r.indexOf("-");
      r = r.replace("-", "");
      let a = r.indexOf(".");
      a === -1 && (a = r.length), r = r.replace(".", ""), a - 2 === 0 ? r = `0.${r}` : a - 2 === -1 ? r = `0.0${r}` : a - 2 === -2 ? r = "0.00" : r = `${r.slice(0, a - 2)}.${r.slice(a - 2)}`, s > -1 && (r = `-${r}`);
    }
    let n = r ? +r : NaN;
    if (isNaN(n)) return NaN;
    if (this.options.style === "percent") {
      var i, o;
      let s = {
        ...this.options,
        style: "decimal",
        minimumFractionDigits: Math.min(((i = this.options.minimumFractionDigits) !== null && i !== void 0 ? i : 0) + 2, 20),
        maximumFractionDigits: Math.min(((o = this.options.maximumFractionDigits) !== null && o !== void 0 ? o : 0) + 2, 20)
      };
      return new Ty(this.locale, s).parse(new AP(this.locale, s).format(n));
    }
    return this.options.currencySign === "accounting" && $P.test(t) && (n = -1 * n), n;
  }
  sanitize(t) {
    return t = t.replace(this.symbols.literals, ""), this.symbols.minusSign && (t = t.replace("-", this.symbols.minusSign)), this.options.numberingSystem === "arab" && (this.symbols.decimal && (t = t.replace(",", this.symbols.decimal), t = t.replace("،", this.symbols.decimal)), this.symbols.group && (t = to(t, ".", this.symbols.group))), this.options.locale === "fr-FR" && this.symbols.group && (t = to(t, " ", this.symbols.group), t = to(t, /\u00A0/g, this.symbols.group)), t;
  }
  isValidPartialNumber(t, r = -1 / 0, n = 1 / 0) {
    return t = this.sanitize(t), this.symbols.minusSign && t.startsWith(this.symbols.minusSign) && r < 0 ? t = t.slice(this.symbols.minusSign.length) : this.symbols.plusSign && t.startsWith(this.symbols.plusSign) && n > 0 && (t = t.slice(this.symbols.plusSign.length)), this.symbols.group && t.startsWith(this.symbols.group) || this.symbols.decimal && t.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0 ? !1 : (this.symbols.group && (t = to(t, this.symbols.group, "")), t = t.replace(this.symbols.numeral, ""), this.symbols.decimal && (t = t.replace(this.symbols.decimal, "")), t.length === 0);
  }
  constructor(t, r = {}) {
    this.locale = t, this.formatter = new Intl.NumberFormat(t, r), this.options = this.formatter.resolvedOptions(), this.symbols = DP(t, this.formatter, this.options, r);
    var n, i;
    this.options.style === "percent" && (((n = this.options.minimumFractionDigits) !== null && n !== void 0 ? n : 0) > 18 || ((i = this.options.maximumFractionDigits) !== null && i !== void 0 ? i : 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
  }
}
const jh = /* @__PURE__ */ new Set([
  "decimal",
  "fraction",
  "integer",
  "minusSign",
  "plusSign",
  "group"
]), zP = [
  0,
  4,
  2,
  1,
  11,
  20,
  3,
  7,
  100,
  21,
  0.1,
  1.1
];
function DP(e, t, r, n) {
  var i, o, s, a;
  let l = new Intl.NumberFormat(e, {
    ...r,
    // Resets so we get the full range of symbols
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 21,
    roundingIncrement: 1,
    roundingPriority: "auto",
    roundingMode: "halfExpand"
  }), c = l.formatToParts(-10000.111), u = l.formatToParts(10000.111), f = zP.map((T) => l.formatToParts(T));
  var d;
  let p = (d = (i = c.find((T) => T.type === "minusSign")) === null || i === void 0 ? void 0 : i.value) !== null && d !== void 0 ? d : "-", g = (o = u.find((T) => T.type === "plusSign")) === null || o === void 0 ? void 0 : o.value;
  !g && ((n == null ? void 0 : n.signDisplay) === "exceptZero" || (n == null ? void 0 : n.signDisplay) === "always") && (g = "+");
  let m = (s = new Intl.NumberFormat(e, {
    ...r,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).formatToParts(1e-3).find((T) => T.type === "decimal")) === null || s === void 0 ? void 0 : s.value, v = (a = c.find((T) => T.type === "group")) === null || a === void 0 ? void 0 : a.value, y = c.filter((T) => !jh.has(T.type)).map((T) => Uh(T.value)), x = f.flatMap((T) => T.filter((G) => !jh.has(G.type)).map((G) => Uh(G.value))), S = [
    .../* @__PURE__ */ new Set([
      ...y,
      ...x
    ])
  ].sort((T, G) => G.length - T.length), _ = S.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${S.join("|")}|[\\p{White_Space}]`, "gu"), I = [
    ...new Intl.NumberFormat(r.locale, {
      useGrouping: !1
    }).format(9876543210)
  ].reverse(), O = new Map(I.map((T, G) => [
    T,
    G
  ])), w = new RegExp(`[${I.join("")}]`, "g");
  return {
    minusSign: p,
    plusSign: g,
    decimal: m,
    group: v,
    literals: _,
    numeral: w,
    index: (T) => String(O.get(T))
  };
}
function to(e, t, r) {
  return e.replaceAll ? e.replaceAll(t, r) : e.split(t).join(r);
}
function Uh(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var Ry = le("numberInput").parts(
  "root",
  "label",
  "input",
  "control",
  "valueText",
  "incrementTrigger",
  "decrementTrigger",
  "scrubber"
);
Ry.build();
var MP = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.input) != null ? r : `number-input:${e.id}:input`;
}, BP = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.incrementTrigger) != null ? r : `number-input:${e.id}:inc`;
}, WP = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.decrementTrigger) != null ? r : `number-input:${e.id}:dec`;
}, Ay = (e) => `number-input:${e.id}:cursor`, Cs = (e) => e.getById(MP(e)), HP = (e) => e.getById(BP(e)), jP = (e) => e.getById(WP(e)), Ny = (e) => e.getDoc().getElementById(Ay(e)), UP = (e, t) => {
  let r = null;
  return t === "increment" && (r = HP(e)), t === "decrement" && (r = jP(e)), r;
}, GP = (e, t) => {
  if (!yd())
    return YP(e, t), () => {
      var r;
      (r = Ny(e)) == null || r.remove();
    };
}, qP = (e) => {
  const t = e.getDoc(), r = t.documentElement, n = t.body;
  return n.style.pointerEvents = "none", r.style.userSelect = "none", r.style.cursor = "ew-resize", () => {
    n.style.pointerEvents = "", r.style.userSelect = "", r.style.cursor = "", r.style.length || r.removeAttribute("style"), n.style.length || n.removeAttribute("style");
  };
}, KP = (e, t) => {
  const { point: r, isRtl: n, event: i } = t, o = e.getWin(), s = Ul(i.movementX, o.devicePixelRatio), a = Ul(i.movementY, o.devicePixelRatio);
  let l = s > 0 ? "increment" : s < 0 ? "decrement" : null;
  n && l === "increment" && (l = "decrement"), n && l === "decrement" && (l = "increment");
  const c = { x: r.x + s, y: r.y + a }, u = o.innerWidth, f = Ul(7.5, o.devicePixelRatio);
  return c.x = aE(c.x + f, u) - f, { hint: l, point: c };
}, YP = (e, t) => {
  const r = e.getDoc(), n = r.createElement("div");
  n.className = "scrubber--cursor", n.id = Ay(e), Object.assign(n.style, {
    width: "15px",
    height: "15px",
    position: "fixed",
    pointerEvents: "none",
    left: "0px",
    top: "0px",
    zIndex: yb,
    transform: t ? `translate3d(${t.x}px, ${t.y}px, 0px)` : void 0,
    willChange: "transform"
  }), n.innerHTML = `
      <svg width="46" height="15" style="left: -15.5px; position: absolute; top: 0; filter: drop-shadow(rgba(0, 0, 0, 0.4) 0px 1px 1.1px);">
        <g transform="translate(2 3)">
          <path fill-rule="evenodd" d="M 15 4.5L 15 2L 11.5 5.5L 15 9L 15 6.5L 31 6.5L 31 9L 34.5 5.5L 31 2L 31 4.5Z" style="stroke-width: 2px; stroke: white;"></path>
          <path fill-rule="evenodd" d="M 15 4.5L 15 2L 11.5 5.5L 15 9L 15 6.5L 31 6.5L 31 9L 34.5 5.5L 31 2L 31 4.5Z"></path>
        </g>
      </svg>`, r.body.appendChild(n);
};
function XP(e) {
  if (!(!e || e.ownerDocument.activeElement !== e))
    try {
      const { selectionStart: t, selectionEnd: r, value: n } = e, i = n.substring(0, t), o = n.substring(r);
      return {
        start: t,
        end: r,
        value: n,
        beforeTxt: i,
        afterTxt: o
      };
    } catch (t) {
    }
}
function JP(e, t) {
  if (!(!e || e.ownerDocument.activeElement !== e)) {
    if (!t) {
      e.setSelectionRange(e.value.length, e.value.length);
      return;
    }
    try {
      const { value: r } = e, { beforeTxt: n = "", afterTxt: i = "", start: o } = t;
      let s = r.length;
      if (r.endsWith(i))
        s = r.length - i.length;
      else if (r.startsWith(n))
        s = n.length;
      else if (o != null) {
        const a = n[o - 1], l = r.indexOf(a, o - 1);
        l !== -1 && (s = l + 1);
      }
      e.setSelectionRange(s, s);
    } catch (r) {
    }
  }
}
var ZP = (e, t = {}) => new Intl.NumberFormat(e, t), QP = (e, t = {}) => new Ty(e, t), rc = (e, t) => {
  const { prop: r, computed: n } = t;
  return r("formatOptions") ? n("parser").parse(String(e)) : parseFloat(e);
}, wn = (e, t) => {
  const { prop: r, computed: n } = t;
  return Number.isNaN(e) ? "" : r("formatOptions") ? n("formatter").format(e) : e.toString();
}, eT = (e, t) => {
  let r = e !== void 0 && !Number.isNaN(e) ? e : 1;
  return (t == null ? void 0 : t.style) === "percent" && (e === void 0 || Number.isNaN(e)) && (r = 0.01), r;
}, { choose: tT, guards: rT, createMachine: nT } = VC(), { not: Gh, and: qh } = rT;
nT({
  props({ props: e }) {
    const t = eT(e.step, e.formatOptions);
    return {
      dir: "ltr",
      locale: "en-US",
      focusInputOnChange: !0,
      clampValueOnBlur: !e.allowOverflow,
      allowOverflow: !1,
      inputMode: "decimal",
      pattern: "[0-9]*(.[0-9]+)?",
      defaultValue: "",
      step: t,
      min: Number.MIN_SAFE_INTEGER,
      max: Number.MAX_SAFE_INTEGER,
      spinOnPress: !0,
      ...e,
      translations: {
        incrementLabel: "increment value",
        decrementLabel: "decrease value",
        ...e.translations
      }
    };
  },
  initialState() {
    return "idle";
  },
  context({ prop: e, bindable: t, getComputed: r }) {
    return {
      value: t(() => ({
        defaultValue: e("defaultValue"),
        value: e("value"),
        onChange(n) {
          var s;
          const i = r(), o = rc(n, { computed: i, prop: e });
          (s = e("onValueChange")) == null || s({ value: n, valueAsNumber: o });
        }
      })),
      hint: t(() => ({ defaultValue: null })),
      scrubberCursorPoint: t(() => ({
        defaultValue: null,
        hash(n) {
          return n ? `x:${n.x}, y:${n.y}` : "";
        }
      })),
      fieldsetDisabled: t(() => ({ defaultValue: !1 }))
    };
  },
  computed: {
    isRtl: ({ prop: e }) => e("dir") === "rtl",
    valueAsNumber: ({ context: e, computed: t, prop: r }) => rc(e.get("value"), { computed: t, prop: r }),
    formattedValue: ({ computed: e, prop: t }) => wn(e("valueAsNumber"), { computed: e, prop: t }),
    isAtMin: ({ computed: e, prop: t }) => cE(e("valueAsNumber"), t("min")),
    isAtMax: ({ computed: e, prop: t }) => lE(e("valueAsNumber"), t("max")),
    isOutOfRange: ({ computed: e, prop: t }) => !uE(e("valueAsNumber"), t("min"), t("max")),
    isValueEmpty: ({ context: e }) => e.get("value") === "",
    isDisabled: ({ prop: e, context: t }) => !!e("disabled") || t.get("fieldsetDisabled"),
    canIncrement: ({ prop: e, computed: t }) => e("allowOverflow") || !t("isAtMax"),
    canDecrement: ({ prop: e, computed: t }) => e("allowOverflow") || !t("isAtMin"),
    valueText: ({ prop: e, context: t }) => {
      var r, n;
      return (n = (r = e("translations")).valueText) == null ? void 0 : n.call(r, t.get("value"));
    },
    formatter: jc(
      ({ prop: e }) => [e("locale"), e("formatOptions")],
      (e, t) => ZP(e, t)
    ),
    parser: jc(
      ({ prop: e }) => [e("locale"), e("formatOptions")],
      (e, t) => QP(e, t)
    )
  },
  watch({ track: e, action: t, context: r, computed: n, prop: i }) {
    e([() => r.get("value"), () => i("locale")], () => {
      t(["syncInputElement"]);
    }), e([() => n("isOutOfRange")], () => {
      t(["invokeOnInvalid"]);
    }), e([() => r.hash("scrubberCursorPoint")], () => {
      t(["setVirtualCursorPosition"]);
    });
  },
  effects: ["trackFormControl"],
  on: {
    "VALUE.SET": {
      actions: ["setRawValue"]
    },
    "VALUE.CLEAR": {
      actions: ["clearValue"]
    },
    "VALUE.INCREMENT": {
      actions: ["increment"]
    },
    "VALUE.DECREMENT": {
      actions: ["decrement"]
    }
  },
  states: {
    idle: {
      on: {
        "TRIGGER.PRESS_DOWN": [
          { guard: "isTouchPointer", target: "before:spin", actions: ["setHint"] },
          {
            target: "before:spin",
            actions: ["focusInput", "invokeOnFocus", "setHint"]
          }
        ],
        "SCRUBBER.PRESS_DOWN": {
          target: "scrubbing",
          actions: ["focusInput", "invokeOnFocus", "setHint", "setCursorPoint"]
        },
        "INPUT.FOCUS": {
          target: "focused",
          actions: ["focusInput", "invokeOnFocus"]
        }
      }
    },
    focused: {
      tags: ["focus"],
      effects: ["attachWheelListener"],
      on: {
        "TRIGGER.PRESS_DOWN": [
          { guard: "isTouchPointer", target: "before:spin", actions: ["setHint"] },
          { target: "before:spin", actions: ["focusInput", "setHint"] }
        ],
        "SCRUBBER.PRESS_DOWN": {
          target: "scrubbing",
          actions: ["focusInput", "setHint", "setCursorPoint"]
        },
        "INPUT.ARROW_UP": {
          actions: ["increment"]
        },
        "INPUT.ARROW_DOWN": {
          actions: ["decrement"]
        },
        "INPUT.HOME": {
          actions: ["decrementToMin"]
        },
        "INPUT.END": {
          actions: ["incrementToMax"]
        },
        "INPUT.CHANGE": {
          actions: ["setValue", "setHint"]
        },
        "INPUT.BLUR": [
          {
            guard: qh("clampValueOnBlur", Gh("isInRange")),
            target: "idle",
            actions: ["setClampedValue", "clearHint", "invokeOnBlur"]
          },
          {
            guard: Gh("isInRange"),
            target: "idle",
            actions: ["setFormattedValue", "clearHint", "invokeOnBlur", "invokeOnInvalid"]
          },
          {
            target: "idle",
            actions: ["setFormattedValue", "clearHint", "invokeOnBlur"]
          }
        ],
        "INPUT.ENTER": {
          actions: ["setFormattedValue", "clearHint", "invokeOnBlur"]
        }
      }
    },
    "before:spin": {
      tags: ["focus"],
      effects: ["trackButtonDisabled", "waitForChangeDelay"],
      entry: tT([
        { guard: "isIncrementHint", actions: ["increment"] },
        { guard: "isDecrementHint", actions: ["decrement"] }
      ]),
      on: {
        CHANGE_DELAY: {
          target: "spinning",
          guard: qh("isInRange", "spinOnPress")
        },
        "TRIGGER.PRESS_UP": [
          { guard: "isTouchPointer", target: "focused", actions: ["clearHint"] },
          { target: "focused", actions: ["focusInput", "clearHint"] }
        ]
      }
    },
    spinning: {
      tags: ["focus"],
      effects: ["trackButtonDisabled", "spinValue"],
      on: {
        SPIN: [
          {
            guard: "isIncrementHint",
            actions: ["increment"]
          },
          {
            guard: "isDecrementHint",
            actions: ["decrement"]
          }
        ],
        "TRIGGER.PRESS_UP": {
          target: "focused",
          actions: ["focusInput", "clearHint"]
        }
      }
    },
    scrubbing: {
      tags: ["focus"],
      effects: ["activatePointerLock", "trackMousemove", "setupVirtualCursor", "preventTextSelection"],
      on: {
        "SCRUBBER.POINTER_UP": {
          target: "focused",
          actions: ["focusInput", "clearCursorPoint"]
        },
        "SCRUBBER.POINTER_MOVE": [
          {
            guard: "isIncrementHint",
            actions: ["increment", "setCursorPoint"]
          },
          {
            guard: "isDecrementHint",
            actions: ["decrement", "setCursorPoint"]
          }
        ]
      }
    }
  },
  implementations: {
    guards: {
      clampValueOnBlur: ({ prop: e }) => e("clampValueOnBlur"),
      spinOnPress: ({ prop: e }) => !!e("spinOnPress"),
      isInRange: ({ computed: e }) => !e("isOutOfRange"),
      isDecrementHint: ({ context: e, event: t }) => {
        var r;
        return ((r = t.hint) != null ? r : e.get("hint")) === "decrement";
      },
      isIncrementHint: ({ context: e, event: t }) => {
        var r;
        return ((r = t.hint) != null ? r : e.get("hint")) === "increment";
      },
      isTouchPointer: ({ event: e }) => e.pointerType === "touch"
    },
    effects: {
      waitForChangeDelay({ send: e }) {
        const t = setTimeout(() => {
          e({ type: "CHANGE_DELAY" });
        }, 300);
        return () => clearTimeout(t);
      },
      spinValue({ send: e }) {
        const t = setInterval(() => {
          e({ type: "SPIN" });
        }, 50);
        return () => clearInterval(t);
      },
      trackFormControl({ context: e, scope: t }) {
        const r = Cs(t);
        return xd(r, {
          onFieldsetDisabledChange(n) {
            e.set("fieldsetDisabled", n);
          },
          onFormReset() {
            e.set("value", e.initial("value"));
          }
        });
      },
      setupVirtualCursor({ context: e, scope: t }) {
        const r = e.get("scrubberCursorPoint");
        return GP(t, r);
      },
      preventTextSelection({ scope: e }) {
        return qP(e);
      },
      trackButtonDisabled({ context: e, scope: t, send: r }) {
        const n = e.get("hint"), i = UP(t, n);
        return ll(i, {
          attributes: ["disabled"],
          callback() {
            r({ type: "TRIGGER.PRESS_UP", src: "attr" });
          }
        });
      },
      attachWheelListener({ scope: e, send: t, prop: r }) {
        const n = Cs(e);
        if (!n || !e.isActiveElement(n) || !r("allowMouseWheel")) return;
        function i(o) {
          o.preventDefault();
          const s = Math.sign(o.deltaY) * -1;
          s === 1 ? t({ type: "VALUE.INCREMENT" }) : s === -1 && t({ type: "VALUE.DECREMENT" });
        }
        return Ae(n, "wheel", i, { passive: !1 });
      },
      activatePointerLock({ scope: e }) {
        if (!yd())
          return hC(e.getDoc());
      },
      trackMousemove({ scope: e, send: t, context: r, computed: n }) {
        const i = e.getDoc();
        function o(a) {
          const l = r.get("scrubberCursorPoint"), c = n("isRtl"), u = KP(e, { point: l, isRtl: c, event: a });
          u.hint && t({
            type: "SCRUBBER.POINTER_MOVE",
            hint: u.hint,
            point: u.point
          });
        }
        function s() {
          t({ type: "SCRUBBER.POINTER_UP" });
        }
        return ga(Ae(i, "mousemove", o, !1), Ae(i, "mouseup", s, !1));
      }
    },
    actions: {
      focusInput({ scope: e, prop: t }) {
        if (!t("focusInputOnChange")) return;
        const r = Cs(e);
        e.isActiveElement(r) || de(() => r == null ? void 0 : r.focus({ preventScroll: !0 }));
      },
      increment({ context: e, event: t, prop: r, computed: n }) {
        var o;
        let i = hE(n("valueAsNumber"), (o = t.step) != null ? o : r("step"));
        r("allowOverflow") || (i = Et(i, r("min"), r("max"))), e.set("value", wn(i, { computed: n, prop: r }));
      },
      decrement({ context: e, event: t, prop: r, computed: n }) {
        var o;
        let i = pE(n("valueAsNumber"), (o = t.step) != null ? o : r("step"));
        r("allowOverflow") || (i = Et(i, r("min"), r("max"))), e.set("value", wn(i, { computed: n, prop: r }));
      },
      setClampedValue({ context: e, prop: t, computed: r }) {
        const n = Et(r("valueAsNumber"), t("min"), t("max"));
        e.set("value", wn(n, { computed: r, prop: t }));
      },
      setRawValue({ context: e, event: t, prop: r, computed: n }) {
        let i = rc(t.value, { computed: n, prop: r });
        r("allowOverflow") || (i = Et(i, r("min"), r("max"))), e.set("value", wn(i, { computed: n, prop: r }));
      },
      setValue({ context: e, event: t }) {
        var n, i;
        const r = (i = (n = t.target) == null ? void 0 : n.value) != null ? i : t.value;
        e.set("value", r);
      },
      clearValue({ context: e }) {
        e.set("value", "");
      },
      incrementToMax({ context: e, prop: t, computed: r }) {
        const n = wn(t("max"), { computed: r, prop: t });
        e.set("value", n);
      },
      decrementToMin({ context: e, prop: t, computed: r }) {
        const n = wn(t("min"), { computed: r, prop: t });
        e.set("value", n);
      },
      setHint({ context: e, event: t }) {
        e.set("hint", t.hint);
      },
      clearHint({ context: e }) {
        e.set("hint", null);
      },
      invokeOnFocus({ computed: e, prop: t }) {
        var r;
        (r = t("onFocusChange")) == null || r({
          focused: !0,
          value: e("formattedValue"),
          valueAsNumber: e("valueAsNumber")
        });
      },
      invokeOnBlur({ computed: e, prop: t }) {
        var r;
        (r = t("onFocusChange")) == null || r({
          focused: !1,
          value: e("formattedValue"),
          valueAsNumber: e("valueAsNumber")
        });
      },
      invokeOnInvalid({ computed: e, prop: t, event: r }) {
        var i;
        if (r.type === "INPUT.CHANGE") return;
        const n = e("valueAsNumber") > t("max") ? "rangeOverflow" : "rangeUnderflow";
        (i = t("onValueInvalid")) == null || i({
          reason: n,
          value: e("formattedValue"),
          valueAsNumber: e("valueAsNumber")
        });
      },
      syncInputElement({ context: e, event: t, computed: r, scope: n }) {
        const i = t.type.endsWith("CHANGE") ? e.get("value") : r("formattedValue"), o = Cs(n), s = XP(o);
        de(() => {
          es(o, i), JP(o, s);
        });
      },
      setFormattedValue({ context: e, computed: t }) {
        e.set("value", t("formattedValue"));
      },
      setCursorPoint({ context: e, event: t }) {
        e.set("scrubberCursorPoint", t.point);
      },
      clearCursorPoint({ context: e }) {
        e.set("scrubberCursorPoint", null);
      },
      setVirtualCursorPosition({ context: e, scope: t }) {
        const r = Ny(t), n = e.get("scrubberCursorPoint");
        !r || !n || (r.style.transform = `translate3d(${n.x}px, ${n.y}px, 0px)`);
      }
    }
  }
});
ue()([
  "allowMouseWheel",
  "allowOverflow",
  "clampValueOnBlur",
  "dir",
  "disabled",
  "focusInputOnChange",
  "form",
  "formatOptions",
  "getRootNode",
  "id",
  "ids",
  "inputMode",
  "invalid",
  "locale",
  "max",
  "min",
  "name",
  "onFocusChange",
  "onValueChange",
  "onValueInvalid",
  "pattern",
  "required",
  "readOnly",
  "spinOnPress",
  "step",
  "translations",
  "value",
  "defaultValue"
]);
var Fy = le("pinInput").parts("root", "label", "input", "control");
Fy.build();
ue()([
  "autoFocus",
  "blurOnComplete",
  "count",
  "defaultValue",
  "dir",
  "disabled",
  "form",
  "getRootNode",
  "id",
  "ids",
  "invalid",
  "mask",
  "name",
  "onValueChange",
  "onValueComplete",
  "onValueInvalid",
  "otp",
  "pattern",
  "placeholder",
  "readOnly",
  "required",
  "selectOnFocus",
  "translations",
  "type",
  "value"
]);
const [$y, Or] = Bt({
  name: "PopoverContext",
  hookName: "usePopoverContext",
  providerName: "<PopoverProvider />"
}), Ly = Z((e, t) => {
  const r = Or(), n = oe(r.getAnchorProps(), e);
  return /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
Ly.displayName = "PopoverAnchor";
const Vy = Z((e, t) => {
  const r = Or(), n = oe(r.getArrowProps(), e);
  return /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
Vy.displayName = "PopoverArrow";
const zy = Z((e, t) => {
  const r = Or(), n = oe(r.getArrowTipProps(), e);
  return /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
zy.displayName = "PopoverArrowTip";
const Dy = Z((e, t) => {
  const r = Or(), n = oe(r.getCloseTriggerProps(), e);
  return /* @__PURE__ */ b(ae.button, { ...n, ref: t });
});
Dy.displayName = "PopoverCloseTrigger";
const My = Z((e, t) => {
  const r = Or(), n = Gn(), i = oe(r.getContentProps(), n.getPresenceProps(), e);
  return n.unmounted ? null : /* @__PURE__ */ b(ae.div, { ...i, ref: cl(n.ref, t) });
});
My.displayName = "PopoverContent";
const By = Z((e, t) => {
  const r = Or(), n = oe(r.getDescriptionProps(), e);
  return /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
By.displayName = "PopoverDescription";
const Wy = Z((e, t) => {
  const r = Or(), n = oe(r.getIndicatorProps(), e);
  return /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
Wy.displayName = "PopoverIndicator";
const Hy = Z((e, t) => {
  const r = Or(), n = Gn(), i = oe(r.getPositionerProps(), e);
  return n.unmounted ? null : /* @__PURE__ */ b(ae.div, { ...i, ref: t });
});
Hy.displayName = "PopoverPositioner";
var jy = le("popover").parts(
  "arrow",
  "arrowTip",
  "anchor",
  "trigger",
  "indicator",
  "positioner",
  "content",
  "title",
  "description",
  "closeTrigger"
), ur = jy.build(), Uy = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.anchor) != null ? r : `popover:${e.id}:anchor`;
}, Gy = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.trigger) != null ? r : `popover:${e.id}:trigger`;
}, ru = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.content) != null ? r : `popover:${e.id}:content`;
}, qy = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.positioner) != null ? r : `popover:${e.id}:popper`;
}, iT = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.arrow) != null ? r : `popover:${e.id}:arrow`;
}, nu = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.title) != null ? r : `popover:${e.id}:title`;
}, iu = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.description) != null ? r : `popover:${e.id}:desc`;
}, oT = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.closeTrigger) != null ? r : `popover:${e.id}:close`;
}, Kh = (e) => e.getById(Uy(e)), ti = (e) => e.getById(Gy(e)), ri = (e) => e.getById(ru(e)), Yh = (e) => e.getById(qy(e)), sT = (e) => e.getById(nu(e)), aT = (e) => e.getById(iu(e));
function lT(e, t) {
  const { state: r, context: n, send: i, computed: o, prop: s, scope: a } = e, l = r.matches("open"), c = n.get("currentPlacement"), u = o("currentPortalled"), f = n.get("renderedElements"), d = zd({
    ...s("positioning"),
    placement: c
  });
  return {
    portalled: u,
    open: l,
    setOpen(p) {
      r.matches("open") !== p && i({ type: p ? "OPEN" : "CLOSE" });
    },
    reposition(p = {}) {
      i({ type: "POSITIONING.SET", options: p });
    },
    getArrowProps() {
      return t.element({
        id: iT(a),
        ...ur.arrow.attrs,
        dir: s("dir"),
        style: d.arrow
      });
    },
    getArrowTipProps() {
      return t.element({
        ...ur.arrowTip.attrs,
        dir: s("dir"),
        style: d.arrowTip
      });
    },
    getAnchorProps() {
      return t.element({
        ...ur.anchor.attrs,
        dir: s("dir"),
        id: Uy(a)
      });
    },
    getTriggerProps() {
      return t.button({
        ...ur.trigger.attrs,
        dir: s("dir"),
        type: "button",
        "data-placement": c,
        id: Gy(a),
        "aria-haspopup": "dialog",
        "aria-expanded": l,
        "data-state": l ? "open" : "closed",
        "aria-controls": ru(a),
        onPointerDown(p) {
          yd() && p.currentTarget.focus();
        },
        onClick(p) {
          p.defaultPrevented || i({ type: "TOGGLE" });
        },
        onBlur(p) {
          i({ type: "TRIGGER_BLUR", target: p.relatedTarget });
        }
      });
    },
    getIndicatorProps() {
      return t.element({
        ...ur.indicator.attrs,
        dir: s("dir"),
        "data-state": l ? "open" : "closed"
      });
    },
    getPositionerProps() {
      return t.element({
        id: qy(a),
        ...ur.positioner.attrs,
        dir: s("dir"),
        style: d.floating
      });
    },
    getContentProps() {
      return t.element({
        ...ur.content.attrs,
        dir: s("dir"),
        id: ru(a),
        tabIndex: -1,
        role: "dialog",
        hidden: !l,
        "data-state": l ? "open" : "closed",
        "data-expanded": me(l),
        "aria-labelledby": f.title ? nu(a) : void 0,
        "aria-describedby": f.description ? iu(a) : void 0,
        "data-placement": c
      });
    },
    getTitleProps() {
      return t.element({
        ...ur.title.attrs,
        id: nu(a),
        dir: s("dir")
      });
    },
    getDescriptionProps() {
      return t.element({
        ...ur.description.attrs,
        id: iu(a),
        dir: s("dir")
      });
    },
    getCloseTriggerProps() {
      return t.button({
        ...ur.closeTrigger.attrs,
        dir: s("dir"),
        id: oT(a),
        type: "button",
        "aria-label": "close",
        onClick(p) {
          p.defaultPrevented || (p.stopPropagation(), i({ type: "CLOSE" }));
        }
      });
    }
  };
}
var cT = {
  props({ props: e }) {
    return {
      closeOnInteractOutside: !0,
      closeOnEscape: !0,
      autoFocus: !0,
      modal: !1,
      portalled: !0,
      ...e,
      positioning: {
        placement: "bottom",
        ...e.positioning
      }
    };
  },
  initialState({ prop: e }) {
    return e("open") || e("defaultOpen") ? "open" : "closed";
  },
  context({ bindable: e }) {
    return {
      currentPlacement: e(() => ({
        defaultValue: void 0
      })),
      renderedElements: e(() => ({
        defaultValue: { title: !0, description: !0 }
      }))
    };
  },
  computed: {
    currentPortalled: ({ prop: e }) => !!e("modal") || !!e("portalled")
  },
  watch({ track: e, prop: t, action: r }) {
    e([() => t("open")], () => {
      r(["toggleVisibility"]);
    });
  },
  entry: ["checkRenderedElements"],
  states: {
    closed: {
      on: {
        "CONTROLLED.OPEN": {
          target: "open",
          actions: ["setInitialFocus"]
        },
        TOGGLE: [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnOpen"]
          },
          {
            target: "open",
            actions: ["invokeOnOpen", "setInitialFocus"]
          }
        ],
        OPEN: [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnOpen"]
          },
          {
            target: "open",
            actions: ["invokeOnOpen", "setInitialFocus"]
          }
        ]
      }
    },
    open: {
      effects: [
        "trapFocus",
        "preventScroll",
        "hideContentBelow",
        "trackPositioning",
        "trackDismissableElement",
        "proxyTabFocus"
      ],
      on: {
        "CONTROLLED.CLOSE": {
          target: "closed",
          actions: ["setFinalFocus"]
        },
        CLOSE: [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnClose"]
          },
          {
            target: "closed",
            actions: ["invokeOnClose", "setFinalFocus"]
          }
        ],
        TOGGLE: [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnClose"]
          },
          {
            target: "closed",
            actions: ["invokeOnClose"]
          }
        ],
        "POSITIONING.SET": {
          actions: ["reposition"]
        }
      }
    }
  },
  implementations: {
    guards: {
      isOpenControlled: ({ prop: e }) => e("open") != null
    },
    effects: {
      trackPositioning({ context: e, prop: t, scope: r }) {
        var o;
        e.set("currentPlacement", t("positioning").placement);
        const n = (o = Kh(r)) != null ? o : ti(r);
        return Mt(n, () => Yh(r), {
          ...t("positioning"),
          defer: !0,
          onComplete(s) {
            e.set("currentPlacement", s.placement);
          }
        });
      },
      trackDismissableElement({ send: e, prop: t, scope: r }) {
        const n = () => ri(r);
        let i = !0;
        return Di(n, {
          pointerBlocking: t("modal"),
          exclude: ti(r),
          defer: !0,
          onEscapeKeyDown(o) {
            var s;
            (s = t("onEscapeKeyDown")) == null || s(o), !t("closeOnEscape") && o.preventDefault();
          },
          onInteractOutside(o) {
            var s;
            (s = t("onInteractOutside")) == null || s(o), !o.defaultPrevented && (i = !(o.detail.focusable || o.detail.contextmenu), t("closeOnInteractOutside") || o.preventDefault());
          },
          onPointerDownOutside: t("onPointerDownOutside"),
          onFocusOutside: t("onFocusOutside"),
          persistentElements: t("persistentElements"),
          onDismiss() {
            e({ type: "CLOSE", src: "interact-outside", restoreFocus: i });
          }
        });
      },
      proxyTabFocus({ prop: e, scope: t }) {
        return e("modal") || !e("portalled") ? void 0 : bC(() => ri(t), {
          triggerElement: ti(t),
          defer: !0,
          onFocus(n) {
            n.focus({ preventScroll: !0 });
          }
        });
      },
      hideContentBelow({ prop: e, scope: t }) {
        return e("modal") ? gy(() => [ri(t), ti(t)], { defer: !0 }) : void 0;
      },
      preventScroll({ prop: e, scope: t }) {
        if (e("modal"))
          return ZO(t.getDoc());
      },
      trapFocus({ prop: e, scope: t }) {
        return e("modal") ? XO(() => ri(t), {
          initialFocus: () => Mo({
            root: ri(t),
            getInitialEl: e("initialFocusEl"),
            enabled: e("autoFocus")
          })
        }) : void 0;
      }
    },
    actions: {
      reposition({ event: e, prop: t, scope: r, context: n }) {
        var s;
        const i = (s = Kh(r)) != null ? s : ti(r);
        Mt(i, () => Yh(r), {
          ...t("positioning"),
          ...e.options,
          defer: !0,
          listeners: !1,
          onComplete(a) {
            n.set("currentPlacement", a.placement);
          }
        });
      },
      checkRenderedElements({ context: e, scope: t }) {
        de(() => {
          Object.assign(e.get("renderedElements"), {
            title: !!sT(t),
            description: !!aT(t)
          });
        });
      },
      setInitialFocus({ prop: e, scope: t }) {
        e("modal") || de(() => {
          const r = Mo({
            root: ri(t),
            getInitialEl: e("initialFocusEl"),
            enabled: e("autoFocus")
          });
          r == null || r.focus({ preventScroll: !0 });
        });
      },
      setFinalFocus({ event: e, scope: t }) {
        var n, i;
        const r = (i = e.restoreFocus) != null ? i : (n = e.previousEvent) == null ? void 0 : n.restoreFocus;
        r != null && !r || de(() => {
          const o = ti(t);
          o == null || o.focus({ preventScroll: !0 });
        });
      },
      invokeOnOpen({ prop: e }) {
        var t;
        (t = e("onOpenChange")) == null || t({ open: !0 });
      },
      invokeOnClose({ prop: e }) {
        var t;
        (t = e("onOpenChange")) == null || t({ open: !1 });
      },
      toggleVisibility({ event: e, send: t, prop: r }) {
        t({ type: r("open") ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE", previousEvent: e });
      }
    }
  }
};
ue()([
  "autoFocus",
  "closeOnEscape",
  "closeOnInteractOutside",
  "dir",
  "getRootNode",
  "id",
  "ids",
  "initialFocusEl",
  "modal",
  "onEscapeKeyDown",
  "onFocusOutside",
  "onInteractOutside",
  "onOpenChange",
  "onPointerDownOutside",
  "defaultOpen",
  "open",
  "persistentElements",
  "portalled",
  "positioning"
]);
const uT = (e) => {
  const t = Hn(), { getRootNode: r } = bn(), { dir: n } = rs(), i = {
    id: t,
    dir: n,
    getRootNode: r,
    ...e
  }, o = yn(cT, i);
  return lT(o, Un);
}, dT = (e) => {
  const [t, { children: r, ...n }] = Ni(e), i = uT(n), o = Fi(oe({ present: i.open }, t));
  return /* @__PURE__ */ b($y, { value: i, children: /* @__PURE__ */ b($i, { value: o, children: r }) });
}, fT = (e) => {
  const [t, { value: r, children: n }] = Ni(e), i = Fi(oe({ present: r.open }, t));
  return /* @__PURE__ */ b($y, { value: r, children: /* @__PURE__ */ b($i, { value: i, children: n }) });
}, Ky = Z((e, t) => {
  const r = Or(), n = oe(r.getTitleProps(), e);
  return /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
Ky.displayName = "PopoverTitle";
const Yy = Z((e, t) => {
  const r = Or(), n = Gn(), i = oe(
    {
      ...r.getTriggerProps(),
      "aria-controls": n.unmounted ? void 0 : r.getTriggerProps()["aria-controls"]
    },
    e
  );
  return /* @__PURE__ */ b(ae.button, { ...i, ref: t });
});
Yy.displayName = "PopoverTrigger";
const gl = (e) => {
  var l;
  const { children: t, disabled: r } = e, [n, i] = We((l = e.container) == null ? void 0 : l.current), o = Qw(
    pT,
    () => !1,
    () => !0
  ), { getRootNode: s } = bn();
  if (Ce(() => {
    i(() => {
      var c;
      return (c = e.container) == null ? void 0 : c.current;
    });
  }, [e.container]), o || r) return /* @__PURE__ */ b(wi, { children: t });
  const a = n != null ? n : hT(s);
  return /* @__PURE__ */ b(wi, { children: Ya.map(t, (c) => lS(c, a)) });
}, hT = (e) => {
  const t = e == null ? void 0 : e(), r = t.getRootNode();
  return Ei(r) ? r : Wt(t).body;
}, pT = () => () => {
}, [Xy, ss] = Bt({
  name: "ProgressContext",
  hookName: "useProgressContext",
  providerName: "<ProgressProvider />"
}), Jy = Z((e, t) => {
  const r = ss(), n = oe(r.getCircleProps(), e);
  return /* @__PURE__ */ b(ae.svg, { ref: t, ...n });
});
Jy.displayName = "ProgressCircle";
const Zy = Z((e, t) => {
  const r = ss(), n = oe(r.getCircleRangeProps(), e);
  return /* @__PURE__ */ b(ae.circle, { ref: t, ...n });
});
Zy.displayName = "ProgressCircleRange";
const Qy = Z((e, t) => {
  const r = ss(), n = oe(r.getCircleTrackProps(), e);
  return /* @__PURE__ */ b(ae.circle, { ref: t, ...n });
});
Qy.displayName = "ProgressCircleTrack";
const e0 = Z((e, t) => {
  const r = ss(), n = oe(r.getLabelProps(), e);
  return /* @__PURE__ */ b(ae.label, { ...n, ref: t });
});
e0.displayName = "ProgressLabel";
var Hd = le("progress").parts(
  "root",
  "label",
  "track",
  "range",
  "valueText",
  "view",
  "circle",
  "circleTrack",
  "circleRange"
), Rr = Hd.build(), gT = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.root) != null ? r : `progress-${e.id}`;
}, mT = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.track) != null ? r : `progress-${e.id}-track`;
}, vT = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.label) != null ? r : `progress-${e.id}-label`;
}, bT = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.circle) != null ? r : `progress-${e.id}-circle`;
};
function yT(e, t) {
  var x;
  const { context: r, computed: n, prop: i, send: o, scope: s } = e, a = n("percent"), l = n("isIndeterminate") ? "" : n("formatter").format(n("percent") / 100), c = i("max"), u = i("min"), f = i("orientation"), d = i("translations"), p = n("isIndeterminate"), g = r.get("value"), h = (x = d == null ? void 0 : d.value({ value: g, max: c, percent: a, min: u })) != null ? x : "", m = xT(g, c), v = {
    role: "progressbar",
    "aria-label": h,
    "data-max": c,
    "aria-valuemin": u,
    "aria-valuemax": c,
    "aria-valuenow": g != null ? g : void 0,
    "data-orientation": f,
    "data-state": m
  }, y = wT(e);
  return {
    value: g,
    valueAsString: h,
    min: u,
    max: c,
    percent: a,
    percentAsString: l,
    indeterminate: p,
    setValue(S) {
      o({ type: "VALUE.SET", value: S });
    },
    setToMax() {
      o({ type: "VALUE.SET", value: c });
    },
    setToMin() {
      o({ type: "VALUE.SET", value: u });
    },
    getRootProps() {
      return t.element({
        dir: i("dir"),
        ...Rr.root.attrs,
        id: gT(s),
        "data-max": c,
        "data-value": g != null ? g : void 0,
        "data-state": m,
        "data-orientation": f,
        style: {
          "--percent": p ? void 0 : a
        }
      });
    },
    getLabelProps() {
      return t.element({
        dir: i("dir"),
        id: vT(s),
        ...Rr.label.attrs,
        "data-orientation": f
      });
    },
    getValueTextProps() {
      return t.element({
        dir: i("dir"),
        "aria-live": "polite",
        ...Rr.valueText.attrs
      });
    },
    getTrackProps() {
      return t.element({
        dir: i("dir"),
        id: mT(s),
        ...Rr.track.attrs,
        ...v
      });
    },
    getRangeProps() {
      return t.element({
        dir: i("dir"),
        ...Rr.range.attrs,
        "data-orientation": f,
        "data-state": m,
        style: {
          [n("isHorizontal") ? "width" : "height"]: p ? void 0 : `${a}%`
        }
      });
    },
    getCircleProps() {
      return t.element({
        dir: i("dir"),
        id: bT(s),
        ...Rr.circle.attrs,
        ...v,
        ...y.root
      });
    },
    getCircleTrackProps() {
      return t.element({
        dir: i("dir"),
        "data-orientation": f,
        ...Rr.circleTrack.attrs,
        ...y.track
      });
    },
    getCircleRangeProps() {
      return t.element({
        dir: i("dir"),
        ...Rr.circleRange.attrs,
        ...y.range,
        "data-state": m
      });
    },
    getViewProps(S) {
      return t.element({
        dir: i("dir"),
        ...Rr.view.attrs,
        "data-state": S.state,
        hidden: S.state !== m
      });
    }
  };
}
function xT(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
var Xh = {
  style: {
    "--radius": "calc(var(--size) / 2 - var(--thickness) / 2)",
    cx: "calc(var(--size) / 2)",
    cy: "calc(var(--size) / 2)",
    r: "var(--radius)",
    fill: "transparent",
    strokeWidth: "var(--thickness)"
  }
}, _T = {
  style: {
    width: "var(--size)",
    height: "var(--size)"
  }
};
function wT(e) {
  const { context: t, computed: r } = e;
  return {
    root: _T,
    track: Xh,
    range: {
      opacity: t.get("value") === 0 ? 0 : void 0,
      style: {
        ...Xh.style,
        "--percent": r("percent"),
        "--circumference": "calc(2 * 3.14159 * var(--radius))",
        "--offset": "calc(var(--circumference) * (100 - var(--percent)) / 100)",
        strokeDashoffset: "calc(var(--circumference) * ((100 - var(--percent)) / 100))",
        strokeDasharray: r("isIndeterminate") ? void 0 : "var(--circumference)",
        transformOrigin: "center",
        transform: "rotate(-90deg)"
      }
    }
  };
}
var ST = {
  props({ props: e }) {
    var n, i, o;
    const t = (n = e.min) != null ? n : 0, r = (i = e.max) != null ? i : 100;
    return {
      ...e,
      max: r,
      min: t,
      defaultValue: (o = e.defaultValue) != null ? o : kT(t, r),
      orientation: "horizontal",
      formatOptions: {
        style: "percent",
        ...e.formatOptions
      },
      translations: {
        value: ({ percent: s }) => s === -1 ? "loading..." : `${s} percent`,
        ...e.translations
      }
    };
  },
  initialState() {
    return "idle";
  },
  entry: ["validateContext"],
  context({ bindable: e, prop: t }) {
    return {
      value: e(() => ({
        defaultValue: t("defaultValue"),
        value: t("value"),
        onChange(r) {
          var n;
          (n = t("onValueChange")) == null || n({ value: r });
        }
      }))
    };
  },
  computed: {
    isIndeterminate: ({ context: e }) => e.get("value") === null,
    percent({ context: e, prop: t }) {
      const r = e.get("value");
      return db(r) ? gb(r, t("min"), t("max")) * 100 : -1;
    },
    formatter: jc(
      ({ prop: e }) => [e("locale"), e("formatOptions")],
      (e, t) => new Intl.NumberFormat(e, t)
    ),
    isHorizontal: ({ prop: e }) => e("orientation") === "horizontal"
  },
  states: {
    idle: {
      on: {
        "VALUE.SET": {
          actions: ["setValue"]
        }
      }
    }
  },
  implementations: {
    actions: {
      setValue: ({ context: e, event: t, prop: r }) => {
        const n = t.value === null ? null : Math.max(0, Math.min(t.value, r("max")));
        e.set("value", n);
      },
      validateContext: ({ context: e, prop: t }) => {
        const r = t("max"), n = t("min"), i = e.get("value");
        if (i != null) {
          if (!jd(r))
            throw new Error(`[progress] The max value passed \`${r}\` is not a valid number`);
          if (!ET(i, r))
            throw new Error(`[progress] The value passed \`${i}\` exceeds the max value \`${r}\``);
          if (!CT(i, n))
            throw new Error(`[progress] The value passed \`${i}\` exceeds the min value \`${n}\``);
        }
      }
    }
  }
}, jd = (e) => db(e) && !isNaN(e), ET = (e, t) => jd(e) && e <= t, CT = (e, t) => jd(e) && e >= t, kT = (e, t) => e + (t - e) / 2;
ue()([
  "dir",
  "getRootNode",
  "id",
  "ids",
  "max",
  "min",
  "orientation",
  "translations",
  "value",
  "onValueChange",
  "defaultValue",
  "formatOptions",
  "locale"
]);
const IT = (e) => {
  const t = Hn(), { getRootNode: r } = bn(), { dir: n, locale: i } = rs(), o = {
    id: t,
    dir: n,
    locale: i,
    getRootNode: r,
    ...e
  }, s = yn(ST, o);
  return yT(s, Un);
}, t0 = Z((e, t) => {
  const [r, n] = Xr()(e, [
    "defaultValue",
    "formatOptions",
    "id",
    "ids",
    "locale",
    "max",
    "min",
    "onValueChange",
    "orientation",
    "translations",
    "value"
  ]), i = IT(r), o = oe(i.getRootProps(), n);
  return /* @__PURE__ */ b(Xy, { value: i, children: /* @__PURE__ */ b(ae.div, { ...o, ref: t }) });
});
t0.displayName = "ProgressRoot";
const r0 = Z((e, t) => {
  const [{ value: r }, n] = Xr()(e, ["value"]), i = oe(r.getRootProps(), n);
  return /* @__PURE__ */ b(Xy, { value: r, children: /* @__PURE__ */ b(ae.div, { ...i, ref: t }) });
});
r0.displayName = "ProgressRootProvider";
const n0 = Z((e, t) => {
  const { children: r, ...n } = e, i = ss(), o = oe(i.getValueTextProps(), n);
  return /* @__PURE__ */ b(ae.span, { ...o, ref: t, children: r || i.percentAsString });
});
n0.displayName = "ProgressValueText";
var i0 = le("qr-code").parts("root", "frame", "pattern", "overlay", "downloadTrigger");
i0.build();
ue()([
  "ids",
  "defaultValue",
  "value",
  "id",
  "encoding",
  "dir",
  "getRootNode",
  "onValueChange",
  "pixelSize"
]);
var Ud = le("radio-group").parts(
  "root",
  "label",
  "item",
  "itemText",
  "itemControl",
  "indicator"
);
Ud.build();
ue()([
  "dir",
  "disabled",
  "form",
  "getRootNode",
  "id",
  "ids",
  "name",
  "onValueChange",
  "orientation",
  "readOnly",
  "value",
  "defaultValue"
]);
ue()(["value", "disabled", "invalid"]);
var o0 = le("rating-group").parts("root", "label", "item", "control");
o0.build();
ue()([
  "allowHalf",
  "autoFocus",
  "count",
  "dir",
  "disabled",
  "form",
  "getRootNode",
  "id",
  "ids",
  "name",
  "onHoverChange",
  "onValueChange",
  "required",
  "readOnly",
  "translations",
  "value",
  "defaultValue"
]);
ue()(["index"]);
const s0 = Ud.rename("segment-group");
s0.build();
const [a0, xt] = Bt({
  name: "SelectContext",
  hookName: "useSelectContext",
  providerName: "<SelectProvider />"
}), l0 = Z((e, t) => {
  const r = xt(), n = oe(r.getClearTriggerProps(), e);
  return /* @__PURE__ */ b(ae.button, { ...n, ref: t });
});
l0.displayName = "SelectClearTrigger";
const c0 = Z((e, t) => {
  const r = xt(), n = Gn(), i = oe(r.getContentProps(), n.getPresenceProps(), e);
  return n.unmounted ? null : /* @__PURE__ */ b(ae.div, { ...i, ref: cl(n.ref, t) });
});
c0.displayName = "SelectContent";
const OT = (e) => e.children(xt()), u0 = Z((e, t) => {
  const r = xt(), n = oe(r.getControlProps(), e);
  return /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
u0.displayName = "SelectControl";
const d0 = Z((e, t) => {
  const r = xt(), n = oe(r.getHiddenSelectProps(), e), i = r.value.length === 0, o = Dd();
  return /* @__PURE__ */ K(ae.select, { "aria-describedby": o == null ? void 0 : o.ariaDescribedby, ...n, ref: t, children: [
    i && /* @__PURE__ */ b("option", { value: "" }),
    r.collection.items.map((s, a) => {
      var l;
      return /* @__PURE__ */ b(
        "option",
        {
          value: (l = r.collection.getItemValue(s)) != null ? l : "",
          disabled: r.collection.getItemDisabled(s),
          children: r.collection.stringifyItem(s)
        },
        a
      );
    })
  ] });
});
d0.displayName = "SelectHiddenSelect";
const f0 = Z((e, t) => {
  const r = xt(), n = oe(r.getIndicatorProps(), e);
  return /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
f0.displayName = "SelectIndicator";
const [PT, k3] = Bt({
  name: "SelectItemContext",
  hookName: "useSelectItemContext",
  providerName: "<SelectItemProvider />"
}), [TT, h0] = Bt({
  name: "SelectItemPropsContext",
  hookName: "useSelectItemPropsContext",
  providerName: "<SelectItemPropsProvider />"
}), p0 = Z((e, t) => {
  const [r, n] = Xr()(e, ["item", "persistFocus"]), i = xt(), o = oe(i.getItemProps(r), n), s = i.getItemState(r);
  return /* @__PURE__ */ b(TT, { value: r, children: /* @__PURE__ */ b(PT, { value: s, children: /* @__PURE__ */ b(ae.div, { ...o, ref: t }) }) });
});
p0.displayName = "SelectItem";
const [RT, AT] = Bt({
  name: "SelectItemGroupPropsContext",
  hookName: "useSelectItemGroupPropsContext",
  providerName: "<SelectItemGroupPropsProvider />"
}), g0 = Z((e, t) => {
  const r = Hn(), [n, i] = Xr()(e, ["id"]), o = { id: r, ...n }, s = xt(), a = oe(s.getItemGroupProps(o), i);
  return /* @__PURE__ */ b(RT, { value: o, children: /* @__PURE__ */ b(ae.div, { ...a, ref: t }) });
});
g0.displayName = "SelectItemGroup";
const m0 = Z((e, t) => {
  const r = xt(), n = AT(), i = oe(r.getItemGroupLabelProps({ htmlFor: n.id }), e);
  return /* @__PURE__ */ b(ae.div, { ...i, ref: t });
});
m0.displayName = "SelectItemGroupLabel";
const v0 = Z((e, t) => {
  const r = xt(), n = h0(), i = oe(r.getItemIndicatorProps(n), e);
  return /* @__PURE__ */ b(ae.div, { ...i, ref: t });
});
v0.displayName = "SelectItemIndicator";
const b0 = Z((e, t) => {
  const r = xt(), n = h0(), i = oe(r.getItemTextProps(n), e);
  return /* @__PURE__ */ b(ae.span, { ...i, ref: t });
});
b0.displayName = "SelectItemText";
const y0 = Z((e, t) => {
  const r = xt(), n = oe(r.getLabelProps(), e);
  return /* @__PURE__ */ b(ae.label, { ...n, ref: t });
});
y0.displayName = "SelectLabel";
const x0 = Z((e, t) => {
  const r = xt(), n = oe(r.getPositionerProps(), e);
  return Gn().unmounted ? null : /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
x0.displayName = "SelectPositioner";
var _0 = le("select").parts(
  "label",
  "positioner",
  "trigger",
  "indicator",
  "clearTrigger",
  "item",
  "itemText",
  "itemIndicator",
  "itemGroup",
  "itemGroupLabel",
  "list",
  "content",
  "root",
  "control",
  "valueText"
), bt = _0.build(), w0 = (e) => new is(e);
w0.empty = () => new is({ items: [] });
var NT = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.root) != null ? r : `select:${e.id}`;
}, ou = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.content) != null ? r : `select:${e.id}:content`;
}, su = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.trigger) != null ? r : `select:${e.id}:trigger`;
}, S0 = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.clearTrigger) != null ? r : `select:${e.id}:clear-trigger`;
}, ks = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.label) != null ? r : `select:${e.id}:label`;
}, FT = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.control) != null ? r : `select:${e.id}:control`;
}, au = (e, t) => {
  var r, n, i;
  return (i = (n = (r = e.ids) == null ? void 0 : r.item) == null ? void 0 : n.call(r, t)) != null ? i : `select:${e.id}:option:${t}`;
}, lu = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.hiddenSelect) != null ? r : `select:${e.id}:select`;
}, E0 = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.positioner) != null ? r : `select:${e.id}:positioner`;
}, $T = (e, t) => {
  var r, n, i;
  return (i = (n = (r = e.ids) == null ? void 0 : r.itemGroup) == null ? void 0 : n.call(r, t)) != null ? i : `select:${e.id}:optgroup:${t}`;
}, Jh = (e, t) => {
  var r, n, i;
  return (i = (n = (r = e.ids) == null ? void 0 : r.itemGroupLabel) == null ? void 0 : n.call(r, t)) != null ? i : `select:${e.id}:optgroup-label:${t}`;
}, nc = (e) => e.getById(lu(e)), ro = (e) => e.getById(ou(e)), Nn = (e) => e.getById(su(e)), LT = (e) => e.getById(S0(e)), Zh = (e) => e.getById(E0(e)), VT = (e, t) => e.getById(au(e, t));
function zT(e, t) {
  const { context: r, prop: n, scope: i, state: o, computed: s, send: a } = e, l = n("disabled") || r.get("fieldsetDisabled"), c = n("invalid"), u = n("readOnly"), f = n("composite"), d = n("collection"), p = o.hasTag("open"), g = o.matches("focused"), h = r.get("highlightedValue"), m = r.get("highlightedItem"), v = r.get("selectedItems"), y = r.get("currentPlacement"), x = s("isTypingAhead"), S = s("isInteractive"), _ = h ? au(i, h) : void 0;
  function I(w) {
    const E = d.getItemDisabled(w.item), T = d.getItemValue(w.item);
    return vb(T, () => `[zag-js] No value found for item ${JSON.stringify(w.item)}`), {
      value: T,
      disabled: !!(l || E),
      highlighted: h === T,
      selected: r.get("value").includes(T)
    };
  }
  const O = zd({
    ...n("positioning"),
    placement: y
  });
  return {
    open: p,
    focused: g,
    empty: r.get("value").length === 0,
    highlightedItem: m,
    highlightedValue: h,
    selectedItems: v,
    hasSelectedItems: s("hasSelectedItems"),
    value: r.get("value"),
    valueAsString: r.get("valueAsString"),
    collection: d,
    multiple: !!n("multiple"),
    disabled: !!l,
    reposition(w = {}) {
      a({ type: "POSITIONING.SET", options: w });
    },
    focus() {
      var w;
      (w = Nn(i)) == null || w.focus({ preventScroll: !0 });
    },
    setOpen(w) {
      o.hasTag("open") !== w && a({ type: w ? "OPEN" : "CLOSE" });
    },
    selectValue(w) {
      a({ type: "ITEM.SELECT", value: w });
    },
    setValue(w) {
      a({ type: "VALUE.SET", value: w });
    },
    selectAll() {
      a({ type: "VALUE.SET", value: d.getValues() });
    },
    highlightValue(w) {
      a({ type: "HIGHLIGHTED_VALUE.SET", value: w });
    },
    clearValue(w) {
      a(w ? { type: "ITEM.CLEAR", value: w } : { type: "VALUE.CLEAR" });
    },
    getItemState: I,
    getRootProps() {
      return t.element({
        ...bt.root.attrs,
        dir: n("dir"),
        id: NT(i),
        "data-invalid": me(c),
        "data-readonly": me(u)
      });
    },
    getLabelProps() {
      return t.label({
        dir: n("dir"),
        id: ks(i),
        ...bt.label.attrs,
        "data-disabled": me(l),
        "data-invalid": me(c),
        "data-readonly": me(u),
        htmlFor: lu(i),
        onClick(w) {
          var E;
          w.defaultPrevented || l || (E = Nn(i)) == null || E.focus({ preventScroll: !0 });
        }
      });
    },
    getControlProps() {
      return t.element({
        ...bt.control.attrs,
        dir: n("dir"),
        id: FT(i),
        "data-state": p ? "open" : "closed",
        "data-focus": me(g),
        "data-disabled": me(l),
        "data-invalid": me(c)
      });
    },
    getValueTextProps() {
      return t.element({
        ...bt.valueText.attrs,
        dir: n("dir"),
        "data-disabled": me(l),
        "data-invalid": me(c),
        "data-focus": me(g)
      });
    },
    getTriggerProps() {
      return t.button({
        id: su(i),
        disabled: l,
        dir: n("dir"),
        type: "button",
        role: "combobox",
        "aria-controls": ou(i),
        "aria-expanded": p,
        "aria-haspopup": "listbox",
        "data-state": p ? "open" : "closed",
        "aria-invalid": c,
        "aria-labelledby": ks(i),
        ...bt.trigger.attrs,
        "data-disabled": me(l),
        "data-invalid": me(c),
        "data-readonly": me(u),
        "data-placement": y,
        "data-placeholder-shown": me(!s("hasSelectedItems")),
        onClick(w) {
          S && (w.defaultPrevented || a({ type: "TRIGGER.CLICK" }));
        },
        onFocus() {
          a({ type: "TRIGGER.FOCUS" });
        },
        onBlur() {
          a({ type: "TRIGGER.BLUR" });
        },
        onKeyDown(w) {
          if (w.defaultPrevented || !S) return;
          const T = {
            ArrowUp() {
              a({ type: "TRIGGER.ARROW_UP" });
            },
            ArrowDown(G) {
              a({ type: G.altKey ? "OPEN" : "TRIGGER.ARROW_DOWN" });
            },
            ArrowLeft() {
              a({ type: "TRIGGER.ARROW_LEFT" });
            },
            ArrowRight() {
              a({ type: "TRIGGER.ARROW_RIGHT" });
            },
            Home() {
              a({ type: "TRIGGER.HOME" });
            },
            End() {
              a({ type: "TRIGGER.END" });
            },
            Enter() {
              a({ type: "TRIGGER.ENTER" });
            },
            Space(G) {
              a(x ? { type: "TRIGGER.TYPEAHEAD", key: G.key } : { type: "TRIGGER.ENTER" });
            }
          }[sh(w, {
            dir: n("dir"),
            orientation: "vertical"
          })];
          if (T) {
            T(w), w.preventDefault();
            return;
          }
          Bo.isValidEvent(w) && (a({ type: "TRIGGER.TYPEAHEAD", key: w.key }), w.preventDefault());
        }
      });
    },
    getIndicatorProps() {
      return t.element({
        ...bt.indicator.attrs,
        dir: n("dir"),
        "aria-hidden": !0,
        "data-state": p ? "open" : "closed",
        "data-disabled": me(l),
        "data-invalid": me(c),
        "data-readonly": me(u)
      });
    },
    getItemProps(w) {
      const E = I(w);
      return t.element({
        id: au(i, E.value),
        role: "option",
        ...bt.item.attrs,
        dir: n("dir"),
        "data-value": E.value,
        "aria-selected": E.selected,
        "data-state": E.selected ? "checked" : "unchecked",
        "data-highlighted": me(E.highlighted),
        "data-disabled": me(E.disabled),
        "aria-disabled": _E(E.disabled),
        onPointerMove(T) {
          E.disabled || T.pointerType !== "mouse" || E.value !== h && a({ type: "ITEM.POINTER_MOVE", value: E.value });
        },
        onClick(T) {
          T.defaultPrevented || E.disabled || a({ type: "ITEM.CLICK", src: "pointerup", value: E.value });
        },
        onPointerLeave(T) {
          var k;
          E.disabled || w.persistFocus || T.pointerType !== "mouse" || !((k = e.event.previous()) != null && k.type.includes("POINTER")) || a({ type: "ITEM.POINTER_LEAVE" });
        }
      });
    },
    getItemTextProps(w) {
      const E = I(w);
      return t.element({
        ...bt.itemText.attrs,
        "data-state": E.selected ? "checked" : "unchecked",
        "data-disabled": me(E.disabled),
        "data-highlighted": me(E.highlighted)
      });
    },
    getItemIndicatorProps(w) {
      const E = I(w);
      return t.element({
        "aria-hidden": !0,
        ...bt.itemIndicator.attrs,
        "data-state": E.selected ? "checked" : "unchecked",
        hidden: !E.selected
      });
    },
    getItemGroupLabelProps(w) {
      const { htmlFor: E } = w;
      return t.element({
        ...bt.itemGroupLabel.attrs,
        id: Jh(i, E),
        dir: n("dir"),
        role: "presentation"
      });
    },
    getItemGroupProps(w) {
      const { id: E } = w;
      return t.element({
        ...bt.itemGroup.attrs,
        "data-disabled": me(l),
        id: $T(i, E),
        "aria-labelledby": Jh(i, E),
        role: "group",
        dir: n("dir")
      });
    },
    getClearTriggerProps() {
      return t.button({
        ...bt.clearTrigger.attrs,
        id: S0(i),
        type: "button",
        "aria-label": "Clear value",
        "data-invalid": me(c),
        disabled: l,
        hidden: !s("hasSelectedItems"),
        dir: n("dir"),
        onClick(w) {
          w.defaultPrevented || a({ type: "CLEAR.CLICK" });
        }
      });
    },
    getHiddenSelectProps() {
      const w = r.get("value"), E = n("multiple") ? w : w == null ? void 0 : w[0];
      return t.select({
        name: n("name"),
        form: n("form"),
        disabled: l,
        multiple: n("multiple"),
        required: n("required"),
        "aria-hidden": !0,
        id: lu(i),
        defaultValue: E,
        style: TC,
        tabIndex: -1,
        // Some browser extensions will focus the hidden select.
        // Let's forward the focus to the trigger.
        onFocus() {
          var T;
          (T = Nn(i)) == null || T.focus({ preventScroll: !0 });
        },
        "aria-labelledby": ks(i)
      });
    },
    getPositionerProps() {
      return t.element({
        ...bt.positioner.attrs,
        dir: n("dir"),
        id: E0(i),
        style: O.floating
      });
    },
    getContentProps() {
      return t.element({
        hidden: !p,
        dir: n("dir"),
        id: ou(i),
        role: f ? "listbox" : "dialog",
        ...bt.content.attrs,
        "data-state": p ? "open" : "closed",
        "data-placement": y,
        "data-activedescendant": _,
        "aria-activedescendant": f ? _ : void 0,
        "aria-multiselectable": n("multiple") && f ? !0 : void 0,
        "aria-labelledby": ks(i),
        tabIndex: 0,
        onKeyDown(w) {
          if (!S || !WE(w)) return;
          if (w.key === "Tab" && !sC(w)) {
            w.preventDefault();
            return;
          }
          const E = {
            ArrowUp() {
              a({ type: "CONTENT.ARROW_UP" });
            },
            ArrowDown() {
              a({ type: "CONTENT.ARROW_DOWN" });
            },
            Home() {
              a({ type: "CONTENT.HOME" });
            },
            End() {
              a({ type: "CONTENT.END" });
            },
            Enter() {
              a({ type: "ITEM.CLICK", src: "keydown.enter" });
            },
            Space(k) {
              var j;
              x ? a({ type: "CONTENT.TYPEAHEAD", key: k.key }) : (j = E.Enter) == null || j.call(E, k);
            }
          }, T = E[sh(w)];
          if (T) {
            T(w), w.preventDefault();
            return;
          }
          const G = Ct(w);
          vd(G) || Bo.isValidEvent(w) && (a({ type: "CONTENT.TYPEAHEAD", key: w.key }), w.preventDefault());
        }
      });
    },
    getListProps() {
      return t.element({
        ...bt.list.attrs,
        tabIndex: 0,
        role: f ? void 0 : "listbox",
        "aria-labelledby": su(i),
        "aria-activedescendant": f ? void 0 : _,
        "aria-multiselectable": !f && n("multiple") ? !0 : void 0
      });
    }
  };
}
var { and: no, not: Sn, or: DT } = Yr(), MT = {
  props({ props: e }) {
    var t;
    return {
      loopFocus: !1,
      closeOnSelect: !e.multiple,
      composite: !0,
      defaultValue: [],
      ...e,
      collection: (t = e.collection) != null ? t : w0.empty(),
      positioning: {
        placement: "bottom-start",
        gutter: 8,
        ...e.positioning
      }
    };
  },
  context({ prop: e, bindable: t }) {
    return {
      value: t(() => ({
        defaultValue: e("defaultValue"),
        value: e("value"),
        isEqual: Ai,
        onChange(r) {
          var i;
          const n = e("collection").findMany(r);
          return (i = e("onValueChange")) == null ? void 0 : i({ value: r, items: n });
        }
      })),
      highlightedValue: t(() => ({
        defaultValue: e("defaultHighlightedValue") || null,
        value: e("highlightedValue"),
        onChange(r) {
          var n;
          (n = e("onHighlightChange")) == null || n({
            highlightedValue: r,
            highlightedItem: e("collection").find(r),
            highlightedIndex: e("collection").indexOf(r)
          });
        }
      })),
      currentPlacement: t(() => ({
        defaultValue: void 0
      })),
      fieldsetDisabled: t(() => ({
        defaultValue: !1
      })),
      highlightedItem: t(() => ({
        defaultValue: null
      })),
      selectedItems: t(() => {
        var i, o;
        const r = (o = (i = e("value")) != null ? i : e("defaultValue")) != null ? o : [];
        return { defaultValue: e("collection").findMany(r) };
      }),
      valueAsString: t(() => {
        var n, i;
        const r = (i = (n = e("value")) != null ? n : e("defaultValue")) != null ? i : [];
        return { defaultValue: e("collection").stringifyMany(r) };
      })
    };
  },
  refs() {
    return {
      typeahead: { ...Bo.defaultOptions }
    };
  },
  computed: {
    hasSelectedItems: ({ context: e }) => e.get("value").length > 0,
    isTypingAhead: ({ refs: e }) => e.get("typeahead").keysSoFar !== "",
    isDisabled: ({ prop: e, context: t }) => !!e("disabled") || !!t.get("fieldsetDisabled"),
    isInteractive: ({ prop: e }) => !(e("disabled") || e("readOnly"))
  },
  initialState({ prop: e }) {
    return e("open") || e("defaultOpen") ? "open" : "idle";
  },
  entry: ["syncSelectElement"],
  watch({ context: e, prop: t, track: r, action: n }) {
    r([() => e.get("value").toString()], () => {
      n(["syncSelectedItems", "syncSelectElement", "dispatchChangeEvent"]);
    }), r([() => t("open")], () => {
      n(["toggleVisibility"]);
    }), r([() => e.get("highlightedValue")], () => {
      n(["syncHighlightedItem"]);
    }), r([() => t("collection").toString()], () => {
      n(["syncCollection"]);
    });
  },
  on: {
    "HIGHLIGHTED_VALUE.SET": {
      actions: ["setHighlightedItem"]
    },
    "ITEM.SELECT": {
      actions: ["selectItem"]
    },
    "ITEM.CLEAR": {
      actions: ["clearItem"]
    },
    "VALUE.SET": {
      actions: ["setSelectedItems"]
    },
    "VALUE.CLEAR": {
      actions: ["clearSelectedItems"]
    },
    "CLEAR.CLICK": {
      actions: ["clearSelectedItems", "focusTriggerEl"]
    }
  },
  effects: ["trackFormControlState"],
  states: {
    idle: {
      tags: ["closed"],
      on: {
        "CONTROLLED.OPEN": [
          {
            guard: "isTriggerClickEvent",
            target: "open",
            actions: ["setInitialFocus", "highlightFirstSelectedItem"]
          },
          {
            target: "open",
            actions: ["setInitialFocus"]
          }
        ],
        "TRIGGER.CLICK": [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnOpen"]
          },
          {
            target: "open",
            actions: ["invokeOnOpen", "setInitialFocus", "highlightFirstSelectedItem"]
          }
        ],
        "TRIGGER.FOCUS": {
          target: "focused"
        },
        OPEN: [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnOpen"]
          },
          {
            target: "open",
            actions: ["setInitialFocus", "invokeOnOpen"]
          }
        ]
      }
    },
    focused: {
      tags: ["closed"],
      on: {
        "CONTROLLED.OPEN": [
          {
            guard: "isTriggerClickEvent",
            target: "open",
            actions: ["setInitialFocus", "highlightFirstSelectedItem"]
          },
          {
            guard: "isTriggerArrowUpEvent",
            target: "open",
            actions: ["setInitialFocus", "highlightComputedLastItem"]
          },
          {
            guard: DT("isTriggerArrowDownEvent", "isTriggerEnterEvent"),
            target: "open",
            actions: ["setInitialFocus", "highlightComputedFirstItem"]
          },
          {
            target: "open",
            actions: ["setInitialFocus"]
          }
        ],
        OPEN: [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnOpen"]
          },
          {
            target: "open",
            actions: ["setInitialFocus", "invokeOnOpen"]
          }
        ],
        "TRIGGER.BLUR": {
          target: "idle"
        },
        "TRIGGER.CLICK": [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnOpen"]
          },
          {
            target: "open",
            actions: ["setInitialFocus", "invokeOnOpen", "highlightFirstSelectedItem"]
          }
        ],
        "TRIGGER.ENTER": [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnOpen"]
          },
          {
            target: "open",
            actions: ["setInitialFocus", "invokeOnOpen", "highlightComputedFirstItem"]
          }
        ],
        "TRIGGER.ARROW_UP": [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnOpen"]
          },
          {
            target: "open",
            actions: ["setInitialFocus", "invokeOnOpen", "highlightComputedLastItem"]
          }
        ],
        "TRIGGER.ARROW_DOWN": [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnOpen"]
          },
          {
            target: "open",
            actions: ["setInitialFocus", "invokeOnOpen", "highlightComputedFirstItem"]
          }
        ],
        "TRIGGER.ARROW_LEFT": [
          {
            guard: no(Sn("multiple"), "hasSelectedItems"),
            actions: ["selectPreviousItem"]
          },
          {
            guard: Sn("multiple"),
            actions: ["selectLastItem"]
          }
        ],
        "TRIGGER.ARROW_RIGHT": [
          {
            guard: no(Sn("multiple"), "hasSelectedItems"),
            actions: ["selectNextItem"]
          },
          {
            guard: Sn("multiple"),
            actions: ["selectFirstItem"]
          }
        ],
        "TRIGGER.HOME": {
          guard: Sn("multiple"),
          actions: ["selectFirstItem"]
        },
        "TRIGGER.END": {
          guard: Sn("multiple"),
          actions: ["selectLastItem"]
        },
        "TRIGGER.TYPEAHEAD": {
          guard: Sn("multiple"),
          actions: ["selectMatchingItem"]
        }
      }
    },
    open: {
      tags: ["open"],
      exit: ["scrollContentToTop"],
      effects: ["trackDismissableElement", "computePlacement", "scrollToHighlightedItem"],
      on: {
        "CONTROLLED.CLOSE": [
          {
            guard: "restoreFocus",
            target: "focused",
            actions: ["focusTriggerEl", "clearHighlightedItem"]
          },
          {
            target: "idle",
            actions: ["clearHighlightedItem"]
          }
        ],
        CLOSE: [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnClose"]
          },
          {
            guard: "restoreFocus",
            target: "focused",
            actions: ["invokeOnClose", "focusTriggerEl", "clearHighlightedItem"]
          },
          {
            target: "idle",
            actions: ["invokeOnClose", "clearHighlightedItem"]
          }
        ],
        "TRIGGER.CLICK": [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnClose"]
          },
          {
            target: "focused",
            actions: ["invokeOnClose", "clearHighlightedItem"]
          }
        ],
        "ITEM.CLICK": [
          {
            guard: no("closeOnSelect", "isOpenControlled"),
            actions: ["selectHighlightedItem", "invokeOnClose"]
          },
          {
            guard: "closeOnSelect",
            target: "focused",
            actions: ["selectHighlightedItem", "invokeOnClose", "focusTriggerEl", "clearHighlightedItem"]
          },
          {
            actions: ["selectHighlightedItem"]
          }
        ],
        "CONTENT.HOME": {
          actions: ["highlightFirstItem"]
        },
        "CONTENT.END": {
          actions: ["highlightLastItem"]
        },
        "CONTENT.ARROW_DOWN": [
          {
            guard: no("hasHighlightedItem", "loop", "isLastItemHighlighted"),
            actions: ["highlightFirstItem"]
          },
          {
            guard: "hasHighlightedItem",
            actions: ["highlightNextItem"]
          },
          {
            actions: ["highlightFirstItem"]
          }
        ],
        "CONTENT.ARROW_UP": [
          {
            guard: no("hasHighlightedItem", "loop", "isFirstItemHighlighted"),
            actions: ["highlightLastItem"]
          },
          {
            guard: "hasHighlightedItem",
            actions: ["highlightPreviousItem"]
          },
          {
            actions: ["highlightLastItem"]
          }
        ],
        "CONTENT.TYPEAHEAD": {
          actions: ["highlightMatchingItem"]
        },
        "ITEM.POINTER_MOVE": {
          actions: ["highlightItem"]
        },
        "ITEM.POINTER_LEAVE": {
          actions: ["clearHighlightedItem"]
        },
        "POSITIONING.SET": {
          actions: ["reposition"]
        }
      }
    }
  },
  implementations: {
    guards: {
      loop: ({ prop: e }) => !!e("loopFocus"),
      multiple: ({ prop: e }) => !!e("multiple"),
      hasSelectedItems: ({ computed: e }) => !!e("hasSelectedItems"),
      hasHighlightedItem: ({ context: e }) => e.get("highlightedValue") != null,
      isFirstItemHighlighted: ({ context: e, prop: t }) => e.get("highlightedValue") === t("collection").firstValue,
      isLastItemHighlighted: ({ context: e, prop: t }) => e.get("highlightedValue") === t("collection").lastValue,
      closeOnSelect: ({ prop: e, event: t }) => {
        var r;
        return !!((r = t.closeOnSelect) != null ? r : e("closeOnSelect"));
      },
      restoreFocus: ({ event: e }) => Qh(e),
      // guard assertions (for controlled mode)
      isOpenControlled: ({ prop: e }) => e("open") !== void 0,
      isTriggerClickEvent: ({ event: e }) => {
        var t;
        return ((t = e.previousEvent) == null ? void 0 : t.type) === "TRIGGER.CLICK";
      },
      isTriggerEnterEvent: ({ event: e }) => {
        var t;
        return ((t = e.previousEvent) == null ? void 0 : t.type) === "TRIGGER.ENTER";
      },
      isTriggerArrowUpEvent: ({ event: e }) => {
        var t;
        return ((t = e.previousEvent) == null ? void 0 : t.type) === "TRIGGER.ARROW_UP";
      },
      isTriggerArrowDownEvent: ({ event: e }) => {
        var t;
        return ((t = e.previousEvent) == null ? void 0 : t.type) === "TRIGGER.ARROW_DOWN";
      }
    },
    effects: {
      trackFormControlState({ context: e, scope: t }) {
        return xd(nc(t), {
          onFieldsetDisabledChange(r) {
            e.set("fieldsetDisabled", r);
          },
          onFormReset() {
            const r = e.initial("value");
            e.set("value", r);
          }
        });
      },
      trackDismissableElement({ scope: e, send: t, prop: r }) {
        const n = () => ro(e);
        let i = !0;
        return Di(n, {
          defer: !0,
          exclude: [Nn(e), LT(e)],
          onFocusOutside: r("onFocusOutside"),
          onPointerDownOutside: r("onPointerDownOutside"),
          onInteractOutside(o) {
            var s;
            (s = r("onInteractOutside")) == null || s(o), i = !(o.detail.focusable || o.detail.contextmenu);
          },
          onDismiss() {
            t({ type: "CLOSE", src: "interact-outside", restoreFocus: i });
          }
        });
      },
      computePlacement({ context: e, prop: t, scope: r }) {
        const n = t("positioning");
        return e.set("currentPlacement", n.placement), Mt(() => Nn(r), () => Zh(r), {
          defer: !0,
          ...n,
          onComplete(s) {
            e.set("currentPlacement", s.placement);
          }
        });
      },
      scrollToHighlightedItem({ context: e, prop: t, scope: r, event: n }) {
        const i = (s) => {
          const a = e.get("highlightedValue");
          if (a == null || n.current().type.includes("POINTER")) return;
          const l = VT(r, a), c = ro(r), u = t("scrollToIndexFn");
          if (u) {
            const f = t("collection").indexOf(a);
            u == null || u({ index: f, immediate: s });
            return;
          }
          Sd(l, { rootEl: c, block: "nearest" });
        };
        return de(() => i(!0)), ll(() => ro(r), {
          defer: !0,
          attributes: ["data-activedescendant"],
          callback() {
            i(!1);
          }
        });
      }
    },
    actions: {
      reposition({ context: e, prop: t, scope: r, event: n }) {
        const i = () => Zh(r);
        Mt(Nn(r), i, {
          ...t("positioning"),
          ...n.options,
          defer: !0,
          listeners: !1,
          onComplete(o) {
            e.set("currentPlacement", o.placement);
          }
        });
      },
      toggleVisibility({ send: e, prop: t, event: r }) {
        e({ type: t("open") ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE", previousEvent: r });
      },
      highlightPreviousItem({ context: e, prop: t }) {
        const r = e.get("highlightedValue");
        if (r == null) return;
        const n = t("collection").getPreviousValue(r, 1, t("loopFocus"));
        e.set("highlightedValue", n);
      },
      highlightNextItem({ context: e, prop: t }) {
        const r = e.get("highlightedValue");
        if (r == null) return;
        const n = t("collection").getNextValue(r, 1, t("loopFocus"));
        e.set("highlightedValue", n);
      },
      highlightFirstItem({ context: e, prop: t }) {
        const r = t("collection").firstValue;
        e.set("highlightedValue", r);
      },
      highlightLastItem({ context: e, prop: t }) {
        const r = t("collection").lastValue;
        e.set("highlightedValue", r);
      },
      setInitialFocus({ scope: e }) {
        de(() => {
          const t = Mo({
            root: ro(e)
          });
          t == null || t.focus({ preventScroll: !0 });
        });
      },
      focusTriggerEl({ event: e, scope: t }) {
        Qh(e) && de(() => {
          const r = Nn(t);
          r == null || r.focus({ preventScroll: !0 });
        });
      },
      selectHighlightedItem({ context: e, prop: t, event: r }) {
        var o;
        let n = (o = r.value) != null ? o : e.get("highlightedValue");
        if (n == null) return;
        n = t("deselectable") && !t("multiple") && e.get("value").includes(n) ? null : n, e.set("value", (s) => n == null ? [] : t("multiple") ? pa(s, n) : [n]);
      },
      highlightComputedFirstItem({ context: e, prop: t, computed: r }) {
        const n = t("collection"), i = r("hasSelectedItems") ? n.sort(e.get("value"))[0] : n.firstValue;
        e.set("highlightedValue", i);
      },
      highlightComputedLastItem({ context: e, prop: t, computed: r }) {
        const n = t("collection"), i = r("hasSelectedItems") ? n.sort(e.get("value"))[0] : n.lastValue;
        e.set("highlightedValue", i);
      },
      highlightFirstSelectedItem({ context: e, prop: t, computed: r }) {
        if (!r("hasSelectedItems")) return;
        const n = t("collection").sort(e.get("value"))[0];
        e.set("highlightedValue", n);
      },
      highlightItem({ context: e, event: t }) {
        e.set("highlightedValue", t.value);
      },
      highlightMatchingItem({ context: e, prop: t, event: r, refs: n }) {
        const i = t("collection").search(r.key, {
          state: n.get("typeahead"),
          currentValue: e.get("highlightedValue")
        });
        i != null && e.set("highlightedValue", i);
      },
      setHighlightedItem({ context: e, event: t }) {
        e.set("highlightedValue", t.value);
      },
      clearHighlightedItem({ context: e }) {
        e.set("highlightedValue", null);
      },
      selectItem({ context: e, prop: t, event: r }) {
        const i = t("deselectable") && !t("multiple") && e.get("value").includes(r.value) ? null : r.value;
        e.set("value", (o) => i == null ? [] : t("multiple") ? pa(o, i) : [i]);
      },
      clearItem({ context: e, event: t }) {
        e.set("value", (r) => r.filter((n) => n !== t.value));
      },
      setSelectedItems({ context: e, event: t }) {
        e.set("value", t.value);
      },
      clearSelectedItems({ context: e }) {
        e.set("value", []);
      },
      selectPreviousItem({ context: e, prop: t }) {
        const [r] = e.get("value"), n = t("collection").getPreviousValue(r);
        n && e.set("value", [n]);
      },
      selectNextItem({ context: e, prop: t }) {
        const [r] = e.get("value"), n = t("collection").getNextValue(r);
        n && e.set("value", [n]);
      },
      selectFirstItem({ context: e, prop: t }) {
        const r = t("collection").firstValue;
        r && e.set("value", [r]);
      },
      selectLastItem({ context: e, prop: t }) {
        const r = t("collection").lastValue;
        r && e.set("value", [r]);
      },
      selectMatchingItem({ context: e, prop: t, event: r, refs: n }) {
        const i = t("collection").search(r.key, {
          state: n.get("typeahead"),
          currentValue: e.get("value")[0]
        });
        i != null && e.set("value", [i]);
      },
      scrollContentToTop({ prop: e, scope: t }) {
        var r, n;
        e("scrollToIndexFn") ? (r = e("scrollToIndexFn")) == null || r({ index: 0, immediate: !0 }) : (n = ro(t)) == null || n.scrollTo(0, 0);
      },
      invokeOnOpen({ prop: e }) {
        var t;
        (t = e("onOpenChange")) == null || t({ open: !0 });
      },
      invokeOnClose({ prop: e }) {
        var t;
        (t = e("onOpenChange")) == null || t({ open: !1 });
      },
      syncSelectElement({ context: e, prop: t, scope: r }) {
        const n = nc(r);
        if (n) {
          if (e.get("value").length === 0 && !t("multiple")) {
            n.selectedIndex = -1;
            return;
          }
          for (const i of n.options)
            i.selected = e.get("value").includes(i.value);
        }
      },
      syncCollection({ context: e, prop: t }) {
        const r = t("collection"), n = r.find(e.get("highlightedValue"));
        n && e.set("highlightedItem", n);
        const i = r.findMany(e.get("value"));
        e.set("selectedItems", i);
        const o = r.stringifyItems(i);
        e.set("valueAsString", o);
      },
      syncSelectedItems({ context: e, prop: t }) {
        const r = t("collection"), n = e.get("selectedItems"), o = e.get("value").map((s) => n.find((l) => r.getItemValue(l) === s) || r.find(s));
        e.set("selectedItems", o), e.set("valueAsString", r.stringifyItems(o));
      },
      syncHighlightedItem({ context: e, prop: t }) {
        const r = t("collection"), n = e.get("highlightedValue"), i = n ? r.find(n) : null;
        e.set("highlightedItem", i);
      },
      dispatchChangeEvent({ scope: e }) {
        queueMicrotask(() => {
          const t = nc(e);
          if (!t) return;
          const r = e.getWin(), n = new r.Event("change", { bubbles: !0, composed: !0 });
          t.dispatchEvent(n);
        });
      }
    }
  }
};
function Qh(e) {
  var r, n;
  const t = (n = e.restoreFocus) != null ? n : (r = e.previousEvent) == null ? void 0 : r.restoreFocus;
  return t == null || !!t;
}
ue()([
  "closeOnSelect",
  "collection",
  "dir",
  "disabled",
  "deselectable",
  "form",
  "getRootNode",
  "highlightedValue",
  "id",
  "ids",
  "invalid",
  "loopFocus",
  "multiple",
  "name",
  "onFocusOutside",
  "onHighlightChange",
  "onInteractOutside",
  "onOpenChange",
  "onPointerDownOutside",
  "onValueChange",
  "defaultOpen",
  "open",
  "composite",
  "positioning",
  "required",
  "readOnly",
  "scrollToIndexFn",
  "value",
  "defaultValue",
  "defaultHighlightedValue"
]);
ue()(["item", "persistFocus"]);
ue()(["id"]);
ue()(["htmlFor"]);
const BT = (e) => {
  const t = Hn(), { dir: r } = rs(), { getRootNode: n } = bn(), i = Dd(), o = {
    id: t,
    ids: {
      label: i == null ? void 0 : i.ids.label,
      hiddenSelect: i == null ? void 0 : i.ids.control
    },
    disabled: i == null ? void 0 : i.disabled,
    readOnly: i == null ? void 0 : i.readOnly,
    invalid: i == null ? void 0 : i.invalid,
    required: i == null ? void 0 : i.required,
    dir: r,
    getRootNode: n,
    ...e
  }, s = yn(MT, o);
  return zT(s, Un);
}, WT = (e, t) => {
  const [r, n] = Ni(e), [i, o] = Xr()(n, [
    "closeOnSelect",
    "collection",
    "composite",
    "defaultHighlightedValue",
    "defaultOpen",
    "defaultValue",
    "deselectable",
    "disabled",
    "form",
    "highlightedValue",
    "id",
    "ids",
    "invalid",
    "loopFocus",
    "multiple",
    "name",
    "onFocusOutside",
    "onHighlightChange",
    "onInteractOutside",
    "onOpenChange",
    "onPointerDownOutside",
    "onValueChange",
    "open",
    "positioning",
    "readOnly",
    "required",
    "scrollToIndexFn",
    "value"
  ]), s = BT(i), a = Fi(oe({ present: s.open }, r)), l = oe(s.getRootProps(), o);
  return /* @__PURE__ */ b(a0, { value: s, children: /* @__PURE__ */ b($i, { value: a, children: /* @__PURE__ */ b(ae.div, { ...l, ref: t }) }) });
}, HT = Z(WT), jT = (e, t) => {
  const [r, n] = Ni(e), [{ value: i }, o] = Xr()(n, ["value"]), s = Fi(oe({ present: i.open }, r)), a = oe(i.getRootProps(), o);
  return /* @__PURE__ */ b(a0, { value: i, children: /* @__PURE__ */ b($i, { value: s, children: /* @__PURE__ */ b(ae.div, { ...a, ref: t }) }) });
}, UT = Z(jT), C0 = Z((e, t) => {
  const r = xt(), n = oe(r.getTriggerProps(), e);
  return /* @__PURE__ */ b(ae.button, { ...n, ref: t });
});
C0.displayName = "SelectTrigger";
const k0 = Z((e, t) => {
  const { children: r, placeholder: n, ...i } = e, o = xt(), s = oe(o.getValueTextProps(), i);
  return /* @__PURE__ */ b(ae.span, { ...s, ref: t, children: r || o.valueAsString || n });
});
k0.displayName = "SelectValueText";
var I0 = le("slider").parts(
  "root",
  "label",
  "thumb",
  "valueText",
  "track",
  "range",
  "control",
  "markerGroup",
  "marker",
  "draggingIndicator"
);
I0.build();
ue()([
  "aria-label",
  "aria-labelledby",
  "dir",
  "disabled",
  "form",
  "getAriaValueText",
  "getRootNode",
  "id",
  "ids",
  "invalid",
  "max",
  "min",
  "minStepsBetweenThumbs",
  "name",
  "onFocusChange",
  "onValueChange",
  "onValueChangeEnd",
  "orientation",
  "origin",
  "readOnly",
  "step",
  "thumbAlignment",
  "thumbAlignment",
  "thumbSize",
  "value",
  "defaultValue"
]);
ue()(["index", "name"]);
var O0 = le("switch").parts("root", "label", "control", "thumb");
O0.build();
ue()([
  "checked",
  "defaultChecked",
  "dir",
  "disabled",
  "form",
  "getRootNode",
  "id",
  "ids",
  "invalid",
  "label",
  "name",
  "onCheckedChange",
  "readOnly",
  "required",
  "value"
]);
var GT = le("toast").parts(
  "group",
  "root",
  "title",
  "description",
  "actionTrigger",
  "closeTrigger"
), ci = GT.build(), qT = (e) => `toast-group:${e}`, ep = (e, t) => e.getById(`toast-group:${t}`), P0 = (e) => `toast:${e.id}`, tp = (e) => e.getById(P0(e)), rp = (e) => `toast:${e.id}:title`, np = (e) => `toast:${e.id}:description`, KT = (e) => `toast${e.id}:close`, ip = {
  info: 5e3,
  error: 5e3,
  success: 2e3,
  loading: 1 / 0,
  DEFAULT: 5e3
};
function ic(e, t) {
  var r;
  return (r = e != null ? e : ip[t]) != null ? r : ip.DEFAULT;
}
var YT = (e) => typeof e == "string" ? { left: e, right: e, bottom: e, top: e } : e;
function XT(e, t) {
  var h;
  const { prop: r, computed: n, context: i } = e, { offsets: o, gap: s } = r("store").attrs, a = i.get("heights"), l = YT(o), c = r("dir") === "rtl", u = t.replace("-start", c ? "-right" : "-left").replace("-end", c ? "-left" : "-right"), f = u.includes("right"), d = u.includes("left"), p = {
    position: "fixed",
    pointerEvents: n("count") > 0 ? void 0 : "none",
    display: "flex",
    flexDirection: "column",
    "--gap": `${s}px`,
    "--first-height": `${((h = a[0]) == null ? void 0 : h.height) || 0}px`,
    zIndex: yb
  };
  let g = "center";
  if (f && (g = "flex-end"), d && (g = "flex-start"), p.alignItems = g, u.includes("top")) {
    const m = l.top;
    p.top = `max(env(safe-area-inset-top, 0px), ${m})`;
  }
  if (u.includes("bottom")) {
    const m = l.bottom;
    p.bottom = `max(env(safe-area-inset-bottom, 0px), ${m})`;
  }
  if (!u.includes("left")) {
    const m = l.right;
    p.insetInlineEnd = `calc(env(safe-area-inset-right, 0px) + ${m})`;
  }
  if (!u.includes("right")) {
    const m = l.left;
    p.insetInlineStart = `calc(env(safe-area-inset-left, 0px) + ${m})`;
  }
  return p;
}
function JT(e, t) {
  const { prop: r, context: n, computed: i } = e, o = r("parent"), s = o.computed("placement"), { gap: a } = o.prop("store").attrs, [l] = s.split("-"), c = n.get("mounted"), u = n.get("remainingTime"), f = i("height"), d = i("frontmost"), p = !d, g = !r("stacked"), h = r("stacked"), v = r("type") === "loading" ? Number.MAX_SAFE_INTEGER : u, y = i("heightIndex") * a + i("heightBefore"), x = {
    position: "absolute",
    pointerEvents: "auto",
    "--opacity": "0",
    "--remove-delay": `${r("removeDelay")}ms`,
    "--duration": `${v}ms`,
    "--initial-height": `${f}px`,
    "--offset": `${y}px`,
    "--index": r("index"),
    "--z-index": i("zIndex"),
    "--lift-amount": "calc(var(--lift) * var(--gap))",
    "--y": "100%",
    "--x": "0"
  }, S = (_) => Object.assign(x, _);
  return l === "top" ? S({
    top: "0",
    "--sign": "-1",
    "--y": "-100%",
    "--lift": "1"
  }) : l === "bottom" && S({
    bottom: "0",
    "--sign": "1",
    "--y": "100%",
    "--lift": "-1"
  }), c && (S({
    "--y": "0",
    "--opacity": "1"
  }), h && S({
    "--y": "calc(var(--lift) * var(--offset))",
    "--height": "var(--initial-height)"
  })), t || S({
    "--opacity": "0",
    pointerEvents: "none"
  }), p && g && (S({
    "--base-scale": "var(--index) * 0.05 + 1",
    "--y": "calc(var(--lift-amount) * var(--index))",
    "--scale": "calc(-1 * var(--base-scale))",
    "--height": "var(--first-height)"
  }), t || S({
    "--y": "calc(var(--sign) * 40%)"
  })), p && h && !t && S({
    "--y": "calc(var(--lift) * var(--offset) + var(--lift) * -100%)"
  }), d && !t && S({
    "--y": "calc(var(--lift) * -100%)"
  }), x;
}
function ZT(e, t) {
  const { computed: r } = e, n = {
    position: "absolute",
    inset: "0",
    scale: "1 2",
    pointerEvents: t ? "none" : "auto"
  }, i = (o) => Object.assign(n, o);
  return r("frontmost") && !t && i({
    height: "calc(var(--initial-height) + 80%)"
  }), n;
}
function QT() {
  return {
    position: "absolute",
    left: "0",
    height: "calc(var(--gap) + 2px)",
    bottom: "100%",
    width: "100%"
  };
}
function eR(e, t) {
  const { context: r, prop: n, send: i, refs: o, computed: s } = e;
  return {
    getCount() {
      return r.get("toasts").length;
    },
    getToasts() {
      return r.get("toasts");
    },
    getGroupProps(a = {}) {
      const { label: l = "Notifications" } = a, { hotkey: c } = n("store").attrs, u = c.join("+").replace(/Key/g, "").replace(/Digit/g, ""), f = s("placement"), [d, p = "center"] = f.split("-");
      return t.element({
        ...ci.group.attrs,
        dir: n("dir"),
        tabIndex: -1,
        "aria-label": `${f} ${l} ${u}`,
        id: qT(f),
        "data-placement": f,
        "data-side": d,
        "data-align": p,
        "aria-live": "polite",
        role: "region",
        style: XT(e, f),
        onMouseMove() {
          i({ type: "REGION.POINTER_ENTER", placement: f });
        },
        onMouseLeave() {
          i({ type: "REGION.POINTER_LEAVE", placement: f });
        },
        onFocus(g) {
          i({ type: "REGION.FOCUS", target: g.relatedTarget });
        },
        onBlur(g) {
          o.get("isFocusWithin") && !fn(g.currentTarget, g.relatedTarget) && queueMicrotask(() => i({ type: "REGION.BLUR" }));
        }
      });
    },
    subscribe(a) {
      return n("store").subscribe(() => a(r.get("toasts")));
    }
  };
}
var tR = {
  props({ props: e }) {
    return {
      dir: "ltr",
      id: fb(),
      ...e,
      store: e.store
    };
  },
  initialState({ prop: e }) {
    return e("store").attrs.overlap ? "overlap" : "stack";
  },
  refs() {
    return {
      lastFocusedEl: null,
      isFocusWithin: !1,
      dismissableCleanup: void 0
    };
  },
  context({ bindable: e }) {
    return {
      toasts: e(() => ({
        defaultValue: [],
        sync: !0,
        hash: (t) => t.map((r) => r.id).join(",")
      })),
      heights: e(() => ({
        defaultValue: [],
        sync: !0
      }))
    };
  },
  computed: {
    count: ({ context: e }) => e.get("toasts").length,
    overlap: ({ prop: e }) => e("store").attrs.overlap,
    placement: ({ prop: e }) => e("store").attrs.placement
  },
  effects: ["subscribeToStore", "trackDocumentVisibility", "trackHotKeyPress"],
  watch({ track: e, context: t, action: r }) {
    e([() => t.hash("toasts")], () => {
      queueMicrotask(() => {
        r(["collapsedIfEmpty", "setDismissableBranch"]);
      });
    });
  },
  exit: ["clearDismissableBranch", "clearLastFocusedEl"],
  on: {
    "DOC.HOTKEY": {
      actions: ["focusRegionEl"]
    },
    "REGION.BLUR": [
      {
        guard: "isOverlapping",
        target: "overlap",
        actions: ["collapseToasts", "resumeToasts", "restoreLastFocusedEl"]
      },
      {
        target: "stack",
        actions: ["resumeToasts", "restoreLastFocusedEl"]
      }
    ],
    "TOAST.REMOVE": {
      actions: ["removeToast", "removeHeight"]
    },
    "TOAST.PAUSE": {
      actions: ["pauseToasts"]
    }
  },
  states: {
    stack: {
      on: {
        "REGION.POINTER_LEAVE": [
          {
            guard: "isOverlapping",
            target: "overlap",
            actions: ["resumeToasts", "collapseToasts"]
          },
          {
            actions: ["resumeToasts"]
          }
        ],
        "REGION.OVERLAP": {
          target: "overlap",
          actions: ["collapseToasts"]
        },
        "REGION.FOCUS": {
          actions: ["setLastFocusedEl", "pauseToasts"]
        },
        "REGION.POINTER_ENTER": {
          actions: ["pauseToasts"]
        }
      }
    },
    overlap: {
      on: {
        "REGION.STACK": {
          target: "stack",
          actions: ["expandToasts"]
        },
        "REGION.POINTER_ENTER": {
          target: "stack",
          actions: ["pauseToasts", "expandToasts"]
        },
        "REGION.FOCUS": {
          target: "stack",
          actions: ["setLastFocusedEl", "pauseToasts", "expandToasts"]
        }
      }
    }
  },
  implementations: {
    guards: {
      isOverlapping: ({ computed: e }) => e("overlap")
    },
    effects: {
      subscribeToStore({ context: e, prop: t }) {
        return t("store").subscribe((r) => {
          if (r.dismiss) {
            e.set("toasts", (n) => n.filter((i) => i.id !== r.id));
            return;
          }
          e.set("toasts", (n) => {
            const i = n.findIndex((o) => o.id === r.id);
            return i !== -1 ? [...n.slice(0, i), { ...n[i], ...r }, ...n.slice(i + 1)] : [r, ...n];
          });
        });
      },
      trackHotKeyPress({ prop: e, send: t }) {
        return Ae(document, "keydown", (n) => {
          const { hotkey: i } = e("store").attrs;
          i.every((s) => n[s] || n.code === s) && t({ type: "DOC.HOTKEY" });
        }, { capture: !0 });
      },
      trackDocumentVisibility({ prop: e, send: t, scope: r }) {
        const { pauseOnPageIdle: n } = e("store").attrs;
        if (!n) return;
        const i = r.getDoc();
        return Ae(i, "visibilitychange", () => {
          const o = i.visibilityState === "hidden";
          t({ type: o ? "PAUSE_ALL" : "RESUME_ALL" });
        });
      }
    },
    actions: {
      setDismissableBranch({ refs: e, context: t, computed: r, scope: n }) {
        var c;
        const i = t.get("toasts"), o = r("placement"), s = i.length > 0;
        if (!s) {
          (c = e.get("dismissableCleanup")) == null || c();
          return;
        }
        if (s && e.get("dismissableCleanup"))
          return;
        const l = EI(() => ep(n, o), { defer: !0 });
        e.set("dismissableCleanup", l);
      },
      clearDismissableBranch({ refs: e }) {
        var t;
        (t = e.get("dismissableCleanup")) == null || t();
      },
      focusRegionEl({ scope: e, computed: t }) {
        queueMicrotask(() => {
          var r;
          (r = ep(e, t("placement"))) == null || r.focus();
        });
      },
      pauseToasts({ prop: e }) {
        e("store").pause();
      },
      resumeToasts({ prop: e }) {
        e("store").resume();
      },
      expandToasts({ prop: e }) {
        e("store").expand();
      },
      collapseToasts({ prop: e }) {
        e("store").collapse();
      },
      removeToast({ prop: e, event: t }) {
        e("store").remove(t.id);
      },
      removeHeight({ event: e, context: t }) {
        (e == null ? void 0 : e.id) != null && queueMicrotask(() => {
          t.set("heights", (r) => r.filter((n) => n.id !== e.id));
        });
      },
      collapsedIfEmpty({ send: e, computed: t }) {
        !t("overlap") || t("count") > 1 || e({ type: "REGION.OVERLAP" });
      },
      setLastFocusedEl({ refs: e, event: t }) {
        e.get("isFocusWithin") || !t.target || (e.set("isFocusWithin", !0), e.set("lastFocusedEl", t.target));
      },
      restoreLastFocusedEl({ refs: e }) {
        var t;
        e.get("lastFocusedEl") && ((t = e.get("lastFocusedEl")) == null || t.focus({ preventScroll: !0 }), e.set("lastFocusedEl", null), e.set("isFocusWithin", !1));
      },
      clearLastFocusedEl({ refs: e }) {
        var t;
        e.get("lastFocusedEl") && ((t = e.get("lastFocusedEl")) == null || t.focus({ preventScroll: !0 }), e.set("lastFocusedEl", null), e.set("isFocusWithin", !1));
      }
    }
  }
};
function rR(e, t) {
  const { state: r, send: n, prop: i, scope: o, context: s, computed: a } = e, l = r.hasTag("visible"), c = r.hasTag("paused"), u = s.get("mounted"), f = a("frontmost"), d = i("parent").computed("placement"), p = i("type"), g = i("stacked"), h = i("title"), m = i("description"), v = i("action"), [y, x = "center"] = d.split("-");
  return {
    type: p,
    title: h,
    description: m,
    placement: d,
    visible: l,
    paused: c,
    closable: !!i("closable"),
    pause() {
      n({ type: "PAUSE" });
    },
    resume() {
      n({ type: "RESUME" });
    },
    dismiss() {
      n({ type: "DISMISS", src: "programmatic" });
    },
    getRootProps() {
      return t.element({
        ...ci.root.attrs,
        dir: i("dir"),
        id: P0(o),
        "data-state": l ? "open" : "closed",
        "data-type": p,
        "data-placement": d,
        "data-align": x,
        "data-side": y,
        "data-mounted": me(u),
        "data-paused": me(c),
        "data-first": me(f),
        "data-sibling": me(!f),
        "data-stack": me(g),
        "data-overlap": me(!g),
        role: "status",
        "aria-atomic": "true",
        "aria-describedby": m ? np(o) : void 0,
        "aria-labelledby": h ? rp(o) : void 0,
        tabIndex: 0,
        style: JT(e, l),
        onKeyDown(S) {
          S.defaultPrevented || S.key == "Escape" && (n({ type: "DISMISS", src: "keyboard" }), S.preventDefault());
        }
      });
    },
    /* Leave a ghost div to avoid setting hover to false when transitioning out */
    getGhostBeforeProps() {
      return t.element({
        "data-ghost": "before",
        style: ZT(e, l)
      });
    },
    /* Needed to avoid setting hover to false when in between toasts */
    getGhostAfterProps() {
      return t.element({
        "data-ghost": "after",
        style: QT()
      });
    },
    getTitleProps() {
      return t.element({
        ...ci.title.attrs,
        id: rp(o)
      });
    },
    getDescriptionProps() {
      return t.element({
        ...ci.description.attrs,
        id: np(o)
      });
    },
    getActionTriggerProps() {
      return t.button({
        ...ci.actionTrigger.attrs,
        type: "button",
        onClick(S) {
          var _;
          S.defaultPrevented || ((_ = v == null ? void 0 : v.onClick) == null || _.call(v), n({ type: "DISMISS", src: "user" }));
        }
      });
    },
    getCloseTriggerProps() {
      return t.button({
        id: KT(o),
        ...ci.closeTrigger.attrs,
        type: "button",
        "aria-label": "Dismiss notification",
        onClick(S) {
          S.defaultPrevented || n({ type: "DISMISS", src: "user" });
        }
      });
    }
  };
}
var { not: nR } = Yr(), iR = {
  props({ props: e }) {
    return mE(e, ["id", "type", "parent", "removeDelay"], "toast"), {
      closable: !0,
      ...e,
      duration: ic(e.duration, e.type)
    };
  },
  initialState({ prop: e }) {
    return e("type") === "loading" || e("duration") === 1 / 0 ? "visible:persist" : "visible";
  },
  context({ prop: e, bindable: t }) {
    return {
      remainingTime: t(() => ({
        defaultValue: ic(e("duration"), e("type"))
      })),
      createdAt: t(() => ({
        defaultValue: Date.now()
      })),
      mounted: t(() => ({
        defaultValue: !1
      })),
      initialHeight: t(() => ({
        defaultValue: 0
      }))
    };
  },
  refs() {
    return {
      closeTimerStartTime: Date.now(),
      lastCloseStartTimerStartTime: 0
    };
  },
  computed: {
    zIndex: ({ prop: e }) => {
      const t = e("parent").context.get("toasts"), r = t.findIndex((n) => n.id === e("id"));
      return t.length - r;
    },
    height: ({ prop: e }) => {
      var n;
      const r = e("parent").context.get("heights").find((i) => i.id === e("id"));
      return (n = r == null ? void 0 : r.height) != null ? n : 0;
    },
    heightIndex: ({ prop: e }) => e("parent").context.get("heights").findIndex((r) => r.id === e("id")),
    frontmost: ({ prop: e }) => e("index") === 0,
    heightBefore: ({ prop: e }) => {
      const t = e("parent").context.get("heights"), r = t.findIndex((n) => n.id === e("id"));
      return t.reduce((n, i, o) => o >= r ? n : n + i.height, 0);
    },
    shouldPersist: ({ prop: e }) => e("type") === "loading" || e("duration") === 1 / 0
  },
  watch({ track: e, prop: t, send: r }) {
    e([() => t("message")], () => {
      const n = t("message");
      n && r({ type: n, src: "programmatic" });
    }), e([() => t("type"), () => t("duration")], () => {
      r({ type: "UPDATE" });
    });
  },
  on: {
    UPDATE: [
      {
        guard: "shouldPersist",
        target: "visible:persist",
        actions: ["resetCloseTimer"]
      },
      {
        target: "visible:updating",
        actions: ["resetCloseTimer"]
      }
    ],
    MEASURE: {
      actions: ["measureHeight"]
    }
  },
  entry: ["setMounted", "measureHeight", "invokeOnVisible"],
  effects: ["trackHeight"],
  states: {
    "visible:updating": {
      tags: ["visible", "updating"],
      effects: ["waitForNextTick"],
      on: {
        SHOW: {
          target: "visible"
        }
      }
    },
    "visible:persist": {
      tags: ["visible", "paused"],
      on: {
        RESUME: {
          guard: nR("isLoadingType"),
          target: "visible",
          actions: ["setCloseTimer"]
        },
        DISMISS: {
          target: "dismissing"
        }
      }
    },
    visible: {
      tags: ["visible"],
      effects: ["waitForDuration"],
      on: {
        DISMISS: {
          target: "dismissing"
        },
        PAUSE: {
          target: "visible:persist",
          actions: ["syncRemainingTime"]
        }
      }
    },
    dismissing: {
      entry: ["invokeOnDismiss"],
      effects: ["waitForRemoveDelay"],
      on: {
        REMOVE: {
          target: "unmounted",
          actions: ["notifyParentToRemove"]
        }
      }
    },
    unmounted: {
      entry: ["invokeOnUnmount"]
    }
  },
  implementations: {
    effects: {
      waitForRemoveDelay({ prop: e, send: t }) {
        return Gs(() => {
          t({ type: "REMOVE", src: "timer" });
        }, e("removeDelay"));
      },
      waitForDuration({ send: e, context: t, computed: r }) {
        if (!r("shouldPersist"))
          return Gs(() => {
            e({ type: "DISMISS", src: "timer" });
          }, t.get("remainingTime"));
      },
      waitForNextTick({ send: e }) {
        return Gs(() => {
          e({ type: "SHOW", src: "timer" });
        }, 0);
      },
      trackHeight({ scope: e, prop: t }) {
        let r;
        return de(() => {
          const n = tp(e);
          if (!n) return;
          const i = () => {
            const a = n.style.height;
            n.style.height = "auto";
            const l = n.getBoundingClientRect().height;
            n.style.height = a;
            const c = { id: t("id"), height: l };
            op(t("parent"), c);
          }, o = e.getWin(), s = new o.MutationObserver(i);
          s.observe(n, {
            childList: !0,
            subtree: !0,
            characterData: !0
          }), r = () => s.disconnect();
        }), () => r == null ? void 0 : r();
      }
    },
    guards: {
      isLoadingType: ({ prop: e }) => e("type") === "loading",
      shouldPersist: ({ computed: e }) => e("shouldPersist")
    },
    actions: {
      setMounted({ context: e }) {
        de(() => {
          e.set("mounted", !0);
        });
      },
      measureHeight({ scope: e, prop: t, context: r }) {
        queueMicrotask(() => {
          const n = tp(e);
          if (!n) return;
          const i = n.style.height;
          n.style.height = "auto";
          const o = n.getBoundingClientRect().height;
          n.style.height = i, r.set("initialHeight", o);
          const s = { id: t("id"), height: o };
          op(t("parent"), s);
        });
      },
      setCloseTimer({ refs: e }) {
        e.set("closeTimerStartTime", Date.now());
      },
      resetCloseTimer({ context: e, refs: t, prop: r }) {
        t.set("closeTimerStartTime", Date.now()), e.set("remainingTime", ic(r("duration"), r("type")));
      },
      syncRemainingTime({ context: e, refs: t }) {
        e.set("remainingTime", (r) => {
          const n = t.get("closeTimerStartTime"), i = Date.now() - n;
          return t.set("lastCloseStartTimerStartTime", Date.now()), r - i;
        });
      },
      notifyParentToRemove({ prop: e }) {
        e("parent").send({ type: "TOAST.REMOVE", id: e("id") });
      },
      invokeOnDismiss({ prop: e, event: t }) {
        var r;
        (r = e("onStatusChange")) == null || r({ status: "dismissing", src: t.src });
      },
      invokeOnUnmount({ prop: e }) {
        var t;
        (t = e("onStatusChange")) == null || t({ status: "unmounted" });
      },
      invokeOnVisible({ prop: e }) {
        var t;
        (t = e("onStatusChange")) == null || t({ status: "visible" });
      }
    }
  }
};
function op(e, t) {
  const { id: r, height: n } = t;
  e.context.set("heights", (i) => i.find((s) => s.id === r) ? i.map((s) => s.id === r ? { ...s, height: n } : s) : [{ id: r, height: n }, ...i]);
}
var oR = (e, t) => ({ ...t, ...nl(e) });
function sR(e) {
  const t = oR(e, {
    placement: "bottom",
    overlap: !1,
    max: 24,
    gap: 16,
    offsets: "1rem",
    hotkey: ["altKey", "KeyT"],
    removeDelay: 200,
    pauseOnPageIdle: !0
  });
  let r = [], n = [], i = /* @__PURE__ */ new Set(), o = [];
  const s = (k) => (r.push(k), () => {
    const j = r.indexOf(k);
    r.splice(j, 1);
  }), a = (k) => (r.forEach((j) => j(k)), k), l = (k) => {
    if (n.length >= t.max) {
      o.push(k);
      return;
    }
    a(k), n.unshift(k);
  }, c = () => {
    for (; o.length > 0 && n.length < t.max; ) {
      const k = o.shift();
      k && (a(k), n.unshift(k));
    }
  }, u = (k) => {
    var L;
    const j = (L = k.id) != null ? L : `toast:${fb()}`, F = n.find((D) => D.id === j);
    return i.has(j) && i.delete(j), F ? n = n.map((D) => D.id === j ? a({ ...D, ...k, id: j }) : D) : l({
      id: j,
      duration: t.duration,
      removeDelay: t.removeDelay,
      type: "info",
      ...k,
      stacked: !t.overlap,
      gap: t.gap
    }), j;
  }, f = (k) => (i.add(k), k ? (r.forEach((j) => j({ id: k, dismiss: !0 })), n = n.filter((j) => j.id !== k), c()) : (n.forEach((j) => {
    r.forEach((F) => F({ id: j.id, dismiss: !0 }));
  }), n = [], o = []), k);
  return {
    attrs: t,
    subscribe: s,
    create: u,
    update: (k, j) => u({ id: k, ...j }),
    remove: f,
    dismiss: (k) => {
      k != null ? n = n.map((j) => j.id === k ? a({ ...j, message: "DISMISS" }) : j) : n = n.map((j) => a({ ...j, message: "DISMISS" }));
    },
    error: (k) => u({ ...k, type: "error" }),
    success: (k) => u({ ...k, type: "success" }),
    info: (k) => u({ ...k, type: "info" }),
    warning: (k) => u({ ...k, type: "warning" }),
    loading: (k) => u({ ...k, type: "loading" }),
    getVisibleToasts: () => n.filter((k) => !i.has(k.id)),
    getCount: () => n.length,
    promise: (k, j, F = {}) => {
      if (!j) return;
      let L;
      j.loading !== void 0 && (L = u({
        ...F,
        ...j.loading,
        promise: k,
        type: "loading"
      }));
      let D = L !== void 0, N;
      const B = ho(k).then(async (P) => {
        if (N = ["resolve", P], aR(P) && !P.ok) {
          D = !1;
          const C = ho(j.error, `HTTP Error! status: ${P.status}`);
          u({ ...F, ...C, id: L, type: "error" });
        } else if (j.success !== void 0) {
          D = !1;
          const C = ho(j.success, P);
          u({ ...F, ...C, id: L, type: "success" });
        }
      }).catch(async (P) => {
        if (N = ["reject", P], j.error !== void 0) {
          D = !1;
          const C = ho(j.error, P);
          u({ ...F, ...C, id: L, type: "error" });
        }
      }).finally(() => {
        var P;
        D && (f(L), L = void 0), (P = j.finally) == null || P.call(j);
      });
      return { id: L, unwrap: () => new Promise(
        (P, C) => B.then(() => N[0] === "reject" ? C(N[1]) : P(N[1])).catch(C)
      ) };
    },
    pause: (k) => {
      k != null ? n = n.map((j) => j.id === k ? a({ ...j, message: "PAUSE" }) : j) : n = n.map((j) => a({ ...j, message: "PAUSE" }));
    },
    resume: (k) => {
      k != null ? n = n.map((j) => j.id === k ? a({ ...j, message: "RESUME" }) : j) : n = n.map((j) => a({ ...j, message: "RESUME" }));
    },
    isVisible: (k) => !i.has(k) && !!n.find((j) => j.id === k),
    isDismissed: (k) => i.has(k),
    expand: () => {
      n = n.map((k) => a({ ...k, stacked: !0 }));
    },
    collapse: () => {
      n = n.map((k) => a({ ...k, stacked: !1 }));
    }
  };
}
var aR = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", sp = {
  connect: eR,
  machine: tR
};
const lR = (e) => sR(e), [cR, Bi] = Bt({
  name: "ToastContext",
  hookName: "useToastContext",
  providerName: "<ToastProvider />"
}), T0 = Z((e, t) => {
  const r = Bi(), n = oe(r.getActionTriggerProps(), e);
  return /* @__PURE__ */ b(ae.button, { ...n, ref: t });
});
T0.displayName = "ToastActionTrigger";
const R0 = Z((e, t) => {
  const r = Bi(), n = oe(r.getCloseTriggerProps(), e);
  return /* @__PURE__ */ b(ae.button, { ...n, ref: t });
});
R0.displayName = "ToastCloseTrigger";
const A0 = Z((e, t) => {
  const r = Bi(), n = oe(r.getDescriptionProps(), e);
  return /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
A0.displayName = "ToastDescription";
const N0 = Z((e, t) => {
  const r = Bi(), n = oe(r.getRootProps(), e);
  return /* @__PURE__ */ K("div", { ...n, ref: t, children: [
    /* @__PURE__ */ b("div", { ...r.getGhostBeforeProps() }),
    e.children,
    /* @__PURE__ */ b("div", { ...r.getGhostAfterProps() })
  ] });
});
N0.displayName = "ToastRoot";
const F0 = Z((e, t) => {
  const r = Bi(), n = oe(r.getTitleProps(), e);
  return /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
F0.displayName = "ToastTitle";
const $0 = Z((e, t) => {
  const { toaster: r, children: n, ...i } = e, o = rs(), s = bn(), a = yn(sp.machine, {
    store: r,
    id: Hn(),
    dir: o == null ? void 0 : o.dir,
    getRootNode: s == null ? void 0 : s.getRootNode
  }), l = sp.connect(a, Un), c = oe(l.getGroupProps(), i);
  return /* @__PURE__ */ b(ae.div, { ...c, ref: t, children: l.getToasts().map((u, f) => /* @__PURE__ */ b(L0, { value: u, parent: a, index: f, children: (d) => n(d) }, u.id)) });
});
$0.displayName = "Toaster";
const L0 = (e) => {
  const t = bn(), r = {
    ...e.value,
    parent: e.parent,
    index: e.index,
    getRootNode: t.getRootNode
  }, n = yn(iR, { ...r }), i = rR(n, Un);
  return /* @__PURE__ */ b(cR, { value: i, children: e.children(e.value) });
};
L0.displayName = "ToastActor";
const [V0, as] = Bt({
  name: "TooltipContext",
  hookName: "useTooltipContext",
  providerName: "<TooltipProvider />"
}), z0 = Z((e, t) => {
  const r = as(), n = oe(r.getArrowProps(), e);
  return /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
z0.displayName = "TooltipArrow";
const D0 = Z((e, t) => {
  const r = as(), n = oe(r.getArrowTipProps(), e);
  return /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
D0.displayName = "TooltipArrowTip";
const M0 = Z((e, t) => {
  const r = as(), n = Gn(), i = oe(r.getContentProps(), n.getPresenceProps(), e);
  return n.unmounted ? null : /* @__PURE__ */ b(ae.div, { ...i, ref: cl(n.ref, t) });
});
M0.displayName = "TooltipContent";
const B0 = Z((e, t) => {
  const r = as(), n = oe(r.getPositionerProps(), e);
  return Gn().unmounted ? null : /* @__PURE__ */ b(ae.div, { ...n, ref: t });
});
B0.displayName = "TooltipPositioner";
var W0 = le("tooltip").parts("trigger", "arrow", "arrowTip", "positioner", "content"), io = W0.build(), H0 = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.trigger) != null ? r : `tooltip:${e.id}:trigger`;
}, uR = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.content) != null ? r : `tooltip:${e.id}:content`;
}, dR = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.arrow) != null ? r : `tooltip:${e.id}:arrow`;
}, j0 = (e) => {
  var t, r;
  return (r = (t = e.ids) == null ? void 0 : t.positioner) != null ? r : `tooltip:${e.id}:popper`;
}, oc = (e) => e.getById(H0(e)), ap = (e) => e.getById(j0(e)), Lr = Ey({ id: null });
function fR(e, t) {
  const { state: r, context: n, send: i, scope: o, prop: s, event: a } = e, l = s("id"), c = !!s("aria-label"), u = r.matches("open", "closing"), f = H0(o), d = uR(o), p = s("disabled"), g = zd({
    ...s("positioning"),
    placement: n.get("currentPlacement")
  });
  return {
    open: u,
    setOpen(h) {
      r.matches("open", "closing") !== h && i({ type: h ? "open" : "close" });
    },
    reposition(h = {}) {
      i({ type: "positioning.set", options: h });
    },
    getTriggerProps() {
      return t.button({
        ...io.trigger.attrs,
        id: f,
        dir: s("dir"),
        "data-expanded": me(u),
        "data-state": u ? "open" : "closed",
        "aria-describedby": u ? d : void 0,
        onClick(h) {
          h.defaultPrevented || p || s("closeOnClick") && i({ type: "close", src: "trigger.click" });
        },
        onFocus(h) {
          queueMicrotask(() => {
            h.defaultPrevented || p || a.src !== "trigger.pointerdown" && Xc() && i({ type: "open", src: "trigger.focus" });
          });
        },
        onBlur(h) {
          h.defaultPrevented || p || l === Lr.id && i({ type: "close", src: "trigger.blur" });
        },
        onPointerDown(h) {
          h.defaultPrevented || p || s("closeOnPointerDown") && l === Lr.id && i({ type: "close", src: "trigger.pointerdown" });
        },
        onPointerMove(h) {
          h.defaultPrevented || p || h.pointerType !== "touch" && i({ type: "pointer.move" });
        },
        onPointerLeave() {
          p || i({ type: "pointer.leave" });
        },
        onPointerCancel() {
          p || i({ type: "pointer.leave" });
        }
      });
    },
    getArrowProps() {
      return t.element({
        id: dR(o),
        ...io.arrow.attrs,
        dir: s("dir"),
        style: g.arrow
      });
    },
    getArrowTipProps() {
      return t.element({
        ...io.arrowTip.attrs,
        dir: s("dir"),
        style: g.arrowTip
      });
    },
    getPositionerProps() {
      return t.element({
        id: j0(o),
        ...io.positioner.attrs,
        dir: s("dir"),
        style: g.floating
      });
    },
    getContentProps() {
      return t.element({
        ...io.content.attrs,
        dir: s("dir"),
        hidden: !u,
        "data-state": u ? "open" : "closed",
        role: c ? void 0 : "tooltip",
        id: c ? void 0 : d,
        "data-placement": n.get("currentPlacement"),
        onPointerEnter() {
          i({ type: "content.pointer.move" });
        },
        onPointerLeave() {
          i({ type: "content.pointer.leave" });
        },
        style: {
          pointerEvents: s("interactive") ? "auto" : "none"
        }
      });
    }
  };
}
var { and: hR, not: lp } = Yr(), pR = {
  initialState: ({ prop: e }) => e("open") || e("defaultOpen") ? "open" : "closed",
  props({ props: e }) {
    return {
      id: "x",
      openDelay: 1e3,
      closeDelay: 500,
      closeOnPointerDown: !0,
      closeOnEscape: !0,
      interactive: !1,
      closeOnScroll: !0,
      closeOnClick: !0,
      disabled: !1,
      ...e,
      positioning: {
        placement: "bottom",
        ...e.positioning
      }
    };
  },
  effects: ["trackFocusVisible", "trackStore"],
  context: ({ bindable: e }) => ({
    currentPlacement: e(() => ({ defaultValue: void 0 })),
    hasPointerMoveOpened: e(() => ({ defaultValue: !1 }))
  }),
  watch({ track: e, action: t, prop: r }) {
    e([() => r("disabled")], () => {
      t(["closeIfDisabled"]);
    }), e([() => r("open")], () => {
      t(["toggleVisibility"]);
    });
  },
  states: {
    closed: {
      entry: ["clearGlobalId"],
      on: {
        "controlled.open": {
          target: "open"
        },
        open: [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnOpen"]
          },
          {
            target: "open",
            actions: ["invokeOnOpen"]
          }
        ],
        "pointer.leave": {
          actions: ["clearPointerMoveOpened"]
        },
        "pointer.move": [
          {
            guard: hR("noVisibleTooltip", lp("hasPointerMoveOpened")),
            target: "opening"
          },
          {
            guard: lp("hasPointerMoveOpened"),
            target: "open",
            actions: ["setPointerMoveOpened", "invokeOnOpen"]
          }
        ]
      }
    },
    opening: {
      effects: ["trackScroll", "trackPointerlockChange", "waitForOpenDelay"],
      on: {
        "after.openDelay": [
          {
            guard: "isOpenControlled",
            actions: ["setPointerMoveOpened", "invokeOnOpen"]
          },
          {
            target: "open",
            actions: ["setPointerMoveOpened", "invokeOnOpen"]
          }
        ],
        "controlled.open": {
          target: "open"
        },
        "controlled.close": {
          target: "closed"
        },
        open: [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnOpen"]
          },
          {
            target: "open",
            actions: ["invokeOnOpen"]
          }
        ],
        "pointer.leave": [
          {
            guard: "isOpenControlled",
            // We trigger toggleVisibility manually since the `ctx.open` has not changed yet (at this point)
            actions: ["clearPointerMoveOpened", "invokeOnClose", "toggleVisibility"]
          },
          {
            target: "closed",
            actions: ["clearPointerMoveOpened", "invokeOnClose"]
          }
        ],
        close: [
          {
            guard: "isOpenControlled",
            // We trigger toggleVisibility manually since the `ctx.open` has not changed yet (at this point)
            actions: ["invokeOnClose", "toggleVisibility"]
          },
          {
            target: "closed",
            actions: ["invokeOnClose"]
          }
        ]
      }
    },
    open: {
      effects: ["trackEscapeKey", "trackScroll", "trackPointerlockChange", "trackPositioning"],
      entry: ["setGlobalId"],
      on: {
        "controlled.close": {
          target: "closed"
        },
        close: [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnClose"]
          },
          {
            target: "closed",
            actions: ["invokeOnClose"]
          }
        ],
        "pointer.leave": [
          {
            guard: "isVisible",
            target: "closing",
            actions: ["clearPointerMoveOpened"]
          },
          // == group ==
          {
            guard: "isOpenControlled",
            actions: ["clearPointerMoveOpened", "invokeOnClose"]
          },
          {
            target: "closed",
            actions: ["clearPointerMoveOpened", "invokeOnClose"]
          }
        ],
        "content.pointer.leave": {
          guard: "isInteractive",
          target: "closing"
        },
        "positioning.set": {
          actions: ["reposition"]
        }
      }
    },
    closing: {
      effects: ["trackPositioning", "waitForCloseDelay"],
      on: {
        "after.closeDelay": [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnClose"]
          },
          {
            target: "closed",
            actions: ["invokeOnClose"]
          }
        ],
        "controlled.close": {
          target: "closed"
        },
        "controlled.open": {
          target: "open"
        },
        close: [
          {
            guard: "isOpenControlled",
            actions: ["invokeOnClose"]
          },
          {
            target: "closed",
            actions: ["invokeOnClose"]
          }
        ],
        "pointer.move": [
          {
            guard: "isOpenControlled",
            // We trigger toggleVisibility manually since the `ctx.open` has not changed yet (at this point)
            actions: ["setPointerMoveOpened", "invokeOnOpen", "toggleVisibility"]
          },
          {
            target: "open",
            actions: ["setPointerMoveOpened", "invokeOnOpen"]
          }
        ],
        "content.pointer.move": {
          guard: "isInteractive",
          target: "open"
        },
        "positioning.set": {
          actions: ["reposition"]
        }
      }
    }
  },
  implementations: {
    guards: {
      noVisibleTooltip: () => Lr.id === null,
      isVisible: ({ prop: e }) => e("id") === Lr.id,
      isInteractive: ({ prop: e }) => !!e("interactive"),
      hasPointerMoveOpened: ({ context: e }) => e.get("hasPointerMoveOpened"),
      isOpenControlled: ({ prop: e }) => e("open") !== void 0
    },
    actions: {
      setGlobalId: ({ prop: e }) => {
        Lr.id = e("id");
      },
      clearGlobalId: ({ prop: e }) => {
        e("id") === Lr.id && (Lr.id = null);
      },
      invokeOnOpen: ({ prop: e }) => {
        var t;
        (t = e("onOpenChange")) == null || t({ open: !0 });
      },
      invokeOnClose: ({ prop: e }) => {
        var t;
        (t = e("onOpenChange")) == null || t({ open: !1 });
      },
      closeIfDisabled: ({ prop: e, send: t }) => {
        e("disabled") && t({ type: "close", src: "disabled.change" });
      },
      reposition: ({ context: e, event: t, prop: r, scope: n }) => {
        if (t.type !== "positioning.set") return;
        const i = () => ap(n);
        return Mt(oc(n), i, {
          ...r("positioning"),
          ...t.options,
          defer: !0,
          listeners: !1,
          onComplete(o) {
            e.set("currentPlacement", o.placement);
          }
        });
      },
      toggleVisibility: ({ prop: e, event: t, send: r }) => {
        queueMicrotask(() => {
          r({
            type: e("open") ? "controlled.open" : "controlled.close",
            previousEvent: t
          });
        });
      },
      setPointerMoveOpened: ({ context: e }) => {
        e.set("hasPointerMoveOpened", !0);
      },
      clearPointerMoveOpened: ({ context: e }) => {
        e.set("hasPointerMoveOpened", !1);
      }
    },
    effects: {
      trackFocusVisible: ({ scope: e }) => {
        var t;
        return dO({ root: (t = e.getRootNode) == null ? void 0 : t.call(e) });
      },
      trackPositioning: ({ context: e, prop: t, scope: r }) => {
        e.get("currentPlacement") || e.set("currentPlacement", t("positioning").placement);
        const n = () => ap(r);
        return Mt(oc(r), n, {
          ...t("positioning"),
          defer: !0,
          onComplete(i) {
            e.set("currentPlacement", i.placement);
          }
        });
      },
      trackPointerlockChange: ({ send: e, scope: t }) => {
        const r = t.getDoc();
        return Ae(r, "pointerlockchange", () => e({ type: "close", src: "pointerlock:change" }), !1);
      },
      trackScroll: ({ send: e, prop: t, scope: r }) => {
        if (!t("closeOnScroll")) return;
        const n = oc(r);
        if (!n) return;
        const o = Pb(n).map((s) => Ae(s, "scroll", () => {
          e({ type: "close", src: "scroll" });
        }, {
          passive: !0,
          capture: !0
        }));
        return () => {
          o.forEach((s) => s == null ? void 0 : s());
        };
      },
      trackStore: ({ prop: e, send: t }) => {
        let r;
        return queueMicrotask(() => {
          r = cP(Lr, () => {
            Lr.id !== e("id") && t({ type: "close", src: "id.change" });
          });
        }), () => r == null ? void 0 : r();
      },
      trackEscapeKey: ({ send: e, prop: t }) => t("closeOnEscape") ? Ae(document, "keydown", (n) => {
        HE(n) || n.key === "Escape" && (n.stopPropagation(), e({ type: "close", src: "keydown.escape" }));
      }, !0) : void 0,
      waitForOpenDelay: ({ send: e, prop: t }) => {
        const r = setTimeout(() => {
          e({ type: "after.openDelay" });
        }, t("openDelay"));
        return () => clearTimeout(r);
      },
      waitForCloseDelay: ({ send: e, prop: t }) => {
        const r = setTimeout(() => {
          e({ type: "after.closeDelay" });
        }, t("closeDelay"));
        return () => clearTimeout(r);
      }
    }
  }
};
ue()([
  "aria-label",
  "closeDelay",
  "closeOnEscape",
  "closeOnPointerDown",
  "closeOnScroll",
  "closeOnClick",
  "dir",
  "disabled",
  "getRootNode",
  "id",
  "ids",
  "interactive",
  "onOpenChange",
  "defaultOpen",
  "open",
  "openDelay",
  "positioning"
]);
const gR = (e) => {
  const t = Hn(), { getRootNode: r } = bn(), { dir: n } = rs(), i = {
    id: t,
    dir: n,
    getRootNode: r,
    ...e
  }, o = yn(pR, i);
  return fR(o, Un);
}, mR = (e) => {
  const [t, { children: r, ...n }] = Ni(e), i = gR(n), o = Fi(oe({ present: i.open }, t));
  return /* @__PURE__ */ b(V0, { value: i, children: /* @__PURE__ */ b($i, { value: o, children: r }) });
}, vR = (e) => {
  const [t, { value: r, children: n }] = Ni(e), i = Fi(oe({ present: r.open }, t));
  return /* @__PURE__ */ b(V0, { value: r, children: /* @__PURE__ */ b($i, { value: i, children: n }) });
}, U0 = Z((e, t) => {
  const r = as(), n = oe(r.getTriggerProps(), e);
  return /* @__PURE__ */ b(ae.button, { ...n, ref: t });
});
U0.displayName = "TooltipTrigger";
function G0(e, t = []) {
  const r = Object.assign({}, e);
  for (const n of t)
    n in r && delete r[n];
  return r;
}
const bR = (e, t) => {
  var l;
  if (!e || typeof e != "string")
    return { invalid: !0, value: e };
  const [r, n] = e.split("/");
  if (!r || !n || r === "currentBg")
    return { invalid: !0, value: r };
  const i = t(`colors.${r}`), o = (l = t.raw(`opacity.${n}`)) == null ? void 0 : l.value;
  if (!o && isNaN(Number(n)))
    return { invalid: !0, value: r };
  const s = o ? Number(o) * 100 + "%" : `${n}%`, a = i != null ? i : r;
  return {
    invalid: !1,
    color: a,
    value: `color-mix(in srgb, ${a} ${s}, transparent)`
  };
}, Ie = (e) => (t, r) => {
  const n = r.utils.colorMix(t);
  if (n.invalid) return { [e]: t };
  const i = "--mix-" + e;
  return {
    [i]: n.value,
    [e]: `var(${i}, ${n.color})`
  };
};
function cu(e) {
  if (e === null || typeof e != "object") return e;
  if (Array.isArray(e)) return e.map((r) => cu(r));
  const t = Object.create(Object.getPrototypeOf(e));
  for (const r of Object.keys(e))
    t[r] = cu(e[r]);
  return t;
}
function uu(e, t) {
  if (t == null) return e;
  for (const r of Object.keys(t))
    if (!(t[r] === void 0 || r === "__proto__"))
      if (!St(e[r]) && St(t[r]))
        Object.assign(e, { [r]: t[r] });
      else if (e[r] && St(t[r]))
        uu(e[r], t[r]);
      else if (Array.isArray(t[r]) && Array.isArray(e[r])) {
        let n = 0;
        for (; n < t[r].length; n++)
          St(e[r][n]) && St(t[r][n]) ? uu(e[r][n], t[r][n]) : e[r][n] = t[r][n];
      } else
        Object.assign(e, { [r]: t[r] });
  return e;
}
function Wi(e, ...t) {
  for (const r of t)
    uu(e, r);
  return e;
}
const yR = (e) => e, Qe = (e) => e, ce = (e) => e, xR = (e) => e, _R = (e) => e, q0 = (e) => e, wR = (e) => e, SR = (e) => e, ER = (e) => e;
function K0() {
  const e = (t) => t;
  return new Proxy(e, {
    get() {
      return e;
    }
  });
}
const Ke = /* @__PURE__ */ K0(), Gd = /* @__PURE__ */ K0(), Y0 = (e) => e, X0 = (...e) => Wi({}, ...e.map(cu)), CR = /[^a-zA-Z0-9_\u0081-\uffff-]/g;
function kR(e) {
  return `${e}`.replace(CR, (t) => `\\${t}`);
}
const IR = /[A-Z]/g;
function OR(e) {
  return e.replace(IR, (t) => `-${t.toLowerCase()}`);
}
function J0(e, t = {}) {
  const { fallback: r = "", prefix: n = "" } = t, i = OR(["-", n, kR(e)].filter(Boolean).join("-"));
  return {
    var: i,
    ref: `var(${i}${r ? `, ${r}` : ""})`
  };
}
const PR = (e) => /^var\(--.+\)$/.test(e), tt = (e, t) => t != null ? `${e}(${t})` : t, En = (e) => {
  if (PR(e) || e == null) return e;
  const t = typeof e == "string" && !e.endsWith("deg");
  return typeof e == "number" || t ? `${e}deg` : e;
}, cp = (e) => ({
  values: ["outside", "inside", "mixed", "none"],
  transform(t, { token: r }) {
    var o;
    const n = r("colors.colorPalette.focusRing");
    return (o = {
      inside: {
        "--focus-ring-color": n,
        [e]: {
          outlineOffset: "0px",
          outlineWidth: "var(--focus-ring-width, 1px)",
          outlineColor: "var(--focus-ring-color)",
          outlineStyle: "var(--focus-ring-style, solid)",
          borderColor: "var(--focus-ring-color)"
        }
      },
      outside: {
        "--focus-ring-color": n,
        [e]: {
          outlineWidth: "var(--focus-ring-width, 2px)",
          outlineOffset: "var(--focus-ring-offset, 2px)",
          outlineStyle: "var(--focus-ring-style, solid)",
          outlineColor: "var(--focus-ring-color)"
        }
      },
      mixed: {
        "--focus-ring-color": n,
        [e]: {
          outlineWidth: "var(--focus-ring-width, 3px)",
          outlineStyle: "var(--focus-ring-style, solid)",
          outlineColor: "color-mix(in srgb, var(--focus-ring-color), transparent 60%)",
          borderColor: "var(--focus-ring-color)"
        }
      },
      none: {
        "--focus-ring-color": n,
        [e]: {
          outline: "none"
        }
      }
    }[t]) != null ? o : {};
  }
}), TR = Ie("borderColor"), Ar = (e) => ({
  transition: e,
  transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
  transitionDuration: "150ms"
}), RR = yR({
  hover: [
    "@media (hover: hover)",
    "&:is(:hover, [data-hover]):not(:disabled, [data-disabled])"
  ],
  active: "&:is(:active, [data-active]):not(:disabled, [data-disabled], [data-state=open])",
  focus: "&:is(:focus, [data-focus])",
  focusWithin: "&:is(:focus-within, [data-focus-within])",
  focusVisible: "&:is(:focus-visible, [data-focus-visible])",
  disabled: "&:is(:disabled, [disabled], [data-disabled], [aria-disabled=true])",
  visited: "&:visited",
  target: "&:target",
  readOnly: "&:is([data-readonly], [aria-readonly=true], [readonly])",
  readWrite: "&:read-write",
  empty: "&:is(:empty, [data-empty])",
  checked: "&:is(:checked, [data-checked], [aria-checked=true], [data-state=checked])",
  enabled: "&:enabled",
  expanded: "&:is([aria-expanded=true], [data-expanded], [data-state=expanded])",
  highlighted: "&[data-highlighted]",
  complete: "&[data-complete]",
  incomplete: "&[data-incomplete]",
  dragging: "&[data-dragging]",
  before: "&::before",
  after: "&::after",
  firstLetter: "&::first-letter",
  firstLine: "&::first-line",
  marker: "&::marker",
  selection: "&::selection",
  file: "&::file-selector-button",
  backdrop: "&::backdrop",
  first: "&:first-of-type",
  last: "&:last-of-type",
  notFirst: "&:not(:first-of-type)",
  notLast: "&:not(:last-of-type)",
  only: "&:only-child",
  even: "&:nth-of-type(even)",
  odd: "&:nth-of-type(odd)",
  peerFocus: ".peer:is(:focus, [data-focus]) ~ &",
  peerHover: ".peer:is(:hover, [data-hover]):not(:disabled, [data-disabled]) ~ &",
  peerActive: ".peer:is(:active, [data-active]):not(:disabled, [data-disabled]) ~ &",
  peerFocusWithin: ".peer:focus-within ~ &",
  peerFocusVisible: ".peer:is(:focus-visible, [data-focus-visible]) ~ &",
  peerDisabled: ".peer:is(:disabled, [disabled], [data-disabled]) ~ &",
  peerChecked: ".peer:is(:checked, [data-checked], [aria-checked=true], [data-state=checked]) ~ &",
  peerInvalid: ".peer:is(:invalid, [data-invalid], [aria-invalid=true]) ~ &",
  peerExpanded: ".peer:is([aria-expanded=true], [data-expanded], [data-state=expanded]) ~ &",
  peerPlaceholderShown: ".peer:placeholder-shown ~ &",
  groupFocus: ".group:is(:focus, [data-focus]) &",
  groupHover: ".group:is(:hover, [data-hover]):not(:disabled, [data-disabled]) &",
  groupActive: ".group:is(:active, [data-active]):not(:disabled, [data-disabled]) &",
  groupFocusWithin: ".group:focus-within &",
  groupFocusVisible: ".group:is(:focus-visible, [data-focus-visible]) &",
  groupDisabled: ".group:is(:disabled, [disabled], [data-disabled]) &",
  groupChecked: ".group:is(:checked, [data-checked], [aria-checked=true], [data-state=checked]) &",
  groupExpanded: ".group:is([aria-expanded=true], [data-expanded], [data-state=expanded]) &",
  groupInvalid: ".group:invalid &",
  indeterminate: "&:is(:indeterminate, [data-indeterminate], [aria-checked=mixed], [data-state=indeterminate])",
  required: "&:is([data-required], [aria-required=true])",
  valid: "&:is([data-valid], [data-state=valid])",
  invalid: "&:is([data-invalid], [aria-invalid=true], [data-state=invalid])",
  autofill: "&:autofill",
  inRange: "&:is(:in-range, [data-in-range])",
  outOfRange: "&:is(:out-of-range, [data-outside-range])",
  placeholder: "&::placeholder, &[data-placeholder]",
  placeholderShown: "&:is(:placeholder-shown, [data-placeholder-shown])",
  pressed: "&:is([aria-pressed=true], [data-pressed])",
  selected: "&:is([aria-selected=true], [data-selected])",
  grabbed: "&:is([aria-grabbed=true], [data-grabbed])",
  underValue: "&[data-state=under-value]",
  overValue: "&[data-state=over-value]",
  atValue: "&[data-state=at-value]",
  default: "&:default",
  optional: "&:optional",
  open: "&:is([open], [data-open], [data-state=open])",
  closed: "&:is([closed], [data-closed], [data-state=closed])",
  fullscreen: "&is(:fullscreen, [data-fullscreen])",
  loading: "&:is([data-loading], [aria-busy=true])",
  hidden: "&:is([hidden], [data-hidden])",
  current: "&[data-current]",
  currentPage: "&[aria-current=page]",
  currentStep: "&[aria-current=step]",
  today: "&[data-today]",
  unavailable: "&[data-unavailable]",
  rangeStart: "&[data-range-start]",
  rangeEnd: "&[data-range-end]",
  now: "&[data-now]",
  topmost: "&[data-topmost]",
  motionReduce: "@media (prefers-reduced-motion: reduce)",
  motionSafe: "@media (prefers-reduced-motion: no-preference)",
  print: "@media print",
  landscape: "@media (orientation: landscape)",
  portrait: "@media (orientation: portrait)",
  dark: ".dark &, .dark .chakra-theme:not(.light) &",
  light: ":root &, .light &",
  osDark: "@media (prefers-color-scheme: dark)",
  osLight: "@media (prefers-color-scheme: light)",
  highContrast: "@media (forced-colors: active)",
  lessContrast: "@media (prefers-contrast: less)",
  moreContrast: "@media (prefers-contrast: more)",
  ltr: "[dir=ltr] &",
  rtl: "[dir=rtl] &",
  scrollbar: "&::-webkit-scrollbar",
  scrollbarThumb: "&::-webkit-scrollbar-thumb",
  scrollbarTrack: "&::-webkit-scrollbar-track",
  horizontal: "&[data-orientation=horizontal]",
  vertical: "&[data-orientation=vertical]",
  icon: "& :where(svg)",
  starting: "@starting-style"
}), hi = J0("bg-currentcolor"), up = (e) => e === hi.ref || e === "currentBg", ke = (e) => ({
  ...e("colors"),
  currentBg: hi
}), AR = Y0({
  conditions: RR,
  utilities: {
    // background
    background: {
      values: ke,
      shorthand: ["bg"],
      transform(e, t) {
        if (up(t.raw)) return { background: hi.ref };
        const r = Ie("background")(e, t);
        return { ...r, [hi.var]: r == null ? void 0 : r.background };
      }
    },
    backgroundColor: {
      values: ke,
      shorthand: ["bgColor"],
      transform(e, t) {
        if (up(t.raw))
          return { backgroundColor: hi.ref };
        const r = Ie("backgroundColor")(e, t);
        return {
          ...r,
          [hi.var]: r == null ? void 0 : r.backgroundColor
        };
      }
    },
    backgroundSize: { shorthand: ["bgSize"] },
    backgroundPosition: { shorthand: ["bgPos"] },
    backgroundRepeat: { shorthand: ["bgRepeat"] },
    backgroundAttachment: { shorthand: ["bgAttachment"] },
    backgroundClip: {
      shorthand: ["bgClip"],
      values: ["text"],
      transform(e) {
        return e === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: e };
      }
    },
    backgroundGradient: {
      shorthand: ["bgGradient"],
      values(e) {
        return {
          ...e("gradients"),
          "to-t": "linear-gradient(to top, var(--gradient))",
          "to-tr": "linear-gradient(to top right, var(--gradient))",
          "to-r": "linear-gradient(to right, var(--gradient))",
          "to-br": "linear-gradient(to bottom right, var(--gradient))",
          "to-b": "linear-gradient(to bottom, var(--gradient))",
          "to-bl": "linear-gradient(to bottom left, var(--gradient))",
          "to-l": "linear-gradient(to left, var(--gradient))",
          "to-tl": "linear-gradient(to top left, var(--gradient))"
        };
      },
      transform(e) {
        return {
          "--gradient-stops": "var(--gradient-from), var(--gradient-to)",
          "--gradient": "var(--gradient-via-stops, var(--gradient-stops))",
          backgroundImage: e
        };
      }
    },
    gradientFrom: {
      values: ke,
      transform: Ie("--gradient-from")
    },
    gradientTo: {
      values: ke,
      transform: Ie("--gradient-to")
    },
    gradientVia: {
      values: ke,
      transform(e, t) {
        return {
          ...Ie("--gradient-via")(e, t),
          "--gradient-via-stops": "var(--gradient-from), var(--gradient-via), var(--gradient-to)"
        };
      }
    },
    backgroundImage: {
      values(e) {
        return { ...e("gradients"), ...e("assets") };
      },
      shorthand: ["bgImg", "bgImage"]
    },
    // border
    border: { values: "borders" },
    borderTop: { values: "borders" },
    borderLeft: { values: "borders" },
    borderBlockStart: { values: "borders" },
    borderRight: { values: "borders" },
    borderBottom: { values: "borders" },
    borderBlockEnd: { values: "borders" },
    borderInlineStart: { values: "borders", shorthand: ["borderStart"] },
    borderInlineEnd: { values: "borders", shorthand: ["borderEnd"] },
    borderInline: { values: "borders", shorthand: ["borderX"] },
    borderBlock: { values: "borders", shorthand: ["borderY"] },
    // border colors
    borderColor: {
      values: ke,
      transform: Ie("borderColor")
    },
    borderTopColor: {
      values: ke,
      transform: Ie("borderTopColor")
    },
    borderBlockStartColor: {
      values: ke,
      transform: Ie("borderBlockStartColor")
    },
    borderBottomColor: {
      values: ke,
      transform: Ie("borderBottomColor")
    },
    borderBlockEndColor: {
      values: ke,
      transform: Ie("borderBlockEndColor")
    },
    borderLeftColor: {
      values: ke,
      transform: Ie("borderLeftColor")
    },
    borderInlineStartColor: {
      values: ke,
      shorthand: ["borderStartColor"],
      transform: Ie("borderInlineStartColor")
    },
    borderRightColor: {
      values: ke,
      transform: Ie("borderRightColor")
    },
    borderInlineEndColor: {
      values: ke,
      shorthand: ["borderEndColor"],
      transform: Ie("borderInlineEndColor")
    },
    // border styles
    borderStyle: { values: "borderStyles" },
    borderTopStyle: { values: "borderStyles" },
    borderBlockStartStyle: { values: "borderStyles" },
    borderBottomStyle: { values: "borderStyles" },
    borderBlockEndStyle: {
      values: "borderStyles"
    },
    borderInlineStartStyle: {
      values: "borderStyles",
      shorthand: ["borderStartStyle"]
    },
    borderInlineEndStyle: {
      values: "borderStyles",
      shorthand: ["borderEndStyle"]
    },
    borderLeftStyle: { values: "borderStyles" },
    borderRightStyle: { values: "borderStyles" },
    // border radius
    borderRadius: { values: "radii", shorthand: ["rounded"] },
    borderTopLeftRadius: { values: "radii", shorthand: ["roundedTopLeft"] },
    borderStartStartRadius: {
      values: "radii",
      shorthand: ["roundedStartStart", "borderTopStartRadius"]
    },
    borderEndStartRadius: {
      values: "radii",
      shorthand: ["roundedEndStart", "borderBottomStartRadius"]
    },
    borderTopRightRadius: {
      values: "radii",
      shorthand: ["roundedTopRight"]
    },
    borderStartEndRadius: {
      values: "radii",
      shorthand: ["roundedStartEnd", "borderTopEndRadius"]
    },
    borderEndEndRadius: {
      values: "radii",
      shorthand: ["roundedEndEnd", "borderBottomEndRadius"]
    },
    borderBottomLeftRadius: {
      values: "radii",
      shorthand: ["roundedBottomLeft"]
    },
    borderBottomRightRadius: {
      values: "radii",
      shorthand: ["roundedBottomRight"]
    },
    borderInlineStartRadius: {
      values: "radii",
      property: "borderRadius",
      shorthand: ["roundedStart", "borderStartRadius"],
      transform: (e) => ({
        borderStartStartRadius: e,
        borderEndStartRadius: e
      })
    },
    borderInlineEndRadius: {
      values: "radii",
      property: "borderRadius",
      shorthand: ["roundedEnd", "borderEndRadius"],
      transform: (e) => ({
        borderStartEndRadius: e,
        borderEndEndRadius: e
      })
    },
    borderTopRadius: {
      values: "radii",
      property: "borderRadius",
      shorthand: ["roundedTop"],
      transform: (e) => ({
        borderTopLeftRadius: e,
        borderTopRightRadius: e
      })
    },
    borderBottomRadius: {
      values: "radii",
      property: "borderRadius",
      shorthand: ["roundedBottom"],
      transform: (e) => ({
        borderBottomLeftRadius: e,
        borderBottomRightRadius: e
      })
    },
    borderLeftRadius: {
      values: "radii",
      property: "borderRadius",
      shorthand: ["roundedLeft"],
      transform: (e) => ({
        borderTopLeftRadius: e,
        borderBottomLeftRadius: e
      })
    },
    borderRightRadius: {
      values: "radii",
      property: "borderRadius",
      shorthand: ["roundedRight"],
      transform: (e) => ({
        borderTopRightRadius: e,
        borderBottomRightRadius: e
      })
    },
    borderWidth: { values: "borderWidths" },
    borderBlockStartWidth: { values: "borderWidths" },
    borderTopWidth: { values: "borderWidths" },
    borderBottomWidth: { values: "borderWidths" },
    borderBlockEndWidth: { values: "borderWidths" },
    borderRightWidth: { values: "borderWidths" },
    borderInlineWidth: {
      values: "borderWidths",
      shorthand: ["borderXWidth"]
    },
    borderInlineStartWidth: {
      values: "borderWidths",
      shorthand: ["borderStartWidth"]
    },
    borderInlineEndWidth: {
      values: "borderWidths",
      shorthand: ["borderEndWidth"]
    },
    borderLeftWidth: { values: "borderWidths" },
    borderBlockWidth: {
      values: "borderWidths",
      shorthand: ["borderYWidth"]
    },
    // colors
    color: {
      values: ke,
      transform: Ie("color")
    },
    fill: {
      values: ke,
      transform: Ie("fill")
    },
    stroke: {
      values: ke,
      transform: Ie("stroke")
    },
    accentColor: {
      values: ke,
      transform: Ie("accentColor")
    },
    // divide
    divideX: {
      values: { type: "string" },
      transform(e) {
        return {
          "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
            borderInlineStartWidth: e,
            borderInlineEndWidth: "0px"
          }
        };
      }
    },
    divideY: {
      values: { type: "string" },
      transform(e) {
        return {
          "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
            borderTopWidth: e,
            borderBottomWidth: "0px"
          }
        };
      }
    },
    divideColor: {
      values: ke,
      transform(e, t) {
        return {
          "& > :not(style, [hidden]) ~ :not(style, [hidden])": TR(
            e,
            t
          )
        };
      }
    },
    divideStyle: {
      property: "borderStyle",
      transform(e) {
        return {
          "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
            borderStyle: e
          }
        };
      }
    },
    // effects
    boxShadow: { values: "shadows", shorthand: ["shadow"] },
    boxShadowColor: {
      values: ke,
      transform: Ie("--shadow-color"),
      shorthand: ["shadowColor"]
    },
    mixBlendMode: { shorthand: ["blendMode"] },
    backgroundBlendMode: { shorthand: ["bgBlendMode"] },
    opacity: { values: "opacity" },
    // filters
    filter: {
      transform(e) {
        return e !== "auto" ? { filter: e } : {
          filter: "var(--blur) var(--brightness) var(--contrast) var(--grayscale) var(--hue-rotate) var(--invert) var(--saturate) var(--sepia) var(--drop-shadow)"
        };
      }
    },
    blur: {
      values: "blurs",
      transform: (e) => ({ "--blur": tt("blur", e) })
    },
    brightness: {
      transform: (e) => ({ "--brightness": tt("brightness", e) })
    },
    contrast: {
      transform: (e) => ({ "--contrast": tt("contrast", e) })
    },
    grayscale: {
      transform: (e) => ({ "--grayscale": tt("grayscale", e) })
    },
    hueRotate: {
      transform: (e) => ({ "--hue-rotate": tt("hue-rotate", En(e)) })
    },
    invert: { transform: (e) => ({ "--invert": tt("invert", e) }) },
    saturate: {
      transform: (e) => ({ "--saturate": tt("saturate", e) })
    },
    sepia: { transform: (e) => ({ "--sepia": tt("sepia", e) }) },
    dropShadow: {
      transform: (e) => ({ "--drop-shadow": tt("drop-shadow", e) })
    },
    // backdrop filters
    backdropFilter: {
      transform(e) {
        return e !== "auto" ? { backdropFilter: e } : {
          backdropFilter: "var(--backdrop-blur) var(--backdrop-brightness) var(--backdrop-contrast) var(--backdrop-grayscale) var(--backdrop-hue-rotate) var(--backdrop-invert) var(--backdrop-opacity) var(--backdrop-saturate) var(--backdrop-sepia)"
        };
      }
    },
    backdropBlur: {
      values: "blurs",
      transform: (e) => ({ "--backdrop-blur": tt("blur", e) })
    },
    backdropBrightness: {
      transform: (e) => ({
        "--backdrop-brightness": tt("brightness", e)
      })
    },
    backdropContrast: {
      transform: (e) => ({ "--backdrop-contrast": tt("contrast", e) })
    },
    backdropGrayscale: {
      transform: (e) => ({
        "--backdrop-grayscale": tt("grayscale", e)
      })
    },
    backdropHueRotate: {
      transform: (e) => ({
        "--backdrop-hue-rotate": tt("hue-rotate", En(e))
      })
    },
    backdropInvert: {
      transform: (e) => ({ "--backdrop-invert": tt("invert", e) })
    },
    backdropOpacity: {
      transform: (e) => ({ "--backdrop-opacity": tt("opacity", e) })
    },
    backdropSaturate: {
      transform: (e) => ({ "--backdrop-saturate": tt("saturate", e) })
    },
    backdropSepia: {
      transform: (e) => ({ "--backdrop-sepia": tt("sepia", e) })
    },
    // flexbox
    flexBasis: { values: "sizes" },
    gap: { values: "spacing" },
    rowGap: { values: "spacing", shorthand: ["gapY"] },
    columnGap: { values: "spacing", shorthand: ["gapX"] },
    flexDirection: { shorthand: ["flexDir"] },
    // grid
    gridGap: { values: "spacing" },
    gridColumnGap: { values: "spacing" },
    gridRowGap: { values: "spacing" },
    // interactivity
    outlineColor: {
      values: ke,
      transform: Ie("outlineColor")
    },
    focusRing: cp("&:is(:focus, [data-focus])"),
    focusVisibleRing: cp(
      "&:is(:focus-visible, [data-focus-visible])"
    ),
    focusRingColor: {
      values: ke,
      transform: Ie("--focus-ring-color")
    },
    focusRingOffset: {
      values: "spacing",
      transform: (e) => ({ "--focus-ring-offset": e })
    },
    focusRingWidth: {
      values: "borderWidths",
      property: "outlineWidth",
      transform: (e) => ({ "--focus-ring-width": e })
    },
    focusRingStyle: {
      values: "borderStyles",
      property: "outlineStyle",
      transform: (e) => ({ "--focus-ring-style": e })
    },
    // layout
    aspectRatio: { values: "aspectRatios" },
    width: { values: "sizes", shorthand: ["w"] },
    inlineSize: { values: "sizes" },
    height: { values: "sizes", shorthand: ["h"] },
    blockSize: { values: "sizes" },
    boxSize: {
      values: "sizes",
      property: "width",
      transform: (e) => ({ width: e, height: e })
    },
    minWidth: { values: "sizes", shorthand: ["minW"] },
    minInlineSize: { values: "sizes" },
    minHeight: { values: "sizes", shorthand: ["minH"] },
    minBlockSize: { values: "sizes" },
    maxWidth: { values: "sizes", shorthand: ["maxW"] },
    maxInlineSize: { values: "sizes" },
    maxHeight: { values: "sizes", shorthand: ["maxH"] },
    maxBlockSize: { values: "sizes" },
    hideFrom: {
      values: "breakpoints",
      //@ts-ignore
      transform: (e, { raw: t, token: r }) => ({
        [r.raw(`breakpoints.${t}`) ? `@breakpoint ${t}` : `@media screen and (min-width: ${e})`]: { display: "none" }
      })
    },
    hideBelow: {
      values: "breakpoints",
      //@ts-ignore
      transform(e, { raw: t, token: r }) {
        return {
          [r.raw(`breakpoints.${t}`) ? `@breakpoint ${t}Down` : `@media screen and (max-width: ${e})`]: {
            display: "none"
          }
        };
      }
    },
    // scroll
    overscrollBehavior: { shorthand: ["overscroll"] },
    overscrollBehaviorX: { shorthand: ["overscrollX"] },
    overscrollBehaviorY: { shorthand: ["overscrollY"] },
    scrollbar: {
      values: ["visible", "hidden"],
      transform(e) {
        switch (e) {
          case "visible":
            return {
              msOverflowStyle: "auto",
              scrollbarWidth: "auto",
              "&::-webkit-scrollbar": { display: "block" }
            };
          case "hidden":
            return {
              msOverflowStyle: "none",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" }
            };
          default:
            return {};
        }
      }
    },
    scrollbarColor: {
      values: ke,
      transform: Ie("scrollbarColor")
    },
    scrollbarGutter: { values: "spacing" },
    scrollbarWidth: { values: "sizes" },
    // scroll margin
    scrollMargin: { values: "spacing" },
    scrollMarginTop: { values: "spacing" },
    scrollMarginBottom: { values: "spacing" },
    scrollMarginLeft: { values: "spacing" },
    scrollMarginRight: { values: "spacing" },
    scrollMarginX: {
      values: "spacing",
      transform: (e) => ({ scrollMarginLeft: e, scrollMarginRight: e })
    },
    scrollMarginY: {
      values: "spacing",
      transform: (e) => ({ scrollMarginTop: e, scrollMarginBottom: e })
    },
    // scroll padding
    scrollPadding: { values: "spacing" },
    scrollPaddingTop: { values: "spacing" },
    scrollPaddingBottom: { values: "spacing" },
    scrollPaddingLeft: { values: "spacing" },
    scrollPaddingRight: { values: "spacing" },
    scrollPaddingInline: { values: "spacing", shorthand: ["scrollPaddingX"] },
    scrollPaddingBlock: { values: "spacing", shorthand: ["scrollPaddingY"] },
    // scroll snap
    scrollSnapType: {
      values: {
        none: "none",
        x: "x var(--scroll-snap-strictness)",
        y: "y var(--scroll-snap-strictness)",
        both: "both var(--scroll-snap-strictness)"
      }
    },
    scrollSnapStrictness: {
      values: ["mandatory", "proximity"],
      transform: (e) => ({ "--scroll-snap-strictness": e })
    },
    scrollSnapMargin: { values: "spacing" },
    scrollSnapMarginTop: { values: "spacing" },
    scrollSnapMarginBottom: { values: "spacing" },
    scrollSnapMarginLeft: { values: "spacing" },
    scrollSnapMarginRight: { values: "spacing" },
    // list
    listStylePosition: { shorthand: ["listStylePos"] },
    listStyleImage: { values: "assets", shorthand: ["listStyleImg"] },
    // position
    position: { shorthand: ["pos"] },
    zIndex: { values: "zIndex" },
    inset: { values: "spacing" },
    insetInline: { values: "spacing", shorthand: ["insetX"] },
    insetBlock: { values: "spacing", shorthand: ["insetY"] },
    top: { values: "spacing" },
    insetBlockStart: { values: "spacing" },
    bottom: { values: "spacing" },
    insetBlockEnd: { values: "spacing" },
    left: { values: "spacing" },
    right: { values: "spacing" },
    insetInlineStart: {
      values: "spacing",
      shorthand: ["insetStart"]
    },
    insetInlineEnd: {
      values: "spacing",
      shorthand: ["insetEnd"]
    },
    // shadow / ring
    ring: {
      transform(e) {
        return {
          "--ring-offset-shadow": "var(--ring-inset) 0 0 0 var(--ring-offset-width) var(--ring-offset-color)",
          "--ring-shadow": "var(--ring-inset) 0 0 0 calc(var(--ring-width) + var(--ring-offset-width)) var(--ring-color)",
          "--ring-width": e,
          boxShadow: "var(--ring-offset-shadow), var(--ring-shadow), var(--shadow, 0 0 #0000)"
        };
      }
    },
    ringColor: {
      values: ke,
      transform: Ie("--ring-color")
    },
    ringOffset: {
      transform: (e) => ({ "--ring-offset-width": e })
    },
    ringOffsetColor: {
      values: ke,
      transform: Ie("--ring-offset-color")
    },
    ringInset: {
      transform: (e) => ({ "--ring-inset": e })
    },
    // margin
    margin: { values: "spacing", shorthand: ["m"] },
    marginTop: { values: "spacing", shorthand: ["mt"] },
    marginBlockStart: { values: "spacing" },
    marginRight: { values: "spacing", shorthand: ["mr"] },
    marginBottom: { values: "spacing", shorthand: ["mb"] },
    marginBlockEnd: { values: "spacing" },
    marginLeft: { values: "spacing", shorthand: ["ml"] },
    marginInlineStart: { values: "spacing", shorthand: ["ms", "marginStart"] },
    marginInlineEnd: { values: "spacing", shorthand: ["me", "marginEnd"] },
    marginInline: { values: "spacing", shorthand: ["mx", "marginX"] },
    marginBlock: { values: "spacing", shorthand: ["my", "marginY"] },
    // padding
    padding: { values: "spacing", shorthand: ["p"] },
    paddingTop: { values: "spacing", shorthand: ["pt"] },
    paddingRight: { values: "spacing", shorthand: ["pr"] },
    paddingBottom: { values: "spacing", shorthand: ["pb"] },
    paddingBlockStart: { values: "spacing" },
    paddingBlockEnd: { values: "spacing" },
    paddingLeft: { values: "spacing", shorthand: ["pl"] },
    paddingInlineStart: {
      values: "spacing",
      shorthand: ["ps", "paddingStart"]
    },
    paddingInlineEnd: { values: "spacing", shorthand: ["pe", "paddingEnd"] },
    paddingInline: { values: "spacing", shorthand: ["px", "paddingX"] },
    paddingBlock: { values: "spacing", shorthand: ["py", "paddingY"] },
    // text decoration
    textDecoration: { shorthand: ["textDecor"] },
    textDecorationColor: {
      values: ke,
      transform: Ie("textDecorationColor")
    },
    textShadow: { values: "shadows" },
    // transform
    transform: {
      transform: (e) => {
        let t = e;
        return e === "auto" && (t = "translateX(var(--translate-x, 0)) translateY(var(--translate-y, 0)) rotate(var(--rotate, 0)) scaleX(var(--scale-x, 1)) scaleY(var(--scale-y, 1)) skewX(var(--skew-x, 0)) skewY(var(--skew-y, 0))"), e === "auto-gpu" && (t = "translate3d(var(--translate-x, 0), var(--translate-y, 0), 0) rotate(var(--rotate, 0)) scaleX(var(--scale-x, 1)) scaleY(var(--scale-y, 1)) skewX(var(--skew-x, 0)) skewY(var(--skew-y, 0))"), { transform: t };
      }
    },
    skewX: { transform: (e) => ({ "--skew-x": En(e) }) },
    skewY: { transform: (e) => ({ "--skew-y": En(e) }) },
    scaleX: { transform: (e) => ({ "--scale-x": e }) },
    scaleY: { transform: (e) => ({ "--scale-y": e }) },
    scale: {
      transform(e) {
        return e !== "auto" ? { scale: e } : {
          scale: "var(--scale-x, 1) var(--scale-y, 1)"
        };
      }
    },
    spaceXReverse: {
      values: { type: "boolean" },
      transform(e) {
        return {
          "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
            "--space-x-reverse": e ? "1" : void 0
          }
        };
      }
    },
    spaceX: {
      property: "marginInlineStart",
      values: "spacing",
      transform: (e) => ({
        "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
          "--space-x-reverse": "0",
          marginInlineStart: `calc(${e} * calc(1 - var(--space-x-reverse)))`,
          marginInlineEnd: `calc(${e} * var(--space-x-reverse))`
        }
      })
    },
    spaceYReverse: {
      values: { type: "boolean" },
      transform(e) {
        return {
          "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
            "--space-y-reverse": e ? "1" : void 0
          }
        };
      }
    },
    spaceY: {
      property: "marginTop",
      values: "spacing",
      transform: (e) => ({
        "& > :not(style, [hidden]) ~ :not(style, [hidden])": {
          "--space-y-reverse": "0",
          marginTop: `calc(${e} * calc(1 - var(--space-y-reverse)))`,
          marginBottom: `calc(${e} * var(--space-y-reverse))`
        }
      })
    },
    rotate: {
      transform(e) {
        return e !== "auto" ? { rotate: En(e) } : {
          rotate: "var(--rotate-x, 0) var(--rotate-y, 0) var(--rotate-z, 0)"
        };
      }
    },
    rotateX: {
      transform(e) {
        return { "--rotate-x": En(e) };
      }
    },
    rotateY: {
      transform(e) {
        return { "--rotate-y": En(e) };
      }
    },
    // transform / translate
    translate: {
      transform(e) {
        return e !== "auto" ? { translate: e } : {
          translate: "var(--translate-x) var(--translate-y)"
        };
      }
    },
    translateX: {
      values: "spacing",
      transform: (e) => ({ "--translate-x": e })
    },
    translateY: {
      values: "spacing",
      transform: (e) => ({ "--translate-y": e })
    },
    // transition
    transition: {
      values: [
        "all",
        "common",
        "colors",
        "opacity",
        "position",
        "backgrounds",
        "size",
        "shadow",
        "transform"
      ],
      transform(e) {
        switch (e) {
          case "all":
            return Ar("all");
          case "position":
            return Ar(
              "left, right, top, bottom, inset-inline, inset-block"
            );
          case "colors":
            return Ar(
              "color, background-color, border-color, text-decoration-color, fill, stroke"
            );
          case "opacity":
            return Ar("opacity");
          case "shadow":
            return Ar("box-shadow");
          case "transform":
            return Ar("transform");
          case "size":
            return Ar("width, height");
          case "backgrounds":
            return Ar(
              "background, background-color, background-image, background-position"
            );
          case "common":
            return Ar(
              "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter"
            );
          default:
            return { transition: e };
        }
      }
    },
    transitionDuration: { values: "durations" },
    transitionProperty: {
      values: {
        common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, translate, transform",
        colors: "background-color, border-color, color, fill, stroke",
        size: "width, height",
        position: "left, right, top, bottom, inset-inline, inset-block",
        background: "background, background-color, background-image, background-position"
      }
    },
    transitionTimingFunction: { values: "easings" },
    // animation
    animation: { values: "animations" },
    animationDuration: { values: "durations" },
    animationDelay: { values: "durations" },
    animationTimingFunction: { values: "easings" },
    // typography
    fontFamily: { values: "fonts" },
    fontSize: { values: "fontSizes" },
    fontWeight: { values: "fontWeights" },
    lineHeight: { values: "lineHeights" },
    letterSpacing: { values: "letterSpacings" },
    textIndent: { values: "spacing" },
    truncate: {
      values: { type: "boolean" },
      transform(e) {
        return e === !0 ? {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        } : {};
      }
    },
    lineClamp: {
      transform(e) {
        return e === "none" ? {
          WebkitLineClamp: "unset"
        } : {
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: e,
          WebkitBoxOrient: "vertical",
          textWrap: "wrap"
        };
      }
    },
    // helpers
    srOnly: {
      values: { type: "boolean" },
      transform(e) {
        return NR[e] || {};
      }
    },
    debug: {
      values: { type: "boolean" },
      transform(e) {
        return e ? {
          outline: "1px solid blue !important",
          "& > *": {
            outline: "1px solid red !important"
          }
        } : {};
      }
    },
    caretColor: {
      values: ke,
      transform: Ie("caretColor")
    },
    cursor: { values: "cursor" }
  }
}), NR = {
  true: {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: "0"
  },
  false: {
    position: "static",
    width: "auto",
    height: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    clip: "auto",
    whiteSpace: "normal"
  }
};
var FR = "", $R = FR.split(","), LR = "WebkitAppearance,WebkitBorderBefore,WebkitBorderBeforeColor,WebkitBorderBeforeStyle,WebkitBorderBeforeWidth,WebkitBoxReflect,WebkitLineClamp,WebkitMask,WebkitMaskAttachment,WebkitMaskClip,WebkitMaskComposite,WebkitMaskImage,WebkitMaskOrigin,WebkitMaskPosition,WebkitMaskPositionX,WebkitMaskPositionY,WebkitMaskRepeat,WebkitMaskRepeatX,WebkitMaskRepeatY,WebkitMaskSize,WebkitOverflowScrolling,WebkitTapHighlightColor,WebkitTextFillColor,WebkitTextStroke,WebkitTextStrokeColor,WebkitTextStrokeWidth,WebkitTouchCallout,WebkitUserModify,WebkitUserSelect,accentColor,alignContent,alignItems,alignSelf,alignTracks,all,anchorName,anchorScope,animation,animationComposition,animationDelay,animationDirection,animationDuration,animationFillMode,animationIterationCount,animationName,animationPlayState,animationRange,animationRangeEnd,animationRangeStart,animationTimeline,animationTimingFunction,appearance,aspectRatio,backdropFilter,backfaceVisibility,background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundPositionX,backgroundPositionY,backgroundRepeat,backgroundSize,blockSize,border,borderBlock,borderBlockColor,borderBlockEnd,borderBlockEndColor,borderBlockEndStyle,borderBlockEndWidth,borderBlockStart,borderBlockStartColor,borderBlockStartStyle,borderBlockStartWidth,borderBlockStyle,borderBlockWidth,borderBottom,borderBottomColor,borderBottomLeftRadius,borderBottomRightRadius,borderBottomStyle,borderBottomWidth,borderCollapse,borderColor,borderEndEndRadius,borderEndStartRadius,borderImage,borderImageOutset,borderImageRepeat,borderImageSlice,borderImageSource,borderImageWidth,borderInline,borderInlineColor,borderInlineEnd,borderInlineEndColor,borderInlineEndStyle,borderInlineEndWidth,borderInlineStart,borderInlineStartColor,borderInlineStartStyle,borderInlineStartWidth,borderInlineStyle,borderInlineWidth,borderLeft,borderLeftColor,borderLeftStyle,borderLeftWidth,borderRadius,borderRight,borderRightColor,borderRightStyle,borderRightWidth,borderSpacing,borderStartEndRadius,borderStartStartRadius,borderStyle,borderTop,borderTopColor,borderTopLeftRadius,borderTopRightRadius,borderTopStyle,borderTopWidth,borderWidth,bottom,boxAlign,boxDecorationBreak,boxDirection,boxFlex,boxFlexGroup,boxLines,boxOrdinalGroup,boxOrient,boxPack,boxShadow,boxSizing,breakAfter,breakBefore,breakInside,captionSide,caret,caretColor,caretShape,clear,clip,clipPath,clipRule,color,colorInterpolationFilters,colorScheme,columnCount,columnFill,columnGap,columnRule,columnRuleColor,columnRuleStyle,columnRuleWidth,columnSpan,columnWidth,columns,contain,containIntrinsicBlockSize,containIntrinsicHeight,containIntrinsicInlineSize,containIntrinsicSize,containIntrinsicWidth,container,containerName,containerType,content,contentVisibility,counterIncrement,counterReset,counterSet,cursor,cx,cy,d,direction,display,dominantBaseline,emptyCells,fieldSizing,fill,fillOpacity,fillRule,filter,flex,flexBasis,flexDirection,flexFlow,flexGrow,flexShrink,flexWrap,float,floodColor,floodOpacity,font,fontFamily,fontFeatureSettings,fontKerning,fontLanguageOverride,fontOpticalSizing,fontPalette,fontSize,fontSizeAdjust,fontSmooth,fontStretch,fontStyle,fontSynthesis,fontSynthesisPosition,fontSynthesisSmallCaps,fontSynthesisStyle,fontSynthesisWeight,fontVariant,fontVariantAlternates,fontVariantCaps,fontVariantEastAsian,fontVariantEmoji,fontVariantLigatures,fontVariantNumeric,fontVariantPosition,fontVariationSettings,fontWeight,forcedColorAdjust,gap,grid,gridArea,gridAutoColumns,gridAutoFlow,gridAutoRows,gridColumn,gridColumnEnd,gridColumnGap,gridColumnStart,gridGap,gridRow,gridRowEnd,gridRowGap,gridRowStart,gridTemplate,gridTemplateAreas,gridTemplateColumns,gridTemplateRows,hangingPunctuation,height,hyphenateCharacter,hyphenateLimitChars,hyphens,imageOrientation,imageRendering,imageResolution,imeMode,initialLetter,initialLetterAlign,inlineSize,inset,insetBlock,insetBlockEnd,insetBlockStart,insetInline,insetInlineEnd,insetInlineStart,interpolateSize,isolation,justifyContent,justifyItems,justifySelf,justifyTracks,left,letterSpacing,lightingColor,lineBreak,lineClamp,lineHeight,lineHeightStep,listStyle,listStyleImage,listStylePosition,listStyleType,margin,marginBlock,marginBlockEnd,marginBlockStart,marginBottom,marginInline,marginInlineEnd,marginInlineStart,marginLeft,marginRight,marginTop,marginTrim,marker,markerEnd,markerMid,markerStart,mask,maskBorder,maskBorderMode,maskBorderOutset,maskBorderRepeat,maskBorderSlice,maskBorderSource,maskBorderWidth,maskClip,maskComposite,maskImage,maskMode,maskOrigin,maskPosition,maskRepeat,maskSize,maskType,masonryAutoFlow,mathDepth,mathShift,mathStyle,maxBlockSize,maxHeight,maxInlineSize,maxLines,maxWidth,minBlockSize,minHeight,minInlineSize,minWidth,mixBlendMode,objectFit,objectPosition,offset,offsetAnchor,offsetDistance,offsetPath,offsetPosition,offsetRotate,opacity,order,orphans,outline,outlineColor,outlineOffset,outlineStyle,outlineWidth,overflow,overflowAnchor,overflowBlock,overflowClipBox,overflowClipMargin,overflowInline,overflowWrap,overflowX,overflowY,overlay,overscrollBehavior,overscrollBehaviorBlock,overscrollBehaviorInline,overscrollBehaviorX,overscrollBehaviorY,padding,paddingBlock,paddingBlockEnd,paddingBlockStart,paddingBottom,paddingInline,paddingInlineEnd,paddingInlineStart,paddingLeft,paddingRight,paddingTop,page,pageBreakAfter,pageBreakBefore,pageBreakInside,paintOrder,perspective,perspectiveOrigin,placeContent,placeItems,placeSelf,pointerEvents,position,positionAnchor,positionArea,positionTry,positionTryFallbacks,positionTryOrder,positionVisibility,printColorAdjust,quotes,r,resize,right,rotate,rowGap,rubyAlign,rubyMerge,rubyPosition,rx,ry,scale,scrollBehavior,scrollMargin,scrollMarginBlock,scrollMarginBlockEnd,scrollMarginBlockStart,scrollMarginBottom,scrollMarginInline,scrollMarginInlineEnd,scrollMarginInlineStart,scrollMarginLeft,scrollMarginRight,scrollMarginTop,scrollPadding,scrollPaddingBlock,scrollPaddingBlockEnd,scrollPaddingBlockStart,scrollPaddingBottom,scrollPaddingInline,scrollPaddingInlineEnd,scrollPaddingInlineStart,scrollPaddingLeft,scrollPaddingRight,scrollPaddingTop,scrollSnapAlign,scrollSnapCoordinate,scrollSnapDestination,scrollSnapPointsX,scrollSnapPointsY,scrollSnapStop,scrollSnapType,scrollSnapTypeX,scrollSnapTypeY,scrollTimeline,scrollTimelineAxis,scrollTimelineName,scrollbarColor,scrollbarGutter,scrollbarWidth,shapeImageThreshold,shapeMargin,shapeOutside,shapeRendering,stopColor,stopOpacity,stroke,strokeDasharray,strokeDashoffset,strokeLinecap,strokeLinejoin,strokeMiterlimit,strokeOpacity,strokeWidth,tabSize,tableLayout,textAlign,textAlignLast,textAnchor,textBox,textBoxEdge,textBoxTrim,textCombineUpright,textDecoration,textDecorationColor,textDecorationLine,textDecorationSkip,textDecorationSkipInk,textDecorationStyle,textDecorationThickness,textEmphasis,textEmphasisColor,textEmphasisPosition,textEmphasisStyle,textIndent,textJustify,textOrientation,textOverflow,textRendering,textShadow,textSizeAdjust,textSpacingTrim,textTransform,textUnderlineOffset,textUnderlinePosition,textWrap,textWrapMode,textWrapStyle,timelineScope,top,touchAction,transform,transformBox,transformOrigin,transformStyle,transition,transitionBehavior,transitionDelay,transitionDuration,transitionProperty,transitionTimingFunction,translate,unicodeBidi,userSelect,vectorEffect,verticalAlign,viewTimeline,viewTimelineAxis,viewTimelineInset,viewTimelineName,viewTransitionName,visibility,whiteSpace,whiteSpaceCollapse,widows,width,willChange,wordBreak,wordSpacing,wordWrap,writingMode,x,y,zIndex,zoom,alignmentBaseline,baselineShift,colorInterpolation,colorRendering,glyphOrientationVertical", VR = LR.split(",").concat($R), zR = new Map(VR.map((e) => [e, !0]));
function DR(e) {
  const t = /* @__PURE__ */ Object.create(null);
  return (r) => (t[r] === void 0 && (t[r] = e(r)), t[r]);
}
var MR = /&|@/, BR = /* @__PURE__ */ DR((e) => zR.has(e) || e.startsWith("--") || MR.test(e));
const WR = (e) => e != null;
function qr(e, t, r = {}) {
  const { stop: n, getKey: i } = r;
  function o(s, a = []) {
    var l;
    if (St(s) || Array.isArray(s)) {
      const c = {};
      for (const [u, f] of Object.entries(s)) {
        const d = (l = i == null ? void 0 : i(u, f)) != null ? l : u, p = [...a, d];
        if (n != null && n(s, p))
          return t(s, a);
        const g = o(f, p);
        WR(g) && (c[d] = g);
      }
      return c;
    }
    return t(s, a);
  }
  return o(e);
}
function Z0(e, t) {
  return Array.isArray(e) ? e.map((r) => t(r)) : St(e) ? qr(e, (r) => t(r)) : e != null ? t(e) : e;
}
function HR(e, t) {
  const r = {};
  return qr(
    e,
    (n, i) => {
      n && (r[i.join(".")] = n.value);
    },
    { stop: t }
  ), r;
}
var sc, dp;
function jR() {
  if (dp) return sc;
  dp = 1, sc = o, o.default = o, o.stable = c, o.stableStringify = c;
  var e = "[...]", t = "[Circular]", r = [], n = [];
  function i() {
    return {
      depthLimit: Number.MAX_SAFE_INTEGER,
      edgesLimit: Number.MAX_SAFE_INTEGER
    };
  }
  function o(d, p, g, h) {
    typeof h == "undefined" && (h = i()), a(d, "", 0, [], void 0, 0, h);
    var m;
    try {
      n.length === 0 ? m = JSON.stringify(d, p, g) : m = JSON.stringify(d, f(p), g);
    } catch (y) {
      return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally {
      for (; r.length !== 0; ) {
        var v = r.pop();
        v.length === 4 ? Object.defineProperty(v[0], v[1], v[3]) : v[0][v[1]] = v[2];
      }
    }
    return m;
  }
  function s(d, p, g, h) {
    var m = Object.getOwnPropertyDescriptor(h, g);
    m.get !== void 0 ? m.configurable ? (Object.defineProperty(h, g, { value: d }), r.push([h, g, p, m])) : n.push([p, g, d]) : (h[g] = d, r.push([h, g, p]));
  }
  function a(d, p, g, h, m, v, y) {
    v += 1;
    var x;
    if (typeof d == "object" && d !== null) {
      for (x = 0; x < h.length; x++)
        if (h[x] === d) {
          s(t, d, p, m);
          return;
        }
      if (typeof y.depthLimit != "undefined" && v > y.depthLimit) {
        s(e, d, p, m);
        return;
      }
      if (typeof y.edgesLimit != "undefined" && g + 1 > y.edgesLimit) {
        s(e, d, p, m);
        return;
      }
      if (h.push(d), Array.isArray(d))
        for (x = 0; x < d.length; x++)
          a(d[x], x, x, h, d, v, y);
      else {
        var S = Object.keys(d);
        for (x = 0; x < S.length; x++) {
          var _ = S[x];
          a(d[_], _, x, h, d, v, y);
        }
      }
      h.pop();
    }
  }
  function l(d, p) {
    return d < p ? -1 : d > p ? 1 : 0;
  }
  function c(d, p, g, h) {
    typeof h == "undefined" && (h = i());
    var m = u(d, "", 0, [], void 0, 0, h) || d, v;
    try {
      n.length === 0 ? v = JSON.stringify(m, p, g) : v = JSON.stringify(m, f(p), g);
    } catch (x) {
      return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally {
      for (; r.length !== 0; ) {
        var y = r.pop();
        y.length === 4 ? Object.defineProperty(y[0], y[1], y[3]) : y[0][y[1]] = y[2];
      }
    }
    return v;
  }
  function u(d, p, g, h, m, v, y) {
    v += 1;
    var x;
    if (typeof d == "object" && d !== null) {
      for (x = 0; x < h.length; x++)
        if (h[x] === d) {
          s(t, d, p, m);
          return;
        }
      try {
        if (typeof d.toJSON == "function")
          return;
      } catch (O) {
        return;
      }
      if (typeof y.depthLimit != "undefined" && v > y.depthLimit) {
        s(e, d, p, m);
        return;
      }
      if (typeof y.edgesLimit != "undefined" && g + 1 > y.edgesLimit) {
        s(e, d, p, m);
        return;
      }
      if (h.push(d), Array.isArray(d))
        for (x = 0; x < d.length; x++)
          u(d[x], x, x, h, d, v, y);
      else {
        var S = {}, _ = Object.keys(d).sort(l);
        for (x = 0; x < _.length; x++) {
          var I = _[x];
          u(d[I], I, x, h, d, v, y), S[I] = d[I];
        }
        if (typeof m != "undefined")
          r.push([m, p, d]), m[p] = S;
        else
          return S;
      }
      h.pop();
    }
  }
  function f(d) {
    return d = typeof d != "undefined" ? d : function(p, g) {
      return g;
    }, function(p, g) {
      if (n.length > 0)
        for (var h = 0; h < n.length; h++) {
          var m = n[h];
          if (m[1] === p && m[0] === g) {
            g = m[2], n.splice(h, 1);
            break;
          }
        }
      return d.call(this, p, g);
    };
  }
  return sc;
}
var UR = jR();
const GR = /* @__PURE__ */ ld(UR), nr = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  function r(...n) {
    const i = n.map((o) => GR(o)).join("|");
    return t[i] === void 0 && (t[i] = e(...n)), t[i];
  }
  return r;
}, Q0 = 16, Ia = "px", qd = "em", To = "rem";
function ex(e = "") {
  const t = new RegExp(String.raw`-?\d+(?:\.\d+|\d*)`), r = new RegExp(`${Ia}|${qd}|${To}`), n = e.match(
    new RegExp(`${t.source}(${r.source})`)
  );
  return n == null ? void 0 : n[1];
}
function tx(e = "") {
  if (typeof e == "number")
    return `${e}px`;
  const t = ex(e);
  if (!t || t === Ia)
    return e;
  if (t === qd || t === To)
    return `${parseFloat(e) * Q0}${Ia}`;
}
function rx(e = "") {
  const t = ex(e);
  if (!t || t === To)
    return e;
  if (t === qd)
    return `${parseFloat(e)}${To}`;
  if (t === Ia)
    return `${parseFloat(e) / Q0}${To}`;
}
const qR = (e) => e.charAt(0).toUpperCase() + e.slice(1);
function KR(e) {
  const t = YR(e), r = Object.fromEntries(t);
  function n(d) {
    return r[d];
  }
  function i(d) {
    return ni(n(d));
  }
  function o() {
    const d = Object.keys(r), p = XR(d), g = d.flatMap((h) => {
      const m = n(h), v = [
        `${h}Down`,
        ni({ max: ea(m.min) })
      ], y = [h, ni({ min: m.min })], x = [`${h}Only`, i(h)];
      return [y, x, v];
    }).filter(([, h]) => h !== "").concat(
      p.map(([h, m]) => {
        const v = n(h), y = n(m);
        return [
          `${h}To${qR(m)}`,
          ni({ min: v.min, max: ea(y.min) })
        ];
      })
    );
    return Object.fromEntries(g);
  }
  function s() {
    const d = o();
    return Object.fromEntries(Object.entries(d));
  }
  const a = s(), l = (d) => a[d];
  function c() {
    return ["base", ...Object.keys(r)];
  }
  function u(d) {
    return ni({ min: n(d).min });
  }
  function f(d) {
    return ni({ max: ea(n(d).min) });
  }
  return {
    values: Object.values(r),
    only: i,
    keys: c,
    conditions: a,
    getCondition: l,
    up: u,
    down: f
  };
}
function ea(e) {
  var r;
  const t = parseFloat((r = tx(e)) != null ? r : "") - 0.04;
  return rx(`${t}px`);
}
function YR(e) {
  return Object.entries(e).sort(([, r], [, n]) => parseInt(r, 10) < parseInt(n, 10) ? -1 : 1).map(([r, n], i, o) => {
    var a;
    let s = null;
    return i <= o.length - 1 && (s = (a = o[i + 1]) == null ? void 0 : a[1]), s != null && (s = ea(s)), [r, { name: r, min: rx(n), max: s }];
  });
}
function XR(e) {
  const t = [];
  return e.forEach((r, n) => {
    let i = n;
    i++;
    let o = e[i];
    for (; o; )
      t.push([r, o]), i++, o = e[i];
  }), t;
}
function ni({
  min: e,
  max: t
}) {
  return e == null && t == null ? "" : [
    "@media screen",
    e && `(min-width: ${e})`,
    t && `(max-width: ${t})`
  ].filter(Boolean).join(" and ");
}
const JR = (e, t) => Object.fromEntries(
  Object.entries(e).map(([r, n]) => t(r, n))
), ZR = (e) => {
  const { breakpoints: t, conditions: r = {} } = e, n = JR(r, (u, f) => [`_${u}`, f]), i = Object.assign({}, n, t.conditions);
  function o() {
    return Object.keys(i);
  }
  function s(u) {
    return o().includes(u) || /^@|&|&$/.test(u) || u.startsWith("_");
  }
  function a(u) {
    return u.filter((f) => f !== "base").sort((f, d) => {
      const p = s(f), g = s(d);
      return p && !g ? 1 : !p && g ? -1 : 0;
    });
  }
  function l(u) {
    return u.startsWith("@breakpoint") ? t.getCondition(u.replace("@breakpoint ", "")) : u;
  }
  function c(u) {
    return Reflect.get(i, u) || u;
  }
  return {
    keys: o,
    sort: a,
    has: s,
    resolve: c,
    breakpoints: t.keys(),
    expandAtRule: l
  };
}, nx = (e) => ({
  minMax: new RegExp(
    `(!?\\(\\s*min(-device-)?-${e})(.|
)+\\(\\s*max(-device)?-${e}`,
    "i"
  ),
  min: new RegExp(`\\(\\s*min(-device)?-${e}`, "i"),
  maxMin: new RegExp(
    `(!?\\(\\s*max(-device)?-${e})(.|
)+\\(\\s*min(-device)?-${e}`,
    "i"
  ),
  max: new RegExp(`\\(\\s*max(-device)?-${e}`, "i")
}), QR = nx("width"), e2 = nx("height"), ix = (e) => ({
  isMin: vp(e.minMax, e.maxMin, e.min),
  isMax: vp(e.maxMin, e.minMax, e.max)
}), { isMin: du, isMax: fp } = ix(QR), { isMin: fu, isMax: hp } = ix(e2), pp = /print/i, gp = /^print$/i, t2 = /(-?\d*\.?\d+)(ch|em|ex|px|rem)/, r2 = /(\d)/, vo = Number.MAX_VALUE, n2 = { ch: 8.8984375, em: 16, rem: 16, ex: 8.296875, px: 1 };
function mp(e) {
  const t = t2.exec(e) || (du(e) || fu(e) ? r2.exec(e) : null);
  if (!t) return vo;
  if (t[0] === "0") return 0;
  const r = parseFloat(t[1]), n = t[2];
  return r * (n2[n] || 1);
}
function vp(e, t, r) {
  return (n) => e.test(n) || !t.test(n) && r.test(n);
}
function i2(e, t) {
  const r = pp.test(e), n = gp.test(e), i = pp.test(t), o = gp.test(t);
  return r && i ? !n && o ? 1 : n && !o ? -1 : e.localeCompare(t) : r ? 1 : i ? -1 : null;
}
const o2 = nr((e, t) => {
  const r = i2(e, t);
  if (r !== null) return r;
  const n = du(e) || fu(e), i = fp(e) || hp(e), o = du(t) || fu(t), s = fp(t) || hp(t);
  if (n && s) return -1;
  if (i && o) return 1;
  const a = mp(e), l = mp(t);
  return a === vo && l === vo ? e.localeCompare(t) : a === vo ? 1 : l === vo ? -1 : a !== l ? a > l ? i ? -1 : 1 : i ? 1 : -1 : e.localeCompare(t);
});
function bp(e) {
  return e.sort(([t], [r]) => o2(t, r));
}
function ox(e) {
  const t = [], r = [], n = {};
  for (const [s, a] of Object.entries(e))
    s.startsWith("@media") ? t.push([s, a]) : s.startsWith("@container") ? r.push([s, a]) : St(a) ? n[s] = ox(a) : n[s] = a;
  const i = bp(t), o = bp(r);
  return {
    ...n,
    ...Object.fromEntries(i),
    ...Object.fromEntries(o)
  };
}
const sx = /\s*!(important)?/i, s2 = (e) => Er(e) ? sx.test(e) : !1, a2 = (e) => Er(e) ? e.replace(sx, "").trim() : e;
function ax(e) {
  const { transform: t, conditions: r, normalize: n } = e, i = u2(e);
  return nr(function(...s) {
    const a = i(...s), l = n(a), c = /* @__PURE__ */ Object.create(null);
    return qr(l, (u, f) => {
      var m;
      const d = s2(u);
      if (u == null) return;
      const [p, ...g] = r.sort(f).map(r.resolve);
      d && (u = a2(u));
      let h = (m = t(p, u)) != null ? m : /* @__PURE__ */ Object.create(null);
      h = qr(
        h,
        (v) => Er(v) && d ? `${v} !important` : v,
        { getKey: (v) => r.expandAtRule(v) }
      ), l2(c, g.flat(), h);
    }), ox(c);
  });
}
function l2(e, t, r) {
  let n = e;
  for (const i of t)
    i && (n[i] || (n[i] = /* @__PURE__ */ Object.create(null)), n = n[i]);
  Wi(n, r);
}
function c2(...e) {
  return e.filter(
    (t) => St(t) && Object.keys(Qo(t)).length > 0
  );
}
function u2(e) {
  function t(r) {
    const n = c2(...r);
    return n.length === 1 ? n : n.map((i) => e.normalize(i));
  }
  return nr(function(...n) {
    return Wi({}, ...t(n));
  });
}
const lx = (e) => ({
  base: {},
  variants: {},
  defaultVariants: {},
  compoundVariants: [],
  ...e
});
function d2(e) {
  const { css: t, conditions: r, normalize: n, layers: i } = e;
  function o(a = {}) {
    const { base: l, variants: c, defaultVariants: u, compoundVariants: f } = lx(a), d = ax({
      conditions: r,
      normalize: n,
      transform(y, x) {
        var S;
        return (S = c[y]) == null ? void 0 : S[x];
      }
    }), p = (y = {}) => {
      const x = n({
        ...u,
        ...Qo(y)
      });
      let S = { ...l };
      Wi(S, d(x));
      const _ = s(
        f,
        x
      );
      return i.wrap("recipes", t(S, _));
    }, g = Object.keys(c), h = (y) => {
      const x = G0(y, ["recipe"]), [S, _] = bi(x, g);
      return g.includes("colorPalette") || (S.colorPalette = y.colorPalette || u.colorPalette), g.includes("orientation") && (_.orientation = y.orientation), [S, _];
    }, m = Object.fromEntries(
      Object.entries(c).map(([y, x]) => [
        y,
        Object.keys(x)
      ])
    );
    return Object.assign((y) => t(p(y)), {
      className: a.className,
      __cva__: !0,
      variantMap: m,
      variantKeys: g,
      raw: p,
      config: a,
      splitVariantProps: h,
      merge(y) {
        return o(f2(e)(this, y));
      }
    });
  }
  function s(a, l) {
    let c = {};
    return a.forEach((u) => {
      Object.entries(u).every(([d, p]) => d === "css" ? !0 : (Array.isArray(p) ? p : [p]).some((h) => l[d] === h)) && (c = t(c, u.css));
    }), c;
  }
  return o;
}
function f2(e) {
  const { css: t } = e;
  return function(n, i) {
    const o = lx(i.config), s = sb(n.variantKeys, Object.keys(i.variants)), a = t(n.base, o.base), l = Object.fromEntries(
      s.map((d) => [
        d,
        t(n.config.variants[d], o.variants[d])
      ])
    ), c = Wi(
      n.config.defaultVariants,
      o.defaultVariants
    ), u = [
      ...n.compoundVariants,
      ...o.compoundVariants
    ];
    return {
      className: Yt(n.className, i.className),
      base: a,
      variants: l,
      defaultVariants: c,
      compoundVariants: u
    };
  };
}
const h2 = {
  reset: "reset",
  base: "base",
  tokens: "tokens",
  recipes: "recipes"
}, yp = {
  reset: 0,
  base: 1,
  tokens: 2,
  recipes: 3
};
function p2(e) {
  var i;
  const t = (i = e.layers) != null ? i : h2, n = Object.values(t).sort((o, s) => yp[o] - yp[s]);
  return {
    names: n,
    atRule: `@layer ${n.join(", ")};`,
    wrap(o, s) {
      return e.disableLayers ? s : { [`@layer ${t[o]}`]: s };
    }
  };
}
function g2(e) {
  const { utility: t, normalize: r } = e, { hasShorthand: n, resolveShorthand: i } = t;
  return function(o) {
    return qr(o, r, {
      stop: (s) => Array.isArray(s),
      getKey: n ? i : void 0
    });
  };
}
function m2(e) {
  const { preflight: t } = e;
  if (!t) return {};
  const { scope: r = "", level: n = "parent" } = St(t) ? t : {};
  let i = "";
  r && n === "parent" ? i = `${r} ` : r && n === "element" && (i = `&${r}`);
  const o = {
    "*": {
      margin: "0px",
      padding: "0px",
      font: "inherit",
      wordWrap: "break-word",
      WebkitTapHighlightColor: "transparent"
    },
    "*, *::before, *::after, *::backdrop": {
      boxSizing: "border-box",
      borderWidth: "0px",
      borderStyle: "solid",
      borderColor: "var(--global-color-border, currentColor)"
    },
    hr: {
      height: "0px",
      color: "inherit",
      borderTopWidth: "1px"
    },
    body: {
      minHeight: "100dvh",
      position: "relative"
    },
    img: {
      borderStyle: "none"
    },
    "img, svg, video, canvas, audio, iframe, embed, object": {
      display: "block",
      verticalAlign: "middle"
    },
    iframe: { border: "none" },
    "img, video": { maxWidth: "100%", height: "auto" },
    "p, h1, h2, h3, h4, h5, h6": { overflowWrap: "break-word" },
    "ol, ul": { listStyle: "none" },
    "code, kbd, pre, samp": { fontSize: "1em" },
    "button, [type='button'], [type='reset'], [type='submit']": {
      WebkitAppearance: "button",
      backgroundColor: "transparent",
      backgroundImage: "none"
    },
    "button, input, optgroup, select, textarea": { color: "inherit" },
    "button, select": { textTransform: "none" },
    table: {
      textIndent: "0px",
      borderColor: "inherit",
      borderCollapse: "collapse"
    },
    "*::placeholder": {
      opacity: "unset",
      color: "#9ca3af",
      userSelect: "none"
    },
    textarea: {
      resize: "vertical"
    },
    summary: {
      display: "list-item"
    },
    small: {
      fontSize: "80%"
    },
    "sub, sup": {
      fontSize: "75%",
      lineHeight: 0,
      position: "relative",
      verticalAlign: "baseline"
    },
    sub: {
      bottom: "-0.25em"
    },
    sup: {
      top: "-0.5em"
    },
    dialog: {
      padding: "0px"
    },
    a: {
      color: "inherit",
      textDecoration: "inherit"
    },
    "abbr:where([title])": {
      textDecoration: "underline dotted"
    },
    "b, strong": {
      fontWeight: "bolder"
    },
    "code, kbd, samp, pre": {
      fontSize: "1em",
      "--font-mono-fallback": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New'",
      fontFamily: "var(--global-font-mono, var(--font-mono-fallback))"
    },
    'input[type="text"], input[type="email"], input[type="search"], input[type="password"]': {
      WebkitAppearance: "none",
      MozAppearance: "none"
    },
    "input[type='search']": {
      WebkitAppearance: "textfield",
      outlineOffset: "-2px"
    },
    "::-webkit-search-decoration, ::-webkit-search-cancel-button": {
      WebkitAppearance: "none"
    },
    "::-webkit-file-upload-button": {
      WebkitAppearance: "button",
      font: "inherit"
    },
    'input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button': {
      height: "auto"
    },
    "input[type='number']": {
      MozAppearance: "textfield"
    },
    ":-moz-ui-invalid": {
      boxShadow: "none"
    },
    ":-moz-focusring": {
      outline: "auto"
    },
    "[hidden]:where(:not([hidden='until-found']))": {
      display: "none !important"
    }
  }, s = {
    [r || "html"]: {
      lineHeight: 1.5,
      "--font-fallback": "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      WebkitTextSizeAdjust: "100%",
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
      textRendering: "optimizeLegibility",
      touchAction: "manipulation",
      MozTabSize: "4",
      tabSize: "4",
      fontFamily: "var(--global-font-body, var(--font-fallback))"
    }
  };
  if (n === "element") {
    const a = Object.entries(o).reduce((l, [c, u]) => (l[c] = { [i]: u }, l), {});
    Object.assign(s, a);
  } else i ? s[i] = o : Object.assign(s, o);
  return s;
}
function v2(e) {
  const { conditions: t, isValidProperty: r } = e;
  return function(i) {
    return qr(i, (o) => o, {
      getKey: (o, s) => St(s) && !t.has(o) && !r(o) ? b2(o).map((a) => "&" + a).join(", ") : o
    });
  };
}
function b2(e) {
  const t = [];
  let r = 0, n = "", i = !1;
  for (let o = 0; o < e.length; o++) {
    const s = e[o];
    if (s === "\\" && !i) {
      i = !0, n += s;
      continue;
    }
    if (i) {
      i = !1, n += s;
      continue;
    }
    s === "(" ? r++ : s === ")" && r--, s === "," && r === 0 ? (t.push(n.trim()), n = "") : n += s;
  }
  return n && t.push(n.trim()), t;
}
const y2 = (e = {}) => {
  var i, o;
  const t = (s) => {
    var a, l, c;
    return {
      base: (l = (a = e.base) == null ? void 0 : a[s]) != null ? l : {},
      variants: {},
      defaultVariants: (c = e.defaultVariants) != null ? c : {},
      compoundVariants: e.compoundVariants ? x2(e.compoundVariants, s) : []
    };
  }, n = ((i = e.slots) != null ? i : []).map((s) => [s, t(s)]);
  for (const [s, a] of Object.entries(
    (o = e.variants) != null ? o : {}
  ))
    for (const [l, c] of Object.entries(
      a
    ))
      n.forEach(([u, f]) => {
        var p, g;
        var d;
        (p = (d = f.variants)[s]) != null || (d[s] = {}), f.variants[s][l] = (g = c[u]) != null ? g : {};
      });
  return Object.fromEntries(n);
}, x2 = (e, t) => e.filter((r) => r.css[t]).map((r) => ({
  ...r,
  css: r.css[t]
}));
function _2(e) {
  const { cva: t } = e;
  return function(n = {}) {
    var f;
    const i = Object.entries(y2(n)).map(
      ([d, p]) => [d, t(p)]
    );
    function o(d) {
      const p = i.map(([g, h]) => [g, h(d)]);
      return Object.fromEntries(p);
    }
    const s = (f = n.variants) != null ? f : {}, a = Object.keys(s);
    function l(d) {
      var m;
      const p = G0(d, ["recipe"]), [g, h] = bi(p, a);
      return a.includes("colorPalette") || (g.colorPalette = d.colorPalette || ((m = n.defaultVariants) == null ? void 0 : m.colorPalette)), a.includes("orientation") && (h.orientation = d.orientation), [g, h];
    }
    const c = Object.fromEntries(
      Object.entries(s).map(([d, p]) => [d, Object.keys(p)])
    );
    let u = {};
    return n.className && (u = Object.fromEntries(
      n.slots.map((d) => [
        d,
        `${n.className}__${d}`
      ])
    )), Object.assign(o, {
      variantMap: c,
      variantKeys: a,
      splitVariantProps: l,
      classNameMap: u
    });
  };
}
const w2 = () => (e) => Array.from(new Set(e)), S2 = /([\0-\x1f\x7f]|^-?\d)|^-$|^-|[^\x80-\uFFFF\w-]/g, E2 = function(e, t) {
  return t ? e === "\0" ? "�" : e === "-" && e.length === 1 ? "\\-" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) : "\\" + e;
}, cx = (e) => (e + "").replace(S2, E2), ux = (e, t) => {
  var l, c, u, f;
  let r = "", n = 0, i = "char", o = "", s = "";
  const a = [];
  for (; n < e.length; ) {
    const d = e[n];
    if (d === "{") {
      const g = e.indexOf("}", n);
      if (g === -1)
        break;
      const h = e.slice(n + 1, g), m = t(h);
      r += m != null ? m : h, n = g + 1;
      continue;
    }
    if (i === "token" && d === ",") {
      e[n] === "" && n++, i = "fallback", a.push(i);
      const g = t(o);
      g != null && g.endsWith(")") && (r += g.slice(0, -1)), o = "", s = "";
      continue;
    }
    if (i === "fallback" && s + d === ", var(") {
      const m = C2(e.slice(n + 1)) + n + 1, v = e.slice(n + 1, m);
      if (m === -1)
        break;
      r += ", var(" + v + ")", n = m + 1, i = (l = a.pop()) != null ? l : i, s = "";
      continue;
    }
    if (i === "token" || i === "fallback") {
      if (n++, d === ")") {
        i = (u = (c = a.pop()) != null ? c : i) != null ? u : "char", s += d;
        const g = o && ((f = t(o)) != null ? f : cx(o));
        if (s) {
          if (s = s.slice(1).trim(), !s.startsWith("token(") && s.endsWith(")") && (s = s.slice(0, -1)), s.includes("token(")) {
            const m = ux(s, t);
            m && (s = m.slice(0, -1));
          } else if (s) {
            const m = t(s);
            m && (s = m);
          }
        }
        const h = r.at(-1);
        s ? h != null && h.trim() ? r += g.slice(0, -1) + (", " + s + ")") : r += s : r += g || ")", o = "", s = "", i = "char";
        continue;
      }
      i === "token" && (o += d), i === "fallback" && (s += d);
      continue;
    }
    const p = e.indexOf("token(", n);
    if (p !== -1) {
      const g = p + 6;
      r += e.slice(n, p), n = g, i = "token", a.push(i);
      continue;
    }
    r += d, n++;
  }
  return r;
}, C2 = (e) => {
  let t = 0;
  const r = ["("];
  for (; t < e.length; ) {
    const n = e[t];
    if (n === "(")
      r.push(n);
    else if (n === ")" && (r.pop(), r.length === 0))
      return t;
    t++;
  }
  return t;
};
function dx(e) {
  const t = {};
  return e.forEach((r, n) => {
    r instanceof Map ? t[n] = Object.fromEntries(r) : t[n] = r;
  }), t;
}
const fx = /({([^}]*)})/g, k2 = /[{}]/g, I2 = /\w+\.\w+/, hx = (e) => {
  if (!Er(e)) return [];
  const t = e.match(fx);
  return t ? t.map((r) => r.replace(k2, "")).map((r) => r.trim()) : [];
}, O2 = (e) => fx.test(e);
function px(e) {
  var r, n, i, o, s;
  if (!((r = e.extensions) != null && r.references))
    return (o = (i = (n = e.extensions) == null ? void 0 : n.cssVar) == null ? void 0 : i.ref) != null ? o : e.value;
  const t = (s = e.extensions.references) != null ? s : {};
  return e.value = Object.keys(t).reduce((a, l) => {
    const c = t[l];
    if (c.extensions.conditions)
      return a;
    const u = px(c);
    return a.replace(`{${l}}`, u);
  }, e.value), delete e.extensions.references, e.value;
}
function gx(e) {
  return St(e) && e.reference ? e.reference : String(e);
}
const ml = (e, ...t) => t.map(gx).join(` ${e} `).replace(/calc/g, ""), xp = (...e) => `calc(${ml("+", ...e)})`, _p = (...e) => `calc(${ml("-", ...e)})`, hu = (...e) => `calc(${ml("*", ...e)})`, wp = (...e) => `calc(${ml("/", ...e)})`, Sp = (e) => {
  const t = gx(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : hu(t, -1);
}, ui = Object.assign(
  (e) => ({
    add: (...t) => ui(xp(e, ...t)),
    subtract: (...t) => ui(_p(e, ...t)),
    multiply: (...t) => ui(hu(e, ...t)),
    divide: (...t) => ui(wp(e, ...t)),
    negate: () => ui(Sp(e)),
    toString: () => e.toString()
  }),
  {
    add: xp,
    subtract: _p,
    multiply: hu,
    divide: wp,
    negate: Sp
  }
), P2 = {
  enforce: "pre",
  transform(e) {
    const { prefix: t, allTokens: r, formatCssVar: n, formatTokenName: i, registerToken: o } = e;
    r.filter(
      ({ extensions: a }) => a.category === "spacing"
    ).forEach((a) => {
      const l = a.path.slice(), c = n(l, t);
      if (Er(a.value) && a.value === "0rem")
        return;
      const u = structuredClone(a);
      Object.assign(u.extensions, {
        negative: !0,
        prop: `-${a.extensions.prop}`,
        originalPath: l
      }), u.value = ui.negate(c.ref);
      const f = u.path[u.path.length - 1];
      f != null && (u.path[u.path.length - 1] = `-${f}`), u.path && (u.name = i(u.path)), o(u);
    });
  }
}, T2 = /* @__PURE__ */ new Set([
  "spacing",
  "sizes",
  "borderWidths",
  "fontSizes",
  "radii"
]), R2 = {
  enforce: "post",
  transform(e) {
    e.allTokens.filter((r) => T2.has(r.extensions.category) && !r.extensions.negative).forEach((r) => {
      Object.assign(r.extensions, {
        pixelValue: tx(r.value)
      });
    });
  }
}, A2 = {
  enforce: "post",
  transform(e) {
    const { allTokens: t, registerToken: r, formatTokenName: n } = e, i = t.filter(
      ({ extensions: a }) => a.category === "colors"
    ), o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
    i.forEach((a) => {
      const { colorPalette: l } = a.extensions;
      l && (l.keys.forEach((c) => {
        o.set(n(c), c);
      }), l.roots.forEach((c) => {
        var d;
        const u = n(c), f = s.get(u) || [];
        if (f.push(a), s.set(u, f), a.extensions.default && c.length === 1) {
          const p = (d = l.keys[0]) == null ? void 0 : d.filter(Boolean);
          if (!p.length) return;
          const g = c.concat(p);
          o.set(n(g), []);
        }
      }));
    }), o.forEach((a) => {
      const l = ["colors", "colorPalette", ...a].filter(Boolean), c = n(l), u = n(l.slice(1));
      r({
        name: c,
        value: c,
        originalValue: c,
        path: l,
        extensions: {
          condition: "base",
          originalPath: l,
          category: "colors",
          prop: u,
          virtual: !0
        }
      }, "pre");
    });
  }
}, N2 = {
  enforce: "post",
  transform(e) {
    e.allTokens = e.allTokens.filter(
      (t) => t.value !== ""
    );
  }
}, F2 = [
  P2,
  A2,
  R2,
  N2
], $2 = {
  type: "extensions",
  enforce: "pre",
  name: "tokens/css-var",
  transform(e, t) {
    const { prefix: r, formatCssVar: n } = t, { negative: i, originalPath: o } = e.extensions, s = i ? o : e.path;
    return {
      cssVar: n(s.filter(Boolean), r)
    };
  }
}, L2 = {
  enforce: "post",
  type: "value",
  name: "tokens/conditionals",
  transform(e, t) {
    const { prefix: r, formatCssVar: n } = t, i = hx(e.value);
    return i.length && i.forEach((o) => {
      const s = n(o.split("."), r);
      e.value = e.value.replace(`{${s.ref}}`, s);
    }), e.value;
  }
}, V2 = {
  type: "extensions",
  enforce: "pre",
  name: "tokens/colors/colorPalette",
  match(e) {
    return e.extensions.category === "colors" && !e.extensions.virtual;
  },
  transform(e, t) {
    let r = e.path.slice();
    if (r.pop(), r.shift(), r.length === 0) {
      const a = [...e.path];
      a.shift(), r = a;
    }
    if (r.length === 0)
      return {};
    const n = r.reduce((a, l, c, u) => {
      const f = u.slice(0, c + 1);
      return a.push(f), a;
    }, []), i = r[0], o = t.formatTokenName(r), s = e.path.slice(e.path.indexOf(i) + 1).reduce((a, l, c, u) => (a.push(u.slice(c)), a), []);
    return s.length === 0 && s.push([""]), {
      colorPalette: { value: o, roots: n, keys: s }
    };
  }
}, z2 = [
  $2,
  L2,
  V2
], Ep = (e) => St(e) && Object.prototype.hasOwnProperty.call(e, "value");
function D2(e) {
  return e ? {
    breakpoints: Z0(e, (t) => ({ value: t })),
    sizes: Object.fromEntries(
      Object.entries(e).map(([t, r]) => [
        `breakpoint-${t}`,
        { value: r }
      ])
    )
  } : { breakpoints: {}, sizes: {} };
}
function M2(e) {
  const {
    prefix: t = "",
    tokens: r = {},
    semanticTokens: n = {},
    breakpoints: i = {}
  } = e, o = (R) => R.join("."), s = (R, M) => J0(R.join("-"), { prefix: M }), a = [], l = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new Map(), m = [];
  function v(R, M) {
    a.push(R), l.set(R.name, R), M && h.forEach((z) => {
      z.enforce === M && P(z, R);
    });
  }
  const y = D2(i), x = Qo({
    ...r,
    breakpoints: y.breakpoints,
    sizes: {
      ...r.sizes,
      ...y.sizes
    }
  });
  function S() {
    qr(
      x,
      (R, M) => {
        const z = M.includes("DEFAULT");
        M = Cp(M);
        const Y = M[0], U = o(M), se = Er(R) ? { value: R } : R, we = {
          value: se.value,
          originalValue: se.value,
          name: U,
          path: M,
          extensions: {
            condition: "base",
            originalPath: M,
            category: Y,
            prop: o(M.slice(1))
          }
        };
        z && (we.extensions.default = !0), v(we);
      },
      { stop: Ep }
    ), qr(
      n,
      (R, M) => {
        const z = M.includes("DEFAULT");
        M = mx(Cp(M));
        const Y = M[0], U = o(M), se = Er(R.value) ? { value: { base: R.value } } : R, we = {
          value: se.value.base || "",
          originalValue: se.value.base || "",
          name: U,
          path: M,
          extensions: {
            originalPath: M,
            category: Y,
            conditions: se.value,
            condition: "base",
            prop: o(M.slice(1))
          }
        };
        z && (we.extensions.default = !0), v(we);
      },
      { stop: Ep }
    );
  }
  function _(R) {
    return l.get(R);
  }
  function I(R) {
    const { condition: M } = R.extensions;
    M && (c.has(M) || c.set(M, /* @__PURE__ */ new Set()), c.get(M).add(R));
  }
  function O(R) {
    const { category: M, prop: z } = R.extensions;
    M && (g.has(M) || g.set(M, /* @__PURE__ */ new Map()), g.get(M).set(z, R));
  }
  function w(R) {
    const { condition: M, negative: z, virtual: Y, cssVar: U } = R.extensions;
    z || Y || !M || !U || (u.has(M) || u.set(M, /* @__PURE__ */ new Map()), u.get(M).set(U.var, R.value));
  }
  function E(R) {
    const { category: M, prop: z, cssVar: Y, negative: U } = R.extensions;
    if (!M) return;
    p.has(M) || p.set(M, /* @__PURE__ */ new Map());
    const se = U ? R.extensions.conditions ? R.originalValue : R.value : Y.ref;
    p.get(M).set(z, se), d.set([M, z].join("."), se);
  }
  function T(R) {
    const { colorPalette: M, virtual: z, default: Y } = R.extensions;
    !M || z || M.roots.forEach((U) => {
      var Jr;
      const se = o(U);
      f.has(se) || f.set(se, /* @__PURE__ */ new Map());
      const we = W2(
        [...R.path],
        [...U]
      ), ze = o(we), Ye = _(ze);
      if (!Ye || !Ye.extensions.cssVar) return;
      const { var: At } = Ye.extensions.cssVar;
      if (f.get(se).set(At, R.extensions.cssVar.ref), Y && U.length === 1) {
        const lr = o(["colors", "colorPalette"]), Tr = _(lr);
        if (!Tr) return;
        const Yn = o(R.path), Zr = _(Yn);
        if (!Zr) return;
        const Xn = (Jr = M.keys[0]) == null ? void 0 : Jr.filter(Boolean);
        if (!Xn.length) return;
        const cr = o(U.concat(Xn));
        f.has(cr) || f.set(cr, /* @__PURE__ */ new Map()), f.get(cr).set(
          Tr.extensions.cssVar.var,
          Zr.extensions.cssVar.ref
        );
      }
    });
  }
  let G = {};
  function k() {
    a.forEach((R) => {
      I(R), O(R), w(R), E(R), T(R);
    }), G = dx(p);
  }
  const j = (R, M) => {
    var Ye;
    if (!R || typeof R != "string") return { invalid: !0, value: R };
    const [z, Y] = R.split("/");
    if (!z || !Y)
      return { invalid: !0, value: z };
    const U = M(z), se = (Ye = _(`opacity.${Y}`)) == null ? void 0 : Ye.value;
    if (!se && isNaN(Number(Y)))
      return { invalid: !0, value: z };
    const we = se ? Number(se) * 100 + "%" : `${Y}%`, ze = U != null ? U : z;
    return {
      invalid: !1,
      color: ze,
      value: `color-mix(in srgb, ${ze} ${we}, transparent)`
    };
  }, F = nr((R, M) => {
    var z;
    return (z = d.get(R)) != null ? z : M;
  }), L = nr((R) => G[R] || null), D = nr((R) => ux(R, (M) => {
    if (!M) return;
    if (M.includes("/")) {
      const Y = j(M, (U) => F(U));
      if (Y.invalid)
        throw new Error("Invalid color mix at " + M + ": " + Y.value);
      return Y.value;
    }
    const z = F(M);
    return z || (I2.test(M) ? cx(M) : M);
  })), N = {
    prefix: t,
    allTokens: a,
    tokenMap: l,
    registerToken: v,
    getByName: _,
    formatTokenName: o,
    formatCssVar: s,
    flatMap: d,
    cssVarMap: u,
    categoryMap: g,
    colorPaletteMap: f,
    getVar: F,
    getCategoryValues: L,
    expandReferenceInValue: D
  };
  function B(...R) {
    R.forEach((M) => {
      h.set(M.name, M);
    });
  }
  function q(...R) {
    m.push(...R);
  }
  function P(R, M) {
    if (M.extensions.references || pd(R.match) && !R.match(M)) return;
    const Y = ((U) => R.transform(U, N))(M);
    switch (!0) {
      case R.type === "extensions":
        Object.assign(M.extensions, Y);
        break;
      case R.type === "value":
        M.value = Y;
        break;
      default:
        M[R.type] = Y;
        break;
    }
  }
  function C(R) {
    m.forEach((M) => {
      M.enforce === R && M.transform(N);
    });
  }
  function W(R) {
    h.forEach((M) => {
      M.enforce === R && a.forEach((z) => {
        P(M, z);
      });
    });
  }
  function H() {
    a.forEach((R) => {
      const M = B2(R);
      !M || M.length === 0 || M.forEach((z) => {
        v(z);
      });
    });
  }
  function V(R) {
    return hx(R).map((z) => _(z)).filter(Boolean);
  }
  function Q() {
    a.forEach((R) => {
      if (!O2(R.value)) return;
      const M = V(R.value);
      R.extensions.references = M.reduce((z, Y) => (z[Y.name] = Y, z), {});
    });
  }
  function X() {
    a.forEach((R) => {
      px(R);
    });
  }
  function ne() {
    C("pre"), W("pre"), H(), Q(), X(), C("post"), W("post"), k();
  }
  return S(), B(...z2), q(...F2), ne(), N;
}
function Cp(e) {
  return e[0] === "DEFAULT" ? e : e.filter((t) => t !== "DEFAULT");
}
function mx(e) {
  return e.filter((t) => t !== "base");
}
function B2(e) {
  if (!e.extensions.conditions) return;
  const { conditions: t } = e.extensions, r = [];
  return qr(t, (n, i) => {
    const o = mx(i);
    if (!o.length) return;
    const s = structuredClone(e);
    s.value = n, s.extensions.condition = o.join(":"), r.push(s);
  }), r;
}
function W2(e, t) {
  const r = e.findIndex(
    (n, i) => t.every(
      (o, s) => e[i + s] === o
    )
  );
  return r === -1 || (e.splice(r, t.length), e.splice(r, 0, "colorPalette")), e;
}
w2()([
  "aspectRatios",
  "zIndex",
  "opacity",
  "colors",
  "fonts",
  "fontSizes",
  "fontWeights",
  "lineHeights",
  "letterSpacings",
  "sizes",
  "shadows",
  "spacing",
  "radii",
  "cursor",
  "borders",
  "borderWidths",
  "borderStyles",
  "durations",
  "easings",
  "animations",
  "blurs",
  "gradients",
  "breakpoints",
  "assets"
]);
function H2(e) {
  return Object.fromEntries(
    Object.entries(e).map(([t, r]) => [t, r])
  );
}
function j2(e) {
  const t = H2(e.config), r = e.tokens, n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  function o(w, E) {
    t[w] = E, s(w, E);
  }
  const s = (w, E) => {
    const T = h(E);
    T && (i.set(w, T), f(w, E));
  }, a = () => {
    for (const [w, E] of Object.entries(t))
      E && s(w, E);
  }, l = () => {
    for (const [w, E] of Object.entries(t)) {
      const { shorthand: T } = E != null ? E : {};
      if (!T) continue;
      (Array.isArray(T) ? T : [T]).forEach((k) => n.set(k, w));
    }
  }, c = () => {
    const w = dx(r.colorPaletteMap);
    o("colorPalette", {
      values: Object.keys(w),
      transform: nr((E) => w[E])
    });
  }, u = /* @__PURE__ */ new Map(), f = (w, E) => {
    var k;
    if (!E) return;
    const T = h(E, (j) => `type:Tokens["${j}"]`);
    if (typeof T == "object" && T.type) {
      u.set(w, /* @__PURE__ */ new Set([`type:${T.type}`]));
      return;
    }
    if (T) {
      const j = new Set(Object.keys(T));
      u.set(w, j);
    }
    const G = (k = u.get(w)) != null ? k : /* @__PURE__ */ new Set();
    E.property && u.set(w, G.add(`CssProperties["${E.property}"]`));
  }, d = () => {
    for (const [w, E] of Object.entries(t))
      E && f(w, E);
  }, p = (w, E) => {
    var G;
    const T = (G = u.get(w)) != null ? G : /* @__PURE__ */ new Set();
    u.set(w, /* @__PURE__ */ new Set([...T, ...E]));
  }, g = () => {
    const w = /* @__PURE__ */ new Map();
    for (const [E, T] of u.entries()) {
      if (T.size === 0) {
        w.set(E, ["string"]);
        continue;
      }
      const G = Array.from(T).map((k) => k.startsWith("CssProperties") ? k : k.startsWith("type:") ? k.replace("type:", "") : JSON.stringify(k));
      w.set(E, G);
    }
    return w;
  }, h = (w, E) => {
    var k, j;
    const { values: T } = w, G = (F) => {
      const L = E == null ? void 0 : E(F);
      return L ? { [L]: L } : void 0;
    };
    return Er(T) ? (j = (k = G == null ? void 0 : G(T)) != null ? k : r.getCategoryValues(T)) != null ? j : {} : Array.isArray(T) ? T.reduce((F, L) => (F[L] = L, F), {}) : pd(T) ? T(E ? G : r.getCategoryValues) : T;
  }, m = nr((w, E) => ({
    [w]: w.startsWith("--") ? r.getVar(E, E) : E
  })), v = Object.assign(r.getVar, {
    raw: (w) => r.getByName(w)
  }), y = nr((w, E) => {
    var F;
    const T = _(w);
    Er(E) && !E.includes("_EMO_") && (E = r.expandReferenceInValue(E));
    const G = t[T];
    if (!G)
      return m(T, E);
    const k = (F = i.get(T)) == null ? void 0 : F[E];
    if (!G.transform)
      return m(w, k != null ? k : E);
    const j = (L) => bR(L, v);
    return G.transform(k != null ? k : E, {
      raw: E,
      token: v,
      utils: { colorMix: j }
    });
  });
  function x() {
    l(), c(), a(), d();
  }
  x();
  const S = n.size > 0, _ = nr((w) => {
    var E;
    return (E = n.get(w)) != null ? E : w;
  });
  return {
    keys: () => [...Array.from(n.keys()), ...Object.keys(t)],
    hasShorthand: S,
    transform: y,
    shorthands: n,
    resolveShorthand: _,
    register: o,
    getTypes: g,
    addPropertyType: p
  };
}
function vx(...e) {
  var B, q, P;
  const t = X0(...e), {
    theme: r = {},
    utilities: n = {},
    globalCss: i = {},
    cssVarsRoot: o = ":where(:root, :host)",
    cssVarsPrefix: s = "chakra",
    preflight: a
  } = t, l = p2(t), c = M2({
    breakpoints: r.breakpoints,
    tokens: r.tokens,
    semanticTokens: r.semanticTokens,
    prefix: s
  }), u = KR((B = r.breakpoints) != null ? B : {}), f = ZR({
    conditions: (q = t.conditions) != null ? q : {},
    breakpoints: u
  }), d = j2({
    config: n,
    tokens: c
  });
  function p() {
    const { textStyles: C, layerStyles: W, animationStyles: H } = r, V = Qo({
      textStyle: C,
      layerStyle: W,
      animationStyle: H
    });
    for (const [Q, X] of Object.entries(V)) {
      const ne = HR(
        X != null ? X : {},
        (R) => St(R) && "value" in R
      );
      d.register(Q, {
        values: Object.keys(ne),
        transform(R) {
          return x(ne[R]);
        }
      });
    }
  }
  p(), d.addPropertyType("animationName", Object.keys((P = r.keyframes) != null ? P : {}));
  const g = /* @__PURE__ */ new Set(["css", ...d.keys(), ...f.keys()]), h = nr(
    (C) => g.has(C) || BR(C)
  ), m = (C) => Array.isArray(C) ? C.reduce((W, H, V) => {
    const Q = f.breakpoints[V];
    return H != null && (W[Q] = H), W;
  }, {}) : C, v = g2({
    utility: d,
    normalize: m
  }), y = v2({
    conditions: f,
    isValidProperty: h
  }), x = ax({
    transform: d.transform,
    conditions: f,
    normalize: v
  }), S = d2({
    css: x,
    conditions: f,
    normalize: v,
    layers: l
  }), _ = _2({ cva: S });
  function I() {
    const C = {};
    for (const [W, H] of c.cssVarMap.entries()) {
      const V = Object.fromEntries(H);
      if (Object.keys(V).length === 0) continue;
      const Q = W === "base" ? o : f.resolve(W), X = Q.startsWith("@"), ne = x(
        y({
          [Q]: X ? { [o]: V } : V
        })
      );
      Wi(C, ne);
    }
    return l.wrap("tokens", C);
  }
  function O() {
    var H;
    const C = Object.fromEntries(
      Object.entries((H = r.keyframes) != null ? H : {}).map(([V, Q]) => [
        `@keyframes ${V}`,
        Q
      ])
    ), W = Object.assign({}, C, x(y(i)));
    return l.wrap("base", W);
  }
  function w(C) {
    return bi(C, h);
  }
  function E() {
    const C = m2({ preflight: a });
    return l.wrap("reset", C);
  }
  const T = U2(c), G = (C, W) => {
    var H;
    return ((H = T.get(C)) == null ? void 0 : H.value) || W;
  };
  G.var = (C, W) => {
    var H;
    return ((H = T.get(C)) == null ? void 0 : H.variable) || W;
  };
  function k(C, W) {
    var H, V;
    return (V = (H = r.recipes) == null ? void 0 : H[C]) != null ? V : W;
  }
  function j(C, W) {
    var H, V;
    return (V = (H = r.slotRecipes) == null ? void 0 : H[C]) != null ? V : W;
  }
  function F(C) {
    var W;
    return Object.hasOwnProperty.call((W = r.recipes) != null ? W : {}, C);
  }
  function L(C) {
    var W;
    return Object.hasOwnProperty.call((W = r.slotRecipes) != null ? W : {}, C);
  }
  function D(C) {
    return F(C) || L(C);
  }
  const N = [E(), O(), I()];
  return {
    $$chakra: !0,
    _config: t,
    _global: N,
    breakpoints: u,
    tokens: c,
    conditions: f,
    utility: d,
    token: G,
    properties: g,
    layers: l,
    isValidProperty: h,
    splitCssProps: w,
    normalizeValue: m,
    getTokenCss: I,
    getGlobalCss: O,
    getPreflightCss: E,
    css: x,
    cva: S,
    sva: _,
    getRecipe: k,
    getSlotRecipe: j,
    hasRecipe: D,
    isRecipe: F,
    isSlotRecipe: L
  };
}
function U2(e) {
  const t = /* @__PURE__ */ new Map();
  return e.allTokens.forEach((r) => {
    const { cssVar: n, virtual: i, conditions: o } = r.extensions, s = o || i ? n.ref : r.value;
    t.set(r.name, { value: s, variable: n.ref });
  }), t;
}
const G2 = {
  sm: "480px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px"
}, ac = "var(--chakra-empty,/*!*/ /*!*/)", q2 = _R({
  "*": {
    fontFeatureSettings: '"cv11"',
    "--ring-inset": ac,
    "--ring-offset-width": "0px",
    "--ring-offset-color": "#fff",
    "--ring-color": "rgba(66, 153, 225, 0.6)",
    "--ring-offset-shadow": "0 0 #0000",
    "--ring-shadow": "0 0 #0000",
    ...Object.fromEntries(
      [
        "brightness",
        "contrast",
        "grayscale",
        "hue-rotate",
        "invert",
        "saturate",
        "sepia",
        "drop-shadow"
      ].map((e) => [`--${e}`, ac])
    ),
    ...Object.fromEntries(
      [
        "blur",
        "brightness",
        "contrast",
        "grayscale",
        "hue-rotate",
        "invert",
        "opacity",
        "saturate",
        "sepia"
      ].map((e) => [`--backdrop-${e}`, ac])
    ),
    "--global-font-mono": "fonts.mono",
    "--global-font-body": "fonts.body",
    "--global-color-border": "colors.border"
  },
  html: {
    color: "fg",
    bg: "bg",
    lineHeight: "1.5",
    colorPalette: "gray"
  },
  "*::placeholder, *[data-placeholder]": {
    color: "fg.muted/80"
  },
  "*::selection": {
    bg: "colorPalette.emphasized/80"
  }
}), K2 = ER({
  // fill: some background color + color combination
  "fill.muted": {
    value: {
      background: "colorPalette.muted",
      color: "colorPalette.fg"
    }
  },
  "fill.subtle": {
    value: {
      background: "colorPalette.subtle",
      color: "colorPalette.fg"
    }
  },
  "fill.surface": {
    value: {
      background: "colorPalette.subtle",
      color: "colorPalette.fg",
      boxShadow: "0 0 0px 1px var(--shadow-color)",
      boxShadowColor: "colorPalette.muted"
    }
  },
  "fill.solid": {
    value: {
      background: "colorPalette.solid",
      color: "colorPalette.contrast"
    }
  },
  // outline: some border color + color combination
  "outline.subtle": {
    value: {
      color: "colorPalette.fg",
      boxShadow: "inset 0 0 0px 1px var(--shadow-color)",
      boxShadowColor: "colorPalette.subtle"
    }
  },
  "outline.solid": {
    value: {
      borderWidth: "1px",
      borderColor: "colorPalette.solid",
      color: "colorPalette.fg"
    }
  },
  // indicator: floating border color or left/bottom border
  "indicator.bottom": {
    value: {
      position: "relative",
      "--indicator-color-fallback": "colors.colorPalette.solid",
      _before: {
        content: '""',
        position: "absolute",
        bottom: "var(--indicator-offset-y, 0)",
        insetInline: "var(--indicator-offset-x, 0)",
        height: "var(--indicator-thickness, 2px)",
        background: "var(--indicator-color, var(--indicator-color-fallback))"
      }
    }
  },
  "indicator.top": {
    value: {
      position: "relative",
      "--indicator-color-fallback": "colors.colorPalette.solid",
      _before: {
        content: '""',
        position: "absolute",
        top: "var(--indicator-offset-y, 0)",
        insetInline: "var(--indicator-offset-x, 0)",
        height: "var(--indicator-thickness, 2px)",
        background: "var(--indicator-color, var(--indicator-color-fallback))"
      }
    }
  },
  "indicator.start": {
    value: {
      position: "relative",
      "--indicator-color-fallback": "colors.colorPalette.solid",
      _before: {
        content: '""',
        position: "absolute",
        insetInlineStart: "var(--indicator-offset-x, 0)",
        insetBlock: "var(--indicator-offset-y, 0)",
        width: "var(--indicator-thickness, 2px)",
        background: "var(--indicator-color, var(--indicator-color-fallback))"
      }
    }
  },
  "indicator.end": {
    value: {
      position: "relative",
      "--indicator-color-fallback": "colors.colorPalette.solid",
      _before: {
        content: '""',
        position: "absolute",
        insetInlineEnd: "var(--indicator-offset-x, 0)",
        insetBlock: "var(--indicator-offset-y, 0)",
        width: "var(--indicator-thickness, 2px)",
        background: "var(--indicator-color, var(--indicator-color-fallback))"
      }
    }
  },
  disabled: {
    value: {
      opacity: "0.5",
      cursor: "not-allowed"
    }
  },
  none: {
    value: {}
  }
}), Y2 = SR({
  "slide-fade-in": {
    value: {
      transformOrigin: "var(--transform-origin)",
      "&[data-placement^=top]": {
        animationName: "slide-from-bottom, fade-in"
      },
      "&[data-placement^=bottom]": {
        animationName: "slide-from-top, fade-in"
      },
      "&[data-placement^=left]": {
        animationName: "slide-from-right, fade-in"
      },
      "&[data-placement^=right]": {
        animationName: "slide-from-left, fade-in"
      }
    }
  },
  "slide-fade-out": {
    value: {
      transformOrigin: "var(--transform-origin)",
      "&[data-placement^=top]": {
        animationName: "slide-to-bottom, fade-out"
      },
      "&[data-placement^=bottom]": {
        animationName: "slide-to-top, fade-out"
      },
      "&[data-placement^=left]": {
        animationName: "slide-to-right, fade-out"
      },
      "&[data-placement^=right]": {
        animationName: "slide-to-left, fade-out"
      }
    }
  },
  "scale-fade-in": {
    value: {
      transformOrigin: "var(--transform-origin)",
      animationName: "scale-in, fade-in"
    }
  },
  "scale-fade-out": {
    value: {
      transformOrigin: "var(--transform-origin)",
      animationName: "scale-out, fade-out"
    }
  }
}), Kd = Qe({
  className: "chakra-badge",
  base: {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "l2",
    gap: "1",
    fontWeight: "medium",
    fontVariantNumeric: "tabular-nums",
    whiteSpace: "nowrap",
    userSelect: "none"
  },
  variants: {
    variant: {
      solid: {
        bg: "colorPalette.solid",
        color: "colorPalette.contrast"
      },
      subtle: {
        bg: "colorPalette.subtle",
        color: "colorPalette.fg"
      },
      outline: {
        color: "colorPalette.fg",
        shadow: "inset 0 0 0px 1px var(--shadow-color)",
        shadowColor: "colorPalette.muted"
      },
      surface: {
        bg: "colorPalette.subtle",
        color: "colorPalette.fg",
        shadow: "inset 0 0 0px 1px var(--shadow-color)",
        shadowColor: "colorPalette.muted"
      },
      plain: {
        color: "colorPalette.fg"
      }
    },
    size: {
      xs: {
        textStyle: "2xs",
        px: "1",
        minH: "4"
      },
      sm: {
        textStyle: "xs",
        px: "1.5",
        minH: "5"
      },
      md: {
        textStyle: "sm",
        px: "2",
        minH: "6"
      },
      lg: {
        textStyle: "sm",
        px: "2.5",
        minH: "7"
      }
    }
  },
  defaultVariants: {
    variant: "subtle",
    size: "sm"
  }
}), X2 = Qe({
  className: "chakra-button",
  base: {
    display: "inline-flex",
    appearance: "none",
    alignItems: "center",
    justifyContent: "center",
    userSelect: "none",
    position: "relative",
    borderRadius: "l2",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    borderWidth: "1px",
    borderColor: "transparent",
    cursor: "button",
    flexShrink: "0",
    outline: "0",
    lineHeight: "1.2",
    isolation: "isolate",
    fontWeight: "medium",
    transitionProperty: "common",
    transitionDuration: "moderate",
    focusVisibleRing: "outside",
    _disabled: {
      layerStyle: "disabled"
    },
    _icon: {
      flexShrink: "0"
    }
  },
  variants: {
    size: {
      "2xs": {
        h: "6",
        minW: "6",
        textStyle: "xs",
        px: "2",
        gap: "1",
        _icon: {
          width: "3.5",
          height: "3.5"
        }
      },
      xs: {
        h: "8",
        minW: "8",
        textStyle: "xs",
        px: "2.5",
        gap: "1",
        _icon: {
          width: "4",
          height: "4"
        }
      },
      sm: {
        h: "9",
        minW: "9",
        px: "3.5",
        textStyle: "sm",
        gap: "2",
        _icon: {
          width: "4",
          height: "4"
        }
      },
      md: {
        h: "10",
        minW: "10",
        textStyle: "sm",
        px: "4",
        gap: "2",
        _icon: {
          width: "5",
          height: "5"
        }
      },
      lg: {
        h: "11",
        minW: "11",
        textStyle: "md",
        px: "5",
        gap: "3",
        _icon: {
          width: "5",
          height: "5"
        }
      },
      xl: {
        h: "12",
        minW: "12",
        textStyle: "md",
        px: "5",
        gap: "2.5",
        _icon: {
          width: "5",
          height: "5"
        }
      },
      "2xl": {
        h: "16",
        minW: "16",
        textStyle: "lg",
        px: "7",
        gap: "3",
        _icon: {
          width: "6",
          height: "6"
        }
      }
    },
    variant: {
      solid: {
        bg: "colorPalette.solid",
        color: "colorPalette.contrast",
        borderColor: "transparent",
        _hover: {
          bg: "colorPalette.solid/90"
        },
        _expanded: {
          bg: "colorPalette.solid/90"
        }
      },
      subtle: {
        bg: "colorPalette.subtle",
        color: "colorPalette.fg",
        borderColor: "transparent",
        _hover: {
          bg: "colorPalette.muted"
        },
        _expanded: {
          bg: "colorPalette.muted"
        }
      },
      surface: {
        bg: "colorPalette.subtle",
        color: "colorPalette.fg",
        shadow: "0 0 0px 1px var(--shadow-color)",
        shadowColor: "colorPalette.muted",
        _hover: {
          bg: "colorPalette.muted"
        },
        _expanded: {
          bg: "colorPalette.muted"
        }
      },
      outline: {
        borderWidth: "1px",
        borderColor: "colorPalette.muted",
        color: "colorPalette.fg",
        _hover: {
          bg: "colorPalette.subtle"
        },
        _expanded: {
          bg: "colorPalette.subtle"
        }
      },
      ghost: {
        bg: "transparent",
        color: "colorPalette.fg",
        _hover: {
          bg: "colorPalette.subtle"
        },
        _expanded: {
          bg: "colorPalette.subtle"
        }
      },
      plain: {
        color: "colorPalette.fg"
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "solid"
  }
}), nt = Qe({
  className: "chakra-checkmark",
  base: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: "0",
    color: "white",
    borderWidth: "1px",
    borderColor: "transparent",
    borderRadius: "l1",
    cursor: "checkbox",
    focusVisibleRing: "outside",
    _icon: {
      boxSize: "full"
    },
    _invalid: {
      colorPalette: "red",
      borderColor: "border.error"
    },
    _disabled: {
      opacity: "0.5",
      cursor: "disabled"
    }
  },
  variants: {
    size: {
      xs: {
        boxSize: "3"
      },
      sm: {
        boxSize: "4"
      },
      md: {
        boxSize: "5",
        p: "0.5"
      },
      lg: {
        boxSize: "6",
        p: "0.5"
      }
    },
    variant: {
      solid: {
        borderColor: "border",
        "&:is([data-state=checked], [data-state=indeterminate])": {
          bg: "colorPalette.solid",
          color: "colorPalette.contrast",
          borderColor: "colorPalette.solid"
        }
      },
      outline: {
        borderColor: "border",
        "&:is([data-state=checked], [data-state=indeterminate])": {
          color: "colorPalette.fg",
          borderColor: "colorPalette.solid"
        }
      },
      subtle: {
        bg: "colorPalette.muted",
        borderColor: "colorPalette.muted",
        "&:is([data-state=checked], [data-state=indeterminate])": {
          color: "colorPalette.fg"
        }
      },
      plain: {
        "&:is([data-state=checked], [data-state=indeterminate])": {
          color: "colorPalette.fg"
        }
      },
      inverted: {
        borderColor: "border",
        color: "colorPalette.fg",
        "&:is([data-state=checked], [data-state=indeterminate])": {
          borderColor: "colorPalette.solid"
        }
      }
    }
  },
  defaultVariants: {
    variant: "solid",
    size: "md"
  }
}), { variants: J2, defaultVariants: Z2 } = Kd, Q2 = Qe({
  className: "chakra-code",
  base: {
    fontFamily: "mono",
    alignItems: "center",
    display: "inline-flex",
    borderRadius: "l2"
  },
  variants: J2,
  defaultVariants: Z2
}), bx = Qe({
  className: "color-swatch",
  base: {
    boxSize: "var(--swatch-size)",
    shadow: "inset 0 0 0 1px rgba(0, 0, 0, 0.1)",
    "--checker-size": "8px",
    "--checker-bg": "colors.bg",
    "--checker-fg": "colors.bg.emphasized",
    background: "linear-gradient(var(--color), var(--color)), repeating-conic-gradient(var(--checker-fg) 0%, var(--checker-fg) 25%, var(--checker-bg) 0%, var(--checker-bg) 50%) 0% 50% / var(--checker-size) var(--checker-size) !important",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: "0"
  },
  variants: {
    size: {
      "2xs": { "--swatch-size": "sizes.3.5" },
      xs: { "--swatch-size": "sizes.4" },
      sm: { "--swatch-size": "sizes.4.5" },
      md: { "--swatch-size": "sizes.5" },
      lg: { "--swatch-size": "sizes.6" },
      xl: { "--swatch-size": "sizes.7" },
      "2xl": { "--swatch-size": "sizes.8" },
      inherit: { "--swatch-size": "inherit" },
      full: { "--swatch-size": "100%" }
    },
    shape: {
      square: { borderRadius: "none" },
      circle: { borderRadius: "full" },
      rounded: { borderRadius: "l1" }
    }
  },
  defaultVariants: {
    size: "md",
    shape: "rounded"
  }
}), eA = Qe({
  className: "chakra-container",
  base: {
    position: "relative",
    maxWidth: "8xl",
    w: "100%",
    mx: "auto",
    px: { base: "4", md: "6", lg: "8" }
  },
  variants: {
    centerContent: {
      true: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }
    },
    fluid: {
      true: {
        maxWidth: "full"
      }
    }
  }
}), tA = Qe({
  className: "chakra-heading",
  base: {
    fontFamily: "heading",
    fontWeight: "semibold"
  },
  variants: {
    size: {
      xs: { textStyle: "xs" },
      sm: { textStyle: "sm" },
      md: { textStyle: "md" },
      lg: { textStyle: "lg" },
      xl: { textStyle: "xl" },
      "2xl": { textStyle: "2xl" },
      "3xl": { textStyle: "3xl" },
      "4xl": { textStyle: "4xl" },
      "5xl": { textStyle: "5xl" },
      "6xl": { textStyle: "6xl" },
      "7xl": { textStyle: "7xl" }
    }
  },
  defaultVariants: {
    size: "xl"
  }
}), rA = Qe({
  className: "chakra-icon",
  base: {
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: "0",
    color: "currentcolor",
    verticalAlign: "middle"
  },
  variants: {
    size: {
      inherit: {},
      xs: { boxSize: "3" },
      sm: { boxSize: "4" },
      md: { boxSize: "5" },
      lg: { boxSize: "6" },
      xl: { boxSize: "7" },
      "2xl": { boxSize: "8" }
    }
  },
  defaultVariants: {
    size: "inherit"
  }
}), je = Qe({
  className: "chakra-input",
  base: {
    width: "100%",
    minWidth: "0",
    outline: "0",
    position: "relative",
    appearance: "none",
    textAlign: "start",
    borderRadius: "l2",
    _disabled: {
      layerStyle: "disabled"
    },
    height: "var(--input-height)",
    minW: "var(--input-height)",
    "--focus-color": "colors.colorPalette.focusRing",
    "--error-color": "colors.border.error",
    _invalid: {
      focusRingColor: "var(--error-color)",
      borderColor: "var(--error-color)"
    }
  },
  variants: {
    size: {
      "2xs": {
        textStyle: "xs",
        px: "2",
        "--input-height": "sizes.7"
      },
      xs: {
        textStyle: "xs",
        px: "2",
        "--input-height": "sizes.8"
      },
      sm: {
        textStyle: "sm",
        px: "2.5",
        "--input-height": "sizes.9"
      },
      md: {
        textStyle: "sm",
        px: "3",
        "--input-height": "sizes.10"
      },
      lg: {
        textStyle: "md",
        px: "4",
        "--input-height": "sizes.11"
      },
      xl: {
        textStyle: "md",
        px: "4.5",
        "--input-height": "sizes.12"
      },
      "2xl": {
        textStyle: "lg",
        px: "5",
        "--input-height": "sizes.16"
      }
    },
    variant: {
      outline: {
        bg: "transparent",
        borderWidth: "1px",
        borderColor: "border",
        focusVisibleRing: "inside",
        focusRingColor: "var(--focus-color)"
      },
      subtle: {
        borderWidth: "1px",
        borderColor: "transparent",
        bg: "bg.muted",
        focusVisibleRing: "inside",
        focusRingColor: "var(--focus-color)"
      },
      flushed: {
        bg: "transparent",
        borderBottomWidth: "1px",
        borderBottomColor: "border",
        borderRadius: "0",
        px: "0",
        _focusVisible: {
          borderColor: "var(--focus-color)",
          boxShadow: "0px 1px 0px 0px var(--focus-color)",
          _invalid: {
            borderColor: "var(--error-color)",
            boxShadow: "0px 1px 0px 0px var(--error-color)"
          }
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
}), nA = Qe({
  className: "chakra-input-addon",
  base: {
    flex: "0 0 auto",
    width: "auto",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    alignSelf: "stretch",
    borderRadius: "l2"
  },
  variants: {
    size: je.variants.size,
    variant: {
      outline: {
        borderWidth: "1px",
        borderColor: "border",
        bg: "bg.muted"
      },
      subtle: {
        borderWidth: "1px",
        borderColor: "transparent",
        bg: "bg.emphasized"
      },
      flushed: {
        borderBottom: "1px solid",
        borderColor: "inherit",
        borderRadius: "0",
        px: "0",
        bg: "transparent"
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
}), iA = Qe({
  className: "chakra-kbd",
  base: {
    display: "inline-flex",
    alignItems: "center",
    fontWeight: "medium",
    fontFamily: "mono",
    flexShrink: "0",
    whiteSpace: "nowrap",
    wordSpacing: "-0.5em",
    userSelect: "none",
    px: "1",
    borderRadius: "l2"
  },
  variants: {
    variant: {
      raised: {
        bg: "colorPalette.subtle",
        color: "colorPalette.fg",
        borderWidth: "1px",
        borderBottomWidth: "2px",
        borderColor: "colorPalette.muted"
      },
      outline: {
        borderWidth: "1px",
        color: "colorPalette.fg"
      },
      subtle: {
        bg: "colorPalette.muted",
        color: "colorPalette.fg"
      },
      plain: {
        color: "colorPalette.fg"
      }
    },
    size: {
      sm: {
        textStyle: "xs",
        height: "4.5"
      },
      md: {
        textStyle: "sm",
        height: "5"
      },
      lg: {
        textStyle: "md",
        height: "6"
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "raised"
  }
}), oA = Qe({
  className: "chakra-link",
  base: {
    display: "inline-flex",
    alignItems: "center",
    outline: "none",
    gap: "1.5",
    cursor: "pointer",
    borderRadius: "l1",
    focusRing: "outside"
  },
  variants: {
    variant: {
      underline: {
        color: "colorPalette.fg",
        textDecoration: "underline",
        textUnderlineOffset: "3px",
        textDecorationColor: "currentColor/20"
      },
      plain: {
        color: "colorPalette.fg",
        _hover: {
          textDecoration: "underline",
          textUnderlineOffset: "3px",
          textDecorationColor: "currentColor/20"
        }
      }
    }
  },
  defaultVariants: {
    variant: "plain"
  }
}), sA = Qe({
  className: "chakra-mark",
  base: {
    bg: "transparent",
    color: "inherit",
    whiteSpace: "nowrap"
  },
  variants: {
    variant: {
      subtle: {
        bg: "colorPalette.subtle",
        color: "inherit"
      },
      solid: {
        bg: "colorPalette.solid",
        color: "colorPalette.contrast"
      },
      text: {
        fontWeight: "medium"
      },
      plain: {}
    }
  }
}), it = Qe({
  className: "chakra-radiomark",
  base: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    verticalAlign: "top",
    color: "white",
    borderWidth: "1px",
    borderColor: "transparent",
    borderRadius: "full",
    cursor: "radio",
    _focusVisible: {
      outline: "2px solid",
      outlineColor: "colorPalette.focusRing",
      outlineOffset: "2px"
    },
    _invalid: {
      colorPalette: "red",
      borderColor: "red.500"
    },
    _disabled: {
      opacity: "0.5",
      cursor: "disabled"
    },
    "& .dot": {
      height: "100%",
      width: "100%",
      borderRadius: "full",
      bg: "currentColor",
      scale: "0.4"
    }
  },
  variants: {
    variant: {
      solid: {
        borderWidth: "1px",
        borderColor: "border",
        _checked: {
          bg: "colorPalette.solid",
          color: "colorPalette.contrast",
          borderColor: "colorPalette.solid"
        }
      },
      subtle: {
        borderWidth: "1px",
        bg: "colorPalette.muted",
        borderColor: "colorPalette.muted",
        color: "transparent",
        _checked: {
          color: "colorPalette.fg"
        }
      },
      outline: {
        borderWidth: "1px",
        borderColor: "inherit",
        _checked: {
          color: "colorPalette.fg",
          borderColor: "colorPalette.solid"
        },
        "& .dot": {
          scale: "0.6"
        }
      },
      inverted: {
        bg: "bg",
        borderWidth: "1px",
        borderColor: "inherit",
        _checked: {
          color: "colorPalette.solid",
          borderColor: "currentcolor"
        }
      }
    },
    size: {
      xs: {
        boxSize: "3"
      },
      sm: {
        boxSize: "4"
      },
      md: {
        boxSize: "5"
      },
      lg: {
        boxSize: "6"
      }
    }
  },
  defaultVariants: {
    variant: "solid",
    size: "md"
  }
}), aA = Qe({
  className: "chakra-separator",
  base: {
    display: "block",
    borderColor: "border"
  },
  variants: {
    variant: {
      solid: {
        borderStyle: "solid"
      },
      dashed: {
        borderStyle: "dashed"
      },
      dotted: {
        borderStyle: "dotted"
      }
    },
    orientation: {
      vertical: {
        borderInlineStartWidth: "var(--separator-thickness)"
      },
      horizontal: {
        borderTopWidth: "var(--separator-thickness)"
      }
    },
    size: {
      xs: {
        "--separator-thickness": "0.5px"
      },
      sm: {
        "--separator-thickness": "1px"
      },
      md: {
        "--separator-thickness": "2px"
      },
      lg: {
        "--separator-thickness": "3px"
      }
    }
  },
  defaultVariants: {
    size: "sm",
    variant: "solid",
    orientation: "horizontal"
  }
}), lA = Qe({
  className: "chakra-skeleton",
  base: {},
  variants: {
    loading: {
      true: {
        borderRadius: "l2",
        boxShadow: "none",
        backgroundClip: "padding-box",
        cursor: "default",
        color: "transparent",
        pointerEvents: "none",
        userSelect: "none",
        flexShrink: "0",
        "&::before, &::after, *": {
          visibility: "hidden"
        }
      },
      false: {
        background: "unset",
        animation: "fade-in var(--fade-duration, 0.1s) ease-out !important"
      }
    },
    variant: {
      pulse: {
        background: "bg.emphasized",
        animation: "pulse",
        animationDuration: "var(--duration, 1.2s)"
      },
      shine: {
        "--animate-from": "200%",
        "--animate-to": "-200%",
        "--start-color": "colors.bg.muted",
        "--end-color": "colors.bg.emphasized",
        backgroundImage: "linear-gradient(270deg,var(--start-color),var(--end-color),var(--end-color),var(--start-color))",
        backgroundSize: "400% 100%",
        animation: "bg-position var(--duration, 5s) ease-in-out infinite"
      },
      none: {
        animation: "none"
      }
    }
  },
  defaultVariants: {
    variant: "pulse",
    loading: !0
  }
}), cA = Qe({
  className: "chakra-skip-nav",
  base: {
    display: "inline-flex",
    bg: "bg.panel",
    padding: "2.5",
    borderRadius: "l2",
    fontWeight: "semibold",
    focusVisibleRing: "outside",
    textStyle: "sm",
    // visually hidden
    userSelect: "none",
    border: "0",
    height: "1px",
    width: "1px",
    margin: "-1px",
    outline: "0",
    overflow: "hidden",
    position: "absolute",
    clip: "rect(0 0 0 0)",
    _focusVisible: {
      clip: "auto",
      width: "auto",
      height: "auto",
      position: "fixed",
      top: "6",
      insetStart: "6"
    }
  }
}), uA = Qe({
  className: "chakra-spinner",
  base: {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderWidth: "2px",
    borderRadius: "full",
    width: "var(--spinner-size)",
    height: "var(--spinner-size)",
    animation: "spin",
    animationDuration: "slowest",
    "--spinner-track-color": "transparent",
    borderBottomColor: "var(--spinner-track-color)",
    borderInlineStartColor: "var(--spinner-track-color)"
  },
  variants: {
    size: {
      inherit: { "--spinner-size": "1em" },
      xs: { "--spinner-size": "sizes.3" },
      sm: { "--spinner-size": "sizes.4" },
      md: { "--spinner-size": "sizes.5" },
      lg: { "--spinner-size": "sizes.8" },
      xl: { "--spinner-size": "sizes.10" }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), dA = Qe({
  className: "chakra-textarea",
  base: {
    width: "100%",
    minWidth: "0",
    outline: "0",
    position: "relative",
    appearance: "none",
    textAlign: "start",
    borderRadius: "l2",
    _disabled: {
      layerStyle: "disabled"
    },
    "--focus-color": "colors.colorPalette.focusRing",
    "--error-color": "colors.border.error",
    _invalid: {
      focusRingColor: "var(--error-color)",
      borderColor: "var(--error-color)"
    }
  },
  variants: {
    size: {
      xs: {
        textStyle: "xs",
        px: "2",
        py: "1.5",
        scrollPaddingBottom: "1.5"
      },
      sm: {
        textStyle: "sm",
        px: "2.5",
        py: "2",
        scrollPaddingBottom: "2"
      },
      md: {
        textStyle: "sm",
        px: "3",
        py: "2",
        scrollPaddingBottom: "2"
      },
      lg: {
        textStyle: "md",
        px: "4",
        py: "3",
        scrollPaddingBottom: "3"
      },
      xl: {
        textStyle: "md",
        px: "4.5",
        py: "3.5",
        scrollPaddingBottom: "3.5"
      }
    },
    variant: {
      outline: {
        bg: "transparent",
        borderWidth: "1px",
        borderColor: "border",
        focusVisibleRing: "inside"
      },
      subtle: {
        borderWidth: "1px",
        borderColor: "transparent",
        bg: "bg.muted",
        focusVisibleRing: "inside"
      },
      flushed: {
        bg: "transparent",
        borderBottomWidth: "1px",
        borderBottomColor: "border",
        borderRadius: "0",
        px: "0",
        _focusVisible: {
          borderColor: "var(--focus-color)",
          boxShadow: "0px 1px 0px 0px var(--focus-color)"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
}), fA = {
  badge: Kd,
  button: X2,
  code: Q2,
  container: eA,
  heading: tA,
  input: je,
  inputAddon: nA,
  kbd: iA,
  link: oA,
  mark: sA,
  separator: aA,
  skeleton: lA,
  skipNavLink: cA,
  spinner: uA,
  textarea: dA,
  icon: rA,
  checkmark: nt,
  radiomark: it,
  colorSwatch: bx
}, hA = Gd.colors({
  bg: {
    DEFAULT: {
      value: { _light: "{colors.white}", _dark: "{colors.black}" }
    },
    subtle: {
      value: { _light: "{colors.gray.50}", _dark: "{colors.gray.950}" }
    },
    muted: {
      value: { _light: "{colors.gray.100}", _dark: "{colors.gray.900}" }
    },
    emphasized: {
      value: { _light: "{colors.gray.200}", _dark: "{colors.gray.800}" }
    },
    inverted: {
      value: { _light: "{colors.black}", _dark: "{colors.white}" }
    },
    panel: {
      value: { _light: "{colors.white}", _dark: "{colors.gray.950}" }
    },
    error: {
      value: { _light: "{colors.red.50}", _dark: "{colors.red.950}" }
    },
    warning: {
      value: { _light: "{colors.orange.50}", _dark: "{colors.orange.950}" }
    },
    success: {
      value: { _light: "{colors.green.50}", _dark: "{colors.green.950}" }
    },
    info: {
      value: { _light: "{colors.blue.50}", _dark: "{colors.blue.950}" }
    }
  },
  fg: {
    DEFAULT: {
      value: { _light: "{colors.black}", _dark: "{colors.gray.50}" }
    },
    muted: {
      value: { _light: "{colors.gray.600}", _dark: "{colors.gray.400}" }
    },
    subtle: {
      value: { _light: "{colors.gray.400}", _dark: "{colors.gray.500}" }
    },
    inverted: {
      value: { _light: "{colors.gray.50}", _dark: "{colors.black}" }
    },
    error: {
      value: { _light: "{colors.red.500}", _dark: "{colors.red.400}" }
    },
    warning: {
      value: { _light: "{colors.orange.600}", _dark: "{colors.orange.300}" }
    },
    success: {
      value: { _light: "{colors.green.600}", _dark: "{colors.green.300}" }
    },
    info: {
      value: { _light: "{colors.blue.600}", _dark: "{colors.blue.300}" }
    }
  },
  border: {
    DEFAULT: {
      value: { _light: "{colors.gray.200}", _dark: "{colors.gray.800}" }
    },
    muted: {
      value: { _light: "{colors.gray.100}", _dark: "{colors.gray.900}" }
    },
    subtle: {
      value: { _light: "{colors.gray.50}", _dark: "{colors.gray.950}" }
    },
    emphasized: {
      value: { _light: "{colors.gray.300}", _dark: "{colors.gray.700}" }
    },
    inverted: {
      value: { _light: "{colors.gray.800}", _dark: "{colors.gray.200}" }
    },
    error: {
      value: { _light: "{colors.red.500}", _dark: "{colors.red.400}" }
    },
    warning: {
      value: { _light: "{colors.orange.500}", _dark: "{colors.orange.400}" }
    },
    success: {
      value: { _light: "{colors.green.500}", _dark: "{colors.green.400}" }
    },
    info: {
      value: { _light: "{colors.blue.500}", _dark: "{colors.blue.400}" }
    }
  },
  gray: {
    contrast: {
      value: { _light: "{colors.white}", _dark: "{colors.black}" }
    },
    fg: {
      value: { _light: "{colors.gray.800}", _dark: "{colors.gray.200}" }
    },
    subtle: {
      value: { _light: "{colors.gray.100}", _dark: "{colors.gray.900}" }
    },
    muted: {
      value: { _light: "{colors.gray.200}", _dark: "{colors.gray.800}" }
    },
    emphasized: {
      value: { _light: "{colors.gray.300}", _dark: "{colors.gray.700}" }
    },
    solid: {
      value: { _light: "{colors.gray.900}", _dark: "{colors.white}" }
    },
    focusRing: {
      value: { _light: "{colors.gray.400}", _dark: "{colors.gray.400}" }
    }
  },
  red: {
    contrast: {
      value: { _light: "white", _dark: "white" }
    },
    fg: {
      value: { _light: "{colors.red.700}", _dark: "{colors.red.300}" }
    },
    subtle: {
      value: { _light: "{colors.red.100}", _dark: "{colors.red.900}" }
    },
    muted: {
      value: { _light: "{colors.red.200}", _dark: "{colors.red.800}" }
    },
    emphasized: {
      value: { _light: "{colors.red.300}", _dark: "{colors.red.700}" }
    },
    solid: {
      value: { _light: "{colors.red.600}", _dark: "{colors.red.600}" }
    },
    focusRing: {
      value: { _light: "{colors.red.400}", _dark: "{colors.red.400}" }
    }
  },
  orange: {
    contrast: {
      value: { _light: "white", _dark: "black" }
    },
    fg: {
      value: { _light: "{colors.orange.700}", _dark: "{colors.orange.300}" }
    },
    subtle: {
      value: { _light: "{colors.orange.100}", _dark: "{colors.orange.900}" }
    },
    muted: {
      value: { _light: "{colors.orange.200}", _dark: "{colors.orange.800}" }
    },
    emphasized: {
      value: { _light: "{colors.orange.300}", _dark: "{colors.orange.700}" }
    },
    solid: {
      value: { _light: "{colors.orange.600}", _dark: "{colors.orange.500}" }
    },
    focusRing: {
      value: { _light: "{colors.orange.400}", _dark: "{colors.orange.400}" }
    }
  },
  green: {
    contrast: {
      value: { _light: "white", _dark: "white" }
    },
    fg: {
      value: { _light: "{colors.green.700}", _dark: "{colors.green.300}" }
    },
    subtle: {
      value: { _light: "{colors.green.100}", _dark: "{colors.green.900}" }
    },
    muted: {
      value: { _light: "{colors.green.200}", _dark: "{colors.green.800}" }
    },
    emphasized: {
      value: { _light: "{colors.green.300}", _dark: "{colors.green.700}" }
    },
    solid: {
      value: { _light: "{colors.green.600}", _dark: "{colors.green.600}" }
    },
    focusRing: {
      value: { _light: "{colors.green.400}", _dark: "{colors.green.400}" }
    }
  },
  blue: {
    contrast: {
      value: { _light: "white", _dark: "white" }
    },
    fg: {
      value: { _light: "{colors.blue.700}", _dark: "{colors.blue.300}" }
    },
    subtle: {
      value: { _light: "{colors.blue.100}", _dark: "{colors.blue.900}" }
    },
    muted: {
      value: { _light: "{colors.blue.200}", _dark: "{colors.blue.800}" }
    },
    emphasized: {
      value: { _light: "{colors.blue.300}", _dark: "{colors.blue.700}" }
    },
    solid: {
      value: { _light: "{colors.blue.600}", _dark: "{colors.blue.600}" }
    },
    focusRing: {
      value: { _light: "{colors.blue.400}", _dark: "{colors.blue.400}" }
    }
  },
  yellow: {
    contrast: {
      value: { _light: "black", _dark: "black" }
    },
    fg: {
      value: { _light: "{colors.yellow.800}", _dark: "{colors.yellow.300}" }
    },
    subtle: {
      value: { _light: "{colors.yellow.100}", _dark: "{colors.yellow.900}" }
    },
    muted: {
      value: { _light: "{colors.yellow.200}", _dark: "{colors.yellow.800}" }
    },
    emphasized: {
      value: { _light: "{colors.yellow.300}", _dark: "{colors.yellow.700}" }
    },
    solid: {
      value: { _light: "{colors.yellow.300}", _dark: "{colors.yellow.300}" }
    },
    focusRing: {
      value: { _light: "{colors.yellow.400}", _dark: "{colors.yellow.400}" }
    }
  },
  teal: {
    contrast: {
      value: { _light: "white", _dark: "white" }
    },
    fg: {
      value: { _light: "{colors.teal.700}", _dark: "{colors.teal.300}" }
    },
    subtle: {
      value: { _light: "{colors.teal.100}", _dark: "{colors.teal.900}" }
    },
    muted: {
      value: { _light: "{colors.teal.200}", _dark: "{colors.teal.800}" }
    },
    emphasized: {
      value: { _light: "{colors.teal.300}", _dark: "{colors.teal.700}" }
    },
    solid: {
      value: { _light: "{colors.teal.600}", _dark: "{colors.teal.600}" }
    },
    focusRing: {
      value: { _light: "{colors.teal.400}", _dark: "{colors.teal.400}" }
    }
  },
  purple: {
    contrast: {
      value: { _light: "white", _dark: "white" }
    },
    fg: {
      value: { _light: "{colors.purple.700}", _dark: "{colors.purple.300}" }
    },
    subtle: {
      value: { _light: "{colors.purple.100}", _dark: "{colors.purple.900}" }
    },
    muted: {
      value: { _light: "{colors.purple.200}", _dark: "{colors.purple.800}" }
    },
    emphasized: {
      value: { _light: "{colors.purple.300}", _dark: "{colors.purple.700}" }
    },
    solid: {
      value: { _light: "{colors.purple.600}", _dark: "{colors.purple.600}" }
    },
    focusRing: {
      value: { _light: "{colors.purple.400}", _dark: "{colors.purple.400}" }
    }
  },
  pink: {
    contrast: {
      value: { _light: "white", _dark: "white" }
    },
    fg: {
      value: { _light: "{colors.pink.700}", _dark: "{colors.pink.300}" }
    },
    subtle: {
      value: { _light: "{colors.pink.100}", _dark: "{colors.pink.900}" }
    },
    muted: {
      value: { _light: "{colors.pink.200}", _dark: "{colors.pink.800}" }
    },
    emphasized: {
      value: { _light: "{colors.pink.300}", _dark: "{colors.pink.700}" }
    },
    solid: {
      value: { _light: "{colors.pink.600}", _dark: "{colors.pink.600}" }
    },
    focusRing: {
      value: { _light: "{colors.pink.400}", _dark: "{colors.pink.400}" }
    }
  },
  cyan: {
    contrast: {
      value: { _light: "white", _dark: "white" }
    },
    fg: {
      value: { _light: "{colors.cyan.700}", _dark: "{colors.cyan.300}" }
    },
    subtle: {
      value: { _light: "{colors.cyan.100}", _dark: "{colors.cyan.900}" }
    },
    muted: {
      value: { _light: "{colors.cyan.200}", _dark: "{colors.cyan.800}" }
    },
    emphasized: {
      value: { _light: "{colors.cyan.300}", _dark: "{colors.cyan.700}" }
    },
    solid: {
      value: { _light: "{colors.cyan.600}", _dark: "{colors.cyan.600}" }
    },
    focusRing: {
      value: { _light: "{colors.cyan.400}", _dark: "{colors.cyan.400}" }
    }
  }
}), pA = Gd.radii({
  l1: { value: "{radii.xs}" },
  l2: { value: "{radii.sm}" },
  l3: { value: "{radii.md}" }
}), gA = Gd.shadows({
  xs: {
    value: {
      _light: "0px 1px 2px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/20}",
      _dark: "0px 1px 1px {black/64}, 0px 0px 1px inset {colors.gray.300/20}"
    }
  },
  sm: {
    value: {
      _light: "0px 2px 4px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/30}",
      _dark: "0px 2px 4px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
    }
  },
  md: {
    value: {
      _light: "0px 4px 8px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/30}",
      _dark: "0px 4px 8px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
    }
  },
  lg: {
    value: {
      _light: "0px 8px 16px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/30}",
      _dark: "0px 8px 16px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
    }
  },
  xl: {
    value: {
      _light: "0px 16px 24px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/30}",
      _dark: "0px 16px 24px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
    }
  },
  "2xl": {
    value: {
      _light: "0px 24px 40px {colors.gray.900/16}, 0px 0px 1px {colors.gray.900/30}",
      _dark: "0px 24px 40px {black/64}, 0px 0px 1px inset {colors.gray.300/30}"
    }
  },
  inner: {
    value: {
      _light: "inset 0 2px 4px 0 {black/5}",
      _dark: "inset 0 2px 4px 0 black"
    }
  },
  inset: {
    value: {
      _light: "inset 0 0 0 1px {black/5}",
      _dark: "inset 0 0 0 1px {colors.gray.300/5}"
    }
  }
}), mA = Xb.extendWith("itemBody"), vA = le("action-bar").parts(
  "positioner",
  "content",
  "separator",
  "selectionTrigger",
  "closeTrigger"
), bA = le("alert").parts(
  "title",
  "description",
  "root",
  "indicator",
  "content"
), yA = le("breadcrumb").parts(
  "link",
  "currentLink",
  "item",
  "list",
  "root",
  "ellipsis",
  "separator"
), xA = le("blockquote").parts(
  "root",
  "icon",
  "content",
  "caption"
), _A = le("card").parts(
  "root",
  "header",
  "body",
  "footer",
  "title",
  "description"
), wA = le("checkbox-card", [
  "root",
  "control",
  "label",
  "description",
  "addon",
  "indicator",
  "content"
]), SA = le("data-list").parts(
  "root",
  "item",
  "itemLabel",
  "itemValue"
), EA = Bd.extendWith(
  "header",
  "body",
  "footer",
  "backdrop"
), CA = Bd.extendWith(
  "header",
  "body",
  "footer",
  "backdrop"
), kA = by.extendWith("textarea"), IA = le("empty-state", [
  "root",
  "content",
  "indicator",
  "title",
  "description"
]), OA = xy.extendWith("requiredIndicator"), PA = _y.extendWith("content"), TA = wy.extendWith(
  "itemContent",
  "dropzoneContent",
  "fileText"
), RA = le("list").parts(
  "root",
  "item",
  "indicator"
), AA = ky.extendWith("itemCommand"), NA = le("select").parts(
  "root",
  "field",
  "indicator"
), FA = jy.extendWith(
  "header",
  "body",
  "footer"
), yx = Ud.extendWith(
  "itemAddon",
  "itemIndicator"
), $A = yx.extendWith(
  "itemContent",
  "itemDescription"
), LA = o0.extendWith("itemIndicator"), VA = _0.extendWith("indicatorGroup"), zA = my.extendWith(
  "indicatorGroup",
  "empty"
), DA = I0.extendWith("markerIndicator"), MA = le("stat").parts(
  "root",
  "label",
  "helpText",
  "valueText",
  "valueUnit",
  "indicator"
), BA = le("status").parts("root", "indicator"), WA = le("steps", [
  "root",
  "list",
  "item",
  "trigger",
  "indicator",
  "separator",
  "content",
  "title",
  "description",
  "nextTrigger",
  "prevTrigger",
  "progress"
]), HA = O0.extendWith("indicator"), jA = le("table").parts(
  "root",
  "header",
  "body",
  "row",
  "columnHeader",
  "cell",
  "footer",
  "caption"
), UA = le("toast").parts(
  "root",
  "title",
  "description",
  "indicator",
  "closeTrigger",
  "actionTrigger"
), GA = le("tabs").parts(
  "root",
  "trigger",
  "list",
  "content",
  "contentGroup",
  "indicator"
), qA = le("tag").parts(
  "root",
  "label",
  "closeTrigger",
  "startElement",
  "endElement"
), KA = le("timeline").parts(
  "root",
  "item",
  "content",
  "separator",
  "indicator",
  "connector",
  "title",
  "description"
), YA = EO.extendWith("channelText"), XA = ce({
  className: "chakra-accordion",
  slots: mA.keys(),
  base: {
    root: {
      width: "full",
      "--accordion-radius": "radii.l2"
    },
    item: {
      overflowAnchor: "none"
    },
    itemTrigger: {
      display: "flex",
      alignItems: "center",
      textAlign: "start",
      width: "full",
      outline: "0",
      gap: "3",
      fontWeight: "medium",
      borderRadius: "var(--accordion-radius)",
      _focusVisible: {
        outline: "2px solid",
        outlineColor: "colorPalette.focusRing"
      },
      _disabled: {
        layerStyle: "disabled"
      }
    },
    itemBody: {
      pt: "var(--accordion-padding-y)",
      pb: "calc(var(--accordion-padding-y) * 2)"
    },
    itemContent: {
      overflow: "hidden",
      borderRadius: "var(--accordion-radius)",
      _open: {
        animationName: "expand-height, fade-in",
        animationDuration: "moderate"
      },
      _closed: {
        animationName: "collapse-height, fade-out",
        animationDuration: "moderate"
      }
    },
    itemIndicator: {
      transition: "rotate 0.2s",
      transformOrigin: "center",
      color: "fg.subtle",
      _open: {
        rotate: "180deg"
      },
      _icon: {
        width: "1.2em",
        height: "1.2em"
      }
    }
  },
  variants: {
    variant: {
      outline: {
        item: {
          borderBottomWidth: "1px"
        }
      },
      subtle: {
        itemTrigger: {
          px: "var(--accordion-padding-x)"
        },
        itemContent: {
          px: "var(--accordion-padding-x)"
        },
        item: {
          borderRadius: "var(--accordion-radius)",
          _open: {
            bg: "colorPalette.subtle"
          }
        }
      },
      enclosed: {
        root: {
          borderWidth: "1px",
          borderRadius: "var(--accordion-radius)",
          divideY: "1px",
          overflow: "hidden"
        },
        itemTrigger: {
          px: "var(--accordion-padding-x)"
        },
        itemContent: {
          px: "var(--accordion-padding-x)"
        },
        item: {
          _open: {
            bg: "bg.subtle"
          }
        }
      },
      plain: {}
    },
    size: {
      sm: {
        root: {
          "--accordion-padding-x": "spacing.3",
          "--accordion-padding-y": "spacing.2"
        },
        itemTrigger: {
          textStyle: "sm",
          py: "var(--accordion-padding-y)"
        }
      },
      md: {
        root: {
          "--accordion-padding-x": "spacing.4",
          "--accordion-padding-y": "spacing.2"
        },
        itemTrigger: {
          textStyle: "md",
          py: "var(--accordion-padding-y)"
        }
      },
      lg: {
        root: {
          "--accordion-padding-x": "spacing.4.5",
          "--accordion-padding-y": "spacing.2.5"
        },
        itemTrigger: {
          textStyle: "lg",
          py: "var(--accordion-padding-y)"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
}), JA = ce({
  className: "chakra-action-bar",
  slots: vA.keys(),
  base: {
    positioner: {
      position: "fixed",
      display: "flex",
      justifyContent: "center",
      pointerEvents: "none",
      insetInline: "0",
      top: "unset",
      bottom: "calc(env(safe-area-inset-bottom) + 20px)"
    },
    content: {
      bg: "bg.panel",
      shadow: "md",
      display: "flex",
      alignItems: "center",
      gap: "3",
      borderRadius: "l3",
      py: "2.5",
      px: "3",
      pointerEvents: "auto",
      // Stabilize the position of the action bar when the scrollbar is hidden
      // by using the scrollbar width to offset the position.
      translate: "calc(-1 * var(--scrollbar-width) / 2) 0px",
      _open: {
        animationName: "slide-from-bottom, fade-in",
        animationDuration: "moderate"
      },
      _closed: {
        animationName: "slide-to-bottom, fade-out",
        animationDuration: "faster"
      }
    },
    separator: {
      width: "1px",
      height: "5",
      bg: "border"
    },
    selectionTrigger: {
      display: "inline-flex",
      alignItems: "center",
      gap: "2",
      alignSelf: "stretch",
      textStyle: "sm",
      px: "4",
      py: "1",
      borderRadius: "l2",
      borderWidth: "1px",
      borderStyle: "dashed"
    }
  }
}), ZA = ce({
  slots: bA.keys(),
  className: "chakra-alert",
  base: {
    root: {
      width: "full",
      display: "flex",
      alignItems: "flex-start",
      position: "relative",
      borderRadius: "l3"
    },
    title: {
      fontWeight: "medium"
    },
    description: {
      display: "inline"
    },
    indicator: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: "0",
      width: "1em",
      height: "1em",
      _icon: { boxSize: "full" }
    },
    content: {
      display: "flex",
      flex: "1",
      gap: "1"
    }
  },
  variants: {
    status: {
      info: {
        root: { colorPalette: "blue" }
      },
      warning: {
        root: { colorPalette: "orange" }
      },
      success: {
        root: { colorPalette: "green" }
      },
      error: {
        root: { colorPalette: "red" }
      },
      neutral: {
        root: { colorPalette: "gray" }
      }
    },
    inline: {
      true: {
        content: {
          display: "inline-flex",
          flexDirection: "row",
          alignItems: "center"
        }
      },
      false: {
        content: {
          display: "flex",
          flexDirection: "column"
        }
      }
    },
    variant: {
      subtle: {
        root: {
          bg: "colorPalette.subtle",
          color: "colorPalette.fg"
        }
      },
      surface: {
        root: {
          bg: "colorPalette.subtle",
          color: "colorPalette.fg",
          shadow: "inset 0 0 0px 1px var(--shadow-color)",
          shadowColor: "colorPalette.muted"
        },
        indicator: {
          color: "colorPalette.fg"
        }
      },
      outline: {
        root: {
          color: "colorPalette.fg",
          shadow: "inset 0 0 0px 1px var(--shadow-color)",
          shadowColor: "colorPalette.muted"
        },
        indicator: {
          color: "colorPalette.fg"
        }
      },
      solid: {
        root: {
          bg: "colorPalette.solid",
          color: "colorPalette.contrast"
        },
        indicator: {
          color: "colorPalette.contrast"
        }
      }
    },
    size: {
      sm: {
        root: {
          gap: "2",
          px: "3",
          py: "3",
          textStyle: "xs"
        },
        indicator: {
          textStyle: "lg"
        }
      },
      md: {
        root: {
          gap: "3",
          px: "4",
          py: "4",
          textStyle: "sm"
        },
        indicator: {
          textStyle: "xl"
        }
      },
      lg: {
        root: {
          gap: "3",
          px: "4",
          py: "4",
          textStyle: "md"
        },
        indicator: {
          textStyle: "2xl"
        }
      }
    }
  },
  defaultVariants: {
    status: "info",
    variant: "subtle",
    size: "md",
    inline: !1
  }
}), QA = ce({
  slots: Qb.keys(),
  className: "chakra-avatar",
  base: {
    root: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "medium",
      position: "relative",
      verticalAlign: "top",
      flexShrink: "0",
      userSelect: "none",
      width: "var(--avatar-size)",
      height: "var(--avatar-size)",
      fontSize: "var(--avatar-font-size)",
      borderRadius: "var(--avatar-radius)",
      "&[data-group-item]": {
        borderWidth: "2px",
        borderColor: "bg"
      }
    },
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "var(--avatar-radius)"
    },
    fallback: {
      lineHeight: "1",
      textTransform: "uppercase",
      fontWeight: "medium",
      fontSize: "var(--avatar-font-size)",
      borderRadius: "var(--avatar-radius)"
    }
  },
  variants: {
    size: {
      full: {
        root: {
          "--avatar-size": "100%",
          "--avatar-font-size": "100%"
        }
      },
      "2xs": {
        root: {
          "--avatar-font-size": "fontSizes.2xs",
          "--avatar-size": "sizes.6"
        }
      },
      xs: {
        root: {
          "--avatar-font-size": "fontSizes.xs",
          "--avatar-size": "sizes.8"
        }
      },
      sm: {
        root: {
          "--avatar-font-size": "fontSizes.sm",
          "--avatar-size": "sizes.9"
        }
      },
      md: {
        root: {
          "--avatar-font-size": "fontSizes.md",
          "--avatar-size": "sizes.10"
        }
      },
      lg: {
        root: {
          "--avatar-font-size": "fontSizes.md",
          "--avatar-size": "sizes.11"
        }
      },
      xl: {
        root: {
          "--avatar-font-size": "fontSizes.lg",
          "--avatar-size": "sizes.12"
        }
      },
      "2xl": {
        root: {
          "--avatar-font-size": "fontSizes.xl",
          "--avatar-size": "sizes.16"
        }
      }
    },
    variant: {
      solid: {
        root: {
          bg: "colorPalette.solid",
          color: "colorPalette.contrast"
        }
      },
      subtle: {
        root: {
          bg: "colorPalette.muted",
          color: "colorPalette.fg"
        }
      },
      outline: {
        root: {
          color: "colorPalette.fg",
          borderWidth: "1px",
          borderColor: "colorPalette.muted"
        }
      }
    },
    shape: {
      square: {},
      rounded: {
        root: { "--avatar-radius": "radii.l3" }
      },
      full: {
        root: { "--avatar-radius": "radii.full" }
      }
    },
    borderless: {
      true: {
        root: {
          "&[data-group-item]": {
            borderWidth: "0px"
          }
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    shape: "full",
    variant: "subtle"
  }
}), eN = ce({
  className: "chakra-blockquote",
  slots: xA.keys(),
  base: {
    root: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: "2"
    },
    caption: {
      textStyle: "sm",
      color: "fg.muted"
    },
    icon: {
      boxSize: "5"
    }
  },
  variants: {
    justify: {
      start: {
        root: {
          alignItems: "flex-start",
          textAlign: "start"
        }
      },
      center: {
        root: {
          alignItems: "center",
          textAlign: "center"
        }
      },
      end: {
        root: {
          alignItems: "flex-end",
          textAlign: "end"
        }
      }
    },
    variant: {
      subtle: {
        root: {
          paddingX: "5",
          borderStartWidth: "4px",
          borderStartColor: "colorPalette.muted"
        },
        icon: {
          color: "colorPalette.fg"
        }
      },
      solid: {
        root: {
          paddingX: "5",
          borderStartWidth: "4px",
          borderStartColor: "colorPalette.solid"
        },
        icon: {
          color: "colorPalette.solid"
        }
      },
      plain: {
        root: {
          paddingX: "5"
        },
        icon: {
          color: "colorPalette.solid"
        }
      }
    }
  },
  defaultVariants: {
    variant: "subtle",
    justify: "start"
  }
}), tN = ce({
  className: "chakra-breadcrumb",
  slots: yA.keys(),
  base: {
    list: {
      display: "flex",
      alignItems: "center",
      wordBreak: "break-word",
      color: "fg.muted",
      listStyle: "none"
    },
    link: {
      outline: "0",
      textDecoration: "none",
      borderRadius: "l1",
      focusRing: "outside",
      display: "inline-flex",
      alignItems: "center",
      gap: "2"
    },
    item: {
      display: "inline-flex",
      alignItems: "center"
    },
    separator: {
      color: "fg.muted",
      opacity: "0.8",
      _icon: {
        boxSize: "1em"
      },
      _rtl: {
        rotate: "180deg"
      }
    },
    ellipsis: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      _icon: {
        boxSize: "1em"
      }
    }
  },
  variants: {
    variant: {
      underline: {
        link: {
          color: "colorPalette.fg",
          textDecoration: "underline",
          textUnderlineOffset: "0.2em",
          textDecorationColor: "colorPalette.muted"
        },
        currentLink: {
          color: "colorPalette.fg"
        }
      },
      plain: {
        link: {
          color: "fg.muted",
          _hover: { color: "fg" }
        },
        currentLink: {
          color: "fg"
        }
      }
    },
    size: {
      sm: {
        list: {
          gap: "1",
          textStyle: "xs"
        }
      },
      md: {
        list: {
          gap: "1.5",
          textStyle: "sm"
        }
      },
      lg: {
        list: {
          gap: "2",
          textStyle: "md"
        }
      }
    }
  },
  defaultVariants: {
    variant: "plain",
    size: "md"
  }
}), rN = ce({
  className: "chakra-card",
  slots: _A.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: "0",
      wordWrap: "break-word",
      borderRadius: "l3",
      color: "fg",
      textAlign: "start"
    },
    title: {
      fontWeight: "semibold"
    },
    description: {
      color: "fg.muted",
      fontSize: "sm"
    },
    header: {
      paddingInline: "var(--card-padding)",
      paddingTop: "var(--card-padding)",
      display: "flex",
      flexDirection: "column",
      gap: "1.5"
    },
    body: {
      padding: "var(--card-padding)",
      flex: "1",
      display: "flex",
      flexDirection: "column"
    },
    footer: {
      display: "flex",
      alignItems: "center",
      gap: "2",
      paddingInline: "var(--card-padding)",
      paddingBottom: "var(--card-padding)"
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          "--card-padding": "spacing.4"
        },
        title: {
          textStyle: "md"
        }
      },
      md: {
        root: {
          "--card-padding": "spacing.6"
        },
        title: {
          textStyle: "lg"
        }
      },
      lg: {
        root: {
          "--card-padding": "spacing.7"
        },
        title: {
          textStyle: "xl"
        }
      }
    },
    variant: {
      elevated: {
        root: {
          bg: "bg.panel",
          boxShadow: "md"
        }
      },
      outline: {
        root: {
          bg: "bg.panel",
          borderWidth: "1px",
          borderColor: "border"
        }
      },
      subtle: {
        root: {
          bg: "bg.muted"
        }
      }
    }
  },
  defaultVariants: {
    variant: "outline",
    size: "md"
  }
});
var Am, Nm, Fm, $m, Lm, Vm, zm, Dm, Mm, Bm, Wm, Hm, jm, Um;
const nN = ce({
  slots: fO.keys(),
  className: "chakra-checkbox",
  base: {
    root: {
      display: "inline-flex",
      gap: "2",
      alignItems: "center",
      verticalAlign: "top",
      position: "relative"
    },
    control: nt.base,
    label: {
      fontWeight: "medium",
      userSelect: "none",
      _disabled: {
        opacity: "0.5"
      }
    }
  },
  variants: {
    size: {
      xs: {
        root: { gap: "1.5" },
        label: { textStyle: "xs" },
        control: (Nm = (Am = nt.variants) == null ? void 0 : Am.size) == null ? void 0 : Nm.xs
      },
      sm: {
        root: { gap: "2" },
        label: { textStyle: "sm" },
        control: ($m = (Fm = nt.variants) == null ? void 0 : Fm.size) == null ? void 0 : $m.sm
      },
      md: {
        root: { gap: "2.5" },
        label: { textStyle: "sm" },
        control: (Vm = (Lm = nt.variants) == null ? void 0 : Lm.size) == null ? void 0 : Vm.md
      },
      lg: {
        root: { gap: "3" },
        label: { textStyle: "md" },
        control: (Dm = (zm = nt.variants) == null ? void 0 : zm.size) == null ? void 0 : Dm.lg
      }
    },
    variant: {
      outline: {
        control: (Bm = (Mm = nt.variants) == null ? void 0 : Mm.variant) == null ? void 0 : Bm.outline
      },
      solid: {
        control: (Hm = (Wm = nt.variants) == null ? void 0 : Wm.variant) == null ? void 0 : Hm.solid
      },
      subtle: {
        control: (Um = (jm = nt.variants) == null ? void 0 : jm.variant) == null ? void 0 : Um.subtle
      }
    }
  },
  defaultVariants: {
    variant: "solid",
    size: "md"
  }
});
var Gm, qm, Km, Ym, Xm, Jm, Zm;
const iN = ce({
  slots: wA.keys(),
  className: "chakra-checkbox-card",
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      userSelect: "none",
      position: "relative",
      borderRadius: "l2",
      flex: "1",
      focusVisibleRing: "outside",
      _disabled: {
        opacity: "0.8"
      },
      _invalid: {
        outline: "2px solid",
        outlineColor: "border.error"
      }
    },
    control: {
      display: "inline-flex",
      flex: "1",
      position: "relative",
      borderRadius: "inherit",
      justifyContent: "var(--checkbox-card-justify)",
      alignItems: "var(--checkbox-card-align)"
    },
    label: {
      fontWeight: "medium",
      display: "flex",
      alignItems: "center",
      gap: "2",
      flex: "1",
      _disabled: {
        opacity: "0.5"
      }
    },
    description: {
      opacity: "0.64",
      textStyle: "sm",
      _disabled: {
        opacity: "0.5"
      }
    },
    addon: {
      _disabled: {
        opacity: "0.5"
      }
    },
    indicator: nt.base,
    content: {
      display: "flex",
      flexDirection: "column",
      flex: "1",
      gap: "1",
      justifyContent: "var(--checkbox-card-justify)",
      alignItems: "var(--checkbox-card-align)"
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          textStyle: "sm"
        },
        control: {
          padding: "3",
          gap: "1.5"
        },
        addon: {
          px: "3",
          py: "1.5",
          borderTopWidth: "1px"
        },
        indicator: (Gm = nt.variants) == null ? void 0 : Gm.size.sm
      },
      md: {
        root: {
          textStyle: "sm"
        },
        control: {
          padding: "4",
          gap: "2.5"
        },
        addon: {
          px: "4",
          py: "2",
          borderTopWidth: "1px"
        },
        indicator: (qm = nt.variants) == null ? void 0 : qm.size.md
      },
      lg: {
        root: {
          textStyle: "md"
        },
        control: {
          padding: "4",
          gap: "3.5"
        },
        addon: {
          px: "4",
          py: "2",
          borderTopWidth: "1px"
        },
        indicator: (Km = nt.variants) == null ? void 0 : Km.size.lg
      }
    },
    variant: {
      surface: {
        root: {
          borderWidth: "1px",
          borderColor: "border",
          _checked: {
            bg: "colorPalette.subtle",
            color: "colorPalette.fg",
            borderColor: "colorPalette.muted"
          },
          _disabled: {
            bg: "bg.muted"
          }
        },
        indicator: (Ym = nt.variants) == null ? void 0 : Ym.variant.solid
      },
      subtle: {
        root: {
          bg: "bg.muted"
        },
        control: {
          _checked: {
            bg: "colorPalette.muted",
            color: "colorPalette.fg"
          }
        },
        indicator: (Xm = nt.variants) == null ? void 0 : Xm.variant.plain
      },
      outline: {
        root: {
          borderWidth: "1px",
          borderColor: "border",
          _checked: {
            boxShadow: "0 0 0 1px var(--shadow-color)",
            boxShadowColor: "colorPalette.solid",
            borderColor: "colorPalette.solid"
          }
        },
        indicator: (Jm = nt.variants) == null ? void 0 : Jm.variant.solid
      },
      solid: {
        root: {
          borderWidth: "1px",
          _checked: {
            bg: "colorPalette.solid",
            color: "colorPalette.contrast",
            borderColor: "colorPalette.solid"
          }
        },
        indicator: (Zm = nt.variants) == null ? void 0 : Zm.variant.inverted
      }
    },
    justify: {
      start: {
        root: { "--checkbox-card-justify": "flex-start" }
      },
      end: {
        root: { "--checkbox-card-justify": "flex-end" }
      },
      center: {
        root: { "--checkbox-card-justify": "center" }
      }
    },
    align: {
      start: {
        root: { "--checkbox-card-align": "flex-start" },
        content: { textAlign: "start" }
      },
      end: {
        root: { "--checkbox-card-align": "flex-end" },
        content: { textAlign: "end" }
      },
      center: {
        root: { "--checkbox-card-align": "center" },
        content: { textAlign: "center" }
      }
    },
    orientation: {
      vertical: {
        control: { flexDirection: "column" }
      },
      horizontal: {
        control: { flexDirection: "row" }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline",
    align: "start",
    orientation: "horizontal"
  }
}), oN = ce({
  slots: Fb.keys(),
  className: "chakra-collapsible",
  base: {
    content: {
      overflow: "hidden",
      _open: {
        animationName: "expand-height, fade-in",
        animationDuration: "moderate"
      },
      _closed: {
        animationName: "collapse-height, fade-out",
        animationDuration: "moderate"
      }
    }
  }
});
var Qm, ev, tv, rv, nv, iv, ov, sv, av, lv, cv, uv, dv, fv, hv, pv, gv, mv;
const sN = ce({
  className: "colorPicker",
  slots: YA.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "1.5"
    },
    label: {
      color: "fg",
      fontWeight: "medium",
      textStyle: "sm",
      _disabled: {
        opacity: "0.5"
      }
    },
    valueText: {
      textAlign: "start"
    },
    control: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      gap: "2",
      position: "relative"
    },
    swatchTrigger: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    trigger: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      flexShrink: "0",
      gap: "2",
      textStyle: "sm",
      minH: "var(--input-height)",
      minW: "var(--input-height)",
      px: "1",
      rounded: "l2",
      _disabled: { opacity: "0.5" },
      "--focus-color": "colors.colorPalette.focusRing",
      "&:focus-visible": {
        borderColor: "var(--focus-color)",
        outline: "1px solid var(--focus-color)"
      },
      "&[data-fit-content]": {
        "--input-height": "unset",
        px: "0",
        border: "0"
      }
    },
    content: {
      display: "flex",
      flexDirection: "column",
      bg: "bg.panel",
      borderRadius: "l3",
      boxShadow: "lg",
      width: "64",
      p: "4",
      gap: "3",
      zIndex: "dropdown",
      _open: {
        animationStyle: "slide-fade-in",
        animationDuration: "fast"
      },
      _closed: {
        animationStyle: "slide-fade-out",
        animationDuration: "faster"
      }
    },
    area: {
      height: "180px",
      borderRadius: "l2",
      overflow: "hidden"
    },
    areaThumb: {
      borderRadius: "full",
      height: "var(--thumb-size)",
      width: "var(--thumb-size)",
      borderWidth: "2px",
      borderColor: "white",
      shadow: "sm",
      focusVisibleRing: "mixed",
      focusRingColor: "white"
    },
    areaBackground: {
      height: "full"
    },
    channelSlider: {
      borderRadius: "l2",
      flex: "1"
    },
    channelSliderTrack: {
      height: "var(--slider-height)",
      borderRadius: "inherit",
      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    },
    channelText: {
      textStyle: "xs",
      color: "fg.muted",
      fontWeight: "medium",
      textTransform: "capitalize"
    },
    swatchGroup: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "2"
    },
    swatch: {
      ...bx.base,
      borderRadius: "l1"
    },
    swatchIndicator: {
      color: "white",
      rounded: "full"
    },
    channelSliderThumb: {
      borderRadius: "full",
      height: "var(--thumb-size)",
      width: "var(--thumb-size)",
      borderWidth: "2px",
      borderColor: "white",
      shadow: "sm",
      transform: "translate(-50%, -50%)",
      focusVisibleRing: "outside",
      focusRingOffset: "1px"
    },
    channelInput: {
      ...je.base,
      "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
        WebkitAppearance: "none",
        margin: 0
      }
    },
    formatSelect: {
      textStyle: "xs",
      textTransform: "uppercase",
      borderWidth: "1px",
      minH: "6",
      focusRing: "inside",
      rounded: "l2"
    },
    transparencyGrid: {
      borderRadius: "l2"
    },
    view: {
      display: "flex",
      flexDirection: "column",
      gap: "2"
    }
  },
  variants: {
    size: {
      "2xs": {
        channelInput: (ev = (Qm = je.variants) == null ? void 0 : Qm.size) == null ? void 0 : ev["2xs"],
        swatch: { "--swatch-size": "sizes.4.5" },
        trigger: { "--input-height": "sizes.7" },
        area: { "--thumb-size": "sizes.3" },
        channelSlider: {
          "--slider-height": "sizes.3",
          "--thumb-size": "sizes.3"
        }
      },
      xs: {
        channelInput: (rv = (tv = je.variants) == null ? void 0 : tv.size) == null ? void 0 : rv.xs,
        swatch: { "--swatch-size": "sizes.5" },
        trigger: { "--input-height": "sizes.8" },
        area: { "--thumb-size": "sizes.3.5" },
        channelSlider: {
          "--slider-height": "sizes.3.5",
          "--thumb-size": "sizes.3.5"
        }
      },
      sm: {
        channelInput: (iv = (nv = je.variants) == null ? void 0 : nv.size) == null ? void 0 : iv.sm,
        swatch: { "--swatch-size": "sizes.6" },
        trigger: { "--input-height": "sizes.9" },
        area: { "--thumb-size": "sizes.3.5" },
        channelSlider: {
          "--slider-height": "sizes.3.5",
          "--thumb-size": "sizes.3.5"
        }
      },
      md: {
        channelInput: (sv = (ov = je.variants) == null ? void 0 : ov.size) == null ? void 0 : sv.md,
        swatch: { "--swatch-size": "sizes.7" },
        trigger: { "--input-height": "sizes.10" },
        area: { "--thumb-size": "sizes.3.5" },
        channelSlider: {
          "--slider-height": "sizes.3.5",
          "--thumb-size": "sizes.3.5"
        }
      },
      lg: {
        channelInput: (lv = (av = je.variants) == null ? void 0 : av.size) == null ? void 0 : lv.lg,
        swatch: { "--swatch-size": "sizes.7" },
        trigger: { "--input-height": "sizes.11" },
        area: { "--thumb-size": "sizes.3.5" },
        channelSlider: {
          "--slider-height": "sizes.3.5",
          "--thumb-size": "sizes.3.5"
        }
      },
      xl: {
        channelInput: (uv = (cv = je.variants) == null ? void 0 : cv.size) == null ? void 0 : uv.xl,
        swatch: { "--swatch-size": "sizes.8" },
        trigger: { "--input-height": "sizes.12" },
        area: { "--thumb-size": "sizes.3.5" },
        channelSlider: {
          "--slider-height": "sizes.3.5",
          "--thumb-size": "sizes.3.5"
        }
      },
      "2xl": {
        channelInput: (fv = (dv = je.variants) == null ? void 0 : dv.size) == null ? void 0 : fv["2xl"],
        swatch: { "--swatch-size": "sizes.10" },
        trigger: { "--input-height": "sizes.16" },
        area: { "--thumb-size": "sizes.3.5" },
        channelSlider: {
          "--slider-height": "sizes.3.5",
          "--thumb-size": "sizes.3.5"
        }
      }
    },
    variant: {
      outline: {
        channelInput: (pv = (hv = je.variants) == null ? void 0 : hv.variant) == null ? void 0 : pv.outline,
        trigger: {
          borderWidth: "1px"
        }
      },
      subtle: {
        channelInput: (mv = (gv = je.variants) == null ? void 0 : gv.variant) == null ? void 0 : mv.subtle,
        trigger: {
          borderWidth: "1px",
          borderColor: "transparent",
          bg: "bg.muted"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
}), aN = ce({
  className: "chakra-combobox",
  slots: zA.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "1.5",
      width: "full"
    },
    label: {
      fontWeight: "medium",
      userSelect: "none",
      textStyle: "sm",
      _disabled: {
        layerStyle: "disabled"
      }
    },
    input: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: "bg.panel",
      width: "full",
      minH: "var(--combobox-input-height)",
      px: "var(--combobox-input-padding-x)",
      "--input-height": "var(--combobox-input-height)",
      borderRadius: "l2",
      outline: 0,
      userSelect: "none",
      textAlign: "start",
      _placeholderShown: {
        color: "fg.muted"
      },
      _disabled: {
        layerStyle: "disabled"
      },
      "--focus-color": "colors.colorPalette.focusRing",
      "--error-color": "colors.border.error",
      _invalid: {
        focusRingColor: "var(--error-color)",
        borderColor: "var(--error-color)"
      }
    },
    trigger: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      "--input-height": "var(--combobox-input-height)"
    },
    clearTrigger: {
      color: "fg.muted",
      pointerEvents: "auto",
      focusVisibleRing: "inside",
      focusRingWidth: "2px",
      rounded: "l1"
    },
    control: {
      pos: "relative"
    },
    indicatorGroup: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "1",
      pos: "absolute",
      insetEnd: "0",
      top: "0",
      bottom: "0",
      px: "var(--combobox-input-padding-x)",
      _icon: {
        boxSize: "var(--combobox-indicator-size)"
      },
      "[data-disabled] &": {
        opacity: 0.5
      }
    },
    content: {
      background: "bg.panel",
      display: "flex",
      flexDirection: "column",
      zIndex: "dropdown",
      borderRadius: "l2",
      outline: 0,
      maxH: "96",
      overflowY: "auto",
      boxShadow: "md",
      _open: {
        animationStyle: "slide-fade-in",
        animationDuration: "fast"
      },
      _closed: {
        animationStyle: "slide-fade-out",
        animationDuration: "0s"
      },
      "&[data-empty]:not(:has([data-scope=combobox][data-part=empty]))": {
        opacity: 0
      }
    },
    item: {
      position: "relative",
      userSelect: "none",
      display: "flex",
      alignItems: "center",
      gap: "2",
      py: "var(--combobox-item-padding-y)",
      px: "var(--combobox-item-padding-x)",
      cursor: "option",
      justifyContent: "space-between",
      flex: "1",
      textAlign: "start",
      borderRadius: "l1",
      _highlighted: {
        bg: "bg.emphasized/60"
      },
      _disabled: {
        pointerEvents: "none",
        opacity: "0.5"
      },
      _icon: {
        boxSize: "var(--combobox-indicator-size)"
      }
    },
    empty: {
      py: "var(--combobox-item-padding-y)",
      px: "var(--combobox-item-padding-x)"
    },
    itemText: {
      flex: "1"
    },
    itemGroup: {
      pb: "var(--combobox-item-padding-y)",
      _last: {
        pb: "0"
      }
    },
    itemGroupLabel: {
      fontWeight: "medium",
      py: "var(--combobox-item-padding-y)",
      px: "var(--combobox-item-padding-x)"
    }
  },
  variants: {
    variant: {
      outline: {
        input: {
          bg: "transparent",
          borderWidth: "1px",
          borderColor: "border",
          focusVisibleRing: "inside"
        }
      },
      subtle: {
        input: {
          borderWidth: "1px",
          borderColor: "transparent",
          bg: "bg.muted",
          focusVisibleRing: "inside"
        }
      },
      flushed: {
        input: {
          bg: "transparent",
          borderBottomWidth: "1px",
          borderBottomColor: "border",
          borderRadius: "0",
          px: "0",
          _focusVisible: {
            borderColor: "var(--focus-color)",
            boxShadow: "0px 1px 0px 0px var(--focus-color)"
          }
        },
        indicatorGroup: {
          px: "0"
        }
      }
    },
    size: {
      xs: {
        root: {
          "--combobox-input-height": "sizes.8",
          "--combobox-input-padding-x": "spacing.2",
          "--combobox-indicator-size": "sizes.3.5"
        },
        input: {
          textStyle: "xs"
        },
        content: {
          "--combobox-item-padding-x": "spacing.1.5",
          "--combobox-item-padding-y": "spacing.1",
          "--combobox-indicator-size": "sizes.3.5",
          p: "1",
          textStyle: "xs"
        },
        trigger: {
          textStyle: "xs",
          gap: "1"
        }
      },
      sm: {
        root: {
          "--combobox-input-height": "sizes.9",
          "--combobox-input-padding-x": "spacing.2.5",
          "--combobox-indicator-size": "sizes.4"
        },
        input: {
          textStyle: "sm"
        },
        content: {
          "--combobox-item-padding-x": "spacing.2",
          "--combobox-item-padding-y": "spacing.1.5",
          "--combobox-indicator-size": "sizes.4",
          p: "1",
          textStyle: "sm"
        },
        trigger: {
          textStyle: "sm",
          gap: "1"
        }
      },
      md: {
        root: {
          "--combobox-input-height": "sizes.10",
          "--combobox-input-padding-x": "spacing.3",
          "--combobox-indicator-size": "sizes.4"
        },
        input: {
          textStyle: "sm"
        },
        content: {
          "--combobox-item-padding-x": "spacing.2",
          "--combobox-item-padding-y": "spacing.1.5",
          "--combobox-indicator-size": "sizes.4",
          p: "1",
          textStyle: "sm"
        },
        itemIndicator: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        trigger: {
          textStyle: "sm",
          gap: "2"
        }
      },
      lg: {
        root: {
          "--combobox-input-height": "sizes.12",
          "--combobox-input-padding-x": "spacing.4",
          "--combobox-indicator-size": "sizes.5"
        },
        input: {
          textStyle: "md"
        },
        content: {
          "--combobox-item-padding-y": "spacing.2",
          "--combobox-item-padding-x": "spacing.3",
          "--combobox-indicator-size": "sizes.5",
          p: "1.5",
          textStyle: "md"
        },
        trigger: {
          textStyle: "md",
          py: "3",
          gap: "2"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
}), lN = ce({
  slots: SA.keys(),
  className: "chakra-data-list",
  base: {
    itemLabel: {
      display: "flex",
      alignItems: "center",
      gap: "1"
    },
    itemValue: {
      display: "flex",
      minWidth: "0",
      flex: "1"
    }
  },
  variants: {
    orientation: {
      horizontal: {
        root: {
          display: "flex",
          flexDirection: "column"
        },
        item: {
          display: "inline-flex",
          alignItems: "center",
          gap: "4"
        },
        itemLabel: {
          minWidth: "120px"
        }
      },
      vertical: {
        root: {
          display: "flex",
          flexDirection: "column"
        },
        item: {
          display: "flex",
          flexDirection: "column",
          gap: "1"
        }
      }
    },
    size: {
      sm: {
        root: {
          gap: "3"
        },
        item: {
          textStyle: "xs"
        }
      },
      md: {
        root: {
          gap: "4"
        },
        item: {
          textStyle: "sm"
        }
      },
      lg: {
        root: {
          gap: "5"
        },
        item: {
          textStyle: "md"
        }
      }
    },
    variant: {
      subtle: {
        itemLabel: {
          color: "fg.muted"
        }
      },
      bold: {
        itemLabel: {
          fontWeight: "medium"
        },
        itemValue: {
          color: "fg.muted"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    orientation: "vertical",
    variant: "subtle"
  }
}), cN = ce({
  slots: EA.keys(),
  className: "chakra-dialog",
  base: {
    backdrop: {
      bg: "blackAlpha.500",
      pos: "fixed",
      left: 0,
      top: 0,
      w: "100vw",
      h: "100dvh",
      zIndex: "overlay",
      _open: {
        animationName: "fade-in",
        animationDuration: "slow"
      },
      _closed: {
        animationName: "fade-out",
        animationDuration: "moderate"
      }
    },
    positioner: {
      display: "flex",
      width: "100vw",
      height: "100dvh",
      position: "fixed",
      left: 0,
      top: 0,
      "--dialog-z-index": "zIndex.modal",
      zIndex: "calc(var(--dialog-z-index) + var(--layer-index, 0))",
      justifyContent: "center",
      overscrollBehaviorY: "none"
    },
    content: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      borderRadius: "l3",
      textStyle: "sm",
      my: "var(--dialog-margin, var(--dialog-base-margin))",
      "--dialog-z-index": "zIndex.modal",
      zIndex: "calc(var(--dialog-z-index) + var(--layer-index, 0))",
      bg: "bg.panel",
      boxShadow: "lg",
      _open: {
        animationDuration: "moderate"
      },
      _closed: {
        animationDuration: "faster"
      }
    },
    header: {
      display: "flex",
      gap: "2",
      flex: 0,
      px: "6",
      pt: "6",
      pb: "4"
    },
    body: {
      flex: "1",
      px: "6",
      pt: "2",
      pb: "6"
    },
    footer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: "3",
      px: "6",
      pt: "2",
      pb: "4"
    },
    title: {
      textStyle: "lg",
      fontWeight: "semibold"
    },
    description: {
      color: "fg.muted"
    },
    closeTrigger: {
      pos: "absolute",
      top: "2",
      insetEnd: "2"
    }
  },
  variants: {
    placement: {
      center: {
        positioner: {
          alignItems: "center"
        },
        content: {
          "--dialog-base-margin": "auto",
          mx: "auto"
        }
      },
      top: {
        positioner: {
          alignItems: "flex-start"
        },
        content: {
          "--dialog-base-margin": "spacing.16",
          mx: "auto"
        }
      },
      bottom: {
        positioner: {
          alignItems: "flex-end"
        },
        content: {
          "--dialog-base-margin": "spacing.16",
          mx: "auto"
        }
      }
    },
    scrollBehavior: {
      inside: {
        positioner: {
          overflow: "hidden"
        },
        content: {
          maxH: "calc(100% - 7.5rem)"
        },
        body: {
          overflow: "auto"
        }
      },
      outside: {
        positioner: {
          overflow: "auto",
          pointerEvents: "auto"
        }
      }
    },
    size: {
      xs: {
        content: {
          maxW: "sm"
        }
      },
      sm: {
        content: {
          maxW: "md"
        }
      },
      md: {
        content: {
          maxW: "lg"
        }
      },
      lg: {
        content: {
          maxW: "2xl"
        }
      },
      xl: {
        content: {
          maxW: "4xl"
        }
      },
      cover: {
        positioner: {
          padding: "10"
        },
        content: {
          width: "100%",
          height: "100%",
          "--dialog-margin": "0"
        }
      },
      full: {
        content: {
          maxW: "100vw",
          minH: "100vh",
          "--dialog-margin": "0",
          borderRadius: "0"
        }
      }
    },
    motionPreset: {
      scale: {
        content: {
          _open: { animationName: "scale-in, fade-in" },
          _closed: { animationName: "scale-out, fade-out" }
        }
      },
      "slide-in-bottom": {
        content: {
          _open: { animationName: "slide-from-bottom, fade-in" },
          _closed: { animationName: "slide-to-bottom, fade-out" }
        }
      },
      "slide-in-top": {
        content: {
          _open: { animationName: "slide-from-top, fade-in" },
          _closed: { animationName: "slide-to-top, fade-out" }
        }
      },
      "slide-in-left": {
        content: {
          _open: { animationName: "slide-from-left, fade-in" },
          _closed: { animationName: "slide-to-left, fade-out" }
        }
      },
      "slide-in-right": {
        content: {
          _open: { animationName: "slide-from-right, fade-in" },
          _closed: { animationName: "slide-to-right, fade-out" }
        }
      },
      none: {}
    }
  },
  defaultVariants: {
    size: "md",
    scrollBehavior: "outside",
    placement: "top",
    motionPreset: "scale"
  }
}), uN = ce({
  slots: CA.keys(),
  className: "chakra-drawer",
  base: {
    backdrop: {
      bg: "blackAlpha.500",
      pos: "fixed",
      insetInlineStart: 0,
      top: 0,
      w: "100vw",
      h: "100dvh",
      zIndex: "overlay",
      _open: {
        animationName: "fade-in",
        animationDuration: "slow"
      },
      _closed: {
        animationName: "fade-out",
        animationDuration: "moderate"
      }
    },
    positioner: {
      display: "flex",
      width: "100vw",
      height: "100dvh",
      position: "fixed",
      insetInlineStart: 0,
      top: 0,
      zIndex: "modal",
      overscrollBehaviorY: "none"
    },
    content: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      zIndex: "modal",
      textStyle: "sm",
      maxH: "100dvh",
      color: "inherit",
      bg: "bg.panel",
      boxShadow: "lg",
      _open: {
        animationDuration: "slowest",
        animationTimingFunction: "ease-in-smooth"
      },
      _closed: {
        animationDuration: "slower",
        animationTimingFunction: "ease-in-smooth"
      }
    },
    header: {
      display: "flex",
      alignItems: "center",
      gap: "2",
      flex: 0,
      px: "6",
      pt: "6",
      pb: "4"
    },
    body: {
      px: "6",
      py: "2",
      flex: "1",
      overflow: "auto"
    },
    footer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: "3",
      px: "6",
      pt: "2",
      pb: "4"
    },
    title: {
      flex: "1",
      textStyle: "lg",
      fontWeight: "semibold"
    },
    description: {
      color: "fg.muted"
    },
    closeTrigger: {
      pos: "absolute",
      top: "3",
      insetEnd: "2"
    }
  },
  variants: {
    size: {
      xs: {
        content: {
          maxW: "xs"
        }
      },
      sm: {
        content: {
          maxW: "md"
        }
      },
      md: {
        content: {
          maxW: "lg"
        }
      },
      lg: {
        content: {
          maxW: "2xl"
        }
      },
      xl: {
        content: {
          maxW: "4xl"
        }
      },
      full: {
        content: {
          maxW: "100vw",
          h: "100dvh"
        }
      }
    },
    placement: {
      start: {
        positioner: {
          justifyContent: "flex-start"
        },
        content: {
          _open: {
            animationName: {
              base: "slide-from-left-full, fade-in",
              _rtl: "slide-from-right-full, fade-in"
            }
          },
          _closed: {
            animationName: {
              base: "slide-to-left-full, fade-out",
              _rtl: "slide-to-right-full, fade-out"
            }
          }
        }
      },
      end: {
        positioner: {
          justifyContent: "flex-end"
        },
        content: {
          _open: {
            animationName: {
              base: "slide-from-right-full, fade-in",
              _rtl: "slide-from-left-full, fade-in"
            }
          },
          _closed: {
            animationName: {
              base: "slide-to-right-full, fade-out",
              _rtl: "slide-to-left-full, fade-out"
            }
          }
        }
      },
      top: {
        positioner: {
          alignItems: "flex-start"
        },
        content: {
          maxW: "100%",
          _open: { animationName: "slide-from-top-full, fade-in" },
          _closed: { animationName: "slide-to-top-full, fade-out" }
        }
      },
      bottom: {
        positioner: {
          alignItems: "flex-end"
        },
        content: {
          maxW: "100%",
          _open: { animationName: "slide-from-bottom-full, fade-in" },
          _closed: { animationName: "slide-to-bottom-full, fade-out" }
        }
      }
    },
    contained: {
      true: {
        positioner: {
          padding: "4"
        },
        content: {
          borderRadius: "l3"
        }
      }
    }
  },
  defaultVariants: {
    size: "xs",
    placement: "end"
  }
}), kp = q0({
  fontSize: "inherit",
  fontWeight: "inherit",
  textAlign: "inherit",
  bg: "transparent",
  borderRadius: "l2"
}), dN = ce({
  slots: kA.keys(),
  className: "chakra-editable",
  base: {
    root: {
      display: "inline-flex",
      alignItems: "center",
      position: "relative",
      gap: "1.5",
      width: "full"
    },
    preview: {
      ...kp,
      py: "1",
      px: "1",
      display: "inline-flex",
      alignItems: "center",
      transitionProperty: "common",
      transitionDuration: "normal",
      cursor: "text",
      _hover: {
        bg: "bg.muted"
      },
      _disabled: {
        userSelect: "none"
      }
    },
    input: {
      ...kp,
      outline: "0",
      py: "1",
      px: "1",
      transitionProperty: "common",
      transitionDuration: "normal",
      width: "full",
      focusVisibleRing: "inside",
      focusRingWidth: "2px",
      _placeholder: { opacity: 0.6 }
    },
    control: {
      display: "inline-flex",
      alignItems: "center",
      gap: "1.5"
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          textStyle: "sm"
        },
        preview: { minH: "8" },
        input: { minH: "8" }
      },
      md: {
        root: {
          textStyle: "sm"
        },
        preview: { minH: "9" },
        input: { minH: "9" }
      },
      lg: {
        root: {
          textStyle: "md"
        },
        preview: { minH: "10" },
        input: { minH: "10" }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), fN = ce({
  slots: IA.keys(),
  className: "chakra-empty-state",
  base: {
    root: {
      width: "full"
    },
    content: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    },
    indicator: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "fg.subtle",
      _icon: {
        boxSize: "1em"
      }
    },
    title: {
      fontWeight: "semibold"
    },
    description: {
      textStyle: "sm",
      color: "fg.muted"
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          px: "4",
          py: "6"
        },
        title: {
          textStyle: "md"
        },
        content: {
          gap: "4"
        },
        indicator: {
          textStyle: "2xl"
        }
      },
      md: {
        root: {
          px: "8",
          py: "12"
        },
        title: {
          textStyle: "lg"
        },
        content: {
          gap: "6"
        },
        indicator: {
          textStyle: "4xl"
        }
      },
      lg: {
        root: {
          px: "12",
          py: "16"
        },
        title: {
          textStyle: "xl"
        },
        content: {
          gap: "8"
        },
        indicator: {
          textStyle: "6xl"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), hN = ce({
  className: "chakra-field",
  slots: OA.keys(),
  base: {
    requiredIndicator: {
      color: "fg.error",
      lineHeight: "1"
    },
    root: {
      display: "flex",
      width: "100%",
      position: "relative",
      gap: "1.5"
    },
    label: {
      display: "flex",
      alignItems: "center",
      textAlign: "start",
      textStyle: "sm",
      fontWeight: "medium",
      gap: "1",
      userSelect: "none",
      _disabled: {
        opacity: "0.5"
      }
    },
    errorText: {
      display: "inline-flex",
      alignItems: "center",
      fontWeight: "medium",
      gap: "1",
      color: "fg.error",
      textStyle: "xs"
    },
    helperText: {
      color: "fg.muted",
      textStyle: "xs"
    }
  },
  variants: {
    orientation: {
      vertical: {
        root: {
          flexDirection: "column",
          alignItems: "flex-start"
        }
      },
      horizontal: {
        root: {
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between"
        },
        label: {
          flex: "0 0 var(--field-label-width, 80px)"
        }
      }
    }
  },
  defaultVariants: {
    orientation: "vertical"
  }
}), pN = ce({
  className: "fieldset",
  slots: PA.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      width: "full"
    },
    content: {
      display: "flex",
      flexDirection: "column",
      width: "full"
    },
    legend: {
      color: "fg",
      fontWeight: "medium",
      _disabled: {
        opacity: "0.5"
      }
    },
    helperText: {
      color: "fg.muted",
      textStyle: "sm"
    },
    errorText: {
      display: "inline-flex",
      alignItems: "center",
      color: "fg.error",
      gap: "2",
      fontWeight: "medium",
      textStyle: "sm"
    }
  },
  variants: {
    size: {
      sm: {
        root: { spaceY: "2" },
        content: { gap: "1.5" },
        legend: { textStyle: "sm" }
      },
      md: {
        root: { spaceY: "4" },
        content: { gap: "4" },
        legend: { textStyle: "sm" }
      },
      lg: {
        root: { spaceY: "6" },
        content: { gap: "4" },
        legend: { textStyle: "md" }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), gN = ce({
  className: "chakra-file-upload",
  slots: TA.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "4",
      width: "100%",
      alignItems: "flex-start"
    },
    label: {
      fontWeight: "medium",
      textStyle: "sm"
    },
    dropzone: {
      background: "bg",
      borderRadius: "l3",
      borderWidth: "2px",
      borderStyle: "dashed",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      gap: "4",
      justifyContent: "center",
      minHeight: "2xs",
      px: "3",
      py: "2",
      transition: "backgrounds",
      focusVisibleRing: "outside",
      _hover: {
        bg: "bg.subtle"
      },
      _dragging: {
        bg: "colorPalette.subtle",
        borderStyle: "solid",
        borderColor: "colorPalette.solid"
      }
    },
    dropzoneContent: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      gap: "1",
      textStyle: "sm"
    },
    item: {
      pos: "relative",
      textStyle: "sm",
      animationName: "fade-in",
      animationDuration: "moderate",
      background: "bg",
      borderRadius: "l2",
      borderWidth: "1px",
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: "3",
      p: "4"
    },
    itemGroup: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "3",
      _empty: {
        display: "none"
      }
    },
    itemName: {
      color: "fg",
      fontWeight: "medium",
      lineClamp: "1"
    },
    itemContent: {
      display: "flex",
      flexDirection: "column",
      gap: "0.5",
      flex: "1"
    },
    itemSizeText: {
      color: "fg.muted",
      textStyle: "xs"
    },
    itemDeleteTrigger: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      alignSelf: "flex-start",
      boxSize: "5",
      p: "2px",
      color: "fg.muted",
      cursor: "button"
    },
    itemPreview: {
      color: "fg.muted",
      _icon: {
        boxSize: "4.5"
      }
    }
  },
  defaultVariants: {}
}), mN = ce({
  className: "chakra-hover-card",
  slots: Cy.keys(),
  base: {
    content: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      textStyle: "sm",
      "--hovercard-bg": "colors.bg.panel",
      bg: "var(--hovercard-bg)",
      boxShadow: "lg",
      maxWidth: "80",
      borderRadius: "l3",
      zIndex: "popover",
      transformOrigin: "var(--transform-origin)",
      outline: "0",
      _open: {
        animationStyle: "slide-fade-in",
        animationDuration: "fast"
      },
      _closed: {
        animationStyle: "slide-fade-out",
        animationDuration: "faster"
      }
    },
    arrow: {
      "--arrow-size": "sizes.3",
      "--arrow-background": "var(--hovercard-bg)"
    },
    arrowTip: {
      borderTopWidth: "0.5px",
      borderInlineStartWidth: "0.5px"
    }
  },
  variants: {
    size: {
      xs: {
        content: {
          padding: "3"
        }
      },
      sm: {
        content: {
          padding: "4"
        }
      },
      md: {
        content: {
          padding: "5"
        }
      },
      lg: {
        content: {
          padding: "6"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), vN = ce({
  className: "chakra-list",
  slots: RA.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "var(--list-gap)",
      "& :where(ul, ol)": {
        marginTop: "var(--list-gap)"
      }
    },
    item: {
      whiteSpace: "normal",
      display: "list-item"
    },
    indicator: {
      marginEnd: "2",
      minHeight: "1lh",
      flexShrink: 0,
      display: "inline-block",
      verticalAlign: "middle"
    }
  },
  variants: {
    variant: {
      marker: {
        root: {
          listStyle: "revert"
        },
        item: {
          _marker: {
            color: "fg.subtle"
          }
        }
      },
      plain: {
        item: {
          alignItems: "flex-start",
          display: "inline-flex"
        }
      }
    },
    align: {
      center: {
        item: { alignItems: "center" }
      },
      start: {
        item: { alignItems: "flex-start" }
      },
      end: {
        item: { alignItems: "flex-end" }
      }
    }
  },
  defaultVariants: {
    variant: "marker"
  }
}), bN = ce({
  className: "chakra-menu",
  slots: AA.keys(),
  base: {
    content: {
      outline: 0,
      bg: "bg.panel",
      boxShadow: "lg",
      color: "fg",
      maxHeight: "var(--available-height)",
      "--menu-z-index": "zIndex.dropdown",
      zIndex: "calc(var(--menu-z-index) + var(--layer-index, 0))",
      borderRadius: "l2",
      overflow: "hidden",
      overflowY: "auto",
      _open: {
        animationStyle: "slide-fade-in",
        animationDuration: "fast"
      },
      _closed: {
        animationStyle: "slide-fade-out",
        animationDuration: "faster"
      }
    },
    item: {
      textDecoration: "none",
      color: "fg",
      userSelect: "none",
      borderRadius: "l1",
      width: "100%",
      display: "flex",
      cursor: "menuitem",
      alignItems: "center",
      textAlign: "start",
      position: "relative",
      flex: "0 0 auto",
      outline: 0,
      _disabled: {
        layerStyle: "disabled"
      },
      "&[data-type]": {
        ps: "8"
      }
    },
    itemText: {
      flex: "1"
    },
    itemIndicator: {
      position: "absolute",
      insetStart: "2",
      transform: "translateY(-50%)",
      top: "50%"
    },
    itemGroupLabel: {
      px: "2",
      py: "1.5",
      fontWeight: "semibold",
      textStyle: "sm"
    },
    indicator: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: "0"
    },
    itemCommand: {
      opacity: "0.6",
      textStyle: "xs",
      ms: "auto",
      ps: "4",
      letterSpacing: "widest",
      fontFamily: "inherit"
    },
    separator: {
      height: "1px",
      bg: "bg.muted",
      my: "1",
      mx: "-1"
    }
  },
  variants: {
    variant: {
      subtle: {
        item: {
          _highlighted: {
            bg: "bg.emphasized/60"
          }
        }
      },
      solid: {
        item: {
          _highlighted: {
            bg: "colorPalette.solid",
            color: "colorPalette.contrast"
          }
        }
      }
    },
    size: {
      sm: {
        content: {
          minW: "8rem",
          padding: "1"
        },
        item: {
          gap: "1",
          textStyle: "xs",
          py: "1",
          px: "1.5"
        }
      },
      md: {
        content: {
          minW: "8rem",
          padding: "1.5"
        },
        item: {
          gap: "2",
          textStyle: "sm",
          py: "1.5",
          px: "2"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "subtle"
  }
}), ta = ce({
  className: "chakra-select",
  slots: VA.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "1.5",
      width: "full"
    },
    trigger: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "full",
      minH: "var(--select-trigger-height)",
      "--input-height": "var(--select-trigger-height)",
      px: "var(--select-trigger-padding-x)",
      borderRadius: "l2",
      userSelect: "none",
      textAlign: "start",
      focusVisibleRing: "inside",
      _placeholderShown: {
        color: "fg.muted/80"
      },
      _disabled: {
        layerStyle: "disabled"
      },
      _invalid: {
        borderColor: "border.error"
      }
    },
    indicatorGroup: {
      display: "flex",
      alignItems: "center",
      gap: "1",
      pos: "absolute",
      insetEnd: "0",
      top: "0",
      bottom: "0",
      px: "var(--select-trigger-padding-x)",
      pointerEvents: "none"
    },
    indicator: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: { base: "fg.muted", _disabled: "fg.subtle", _invalid: "fg.error" }
    },
    content: {
      background: "bg.panel",
      display: "flex",
      flexDirection: "column",
      zIndex: "dropdown",
      borderRadius: "l2",
      outline: 0,
      maxH: "96",
      overflowY: "auto",
      boxShadow: "md",
      _open: {
        animationStyle: "slide-fade-in",
        animationDuration: "fast"
      },
      _closed: {
        animationStyle: "slide-fade-out",
        animationDuration: "fastest"
      }
    },
    item: {
      position: "relative",
      userSelect: "none",
      display: "flex",
      alignItems: "center",
      gap: "2",
      cursor: "option",
      justifyContent: "space-between",
      flex: "1",
      textAlign: "start",
      borderRadius: "l1",
      _highlighted: {
        bg: "bg.emphasized/60"
      },
      _disabled: {
        pointerEvents: "none",
        opacity: "0.5"
      },
      _icon: {
        width: "4",
        height: "4"
      }
    },
    control: {
      pos: "relative"
    },
    itemText: {
      flex: "1"
    },
    itemGroup: {
      _first: { mt: "0" }
    },
    itemGroupLabel: {
      py: "1",
      fontWeight: "medium"
    },
    label: {
      fontWeight: "medium",
      userSelect: "none",
      textStyle: "sm",
      _disabled: {
        layerStyle: "disabled"
      }
    },
    valueText: {
      lineClamp: "1",
      maxW: "80%"
    },
    clearTrigger: {
      color: "fg.muted",
      pointerEvents: "auto",
      focusVisibleRing: "inside",
      focusRingWidth: "2px",
      rounded: "l1"
    }
  },
  variants: {
    variant: {
      outline: {
        trigger: {
          bg: "transparent",
          borderWidth: "1px",
          borderColor: "border",
          _expanded: {
            borderColor: "border.emphasized"
          }
        }
      },
      subtle: {
        trigger: {
          borderWidth: "1px",
          borderColor: "transparent",
          bg: "bg.muted"
        }
      }
    },
    size: {
      xs: {
        root: {
          "--select-trigger-height": "sizes.8",
          "--select-trigger-padding-x": "spacing.2"
        },
        content: {
          p: "1",
          gap: "1",
          textStyle: "xs"
        },
        trigger: {
          textStyle: "xs",
          gap: "1"
        },
        item: {
          py: "1",
          px: "2"
        },
        itemGroupLabel: {
          py: "1",
          px: "2"
        },
        indicator: {
          _icon: {
            width: "3.5",
            height: "3.5"
          }
        }
      },
      sm: {
        root: {
          "--select-trigger-height": "sizes.9",
          "--select-trigger-padding-x": "spacing.2.5"
        },
        content: {
          p: "1",
          textStyle: "sm"
        },
        trigger: {
          textStyle: "sm",
          gap: "1"
        },
        indicator: {
          _icon: {
            width: "4",
            height: "4"
          }
        },
        item: {
          py: "1",
          px: "1.5"
        },
        itemGroup: {
          mt: "1"
        },
        itemGroupLabel: {
          py: "1",
          px: "1.5"
        }
      },
      md: {
        root: {
          "--select-trigger-height": "sizes.10",
          "--select-trigger-padding-x": "spacing.3"
        },
        content: {
          p: "1",
          textStyle: "sm"
        },
        itemGroup: {
          mt: "1.5"
        },
        item: {
          py: "1.5",
          px: "2"
        },
        itemIndicator: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        itemGroupLabel: {
          py: "1.5",
          px: "2"
        },
        trigger: {
          textStyle: "sm",
          gap: "2"
        },
        indicator: {
          _icon: {
            width: "4",
            height: "4"
          }
        }
      },
      lg: {
        root: {
          "--select-trigger-height": "sizes.12",
          "--select-trigger-padding-x": "spacing.4"
        },
        content: {
          p: "1.5",
          textStyle: "md"
        },
        itemGroup: {
          mt: "2"
        },
        item: {
          py: "2",
          px: "3"
        },
        itemGroupLabel: {
          py: "2",
          px: "3"
        },
        trigger: {
          textStyle: "md",
          py: "3",
          gap: "2"
        },
        indicator: {
          _icon: {
            width: "5",
            height: "5"
          }
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
});
var vv, bv;
const yN = ce({
  className: "chakra-native-select",
  slots: NA.keys(),
  base: {
    root: {
      height: "fit-content",
      display: "flex",
      width: "100%",
      position: "relative"
    },
    field: {
      width: "100%",
      minWidth: "0",
      outline: "0",
      appearance: "none",
      borderRadius: "l2",
      "--error-color": "colors.border.error",
      _disabled: {
        layerStyle: "disabled"
      },
      _invalid: {
        focusRingColor: "var(--error-color)",
        borderColor: "var(--error-color)"
      },
      focusVisibleRing: "inside",
      lineHeight: "normal",
      "& > option, & > optgroup": {
        bg: "bg"
      }
    },
    indicator: {
      position: "absolute",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      pointerEvents: "none",
      top: "50%",
      transform: "translateY(-50%)",
      height: "100%",
      color: "fg.muted",
      _disabled: {
        opacity: "0.5"
      },
      _invalid: {
        color: "fg.error"
      },
      _icon: {
        width: "1em",
        height: "1em"
      }
    }
  },
  variants: {
    variant: {
      outline: {
        field: (vv = ta.variants) == null ? void 0 : vv.variant.outline.trigger
      },
      subtle: {
        field: (bv = ta.variants) == null ? void 0 : bv.variant.subtle.trigger
      },
      plain: {
        field: {
          bg: "transparent",
          color: "fg",
          focusRingWidth: "2px"
        }
      }
    },
    size: {
      xs: {
        field: {
          textStyle: "xs",
          ps: "2",
          pe: "6",
          height: "6"
        },
        indicator: {
          textStyle: "sm",
          insetEnd: "1.5"
        }
      },
      sm: {
        field: {
          textStyle: "sm",
          ps: "2.5",
          pe: "8",
          height: "8"
        },
        indicator: {
          textStyle: "md",
          insetEnd: "2"
        }
      },
      md: {
        field: {
          textStyle: "sm",
          ps: "3",
          pe: "8",
          height: "10"
        },
        indicator: {
          textStyle: "lg",
          insetEnd: "2"
        }
      },
      lg: {
        field: {
          textStyle: "md",
          ps: "4",
          pe: "8",
          height: "11"
        },
        indicator: {
          textStyle: "xl",
          insetEnd: "3"
        }
      },
      xl: {
        field: {
          textStyle: "md",
          ps: "4.5",
          pe: "10",
          height: "12"
        },
        indicator: {
          textStyle: "xl",
          insetEnd: "3"
        }
      }
    }
  },
  defaultVariants: ta.defaultVariants
});
function pu(e, t) {
  const r = {};
  for (const n in e) {
    const i = t(n, e[n]);
    r[i[0]] = i[1];
  }
  return r;
}
const Ip = q0({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flex: "1",
  userSelect: "none",
  cursor: "button",
  lineHeight: "1",
  color: "fg.muted",
  "--stepper-base-radius": "radii.l1",
  "--stepper-radius": "calc(var(--stepper-base-radius) + 1px)",
  _icon: {
    boxSize: "1em"
  },
  _disabled: {
    opacity: "0.5"
  },
  _hover: {
    bg: "bg.muted"
  },
  _active: {
    bg: "bg.emphasized"
  }
}), xN = ce({
  className: "chakra-number-input",
  slots: Ry.keys(),
  base: {
    root: {
      position: "relative",
      zIndex: "0",
      isolation: "isolate"
    },
    input: {
      ...je.base,
      verticalAlign: "top",
      pe: "calc(var(--stepper-width) + 0.5rem)"
    },
    control: {
      display: "flex",
      flexDirection: "column",
      position: "absolute",
      top: "0",
      insetEnd: "0px",
      margin: "1px",
      width: "var(--stepper-width)",
      height: "calc(100% - 2px)",
      zIndex: "1",
      borderStartWidth: "1px",
      divideY: "1px"
    },
    incrementTrigger: {
      ...Ip,
      borderTopEndRadius: "var(--stepper-radius)"
    },
    decrementTrigger: {
      ...Ip,
      borderBottomEndRadius: "var(--stepper-radius)"
    },
    valueText: {
      fontWeight: "medium",
      fontFeatureSettings: "pnum",
      fontVariantNumeric: "proportional-nums"
    }
  },
  variants: {
    size: {
      xs: {
        input: je.variants.size.xs,
        control: {
          fontSize: "2xs",
          "--stepper-width": "sizes.4"
        }
      },
      sm: {
        input: je.variants.size.sm,
        control: {
          fontSize: "xs",
          "--stepper-width": "sizes.5"
        }
      },
      md: {
        input: je.variants.size.md,
        control: {
          fontSize: "sm",
          "--stepper-width": "sizes.6"
        }
      },
      lg: {
        input: je.variants.size.lg,
        control: {
          fontSize: "sm",
          "--stepper-width": "sizes.6"
        }
      }
    },
    variant: pu(je.variants.variant, (e, t) => [
      e,
      { input: t }
    ])
  },
  defaultVariants: {
    size: "md",
    variant: "outline"
  }
}), { variants: Op, defaultVariants: _N } = je, wN = ce({
  className: "chakra-pin-input",
  slots: Fy.keys(),
  base: {
    input: {
      ...je.base,
      textAlign: "center",
      width: "var(--input-height)"
    },
    control: {
      display: "inline-flex",
      gap: "2",
      isolation: "isolate"
    }
  },
  variants: {
    size: pu(Op.size, (e, t) => [e, { input: t }]),
    variant: pu(Op.variant, (e, t) => [
      e,
      { input: t }
    ]),
    attached: {
      true: {
        control: {
          gap: "0",
          spaceX: "-1px"
        },
        input: {
          _notFirst: { borderStartRadius: "0" },
          _notLast: { borderEndRadius: "0" },
          _focusVisible: { zIndex: "1" }
        }
      }
    }
  },
  defaultVariants: _N
}), SN = ce({
  className: "chakra-popover",
  slots: FA.keys(),
  base: {
    content: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      textStyle: "sm",
      "--popover-bg": "colors.bg.panel",
      bg: "var(--popover-bg)",
      boxShadow: "lg",
      "--popover-size": "sizes.xs",
      "--popover-mobile-size": "calc(100dvw - 1rem)",
      width: {
        base: "min(var(--popover-mobile-size), var(--popover-size))",
        sm: "var(--popover-size)"
      },
      borderRadius: "l3",
      "--popover-z-index": "zIndex.popover",
      zIndex: "calc(var(--popover-z-index) + var(--layer-index, 0))",
      outline: "0",
      transformOrigin: "var(--transform-origin)",
      maxHeight: "var(--available-height)",
      _open: {
        animationStyle: "scale-fade-in",
        animationDuration: "fast"
      },
      _closed: {
        animationStyle: "scale-fade-out",
        animationDuration: "faster"
      }
    },
    header: {
      paddingInline: "var(--popover-padding)",
      paddingTop: "var(--popover-padding)"
    },
    body: {
      padding: "var(--popover-padding)",
      flex: "1"
    },
    footer: {
      display: "flex",
      alignItems: "center",
      paddingInline: "var(--popover-padding)",
      paddingBottom: "var(--popover-padding)"
    },
    arrow: {
      "--arrow-size": "sizes.3",
      "--arrow-background": "var(--popover-bg)"
    },
    arrowTip: {
      borderTopWidth: "1px",
      borderInlineStartWidth: "1px"
    }
  },
  variants: {
    size: {
      xs: {
        content: {
          "--popover-padding": "spacing.3"
        }
      },
      sm: {
        content: {
          "--popover-padding": "spacing.4"
        }
      },
      md: {
        content: {
          "--popover-padding": "spacing.5"
        }
      },
      lg: {
        content: {
          "--popover-padding": "spacing.6"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), EN = ce({
  slots: Hd.keys(),
  className: "chakra-progress",
  base: {
    root: {
      textStyle: "sm",
      position: "relative"
    },
    track: {
      overflow: "hidden",
      position: "relative"
    },
    range: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transitionProperty: "width, height",
      transitionDuration: "slow",
      height: "100%",
      bgColor: "var(--track-color)",
      _indeterminate: {
        "--animate-from-x": "-40%",
        "--animate-to-x": "100%",
        position: "absolute",
        willChange: "left",
        minWidth: "50%",
        animation: "position 1s ease infinite normal none running",
        backgroundImage: "linear-gradient(to right, transparent 0%, var(--track-color) 50%, transparent 100%)"
      }
    },
    label: {
      display: "inline-flex",
      fontWeight: "medium",
      alignItems: "center",
      gap: "1"
    },
    valueText: {
      textStyle: "xs",
      lineHeight: "1",
      fontWeight: "medium"
    }
  },
  variants: {
    variant: {
      outline: {
        track: {
          shadow: "inset",
          bgColor: "bg.muted"
        },
        range: {
          bgColor: "colorPalette.solid"
        }
      },
      subtle: {
        track: {
          bgColor: "colorPalette.muted"
        },
        range: {
          bgColor: "colorPalette.solid/72"
        }
      }
    },
    shape: {
      square: {},
      rounded: {
        track: {
          borderRadius: "l1"
        }
      },
      full: {
        track: {
          borderRadius: "full"
        }
      }
    },
    striped: {
      true: {
        range: {
          backgroundImage: "linear-gradient(45deg, var(--stripe-color) 25%, transparent 25%, transparent 50%, var(--stripe-color) 50%, var(--stripe-color) 75%, transparent 75%, transparent)",
          backgroundSize: "var(--stripe-size) var(--stripe-size)",
          "--stripe-size": "1rem",
          "--stripe-color": {
            _light: "rgba(255, 255, 255, 0.3)",
            _dark: "rgba(0, 0, 0, 0.3)"
          }
        }
      }
    },
    animated: {
      true: {
        range: {
          "--animate-from": "var(--stripe-size)",
          animation: "bg-position 1s linear infinite"
        }
      }
    },
    size: {
      xs: {
        track: { h: "1.5" }
      },
      sm: {
        track: { h: "2" }
      },
      md: {
        track: { h: "2.5" }
      },
      lg: {
        track: { h: "3" }
      },
      xl: {
        track: { h: "4" }
      }
    }
  },
  defaultVariants: {
    variant: "outline",
    size: "md",
    shape: "rounded"
  }
}), CN = ce({
  className: "chakra-progress-circle",
  slots: Hd.keys(),
  base: {
    root: {
      display: "inline-flex",
      textStyle: "sm",
      position: "relative"
    },
    circle: {
      _indeterminate: {
        animation: "spin 2s linear infinite"
      }
    },
    circleTrack: {
      "--track-color": "colors.colorPalette.muted",
      stroke: "var(--track-color)"
    },
    circleRange: {
      stroke: "colorPalette.solid",
      transitionProperty: "stroke-dashoffset, stroke-dasharray",
      transitionDuration: "0.6s",
      _indeterminate: {
        animation: "circular-progress 1.5s linear infinite"
      }
    },
    label: {
      display: "inline-flex"
    },
    valueText: {
      lineHeight: "1",
      fontWeight: "medium",
      letterSpacing: "tight",
      fontVariantNumeric: "tabular-nums"
    }
  },
  variants: {
    size: {
      xs: {
        circle: {
          "--size": "24px",
          "--thickness": "4px"
        },
        valueText: {
          textStyle: "2xs"
        }
      },
      sm: {
        circle: {
          "--size": "32px",
          "--thickness": "5px"
        },
        valueText: {
          textStyle: "2xs"
        }
      },
      md: {
        circle: {
          "--size": "40px",
          "--thickness": "6px"
        },
        valueText: {
          textStyle: "xs"
        }
      },
      lg: {
        circle: {
          "--size": "48px",
          "--thickness": "7px"
        },
        valueText: {
          textStyle: "sm"
        }
      },
      xl: {
        circle: {
          "--size": "64px",
          "--thickness": "8px"
        },
        valueText: {
          textStyle: "sm"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), kN = ce({
  slots: i0.keys(),
  className: "chakra-qr-code",
  base: {
    root: {
      position: "relative",
      width: "fit-content",
      "--qr-code-overlay-size": "calc(var(--qr-code-size) / 3)"
    },
    frame: {
      width: "var(--qr-code-size)",
      height: "var(--qr-code-size)",
      fill: "currentColor"
    },
    overlay: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "var(--qr-code-overlay-size)",
      height: "var(--qr-code-overlay-size)",
      padding: "1",
      bg: "bg",
      rounded: "l1"
    }
  },
  variants: {
    size: {
      "2xs": {
        root: { "--qr-code-size": "40px" }
      },
      xs: {
        root: { "--qr-code-size": "64px" }
      },
      sm: {
        root: { "--qr-code-size": "80px" }
      },
      md: {
        root: { "--qr-code-size": "120px" }
      },
      lg: {
        root: { "--qr-code-size": "160px" }
      },
      xl: {
        root: { "--qr-code-size": "200px" }
      },
      "2xl": {
        root: { "--qr-code-size": "240px" }
      },
      full: {
        root: { "--qr-code-size": "100%" }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
});
var yv, xv, _v, wv, Sv, Ev, Cv;
const IN = ce({
  className: "chakra-radio-card",
  slots: $A.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "1.5",
      isolation: "isolate"
    },
    item: {
      flex: "1",
      display: "flex",
      flexDirection: "column",
      userSelect: "none",
      position: "relative",
      borderRadius: "l2",
      _focus: {
        bg: "colorPalette.muted/20"
      },
      _disabled: {
        opacity: "0.8",
        borderColor: "border.disabled"
      },
      _checked: {
        zIndex: "1"
      }
    },
    label: {
      display: "inline-flex",
      fontWeight: "medium",
      textStyle: "sm",
      _disabled: {
        opacity: "0.5"
      }
    },
    itemText: {
      fontWeight: "medium",
      flex: "1"
    },
    itemDescription: {
      opacity: "0.64",
      textStyle: "sm"
    },
    itemControl: {
      display: "inline-flex",
      flex: "1",
      pos: "relative",
      rounded: "inherit",
      justifyContent: "var(--radio-card-justify)",
      alignItems: "var(--radio-card-align)",
      _disabled: {
        bg: "bg.muted"
      }
    },
    itemIndicator: it.base,
    itemAddon: {
      roundedBottom: "inherit",
      _disabled: {
        color: "fg.muted"
      }
    },
    itemContent: {
      display: "flex",
      flexDirection: "column",
      flex: "1",
      gap: "1",
      justifyContent: "var(--radio-card-justify)",
      alignItems: "var(--radio-card-align)"
    }
  },
  variants: {
    size: {
      sm: {
        item: {
          textStyle: "sm"
        },
        itemControl: {
          padding: "3",
          gap: "1.5"
        },
        itemAddon: {
          px: "3",
          py: "1.5",
          borderTopWidth: "1px"
        },
        itemIndicator: (yv = it.variants) == null ? void 0 : yv.size.sm
      },
      md: {
        item: {
          textStyle: "sm"
        },
        itemControl: {
          padding: "4",
          gap: "2.5"
        },
        itemAddon: {
          px: "4",
          py: "2",
          borderTopWidth: "1px"
        },
        itemIndicator: (xv = it.variants) == null ? void 0 : xv.size.md
      },
      lg: {
        item: {
          textStyle: "md"
        },
        itemControl: {
          padding: "4",
          gap: "3.5"
        },
        itemAddon: {
          px: "4",
          py: "2",
          borderTopWidth: "1px"
        },
        itemIndicator: (_v = it.variants) == null ? void 0 : _v.size.lg
      }
    },
    variant: {
      surface: {
        item: {
          borderWidth: "1px",
          _checked: {
            bg: "colorPalette.subtle",
            color: "colorPalette.fg",
            borderColor: "colorPalette.muted"
          }
        },
        itemIndicator: (wv = it.variants) == null ? void 0 : wv.variant.solid
      },
      subtle: {
        item: {
          bg: "bg.muted"
        },
        itemControl: {
          _checked: {
            bg: "colorPalette.muted",
            color: "colorPalette.fg"
          }
        },
        itemIndicator: (Sv = it.variants) == null ? void 0 : Sv.variant.outline
      },
      outline: {
        item: {
          borderWidth: "1px",
          _checked: {
            boxShadow: "0 0 0 1px var(--shadow-color)",
            boxShadowColor: "colorPalette.solid",
            borderColor: "colorPalette.solid"
          }
        },
        itemIndicator: (Ev = it.variants) == null ? void 0 : Ev.variant.solid
      },
      solid: {
        item: {
          borderWidth: "1px",
          _checked: {
            bg: "colorPalette.solid",
            color: "colorPalette.contrast",
            borderColor: "colorPalette.solid"
          }
        },
        itemIndicator: (Cv = it.variants) == null ? void 0 : Cv.variant.inverted
      }
    },
    justify: {
      start: {
        item: { "--radio-card-justify": "flex-start" }
      },
      end: {
        item: { "--radio-card-justify": "flex-end" }
      },
      center: {
        item: { "--radio-card-justify": "center" }
      }
    },
    align: {
      start: {
        item: { "--radio-card-align": "flex-start" },
        itemControl: { textAlign: "start" }
      },
      end: {
        item: { "--radio-card-align": "flex-end" },
        itemControl: { textAlign: "end" }
      },
      center: {
        item: { "--radio-card-align": "center" },
        itemControl: { textAlign: "center" }
      }
    },
    orientation: {
      vertical: {
        itemControl: { flexDirection: "column" }
      },
      horizontal: {
        itemControl: { flexDirection: "row" }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline",
    align: "start",
    orientation: "horizontal"
  }
});
var kv, Iv, Ov, Pv, Tv, Rv, Av, Nv, Fv, $v, Lv, Vv, zv, Dv;
const ON = ce({
  className: "chakra-radio-group",
  slots: yx.keys(),
  base: {
    item: {
      display: "inline-flex",
      alignItems: "center",
      position: "relative",
      fontWeight: "medium",
      _disabled: {
        cursor: "disabled"
      }
    },
    itemControl: it.base,
    label: {
      userSelect: "none",
      textStyle: "sm",
      _disabled: {
        opacity: "0.5"
      }
    }
  },
  variants: {
    variant: {
      outline: {
        itemControl: (Iv = (kv = it.variants) == null ? void 0 : kv.variant) == null ? void 0 : Iv.outline
      },
      subtle: {
        itemControl: (Pv = (Ov = it.variants) == null ? void 0 : Ov.variant) == null ? void 0 : Pv.subtle
      },
      solid: {
        itemControl: (Rv = (Tv = it.variants) == null ? void 0 : Tv.variant) == null ? void 0 : Rv.solid
      }
    },
    size: {
      xs: {
        item: { textStyle: "xs", gap: "1.5" },
        itemControl: (Nv = (Av = it.variants) == null ? void 0 : Av.size) == null ? void 0 : Nv.xs
      },
      sm: {
        item: { textStyle: "sm", gap: "2" },
        itemControl: ($v = (Fv = it.variants) == null ? void 0 : Fv.size) == null ? void 0 : $v.sm
      },
      md: {
        item: { textStyle: "sm", gap: "2.5" },
        itemControl: (Vv = (Lv = it.variants) == null ? void 0 : Lv.size) == null ? void 0 : Vv.md
      },
      lg: {
        item: { textStyle: "md", gap: "3" },
        itemControl: (Dv = (zv = it.variants) == null ? void 0 : zv.size) == null ? void 0 : Dv.lg
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "solid"
  }
}), PN = ce({
  className: "chakra-rating-group",
  slots: LA.keys(),
  base: {
    root: {
      display: "inline-flex"
    },
    control: {
      display: "inline-flex",
      alignItems: "center"
    },
    item: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none"
    },
    itemIndicator: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "1em",
      height: "1em",
      position: "relative",
      "--clip-path": { base: "inset(0 50% 0 0)", _rtl: "inset(0 0 0 50%)" },
      _icon: {
        stroke: "currentColor",
        width: "100%",
        height: "100%",
        display: "inline-block",
        flexShrink: 0,
        position: "absolute",
        left: 0,
        top: 0
      },
      "& [data-bg]": {
        color: "bg.emphasized"
      },
      "& [data-fg]": {
        color: "transparent"
      },
      "&[data-highlighted]:not([data-half])": {
        "& [data-fg]": {
          color: "colorPalette.solid"
        }
      },
      "&[data-half]": {
        "& [data-fg]": {
          color: "colorPalette.solid",
          clipPath: "var(--clip-path)"
        }
      }
    }
  },
  variants: {
    size: {
      xs: {
        item: {
          textStyle: "sm"
        }
      },
      sm: {
        item: {
          textStyle: "md"
        }
      },
      md: {
        item: {
          textStyle: "xl"
        }
      },
      lg: {
        item: {
          textStyle: "2xl"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), TN = ce({
  className: "chakra-segment-group",
  slots: s0.keys(),
  base: {
    root: {
      "--segment-radius": "radii.l2",
      borderRadius: "l2",
      display: "inline-flex",
      boxShadow: "inset",
      minW: "max-content",
      textAlign: "center",
      position: "relative",
      isolation: "isolate",
      bg: "bg.muted",
      _vertical: {
        flexDirection: "column"
      }
    },
    item: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      fontSize: "sm",
      position: "relative",
      color: "fg",
      borderRadius: "var(--segment-radius)",
      _disabled: {
        opacity: "0.5"
      },
      "&:has(input:focus-visible)": {
        focusRing: "outside"
      },
      _before: {
        content: '""',
        position: "absolute",
        bg: "border",
        transition: "opacity 0.2s"
      },
      _horizontal: {
        _before: {
          insetInlineStart: 0,
          insetBlock: "1.5",
          width: "1px"
        }
      },
      _vertical: {
        _before: {
          insetBlockStart: 0,
          insetInline: "1.5",
          height: "1px"
        }
      },
      "& + &[data-state=checked], &[data-state=checked] + &, &:first-of-type": {
        _before: {
          opacity: "0"
        }
      },
      "&[data-state=checked][data-ssr]": {
        shadow: "sm",
        bg: "bg",
        borderRadius: "var(--segment-radius)"
      }
    },
    indicator: {
      shadow: "sm",
      pos: "absolute",
      bg: { _light: "bg", _dark: "bg.emphasized" },
      width: "var(--width)",
      height: "var(--height)",
      top: "var(--top)",
      left: "var(--left)",
      zIndex: -1,
      borderRadius: "var(--segment-radius)"
    }
  },
  variants: {
    size: {
      xs: {
        item: {
          textStyle: "xs",
          px: "3",
          gap: "1",
          height: "6"
        }
      },
      sm: {
        item: {
          textStyle: "sm",
          px: "4",
          gap: "2",
          height: "8"
        }
      },
      md: {
        item: {
          textStyle: "sm",
          px: "4",
          gap: "2",
          height: "10"
        }
      },
      lg: {
        item: {
          textStyle: "md",
          px: "4.5",
          gap: "3",
          height: "11"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), RN = ce({
  className: "chakra-slider",
  slots: DA.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "1",
      textStyle: "sm",
      position: "relative",
      isolation: "isolate",
      touchAction: "none"
    },
    label: {
      fontWeight: "medium",
      textStyle: "sm"
    },
    control: {
      display: "inline-flex",
      alignItems: "center",
      position: "relative"
    },
    track: {
      overflow: "hidden",
      borderRadius: "full",
      flex: "1"
    },
    range: {
      width: "inherit",
      height: "inherit",
      _disabled: { bg: "border.emphasized!" }
    },
    markerGroup: {
      position: "absolute!",
      zIndex: "1"
    },
    marker: {
      "--marker-bg": { base: "white", _underValue: "colors.bg" },
      display: "flex",
      alignItems: "center",
      gap: "calc(var(--slider-thumb-size) / 2)",
      color: "fg.muted",
      textStyle: "xs"
    },
    markerIndicator: {
      width: "var(--slider-marker-size)",
      height: "var(--slider-marker-size)",
      borderRadius: "full",
      bg: "var(--marker-bg)"
    },
    thumb: {
      width: "var(--slider-thumb-size)",
      height: "var(--slider-thumb-size)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      outline: 0,
      zIndex: "2",
      borderRadius: "full",
      _focusVisible: {
        ring: "2px",
        ringColor: "colorPalette.focusRing",
        ringOffset: "2px",
        ringOffsetColor: "bg"
      }
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          "--slider-thumb-size": "sizes.4",
          "--slider-track-size": "sizes.1.5",
          "--slider-marker-center": "6px",
          "--slider-marker-size": "sizes.1",
          "--slider-marker-inset": "3px"
        }
      },
      md: {
        root: {
          "--slider-thumb-size": "sizes.5",
          "--slider-track-size": "sizes.2",
          "--slider-marker-center": "8px",
          "--slider-marker-size": "sizes.1",
          "--slider-marker-inset": "4px"
        }
      },
      lg: {
        root: {
          "--slider-thumb-size": "sizes.6",
          "--slider-track-size": "sizes.2.5",
          "--slider-marker-center": "9px",
          "--slider-marker-size": "sizes.1.5",
          "--slider-marker-inset": "5px"
        }
      }
    },
    variant: {
      outline: {
        track: {
          shadow: "inset",
          bg: "bg.emphasized/72"
        },
        range: {
          bg: "colorPalette.solid"
        },
        thumb: {
          borderWidth: "2px",
          borderColor: "colorPalette.solid",
          bg: "bg",
          _disabled: {
            bg: "border.emphasized",
            borderColor: "border.emphasized"
          }
        }
      },
      solid: {
        track: {
          bg: "colorPalette.subtle",
          _disabled: {
            bg: "bg.muted"
          }
        },
        range: {
          bg: "colorPalette.solid"
        },
        thumb: {
          bg: "colorPalette.solid",
          _disabled: {
            bg: "border.emphasized"
          }
        }
      }
    },
    orientation: {
      vertical: {
        root: {
          display: "inline-flex"
        },
        control: {
          flexDirection: "column",
          height: "100%",
          minWidth: "var(--slider-thumb-size)",
          "&[data-has-mark-label], &:has(.chakra-slider__marker-label)": {
            marginEnd: "4"
          }
        },
        track: {
          width: "var(--slider-track-size)"
        },
        thumb: {
          left: "50%",
          translate: "-50% 0"
        },
        markerGroup: {
          insetStart: "var(--slider-marker-center)",
          insetBlock: "var(--slider-marker-inset)"
        },
        marker: {
          flexDirection: "row"
        }
      },
      horizontal: {
        control: {
          flexDirection: "row",
          width: "100%",
          minHeight: "var(--slider-thumb-size)",
          "&[data-has-mark-label], &:has(.chakra-slider__marker-label)": {
            marginBottom: "4"
          }
        },
        track: {
          height: "var(--slider-track-size)"
        },
        thumb: {
          top: "50%",
          translate: "0 -50%"
        },
        markerGroup: {
          top: "var(--slider-marker-center)",
          insetInline: "var(--slider-marker-inset)"
        },
        marker: {
          flexDirection: "column"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "outline",
    orientation: "horizontal"
  }
}), AN = ce({
  className: "chakra-stat",
  slots: MA.keys(),
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "1",
      position: "relative",
      flex: "1"
    },
    label: {
      display: "inline-flex",
      gap: "1.5",
      alignItems: "center",
      color: "fg.muted",
      textStyle: "sm"
    },
    helpText: {
      color: "fg.muted",
      textStyle: "xs"
    },
    valueUnit: {
      color: "fg.muted",
      textStyle: "xs",
      fontWeight: "initial",
      letterSpacing: "initial"
    },
    valueText: {
      verticalAlign: "baseline",
      fontWeight: "semibold",
      letterSpacing: "tight",
      fontFeatureSettings: "pnum",
      fontVariantNumeric: "proportional-nums",
      display: "inline-flex",
      gap: "1"
    },
    indicator: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      marginEnd: 1,
      "& :where(svg)": {
        w: "1em",
        h: "1em"
      },
      "&[data-type=up]": {
        color: "fg.success"
      },
      "&[data-type=down]": {
        color: "fg.error"
      }
    }
  },
  variants: {
    size: {
      sm: {
        valueText: {
          textStyle: "xl"
        }
      },
      md: {
        valueText: {
          textStyle: "2xl"
        }
      },
      lg: {
        valueText: {
          textStyle: "3xl"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), NN = ce({
  className: "chakra-status",
  slots: BA.keys(),
  base: {
    root: {
      display: "inline-flex",
      alignItems: "center",
      gap: "2"
    },
    indicator: {
      width: "0.64em",
      height: "0.64em",
      flexShrink: 0,
      borderRadius: "full",
      forcedColorAdjust: "none",
      bg: "colorPalette.solid"
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          textStyle: "xs"
        }
      },
      md: {
        root: {
          textStyle: "sm"
        }
      },
      lg: {
        root: {
          textStyle: "md"
        }
      }
    }
  },
  defaultVariants: {
    size: "md"
  }
}), FN = ce({
  className: "chakra-steps",
  slots: WA.keys(),
  base: {
    root: {
      display: "flex",
      width: "full"
    },
    list: {
      display: "flex",
      justifyContent: "space-between",
      "--steps-gutter": "spacing.3",
      "--steps-thickness": "2px"
    },
    title: {
      fontWeight: "medium",
      color: "fg"
    },
    description: {
      color: "fg.muted"
    },
    separator: {
      bg: "border",
      flex: "1"
    },
    indicator: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: "0",
      borderRadius: "full",
      fontWeight: "medium",
      width: "var(--steps-size)",
      height: "var(--steps-size)",
      _icon: {
        flexShrink: "0",
        width: "var(--steps-icon-size)",
        height: "var(--steps-icon-size)"
      }
    },
    item: {
      position: "relative",
      display: "flex",
      gap: "3",
      flex: "1 0 0",
      "&:last-of-type": {
        flex: "initial",
        "& [data-part=separator]": {
          display: "none"
        }
      }
    },
    trigger: {
      display: "flex",
      alignItems: "center",
      gap: "3",
      textAlign: "start",
      focusVisibleRing: "outside",
      borderRadius: "l2"
    },
    content: {
      focusVisibleRing: "outside"
    }
  },
  variants: {
    orientation: {
      vertical: {
        root: {
          flexDirection: "row",
          height: "100%"
        },
        list: {
          flexDirection: "column",
          alignItems: "flex-start"
        },
        separator: {
          position: "absolute",
          width: "var(--steps-thickness)",
          height: "100%",
          maxHeight: "calc(100% - var(--steps-size) - var(--steps-gutter) * 2)",
          top: "calc(var(--steps-size) + var(--steps-gutter))",
          insetStart: "calc(var(--steps-size) / 2 - 1px)"
        },
        item: {
          alignItems: "flex-start"
        }
      },
      horizontal: {
        root: {
          flexDirection: "column",
          width: "100%"
        },
        list: {
          flexDirection: "row",
          alignItems: "center"
        },
        separator: {
          width: "100%",
          height: "var(--steps-thickness)",
          marginX: "var(--steps-gutter)"
        },
        item: {
          alignItems: "center"
        }
      }
    },
    variant: {
      solid: {
        indicator: {
          _incomplete: {
            borderWidth: "var(--steps-thickness)"
          },
          _current: {
            bg: "colorPalette.muted",
            borderWidth: "var(--steps-thickness)",
            borderColor: "colorPalette.solid",
            color: "colorPalette.fg"
          },
          _complete: {
            bg: "colorPalette.solid",
            borderColor: "colorPalette.solid",
            color: "colorPalette.contrast"
          }
        },
        separator: {
          _complete: {
            bg: "colorPalette.solid"
          }
        }
      },
      subtle: {
        indicator: {
          _incomplete: {
            bg: "bg.muted"
          },
          _current: {
            bg: "colorPalette.muted",
            color: "colorPalette.fg"
          },
          _complete: {
            bg: "colorPalette.emphasized",
            color: "colorPalette.fg"
          }
        },
        separator: {
          _complete: {
            bg: "colorPalette.emphasized"
          }
        }
      }
    },
    size: {
      xs: {
        root: {
          gap: "2.5"
        },
        list: {
          "--steps-size": "sizes.6",
          "--steps-icon-size": "sizes.3.5",
          textStyle: "xs"
        },
        title: {
          textStyle: "sm"
        }
      },
      sm: {
        root: {
          gap: "3"
        },
        list: {
          "--steps-size": "sizes.8",
          "--steps-icon-size": "sizes.4",
          textStyle: "xs"
        },
        title: {
          textStyle: "sm"
        }
      },
      md: {
        root: {
          gap: "4"
        },
        list: {
          "--steps-size": "sizes.10",
          "--steps-icon-size": "sizes.4",
          textStyle: "sm"
        },
        title: {
          textStyle: "sm"
        }
      },
      lg: {
        root: {
          gap: "6"
        },
        list: {
          "--steps-size": "sizes.11",
          "--steps-icon-size": "sizes.5",
          textStyle: "md"
        },
        title: {
          textStyle: "md"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "solid",
    orientation: "horizontal"
  }
}), $N = ce({
  slots: HA.keys(),
  className: "chakra-switch",
  base: {
    root: {
      display: "inline-flex",
      gap: "2.5",
      alignItems: "center",
      position: "relative",
      verticalAlign: "middle",
      "--switch-diff": "calc(var(--switch-width) - var(--switch-height))",
      "--switch-x": {
        base: "var(--switch-diff)",
        _rtl: "calc(var(--switch-diff) * -1)"
      }
    },
    label: {
      lineHeight: "1",
      userSelect: "none",
      fontSize: "sm",
      fontWeight: "medium",
      _disabled: {
        opacity: "0.5"
      }
    },
    indicator: {
      position: "absolute",
      height: "var(--switch-height)",
      width: "var(--switch-height)",
      fontSize: "var(--switch-indicator-font-size)",
      fontWeight: "medium",
      flexShrink: 0,
      userSelect: "none",
      display: "grid",
      placeContent: "center",
      transition: "inset-inline-start 0.12s ease",
      insetInlineStart: "calc(var(--switch-x) - 2px)",
      _checked: {
        insetInlineStart: "2px"
      }
    },
    control: {
      display: "inline-flex",
      gap: "0.5rem",
      flexShrink: 0,
      justifyContent: "flex-start",
      cursor: "switch",
      borderRadius: "full",
      position: "relative",
      width: "var(--switch-width)",
      height: "var(--switch-height)",
      transition: "backgrounds",
      _disabled: {
        opacity: "0.5",
        cursor: "not-allowed"
      },
      _invalid: {
        outline: "2px solid",
        outlineColor: "border.error",
        outlineOffset: "2px"
      }
    },
    thumb: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      transitionProperty: "translate",
      transitionDuration: "fast",
      borderRadius: "inherit",
      _checked: {
        translate: "var(--switch-x) 0"
      }
    }
  },
  variants: {
    variant: {
      solid: {
        control: {
          borderRadius: "full",
          bg: "bg.emphasized",
          focusVisibleRing: "outside",
          _checked: {
            bg: "colorPalette.solid"
          }
        },
        thumb: {
          bg: "white",
          width: "var(--switch-height)",
          height: "var(--switch-height)",
          scale: "0.8",
          boxShadow: "sm",
          _checked: {
            bg: "colorPalette.contrast"
          }
        }
      },
      raised: {
        control: {
          borderRadius: "full",
          height: "calc(var(--switch-height) / 2)",
          bg: "bg.muted",
          boxShadow: "inset",
          _checked: {
            bg: "colorPalette.solid/60"
          }
        },
        thumb: {
          width: "var(--switch-height)",
          height: "var(--switch-height)",
          position: "relative",
          top: "calc(var(--switch-height) * -0.25)",
          bg: "white",
          boxShadow: "xs",
          focusVisibleRing: "outside",
          _checked: {
            bg: "colorPalette.solid"
          }
        }
      }
    },
    size: {
      xs: {
        root: {
          "--switch-width": "sizes.6",
          "--switch-height": "sizes.3",
          "--switch-indicator-font-size": "fontSizes.xs"
        }
      },
      sm: {
        root: {
          "--switch-width": "sizes.8",
          "--switch-height": "sizes.4",
          "--switch-indicator-font-size": "fontSizes.xs"
        }
      },
      md: {
        root: {
          "--switch-width": "sizes.10",
          "--switch-height": "sizes.5",
          "--switch-indicator-font-size": "fontSizes.sm"
        }
      },
      lg: {
        root: {
          "--switch-width": "sizes.12",
          "--switch-height": "sizes.6",
          "--switch-indicator-font-size": "fontSizes.md"
        }
      }
    }
  },
  defaultVariants: {
    variant: "solid",
    size: "md"
  }
}), LN = ce({
  className: "chakra-table",
  slots: jA.keys(),
  base: {
    root: {
      fontVariantNumeric: "lining-nums tabular-nums",
      borderCollapse: "collapse",
      width: "full",
      textAlign: "start",
      verticalAlign: "top"
    },
    row: {
      _selected: {
        bg: "colorPalette.subtle"
      }
    },
    cell: {
      textAlign: "start",
      alignItems: "center"
    },
    columnHeader: {
      fontWeight: "medium",
      textAlign: "start",
      color: "fg"
    },
    caption: {
      fontWeight: "medium",
      textStyle: "xs"
    },
    footer: {
      fontWeight: "medium"
    }
  },
  variants: {
    interactive: {
      true: {
        body: {
          "& tr": {
            _hover: {
              bg: "colorPalette.subtle"
            }
          }
        }
      }
    },
    stickyHeader: {
      true: {
        header: {
          "& :where(tr)": {
            top: "var(--table-sticky-offset, 0)",
            position: "sticky",
            zIndex: 1
          }
        }
      }
    },
    striped: {
      true: {
        row: {
          "&:nth-of-type(odd) td": {
            bg: "bg.muted"
          }
        }
      }
    },
    showColumnBorder: {
      true: {
        columnHeader: {
          "&:not(:last-of-type)": {
            borderInlineEndWidth: "1px"
          }
        },
        cell: {
          "&:not(:last-of-type)": {
            borderInlineEndWidth: "1px"
          }
        }
      }
    },
    variant: {
      line: {
        columnHeader: {
          borderBottomWidth: "1px"
        },
        cell: {
          borderBottomWidth: "1px"
        },
        row: {
          bg: "bg"
        }
      },
      outline: {
        root: {
          boxShadow: "0 0 0 1px {colors.border}",
          overflow: "hidden"
        },
        columnHeader: {
          borderBottomWidth: "1px"
        },
        header: {
          bg: "bg.muted"
        },
        row: {
          "&:not(:last-of-type)": {
            borderBottomWidth: "1px"
          }
        },
        footer: {
          borderTopWidth: "1px"
        }
      }
    },
    size: {
      sm: {
        root: {
          textStyle: "sm"
        },
        columnHeader: {
          px: "2",
          py: "2"
        },
        cell: {
          px: "2",
          py: "2"
        }
      },
      md: {
        root: {
          textStyle: "sm"
        },
        columnHeader: {
          px: "3",
          py: "3"
        },
        cell: {
          px: "3",
          py: "3"
        }
      },
      lg: {
        root: {
          textStyle: "md"
        },
        columnHeader: {
          px: "4",
          py: "3"
        },
        cell: {
          px: "4",
          py: "3"
        }
      }
    }
  },
  defaultVariants: {
    variant: "line",
    size: "md"
  }
}), VN = ce({
  slots: GA.keys(),
  className: "chakra-tabs",
  base: {
    root: {
      "--tabs-trigger-radius": "radii.l2",
      position: "relative",
      _horizontal: {
        display: "block"
      },
      _vertical: {
        display: "flex"
      }
    },
    list: {
      display: "inline-flex",
      position: "relative",
      isolation: "isolate",
      "--tabs-indicator-shadow": "shadows.xs",
      "--tabs-indicator-bg": "colors.bg",
      minH: "var(--tabs-height)",
      _horizontal: {
        flexDirection: "row"
      },
      _vertical: {
        flexDirection: "column"
      }
    },
    trigger: {
      outline: "0",
      minW: "var(--tabs-height)",
      height: "var(--tabs-height)",
      display: "flex",
      alignItems: "center",
      fontWeight: "medium",
      position: "relative",
      cursor: "button",
      gap: "2",
      _focusVisible: {
        zIndex: 1,
        outline: "2px solid",
        outlineColor: "colorPalette.focusRing"
      },
      _disabled: {
        cursor: "not-allowed",
        opacity: 0.5
      }
    },
    content: {
      focusVisibleRing: "inside",
      _horizontal: {
        width: "100%",
        pt: "var(--tabs-content-padding)"
      },
      _vertical: {
        height: "100%",
        ps: "var(--tabs-content-padding)"
      }
    },
    indicator: {
      width: "var(--width)",
      height: "var(--height)",
      borderRadius: "var(--tabs-indicator-radius)",
      bg: "var(--tabs-indicator-bg)",
      shadow: "var(--tabs-indicator-shadow)",
      zIndex: -1
    }
  },
  variants: {
    fitted: {
      true: {
        list: {
          display: "flex"
        },
        trigger: {
          flex: 1,
          textAlign: "center",
          justifyContent: "center"
        }
      }
    },
    justify: {
      start: {
        list: {
          justifyContent: "flex-start"
        }
      },
      center: {
        list: {
          justifyContent: "center"
        }
      },
      end: {
        list: {
          justifyContent: "flex-end"
        }
      }
    },
    size: {
      sm: {
        root: {
          "--tabs-height": "sizes.9",
          "--tabs-content-padding": "spacing.3"
        },
        trigger: {
          py: "1",
          px: "3",
          textStyle: "sm"
        }
      },
      md: {
        root: {
          "--tabs-height": "sizes.10",
          "--tabs-content-padding": "spacing.4"
        },
        trigger: {
          py: "2",
          px: "4",
          textStyle: "sm"
        }
      },
      lg: {
        root: {
          "--tabs-height": "sizes.11",
          "--tabs-content-padding": "spacing.4.5"
        },
        trigger: {
          py: "2",
          px: "4.5",
          textStyle: "md"
        }
      }
    },
    variant: {
      line: {
        list: {
          display: "flex",
          borderColor: "border",
          _horizontal: {
            borderBottomWidth: "1px"
          },
          _vertical: {
            borderEndWidth: "1px"
          }
        },
        trigger: {
          color: "fg.muted",
          _disabled: {
            _active: { bg: "initial" }
          },
          _selected: {
            color: "fg",
            _horizontal: {
              layerStyle: "indicator.bottom",
              "--indicator-offset-y": "-1px",
              "--indicator-color": "colors.colorPalette.solid"
            },
            _vertical: {
              layerStyle: "indicator.end",
              "--indicator-offset-x": "-1px"
            }
          }
        }
      },
      subtle: {
        trigger: {
          borderRadius: "var(--tabs-trigger-radius)",
          color: "fg.muted",
          _selected: {
            bg: "colorPalette.subtle",
            color: "colorPalette.fg"
          }
        }
      },
      enclosed: {
        list: {
          bg: "bg.muted",
          padding: "1",
          borderRadius: "l3",
          minH: "calc(var(--tabs-height) - 4px)"
        },
        trigger: {
          justifyContent: "center",
          color: "fg.muted",
          borderRadius: "var(--tabs-trigger-radius)",
          _selected: {
            bg: "bg",
            color: "colorPalette.fg",
            shadow: "xs"
          }
        }
      },
      outline: {
        list: {
          "--line-thickness": "1px",
          "--line-offset": "calc(var(--line-thickness) * -1)",
          borderColor: "border",
          display: "flex",
          _horizontal: {
            _before: {
              content: '""',
              position: "absolute",
              bottom: "0px",
              width: "100%",
              borderBottomWidth: "var(--line-thickness)",
              borderBottomColor: "border"
            }
          },
          _vertical: {
            _before: {
              content: '""',
              position: "absolute",
              insetInline: "var(--line-offset)",
              height: "calc(100% - calc(var(--line-thickness) * 2))",
              borderEndWidth: "var(--line-thickness)",
              borderEndColor: "border"
            }
          }
        },
        trigger: {
          color: "fg.muted",
          borderWidth: "1px",
          borderColor: "transparent",
          _selected: {
            bg: "currentBg",
            color: "colorPalette.fg"
          },
          _horizontal: {
            borderTopRadius: "var(--tabs-trigger-radius)",
            marginBottom: "var(--line-offset)",
            marginEnd: { _notLast: "var(--line-offset)" },
            _selected: {
              borderColor: "border",
              borderBottomColor: "transparent"
            }
          },
          _vertical: {
            borderStartRadius: "var(--tabs-trigger-radius)",
            marginEnd: "var(--line-offset)",
            marginBottom: { _notLast: "var(--line-offset)" },
            _selected: {
              borderColor: "border",
              borderEndColor: "transparent"
            }
          }
        }
      },
      plain: {
        trigger: {
          color: "fg.muted",
          _selected: {
            color: "colorPalette.fg"
          },
          borderRadius: "var(--tabs-trigger-radius)",
          "&[data-selected][data-ssr]": {
            bg: "var(--tabs-indicator-bg)",
            shadow: "var(--tabs-indicator-shadow)",
            borderRadius: "var(--tabs-indicator-radius)"
          }
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "line"
  }
});
var Mv;
const Gt = (Mv = Kd.variants) == null ? void 0 : Mv.variant, zN = ce({
  slots: qA.keys(),
  className: "chakra-tag",
  base: {
    root: {
      display: "inline-flex",
      alignItems: "center",
      verticalAlign: "top",
      maxWidth: "100%",
      userSelect: "none",
      borderRadius: "l2",
      focusVisibleRing: "outside"
    },
    label: {
      lineClamp: "1"
    },
    closeTrigger: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      outline: "0",
      borderRadius: "l1",
      color: "currentColor",
      focusVisibleRing: "inside",
      focusRingWidth: "2px"
    },
    startElement: {
      flexShrink: 0,
      boxSize: "var(--tag-element-size)",
      ms: "var(--tag-element-offset)",
      "&:has([data-scope=avatar])": {
        boxSize: "var(--tag-avatar-size)",
        ms: "calc(var(--tag-element-offset) * 1.5)"
      },
      _icon: { boxSize: "100%" }
    },
    endElement: {
      flexShrink: 0,
      boxSize: "var(--tag-element-size)",
      me: "var(--tag-element-offset)",
      _icon: { boxSize: "100%" },
      "&:has(button)": {
        ms: "calc(var(--tag-element-offset) * -1)"
      }
    }
  },
  variants: {
    size: {
      sm: {
        root: {
          px: "1.5",
          minH: "4.5",
          gap: "1",
          "--tag-avatar-size": "spacing.3",
          "--tag-element-size": "spacing.3",
          "--tag-element-offset": "-2px"
        },
        label: {
          textStyle: "xs"
        }
      },
      md: {
        root: {
          px: "1.5",
          minH: "5",
          gap: "1",
          "--tag-avatar-size": "spacing.3.5",
          "--tag-element-size": "spacing.3.5",
          "--tag-element-offset": "-2px"
        },
        label: {
          textStyle: "xs"
        }
      },
      lg: {
        root: {
          px: "2",
          minH: "6",
          gap: "1.5",
          "--tag-avatar-size": "spacing.4.5",
          "--tag-element-size": "spacing.4",
          "--tag-element-offset": "-3px"
        },
        label: {
          textStyle: "sm"
        }
      },
      xl: {
        root: {
          px: "2.5",
          minH: "8",
          gap: "1.5",
          "--tag-avatar-size": "spacing.6",
          "--tag-element-size": "spacing.4.5",
          "--tag-element-offset": "-4px"
        },
        label: {
          textStyle: "sm"
        }
      }
    },
    variant: {
      subtle: {
        root: Gt == null ? void 0 : Gt.subtle
      },
      solid: {
        root: Gt == null ? void 0 : Gt.solid
      },
      outline: {
        root: Gt == null ? void 0 : Gt.outline
      },
      surface: {
        root: Gt == null ? void 0 : Gt.surface
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "surface"
  }
}), DN = ce({
  slots: KA.keys(),
  className: "chakra-timeline",
  base: {
    root: {
      display: "flex",
      flexDirection: "column",
      width: "full",
      "--timeline-thickness": "1px",
      "--timeline-gutter": "4px"
    },
    item: {
      display: "flex",
      position: "relative",
      alignItems: "flex-start",
      flexShrink: 0,
      gap: "4",
      _last: {
        "& :where(.chakra-timeline__separator)": { display: "none" }
      }
    },
    separator: {
      position: "absolute",
      borderStartWidth: "var(--timeline-thickness)",
      ms: "calc(-1 * var(--timeline-thickness) / 2)",
      insetInlineStart: "calc(var(--timeline-indicator-size) / 2)",
      insetBlock: "0",
      borderColor: "border"
    },
    indicator: {
      outline: "2px solid {colors.bg}",
      position: "relative",
      flexShrink: "0",
      boxSize: "var(--timeline-indicator-size)",
      fontSize: "var(--timeline-font-size)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "full",
      fontWeight: "medium"
    },
    connector: {
      alignSelf: "stretch",
      position: "relative"
    },
    content: {
      pb: "6",
      display: "flex",
      flexDirection: "column",
      width: "full",
      gap: "2"
    },
    title: {
      display: "flex",
      fontWeight: "medium",
      flexWrap: "wrap",
      gap: "1.5",
      alignItems: "center",
      mt: "var(--timeline-margin)"
    },
    description: {
      color: "fg.muted",
      textStyle: "xs"
    }
  },
  variants: {
    variant: {
      subtle: {
        indicator: {
          bg: "colorPalette.muted"
        }
      },
      solid: {
        indicator: {
          bg: "colorPalette.solid",
          color: "colorPalette.contrast"
        }
      },
      outline: {
        indicator: {
          bg: "currentBg",
          borderWidth: "1px",
          borderColor: "colorPalette.muted"
        }
      },
      plain: {}
    },
    size: {
      sm: {
        root: {
          "--timeline-indicator-size": "sizes.4",
          "--timeline-font-size": "fontSizes.2xs"
        },
        title: {
          textStyle: "xs"
        }
      },
      md: {
        root: {
          "--timeline-indicator-size": "sizes.5",
          "--timeline-font-size": "fontSizes.xs"
        },
        title: {
          textStyle: "sm"
        }
      },
      lg: {
        root: {
          "--timeline-indicator-size": "sizes.6",
          "--timeline-font-size": "fontSizes.xs"
        },
        title: {
          mt: "0.5",
          textStyle: "sm"
        }
      },
      xl: {
        root: {
          "--timeline-indicator-size": "sizes.8",
          "--timeline-font-size": "fontSizes.sm"
        },
        title: {
          mt: "1.5",
          textStyle: "sm"
        }
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "solid"
  }
}), MN = ce({
  slots: UA.keys(),
  className: "chakra-toast",
  base: {
    root: {
      width: "full",
      display: "flex",
      alignItems: "flex-start",
      position: "relative",
      gap: "3",
      py: "4",
      ps: "4",
      pe: "6",
      borderRadius: "l2",
      translate: "var(--x) var(--y)",
      scale: "var(--scale)",
      zIndex: "var(--z-index)",
      height: "var(--height)",
      opacity: "var(--opacity)",
      willChange: "translate, opacity, scale",
      transition: "translate 400ms, scale 400ms, opacity 400ms, height 400ms, box-shadow 200ms",
      transitionTimingFunction: "cubic-bezier(0.21, 1.02, 0.73, 1)",
      _closed: {
        transition: "translate 400ms, scale 400ms, opacity 200ms",
        transitionTimingFunction: "cubic-bezier(0.06, 0.71, 0.55, 1)"
      },
      bg: "bg.panel",
      color: "fg",
      boxShadow: "xl",
      "--toast-trigger-bg": "colors.bg.muted",
      "&[data-type=warning]": {
        bg: "orange.solid",
        color: "orange.contrast",
        "--toast-trigger-bg": "{white/10}",
        "--toast-border-color": "{white/40}"
      },
      "&[data-type=success]": {
        bg: "green.solid",
        color: "green.contrast",
        "--toast-trigger-bg": "{white/10}",
        "--toast-border-color": "{white/40}"
      },
      "&[data-type=error]": {
        bg: "red.solid",
        color: "red.contrast",
        "--toast-trigger-bg": "{white/10}",
        "--toast-border-color": "{white/40}"
      }
    },
    title: {
      fontWeight: "medium",
      textStyle: "sm",
      marginEnd: "2"
    },
    description: {
      display: "inline",
      textStyle: "sm",
      opacity: "0.8"
    },
    indicator: {
      flexShrink: "0",
      boxSize: "5"
    },
    actionTrigger: {
      textStyle: "sm",
      fontWeight: "medium",
      height: "8",
      px: "3",
      borderRadius: "l2",
      alignSelf: "center",
      borderWidth: "1px",
      borderColor: "var(--toast-border-color, inherit)",
      transition: "background 200ms",
      _hover: {
        bg: "var(--toast-trigger-bg)"
      }
    },
    closeTrigger: {
      position: "absolute",
      top: "1",
      insetEnd: "1",
      padding: "1",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      color: "{currentColor/60}",
      borderRadius: "l2",
      textStyle: "md",
      transition: "background 200ms",
      _icon: {
        boxSize: "1em"
      }
    }
  }
}), BN = ce({
  slots: W0.keys(),
  className: "chakra-tooltip",
  base: {
    content: {
      "--tooltip-bg": "colors.bg.inverted",
      bg: "var(--tooltip-bg)",
      color: "fg.inverted",
      px: "2.5",
      py: "1",
      borderRadius: "l2",
      fontWeight: "medium",
      textStyle: "xs",
      boxShadow: "md",
      maxW: "xs",
      zIndex: "tooltip",
      transformOrigin: "var(--transform-origin)",
      _open: {
        animationStyle: "scale-fade-in",
        animationDuration: "fast"
      },
      _closed: {
        animationStyle: "scale-fade-out",
        animationDuration: "fast"
      }
    },
    arrow: {
      "--arrow-size": "sizes.2",
      "--arrow-background": "var(--tooltip-bg)"
    },
    arrowTip: {
      borderTopWidth: "1px",
      borderInlineStartWidth: "1px",
      borderColor: "var(--tooltip-bg)"
    }
  }
}), WN = {
  accordion: XA,
  actionBar: JA,
  alert: ZA,
  avatar: QA,
  blockquote: eN,
  breadcrumb: tN,
  card: rN,
  checkbox: nN,
  checkboxCard: iN,
  collapsible: oN,
  dataList: lN,
  dialog: cN,
  drawer: uN,
  editable: dN,
  emptyState: fN,
  field: hN,
  fieldset: pN,
  fileUpload: gN,
  hoverCard: mN,
  list: vN,
  menu: bN,
  nativeSelect: yN,
  numberInput: xN,
  pinInput: wN,
  popover: SN,
  progress: EN,
  progressCircle: CN,
  radioCard: IN,
  radioGroup: ON,
  ratingGroup: PN,
  segmentGroup: TN,
  select: ta,
  combobox: aN,
  slider: RN,
  stat: AN,
  steps: FN,
  switch: $N,
  table: LN,
  tabs: VN,
  tag: zN,
  toast: MN,
  tooltip: BN,
  status: NN,
  timeline: DN,
  colorPicker: sN,
  qrCode: kN
}, HN = wR({
  "2xs": { value: { fontSize: "2xs", lineHeight: "0.75rem" } },
  xs: { value: { fontSize: "xs", lineHeight: "1rem" } },
  sm: { value: { fontSize: "sm", lineHeight: "1.25rem" } },
  md: { value: { fontSize: "md", lineHeight: "1.5rem" } },
  lg: { value: { fontSize: "lg", lineHeight: "1.75rem" } },
  xl: { value: { fontSize: "xl", lineHeight: "1.875rem" } },
  "2xl": { value: { fontSize: "2xl", lineHeight: "2rem" } },
  "3xl": { value: { fontSize: "3xl", lineHeight: "2.375rem" } },
  "4xl": {
    value: {
      fontSize: "4xl",
      lineHeight: "2.75rem",
      letterSpacing: "-0.025em"
    }
  },
  "5xl": {
    value: {
      fontSize: "5xl",
      lineHeight: "3.75rem",
      letterSpacing: "-0.025em"
    }
  },
  "6xl": {
    value: { fontSize: "6xl", lineHeight: "4.5rem", letterSpacing: "-0.025em" }
  },
  "7xl": {
    value: {
      fontSize: "7xl",
      lineHeight: "5.75rem",
      letterSpacing: "-0.025em"
    }
  },
  none: {
    value: {}
  },
  label: {
    value: {
      fontSize: "sm",
      lineHeight: "1.25rem",
      fontWeight: "medium"
    }
  }
}), jN = Ke.animations({
  spin: { value: "spin 1s linear infinite" },
  ping: { value: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite" },
  pulse: { value: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite" },
  bounce: { value: "bounce 1s infinite" }
}), UN = Ke.aspectRatios({
  square: { value: "1 / 1" },
  landscape: { value: "4 / 3" },
  portrait: { value: "3 / 4" },
  wide: { value: "16 / 9" },
  ultrawide: { value: "18 / 5" },
  golden: { value: "1.618 / 1" }
}), GN = Ke.blurs({
  none: { value: " " },
  sm: { value: "4px" },
  md: { value: "8px" },
  lg: { value: "12px" },
  xl: { value: "16px" },
  "2xl": { value: "24px" },
  "3xl": { value: "40px" },
  "4xl": { value: "64px" }
}), qN = Ke.borders({
  xs: { value: "0.5px solid" },
  sm: { value: "1px solid" },
  md: { value: "2px solid" },
  lg: { value: "4px solid" },
  xl: { value: "8px solid" }
}), KN = Ke.colors({
  transparent: { value: "transparent" },
  current: { value: "currentColor" },
  black: { value: "#09090B" },
  white: { value: "#FFFFFF" },
  whiteAlpha: {
    50: { value: "rgba(255, 255, 255, 0.04)" },
    100: { value: "rgba(255, 255, 255, 0.06)" },
    200: { value: "rgba(255, 255, 255, 0.08)" },
    300: { value: "rgba(255, 255, 255, 0.16)" },
    400: { value: "rgba(255, 255, 255, 0.24)" },
    500: { value: "rgba(255, 255, 255, 0.36)" },
    600: { value: "rgba(255, 255, 255, 0.48)" },
    700: { value: "rgba(255, 255, 255, 0.64)" },
    800: { value: "rgba(255, 255, 255, 0.80)" },
    900: { value: "rgba(255, 255, 255, 0.92)" },
    950: { value: "rgba(255, 255, 255, 0.95)" }
  },
  blackAlpha: {
    50: { value: "rgba(0, 0, 0, 0.04)" },
    100: { value: "rgba(0, 0, 0, 0.06)" },
    200: { value: "rgba(0, 0, 0, 0.08)" },
    300: { value: "rgba(0, 0, 0, 0.16)" },
    400: { value: "rgba(0, 0, 0, 0.24)" },
    500: { value: "rgba(0, 0, 0, 0.36)" },
    600: { value: "rgba(0, 0, 0, 0.48)" },
    700: { value: "rgba(0, 0, 0, 0.64)" },
    800: { value: "rgba(0, 0, 0, 0.80)" },
    900: { value: "rgba(0, 0, 0, 0.92)" },
    950: { value: "rgba(0, 0, 0, 0.95)" }
  },
  gray: {
    50: { value: "#fafafa" },
    100: { value: "#f4f4f5" },
    200: { value: "#e4e4e7" },
    300: { value: "#d4d4d8" },
    400: { value: "#a1a1aa" },
    500: { value: "#71717a" },
    600: { value: "#52525b" },
    700: { value: "#3f3f46" },
    800: { value: "#27272a" },
    900: { value: "#18181b" },
    950: { value: "#111111" }
  },
  red: {
    50: { value: "#fef2f2" },
    100: { value: "#fee2e2" },
    200: { value: "#fecaca" },
    300: { value: "#fca5a5" },
    400: { value: "#f87171" },
    500: { value: "#ef4444" },
    600: { value: "#dc2626" },
    700: { value: "#991919" },
    800: { value: "#511111" },
    900: { value: "#300c0c" },
    950: { value: "#1f0808" }
  },
  orange: {
    50: { value: "#fff7ed" },
    100: { value: "#ffedd5" },
    200: { value: "#fed7aa" },
    300: { value: "#fdba74" },
    400: { value: "#fb923c" },
    500: { value: "#f97316" },
    600: { value: "#ea580c" },
    700: { value: "#92310a" },
    800: { value: "#6c2710" },
    900: { value: "#3b1106" },
    950: { value: "#220a04" }
  },
  yellow: {
    50: { value: "#fefce8" },
    100: { value: "#fef9c3" },
    200: { value: "#fef08a" },
    300: { value: "#fde047" },
    400: { value: "#facc15" },
    500: { value: "#eab308" },
    600: { value: "#ca8a04" },
    700: { value: "#845209" },
    800: { value: "#713f12" },
    900: { value: "#422006" },
    950: { value: "#281304" }
  },
  green: {
    50: { value: "#f0fdf4" },
    100: { value: "#dcfce7" },
    200: { value: "#bbf7d0" },
    300: { value: "#86efac" },
    400: { value: "#4ade80" },
    500: { value: "#22c55e" },
    600: { value: "#16a34a" },
    700: { value: "#116932" },
    800: { value: "#124a28" },
    900: { value: "#042713" },
    950: { value: "#03190c" }
  },
  teal: {
    50: { value: "#f0fdfa" },
    100: { value: "#ccfbf1" },
    200: { value: "#99f6e4" },
    300: { value: "#5eead4" },
    400: { value: "#2dd4bf" },
    500: { value: "#14b8a6" },
    600: { value: "#0d9488" },
    700: { value: "#0c5d56" },
    800: { value: "#114240" },
    900: { value: "#032726" },
    950: { value: "#021716" }
  },
  blue: {
    50: { value: "#eff6ff" },
    100: { value: "#dbeafe" },
    200: { value: "#bfdbfe" },
    300: { value: "#a3cfff" },
    400: { value: "#60a5fa" },
    500: { value: "#3b82f6" },
    600: { value: "#2563eb" },
    700: { value: "#173da6" },
    800: { value: "#1a3478" },
    900: { value: "#14204a" },
    950: { value: "#0c142e" }
  },
  cyan: {
    50: { value: "#ecfeff" },
    100: { value: "#cffafe" },
    200: { value: "#a5f3fc" },
    300: { value: "#67e8f9" },
    400: { value: "#22d3ee" },
    500: { value: "#06b6d4" },
    600: { value: "#0891b2" },
    700: { value: "#0c5c72" },
    800: { value: "#134152" },
    900: { value: "#072a38" },
    950: { value: "#051b24" }
  },
  purple: {
    50: { value: "#faf5ff" },
    100: { value: "#f3e8ff" },
    200: { value: "#e9d5ff" },
    300: { value: "#d8b4fe" },
    400: { value: "#c084fc" },
    500: { value: "#a855f7" },
    600: { value: "#9333ea" },
    700: { value: "#641ba3" },
    800: { value: "#4a1772" },
    900: { value: "#2f0553" },
    950: { value: "#1a032e" }
  },
  pink: {
    50: { value: "#fdf2f8" },
    100: { value: "#fce7f3" },
    200: { value: "#fbcfe8" },
    300: { value: "#f9a8d4" },
    400: { value: "#f472b6" },
    500: { value: "#ec4899" },
    600: { value: "#db2777" },
    700: { value: "#a41752" },
    800: { value: "#6d0e34" },
    900: { value: "#45061f" },
    950: { value: "#2c0514" }
  }
}), YN = Ke.cursor({
  button: { value: "pointer" },
  checkbox: { value: "default" },
  disabled: { value: "not-allowed" },
  menuitem: { value: "default" },
  option: { value: "default" },
  radio: { value: "default" },
  slider: { value: "default" },
  switch: { value: "pointer" }
}), XN = Ke.durations({
  fastest: { value: "50ms" },
  faster: { value: "100ms" },
  fast: { value: "150ms" },
  moderate: { value: "200ms" },
  slow: { value: "300ms" },
  slower: { value: "400ms" },
  slowest: { value: "500ms" }
}), JN = Ke.easings({
  "ease-in": { value: "cubic-bezier(0.42, 0, 1, 1)" },
  "ease-out": { value: "cubic-bezier(0, 0, 0.58, 1)" },
  "ease-in-out": { value: "cubic-bezier(0.42, 0, 0.58, 1)" },
  "ease-in-smooth": { value: "cubic-bezier(0.32, 0.72, 0, 1)" }
}), ZN = Ke.fontSizes({
  "2xs": { value: "0.625rem" },
  xs: { value: "0.75rem" },
  sm: { value: "0.875rem" },
  md: { value: "1rem" },
  lg: { value: "1.125rem" },
  xl: { value: "1.25rem" },
  "2xl": { value: "1.5rem" },
  "3xl": { value: "1.875rem" },
  "4xl": { value: "2.25rem" },
  "5xl": { value: "3rem" },
  "6xl": { value: "3.75rem" },
  "7xl": { value: "4.5rem" },
  "8xl": { value: "6rem" },
  "9xl": { value: "8rem" }
}), QN = Ke.fontWeights({
  thin: { value: "100" },
  extralight: { value: "200" },
  light: { value: "300" },
  normal: { value: "400" },
  medium: { value: "500" },
  semibold: { value: "600" },
  bold: { value: "700" },
  extrabold: { value: "800" },
  black: { value: "900" }
}), Pp = '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"', eF = Ke.fonts({
  heading: {
    value: `Inter, ${Pp}`
  },
  body: {
    value: `Inter, ${Pp}`
  },
  mono: {
    value: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  }
}), tF = xR({
  spin: {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" }
  },
  pulse: {
    "50%": { opacity: "0.5" }
  },
  ping: {
    "75%, 100%": {
      transform: "scale(2)",
      opacity: "0"
    }
  },
  bounce: {
    "0%, 100%": {
      transform: "translateY(-25%)",
      animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
    },
    "50%": {
      transform: "none",
      animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
    }
  },
  "bg-position": {
    from: { backgroundPosition: "var(--animate-from, 1rem) 0" },
    to: { backgroundPosition: "var(--animate-to, 0) 0" }
  },
  position: {
    from: {
      insetInlineStart: "var(--animate-from-x)",
      insetBlockStart: "var(--animate-from-y)"
    },
    to: {
      insetInlineStart: "var(--animate-to-x)",
      insetBlockStart: "var(--animate-to-y)"
    }
  },
  "circular-progress": {
    "0%": {
      strokeDasharray: "1, 400",
      strokeDashoffset: "0"
    },
    "50%": {
      strokeDasharray: "400, 400",
      strokeDashoffset: "-100%"
    },
    "100%": {
      strokeDasharray: "400, 400",
      strokeDashoffset: "-260%"
    }
  },
  // collapse
  "expand-height": {
    from: { height: "0" },
    to: { height: "var(--height)" }
  },
  "collapse-height": {
    from: { height: "var(--height)" },
    to: { height: "0" }
  },
  "expand-width": {
    from: { width: "0" },
    to: { width: "var(--width)" }
  },
  "collapse-width": {
    from: { height: "var(--width)" },
    to: { height: "0" }
  },
  // fade
  "fade-in": {
    from: { opacity: 0 },
    to: { opacity: 1 }
  },
  "fade-out": {
    from: { opacity: 1 },
    to: { opacity: 0 }
  },
  // slide from (full)
  "slide-from-left-full": {
    from: { translate: "-100% 0" },
    to: { translate: "0 0" }
  },
  "slide-from-right-full": {
    from: { translate: "100% 0" },
    to: { translate: "0 0" }
  },
  "slide-from-top-full": {
    from: { translate: "0 -100%" },
    to: { translate: "0 0" }
  },
  "slide-from-bottom-full": {
    from: { translate: "0 100%" },
    to: { translate: "0 0" }
  },
  // slide to (full)
  "slide-to-left-full": {
    from: { translate: "0 0" },
    to: { translate: "-100% 0" }
  },
  "slide-to-right-full": {
    from: { translate: "0 0" },
    to: { translate: "100% 0" }
  },
  "slide-to-top-full": {
    from: { translate: "0 0" },
    to: { translate: "0 -100%" }
  },
  "slide-to-bottom-full": {
    from: { translate: "0 0" },
    to: { translate: "0 100%" }
  },
  // slide from
  "slide-from-top": {
    "0%": { translate: "0 -0.5rem" },
    to: { translate: "0" }
  },
  "slide-from-bottom": {
    "0%": { translate: "0 0.5rem" },
    to: { translate: "0" }
  },
  "slide-from-left": {
    "0%": { translate: "-0.5rem 0" },
    to: { translate: "0" }
  },
  "slide-from-right": {
    "0%": { translate: "0.5rem 0" },
    to: { translate: "0" }
  },
  // slide to
  "slide-to-top": {
    "0%": { translate: "0" },
    to: { translate: "0 -0.5rem" }
  },
  "slide-to-bottom": {
    "0%": { translate: "0" },
    to: { translate: "0 0.5rem" }
  },
  "slide-to-left": {
    "0%": { translate: "0" },
    to: { translate: "-0.5rem 0" }
  },
  "slide-to-right": {
    "0%": { translate: "0" },
    to: { translate: "0.5rem 0" }
  },
  // scale
  "scale-in": {
    from: { scale: "0.95" },
    to: { scale: "1" }
  },
  "scale-out": {
    from: { scale: "1" },
    to: { scale: "0.95" }
  }
}), rF = Ke.letterSpacings({
  tighter: { value: "-0.05em" },
  tight: { value: "-0.025em" },
  wide: { value: "0.025em" },
  wider: { value: "0.05em" },
  widest: { value: "0.1em" }
}), nF = Ke.lineHeights({
  shorter: { value: 1.25 },
  short: { value: 1.375 },
  moderate: { value: 1.5 },
  tall: { value: 1.625 },
  taller: { value: 2 }
}), iF = Ke.radii({
  none: { value: "0" },
  "2xs": { value: "0.0625rem" },
  xs: { value: "0.125rem" },
  sm: { value: "0.25rem" },
  md: { value: "0.375rem" },
  lg: { value: "0.5rem" },
  xl: { value: "0.75rem" },
  "2xl": { value: "1rem" },
  "3xl": { value: "1.5rem" },
  "4xl": { value: "2rem" },
  full: { value: "9999px" }
}), xx = Ke.spacing({
  0.5: { value: "0.125rem" },
  1: { value: "0.25rem" },
  1.5: { value: "0.375rem" },
  2: { value: "0.5rem" },
  2.5: { value: "0.625rem" },
  3: { value: "0.75rem" },
  3.5: { value: "0.875rem" },
  4: { value: "1rem" },
  4.5: { value: "1.125rem" },
  5: { value: "1.25rem" },
  6: { value: "1.5rem" },
  7: { value: "1.75rem" },
  8: { value: "2rem" },
  9: { value: "2.25rem" },
  10: { value: "2.5rem" },
  11: { value: "2.75rem" },
  12: { value: "3rem" },
  14: { value: "3.5rem" },
  16: { value: "4rem" },
  20: { value: "5rem" },
  24: { value: "6rem" },
  28: { value: "7rem" },
  32: { value: "8rem" },
  36: { value: "9rem" },
  40: { value: "10rem" },
  44: { value: "11rem" },
  48: { value: "12rem" },
  52: { value: "13rem" },
  56: { value: "14rem" },
  60: { value: "15rem" },
  64: { value: "16rem" },
  72: { value: "18rem" },
  80: { value: "20rem" },
  96: { value: "24rem" }
}), oF = Ke.sizes({
  "3xs": { value: "14rem" },
  "2xs": { value: "16rem" },
  xs: { value: "20rem" },
  sm: { value: "24rem" },
  md: { value: "28rem" },
  lg: { value: "32rem" },
  xl: { value: "36rem" },
  "2xl": { value: "42rem" },
  "3xl": { value: "48rem" },
  "4xl": { value: "56rem" },
  "5xl": { value: "64rem" },
  "6xl": { value: "72rem" },
  "7xl": { value: "80rem" },
  "8xl": { value: "90rem" }
}), sF = Ke.sizes({
  max: { value: "max-content" },
  min: { value: "min-content" },
  fit: { value: "fit-content" },
  prose: { value: "60ch" },
  full: { value: "100%" },
  dvh: { value: "100dvh" },
  svh: { value: "100svh" },
  lvh: { value: "100lvh" },
  dvw: { value: "100dvw" },
  svw: { value: "100svw" },
  lvw: { value: "100lvw" },
  vw: { value: "100vw" },
  vh: { value: "100vh" }
}), aF = Ke.sizes({
  "1/2": { value: "50%" },
  "1/3": { value: "33.333333%" },
  "2/3": { value: "66.666667%" },
  "1/4": { value: "25%" },
  "3/4": { value: "75%" },
  "1/5": { value: "20%" },
  "2/5": { value: "40%" },
  "3/5": { value: "60%" },
  "4/5": { value: "80%" },
  "1/6": { value: "16.666667%" },
  "2/6": { value: "33.333333%" },
  "3/6": { value: "50%" },
  "4/6": { value: "66.666667%" },
  "5/6": { value: "83.333333%" },
  "1/12": { value: "8.333333%" },
  "2/12": { value: "16.666667%" },
  "3/12": { value: "25%" },
  "4/12": { value: "33.333333%" },
  "5/12": { value: "41.666667%" },
  "6/12": { value: "50%" },
  "7/12": { value: "58.333333%" },
  "8/12": { value: "66.666667%" },
  "9/12": { value: "75%" },
  "10/12": { value: "83.333333%" },
  "11/12": { value: "91.666667%" }
}), lF = Ke.sizes({
  ...oF,
  ...xx,
  ...aF,
  ...sF
}), cF = Ke.zIndex({
  hide: { value: -1 },
  base: { value: 0 },
  docked: { value: 10 },
  dropdown: { value: 1e3 },
  sticky: { value: 1100 },
  banner: { value: 1200 },
  overlay: { value: 1300 },
  modal: { value: 1400 },
  popover: { value: 1500 },
  skipNav: { value: 1600 },
  toast: { value: 1700 },
  tooltip: { value: 1800 },
  max: { value: 2147483647 }
}), uF = Y0({
  preflight: !0,
  cssVarsPrefix: "chakra",
  cssVarsRoot: ":where(html, .chakra-theme)",
  globalCss: q2,
  theme: {
    breakpoints: G2,
    keyframes: tF,
    tokens: {
      aspectRatios: UN,
      animations: jN,
      blurs: GN,
      borders: qN,
      colors: KN,
      durations: XN,
      easings: JN,
      fonts: eF,
      fontSizes: ZN,
      fontWeights: QN,
      letterSpacings: rF,
      lineHeights: nF,
      radii: iF,
      spacing: xx,
      sizes: lF,
      zIndex: cF,
      cursor: YN
    },
    semanticTokens: {
      colors: hA,
      shadows: gA,
      radii: pA
    },
    recipes: fA,
    slotRecipes: WN,
    textStyles: HN,
    layerStyles: K2,
    animationStyles: Y2
  }
}), gu = X0(AR, uF);
vx(gu);
const _x = (e) => /* @__PURE__ */ b(
  qe.svg,
  {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...e,
    children: /* @__PURE__ */ b("path", { d: "M20 6 9 17l-5-5" })
  }
), dF = (e) => /* @__PURE__ */ b(
  qe.svg,
  {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...e,
    children: /* @__PURE__ */ b("path", { d: "m6 9 6 6 6-6" })
  }
), fF = (e) => /* @__PURE__ */ b(
  qe.svg,
  {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ b("path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11.0026 16L6.75999 11.7574L8.17421 10.3431L11.0026 13.1716L16.6595 7.51472L18.0737 8.92893L11.0026 16Z" })
  }
), Tp = (e) => /* @__PURE__ */ b(
  qe.svg,
  {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ b("path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z" })
  }
), wx = (e) => /* @__PURE__ */ b(qe.svg, { viewBox: "0 0 24 24", fill: "currentColor", ...e, children: /* @__PURE__ */ b(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z"
  }
) }), hF = (e) => /* @__PURE__ */ K(
  qe.svg,
  {
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...e,
    children: [
      /* @__PURE__ */ b("rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }),
      /* @__PURE__ */ b("path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" })
    ]
  }
), ra = (e) => e ? "" : void 0, pF = qe("div", {
  base: {
    display: "inline-flex",
    gap: "0.5rem",
    isolation: "isolate",
    position: "relative",
    "& [data-group-item]": {
      _focusVisible: {
        zIndex: 1
      }
    }
  },
  variants: {
    orientation: {
      horizontal: {
        flexDirection: "row"
      },
      vertical: {
        flexDirection: "column"
      }
    },
    attached: {
      true: {
        gap: "0!"
      }
    },
    grow: {
      true: {
        display: "flex",
        "& > *": {
          flex: 1
        }
      }
    },
    stacking: {
      "first-on-top": {
        "& > [data-group-item]": {
          zIndex: "calc(var(--group-count) - var(--group-index))"
        }
      },
      "last-on-top": {
        "& > [data-group-item]": {
          zIndex: "var(--group-index)"
        }
      }
    }
  },
  compoundVariants: [
    {
      orientation: "horizontal",
      attached: !0,
      css: {
        "& > *[data-first]": {
          borderEndRadius: "0!",
          marginEnd: "-1px"
        },
        "& > *[data-between]": {
          borderRadius: "0!",
          marginEnd: "-1px"
        },
        "& > *[data-last]": {
          borderStartRadius: "0!"
        }
      }
    },
    {
      orientation: "vertical",
      attached: !0,
      css: {
        "& > *[data-first]": {
          borderBottomRadius: "0!",
          marginBottom: "-1px"
        },
        "& > *[data-between]": {
          borderRadius: "0!",
          marginBottom: "-1px"
        },
        "& > *[data-last]": {
          borderTopRadius: "0!"
        }
      }
    }
  ],
  defaultVariants: {
    orientation: "horizontal"
  }
}), gF = Wv(
  Z(function(t, r) {
    const {
      align: n = "center",
      justify: i = "flex-start",
      children: o,
      wrap: s,
      skip: a,
      ...l
    } = t, c = _e(() => {
      let u = Ya.toArray(o).filter(td);
      if (u.length === 1) return u;
      const f = u.filter((p) => !(a != null && a(p))), d = f.length;
      return f.length === 1 ? u : u.map((p) => {
        var m;
        const g = p.props;
        if (a != null && a(p)) return p;
        const h = f.indexOf(p);
        return rd(p, {
          ...g,
          "data-group-item": "",
          "data-first": ra(h === 0),
          "data-last": ra(h === d - 1),
          "data-between": ra(h > 0 && h < d - 1),
          style: {
            "--group-count": d,
            "--group-index": h,
            ...(m = g == null ? void 0 : g.style) != null ? m : {}
          }
        });
      });
    }, [o, a]);
    return /* @__PURE__ */ b(
      pF,
      {
        ref: r,
        alignItems: n,
        justifyContent: i,
        flexWrap: s,
        ...l,
        className: Yt("chakra-group", t.className),
        children: c
      }
    );
  })
), { withContext: mF } = jn({
  key: "badge"
}), vF = mF("span"), Pe = qe("div");
Pe.displayName = "Box";
const bF = Z(
  function(t, r) {
    const { size: n, ...i } = t;
    return /* @__PURE__ */ b(
      Pe,
      {
        ...i,
        ref: r,
        boxSize: n,
        css: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          flexGrow: 0,
          ...t.css
        }
      }
    );
  }
), yF = Z(
  function(t, r) {
    const { size: n, ...i } = t;
    return /* @__PURE__ */ b(bF, { size: n, ref: r, borderRadius: "9999px", ...i });
  }
), bo = qe("span"), { withContext: xF } = jn({
  key: "spinner"
}), Oa = xF("span"), vl = qe("div", {
  base: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  variants: {
    axis: {
      horizontal: {
        insetStart: "50%",
        translate: "-50%",
        _rtl: {
          translate: "50%"
        }
      },
      vertical: {
        top: "50%",
        translate: "0 -50%"
      },
      both: {
        insetStart: "50%",
        top: "50%",
        translate: "-50% -50%",
        _rtl: {
          translate: "50% -50%"
        }
      }
    }
  },
  defaultVariants: {
    axis: "both"
  }
});
vl.displayName = "AbsoluteCenter";
const _F = ie.forwardRef(
  function(t, r) {
    const {
      spinner: n = /* @__PURE__ */ b(Oa, { size: "inherit", borderWidth: "0.125em", color: "inherit" }),
      spinnerPlacement: i = "start",
      children: o,
      text: s,
      visible: a = !0,
      ...l
    } = t;
    return a ? s ? /* @__PURE__ */ K(bo, { ref: r, display: "contents", ...l, children: [
      i === "start" && n,
      s,
      i === "end" && n
    ] }) : n ? /* @__PURE__ */ K(bo, { ref: r, display: "contents", ...l, children: [
      /* @__PURE__ */ b(vl, { display: "inline-flex", children: n }),
      /* @__PURE__ */ b(bo, { visibility: "hidden", display: "contents", children: o })
    ] }) : /* @__PURE__ */ b(bo, { ref: r, display: "contents", ...l, children: o }) : o;
  }
), { useRecipeResult: wF, usePropsContext: SF } = jn(
  { key: "button" }
), cn = Z(
  function(t, r) {
    const n = SF(), i = _e(
      () => Fo(n, t),
      [n, t]
    ), o = wF(i), {
      loading: s,
      loadingText: a,
      children: l,
      spinner: c,
      spinnerPlacement: u,
      ...f
    } = o.props;
    return /* @__PURE__ */ b(
      qe.button,
      {
        type: "button",
        ref: r,
        ...f,
        "data-loading": ra(s),
        disabled: s || f.disabled,
        className: Yt(o.className, i.className),
        css: [o.styles, i.css],
        children: !i.asChild && s ? /* @__PURE__ */ b(
          _F,
          {
            spinner: c,
            text: a,
            spinnerPlacement: u,
            children: l
          }
        ) : l
      }
    );
  }
), Yd = Z(
  function(t, r) {
    return /* @__PURE__ */ b(
      cn,
      {
        px: "0",
        py: "0",
        _icon: { fontSize: "1.2em" },
        ref: r,
        ...t
      }
    );
  }
), bl = qe("div", {
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  variants: {
    inline: {
      true: {
        display: "inline-flex"
      }
    }
  }
});
bl.displayName = "Center";
const {
  withProvider: Sx,
  withContext: Hi
} = Li({ key: "clipboard" });
Sx(uy, "root", { forwardAsChild: !0 });
const EF = Sx(
  cy,
  "root",
  { forwardAsChild: !0 }
), Xd = Hi(dy, "trigger", { forwardAsChild: !0 });
Hi(oy, "control", { forwardAsChild: !0 });
const Jd = Hi(sy, "indicator", {
  forwardAsChild: !0,
  defaultProps: {
    copied: /* @__PURE__ */ b(_x, { boxSize: "1em" }),
    children: /* @__PURE__ */ b(hF, { boxSize: "1em" })
  }
}), CF = Hi(ay, "input", { forwardAsChild: !0 }), kF = Hi(ly, "label", { forwardAsChild: !0 });
Hi(fy, "valueText", { forwardAsChild: !0 });
Z(function(t, r) {
  return /* @__PURE__ */ b(Jd, { copied: "Copied", ...t, ref: r, children: "Copy" });
});
function IF(e) {
  const { gap: t, direction: r } = e, n = {
    column: {
      marginY: t,
      marginX: 0,
      borderInlineStartWidth: 0,
      borderTopWidth: "1px"
    },
    "column-reverse": {
      marginY: t,
      marginX: 0,
      borderInlineStartWidth: 0,
      borderTopWidth: "1px"
    },
    row: {
      marginX: t,
      marginY: 0,
      borderInlineStartWidth: "1px",
      borderTopWidth: 0
    },
    "row-reverse": {
      marginX: t,
      marginY: 0,
      borderInlineStartWidth: "1px",
      borderTopWidth: 0
    }
  };
  return {
    "&": Z0(r, (i) => n[i])
  };
}
function OF(e) {
  return Ya.toArray(e).filter(
    (t) => td(t)
  );
}
const ls = Z(
  function(t, r) {
    const {
      direction: n = "column",
      align: i,
      justify: o,
      gap: s = "0.5rem",
      wrap: a,
      children: l,
      separator: c,
      className: u,
      ...f
    } = t, d = _e(
      () => IF({ gap: s, direction: n }),
      [s, n]
    ), p = _e(() => c ? OF(l).map((g, h, m) => {
      const v = typeof g.key != "undefined" ? g.key : h, y = rd(c, {
        css: [d, c.props.css]
      });
      return /* @__PURE__ */ K(eS, { children: [
        g,
        h === m.length - 1 ? null : y
      ] }, v);
    }) : l, [l, c, d]);
    return /* @__PURE__ */ b(
      qe.div,
      {
        ref: r,
        display: "flex",
        alignItems: i,
        justifyContent: o,
        flexDirection: n,
        flexWrap: a,
        gap: c ? void 0 : s,
        className: Yt("chakra-stack", u),
        ...f,
        children: p
      }
    );
  }
), ge = Z(
  function(t, r) {
    const {
      direction: n,
      align: i,
      justify: o,
      wrap: s,
      basis: a,
      grow: l,
      shrink: c,
      inline: u,
      ...f
    } = t;
    return /* @__PURE__ */ b(
      qe.div,
      {
        ref: r,
        ...f,
        css: {
          display: u ? "inline-flex" : "flex",
          flexDirection: n,
          alignItems: i,
          justifyContent: o,
          flexWrap: s,
          flexBasis: a,
          flexGrow: l,
          flexShrink: c,
          ...t.css
        }
      }
    );
  }
), { withContext: PF } = jn({
  key: "input"
}), Zd = PF(yy), Rp = qe("div", {
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    zIndex: 2,
    color: "fg.muted",
    height: "full",
    fontSize: "sm",
    px: "3"
  },
  variants: {
    placement: {
      start: {
        insetInlineStart: "0"
      },
      end: {
        insetInlineEnd: "0"
      }
    }
  }
}), { withContext: TF } = jn({
  key: "link"
}), mu = TF("a"), {
  withRootProvider: Ex,
  withContext: Ht
} = Li({ key: "popover" });
Ex(
  fT
);
const RF = Ex(dT), AF = Ht(Yy, "trigger", { forwardAsChild: !0 }), NF = Ht(Hy, "positioner", { forwardAsChild: !0 }), FF = Ht(
  My,
  "content",
  { forwardAsChild: !0 }
), Cx = Ht(zy, "arrowTip", { forwardAsChild: !0 }), $F = Ht(
  Vy,
  "arrow",
  {
    forwardAsChild: !0,
    defaultProps: { children: /* @__PURE__ */ b(Cx, {}) }
  }
), LF = Ht(Dy, "closeTrigger", { forwardAsChild: !0 });
Ht(Wy, "indicator", { forwardAsChild: !0 });
Ht(
  Ky,
  "title",
  { forwardAsChild: !0 }
);
Ht(By, "description", { forwardAsChild: !0 });
Ht(
  "footer",
  "footer"
);
Ht(
  "header",
  "header"
);
const VF = Ht(
  "div",
  "body"
);
Ht(
  Ly,
  void 0,
  { forwardAsChild: !0 }
);
const {
  withProvider: kx,
  withContext: cs
} = Li({ key: "progressCircle" });
kx(r0, "root", { forwardAsChild: !0 });
const zF = kx(t0, "root", { forwardAsChild: !0 });
cs(e0, "label", { forwardAsChild: !0 });
const DF = cs(Jy, "circle", { forwardAsChild: !0 }), MF = cs(Qy, "circleTrack", { forwardAsChild: !0 }), BF = cs(Zy, "circleRange", { forwardAsChild: !0 }), WF = cs(n0, "valueText", { forwardAsChild: !0 }), {
  withProvider: Ix,
  withContext: Rt
} = Li({ key: "select" });
Ix(UT, "root", {
  forwardAsChild: !0
});
const HF = Ix(
  HT,
  "root",
  {
    forwardAsChild: !0,
    defaultProps: { positioning: { sameWidth: !0 } }
  }
), jF = Rt(
  C0,
  "trigger",
  { forwardAsChild: !0 }
), Ox = Rt(x0, "positioner", { forwardAsChild: !0 }), Px = Rt(
  c0,
  "content",
  { forwardAsChild: !0 }
), UF = Rt(k0, "valueText", { forwardAsChild: !0 }), GF = Rt(l0, "clearTrigger", {
  forwardAsChild: !0,
  defaultProps: { children: /* @__PURE__ */ b(wx, { boxSize: "1em" }) }
}), qF = Rt(g0, "itemGroup", { forwardAsChild: !0 }), KF = Rt(m0, "itemGroupLabel", { forwardAsChild: !0 }), YF = Rt(
  p0,
  "item",
  { forwardAsChild: !0 }
);
Rt(
  b0,
  "itemText",
  { forwardAsChild: !0 }
);
const XF = Rt(v0, "itemIndicator", {
  forwardAsChild: !0,
  defaultProps: {
    children: /* @__PURE__ */ b(_x, {})
  }
}), Tx = Rt("div", "indicatorGroup"), Rx = Rt(f0, "indicator", {
  forwardAsChild: !0,
  defaultProps: {
    children: /* @__PURE__ */ b(dF, {})
  }
}), Ax = Rt(
  u0,
  "control",
  { forwardAsChild: !0 }
);
Rt(
  y0,
  "label",
  { forwardAsChild: !0 }
);
const JF = OT, ZF = d0, { withContext: QF } = jn({
  key: "skeleton"
}), vr = QF("div");
ie.forwardRef(function(t, r) {
  const { size: n, ...i } = t;
  return /* @__PURE__ */ b(yF, { size: n, asChild: !0, ref: r, children: /* @__PURE__ */ b(vr, { ...i }) });
});
ie.forwardRef(
  function(t, r) {
    const { noOfLines: n = 3, gap: i, rootProps: o, ...s } = t;
    return /* @__PURE__ */ b(ls, { gap: i, width: "full", ref: r, ...o, children: Array.from({ length: n }).map((a, l) => /* @__PURE__ */ b(
      vr,
      {
        height: "4",
        _last: { maxW: n === 1 ? "100%" : "80%" },
        ...s
      },
      l
    )) });
  }
);
const Nx = Z(
  function(t, r) {
    return /* @__PURE__ */ b(ls, { align: "center", ...t, direction: "row", ref: r });
  }
), Pa = Z(
  function(t, r) {
    return /* @__PURE__ */ b(ls, { align: "center", ...t, direction: "column", ref: r });
  }
), {
  withProvider: e$,
  withContext: yl,
  useStyles: t$
} = Li({ key: "toast" }), r$ = qe(
  $0,
  {},
  { forwardAsChild: !0 }
), n$ = e$(
  N0,
  "root",
  { forwardAsChild: !0 }
), i$ = yl(R0, "closeTrigger", {
  forwardAsChild: !0,
  defaultProps: {
    children: /* @__PURE__ */ b(wx, {})
  }
}), o$ = yl(
  F0,
  "title",
  { forwardAsChild: !0 }
), s$ = yl(A0, "description", { forwardAsChild: !0 }), a$ = yl(T0, "actionTrigger", { forwardAsChild: !0 }), l$ = {
  warning: Tp,
  success: fF,
  error: Tp
}, c$ = Z(
  function(t, r) {
    const n = Bi(), i = t$(), o = l$[n.type];
    return o ? /* @__PURE__ */ b(o, { ref: r, ...t, css: [i.indicator, t.css] }) : null;
  }
), {
  withRootProvider: Fx,
  withContext: us
} = Li({ key: "tooltip" });
Fx(
  vR
);
const u$ = Fx(mR, {
  defaultProps: { lazyMount: !0, unmountOnExit: !0 }
}), d$ = us(U0, "trigger", { forwardAsChild: !0 }), f$ = us(B0, "positioner", { forwardAsChild: !0 }), h$ = us(
  M0,
  "content",
  { forwardAsChild: !0 }
), $x = us(D0, "arrowTip", { forwardAsChild: !0 }), p$ = us(
  z0,
  "arrow",
  { forwardAsChild: !0, defaultProps: { children: /* @__PURE__ */ b($x, {}) } }
), { withContext: g$ } = jn({
  key: "text"
}), Le = g$("p");
var A = typeof window != "undefined" ? window : void 0, kt = typeof globalThis != "undefined" ? globalThis : A, Lx = Array.prototype, Ap = Lx.forEach, Np = Lx.indexOf, Vt = kt == null ? void 0 : kt.navigator, te = kt == null ? void 0 : kt.document, wt = kt == null ? void 0 : kt.location, vu = kt == null ? void 0 : kt.fetch, bu = kt != null && kt.XMLHttpRequest && "withCredentials" in new kt.XMLHttpRequest() ? kt.XMLHttpRequest : void 0, Fp = kt == null ? void 0 : kt.AbortController, _t = Vt == null ? void 0 : Vt.userAgent, pe = A != null ? A : {}, Dr = { DEBUG: !1, LIB_VERSION: "1.249.4" }, lc = "$copy_autocapture", m$ = ["$snapshot", "$pageview", "$pageleave", "$set", "survey dismissed", "survey sent", "survey shown", "$identify", "$groupidentify", "$create_alias", "$$client_ingestion_warning", "$web_experiment_applied", "$feature_enrollment_update", "$feature_flag_called"], Mr = function(e) {
  return e.GZipJS = "gzip-js", e.Base64 = "base64", e;
}({}), v$ = ["fatal", "error", "warning", "log", "info", "debug"];
function ve(e, t) {
  return e.indexOf(t) !== -1;
}
var xl = function(e) {
  return e.trim();
}, yu = function(e) {
  return e.replace(/^\$/, "");
}, b$ = Array.isArray, Vx = Object.prototype, zx = Vx.hasOwnProperty, _l = Vx.toString, Fe = b$ || function(e) {
  return _l.call(e) === "[object Array]";
}, Xt = (e) => typeof e == "function", De = (e) => e === Object(e) && !Fe(e), pi = (e) => {
  if (De(e)) {
    for (var t in e) if (zx.call(e, t)) return !1;
    return !0;
  }
  return !1;
}, J = (e) => e === void 0, Me = (e) => _l.call(e) == "[object String]", xu = (e) => Me(e) && e.trim().length === 0, xn = (e) => e === null, xe = (e) => J(e) || xn(e), pt = (e) => _l.call(e) == "[object Number]", br = (e) => _l.call(e) === "[object Boolean]", y$ = (e) => e instanceof FormData, x$ = (e) => ve(m$, e), Dx = (e) => {
  var t = { t: function(r) {
    if (A && (Dr.DEBUG || pe.POSTHOG_DEBUG) && !J(A.console) && A.console) {
      for (var n = ("__rrweb_original__" in A.console[r]) ? A.console[r].__rrweb_original__ : A.console[r], i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++) o[s - 1] = arguments[s];
      n(e, ...o);
    }
  }, info: function() {
    for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];
    t.t("log", ...n);
  }, warn: function() {
    for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];
    t.t("warn", ...n);
  }, error: function() {
    for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];
    t.t("error", ...n);
  }, critical: function() {
    for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++) n[i] = arguments[i];
    console.error(e, ...n);
  }, uninitializedWarning: (r) => {
    t.error("You must initialize PostHog before calling " + r);
  }, createLogger: (r) => Dx(e + " " + r) };
  return t;
}, re = Dx("[PostHog.js]"), ut = re.createLogger, _$ = ut("[ExternalScriptsLoader]"), $p = (e, t, r) => {
  if (e.config.disable_external_dependency_loading) return _$.warn(t + " was requested but loading of external scripts is disabled."), r("Loading of external scripts is disabled");
  var n = te == null ? void 0 : te.querySelectorAll("script");
  if (n) {
    for (var i = 0; i < n.length; i++) if (n[i].src === t) return r();
  }
  var o = () => {
    if (!te) return r("document not found");
    var s = te.createElement("script");
    if (s.type = "text/javascript", s.crossOrigin = "anonymous", s.src = t, s.onload = (c) => r(void 0, c), s.onerror = (c) => r(c), e.config.prepare_external_dependency_script && (s = e.config.prepare_external_dependency_script(s)), !s) return r("prepare_external_dependency_script returned null");
    var a, l = te.querySelectorAll("body > script");
    l.length > 0 ? (a = l[0].parentNode) == null || a.insertBefore(s, l[0]) : te.body.appendChild(s);
  };
  te != null && te.body ? o() : te == null || te.addEventListener("DOMContentLoaded", o);
};
function ee() {
  return ee = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ee.apply(null, arguments);
}
function Mx(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
pe.__PosthogExtensions__ = pe.__PosthogExtensions__ || {}, pe.__PosthogExtensions__.loadExternalDependency = (e, t, r) => {
  var n = "/static/" + t + ".js?v=" + e.version;
  if (t === "remote-config" && (n = "/array/" + e.config.token + "/config.js"), t === "toolbar") {
    var i = 3e5;
    n = n + "&t=" + Math.floor(Date.now() / i) * i;
  }
  var o = e.requestRouter.endpointFor("assets", n);
  $p(e, o, r);
}, pe.__PosthogExtensions__.loadSiteApp = (e, t, r) => {
  var n = e.requestRouter.endpointFor("api", t);
  $p(e, n, r);
};
var Ta = {};
function un(e, t, r) {
  if (Fe(e)) {
    if (Ap && e.forEach === Ap) e.forEach(t, r);
    else if ("length" in e && e.length === +e.length) {
      for (var n = 0, i = e.length; n < i; n++) if (n in e && t.call(r, e[n], n) === Ta) return;
    }
  }
}
function Oe(e, t, r) {
  if (!xe(e)) {
    if (Fe(e)) return un(e, t, r);
    if (y$(e)) {
      for (var n of e.entries()) if (t.call(r, n[1], n[0]) === Ta) return;
    } else for (var i in e) if (zx.call(e, i) && t.call(r, e[i], i) === Ta) return;
  }
}
var Ue = function(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
  return un(r, function(i) {
    for (var o in i) i[o] !== void 0 && (e[o] = i[o]);
  }), e;
}, wl = function(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
  return un(r, function(i) {
    un(i, function(o) {
      e.push(o);
    });
  }), e;
};
function na(e) {
  for (var t = Object.keys(e), r = t.length, n = new Array(r); r--; ) n[r] = [t[r], e[t[r]]];
  return n;
}
var Lp = function(e) {
  try {
    return e();
  } catch (t) {
    return;
  }
}, w$ = function(e) {
  return function() {
    try {
      for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
      return e.apply(this, r);
    } catch (i) {
      re.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), re.critical(i);
    }
  };
}, Qd = function(e) {
  var t = {};
  return Oe(e, function(r, n) {
    (Me(r) && r.length > 0 || pt(r)) && (t[n] = r);
  }), t;
};
function S$(e, t) {
  return r = e, n = (o) => Me(o) && !xn(t) ? o.slice(0, t) : o, i = /* @__PURE__ */ new Set(), function o(s, a) {
    return s !== Object(s) ? n ? n(s, a) : s : i.has(s) ? void 0 : (i.add(s), Fe(s) ? (l = [], un(s, (c) => {
      l.push(o(c));
    })) : (l = {}, Oe(s, (c, u) => {
      i.has(c) || (l[u] = o(c, u));
    })), l);
    var l;
  }(r);
  var r, n, i;
}
var E$ = ["herokuapp.com", "vercel.app", "netlify.app"];
function C$(e) {
  var t = e == null ? void 0 : e.hostname;
  if (!Me(t)) return !1;
  var r = t.split(".").slice(-2).join(".");
  for (var n of E$) if (r === n) return !1;
  return !0;
}
function Bx(e, t) {
  for (var r = 0; r < e.length; r++) if (t(e[r])) return e[r];
}
function Ve(e, t, r, n) {
  var { capture: i = !1, passive: o = !0 } = n != null ? n : {};
  e == null || e.addEventListener(t, r, { capture: i, passive: o });
}
var Wx = "$people_distinct_id", yo = "__alias", xo = "__timers", Vp = "$autocapture_disabled_server_side", _u = "$heatmaps_enabled_server_side", zp = "$exception_capture_enabled_server_side", wu = "$error_tracking_suppression_rules", Dp = "$web_vitals_enabled_server_side", Hx = "$dead_clicks_enabled_server_side", Mp = "$web_vitals_allowed_metrics", Su = "$session_recording_enabled_server_side", Bp = "$console_log_recording_enabled_server_side", Wp = "$session_recording_network_payload_capture", Hp = "$session_recording_masking", jp = "$session_recording_canvas_recording", Up = "$replay_sample_rate", Gp = "$replay_minimum_duration", qp = "$replay_script_config", Ra = "$sesid", _o = "$session_is_sampled", Eu = "$session_recording_url_trigger_activated_session", Cu = "$session_recording_event_trigger_activated_session", gi = "$enabled_feature_flags", ia = "$early_access_features", ku = "$feature_flag_details", wo = "$stored_person_properties", Pn = "$stored_group_properties", Iu = "$surveys", Is = "$surveys_activated", Aa = "$flag_call_reported", Vr = "$user_state", Ou = "$client_session_props", Pu = "$capture_rate_limit", Tu = "$initial_campaign_params", Ru = "$initial_referrer_info", Na = "$initial_person_info", Fa = "$epp", jx = "__POSTHOG_TOOLBAR__", Kp = "$posthog_cookieless", k$ = [Wx, yo, "__cmpns", xo, Su, _u, Ra, gi, wu, Vr, ia, ku, Pn, wo, Iu, Aa, Ou, Pu, Tu, Ru, Fa, Na];
function Yp(e) {
  return e instanceof Element && (e.id === jx || !(e.closest == null || !e.closest(".toolbar-global-fade-container")));
}
function Sl(e) {
  return !!e && e.nodeType === 1;
}
function dn(e, t) {
  return !!e && !!e.tagName && e.tagName.toLowerCase() === t.toLowerCase();
}
function Ux(e) {
  return !!e && e.nodeType === 3;
}
function Gx(e) {
  return !!e && e.nodeType === 11;
}
function ef(e) {
  return e ? xl(e).split(/\s+/) : [];
}
function Xp(e) {
  var t = A == null ? void 0 : A.location.href;
  return !!(t && e && e.some((r) => t.match(r)));
}
function $a(e) {
  var t = "";
  switch (typeof e.className) {
    case "string":
      t = e.className;
      break;
    case "object":
      t = (e.className && "baseVal" in e.className ? e.className.baseVal : null) || e.getAttribute("class") || "";
      break;
    default:
      t = "";
  }
  return ef(t);
}
function qx(e) {
  return xe(e) ? null : xl(e).split(/(\s+)/).filter((t) => ki(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function El(e) {
  var t = "";
  return Nu(e) && !Xx(e) && e.childNodes && e.childNodes.length && Oe(e.childNodes, function(r) {
    var n;
    Ux(r) && r.textContent && (t += (n = qx(r.textContent)) !== null && n !== void 0 ? n : "");
  }), xl(t);
}
function Kx(e) {
  return J(e.target) ? e.srcElement || null : (t = e.target) != null && t.shadowRoot ? e.composedPath()[0] || null : e.target || null;
  var t;
}
var Au = ["a", "button", "form", "input", "select", "textarea", "label"];
function Yx(e) {
  var t = e.parentNode;
  return !(!t || !Sl(t)) && t;
}
function I$(e, t, r, n, i) {
  var o, s, a;
  if (r === void 0 && (r = void 0), !A || !e || dn(e, "html") || !Sl(e) || (o = r) != null && o.url_allowlist && !Xp(r.url_allowlist) || (s = r) != null && s.url_ignorelist && Xp(r.url_ignorelist)) return !1;
  if ((a = r) != null && a.dom_event_allowlist) {
    var l = r.dom_event_allowlist;
    if (l && !l.some((m) => t.type === m)) return !1;
  }
  for (var c = !1, u = [e], f = !0, d = e; d.parentNode && !dn(d, "body"); ) if (Gx(d.parentNode)) u.push(d.parentNode.host), d = d.parentNode.host;
  else {
    if (!(f = Yx(d))) break;
    if (n || Au.indexOf(f.tagName.toLowerCase()) > -1) c = !0;
    else {
      var p = A.getComputedStyle(f);
      p && p.getPropertyValue("cursor") === "pointer" && (c = !0);
    }
    u.push(f), d = f;
  }
  if (!function(m, v) {
    var y = v == null ? void 0 : v.element_allowlist;
    if (J(y)) return !0;
    var x, S = function(I) {
      if (y.some((O) => I.tagName.toLowerCase() === O)) return { v: !0 };
    };
    for (var _ of m) if (x = S(_)) return x.v;
    return !1;
  }(u, r) || !function(m, v) {
    var y = v == null ? void 0 : v.css_selector_allowlist;
    if (J(y)) return !0;
    var x, S = function(I) {
      if (y.some((O) => I.matches(O))) return { v: !0 };
    };
    for (var _ of m) if (x = S(_)) return x.v;
    return !1;
  }(u, r)) return !1;
  var g = A.getComputedStyle(e);
  if (g && g.getPropertyValue("cursor") === "pointer" && t.type === "click") return !0;
  var h = e.tagName.toLowerCase();
  switch (h) {
    case "html":
      return !1;
    case "form":
      return (i || ["submit"]).indexOf(t.type) >= 0;
    case "input":
    case "select":
    case "textarea":
      return (i || ["change", "click"]).indexOf(t.type) >= 0;
    default:
      return c ? (i || ["click"]).indexOf(t.type) >= 0 : (i || ["click"]).indexOf(t.type) >= 0 && (Au.indexOf(h) > -1 || e.getAttribute("contenteditable") === "true");
  }
}
function Nu(e) {
  for (var t = e; t.parentNode && !dn(t, "body"); t = t.parentNode) {
    var r = $a(t);
    if (ve(r, "ph-sensitive") || ve(r, "ph-no-capture")) return !1;
  }
  if (ve($a(e), "ph-include")) return !0;
  var n = e.type || "";
  if (Me(n)) switch (n.toLowerCase()) {
    case "hidden":
    case "password":
      return !1;
  }
  var i = e.name || e.id || "";
  return !(Me(i) && /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(i.replace(/[^a-zA-Z0-9]/g, "")));
}
function Xx(e) {
  return !!(dn(e, "input") && !["button", "checkbox", "submit", "reset"].includes(e.type) || dn(e, "select") || dn(e, "textarea") || e.getAttribute("contenteditable") === "true");
}
var Jx = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", O$ = new RegExp("^(?:" + Jx + ")$"), P$ = new RegExp(Jx), Zx = "\\d{3}-?\\d{2}-?\\d{4}", T$ = new RegExp("^(" + Zx + ")$"), R$ = new RegExp("(" + Zx + ")");
function ki(e, t) {
  return t === void 0 && (t = !0), !(xe(e) || Me(e) && (e = xl(e), (t ? O$ : P$).test((e || "").replace(/[- ]/g, "")) || (t ? T$ : R$).test(e)));
}
function Qx(e) {
  var t = El(e);
  return ki(t = (t + " " + e_(e)).trim()) ? t : "";
}
function e_(e) {
  var t = "";
  return e && e.childNodes && e.childNodes.length && Oe(e.childNodes, function(r) {
    var n;
    if (r && ((n = r.tagName) == null ? void 0 : n.toLowerCase()) === "span") try {
      var i = El(r);
      t = (t + " " + i).trim(), r.childNodes && r.childNodes.length && (t = (t + " " + e_(r)).trim());
    } catch (o) {
      re.error("[AutoCapture]", o);
    }
  }), t;
}
function A$(e) {
  return function(t) {
    var r = t.map((n) => {
      var i, o, s = "";
      if (n.tag_name && (s += n.tag_name), n.attr_class) for (var a of (n.attr_class.sort(), n.attr_class)) s += "." + a.replace(/"/g, "");
      var l = ee({}, n.text ? { text: n.text } : {}, { "nth-child": (i = n.nth_child) !== null && i !== void 0 ? i : 0, "nth-of-type": (o = n.nth_of_type) !== null && o !== void 0 ? o : 0 }, n.href ? { href: n.href } : {}, n.attr_id ? { attr_id: n.attr_id } : {}, n.attributes), c = {};
      return na(l).sort((u, f) => {
        var [d] = u, [p] = f;
        return d.localeCompare(p);
      }).forEach((u) => {
        var [f, d] = u;
        return c[Jp(f.toString())] = Jp(d.toString());
      }), s += ":", s += na(c).map((u) => {
        var [f, d] = u;
        return f + '="' + d + '"';
      }).join("");
    });
    return r.join(";");
  }(function(t) {
    return t.map((r) => {
      var n, i, o = { text: (n = r.$el_text) == null ? void 0 : n.slice(0, 400), tag_name: r.tag_name, href: (i = r.attr__href) == null ? void 0 : i.slice(0, 2048), attr_class: N$(r), attr_id: r.attr__id, nth_child: r.nth_child, nth_of_type: r.nth_of_type, attributes: {} };
      return na(r).filter((s) => {
        var [a] = s;
        return a.indexOf("attr__") === 0;
      }).forEach((s) => {
        var [a, l] = s;
        return o.attributes[a] = l;
      }), o;
    });
  }(e));
}
function Jp(e) {
  return e.replace(/"|\\"/g, '\\"');
}
function N$(e) {
  var t = e.attr__class;
  return t ? Fe(t) ? t : ef(t) : void 0;
}
class t_ {
  constructor() {
    this.clicks = [];
  }
  isRageClick(t, r, n) {
    var i = this.clicks[this.clicks.length - 1];
    if (i && Math.abs(t - i.x) + Math.abs(r - i.y) < 30 && n - i.timestamp < 1e3) {
      if (this.clicks.push({ x: t, y: r, timestamp: n }), this.clicks.length === 3) return !0;
    } else this.clicks = [{ x: t, y: r, timestamp: n }];
    return !1;
  }
}
var F$ = ["localhost", "127.0.0.1"], Ii = (e) => {
  var t = te == null ? void 0 : te.createElement("a");
  return J(t) ? null : (t.href = e, t);
}, $$ = function(e, t) {
  var r, n;
  t === void 0 && (t = "&");
  var i = [];
  return Oe(e, function(o, s) {
    J(o) || J(s) || s === "undefined" || (r = encodeURIComponent(((a) => a instanceof File)(o) ? o.name : o.toString()), n = encodeURIComponent(s), i[i.length] = n + "=" + r);
  }), i.join(t);
}, La = function(e, t) {
  for (var r, n = ((e.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), i = 0; i < n.length; i++) {
    var o = n[i].split("=");
    if (o[0] === t) {
      r = o;
      break;
    }
  }
  if (!Fe(r) || r.length < 2) return "";
  var s = r[1];
  try {
    s = decodeURIComponent(s);
  } catch (a) {
    re.error("Skipping decoding for malformed query param: " + s);
  }
  return s.replace(/\+/g, " ");
}, tf = function(e, t, r) {
  if (!e || !t || !t.length) return e;
  for (var n = e.split("#"), i = n[0] || "", o = n[1], s = i.split("?"), a = s[1], l = s[0], c = (a || "").split("&"), u = [], f = 0; f < c.length; f++) {
    var d = c[f].split("=");
    Fe(d) && (t.includes(d[0]) ? u.push(d[0] + "=" + r) : u.push(c[f]));
  }
  var p = l;
  return a != null && (p += "?" + u.join("&")), o != null && (p += "#" + o), p;
}, Va = function(e, t) {
  var r = e.match(new RegExp(t + "=([^&]*)"));
  return r ? r[1] : null;
}, Zp = ut("[AutoCapture]");
function cc(e, t) {
  return t.length > e ? t.slice(0, e) + "..." : t;
}
function L$(e) {
  if (e.previousElementSibling) return e.previousElementSibling;
  var t = e;
  do
    t = t.previousSibling;
  while (t && !Sl(t));
  return t;
}
function V$(e, t, r, n) {
  var i = e.tagName.toLowerCase(), o = { tag_name: i };
  Au.indexOf(i) > -1 && !r && (i.toLowerCase() === "a" || i.toLowerCase() === "button" ? o.$el_text = cc(1024, Qx(e)) : o.$el_text = cc(1024, El(e)));
  var s = $a(e);
  s.length > 0 && (o.classes = s.filter(function(u) {
    return u !== "";
  })), Oe(e.attributes, function(u) {
    var f;
    if ((!Xx(e) || ["name", "id", "class", "aria-label"].indexOf(u.name) !== -1) && (n == null || !n.includes(u.name)) && !t && ki(u.value) && (f = u.name, !Me(f) || f.substring(0, 10) !== "_ngcontent" && f.substring(0, 7) !== "_nghost")) {
      var d = u.value;
      u.name === "class" && (d = ef(d).join(" ")), o["attr__" + u.name] = cc(1024, d);
    }
  });
  for (var a = 1, l = 1, c = e; c = L$(c); ) a++, c.tagName === e.tagName && l++;
  return o.nth_child = a, o.nth_of_type = l, o;
}
function z$(e, t) {
  for (var r, n, { e: i, maskAllElementAttributes: o, maskAllText: s, elementAttributeIgnoreList: a, elementsChainAsString: l } = t, c = [e], u = e; u.parentNode && !dn(u, "body"); ) Gx(u.parentNode) ? (c.push(u.parentNode.host), u = u.parentNode.host) : (c.push(u.parentNode), u = u.parentNode);
  var f, d = [], p = {}, g = !1, h = !1;
  if (Oe(c, (S) => {
    var _ = Nu(S);
    S.tagName.toLowerCase() === "a" && (g = S.getAttribute("href"), g = _ && g && ki(g) && g), ve($a(S), "ph-no-capture") && (h = !0), d.push(V$(S, o, s, a));
    var I = function(O) {
      if (!Nu(O)) return {};
      var w = {};
      return Oe(O.attributes, function(E) {
        if (E.name && E.name.indexOf("data-ph-capture-attribute") === 0) {
          var T = E.name.replace("data-ph-capture-attribute-", ""), G = E.value;
          T && G && ki(G) && (w[T] = G);
        }
      }), w;
    }(S);
    Ue(p, I);
  }), h) return { props: {}, explicitNoCapture: h };
  if (s || (e.tagName.toLowerCase() === "a" || e.tagName.toLowerCase() === "button" ? d[0].$el_text = Qx(e) : d[0].$el_text = El(e)), g) {
    var m, v;
    d[0].attr__href = g;
    var y = (m = Ii(g)) == null ? void 0 : m.host, x = A == null || (v = A.location) == null ? void 0 : v.host;
    y && x && y !== x && (f = g);
  }
  return { props: Ue({ $event_type: i.type, $ce_version: 1 }, l ? {} : { $elements: d }, { $elements_chain: A$(d) }, (r = d[0]) != null && r.$el_text ? { $el_text: (n = d[0]) == null ? void 0 : n.$el_text } : {}, f && i.type === "click" ? { $external_click_url: f } : {}, p) };
}
class D$ {
  constructor(t) {
    this.i = !1, this.o = null, this.rageclicks = new t_(), this.h = !1, this.instance = t, this.m = null;
  }
  get S() {
    var t, r, n = De(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
    return n.url_allowlist = (t = n.url_allowlist) == null ? void 0 : t.map((i) => new RegExp(i)), n.url_ignorelist = (r = n.url_ignorelist) == null ? void 0 : r.map((i) => new RegExp(i)), n;
  }
  $() {
    if (this.isBrowserSupported()) {
      if (A && te) {
        var t = (n) => {
          n = n || (A == null ? void 0 : A.event);
          try {
            this.k(n);
          } catch (i) {
            Zp.error("Failed to capture event", i);
          }
        };
        if (Ve(te, "submit", t, { capture: !0 }), Ve(te, "change", t, { capture: !0 }), Ve(te, "click", t, { capture: !0 }), this.S.capture_copied_text) {
          var r = (n) => {
            n = n || (A == null ? void 0 : A.event), this.k(n, lc);
          };
          Ve(te, "copy", r, { capture: !0 }), Ve(te, "cut", r, { capture: !0 });
        }
      }
    } else Zp.info("Disabling Automatic Event Collection because this browser is not supported");
  }
  startIfEnabled() {
    this.isEnabled && !this.i && (this.$(), this.i = !0);
  }
  onRemoteConfig(t) {
    t.elementsChainAsString && (this.h = t.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({ [Vp]: !!t.autocapture_opt_out }), this.o = !!t.autocapture_opt_out, this.startIfEnabled();
  }
  setElementSelectors(t) {
    this.m = t;
  }
  getElementSelectors(t) {
    var r, n = [];
    return (r = this.m) == null || r.forEach((i) => {
      var o = te == null ? void 0 : te.querySelectorAll(i);
      o == null || o.forEach((s) => {
        t === s && n.push(i);
      });
    }), n;
  }
  get isEnabled() {
    var t, r, n = (t = this.instance.persistence) == null ? void 0 : t.props[Vp], i = this.o;
    if (xn(i) && !br(n) && !this.instance.config.advanced_disable_decide) return !1;
    var o = (r = this.o) !== null && r !== void 0 ? r : !!n;
    return !!this.instance.config.autocapture && !o;
  }
  k(t, r) {
    if (r === void 0 && (r = "$autocapture"), this.isEnabled) {
      var n, i = Kx(t);
      Ux(i) && (i = i.parentNode || null), r === "$autocapture" && t.type === "click" && t instanceof MouseEvent && this.instance.config.rageclick && (n = this.rageclicks) != null && n.isRageClick(t.clientX, t.clientY, (/* @__PURE__ */ new Date()).getTime()) && this.k(t, "$rageclick");
      var o = r === lc;
      if (i && I$(i, t, this.S, o, o ? ["copy", "cut"] : void 0)) {
        var { props: s, explicitNoCapture: a } = z$(i, { e: t, maskAllElementAttributes: this.instance.config.mask_all_element_attributes, maskAllText: this.instance.config.mask_all_text, elementAttributeIgnoreList: this.S.element_attribute_ignorelist, elementsChainAsString: this.h });
        if (a) return !1;
        var l = this.getElementSelectors(i);
        if (l && l.length > 0 && (s.$element_selectors = l), r === lc) {
          var c, u = qx(A == null || (c = A.getSelection()) == null ? void 0 : c.toString()), f = t.type || "clipboard";
          if (!u) return !1;
          s.$selected_content = u, s.$copy_type = f;
        }
        return this.instance.capture(r, s), !0;
      }
    }
  }
  isBrowserSupported() {
    return Xt(te == null ? void 0 : te.querySelectorAll);
  }
}
Math.trunc || (Math.trunc = function(e) {
  return e < 0 ? Math.ceil(e) : Math.floor(e);
}), Number.isInteger || (Number.isInteger = function(e) {
  return pt(e) && isFinite(e) && Math.floor(e) === e;
});
var Qp = "0123456789abcdef";
class za {
  constructor(t) {
    if (this.bytes = t, t.length !== 16) throw new TypeError("not 128-bit length");
  }
  static fromFieldsV7(t, r, n, i) {
    if (!Number.isInteger(t) || !Number.isInteger(r) || !Number.isInteger(n) || !Number.isInteger(i) || t < 0 || r < 0 || n < 0 || i < 0 || t > 281474976710655 || r > 4095 || n > 1073741823 || i > 4294967295) throw new RangeError("invalid field value");
    var o = new Uint8Array(16);
    return o[0] = t / Math.pow(2, 40), o[1] = t / Math.pow(2, 32), o[2] = t / Math.pow(2, 24), o[3] = t / Math.pow(2, 16), o[4] = t / Math.pow(2, 8), o[5] = t, o[6] = 112 | r >>> 8, o[7] = r, o[8] = 128 | n >>> 24, o[9] = n >>> 16, o[10] = n >>> 8, o[11] = n, o[12] = i >>> 24, o[13] = i >>> 16, o[14] = i >>> 8, o[15] = i, new za(o);
  }
  toString() {
    for (var t = "", r = 0; r < this.bytes.length; r++) t = t + Qp.charAt(this.bytes[r] >>> 4) + Qp.charAt(15 & this.bytes[r]), r !== 3 && r !== 5 && r !== 7 && r !== 9 || (t += "-");
    if (t.length !== 36) throw new Error("Invalid UUIDv7 was generated");
    return t;
  }
  clone() {
    return new za(this.bytes.slice(0));
  }
  equals(t) {
    return this.compareTo(t) === 0;
  }
  compareTo(t) {
    for (var r = 0; r < 16; r++) {
      var n = this.bytes[r] - t.bytes[r];
      if (n !== 0) return Math.sign(n);
    }
    return 0;
  }
}
class M$ {
  constructor() {
    this.I = 0, this.P = 0, this.R = new B$();
  }
  generate() {
    var t = this.generateOrAbort();
    if (J(t)) {
      this.I = 0;
      var r = this.generateOrAbort();
      if (J(r)) throw new Error("Could not generate UUID after timestamp reset");
      return r;
    }
    return t;
  }
  generateOrAbort() {
    var t = Date.now();
    if (t > this.I) this.I = t, this.T();
    else {
      if (!(t + 1e4 > this.I)) return;
      this.P++, this.P > 4398046511103 && (this.I++, this.T());
    }
    return za.fromFieldsV7(this.I, Math.trunc(this.P / Math.pow(2, 30)), this.P & Math.pow(2, 30) - 1, this.R.nextUint32());
  }
  T() {
    this.P = 1024 * this.R.nextUint32() + (1023 & this.R.nextUint32());
  }
}
var eg, r_ = (e) => {
  if (typeof UUIDV7_DENY_WEAK_RNG != "undefined" && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
  for (var t = 0; t < e.length; t++) e[t] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
  return e;
};
A && !J(A.crypto) && crypto.getRandomValues && (r_ = (e) => crypto.getRandomValues(e));
class B$ {
  constructor() {
    this.M = new Uint32Array(8), this.C = 1 / 0;
  }
  nextUint32() {
    return this.C >= this.M.length && (r_(this.M), this.C = 0), this.M[this.C++];
  }
}
var an = () => W$().toString(), W$ = () => (eg || (eg = new M$())).generate(), oo = "", H$ = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function j$(e, t) {
  if (t) {
    var r = function(i, o) {
      if (o === void 0 && (o = te), oo) return oo;
      if (!o || ["localhost", "127.0.0.1"].includes(i)) return "";
      for (var s = i.split("."), a = Math.min(s.length, 8), l = "dmn_chk_" + an(); !oo && a--; ) {
        var c = s.slice(a).join("."), u = l + "=1;domain=." + c + ";path=/";
        o.cookie = u + ";max-age=3", o.cookie.includes(l) && (o.cookie = u + ";max-age=0", oo = c);
      }
      return oo;
    }(e);
    if (!r) {
      var n = ((i) => {
        var o = i.match(H$);
        return o ? o[0] : "";
      })(e);
      n !== r && re.info("Warning: cookie subdomain discovery mismatch", n, r), r = n;
    }
    return r ? "; domain=." + r : "";
  }
  return "";
}
var Br = { O: () => !!te, F: function(e) {
  re.error("cookieStore error: " + e);
}, A: function(e) {
  if (te) {
    try {
      for (var t = e + "=", r = te.cookie.split(";").filter((o) => o.length), n = 0; n < r.length; n++) {
        for (var i = r[n]; i.charAt(0) == " "; ) i = i.substring(1, i.length);
        if (i.indexOf(t) === 0) return decodeURIComponent(i.substring(t.length, i.length));
      }
    } catch (o) {
    }
    return null;
  }
}, D: function(e) {
  var t;
  try {
    t = JSON.parse(Br.A(e)) || {};
  } catch (r) {
  }
  return t;
}, L: function(e, t, r, n, i) {
  if (te) try {
    var o = "", s = "", a = j$(te.location.hostname, n);
    if (r) {
      var l = /* @__PURE__ */ new Date();
      l.setTime(l.getTime() + 24 * r * 60 * 60 * 1e3), o = "; expires=" + l.toUTCString();
    }
    i && (s = "; secure");
    var c = e + "=" + encodeURIComponent(JSON.stringify(t)) + o + "; SameSite=Lax; path=/" + a + s;
    return c.length > 3686.4 && re.warn("cookieStore warning: large cookie, len=" + c.length), te.cookie = c, c;
  } catch (u) {
    return;
  }
}, N: function(e, t) {
  try {
    Br.L(e, "", -1, t);
  } catch (r) {
    return;
  }
} }, uc = null, Je = { O: function() {
  if (!xn(uc)) return uc;
  var e = !0;
  if (J(A)) e = !1;
  else try {
    var t = "__mplssupport__";
    Je.L(t, "xyz"), Je.A(t) !== '"xyz"' && (e = !1), Je.N(t);
  } catch (r) {
    e = !1;
  }
  return e || re.error("localStorage unsupported; falling back to cookie store"), uc = e, e;
}, F: function(e) {
  re.error("localStorage error: " + e);
}, A: function(e) {
  try {
    return A == null ? void 0 : A.localStorage.getItem(e);
  } catch (t) {
    Je.F(t);
  }
  return null;
}, D: function(e) {
  try {
    return JSON.parse(Je.A(e)) || {};
  } catch (t) {
  }
  return null;
}, L: function(e, t) {
  try {
    A == null || A.localStorage.setItem(e, JSON.stringify(t));
  } catch (r) {
    Je.F(r);
  }
}, N: function(e) {
  try {
    A == null || A.localStorage.removeItem(e);
  } catch (t) {
    Je.F(t);
  }
} }, U$ = ["distinct_id", Ra, _o, Fa, Na], Os = ee({}, Je, { D: function(e) {
  try {
    var t = {};
    try {
      t = Br.D(e) || {};
    } catch (n) {
    }
    var r = Ue(t, JSON.parse(Je.A(e) || "{}"));
    return Je.L(e, r), r;
  } catch (n) {
  }
  return null;
}, L: function(e, t, r, n, i, o) {
  try {
    Je.L(e, t, void 0, void 0, o);
    var s = {};
    U$.forEach((a) => {
      t[a] && (s[a] = t[a]);
    }), Object.keys(s).length && Br.L(e, s, r, n, i, o);
  } catch (a) {
    Je.F(a);
  }
}, N: function(e, t) {
  try {
    A == null || A.localStorage.removeItem(e), Br.N(e, t);
  } catch (r) {
    Je.F(r);
  }
} }), Ps = {}, G$ = { O: function() {
  return !0;
}, F: function(e) {
  re.error("memoryStorage error: " + e);
}, A: function(e) {
  return Ps[e] || null;
}, D: function(e) {
  return Ps[e] || null;
}, L: function(e, t) {
  Ps[e] = t;
}, N: function(e) {
  delete Ps[e];
} }, Cn = null, ot = { O: function() {
  if (!xn(Cn)) return Cn;
  if (Cn = !0, J(A)) Cn = !1;
  else try {
    var e = "__support__";
    ot.L(e, "xyz"), ot.A(e) !== '"xyz"' && (Cn = !1), ot.N(e);
  } catch (t) {
    Cn = !1;
  }
  return Cn;
}, F: function(e) {
  re.error("sessionStorage error: ", e);
}, A: function(e) {
  try {
    return A == null ? void 0 : A.sessionStorage.getItem(e);
  } catch (t) {
    ot.F(t);
  }
  return null;
}, D: function(e) {
  try {
    return JSON.parse(ot.A(e)) || null;
  } catch (t) {
  }
  return null;
}, L: function(e, t) {
  try {
    A == null || A.sessionStorage.setItem(e, JSON.stringify(t));
  } catch (r) {
    ot.F(r);
  }
}, N: function(e) {
  try {
    A == null || A.sessionStorage.removeItem(e);
  } catch (t) {
    ot.F(t);
  }
} }, ii = function(e) {
  return e[e.PENDING = -1] = "PENDING", e[e.DENIED = 0] = "DENIED", e[e.GRANTED = 1] = "GRANTED", e;
}({});
class q$ {
  constructor(t) {
    this._instance = t;
  }
  get S() {
    return this._instance.config;
  }
  get consent() {
    return this.j() ? ii.DENIED : this.U;
  }
  isOptedOut() {
    return this.consent === ii.DENIED || this.consent === ii.PENDING && this.S.opt_out_capturing_by_default;
  }
  isOptedIn() {
    return !this.isOptedOut();
  }
  optInOut(t) {
    this.q.L(this.B, t ? 1 : 0, this.S.cookie_expiration, this.S.cross_subdomain_cookie, this.S.secure_cookie);
  }
  reset() {
    this.q.N(this.B, this.S.cross_subdomain_cookie);
  }
  get B() {
    var { token: t, opt_out_capturing_cookie_prefix: r } = this._instance.config;
    return (r || "__ph_opt_in_out_") + t;
  }
  get U() {
    var t = this.q.A(this.B);
    return t === "1" ? ii.GRANTED : t === "0" ? ii.DENIED : ii.PENDING;
  }
  get q() {
    if (!this.H) {
      var t = this.S.opt_out_capturing_persistence_type;
      this.H = t === "localStorage" ? Je : Br;
      var r = t === "localStorage" ? Br : Je;
      r.A(this.B) && (this.H.A(this.B) || this.optInOut(r.A(this.B) === "1"), r.N(this.B, this.S.cross_subdomain_cookie));
    }
    return this.H;
  }
  j() {
    return !!this.S.respect_dnt && !!Bx([Vt == null ? void 0 : Vt.doNotTrack, Vt == null ? void 0 : Vt.msDoNotTrack, pe.doNotTrack], (t) => ve([!0, 1, "1", "yes"], t));
  }
}
var Ts = ut("[Dead Clicks]"), K$ = () => !0, Y$ = (e) => {
  var t, r = !((t = e.instance.persistence) == null || !t.get_property(Hx)), n = e.instance.config.capture_dead_clicks;
  return br(n) ? n : r;
};
class n_ {
  get lazyLoadedDeadClicksAutocapture() {
    return this.W;
  }
  constructor(t, r, n) {
    this.instance = t, this.isEnabled = r, this.onCapture = n, this.startIfEnabled();
  }
  onRemoteConfig(t) {
    this.instance.persistence && this.instance.persistence.register({ [Hx]: t == null ? void 0 : t.captureDeadClicks }), this.startIfEnabled();
  }
  startIfEnabled() {
    this.isEnabled(this) && this.G(() => {
      this.J();
    });
  }
  G(t) {
    var r, n;
    (r = pe.__PosthogExtensions__) != null && r.initDeadClicksAutocapture && t(), (n = pe.__PosthogExtensions__) == null || n.loadExternalDependency == null || n.loadExternalDependency(this.instance, "dead-clicks-autocapture", (i) => {
      i ? Ts.error("failed to load script", i) : t();
    });
  }
  J() {
    var t;
    if (te) {
      if (!this.W && (t = pe.__PosthogExtensions__) != null && t.initDeadClicksAutocapture) {
        var r = De(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
        r.__onCapture = this.onCapture, this.W = pe.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, r), this.W.start(te), Ts.info("starting...");
      }
    } else Ts.error("`document` not found. Cannot start.");
  }
  stop() {
    this.W && (this.W.stop(), this.W = void 0, Ts.info("stopping..."));
  }
}
var dc = ut("[ExceptionAutocapture]");
class X$ {
  constructor(t) {
    var r;
    this.V = () => {
      var n;
      if (A && this.isEnabled && (n = pe.__PosthogExtensions__) != null && n.errorWrappingFunctions) {
        var i = pe.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, o = pe.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, s = pe.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
        try {
          !this.K && this.S.capture_unhandled_errors && (this.K = i(this.captureException.bind(this))), !this.Y && this.S.capture_unhandled_rejections && (this.Y = o(this.captureException.bind(this))), !this.X && this.S.capture_console_errors && (this.X = s(this.captureException.bind(this)));
        } catch (a) {
          dc.error("failed to start", a), this.Z();
        }
      }
    }, this._instance = t, this.tt = !((r = this._instance.persistence) == null || !r.props[zp]), this.S = this.it(), this.startIfEnabled();
  }
  it() {
    var t = this._instance.config.capture_exceptions, r = { capture_unhandled_errors: !1, capture_unhandled_rejections: !1, capture_console_errors: !1 };
    return De(t) ? r = ee({}, r, t) : (J(t) ? this.tt : t) && (r = ee({}, r, { capture_unhandled_errors: !0, capture_unhandled_rejections: !0 })), r;
  }
  get isEnabled() {
    return this.S.capture_console_errors || this.S.capture_unhandled_errors || this.S.capture_unhandled_rejections;
  }
  startIfEnabled() {
    this.isEnabled && (dc.info("enabled"), this.G(this.V));
  }
  G(t) {
    var r, n;
    (r = pe.__PosthogExtensions__) != null && r.errorWrappingFunctions && t(), (n = pe.__PosthogExtensions__) == null || n.loadExternalDependency == null || n.loadExternalDependency(this._instance, "exception-autocapture", (i) => {
      if (i) return dc.error("failed to load script", i);
      t();
    });
  }
  Z() {
    var t, r, n;
    (t = this.K) == null || t.call(this), this.K = void 0, (r = this.Y) == null || r.call(this), this.Y = void 0, (n = this.X) == null || n.call(this), this.X = void 0;
  }
  onRemoteConfig(t) {
    var r = t.autocaptureExceptions;
    this.tt = !!r || !1, this.S = this.it(), this._instance.persistence && this._instance.persistence.register({ [zp]: this.tt }), this.startIfEnabled();
  }
  captureException(t) {
    var r = this._instance.requestRouter.endpointFor("ui");
    t.$exception_personURL = r + "/project/" + this._instance.config.token + "/person/" + this._instance.get_distinct_id(), this._instance.exceptions.sendExceptionEvent(t);
  }
}
function i_(e) {
  return !J(Event) && o_(e, Event);
}
function o_(e, t) {
  try {
    return e instanceof t;
  } catch (r) {
    return !1;
  }
}
function s_(e) {
  switch (Object.prototype.toString.call(e)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object DOMError]":
      return !0;
    default:
      return o_(e, Error);
  }
}
function oa(e, t) {
  return Object.prototype.toString.call(e) === "[object " + t + "]";
}
function fc(e) {
  return oa(e, "DOMError");
}
var tg = /\(error: (.*)\)/, rg = 50, mi = "?";
function hc(e, t, r, n) {
  var i = { platform: "web:javascript", filename: e, function: t === "<anonymous>" ? mi : t, in_app: !0 };
  return J(r) || (i.lineno = r), J(n) || (i.colno = n), i;
}
var J$ = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, Z$ = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, Q$ = /\((\S*)(?::(\d+))(?::(\d+))\)/, eL = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, tL = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, rL = function() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
  var n = t.sort((i, o) => i[0] - o[0]).map((i) => i[1]);
  return function(i, o) {
    o === void 0 && (o = 0);
    for (var s = [], a = i.split(`
`), l = o; l < a.length; l++) {
      var c = a[l];
      if (!(c.length > 1024)) {
        var u = tg.test(c) ? c.replace(tg, "$1") : c;
        if (!u.match(/\S*Error: /)) {
          for (var f of n) {
            var d = f(u);
            if (d) {
              s.push(d);
              break;
            }
          }
          if (s.length >= rg) break;
        }
      }
    }
    return function(p) {
      if (!p.length) return [];
      var g = Array.from(p);
      return g.reverse(), g.slice(0, rg).map((h) => ee({}, h, { filename: h.filename || nL(g).filename, function: h.function || mi }));
    }(s);
  };
}([30, (e) => {
  var t = J$.exec(e);
  if (t) {
    var [, r, n, i] = t;
    return hc(r, mi, +n, +i);
  }
  var o = Z$.exec(e);
  if (o) {
    if (o[2] && o[2].indexOf("eval") === 0) {
      var s = Q$.exec(o[2]);
      s && (o[2] = s[1], o[3] = s[2], o[4] = s[3]);
    }
    var [a, l] = ig(o[1] || mi, o[2]);
    return hc(l, a, o[3] ? +o[3] : void 0, o[4] ? +o[4] : void 0);
  }
}], [50, (e) => {
  var t = eL.exec(e);
  if (t) {
    if (t[3] && t[3].indexOf(" > eval") > -1) {
      var r = tL.exec(t[3]);
      r && (t[1] = t[1] || "eval", t[3] = r[1], t[4] = r[2], t[5] = "");
    }
    var n = t[3], i = t[1] || mi;
    return [i, n] = ig(i, n), hc(n, i, t[4] ? +t[4] : void 0, t[5] ? +t[5] : void 0);
  }
}]);
function nL(e) {
  return e[e.length - 1] || {};
}
var Rs, ng, pc, ig = (e, t) => {
  var r = e.indexOf("safari-extension") !== -1, n = e.indexOf("safari-web-extension") !== -1;
  return r || n ? [e.indexOf("@") !== -1 ? e.split("@")[0] : mi, r ? "safari-extension:" + t : "safari-web-extension:" + t] : [e, t];
}, iL = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
function rf(e, t) {
  t === void 0 && (t = 0);
  var r = e.stacktrace || e.stack || "", n = function(s) {
    return s && oL.test(s.message) ? 1 : 0;
  }(e);
  try {
    var i = rL, o = function(s, a) {
      var l = function(c) {
        var u = globalThis._posthogChunkIds;
        if (!u) return {};
        var f = Object.keys(u);
        return pc && f.length === ng || (ng = f.length, pc = f.reduce((d, p) => {
          Rs || (Rs = {});
          var g = Rs[p];
          if (g) d[g[0]] = g[1];
          else for (var h = c(p), m = h.length - 1; m >= 0; m--) {
            var v = h[m], y = v == null ? void 0 : v.filename, x = u[p];
            if (y && x) {
              d[y] = x, Rs[p] = [y, x];
              break;
            }
          }
          return d;
        }, {})), pc;
      }(a);
      return s.forEach((c) => {
        c.filename && (c.chunk_id = l[c.filename]);
      }), s;
    }(i(r, n), i);
    return o.slice(0, o.length - t);
  } catch (s) {
  }
  return [];
}
var oL = /Minified React error #\d+;/i;
function sL(e, t) {
  var r, n, i = rf(e), o = (r = t == null ? void 0 : t.handled) === null || r === void 0 || r, s = (n = t == null ? void 0 : t.synthetic) !== null && n !== void 0 && n;
  return { type: t != null && t.overrideExceptionType ? t.overrideExceptionType : e.name, value: function(a) {
    var l = a.message;
    return l.error && typeof l.error.message == "string" ? String(l.error.message) : String(l);
  }(e), stacktrace: { frames: i, type: "raw" }, mechanism: { handled: o, synthetic: s } };
}
function a_(e, t) {
  var r = sL(e, t);
  return e.cause && s_(e.cause) && e.cause !== e ? [r, ...a_(e.cause, { handled: t == null ? void 0 : t.handled, synthetic: t == null ? void 0 : t.synthetic })] : [r];
}
function gc(e, t) {
  return { $exception_list: a_(e, t), $exception_level: "error" };
}
function mc(e, t) {
  var r, n, i, o = (r = t == null ? void 0 : t.handled) === null || r === void 0 || r, s = (n = t == null ? void 0 : t.synthetic) === null || n === void 0 || n, a = { type: t != null && t.overrideExceptionType ? t.overrideExceptionType : (i = t == null ? void 0 : t.defaultExceptionType) !== null && i !== void 0 ? i : "Error", value: e || (t == null ? void 0 : t.defaultExceptionMessage), mechanism: { handled: o, synthetic: s } };
  if (t != null && t.syntheticException) {
    var l = rf(t.syntheticException, 1);
    l.length && (a.stacktrace = { frames: l, type: "raw" });
  }
  return { $exception_list: [a], $exception_level: "error" };
}
function aL(e) {
  return Me(e) && !xu(e) && v$.indexOf(e) >= 0;
}
function lL(e, t) {
  var r, n, i = (r = t == null ? void 0 : t.handled) === null || r === void 0 || r, o = (n = t == null ? void 0 : t.synthetic) === null || n === void 0 || n, s = t != null && t.overrideExceptionType ? t.overrideExceptionType : i_(e) ? e.constructor.name : "Error", a = "Non-Error 'exception' captured with keys: " + function(u, f) {
    f === void 0 && (f = 40);
    var d = Object.keys(u);
    if (d.sort(), !d.length) return "[object has no keys]";
    for (var p = d.length; p > 0; p--) {
      var g = d.slice(0, p).join(", ");
      if (!(g.length > f)) return p === d.length || g.length <= f ? g : g.slice(0, f) + "...";
    }
    return "";
  }(e), l = { type: s, value: a, mechanism: { handled: i, synthetic: o } };
  if (t != null && t.syntheticException) {
    var c = rf(t == null ? void 0 : t.syntheticException, 1);
    c.length && (l.stacktrace = { frames: c, type: "raw" });
  }
  return { $exception_list: [l], $exception_level: aL(e.level) ? e.level : "error" };
}
function cL(e, t) {
  var { error: r, event: n } = e, i = { $exception_list: [] }, o = r || n;
  if (fc(o) || function(d) {
    return oa(d, "DOMException");
  }(o)) {
    var s = o;
    if (function(d) {
      return "stack" in d;
    }(o)) i = gc(o, t);
    else {
      var a = s.name || (fc(s) ? "DOMError" : "DOMException"), l = s.message ? a + ": " + s.message : a;
      i = mc(l, ee({}, t, { overrideExceptionType: fc(s) ? "DOMError" : "DOMException", defaultExceptionMessage: l }));
    }
    return "code" in s && (i.$exception_DOMException_code = "" + s.code), i;
  }
  if (function(d) {
    return oa(d, "ErrorEvent");
  }(o) && o.error) return gc(o.error, t);
  if (s_(o)) return gc(o, t);
  if (function(d) {
    return oa(d, "Object");
  }(o) || i_(o)) return lL(o, t);
  if (J(r) && Me(n)) {
    var c = "Error", u = n, f = n.match(iL);
    return f && (c = f[1], u = f[2]), mc(u, ee({}, t, { overrideExceptionType: c, defaultExceptionMessage: u }));
  }
  return mc(o, t);
}
function og(e, t, r) {
  try {
    if (!(t in e)) return () => {
    };
    var n = e[t], i = r(n);
    return Xt(i) && (i.prototype = i.prototype || {}, Object.defineProperties(i, { __posthog_wrapped__: { enumerable: !1, value: !0 } })), e[t] = i, () => {
      e[t] = n;
    };
  } catch (o) {
    return () => {
    };
  }
}
class uL {
  constructor(t) {
    var r;
    this._instance = t, this.et = (A == null || (r = A.location) == null ? void 0 : r.pathname) || "";
  }
  get isEnabled() {
    return this._instance.config.capture_pageview === "history_change";
  }
  startIfEnabled() {
    this.isEnabled && (re.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
  }
  stop() {
    this.rt && this.rt(), this.rt = void 0, re.info("History API monitoring stopped");
  }
  monitorHistoryChanges() {
    var t, r;
    if (A && A.history) {
      var n = this;
      (t = A.history.pushState) != null && t.__posthog_wrapped__ || og(A.history, "pushState", (i) => function(o, s, a) {
        i.call(this, o, s, a), n.st("pushState");
      }), (r = A.history.replaceState) != null && r.__posthog_wrapped__ || og(A.history, "replaceState", (i) => function(o, s, a) {
        i.call(this, o, s, a), n.st("replaceState");
      }), this.nt();
    }
  }
  st(t) {
    try {
      var r, n = A == null || (r = A.location) == null ? void 0 : r.pathname;
      if (!n) return;
      n !== this.et && this.isEnabled && this._instance.capture("$pageview", { navigation_type: t }), this.et = n;
    } catch (i) {
      re.error("Error capturing " + t + " pageview", i);
    }
  }
  nt() {
    if (!this.rt) {
      var t = () => {
        this.st("popstate");
      };
      Ve(A, "popstate", t), this.rt = () => {
        A && A.removeEventListener("popstate", t);
      };
    }
  }
}
function Da(e) {
  var t, r;
  return ((t = JSON.stringify(e, (r = [], function(n, i) {
    if (De(i)) {
      for (; r.length > 0 && r[r.length - 1] !== this; ) r.pop();
      return r.includes(i) ? "[Circular]" : (r.push(i), i);
    }
    return i;
  }))) == null ? void 0 : t.length) || 0;
}
function Fu(e, t) {
  if (t === void 0 && (t = 66060288e-1), e.size >= t && e.data.length > 1) {
    var r = Math.floor(e.data.length / 2), n = e.data.slice(0, r), i = e.data.slice(r);
    return [Fu({ size: Da(n), data: n, sessionId: e.sessionId, windowId: e.windowId }), Fu({ size: Da(i), data: i, sessionId: e.sessionId, windowId: e.windowId })].flatMap((o) => o);
  }
  return [e];
}
var zr = ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(zr || {}), er = ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(er || {}), $u = "[SessionRecording]", Lu = "redacted", As = { initiatorTypes: ["audio", "beacon", "body", "css", "early-hint", "embed", "fetch", "frame", "iframe", "icon", "image", "img", "input", "link", "navigation", "object", "ping", "script", "track", "video", "xmlhttprequest"], maskRequestFn: (e) => e, recordHeaders: !1, recordBody: !1, recordInitialRequests: !1, recordPerformance: !1, performanceEntryTypeToObserve: ["first-input", "navigation", "paint", "resource"], payloadSizeLimitBytes: 1e6, payloadHostDenyList: [".lr-ingest.io", ".ingest.sentry.io", ".clarity.ms", "analytics.google.com", "bam.nr-data.net"] }, dL = ["authorization", "x-forwarded-for", "authorization", "cookie", "set-cookie", "x-api-key", "x-real-ip", "remote-addr", "forwarded", "proxy-authorization", "x-csrf-token", "x-csrftoken", "x-xsrf-token"], fL = ["password", "secret", "passwd", "api_key", "apikey", "auth", "credentials", "mysql_pwd", "privatekey", "private_key", "token"], hL = ["/s/", "/e/", "/i/"];
function sg(e, t, r, n) {
  if (xe(e)) return e;
  var i = (t == null ? void 0 : t["content-length"]) || function(o) {
    return new Blob([o]).size;
  }(e);
  return Me(i) && (i = parseInt(i)), i > r ? $u + " " + n + " body too large to record (" + i + " bytes)" : e;
}
function ag(e, t) {
  if (xe(e)) return e;
  var r = e;
  return ki(r, !1) || (r = $u + " " + t + " body " + Lu), Oe(fL, (n) => {
    var i, o;
    (i = r) != null && i.length && ((o = r) == null ? void 0 : o.indexOf(n)) !== -1 && (r = $u + " " + t + " body " + Lu + " as might contain: " + n);
  }), r;
}
var pL = (e, t) => {
  var r, n, i, o = { payloadSizeLimitBytes: As.payloadSizeLimitBytes, performanceEntryTypeToObserve: [...As.performanceEntryTypeToObserve], payloadHostDenyList: [...t.payloadHostDenyList || [], ...As.payloadHostDenyList] }, s = e.session_recording.recordHeaders !== !1 && t.recordHeaders, a = e.session_recording.recordBody !== !1 && t.recordBody, l = e.capture_performance !== !1 && t.recordPerformance, c = (r = o, i = Math.min(1e6, (n = r.payloadSizeLimitBytes) !== null && n !== void 0 ? n : 1e6), (d) => (d != null && d.requestBody && (d.requestBody = sg(d.requestBody, d.requestHeaders, i, "Request")), d != null && d.responseBody && (d.responseBody = sg(d.responseBody, d.responseHeaders, i, "Response")), d)), u = (d) => {
    return c(((h, m) => {
      var v, y = Ii(h.name), x = m.indexOf("http") === 0 ? (v = Ii(m)) == null ? void 0 : v.pathname : m;
      x === "/" && (x = "");
      var S = y == null ? void 0 : y.pathname.replace(x || "", "");
      if (!(y && S && hL.some((_) => S.indexOf(_) === 0))) return h;
    })((g = (p = d).requestHeaders, xe(g) || Oe(Object.keys(g != null ? g : {}), (h) => {
      dL.includes(h.toLowerCase()) && (g[h] = Lu);
    }), p), e.api_host));
    var p, g;
  }, f = Xt(e.session_recording.maskNetworkRequestFn);
  return f && Xt(e.session_recording.maskCapturedNetworkRequestFn) && re.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."), f && (e.session_recording.maskCapturedNetworkRequestFn = (d) => {
    var p = e.session_recording.maskNetworkRequestFn({ url: d.name });
    return ee({}, d, { name: p == null ? void 0 : p.url });
  }), o.maskRequestFn = Xt(e.session_recording.maskCapturedNetworkRequestFn) ? (d) => {
    var p, g = u(d);
    return g && (p = e.session_recording.maskCapturedNetworkRequestFn == null ? void 0 : e.session_recording.maskCapturedNetworkRequestFn(g)) !== null && p !== void 0 ? p : void 0;
  } : (d) => function(p) {
    if (!J(p)) return p.requestBody = ag(p.requestBody, "Request"), p.responseBody = ag(p.responseBody, "Response"), p;
  }(u(d)), ee({}, As, o, { recordHeaders: s, recordBody: a, recordPerformance: l, recordInitialRequests: l });
};
function Kt(e, t, r, n, i) {
  return t > r && (re.warn("min cannot be greater than max."), t = r), pt(e) ? e > r ? (n && re.warn(n + " cannot be  greater than max: " + r + ". Using max value instead."), r) : e < t ? (n && re.warn(n + " cannot be less than min: " + t + ". Using min value instead."), t) : e : (n && re.warn(n + " must be a number. using max or fallback. max: " + r + ", fallback: " + i), Kt(i || r, t, r, n));
}
class gL {
  constructor(t, r) {
    var n, i;
    r === void 0 && (r = {}), this.ot = 100, this.lt = 10, this.ut = {}, this.ht = {}, this.dt = () => {
      Object.keys(this.ut).forEach((o) => {
        this.ut[o] = this.ut[o] + this.lt, this.ut[o] >= this.ot && delete this.ut[o];
      });
    }, this.vt = (o) => {
      var s = this._rrweb.mirror.getNode(o);
      if ((s == null ? void 0 : s.nodeName) !== "svg" && s instanceof Element) {
        var a = s.closest("svg");
        if (a) return [this._rrweb.mirror.getId(a), a];
      }
      return [o, s];
    }, this.ct = (o) => {
      var s, a, l, c, u, f, d, p;
      return ((s = (a = o.removes) == null ? void 0 : a.length) !== null && s !== void 0 ? s : 0) + ((l = (c = o.attributes) == null ? void 0 : c.length) !== null && l !== void 0 ? l : 0) + ((u = (f = o.texts) == null ? void 0 : f.length) !== null && u !== void 0 ? u : 0) + ((d = (p = o.adds) == null ? void 0 : p.length) !== null && d !== void 0 ? d : 0);
    }, this.throttleMutations = (o) => {
      if (o.type !== 3 || o.data.source !== 0) return o;
      var s = o.data, a = this.ct(s);
      s.attributes && (s.attributes = s.attributes.filter((c) => {
        var u, f, d, [p, g] = this.vt(c.id);
        return this.ut[p] === 0 ? !1 : (this.ut[p] = (u = this.ut[p]) !== null && u !== void 0 ? u : this.ot, this.ut[p] = Math.max(this.ut[p] - 1, 0), this.ut[p] === 0 && (this.ht[p] || (this.ht[p] = !0, (f = (d = this.ft).onBlockedNode) == null || f.call(d, p, g))), c);
      }));
      var l = this.ct(s);
      return l !== 0 || a === l ? o : void 0;
    }, this._rrweb = t, this.ft = r, this.lt = Kt((n = this.ft.refillRate) !== null && n !== void 0 ? n : this.lt, 0, 100, "mutation throttling refill rate"), this.ot = Kt((i = this.ft.bucketSize) !== null && i !== void 0 ? i : this.ot, 0, 100, "mutation throttling bucket size"), setInterval(() => {
      this.dt();
    }, 1e3);
  }
}
var Jt = Uint8Array, It = Uint16Array, Oi = Uint32Array, nf = new Jt([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), of = new Jt([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]), lg = new Jt([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), l_ = function(e, t) {
  for (var r = new It(31), n = 0; n < 31; ++n) r[n] = t += 1 << e[n - 1];
  var i = new Oi(r[30]);
  for (n = 1; n < 30; ++n) for (var o = r[n]; o < r[n + 1]; ++o) i[o] = o - r[n] << 5 | n;
  return [r, i];
}, c_ = l_(nf, 2), mL = c_[0], Vu = c_[1];
mL[28] = 258, Vu[258] = 28;
for (var cg = l_(of, 0)[1], u_ = new It(32768), Ne = 0; Ne < 32768; ++Ne) {
  var kn = (43690 & Ne) >>> 1 | (21845 & Ne) << 1;
  kn = (61680 & (kn = (52428 & kn) >>> 2 | (13107 & kn) << 2)) >>> 4 | (3855 & kn) << 4, u_[Ne] = ((65280 & kn) >>> 8 | (255 & kn) << 8) >>> 1;
}
var Ro = function(e, t, r) {
  for (var n = e.length, i = 0, o = new It(t); i < n; ++i) ++o[e[i] - 1];
  var s, a = new It(t);
  for (i = 0; i < t; ++i) a[i] = a[i - 1] + o[i - 1] << 1;
  for (s = new It(n), i = 0; i < n; ++i) s[i] = u_[a[e[i] - 1]++] >>> 15 - e[i];
  return s;
}, Dn = new Jt(288);
for (Ne = 0; Ne < 144; ++Ne) Dn[Ne] = 8;
for (Ne = 144; Ne < 256; ++Ne) Dn[Ne] = 9;
for (Ne = 256; Ne < 280; ++Ne) Dn[Ne] = 7;
for (Ne = 280; Ne < 288; ++Ne) Dn[Ne] = 8;
var Ma = new Jt(32);
for (Ne = 0; Ne < 32; ++Ne) Ma[Ne] = 5;
var vL = Ro(Dn, 9), bL = Ro(Ma, 5), d_ = function(e) {
  return (e / 8 >> 0) + (7 & e && 1);
}, f_ = function(e, t, r) {
  (r == null || r > e.length) && (r = e.length);
  var n = new (e instanceof It ? It : e instanceof Oi ? Oi : Jt)(r - t);
  return n.set(e.subarray(t, r)), n;
}, Nr = function(e, t, r) {
  r <<= 7 & t;
  var n = t / 8 >> 0;
  e[n] |= r, e[n + 1] |= r >>> 8;
}, so = function(e, t, r) {
  r <<= 7 & t;
  var n = t / 8 >> 0;
  e[n] |= r, e[n + 1] |= r >>> 8, e[n + 2] |= r >>> 16;
}, vc = function(e, t) {
  for (var r = [], n = 0; n < e.length; ++n) e[n] && r.push({ s: n, f: e[n] });
  var i = r.length, o = r.slice();
  if (!i) return [new Jt(0), 0];
  if (i == 1) {
    var s = new Jt(r[0].s + 1);
    return s[r[0].s] = 1, [s, 1];
  }
  r.sort(function(_, I) {
    return _.f - I.f;
  }), r.push({ s: -1, f: 25001 });
  var a = r[0], l = r[1], c = 0, u = 1, f = 2;
  for (r[0] = { s: -1, f: a.f + l.f, l: a, r: l }; u != i - 1; ) a = r[r[c].f < r[f].f ? c++ : f++], l = r[c != u && r[c].f < r[f].f ? c++ : f++], r[u++] = { s: -1, f: a.f + l.f, l: a, r: l };
  var d = o[0].s;
  for (n = 1; n < i; ++n) o[n].s > d && (d = o[n].s);
  var p = new It(d + 1), g = zu(r[u - 1], p, 0);
  if (g > t) {
    n = 0;
    var h = 0, m = g - t, v = 1 << m;
    for (o.sort(function(_, I) {
      return p[I.s] - p[_.s] || _.f - I.f;
    }); n < i; ++n) {
      var y = o[n].s;
      if (!(p[y] > t)) break;
      h += v - (1 << g - p[y]), p[y] = t;
    }
    for (h >>>= m; h > 0; ) {
      var x = o[n].s;
      p[x] < t ? h -= 1 << t - p[x]++ - 1 : ++n;
    }
    for (; n >= 0 && h; --n) {
      var S = o[n].s;
      p[S] == t && (--p[S], ++h);
    }
    g = t;
  }
  return [new Jt(p), g];
}, zu = function(e, t, r) {
  return e.s == -1 ? Math.max(zu(e.l, t, r + 1), zu(e.r, t, r + 1)) : t[e.s] = r;
}, ug = function(e) {
  for (var t = e.length; t && !e[--t]; ) ;
  for (var r = new It(++t), n = 0, i = e[0], o = 1, s = function(l) {
    r[n++] = l;
  }, a = 1; a <= t; ++a) if (e[a] == i && a != t) ++o;
  else {
    if (!i && o > 2) {
      for (; o > 138; o -= 138) s(32754);
      o > 2 && (s(o > 10 ? o - 11 << 5 | 28690 : o - 3 << 5 | 12305), o = 0);
    } else if (o > 3) {
      for (s(i), --o; o > 6; o -= 6) s(8304);
      o > 2 && (s(o - 3 << 5 | 8208), o = 0);
    }
    for (; o--; ) s(i);
    o = 1, i = e[a];
  }
  return [r.subarray(0, n), t];
}, ao = function(e, t) {
  for (var r = 0, n = 0; n < t.length; ++n) r += e[n] * t[n];
  return r;
}, Du = function(e, t, r) {
  var n = r.length, i = d_(t + 2);
  e[i] = 255 & n, e[i + 1] = n >>> 8, e[i + 2] = 255 ^ e[i], e[i + 3] = 255 ^ e[i + 1];
  for (var o = 0; o < n; ++o) e[i + o + 4] = r[o];
  return 8 * (i + 4 + n);
}, dg = function(e, t, r, n, i, o, s, a, l, c, u) {
  Nr(t, u++, r), ++i[256];
  for (var f = vc(i, 15), d = f[0], p = f[1], g = vc(o, 15), h = g[0], m = g[1], v = ug(d), y = v[0], x = v[1], S = ug(h), _ = S[0], I = S[1], O = new It(19), w = 0; w < y.length; ++w) O[31 & y[w]]++;
  for (w = 0; w < _.length; ++w) O[31 & _[w]]++;
  for (var E = vc(O, 7), T = E[0], G = E[1], k = 19; k > 4 && !T[lg[k - 1]]; --k) ;
  var j, F, L, D, N = c + 5 << 3, B = ao(i, Dn) + ao(o, Ma) + s, q = ao(i, d) + ao(o, h) + s + 14 + 3 * k + ao(O, T) + (2 * O[16] + 3 * O[17] + 7 * O[18]);
  if (N <= B && N <= q) return Du(t, u, e.subarray(l, l + c));
  if (Nr(t, u, 1 + (q < B)), u += 2, q < B) {
    j = Ro(d, p), F = d, L = Ro(h, m), D = h;
    var P = Ro(T, G);
    for (Nr(t, u, x - 257), Nr(t, u + 5, I - 1), Nr(t, u + 10, k - 4), u += 14, w = 0; w < k; ++w) Nr(t, u + 3 * w, T[lg[w]]);
    u += 3 * k;
    for (var C = [y, _], W = 0; W < 2; ++W) {
      var H = C[W];
      for (w = 0; w < H.length; ++w) {
        var V = 31 & H[w];
        Nr(t, u, P[V]), u += T[V], V > 15 && (Nr(t, u, H[w] >>> 5 & 127), u += H[w] >>> 12);
      }
    }
  } else j = vL, F = Dn, L = bL, D = Ma;
  for (w = 0; w < a; ++w) if (n[w] > 255) {
    V = n[w] >>> 18 & 31, so(t, u, j[V + 257]), u += F[V + 257], V > 7 && (Nr(t, u, n[w] >>> 23 & 31), u += nf[V]);
    var Q = 31 & n[w];
    so(t, u, L[Q]), u += D[Q], Q > 3 && (so(t, u, n[w] >>> 5 & 8191), u += of[Q]);
  } else so(t, u, j[n[w]]), u += F[n[w]];
  return so(t, u, j[256]), u + F[256];
}, yL = new Oi([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), xL = function() {
  for (var e = new Oi(256), t = 0; t < 256; ++t) {
    for (var r = t, n = 9; --n; ) r = (1 & r && 3988292384) ^ r >>> 1;
    e[t] = r;
  }
  return e;
}(), _L = function() {
  var e = 4294967295;
  return { p: function(t) {
    for (var r = e, n = 0; n < t.length; ++n) r = xL[255 & r ^ t[n]] ^ r >>> 8;
    e = r;
  }, d: function() {
    return 4294967295 ^ e;
  } };
}, wL = function(e, t, r, n, i) {
  return function(o, s, a, l, c, u) {
    var f = o.length, d = new Jt(l + f + 5 * (1 + Math.floor(f / 7e3)) + c), p = d.subarray(l, d.length - c), g = 0;
    if (!s || f < 8) for (var h = 0; h <= f; h += 65535) {
      var m = h + 65535;
      m < f ? g = Du(p, g, o.subarray(h, m)) : (p[h] = u, g = Du(p, g, o.subarray(h, f)));
    }
    else {
      for (var v = yL[s - 1], y = v >>> 13, x = 8191 & v, S = (1 << a) - 1, _ = new It(32768), I = new It(S + 1), O = Math.ceil(a / 3), w = 2 * O, E = function(At) {
        return (o[At] ^ o[At + 1] << O ^ o[At + 2] << w) & S;
      }, T = new Oi(25e3), G = new It(288), k = new It(32), j = 0, F = 0, L = (h = 0, 0), D = 0, N = 0; h < f; ++h) {
        var B = E(h), q = 32767 & h, P = I[B];
        if (_[q] = P, I[B] = q, D <= h) {
          var C = f - h;
          if ((j > 7e3 || L > 24576) && C > 423) {
            g = dg(o, p, 0, T, G, k, F, L, N, h - N, g), L = j = F = 0, N = h;
            for (var W = 0; W < 286; ++W) G[W] = 0;
            for (W = 0; W < 30; ++W) k[W] = 0;
          }
          var H = 2, V = 0, Q = x, X = q - P & 32767;
          if (C > 2 && B == E(h - X)) for (var ne = Math.min(y, C) - 1, R = Math.min(32767, h), M = Math.min(258, C); X <= R && --Q && q != P; ) {
            if (o[h + H] == o[h + H - X]) {
              for (var z = 0; z < M && o[h + z] == o[h + z - X]; ++z) ;
              if (z > H) {
                if (H = z, V = X, z > ne) break;
                var Y = Math.min(X, z - 2), U = 0;
                for (W = 0; W < Y; ++W) {
                  var se = h - X + W + 32768 & 32767, we = se - _[se] + 32768 & 32767;
                  we > U && (U = we, P = se);
                }
              }
            }
            X += (q = P) - (P = _[q]) + 32768 & 32767;
          }
          if (V) {
            T[L++] = 268435456 | Vu[H] << 18 | cg[V];
            var ze = 31 & Vu[H], Ye = 31 & cg[V];
            F += nf[ze] + of[Ye], ++G[257 + ze], ++k[Ye], D = h + H, ++j;
          } else T[L++] = o[h], ++G[o[h]];
        }
      }
      g = dg(o, p, u, T, G, k, F, L, N, h - N, g);
    }
    return f_(d, 0, l + d_(g) + c);
  }(e, t.level == null ? 6 : t.level, t.mem == null ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(e.length)))) : 12 + t.mem, r, n, !0);
}, Mu = function(e, t, r) {
  for (; r; ++t) e[t] = r, r >>>= 8;
}, SL = function(e, t) {
  var r = t.filename;
  if (e[0] = 31, e[1] = 139, e[2] = 8, e[8] = t.level < 2 ? 4 : t.level == 9 ? 2 : 0, e[9] = 3, t.mtime != 0 && Mu(e, 4, Math.floor(new Date(t.mtime || Date.now()) / 1e3)), r) {
    e[3] = 8;
    for (var n = 0; n <= r.length; ++n) e[n + 10] = r.charCodeAt(n);
  }
}, EL = function(e) {
  return 10 + (e.filename && e.filename.length + 1 || 0);
};
function h_(e, t) {
  t === void 0 && (t = {});
  var r = _L(), n = e.length;
  r.p(e);
  var i = wL(e, t, EL(t), 8), o = i.length;
  return SL(i, t), Mu(i, o - 8, r.d()), Mu(i, o - 4, n), i;
}
function p_(e, t) {
  var r = e.length;
  if (typeof TextEncoder != "undefined") return new TextEncoder().encode(e);
  for (var n = new Jt(e.length + (e.length >>> 1)), i = 0, o = function(c) {
    n[i++] = c;
  }, s = 0; s < r; ++s) {
    if (i + 5 > n.length) {
      var a = new Jt(i + 8 + (r - s << 1));
      a.set(n), n = a;
    }
    var l = e.charCodeAt(s);
    l < 128 || t ? o(l) : l < 2048 ? (o(192 | l >>> 6), o(128 | 63 & l)) : l > 55295 && l < 57344 ? (o(240 | (l = 65536 + (1047552 & l) | 1023 & e.charCodeAt(++s)) >>> 18), o(128 | l >>> 12 & 63), o(128 | l >>> 6 & 63), o(128 | 63 & l)) : (o(224 | l >>> 12), o(128 | l >>> 6 & 63), o(128 | 63 & l));
  }
  return f_(n, 0, i);
}
function CL(e, t) {
  return function(r) {
    for (var n = 0, i = 0; i < r.length; i++) n = (n << 5) - n + r.charCodeAt(i), n |= 0;
    return Math.abs(n);
  }(e) % 100 < Kt(100 * t, 0, 100);
}
var gn = "disabled", sf = "sampled", Ba = "active", Mn = "buffering", af = "paused", lf = "trigger", Sr = lf + "_activated", mt = lf + "_pending", kr = lf + "_" + gn;
function fg(e, t) {
  return t.some((r) => r.matching === "regex" && new RegExp(r.url).test(e));
}
class g_ {
  constructor(t) {
    this._t = t;
  }
  triggerStatus(t) {
    var r = this._t.map((n) => n.triggerStatus(t));
    return r.includes(Sr) ? Sr : r.includes(mt) ? mt : kr;
  }
  stop() {
    this._t.forEach((t) => t.stop());
  }
}
class m_ {
  constructor(t) {
    this._t = t;
  }
  triggerStatus(t) {
    var r = /* @__PURE__ */ new Set();
    for (var n of this._t) r.add(n.triggerStatus(t));
    switch (r.delete(kr), r.size) {
      case 0:
        return kr;
      case 1:
        return Array.from(r)[0];
      default:
        return mt;
    }
  }
  stop() {
    this._t.forEach((t) => t.stop());
  }
}
class kL {
  triggerStatus() {
    return mt;
  }
  stop() {
  }
}
class IL {
  constructor(t) {
    this.gt = [], this.bt = [], this.urlBlocked = !1, this._instance = t;
  }
  onRemoteConfig(t) {
    var r, n;
    this.gt = ((r = t.sessionRecording) == null ? void 0 : r.urlTriggers) || [], this.bt = ((n = t.sessionRecording) == null ? void 0 : n.urlBlocklist) || [];
  }
  yt(t) {
    var r;
    return this.gt.length === 0 ? kr : ((r = this._instance) == null ? void 0 : r.get_property(Eu)) === t ? Sr : mt;
  }
  triggerStatus(t) {
    var r = this.yt(t), n = r === Sr ? Sr : r === mt ? mt : kr;
    return this._instance.register_for_session({ $sdk_debug_replay_url_trigger_status: n }), n;
  }
  checkUrlTriggerConditions(t, r, n) {
    if (A !== void 0 && A.location.href) {
      var i = A.location.href, o = this.urlBlocked, s = fg(i, this.bt);
      o && s || (s && !o ? t() : !s && o && r(), fg(i, this.gt) && n("url"));
    }
  }
  stop() {
  }
}
class OL {
  constructor(t) {
    this.linkedFlag = null, this.linkedFlagSeen = !1, this.wt = () => {
    }, this._instance = t;
  }
  triggerStatus() {
    var t = mt;
    return xe(this.linkedFlag) && (t = kr), this.linkedFlagSeen && (t = Sr), this._instance.register_for_session({ $sdk_debug_replay_linked_flag_trigger_status: t }), t;
  }
  onRemoteConfig(t, r) {
    var n;
    if (this.linkedFlag = ((n = t.sessionRecording) == null ? void 0 : n.linkedFlag) || null, !xe(this.linkedFlag) && !this.linkedFlagSeen) {
      var i = Me(this.linkedFlag) ? this.linkedFlag : this.linkedFlag.flag, o = Me(this.linkedFlag) ? null : this.linkedFlag.variant;
      this.wt = this._instance.onFeatureFlags((s, a) => {
        var l = !1;
        if (De(a) && i in a) {
          var c = a[i];
          l = br(c) ? c === !0 : o ? c === o : !!c;
        }
        this.linkedFlagSeen = l, l && r(i, o);
      });
    }
  }
  stop() {
    this.wt();
  }
}
class PL {
  constructor(t) {
    this.St = [], this._instance = t;
  }
  onRemoteConfig(t) {
    var r;
    this.St = ((r = t.sessionRecording) == null ? void 0 : r.eventTriggers) || [];
  }
  $t(t) {
    var r;
    return this.St.length === 0 ? kr : ((r = this._instance) == null ? void 0 : r.get_property(Cu)) === t ? Sr : mt;
  }
  triggerStatus(t) {
    var r = this.$t(t), n = r === Sr ? Sr : r === mt ? mt : kr;
    return this._instance.register_for_session({ $sdk_debug_replay_event_trigger_status: n }), n;
  }
  stop() {
  }
}
function TL(e) {
  return e.isRecordingEnabled ? Mn : gn;
}
function RL(e) {
  if (!e.receivedDecide) return Mn;
  if (!e.isRecordingEnabled) return gn;
  if (e.urlTriggerMatching.urlBlocked) return af;
  var t = e.isSampled === !0, r = new g_([e.eventTriggerMatching, e.urlTriggerMatching, e.linkedFlagMatching]).triggerStatus(e.sessionId);
  return t ? sf : r === Sr ? Ba : r === mt ? Mn : e.isSampled === !1 ? gn : Ba;
}
function AL(e) {
  if (!e.receivedDecide) return Mn;
  if (!e.isRecordingEnabled) return gn;
  if (e.urlTriggerMatching.urlBlocked) return af;
  var t = new m_([e.eventTriggerMatching, e.urlTriggerMatching, e.linkedFlagMatching]).triggerStatus(e.sessionId), r = t !== kr, n = br(e.isSampled);
  return r && t === mt ? Mn : r && t === kr || n && !e.isSampled ? gn : e.isSampled === !0 ? sf : Ba;
}
var So = "[SessionRecording]", dt = ut(So);
function Ns() {
  var e;
  return pe == null || (e = pe.__PosthogExtensions__) == null || (e = e.rrweb) == null ? void 0 : e.record;
}
var NL = 3e5, FL = [er.MouseMove, er.MouseInteraction, er.Scroll, er.ViewportResize, er.Input, er.TouchMove, er.MediaInteraction, er.Drag], hg = (e) => ({ rrwebMethod: e, enqueuedAt: Date.now(), attempt: 1 });
function In(e) {
  return function(t, r) {
    for (var n = "", i = 0; i < t.length; ) {
      var o = t[i++];
      n += String.fromCharCode(o);
    }
    return n;
  }(h_(p_(JSON.stringify(e))));
}
function pg(e) {
  return e.type === zr.Custom && e.data.tag === "sessionIdle";
}
class $L {
  get sessionId() {
    return this.kt;
  }
  get xt() {
    return this._instance.config.session_recording.session_idle_threshold_ms || 3e5;
  }
  get started() {
    return this.Et;
  }
  get It() {
    if (!this._instance.sessionManager) throw new Error(So + " must be started with a valid sessionManager.");
    return this._instance.sessionManager;
  }
  get Pt() {
    var t, r;
    return this.Rt.triggerStatus(this.sessionId) === mt ? 6e4 : (t = (r = this._instance.config.session_recording) == null ? void 0 : r.full_snapshot_interval_millis) !== null && t !== void 0 ? t : NL;
  }
  get Tt() {
    var t = this._instance.get_property(_o);
    return br(t) ? t : null;
  }
  get Mt() {
    var t, r, n = (t = this.M) == null ? void 0 : t.data[((r = this.M) == null ? void 0 : r.data.length) - 1], { sessionStartTimestamp: i } = this.It.checkAndGetSessionAndWindowId(!0);
    return n ? n.timestamp - i : null;
  }
  get Ct() {
    var t = !!this._instance.get_property(Su), r = !this._instance.config.disable_session_recording;
    return A && t && r;
  }
  get Ot() {
    var t = !!this._instance.get_property(Bp), r = this._instance.config.enable_recording_console_log;
    return r != null ? r : t;
  }
  get Ft() {
    var t, r, n, i, o, s, a = this._instance.config.session_recording.captureCanvas, l = this._instance.get_property(jp), c = (t = (r = a == null ? void 0 : a.recordCanvas) !== null && r !== void 0 ? r : l == null ? void 0 : l.enabled) !== null && t !== void 0 && t, u = (n = (i = a == null ? void 0 : a.canvasFps) !== null && i !== void 0 ? i : l == null ? void 0 : l.fps) !== null && n !== void 0 ? n : 4, f = (o = (s = a == null ? void 0 : a.canvasQuality) !== null && s !== void 0 ? s : l == null ? void 0 : l.quality) !== null && o !== void 0 ? o : 0.4;
    if (typeof f == "string") {
      var d = parseFloat(f);
      f = isNaN(d) ? 0.4 : d;
    }
    return { enabled: c, fps: Kt(u, 0, 12, "canvas recording fps", 4), quality: Kt(f, 0, 1, "canvas recording quality", 0.4) };
  }
  get At() {
    var t, r, n = this._instance.get_property(Wp), i = { recordHeaders: (t = this._instance.config.session_recording) == null ? void 0 : t.recordHeaders, recordBody: (r = this._instance.config.session_recording) == null ? void 0 : r.recordBody }, o = (i == null ? void 0 : i.recordHeaders) || (n == null ? void 0 : n.recordHeaders), s = (i == null ? void 0 : i.recordBody) || (n == null ? void 0 : n.recordBody), a = De(this._instance.config.capture_performance) ? this._instance.config.capture_performance.network_timing : this._instance.config.capture_performance, l = !!(br(a) ? a : n != null && n.capturePerformance);
    return o || s || l ? { recordHeaders: o, recordBody: s, recordPerformance: l } : void 0;
  }
  get Dt() {
    var t, r, n, i, o, s, a = this._instance.get_property(Hp), l = { maskAllInputs: (t = this._instance.config.session_recording) == null ? void 0 : t.maskAllInputs, maskTextSelector: (r = this._instance.config.session_recording) == null ? void 0 : r.maskTextSelector, blockSelector: (n = this._instance.config.session_recording) == null ? void 0 : n.blockSelector }, c = (i = l == null ? void 0 : l.maskAllInputs) !== null && i !== void 0 ? i : a == null ? void 0 : a.maskAllInputs, u = (o = l == null ? void 0 : l.maskTextSelector) !== null && o !== void 0 ? o : a == null ? void 0 : a.maskTextSelector, f = (s = l == null ? void 0 : l.blockSelector) !== null && s !== void 0 ? s : a == null ? void 0 : a.blockSelector;
    return J(c) && J(u) && J(f) ? void 0 : { maskAllInputs: c == null || c, maskTextSelector: u, blockSelector: f };
  }
  get Lt() {
    var t = this._instance.get_property(Up);
    return pt(t) ? t : null;
  }
  get Nt() {
    var t = this._instance.get_property(Gp);
    return pt(t) ? t : null;
  }
  get status() {
    return this.jt ? this.zt({ receivedDecide: this.jt, isRecordingEnabled: this.Ct, isSampled: this.Tt, urlTriggerMatching: this.Ut, eventTriggerMatching: this.qt, linkedFlagMatching: this.Bt, sessionId: this.sessionId }) : Mn;
  }
  constructor(t) {
    if (this.zt = TL, this.jt = !1, this.Ht = [], this.Wt = "unknown", this.Gt = Date.now(), this.Rt = new kL(), this.Jt = void 0, this.Vt = void 0, this.Kt = void 0, this.Yt = void 0, this.Xt = void 0, this._forceAllowLocalhostNetworkCapture = !1, this.Qt = () => {
      this.Zt();
    }, this.ti = () => {
      this.ii("browser offline", {});
    }, this.ei = () => {
      this.ii("browser online", {});
    }, this.ri = () => {
      if (te != null && te.visibilityState) {
        var i = "window " + te.visibilityState;
        this.ii(i, {});
      }
    }, this._instance = t, this.Et = !1, this.si = "/s/", this.ni = void 0, this.jt = !1, !this._instance.sessionManager) throw dt.error("started without valid sessionManager"), new Error(So + " started without valid sessionManager. This is a bug.");
    if (this._instance.config.__preview_experimental_cookieless_mode) throw new Error(So + " cannot be used with __preview_experimental_cookieless_mode.");
    this.Bt = new OL(this._instance), this.Ut = new IL(this._instance), this.qt = new PL(this._instance);
    var { sessionId: r, windowId: n } = this.It.checkAndGetSessionAndWindowId();
    this.kt = r, this.oi = n, this.M = this.ai(), this.xt >= this.It.sessionTimeoutMs && dt.warn("session_idle_threshold_ms (" + this.xt + ") is greater than the session timeout (" + this.It.sessionTimeoutMs + "). Session will never be detected as idle");
  }
  startIfEnabledOrStop(t) {
    this.Ct ? (this.li(t), Ve(A, "beforeunload", this.Qt), Ve(A, "offline", this.ti), Ve(A, "online", this.ei), Ve(A, "visibilitychange", this.ri), this.ui(), this.hi(), xe(this.Jt) && (this.Jt = this._instance.on("eventCaptured", (r) => {
      try {
        if (r.event === "$pageview") {
          var n = r != null && r.properties.$current_url ? this.di(r == null ? void 0 : r.properties.$current_url) : "";
          if (!n) return;
          this.ii("$pageview", { href: n });
        }
      } catch (i) {
        dt.error("Could not add $pageview to rrweb session", i);
      }
    })), this.Vt || (this.Vt = this.It.onSessionId((r, n, i) => {
      var o, s;
      i && (this.ii("$session_id_change", { sessionId: r, windowId: n, changeReason: i }), (o = this._instance) == null || (o = o.persistence) == null || o.unregister(Cu), (s = this._instance) == null || (s = s.persistence) == null || s.unregister(Eu));
    }))) : this.stopRecording();
  }
  stopRecording() {
    var t, r, n, i;
    this.Et && this.ni && (this.ni(), this.ni = void 0, this.Et = !1, A == null || A.removeEventListener("beforeunload", this.Qt), A == null || A.removeEventListener("offline", this.ti), A == null || A.removeEventListener("online", this.ei), A == null || A.removeEventListener("visibilitychange", this.ri), this.ai(), clearInterval(this.vi), (t = this.Jt) == null || t.call(this), this.Jt = void 0, (r = this.Xt) == null || r.call(this), this.Xt = void 0, (n = this.Vt) == null || n.call(this), this.Vt = void 0, (i = this.Yt) == null || i.call(this), this.Yt = void 0, this.qt.stop(), this.Ut.stop(), this.Bt.stop(), dt.info("stopped"));
  }
  ci() {
    var t;
    (t = this._instance.persistence) == null || t.unregister(_o);
  }
  fi(t) {
    var r, n = this.kt !== t, i = this.Lt;
    if (pt(i)) {
      var o = this.Tt, s = n || !br(o), a = s ? CL(t, i) : o;
      s && (a ? this.pi(sf) : dt.warn("Sample rate (" + i + ") has determined that this sessionId (" + t + ") will not be sent to the server."), this.ii("samplingDecisionMade", { sampleRate: i, isSampled: a })), (r = this._instance.persistence) == null || r.register({ [_o]: a });
    } else this.ci();
  }
  onRemoteConfig(t) {
    var r, n, i, o;
    this.ii("$remote_config_received", t), this.gi(t), (r = t.sessionRecording) != null && r.endpoint && (this.si = (o = t.sessionRecording) == null ? void 0 : o.endpoint), this.ui(), ((n = t.sessionRecording) == null ? void 0 : n.triggerMatchType) === "any" ? (this.zt = RL, this.Rt = new g_([this.qt, this.Ut])) : (this.zt = AL, this.Rt = new m_([this.qt, this.Ut])), this._instance.register_for_session({ $sdk_debug_replay_remote_trigger_matching_config: (i = t.sessionRecording) == null ? void 0 : i.triggerMatchType }), this.Ut.onRemoteConfig(t), this.qt.onRemoteConfig(t), this.Bt.onRemoteConfig(t, (s, a) => {
      this.pi("linked_flag_matched", { flag: s, variant: a });
    }), this.jt = !0, this.startIfEnabledOrStop();
  }
  ui() {
    pt(this.Lt) && xe(this.Yt) && (this.Yt = this.It.onSessionId((t) => {
      this.fi(t);
    }));
  }
  gi(t) {
    if (this._instance.persistence) {
      var r, n = this._instance.persistence, i = () => {
        var o, s, a, l, c, u, f, d, p, g = (o = t.sessionRecording) == null ? void 0 : o.sampleRate, h = xe(g) ? null : parseFloat(g);
        xe(h) && this.ci();
        var m = (s = t.sessionRecording) == null ? void 0 : s.minimumDurationMilliseconds;
        n.register({ [Su]: !!t.sessionRecording, [Bp]: (a = t.sessionRecording) == null ? void 0 : a.consoleLogRecordingEnabled, [Wp]: ee({ capturePerformance: t.capturePerformance }, (l = t.sessionRecording) == null ? void 0 : l.networkPayloadCapture), [Hp]: (c = t.sessionRecording) == null ? void 0 : c.masking, [jp]: { enabled: (u = t.sessionRecording) == null ? void 0 : u.recordCanvas, fps: (f = t.sessionRecording) == null ? void 0 : f.canvasFps, quality: (d = t.sessionRecording) == null ? void 0 : d.canvasQuality }, [Up]: h, [Gp]: J(m) ? null : m, [qp]: (p = t.sessionRecording) == null ? void 0 : p.scriptConfig });
      };
      i(), (r = this.Kt) == null || r.call(this), this.Kt = this.It.onSessionId(i);
    }
  }
  log(t, r) {
    var n;
    r === void 0 && (r = "log"), (n = this._instance.sessionRecording) == null || n.onRRwebEmit({ type: 6, data: { plugin: "rrweb/console@1", payload: { level: r, trace: [], payload: [JSON.stringify(t)] } }, timestamp: Date.now() });
  }
  li(t) {
    if (!J(Object.assign) && !J(Array.from) && !(this.Et || this._instance.config.disable_session_recording || this._instance.consent.isOptedOut())) {
      var r;
      this.Et = !0, this.It.checkAndGetSessionAndWindowId(), Ns() ? this.mi() : (r = pe.__PosthogExtensions__) == null || r.loadExternalDependency == null || r.loadExternalDependency(this._instance, this.bi, (n) => {
        if (n) return dt.error("could not load recorder", n);
        this.mi();
      }), dt.info("starting"), this.status === Ba && this.pi(t || "recording_initialized");
    }
  }
  get bi() {
    var t;
    return ((t = this._instance) == null || (t = t.persistence) == null || (t = t.get_property(qp)) == null ? void 0 : t.script) || "recorder";
  }
  yi(t) {
    var r;
    return t.type === 3 && FL.indexOf((r = t.data) == null ? void 0 : r.source) !== -1;
  }
  wi(t) {
    var r = this.yi(t);
    r || this.Wt || t.timestamp - this.Gt > this.xt && (this.Wt = !0, clearInterval(this.vi), this.ii("sessionIdle", { eventTimestamp: t.timestamp, lastActivityTimestamp: this.Gt, threshold: this.xt, bufferLength: this.M.data.length, bufferSize: this.M.size }), this.Zt());
    var n = !1;
    if (r && (this.Gt = t.timestamp, this.Wt)) {
      var i = this.Wt === "unknown";
      this.Wt = !1, i || (this.ii("sessionNoLongerIdle", { reason: "user activity", type: t.type }), n = !0);
    }
    if (!this.Wt) {
      var { windowId: o, sessionId: s } = this.It.checkAndGetSessionAndWindowId(!r, t.timestamp), a = this.kt !== s, l = this.oi !== o;
      this.oi = o, this.kt = s, a || l ? (this.stopRecording(), this.startIfEnabledOrStop("session_id_changed")) : n && this.Si();
    }
  }
  $i(t) {
    try {
      return t.rrwebMethod(), !0;
    } catch (r) {
      return this.Ht.length < 10 ? this.Ht.push({ enqueuedAt: t.enqueuedAt || Date.now(), attempt: t.attempt++, rrwebMethod: t.rrwebMethod }) : dt.warn("could not emit queued rrweb event.", r, t), !1;
    }
  }
  ii(t, r) {
    return this.$i(hg(() => Ns().addCustomEvent(t, r)));
  }
  ki() {
    return this.$i(hg(() => Ns().takeFullSnapshot()));
  }
  mi() {
    var t, r, n, i, o = { blockClass: "ph-no-capture", blockSelector: void 0, ignoreClass: "ph-ignore-input", maskTextClass: "ph-mask", maskTextSelector: void 0, maskTextFn: void 0, maskAllInputs: !0, maskInputOptions: { password: !0 }, maskInputFn: void 0, slimDOMOptions: {}, collectFonts: !1, inlineStylesheet: !0, recordCrossOriginIframes: !1 }, s = this._instance.config.session_recording;
    for (var [a, l] of Object.entries(s || {})) a in o && (a === "maskInputOptions" ? o.maskInputOptions = ee({ password: !0 }, l) : o[a] = l);
    this.Ft && this.Ft.enabled && (o.recordCanvas = !0, o.sampling = { canvas: this.Ft.fps }, o.dataURLOptions = { type: "image/webp", quality: this.Ft.quality }), this.Dt && (o.maskAllInputs = (r = this.Dt.maskAllInputs) === null || r === void 0 || r, o.maskTextSelector = (n = this.Dt.maskTextSelector) !== null && n !== void 0 ? n : void 0, o.blockSelector = (i = this.Dt.blockSelector) !== null && i !== void 0 ? i : void 0);
    var c = Ns();
    if (c) {
      this.xi = (t = this.xi) !== null && t !== void 0 ? t : new gL(c, { refillRate: this._instance.config.session_recording.__mutationRateLimiterRefillRate, bucketSize: this._instance.config.session_recording.__mutationRateLimiterBucketSize, onBlockedNode: (f, d) => {
        var p = "Too many mutations on node '" + f + "'. Rate limiting. This could be due to SVG animations or something similar";
        dt.info(p, { node: d }), this.log(So + " " + p, "warn");
      } });
      var u = this.Ei();
      this.ni = c(ee({ emit: (f) => {
        this.onRRwebEmit(f);
      }, plugins: u }, o)), this.Gt = Date.now(), this.Wt = br(this.Wt) ? this.Wt : "unknown", this.ii("$session_options", { sessionRecordingOptions: o, activePlugins: u.map((f) => f == null ? void 0 : f.name) }), this.ii("$posthog_config", { config: this._instance.config });
    } else dt.error("onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.");
  }
  Si() {
    if (this.vi && clearInterval(this.vi), this.Wt !== !0) {
      var t = this.Pt;
      t && (this.vi = setInterval(() => {
        this.ki();
      }, t));
    }
  }
  Ei() {
    var t, r, n = [], i = (t = pe.__PosthogExtensions__) == null || (t = t.rrwebPlugins) == null ? void 0 : t.getRecordConsolePlugin;
    i && this.Ot && n.push(i());
    var o = (r = pe.__PosthogExtensions__) == null || (r = r.rrwebPlugins) == null ? void 0 : r.getRecordNetworkPlugin;
    return this.At && Xt(o) && (!F$.includes(location.hostname) || this._forceAllowLocalhostNetworkCapture ? n.push(o(pL(this._instance.config, this.At))) : dt.info("NetworkCapture not started because we are on localhost.")), n;
  }
  onRRwebEmit(t) {
    var r;
    if (this.Ii(), t && De(t)) {
      if (t.type === zr.Meta) {
        var n = this.di(t.data.href);
        if (this.Pi = n, !n) return;
        t.data.href = n;
      } else this.Ri();
      if (this.Ut.checkUrlTriggerConditions(() => this.Ti(), () => this.Mi(), (d) => this.Ci(d)), !this.Ut.urlBlocked || (i = t).type === zr.Custom && i.data.tag === "recording paused") {
        var i;
        t.type === zr.FullSnapshot && this.Si(), t.type === zr.FullSnapshot && this.jt && this.Rt.triggerStatus(this.sessionId) === mt && this.ai();
        var o = this.xi ? this.xi.throttleMutations(t) : t;
        if (o) {
          var s = function(d) {
            var p = d;
            if (p && De(p) && p.type === 6 && De(p.data) && p.data.plugin === "rrweb/console@1") {
              p.data.payload.payload.length > 10 && (p.data.payload.payload = p.data.payload.payload.slice(0, 10), p.data.payload.payload.push("...[truncated]"));
              for (var g = [], h = 0; h < p.data.payload.payload.length; h++) p.data.payload.payload[h] && p.data.payload.payload[h].length > 2e3 ? g.push(p.data.payload.payload[h].slice(0, 2e3) + "...[truncated]") : g.push(p.data.payload.payload[h]);
              return p.data.payload.payload = g, d;
            }
            return d;
          }(o);
          if (this.wi(s), this.Wt !== !0 || pg(s)) {
            if (pg(s)) {
              var a = s.data.payload;
              if (a) {
                var l = a.lastActivityTimestamp, c = a.threshold;
                s.timestamp = l + c;
              }
            }
            var u = (r = this._instance.config.session_recording.compress_events) === null || r === void 0 || r ? function(d) {
              if (Da(d) < 1024) return d;
              try {
                if (d.type === zr.FullSnapshot) return ee({}, d, { data: In(d.data), cv: "2024-10" });
                if (d.type === zr.IncrementalSnapshot && d.data.source === er.Mutation) return ee({}, d, { cv: "2024-10", data: ee({}, d.data, { texts: In(d.data.texts), attributes: In(d.data.attributes), removes: In(d.data.removes), adds: In(d.data.adds) }) });
                if (d.type === zr.IncrementalSnapshot && d.data.source === er.StyleSheetRule) return ee({}, d, { cv: "2024-10", data: ee({}, d.data, { adds: d.data.adds ? In(d.data.adds) : void 0, removes: d.data.removes ? In(d.data.removes) : void 0 }) });
              } catch (p) {
                dt.error("could not compress event - will use uncompressed event", p);
              }
              return d;
            }(s) : s, f = { $snapshot_bytes: Da(u), $snapshot_data: u, $session_id: this.kt, $window_id: this.oi };
            this.status !== gn ? this.Oi(f) : this.ai();
          }
        }
      }
    }
  }
  Ri() {
    if (!this._instance.config.capture_pageview && A) {
      var t = this.di(A.location.href);
      this.Pi !== t && (this.ii("$url_changed", { href: t }), this.Pi = t);
    }
  }
  Ii() {
    if (this.Ht.length) {
      var t = [...this.Ht];
      this.Ht = [], t.forEach((r) => {
        Date.now() - r.enqueuedAt <= 2e3 && this.$i(r);
      });
    }
  }
  di(t) {
    var r = this._instance.config.session_recording;
    if (r.maskNetworkRequestFn) {
      var n, i = { url: t };
      return (n = i = r.maskNetworkRequestFn(i)) == null ? void 0 : n.url;
    }
    return t;
  }
  ai() {
    return this.M = { size: 0, data: [], sessionId: this.kt, windowId: this.oi }, this.M;
  }
  Zt() {
    this.Fi && (clearTimeout(this.Fi), this.Fi = void 0);
    var t = this.Nt, r = this.Mt, n = pt(r) && r >= 0, i = pt(t) && n && r < t;
    return this.status === Mn || this.status === af || this.status === gn || i ? (this.Fi = setTimeout(() => {
      this.Zt();
    }, 2e3), this.M) : (this.M.data.length > 0 && Fu(this.M).forEach((o) => {
      this.Ai({ $snapshot_bytes: o.size, $snapshot_data: o.data, $session_id: o.sessionId, $window_id: o.windowId, $lib: "web", $lib_version: Dr.LIB_VERSION });
    }), this.ai());
  }
  Oi(t) {
    var r, n = 2 + (((r = this.M) == null ? void 0 : r.data.length) || 0);
    !this.Wt && (this.M.size + t.$snapshot_bytes + n > 943718.4 || this.M.sessionId !== this.kt) && (this.M = this.Zt()), this.M.size += t.$snapshot_bytes, this.M.data.push(t.$snapshot_data), this.Fi || this.Wt || (this.Fi = setTimeout(() => {
      this.Zt();
    }, 2e3));
  }
  Ai(t) {
    this._instance.capture("$snapshot", t, { _url: this._instance.requestRouter.endpointFor("api", this.si), _noTruncate: !0, _batchKey: "recordings", skip_client_rate_limiting: !0 });
  }
  Ci(t) {
    var r;
    this.Rt.triggerStatus(this.sessionId) === mt && ((r = this._instance) == null || (r = r.persistence) == null || r.register({ [t === "url" ? Eu : Cu]: this.kt }), this.Zt(), this.pi(t + "_trigger_matched"));
  }
  Ti() {
    this.Ut.urlBlocked || (this.Ut.urlBlocked = !0, clearInterval(this.vi), dt.info("recording paused due to URL blocker"), this.ii("recording paused", { reason: "url blocker" }));
  }
  Mi() {
    this.Ut.urlBlocked && (this.Ut.urlBlocked = !1, this.ki(), this.Si(), this.ii("recording resumed", { reason: "left blocked url" }), dt.info("recording resumed"));
  }
  hi() {
    this.qt.St.length !== 0 && xe(this.Xt) && (this.Xt = this._instance.on("eventCaptured", (t) => {
      try {
        this.qt.St.includes(t.event) && this.Ci("event");
      } catch (r) {
        dt.error("Could not activate event trigger", r);
      }
    }));
  }
  overrideLinkedFlag() {
    this.Bt.linkedFlagSeen = !0, this.ki(), this.pi("linked_flag_overridden");
  }
  overrideSampling() {
    var t;
    (t = this._instance.persistence) == null || t.register({ [_o]: !0 }), this.ki(), this.pi("sampling_overridden");
  }
  overrideTrigger(t) {
    this.Ci(t);
  }
  pi(t, r) {
    this._instance.register_for_session({ $session_recording_start_reason: t }), dt.info(t.replace("_", " "), r), ve(["recording_initialized", "session_id_changed"], t) || this.ii(t, r);
  }
  get sdkDebugProperties() {
    var { sessionStartTimestamp: t } = this.It.checkAndGetSessionAndWindowId(!0);
    return { $recording_status: this.status, $sdk_debug_replay_internal_buffer_length: this.M.data.length, $sdk_debug_replay_internal_buffer_size: this.M.size, $sdk_debug_current_session_duration: this.Mt, $sdk_debug_session_start: t };
  }
}
var bc = ut("[SegmentIntegration]");
function LL(e, t) {
  var r = e.config.segment;
  if (!r) return t();
  (function(n, i) {
    var o = n.config.segment;
    if (!o) return i();
    var s = (l) => {
      var c = () => l.anonymousId() || an();
      n.config.get_device_id = c, l.id() && (n.register({ distinct_id: l.id(), $device_id: c() }), n.persistence.set_property(Vr, "identified")), i();
    }, a = o.user();
    "then" in a && Xt(a.then) ? a.then((l) => s(l)) : s(a);
  })(e, () => {
    r.register(((n) => {
      Promise && Promise.resolve || bc.warn("This browser does not have Promise support, and can not use the segment integration");
      var i = (o, s) => {
        if (!s) return o;
        o.event.userId || o.event.anonymousId === n.get_distinct_id() || (bc.info("No userId set, resetting PostHog"), n.reset()), o.event.userId && o.event.userId !== n.get_distinct_id() && (bc.info("UserId set, identifying with PostHog"), n.identify(o.event.userId));
        var a = n.calculateEventProperties(s, o.event.properties);
        return o.event.properties = Object.assign({}, a, o.event.properties), o;
      };
      return { name: "PostHog JS", type: "enrichment", version: "1.0.0", isLoaded: () => !0, load: () => Promise.resolve(), track: (o) => i(o, o.event.event), page: (o) => i(o, "$pageview"), identify: (o) => i(o, "$identify"), screen: (o) => i(o, "$screen") };
    })(e)).then(() => {
      t();
    });
  });
}
var v_ = "posthog-js";
function b_(e, t) {
  var { organization: r, projectId: n, prefix: i, severityAllowList: o = ["error"] } = t === void 0 ? {} : t;
  return (s) => {
    var a, l, c, u, f;
    if (!(o === "*" || o.includes(s.level)) || !e.__loaded) return s;
    s.tags || (s.tags = {});
    var d = e.requestRouter.endpointFor("ui", "/project/" + e.config.token + "/person/" + e.get_distinct_id());
    s.tags["PostHog Person URL"] = d, e.sessionRecordingStarted() && (s.tags["PostHog Recording URL"] = e.get_session_replay_url({ withTimestamp: !0 }));
    var p = ((a = s.exception) == null ? void 0 : a.values) || [], g = p.map((m) => ee({}, m, { stacktrace: m.stacktrace ? ee({}, m.stacktrace, { type: "raw", frames: (m.stacktrace.frames || []).map((v) => ee({}, v, { platform: "web:javascript" })) }) : void 0 })), h = { $exception_message: ((l = p[0]) == null ? void 0 : l.value) || s.message, $exception_type: (c = p[0]) == null ? void 0 : c.type, $exception_personURL: d, $exception_level: s.level, $exception_list: g, $sentry_event_id: s.event_id, $sentry_exception: s.exception, $sentry_exception_message: ((u = p[0]) == null ? void 0 : u.value) || s.message, $sentry_exception_type: (f = p[0]) == null ? void 0 : f.type, $sentry_tags: s.tags };
    return r && n && (h.$sentry_url = (i || "https://sentry.io/organizations/") + r + "/issues/?project=" + n + "&query=" + s.event_id), e.exceptions.sendExceptionEvent(h), s;
  };
}
class VL {
  constructor(t, r, n, i, o) {
    this.name = v_, this.setupOnce = function(s) {
      s(b_(t, { organization: r, projectId: n, prefix: i, severityAllowList: o }));
    };
  }
}
var zL = A != null && A.location ? Va(A.location.hash, "__posthog") || Va(location.hash, "state") : null, gg = "_postHogToolbarParams", mg = ut("[Toolbar]"), nn = function(e) {
  return e[e.UNINITIALIZED = 0] = "UNINITIALIZED", e[e.LOADING = 1] = "LOADING", e[e.LOADED = 2] = "LOADED", e;
}(nn || {});
class DL {
  constructor(t) {
    this.instance = t;
  }
  Di(t) {
    pe.ph_toolbar_state = t;
  }
  Li() {
    var t;
    return (t = pe.ph_toolbar_state) !== null && t !== void 0 ? t : nn.UNINITIALIZED;
  }
  maybeLoadToolbar(t, r, n) {
    if (t === void 0 && (t = void 0), r === void 0 && (r = void 0), n === void 0 && (n = void 0), !A || !te) return !1;
    t = t != null ? t : A.location, n = n != null ? n : A.history;
    try {
      if (!r) {
        try {
          A.localStorage.setItem("test", "test"), A.localStorage.removeItem("test");
        } catch (a) {
          return !1;
        }
        r = A == null ? void 0 : A.localStorage;
      }
      var i, o = zL || Va(t.hash, "__posthog") || Va(t.hash, "state"), s = o ? Lp(() => JSON.parse(atob(decodeURIComponent(o)))) || Lp(() => JSON.parse(decodeURIComponent(o))) : null;
      return s && s.action === "ph_authorize" ? ((i = s).source = "url", i && Object.keys(i).length > 0 && (s.desiredHash ? t.hash = s.desiredHash : n ? n.replaceState(n.state, "", t.pathname + t.search) : t.hash = "")) : ((i = JSON.parse(r.getItem(gg) || "{}")).source = "localstorage", delete i.userIntent), !(!i.token || this.instance.config.token !== i.token) && (this.loadToolbar(i), !0);
    } catch (a) {
      return !1;
    }
  }
  Ni(t) {
    var r = pe.ph_load_toolbar || pe.ph_load_editor;
    !xe(r) && Xt(r) ? r(t, this.instance) : mg.warn("No toolbar load function found");
  }
  loadToolbar(t) {
    var r = !(te == null || !te.getElementById(jx));
    if (!A || r) return !1;
    var n = this.instance.requestRouter.region === "custom" && this.instance.config.advanced_disable_toolbar_metrics, i = ee({ token: this.instance.config.token }, t, { apiURL: this.instance.requestRouter.endpointFor("ui") }, n ? { instrument: !1 } : {});
    if (A.localStorage.setItem(gg, JSON.stringify(ee({}, i, { source: void 0 }))), this.Li() === nn.LOADED) this.Ni(i);
    else if (this.Li() === nn.UNINITIALIZED) {
      var o;
      this.Di(nn.LOADING), (o = pe.__PosthogExtensions__) == null || o.loadExternalDependency == null || o.loadExternalDependency(this.instance, "toolbar", (s) => {
        if (s) return mg.error("[Toolbar] Failed to load", s), void this.Di(nn.UNINITIALIZED);
        this.Di(nn.LOADED), this.Ni(i);
      }), Ve(A, "turbolinks:load", () => {
        this.Di(nn.UNINITIALIZED), this.loadToolbar(i);
      });
    }
    return !0;
  }
  ji(t) {
    return this.loadToolbar(t);
  }
  maybeLoadEditor(t, r, n) {
    return t === void 0 && (t = void 0), r === void 0 && (r = void 0), n === void 0 && (n = void 0), this.maybeLoadToolbar(t, r, n);
  }
}
var ML = ut("[TracingHeaders]");
class BL {
  constructor(t) {
    this.zi = void 0, this.Ui = void 0, this.V = () => {
      var r, n;
      J(this.zi) && ((r = pe.__PosthogExtensions__) == null || (r = r.tracingHeadersPatchFns) == null || r._patchXHR(this._instance.sessionManager)), J(this.Ui) && ((n = pe.__PosthogExtensions__) == null || (n = n.tracingHeadersPatchFns) == null || n._patchFetch(this._instance.sessionManager));
    }, this._instance = t;
  }
  G(t) {
    var r, n;
    (r = pe.__PosthogExtensions__) != null && r.tracingHeadersPatchFns && t(), (n = pe.__PosthogExtensions__) == null || n.loadExternalDependency == null || n.loadExternalDependency(this._instance, "tracing-headers", (i) => {
      if (i) return ML.error("failed to load script", i);
      t();
    });
  }
  startIfEnabledOrStop() {
    var t, r;
    this._instance.config.__add_tracing_headers ? this.G(this.V) : ((t = this.zi) == null || t.call(this), (r = this.Ui) == null || r.call(this), this.zi = void 0, this.Ui = void 0);
  }
}
var Qr = ut("[Web Vitals]"), vg = 9e5;
class WL {
  constructor(t) {
    var r;
    this.qi = !1, this.i = !1, this.M = { url: void 0, metrics: [], firstMetricTimestamp: void 0 }, this.Bi = () => {
      clearTimeout(this.Hi), this.M.metrics.length !== 0 && (this._instance.capture("$web_vitals", this.M.metrics.reduce((n, i) => ee({}, n, { ["$web_vitals_" + i.name + "_event"]: ee({}, i), ["$web_vitals_" + i.name + "_value"]: i.value }), {})), this.M = { url: void 0, metrics: [], firstMetricTimestamp: void 0 });
    }, this.Wi = (n) => {
      var i, o = (i = this._instance.sessionManager) == null ? void 0 : i.checkAndGetSessionAndWindowId(!0);
      if (J(o)) Qr.error("Could not read session ID. Dropping metrics!");
      else {
        this.M = this.M || { url: void 0, metrics: [], firstMetricTimestamp: void 0 };
        var s = this.Gi();
        J(s) || (xe(n == null ? void 0 : n.name) || xe(n == null ? void 0 : n.value) ? Qr.error("Invalid metric received", n) : this.Ji && n.value >= this.Ji ? Qr.error("Ignoring metric with value >= " + this.Ji, n) : (this.M.url !== s && (this.Bi(), this.Hi = setTimeout(this.Bi, this.flushToCaptureTimeoutMs)), J(this.M.url) && (this.M.url = s), this.M.firstMetricTimestamp = J(this.M.firstMetricTimestamp) ? Date.now() : this.M.firstMetricTimestamp, n.attribution && n.attribution.interactionTargetElement && (n.attribution.interactionTargetElement = void 0), this.M.metrics.push(ee({}, n, { $current_url: s, $session_id: o.sessionId, $window_id: o.windowId, timestamp: Date.now() })), this.M.metrics.length === this.allowedMetrics.length && this.Bi()));
      }
    }, this.V = () => {
      var n, i, o, s, a = pe.__PosthogExtensions__;
      J(a) || J(a.postHogWebVitalsCallbacks) || ({ onLCP: n, onCLS: i, onFCP: o, onINP: s } = a.postHogWebVitalsCallbacks), n && i && o && s ? (this.allowedMetrics.indexOf("LCP") > -1 && n(this.Wi.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && i(this.Wi.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && o(this.Wi.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && s(this.Wi.bind(this)), this.i = !0) : Qr.error("web vitals callbacks not loaded - not starting");
    }, this._instance = t, this.qi = !((r = this._instance.persistence) == null || !r.props[Dp]), this.startIfEnabled();
  }
  get allowedMetrics() {
    var t, r, n = De(this._instance.config.capture_performance) ? (t = this._instance.config.capture_performance) == null ? void 0 : t.web_vitals_allowed_metrics : void 0;
    return J(n) ? ((r = this._instance.persistence) == null ? void 0 : r.props[Mp]) || ["CLS", "FCP", "INP", "LCP"] : n;
  }
  get flushToCaptureTimeoutMs() {
    return (De(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
  }
  get Ji() {
    var t = De(this._instance.config.capture_performance) && pt(this._instance.config.capture_performance.__web_vitals_max_value) ? this._instance.config.capture_performance.__web_vitals_max_value : vg;
    return 0 < t && t <= 6e4 ? vg : t;
  }
  get isEnabled() {
    var t = wt == null ? void 0 : wt.protocol;
    if (t !== "http:" && t !== "https:") return Qr.info("Web Vitals are disabled on non-http/https protocols"), !1;
    var r = De(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals : br(this._instance.config.capture_performance) ? this._instance.config.capture_performance : void 0;
    return br(r) ? r : this.qi;
  }
  startIfEnabled() {
    this.isEnabled && !this.i && (Qr.info("enabled, starting..."), this.G(this.V));
  }
  onRemoteConfig(t) {
    var r = De(t.capturePerformance) && !!t.capturePerformance.web_vitals, n = De(t.capturePerformance) ? t.capturePerformance.web_vitals_allowed_metrics : void 0;
    this._instance.persistence && (this._instance.persistence.register({ [Dp]: r }), this._instance.persistence.register({ [Mp]: n })), this.qi = r, this.startIfEnabled();
  }
  G(t) {
    var r, n;
    (r = pe.__PosthogExtensions__) != null && r.postHogWebVitalsCallbacks && t(), (n = pe.__PosthogExtensions__) == null || n.loadExternalDependency == null || n.loadExternalDependency(this._instance, "web-vitals", (i) => {
      i ? Qr.error("failed to load script", i) : t();
    });
  }
  Gi() {
    var t = A ? A.location.href : void 0;
    return t || Qr.error("Could not determine current URL"), t;
  }
}
var HL = ut("[Heatmaps]");
function bg(e) {
  return De(e) && "clientX" in e && "clientY" in e && pt(e.clientX) && pt(e.clientY);
}
class jL {
  constructor(t) {
    var r;
    this.rageclicks = new t_(), this.qi = !1, this.i = !1, this.Vi = null, this.instance = t, this.qi = !((r = this.instance.persistence) == null || !r.props[_u]);
  }
  get flushIntervalMilliseconds() {
    var t = 5e3;
    return De(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (t = this.instance.config.capture_heatmaps.flush_interval_milliseconds), t;
  }
  get isEnabled() {
    return J(this.instance.config.capture_heatmaps) ? J(this.instance.config.enable_heatmaps) ? this.qi : this.instance.config.enable_heatmaps : this.instance.config.capture_heatmaps !== !1;
  }
  startIfEnabled() {
    if (this.isEnabled) {
      if (this.i) return;
      HL.info("starting..."), this.Ki(), this.Vi = setInterval(this.Yi.bind(this), this.flushIntervalMilliseconds);
    } else {
      var t, r;
      clearInterval((t = this.Vi) !== null && t !== void 0 ? t : void 0), (r = this.Xi) == null || r.stop(), this.getAndClearBuffer();
    }
  }
  onRemoteConfig(t) {
    var r = !!t.heatmaps;
    this.instance.persistence && this.instance.persistence.register({ [_u]: r }), this.qi = r, this.startIfEnabled();
  }
  getAndClearBuffer() {
    var t = this.M;
    return this.M = void 0, t;
  }
  Qi(t) {
    this.Zi(t.originalEvent, "deadclick");
  }
  Ki() {
    A && te && (Ve(A, "beforeunload", this.Yi.bind(this)), Ve(te, "click", (t) => this.Zi(t || (A == null ? void 0 : A.event)), { capture: !0 }), Ve(te, "mousemove", (t) => this.te(t || (A == null ? void 0 : A.event)), { capture: !0 }), this.Xi = new n_(this.instance, K$, this.Qi.bind(this)), this.Xi.startIfEnabled(), this.i = !0);
  }
  ie(t, r) {
    var n = this.instance.scrollManager.scrollY(), i = this.instance.scrollManager.scrollX(), o = this.instance.scrollManager.scrollElement(), s = function(a, l, c) {
      for (var u = a; u && Sl(u) && !dn(u, "body"); ) {
        if (u === c) return !1;
        if (ve(l, A == null ? void 0 : A.getComputedStyle(u).position)) return !0;
        u = Yx(u);
      }
      return !1;
    }(Kx(t), ["fixed", "sticky"], o);
    return { x: t.clientX + (s ? 0 : i), y: t.clientY + (s ? 0 : n), target_fixed: s, type: r };
  }
  Zi(t, r) {
    var n;
    if (r === void 0 && (r = "click"), !Yp(t.target) && bg(t)) {
      var i = this.ie(t, r);
      (n = this.rageclicks) != null && n.isRageClick(t.clientX, t.clientY, (/* @__PURE__ */ new Date()).getTime()) && this.ee(ee({}, i, { type: "rageclick" })), this.ee(i);
    }
  }
  te(t) {
    !Yp(t.target) && bg(t) && (clearTimeout(this.re), this.re = setTimeout(() => {
      this.ee(this.ie(t, "mousemove"));
    }, 500));
  }
  ee(t) {
    if (A) {
      var r = A.location.href;
      this.M = this.M || {}, this.M[r] || (this.M[r] = []), this.M[r].push(t);
    }
  }
  Yi() {
    this.M && !pi(this.M) && this.instance.capture("$$heatmap", { $heatmap_data: this.getAndClearBuffer() });
  }
}
class UL {
  constructor(t) {
    this._instance = t;
  }
  doPageView(t, r) {
    var n, i = this.se(t, r);
    return this.ne = { pathname: (n = A == null ? void 0 : A.location.pathname) !== null && n !== void 0 ? n : "", pageViewId: r, timestamp: t }, this._instance.scrollManager.resetContext(), i;
  }
  doPageLeave(t) {
    var r;
    return this.se(t, (r = this.ne) == null ? void 0 : r.pageViewId);
  }
  doEvent() {
    var t;
    return { $pageview_id: (t = this.ne) == null ? void 0 : t.pageViewId };
  }
  se(t, r) {
    var n = this.ne;
    if (!n) return { $pageview_id: r };
    var i = { $pageview_id: r, $prev_pageview_id: n.pageViewId }, o = this._instance.scrollManager.getContext();
    if (o && !this._instance.config.disable_scroll_properties) {
      var { maxScrollHeight: s, lastScrollY: a, maxScrollY: l, maxContentHeight: c, lastContentY: u, maxContentY: f } = o;
      if (!(J(s) || J(a) || J(l) || J(c) || J(u) || J(f))) {
        s = Math.ceil(s), a = Math.ceil(a), l = Math.ceil(l), c = Math.ceil(c), u = Math.ceil(u), f = Math.ceil(f);
        var d = s <= 1 ? 1 : Kt(a / s, 0, 1), p = s <= 1 ? 1 : Kt(l / s, 0, 1), g = c <= 1 ? 1 : Kt(u / c, 0, 1), h = c <= 1 ? 1 : Kt(f / c, 0, 1);
        i = Ue(i, { $prev_pageview_last_scroll: a, $prev_pageview_last_scroll_percentage: d, $prev_pageview_max_scroll: l, $prev_pageview_max_scroll_percentage: p, $prev_pageview_last_content: u, $prev_pageview_last_content_percentage: g, $prev_pageview_max_content: f, $prev_pageview_max_content_percentage: h });
      }
    }
    return n.pathname && (i.$prev_pageview_pathname = n.pathname), n.timestamp && (i.$prev_pageview_duration = (t.getTime() - n.timestamp.getTime()) / 1e3), i;
  }
}
var GL = function(e) {
  var t, r, n, i, o = "";
  for (t = r = 0, n = (e = (e + "").replace(/\r\n/g, `
`).replace(/\r/g, `
`)).length, i = 0; i < n; i++) {
    var s = e.charCodeAt(i), a = null;
    s < 128 ? r++ : a = s > 127 && s < 2048 ? String.fromCharCode(s >> 6 | 192, 63 & s | 128) : String.fromCharCode(s >> 12 | 224, s >> 6 & 63 | 128, 63 & s | 128), xn(a) || (r > t && (o += e.substring(t, r)), o += a, t = r = i + 1);
  }
  return r > t && (o += e.substring(t, e.length)), o;
}, qL = !!bu || !!vu, yg = "text/plain", Wa = (e, t) => {
  var [r, n] = e.split("?"), i = ee({}, t);
  n == null || n.split("&").forEach((s) => {
    var [a] = s.split("=");
    delete i[a];
  });
  var o = $$(i);
  return r + "?" + (o = o ? (n ? n + "&" : "") + o : n);
}, Eo = (e, t) => JSON.stringify(e, (r, n) => typeof n == "bigint" ? n.toString() : n, t), yc = (e) => {
  var { data: t, compression: r } = e;
  if (t) {
    if (r === Mr.GZipJS) {
      var n = h_(p_(Eo(t)), { mtime: 0 }), i = new Blob([n], { type: yg });
      return { contentType: yg, body: i, estimatedSize: i.size };
    }
    if (r === Mr.Base64) {
      var o = function(l) {
        var c, u, f, d, p, g = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", h = 0, m = 0, v = "", y = [];
        if (!l) return l;
        l = GL(l);
        do
          c = (p = l.charCodeAt(h++) << 16 | l.charCodeAt(h++) << 8 | l.charCodeAt(h++)) >> 18 & 63, u = p >> 12 & 63, f = p >> 6 & 63, d = 63 & p, y[m++] = g.charAt(c) + g.charAt(u) + g.charAt(f) + g.charAt(d);
        while (h < l.length);
        switch (v = y.join(""), l.length % 3) {
          case 1:
            v = v.slice(0, -2) + "==";
            break;
          case 2:
            v = v.slice(0, -1) + "=";
        }
        return v;
      }(Eo(t)), s = ((l) => "data=" + encodeURIComponent(typeof l == "string" ? l : Eo(l)))(o);
      return { contentType: "application/x-www-form-urlencoded", body: s, estimatedSize: new Blob([s]).size };
    }
    var a = Eo(t);
    return { contentType: "application/json", body: a, estimatedSize: new Blob([a]).size };
  }
}, Ao = [];
vu && Ao.push({ transport: "fetch", method: (e) => {
  var t, r, { contentType: n, body: i, estimatedSize: o } = (t = yc(e)) !== null && t !== void 0 ? t : {}, s = new Headers();
  Oe(e.headers, function(u, f) {
    s.append(f, u);
  }), n && s.append("Content-Type", n);
  var a = e.url, l = null;
  if (Fp) {
    var c = new Fp();
    l = { signal: c.signal, timeout: setTimeout(() => c.abort(), e.timeout) };
  }
  vu(a, ee({ method: (e == null ? void 0 : e.method) || "GET", headers: s, keepalive: e.method === "POST" && (o || 0) < 52428.8, body: i, signal: (r = l) == null ? void 0 : r.signal }, e.fetchOptions)).then((u) => u.text().then((f) => {
    var d = { statusCode: u.status, text: f };
    if (u.status === 200) try {
      d.json = JSON.parse(f);
    } catch (p) {
      re.error(p);
    }
    e.callback == null || e.callback(d);
  })).catch((u) => {
    re.error(u), e.callback == null || e.callback({ statusCode: 0, text: u });
  }).finally(() => l ? clearTimeout(l.timeout) : null);
} }), bu && Ao.push({ transport: "XHR", method: (e) => {
  var t, r = new bu();
  r.open(e.method || "GET", e.url, !0);
  var { contentType: n, body: i } = (t = yc(e)) !== null && t !== void 0 ? t : {};
  Oe(e.headers, function(o, s) {
    r.setRequestHeader(s, o);
  }), n && r.setRequestHeader("Content-Type", n), e.timeout && (r.timeout = e.timeout), r.withCredentials = !0, r.onreadystatechange = () => {
    if (r.readyState === 4) {
      var o = { statusCode: r.status, text: r.responseText };
      if (r.status === 200) try {
        o.json = JSON.parse(r.responseText);
      } catch (s) {
      }
      e.callback == null || e.callback(o);
    }
  }, r.send(i);
} }), Vt != null && Vt.sendBeacon && Ao.push({ transport: "sendBeacon", method: (e) => {
  var t = Wa(e.url, { beacon: "1" });
  try {
    var r, { contentType: n, body: i } = (r = yc(e)) !== null && r !== void 0 ? r : {}, o = typeof i == "string" ? new Blob([i], { type: n }) : i;
    Vt.sendBeacon(t, o);
  } catch (s) {
  }
} });
var Pi = function(e, t) {
  if (!function(r) {
    try {
      new RegExp(r);
    } catch (n) {
      return !1;
    }
    return !0;
  }(t)) return !1;
  try {
    return new RegExp(t).test(e);
  } catch (r) {
    return !1;
  }
};
function xg(e, t, r) {
  return Eo({ distinct_id: e, userPropertiesToSet: t, userPropertiesToSetOnce: r });
}
var KL = { exact: (e, t) => t.some((r) => e.some((n) => r === n)), is_not: (e, t) => t.every((r) => e.every((n) => r !== n)), regex: (e, t) => t.some((r) => e.some((n) => Pi(r, n))), not_regex: (e, t) => t.every((r) => e.every((n) => !Pi(r, n))), icontains: (e, t) => t.map(Fs).some((r) => e.map(Fs).some((n) => r.includes(n))), not_icontains: (e, t) => t.map(Fs).every((r) => e.map(Fs).every((n) => !r.includes(n))) }, Fs = (e) => e.toLowerCase(), YL = ut("[Error tracking]");
class XL {
  constructor(t) {
    var r, n;
    this.oe = [], this._instance = t, this.oe = (r = (n = this._instance.persistence) == null ? void 0 : n.get_property(wu)) !== null && r !== void 0 ? r : [];
  }
  onRemoteConfig(t) {
    var r, n, i = (r = (n = t.errorTracking) == null ? void 0 : n.suppressionRules) !== null && r !== void 0 ? r : [];
    this.oe = i, this._instance.persistence && this._instance.persistence.register({ [wu]: this.oe });
  }
  sendExceptionEvent(t) {
    this.ae(t) ? YL.info("Skipping exception capture because a suppression rule matched") : this._instance.capture("$exception", t, { _noTruncate: !0, _batchKey: "exceptionEvent" });
  }
  ae(t) {
    var r = t.$exception_list;
    if (!r || !Fe(r) || r.length === 0) return !1;
    var n = r.reduce((i, o) => {
      var { type: s, value: a } = o;
      return Me(s) && s.length > 0 && i.$exception_types.push(s), Me(a) && a.length > 0 && i.$exception_values.push(a), i;
    }, { $exception_types: [], $exception_values: [] });
    return this.oe.some((i) => {
      var o = i.values.map((s) => {
        var a, l = KL[s.operator], c = Fe(s.value) ? s.value : [s.value], u = (a = n[s.key]) !== null && a !== void 0 ? a : [];
        return c.length > 0 && l(c, u);
      });
      return i.type === "OR" ? o.some(Boolean) : o.every(Boolean);
    });
  }
}
var Zt = "Mobile", Ha = "iOS", yr = "Android", jo = "Tablet", y_ = yr + " " + jo, x_ = "iPad", __ = "Apple", w_ = __ + " Watch", Uo = "Safari", Ti = "BlackBerry", S_ = "Samsung", E_ = S_ + "Browser", C_ = S_ + " Internet", Bn = "Chrome", JL = Bn + " OS", k_ = Bn + " " + Ha, cf = "Internet Explorer", I_ = cf + " " + Zt, uf = "Opera", ZL = uf + " Mini", df = "Edge", O_ = "Microsoft " + df, xi = "Firefox", P_ = xi + " " + Ha, Go = "Nintendo", qo = "PlayStation", _i = "Xbox", T_ = yr + " " + Zt, R_ = Zt + " " + Uo, Co = "Windows", Bu = Co + " Phone", _g = "Nokia", Wu = "Ouya", A_ = "Generic", QL = A_ + " " + Zt.toLowerCase(), N_ = A_ + " " + jo.toLowerCase(), Hu = "Konqueror", yt = "(\\d+(\\.\\d+)?)", xc = new RegExp("Version/" + yt), e5 = new RegExp(_i, "i"), t5 = new RegExp(qo + " \\w+", "i"), r5 = new RegExp(Go + " \\w+", "i"), ff = new RegExp(Ti + "|PlayBook|BB10", "i"), n5 = { "NT3.51": "NT 3.11", "NT4.0": "NT 4.0", "5.0": "2000", 5.1: "XP", 5.2: "XP", "6.0": "Vista", 6.1: "7", 6.2: "8", 6.3: "8.1", 6.4: "10", "10.0": "10" }, i5 = (e, t) => t && ve(t, __) || function(r) {
  return ve(r, Uo) && !ve(r, Bn) && !ve(r, yr);
}(e), F_ = function(e, t) {
  return t = t || "", ve(e, " OPR/") && ve(e, "Mini") ? ZL : ve(e, " OPR/") ? uf : ff.test(e) ? Ti : ve(e, "IE" + Zt) || ve(e, "WPDesktop") ? I_ : ve(e, E_) ? C_ : ve(e, df) || ve(e, "Edg/") ? O_ : ve(e, "FBIOS") ? "Facebook " + Zt : ve(e, "UCWEB") || ve(e, "UCBrowser") ? "UC Browser" : ve(e, "CriOS") ? k_ : ve(e, "CrMo") || ve(e, Bn) ? Bn : ve(e, yr) && ve(e, Uo) ? T_ : ve(e, "FxiOS") ? P_ : ve(e.toLowerCase(), Hu.toLowerCase()) ? Hu : i5(e, t) ? ve(e, Zt) ? R_ : Uo : ve(e, xi) ? xi : ve(e, "MSIE") || ve(e, "Trident/") ? cf : ve(e, "Gecko") ? xi : "";
}, o5 = { [I_]: [new RegExp("rv:" + yt)], [O_]: [new RegExp(df + "?\\/" + yt)], [Bn]: [new RegExp("(" + Bn + "|CrMo)\\/" + yt)], [k_]: [new RegExp("CriOS\\/" + yt)], "UC Browser": [new RegExp("(UCBrowser|UCWEB)\\/" + yt)], [Uo]: [xc], [R_]: [xc], [uf]: [new RegExp("(Opera|OPR)\\/" + yt)], [xi]: [new RegExp(xi + "\\/" + yt)], [P_]: [new RegExp("FxiOS\\/" + yt)], [Hu]: [new RegExp("Konqueror[:/]?" + yt, "i")], [Ti]: [new RegExp(Ti + " " + yt), xc], [T_]: [new RegExp("android\\s" + yt, "i")], [C_]: [new RegExp(E_ + "\\/" + yt)], [cf]: [new RegExp("(rv:|MSIE )" + yt)], Mozilla: [new RegExp("rv:" + yt)] }, s5 = function(e, t) {
  var r = F_(e, t), n = o5[r];
  if (J(n)) return null;
  for (var i = 0; i < n.length; i++) {
    var o = n[i], s = e.match(o);
    if (s) return parseFloat(s[s.length - 2]);
  }
  return null;
}, wg = [[new RegExp(_i + "; " + _i + " (.*?)[);]", "i"), (e) => [_i, e && e[1] || ""]], [new RegExp(Go, "i"), [Go, ""]], [new RegExp(qo, "i"), [qo, ""]], [ff, [Ti, ""]], [new RegExp(Co, "i"), (e, t) => {
  if (/Phone/.test(t) || /WPDesktop/.test(t)) return [Bu, ""];
  if (new RegExp(Zt).test(t) && !/IEMobile\b/.test(t)) return [Co + " " + Zt, ""];
  var r = /Windows NT ([0-9.]+)/i.exec(t);
  if (r && r[1]) {
    var n = r[1], i = n5[n] || "";
    return /arm/i.test(t) && (i = "RT"), [Co, i];
  }
  return [Co, ""];
}], [/((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/, (e) => {
  if (e && e[3]) {
    var t = [e[3], e[4], e[5] || "0"];
    return [Ha, t.join(".")];
  }
  return [Ha, ""];
}], [/(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i, (e) => {
  var t = "";
  return e && e.length >= 3 && (t = J(e[2]) ? e[3] : e[2]), ["watchOS", t];
}], [new RegExp("(" + yr + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + yr + ")", "i"), (e) => {
  if (e && e[2]) {
    var t = [e[2], e[3], e[4] || "0"];
    return [yr, t.join(".")];
  }
  return [yr, ""];
}], [/Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i, (e) => {
  var t = ["Mac OS X", ""];
  if (e && e[1]) {
    var r = [e[1], e[2], e[3] || "0"];
    t[1] = r.join(".");
  }
  return t;
}], [/Mac/i, ["Mac OS X", ""]], [/CrOS/, [JL, ""]], [/Linux|debian/i, ["Linux", ""]]], Sg = function(e) {
  return r5.test(e) ? Go : t5.test(e) ? qo : e5.test(e) ? _i : new RegExp(Wu, "i").test(e) ? Wu : new RegExp("(" + Bu + "|WPDesktop)", "i").test(e) ? Bu : /iPad/.test(e) ? x_ : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(e) ? w_ : ff.test(e) ? Ti : /(kobo)\s(ereader|touch)/i.test(e) ? "Kobo" : new RegExp(_g, "i").test(e) ? _g : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(e) || /(kf[a-z]+)( bui|\)).+silk\//i.test(e) ? "Kindle Fire" : /(Android|ZTE)/i.test(e) ? !new RegExp(Zt).test(e) || /(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(e) ? /pixel[\daxl ]{1,6}/i.test(e) && !/pixel c/i.test(e) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(e) || /lmy47v/i.test(e) && !/QTAQZ3/i.test(e) ? yr : y_ : yr : new RegExp("(pda|" + Zt + ")", "i").test(e) ? QL : new RegExp(jo, "i").test(e) && !new RegExp(jo + " pc", "i").test(e) ? N_ : "";
}, $s = "https?://(.*)", Cl = ["gclid", "gclsrc", "dclid", "gbraid", "wbraid", "fbclid", "msclkid", "twclid", "li_fat_id", "igshid", "ttclid", "rdt_cid", "epik", "qclid", "sccid", "irclid", "_kx"], a5 = wl(["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gad_source", "mc_cid"], Cl), hf = "<masked>";
function $_(e, t, r) {
  if (!te) return {};
  var n = t ? wl([], Cl, r || []) : [];
  return L_(tf(te.URL, n, hf), e);
}
function L_(e, t) {
  var r = a5.concat(t || []), n = {};
  return Oe(r, function(i) {
    var o = La(e, i);
    n[i] = o || null;
  }), n;
}
function V_(e) {
  var t = function(o) {
    return o ? o.search($s + "google.([^/?]*)") === 0 ? "google" : o.search($s + "bing.com") === 0 ? "bing" : o.search($s + "yahoo.com") === 0 ? "yahoo" : o.search($s + "duckduckgo.com") === 0 ? "duckduckgo" : null : null;
  }(e), r = t != "yahoo" ? "q" : "p", n = {};
  if (!xn(t)) {
    n.$search_engine = t;
    var i = te ? La(te.referrer, r) : "";
    i.length && (n.ph_keyword = i);
  }
  return n;
}
function Eg() {
  return navigator.language || navigator.userLanguage;
}
function z_() {
  return (te == null ? void 0 : te.referrer) || "$direct";
}
function D_(e, t) {
  var r = e ? wl([], Cl, t || []) : [], n = wt == null ? void 0 : wt.href.substring(0, 1e3);
  return { r: z_().substring(0, 1e3), u: n ? tf(n, r, hf) : void 0 };
}
function M_(e) {
  var t, { r, u: n } = e, i = { $referrer: r, $referring_domain: r == null ? void 0 : r == "$direct" ? "$direct" : (t = Ii(r)) == null ? void 0 : t.host };
  if (n) {
    i.$current_url = n;
    var o = Ii(n);
    i.$host = o == null ? void 0 : o.host, i.$pathname = o == null ? void 0 : o.pathname;
    var s = L_(n);
    Ue(i, s);
  }
  if (r) {
    var a = V_(r);
    Ue(i, a);
  }
  return i;
}
function B_() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    return;
  }
}
function l5() {
  try {
    return (/* @__PURE__ */ new Date()).getTimezoneOffset();
  } catch (e) {
    return;
  }
}
function c5(e, t) {
  if (!_t) return {};
  var r, n, i, o = e ? wl([], Cl, t || []) : [], [s, a] = function(l) {
    for (var c = 0; c < wg.length; c++) {
      var [u, f] = wg[c], d = u.exec(l), p = d && (Xt(f) ? f(d, l) : f);
      if (p) return p;
    }
    return ["", ""];
  }(_t);
  return Ue(Qd({ $os: s, $os_version: a, $browser: F_(_t, navigator.vendor), $device: Sg(_t), $device_type: (n = _t, i = Sg(n), i === x_ || i === y_ || i === "Kobo" || i === "Kindle Fire" || i === N_ ? jo : i === Go || i === _i || i === qo || i === Wu ? "Console" : i === w_ ? "Wearable" : i ? Zt : "Desktop"), $timezone: B_(), $timezone_offset: l5() }), { $current_url: tf(wt == null ? void 0 : wt.href, o, hf), $host: wt == null ? void 0 : wt.host, $pathname: wt == null ? void 0 : wt.pathname, $raw_user_agent: _t.length > 1e3 ? _t.substring(0, 997) + "..." : _t, $browser_version: s5(_t, navigator.vendor), $browser_language: Eg(), $browser_language_prefix: (r = Eg(), typeof r == "string" ? r.split("-")[0] : void 0), $screen_height: A == null ? void 0 : A.screen.height, $screen_width: A == null ? void 0 : A.screen.width, $viewport_height: A == null ? void 0 : A.innerHeight, $viewport_width: A == null ? void 0 : A.innerWidth, $lib: "web", $lib_version: Dr.LIB_VERSION, $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10), $time: Date.now() / 1e3 });
}
var hr = ut("[FeatureFlags]"), _c = "$active_feature_flags", oi = "$override_feature_flags", Cg = "$feature_flag_payloads", lo = "$override_feature_flag_payloads", kg = "$feature_flag_request_id", Ig = (e) => {
  var t = {};
  for (var [r, n] of na(e || {})) n && (t[r] = n);
  return t;
}, u5 = (e) => {
  var t = e.flags;
  return t ? (e.featureFlags = Object.fromEntries(Object.keys(t).map((r) => {
    var n;
    return [r, (n = t[r].variant) !== null && n !== void 0 ? n : t[r].enabled];
  })), e.featureFlagPayloads = Object.fromEntries(Object.keys(t).filter((r) => t[r].enabled).filter((r) => {
    var n;
    return (n = t[r].metadata) == null ? void 0 : n.payload;
  }).map((r) => {
    var n;
    return [r, (n = t[r].metadata) == null ? void 0 : n.payload];
  }))) : hr.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), e;
}, d5 = function(e) {
  return e.FeatureFlags = "feature_flags", e.Recordings = "recordings", e;
}({});
class f5 {
  constructor(t) {
    this.le = !1, this.ue = !1, this.he = !1, this.de = !1, this.ve = !1, this.ce = !1, this.fe = !1, this._instance = t, this.featureFlagEventHandlers = [];
  }
  decide() {
    if (this._instance.config.__preview_remote_config) this.ce = !0;
    else {
      var t = !this.pe && (this._instance.config.advanced_disable_feature_flags || this._instance.config.advanced_disable_feature_flags_on_first_load);
      this._e({ disableFlags: t });
    }
  }
  get hasLoadedFlags() {
    return this.ue;
  }
  getFlags() {
    return Object.keys(this.getFlagVariants());
  }
  getFlagsWithDetails() {
    var t = this._instance.get_property(ku), r = this._instance.get_property(oi), n = this._instance.get_property(lo);
    if (!n && !r) return t || {};
    var i = Ue({}, t || {}), o = [.../* @__PURE__ */ new Set([...Object.keys(n || {}), ...Object.keys(r || {})])];
    for (var s of o) {
      var a, l, c = i[s], u = r == null ? void 0 : r[s], f = J(u) ? (a = c == null ? void 0 : c.enabled) !== null && a !== void 0 && a : !!u, d = J(u) ? c.variant : typeof u == "string" ? u : void 0, p = n == null ? void 0 : n[s], g = ee({}, c, { enabled: f, variant: f ? d != null ? d : c == null ? void 0 : c.variant : void 0 });
      f !== (c == null ? void 0 : c.enabled) && (g.original_enabled = c == null ? void 0 : c.enabled), d !== (c == null ? void 0 : c.variant) && (g.original_variant = c == null ? void 0 : c.variant), p && (g.metadata = ee({}, c == null ? void 0 : c.metadata, { payload: p, original_payload: c == null || (l = c.metadata) == null ? void 0 : l.payload })), i[s] = g;
    }
    return this.le || (hr.warn(" Overriding feature flag details!", { flagDetails: t, overriddenPayloads: n, finalDetails: i }), this.le = !0), i;
  }
  getFlagVariants() {
    var t = this._instance.get_property(gi), r = this._instance.get_property(oi);
    if (!r) return t || {};
    for (var n = Ue({}, t), i = Object.keys(r), o = 0; o < i.length; o++) n[i[o]] = r[i[o]];
    return this.le || (hr.warn(" Overriding feature flags!", { enabledFlags: t, overriddenFlags: r, finalFlags: n }), this.le = !0), n;
  }
  getFlagPayloads() {
    var t = this._instance.get_property(Cg), r = this._instance.get_property(lo);
    if (!r) return t || {};
    for (var n = Ue({}, t || {}), i = Object.keys(r), o = 0; o < i.length; o++) n[i[o]] = r[i[o]];
    return this.le || (hr.warn(" Overriding feature flag payloads!", { flagPayloads: t, overriddenPayloads: r, finalPayloads: n }), this.le = !0), n;
  }
  reloadFeatureFlags() {
    this.de || this._instance.config.advanced_disable_feature_flags || this.pe || (this.pe = setTimeout(() => {
      this._e();
    }, 5));
  }
  ge() {
    clearTimeout(this.pe), this.pe = void 0;
  }
  ensureFlagsLoaded() {
    this.ue || this.he || this.pe || this.reloadFeatureFlags();
  }
  setAnonymousDistinctId(t) {
    this.$anon_distinct_id = t;
  }
  setReloadingPaused(t) {
    this.de = t;
  }
  _e(t) {
    var r;
    if (this.ge(), !this._instance.config.advanced_disable_decide) if (this.he) this.ve = !0;
    else {
      var n = { token: this._instance.config.token, distinct_id: this._instance.get_distinct_id(), groups: this._instance.getGroups(), $anon_distinct_id: this.$anon_distinct_id, person_properties: ee({}, ((r = this._instance.persistence) == null ? void 0 : r.get_initial_props()) || {}, this._instance.get_property(wo) || {}), group_properties: this._instance.get_property(Pn) };
      (t != null && t.disableFlags || this._instance.config.advanced_disable_feature_flags) && (n.disable_flags = !0);
      var i = this._instance.config.__preview_flags_v2 && this._instance.config.__preview_remote_config, o = i ? "/flags/?v=2" : "/decide/?v=4", s = this._instance.config.advanced_only_evaluate_survey_feature_flags ? "&only_evaluate_survey_feature_flags=true" : "", a = this._instance.requestRouter.endpointFor("api", o + s);
      i && (n.timezone = B_()), this.he = !0, this._instance.me({ method: "POST", url: a, data: n, compression: this._instance.config.disable_compression ? void 0 : Mr.Base64, timeout: this._instance.config.feature_flag_request_timeout_ms, callback: (l) => {
        var c, u, f = !0;
        if (l.statusCode === 200 && (this.ve || (this.$anon_distinct_id = void 0), f = !1), this.he = !1, this.ce || (this.ce = !0, this._instance.be((u = l.json) !== null && u !== void 0 ? u : {})), !n.disable_flags || this.ve) if (this.fe = !f, l.json && (c = l.json.quotaLimited) != null && c.includes(d5.FeatureFlags)) hr.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.");
        else {
          var d;
          n.disable_flags || this.receivedFeatureFlags((d = l.json) !== null && d !== void 0 ? d : {}, f), this.ve && (this.ve = !1, this._e());
        }
      } });
    }
  }
  getFeatureFlag(t, r) {
    if (r === void 0 && (r = {}), this.ue || this.getFlags() && this.getFlags().length > 0) {
      var n = this.getFlagVariants()[t], i = "" + n, o = this._instance.get_property(kg) || void 0, s = this._instance.get_property(Aa) || {};
      if ((r.send_event || !("send_event" in r)) && (!(t in s) || !s[t].includes(i))) {
        var a, l, c, u, f, d, p, g, h;
        Fe(s[t]) ? s[t].push(i) : s[t] = [i], (a = this._instance.persistence) == null || a.register({ [Aa]: s });
        var m = this.getFeatureFlagDetails(t), v = { $feature_flag: t, $feature_flag_response: n, $feature_flag_payload: this.getFeatureFlagPayload(t) || null, $feature_flag_request_id: o, $feature_flag_bootstrapped_response: ((l = this._instance.config.bootstrap) == null || (l = l.featureFlags) == null ? void 0 : l[t]) || null, $feature_flag_bootstrapped_payload: ((c = this._instance.config.bootstrap) == null || (c = c.featureFlagPayloads) == null ? void 0 : c[t]) || null, $used_bootstrap_value: !this.fe };
        J(m == null || (u = m.metadata) == null ? void 0 : u.version) || (v.$feature_flag_version = m.metadata.version);
        var y, x = (f = m == null || (d = m.reason) == null ? void 0 : d.description) !== null && f !== void 0 ? f : m == null || (p = m.reason) == null ? void 0 : p.code;
        x && (v.$feature_flag_reason = x), m != null && (g = m.metadata) != null && g.id && (v.$feature_flag_id = m.metadata.id), J(m == null ? void 0 : m.original_variant) && J(m == null ? void 0 : m.original_enabled) || (v.$feature_flag_original_response = J(m.original_variant) ? m.original_enabled : m.original_variant), m != null && (h = m.metadata) != null && h.original_payload && (v.$feature_flag_original_payload = m == null || (y = m.metadata) == null ? void 0 : y.original_payload), this._instance.capture("$feature_flag_called", v);
      }
      return n;
    }
    hr.warn('getFeatureFlag for key "' + t + `" failed. Feature flags didn't load in time.`);
  }
  getFeatureFlagDetails(t) {
    return this.getFlagsWithDetails()[t];
  }
  getFeatureFlagPayload(t) {
    return this.getFlagPayloads()[t];
  }
  getRemoteConfigPayload(t, r) {
    var n = this._instance.config.token;
    this._instance.me({ method: "POST", url: this._instance.requestRouter.endpointFor("api", "/decide/?v=4"), data: { distinct_id: this._instance.get_distinct_id(), token: n }, compression: this._instance.config.disable_compression ? void 0 : Mr.Base64, timeout: this._instance.config.feature_flag_request_timeout_ms, callback: (i) => {
      var o, s = (o = i.json) == null ? void 0 : o.featureFlagPayloads;
      r((s == null ? void 0 : s[t]) || void 0);
    } });
  }
  isFeatureEnabled(t, r) {
    if (r === void 0 && (r = {}), this.ue || this.getFlags() && this.getFlags().length > 0) return !!this.getFeatureFlag(t, r);
    hr.warn('isFeatureEnabled for key "' + t + `" failed. Feature flags didn't load in time.`);
  }
  addFeatureFlagsHandler(t) {
    this.featureFlagEventHandlers.push(t);
  }
  removeFeatureFlagsHandler(t) {
    this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((r) => r !== t);
  }
  receivedFeatureFlags(t, r) {
    if (this._instance.persistence) {
      this.ue = !0;
      var n = this.getFlagVariants(), i = this.getFlagPayloads(), o = this.getFlagsWithDetails();
      (function(s, a, l, c, u) {
        l === void 0 && (l = {}), c === void 0 && (c = {}), u === void 0 && (u = {});
        var f = u5(s), d = f.flags, p = f.featureFlags, g = f.featureFlagPayloads;
        if (p) {
          var h = s.requestId;
          if (Fe(p)) {
            hr.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
            var m = {};
            if (p) for (var v = 0; v < p.length; v++) m[p[v]] = !0;
            a && a.register({ [_c]: p, [gi]: m });
          } else {
            var y = p, x = g, S = d;
            s.errorsWhileComputingFlags && (y = ee({}, l, y), x = ee({}, c, x), S = ee({}, u, S)), a && a.register(ee({ [_c]: Object.keys(Ig(y)), [gi]: y || {}, [Cg]: x || {}, [ku]: S || {} }, h ? { [kg]: h } : {}));
          }
        }
      })(t, this._instance.persistence, n, i, o), this.ye(r);
    }
  }
  override(t, r) {
    r === void 0 && (r = !1), hr.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({ flags: t, suppressWarning: r });
  }
  overrideFeatureFlags(t) {
    if (!this._instance.__loaded || !this._instance.persistence) return hr.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
    if (t === !1) return this._instance.persistence.unregister(oi), this._instance.persistence.unregister(lo), void this.ye();
    if (t && typeof t == "object" && ("flags" in t || "payloads" in t)) {
      var r, n = t;
      if (this.le = !!((r = n.suppressWarning) !== null && r !== void 0 && r), "flags" in n) {
        if (n.flags === !1) this._instance.persistence.unregister(oi);
        else if (n.flags) if (Fe(n.flags)) {
          for (var i = {}, o = 0; o < n.flags.length; o++) i[n.flags[o]] = !0;
          this._instance.persistence.register({ [oi]: i });
        } else this._instance.persistence.register({ [oi]: n.flags });
      }
      return "payloads" in n && (n.payloads === !1 ? this._instance.persistence.unregister(lo) : n.payloads && this._instance.persistence.register({ [lo]: n.payloads })), void this.ye();
    }
    this.ye();
  }
  onFeatureFlags(t) {
    if (this.addFeatureFlagsHandler(t), this.ue) {
      var { flags: r, flagVariants: n } = this.we();
      t(r, n);
    }
    return () => this.removeFeatureFlagsHandler(t);
  }
  updateEarlyAccessFeatureEnrollment(t, r) {
    var n, i = (this._instance.get_property(ia) || []).find((l) => l.flagKey === t), o = { ["$feature_enrollment/" + t]: r }, s = { $feature_flag: t, $feature_enrollment: r, $set: o };
    i && (s.$early_access_feature_name = i.name), this._instance.capture("$feature_enrollment_update", s), this.setPersonPropertiesForFlags(o, !1);
    var a = ee({}, this.getFlagVariants(), { [t]: r });
    (n = this._instance.persistence) == null || n.register({ [_c]: Object.keys(Ig(a)), [gi]: a }), this.ye();
  }
  getEarlyAccessFeatures(t, r, n) {
    r === void 0 && (r = !1);
    var i = this._instance.get_property(ia), o = n ? "&" + n.map((s) => "stage=" + s).join("&") : "";
    if (i && !r) return t(i);
    this._instance.me({ url: this._instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this._instance.config.token + o), method: "GET", callback: (s) => {
      var a;
      if (s.json) {
        var l = s.json.earlyAccessFeatures;
        return (a = this._instance.persistence) == null || a.register({ [ia]: l }), t(l);
      }
    } });
  }
  we() {
    var t = this.getFlags(), r = this.getFlagVariants();
    return { flags: t.filter((n) => r[n]), flagVariants: Object.keys(r).filter((n) => r[n]).reduce((n, i) => (n[i] = r[i], n), {}) };
  }
  ye(t) {
    var { flags: r, flagVariants: n } = this.we();
    this.featureFlagEventHandlers.forEach((i) => i(r, n, { errorsLoading: t }));
  }
  setPersonPropertiesForFlags(t, r) {
    r === void 0 && (r = !0);
    var n = this._instance.get_property(wo) || {};
    this._instance.register({ [wo]: ee({}, n, t) }), r && this._instance.reloadFeatureFlags();
  }
  resetPersonPropertiesForFlags() {
    this._instance.unregister(wo);
  }
  setGroupPropertiesForFlags(t, r) {
    r === void 0 && (r = !0);
    var n = this._instance.get_property(Pn) || {};
    Object.keys(n).length !== 0 && Object.keys(n).forEach((i) => {
      n[i] = ee({}, n[i], t[i]), delete t[i];
    }), this._instance.register({ [Pn]: ee({}, n, t) }), r && this._instance.reloadFeatureFlags();
  }
  resetGroupPropertiesForFlags(t) {
    if (t) {
      var r = this._instance.get_property(Pn) || {};
      this._instance.register({ [Pn]: ee({}, r, { [t]: {} }) });
    } else this._instance.unregister(Pn);
  }
}
var h5 = ["cookie", "localstorage", "localstorage+cookie", "sessionstorage", "memory"];
class wc {
  constructor(t) {
    this.S = t, this.props = {}, this.Se = !1, this.$e = ((r) => {
      var n = "";
      return r.token && (n = r.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), r.persistence_name ? "ph_" + r.persistence_name : "ph_" + n + "_posthog";
    })(t), this.q = this.ke(t), this.load(), t.debug && re.info("Persistence loaded", t.persistence, ee({}, this.props)), this.update_config(t, t), this.save();
  }
  ke(t) {
    h5.indexOf(t.persistence.toLowerCase()) === -1 && (re.critical("Unknown persistence type " + t.persistence + "; falling back to localStorage+cookie"), t.persistence = "localStorage+cookie");
    var r = t.persistence.toLowerCase();
    return r === "localstorage" && Je.O() ? Je : r === "localstorage+cookie" && Os.O() ? Os : r === "sessionstorage" && ot.O() ? ot : r === "memory" ? G$ : r === "cookie" ? Br : Os.O() ? Os : Br;
  }
  properties() {
    var t = {};
    return Oe(this.props, function(r, n) {
      if (n === gi && De(r)) for (var i = Object.keys(r), o = 0; o < i.length; o++) t["$feature/" + i[o]] = r[i[o]];
      else a = n, l = !1, (xn(s = k$) ? l : Np && s.indexOf === Np ? s.indexOf(a) != -1 : (Oe(s, function(c) {
        if (l || (l = c === a)) return Ta;
      }), l)) || (t[n] = r);
      var s, a, l;
    }), t;
  }
  load() {
    if (!this.xe) {
      var t = this.q.D(this.$e);
      t && (this.props = Ue({}, t));
    }
  }
  save() {
    this.xe || this.q.L(this.$e, this.props, this.Ee, this.Ie, this.Pe, this.S.debug);
  }
  remove() {
    this.q.N(this.$e, !1), this.q.N(this.$e, !0);
  }
  clear() {
    this.remove(), this.props = {};
  }
  register_once(t, r, n) {
    if (De(t)) {
      J(r) && (r = "None"), this.Ee = J(n) ? this.Re : n;
      var i = !1;
      if (Oe(t, (o, s) => {
        this.props.hasOwnProperty(s) && this.props[s] !== r || (this.props[s] = o, i = !0);
      }), i) return this.save(), !0;
    }
    return !1;
  }
  register(t, r) {
    if (De(t)) {
      this.Ee = J(r) ? this.Re : r;
      var n = !1;
      if (Oe(t, (i, o) => {
        t.hasOwnProperty(o) && this.props[o] !== i && (this.props[o] = i, n = !0);
      }), n) return this.save(), !0;
    }
    return !1;
  }
  unregister(t) {
    t in this.props && (delete this.props[t], this.save());
  }
  update_campaign_params() {
    if (!this.Se) {
      var t = $_(this.S.custom_campaign_params, this.S.mask_personal_data_properties, this.S.custom_personal_data_properties);
      pi(Qd(t)) || this.register(t), this.Se = !0;
    }
  }
  update_search_keyword() {
    var t;
    this.register((t = te == null ? void 0 : te.referrer) ? V_(t) : {});
  }
  update_referrer_info() {
    var t;
    this.register_once({ $referrer: z_(), $referring_domain: te != null && te.referrer && ((t = Ii(te.referrer)) == null ? void 0 : t.host) || "$direct" }, void 0);
  }
  set_initial_person_info() {
    this.props[Tu] || this.props[Ru] || this.register_once({ [Na]: D_(this.S.mask_personal_data_properties, this.S.custom_personal_data_properties) }, void 0);
  }
  get_initial_props() {
    var t = {};
    Oe([Ru, Tu], (s) => {
      var a = this.props[s];
      a && Oe(a, function(l, c) {
        t["$initial_" + yu(c)] = l;
      });
    });
    var r, n, i = this.props[Na];
    if (i) {
      var o = (r = M_(i), n = {}, Oe(r, function(s, a) {
        n["$initial_" + yu(a)] = s;
      }), n);
      Ue(t, o);
    }
    return t;
  }
  safe_merge(t) {
    return Oe(this.props, function(r, n) {
      n in t || (t[n] = r);
    }), t;
  }
  update_config(t, r) {
    if (this.Re = this.Ee = t.cookie_expiration, this.set_disabled(t.disable_persistence), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie), t.persistence !== r.persistence) {
      var n = this.ke(t), i = this.props;
      this.clear(), this.q = n, this.props = i, this.save();
    }
  }
  set_disabled(t) {
    this.xe = t, this.xe ? this.remove() : this.save();
  }
  set_cross_subdomain(t) {
    t !== this.Ie && (this.Ie = t, this.remove(), this.save());
  }
  set_secure(t) {
    t !== this.Pe && (this.Pe = t, this.remove(), this.save());
  }
  set_event_timer(t, r) {
    var n = this.props[xo] || {};
    n[t] = r, this.props[xo] = n, this.save();
  }
  remove_event_timer(t) {
    var r = (this.props[xo] || {})[t];
    return J(r) || (delete this.props[xo][t], this.save()), r;
  }
  get_property(t) {
    return this.props[t];
  }
  set_property(t, r) {
    this.props[t] = r, this.save();
  }
}
class W_ {
  constructor() {
    this.Te = {}, this.Te = {};
  }
  on(t, r) {
    return this.Te[t] || (this.Te[t] = []), this.Te[t].push(r), () => {
      this.Te[t] = this.Te[t].filter((n) => n !== r);
    };
  }
  emit(t, r) {
    for (var n of this.Te[t] || []) n(r);
    for (var i of this.Te["*"] || []) i(t, r);
  }
}
class An {
  constructor(t) {
    this.Me = new W_(), this.Ce = (r, n) => this.Oe(r, n) && this.Fe(r, n) && this.Ae(r, n), this.Oe = (r, n) => n == null || !n.event || (r == null ? void 0 : r.event) === (n == null ? void 0 : n.event), this._instance = t, this.De = /* @__PURE__ */ new Set(), this.Le = /* @__PURE__ */ new Set();
  }
  init() {
    var t;
    if (!J((t = this._instance) == null ? void 0 : t.Ne)) {
      var r;
      (r = this._instance) == null || r.Ne((n, i) => {
        this.on(n, i);
      });
    }
  }
  register(t) {
    var r, n;
    if (!J((r = this._instance) == null ? void 0 : r.Ne) && (t.forEach((s) => {
      var a, l;
      (a = this.Le) == null || a.add(s), (l = s.steps) == null || l.forEach((c) => {
        var u;
        (u = this.De) == null || u.add((c == null ? void 0 : c.event) || "");
      });
    }), (n = this._instance) != null && n.autocapture)) {
      var i, o = /* @__PURE__ */ new Set();
      t.forEach((s) => {
        var a;
        (a = s.steps) == null || a.forEach((l) => {
          l != null && l.selector && o.add(l == null ? void 0 : l.selector);
        });
      }), (i = this._instance) == null || i.autocapture.setElementSelectors(o);
    }
  }
  on(t, r) {
    var n;
    r != null && t.length != 0 && (this.De.has(t) || this.De.has(r == null ? void 0 : r.event)) && this.Le && ((n = this.Le) == null ? void 0 : n.size) > 0 && this.Le.forEach((i) => {
      this.je(r, i) && this.Me.emit("actionCaptured", i.name);
    });
  }
  ze(t) {
    this.onAction("actionCaptured", (r) => t(r));
  }
  je(t, r) {
    if ((r == null ? void 0 : r.steps) == null) return !1;
    for (var n of r.steps) if (this.Ce(t, n)) return !0;
    return !1;
  }
  onAction(t, r) {
    return this.Me.on(t, r);
  }
  Fe(t, r) {
    if (r != null && r.url) {
      var n, i = t == null || (n = t.properties) == null ? void 0 : n.$current_url;
      if (!i || typeof i != "string" || !An.Ue(i, r == null ? void 0 : r.url, (r == null ? void 0 : r.url_matching) || "contains")) return !1;
    }
    return !0;
  }
  static Ue(t, r, n) {
    switch (n) {
      case "regex":
        return !!A && Pi(t, r);
      case "exact":
        return r === t;
      case "contains":
        var i = An.qe(r).replace(/_/g, ".").replace(/%/g, ".*");
        return Pi(t, i);
      default:
        return !1;
    }
  }
  static qe(t) {
    return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  }
  Ae(t, r) {
    if ((r != null && r.href || r != null && r.tag_name || r != null && r.text) && !this.Be(t).some((o) => !(r != null && r.href && !An.Ue(o.href || "", r == null ? void 0 : r.href, (r == null ? void 0 : r.href_matching) || "exact")) && (r == null || !r.tag_name || o.tag_name === (r == null ? void 0 : r.tag_name)) && !(r != null && r.text && !An.Ue(o.text || "", r == null ? void 0 : r.text, (r == null ? void 0 : r.text_matching) || "exact") && !An.Ue(o.$el_text || "", r == null ? void 0 : r.text, (r == null ? void 0 : r.text_matching) || "exact")))) return !1;
    if (r != null && r.selector) {
      var n, i = t == null || (n = t.properties) == null ? void 0 : n.$element_selectors;
      if (!i || !i.includes(r == null ? void 0 : r.selector)) return !1;
    }
    return !0;
  }
  Be(t) {
    return (t == null ? void 0 : t.properties.$elements) == null ? [] : t == null ? void 0 : t.properties.$elements;
  }
}
var Xe = ut("[Surveys]"), ju = "seenSurvey_", p5 = (e, t) => {
  var r = "$survey_" + t + "/" + e.id;
  return e.current_iteration && e.current_iteration > 0 && (r = "$survey_" + t + "/" + e.id + "/" + e.current_iteration), r;
};
class g5 {
  constructor(t) {
    this._instance = t, this.He = /* @__PURE__ */ new Map(), this.We = /* @__PURE__ */ new Map();
  }
  register(t) {
    var r;
    J((r = this._instance) == null ? void 0 : r.Ne) || (this.Ge(t), this.Je(t));
  }
  Je(t) {
    var r = t.filter((n) => {
      var i, o;
      return ((i = n.conditions) == null ? void 0 : i.actions) && ((o = n.conditions) == null || (o = o.actions) == null || (o = o.values) == null ? void 0 : o.length) > 0;
    });
    r.length !== 0 && (this.Ve == null && (this.Ve = new An(this._instance), this.Ve.init(), this.Ve.ze((n) => {
      this.onAction(n);
    })), r.forEach((n) => {
      var i, o, s, a, l;
      n.conditions && (i = n.conditions) != null && i.actions && (o = n.conditions) != null && (o = o.actions) != null && o.values && ((s = n.conditions) == null || (s = s.actions) == null || (s = s.values) == null ? void 0 : s.length) > 0 && ((a = this.Ve) == null || a.register(n.conditions.actions.values), (l = n.conditions) == null || (l = l.actions) == null || (l = l.values) == null || l.forEach((c) => {
        if (c && c.name) {
          var u = this.We.get(c.name);
          u && u.push(n.id), this.We.set(c.name, u || [n.id]);
        }
      }));
    }));
  }
  Ge(t) {
    var r;
    t.filter((n) => {
      var i, o;
      return ((i = n.conditions) == null ? void 0 : i.events) && ((o = n.conditions) == null || (o = o.events) == null || (o = o.values) == null ? void 0 : o.length) > 0;
    }).length !== 0 && ((r = this._instance) == null || r.Ne((n, i) => {
      this.onEvent(n, i);
    }), t.forEach((n) => {
      var i;
      (i = n.conditions) == null || (i = i.events) == null || (i = i.values) == null || i.forEach((o) => {
        if (o && o.name) {
          var s = this.He.get(o.name);
          s && s.push(n.id), this.He.set(o.name, s || [n.id]);
        }
      });
    }));
  }
  onEvent(t, r) {
    var n, i = ((n = this._instance) == null || (n = n.persistence) == null ? void 0 : n.props[Is]) || [];
    if (t === "survey shown" && r && i.length > 0) {
      var o;
      Xe.info("survey event matched, removing survey from activated surveys", { event: t, eventPayload: r, existingActivatedSurveys: i });
      var s = r == null || (o = r.properties) == null ? void 0 : o.$survey_id;
      if (s) {
        var a = i.indexOf(s);
        a >= 0 && (i.splice(a, 1), this.Ke(i));
      }
    } else this.He.has(t) && (Xe.info("survey event matched, updating activated surveys", { event: t, surveys: this.He.get(t) }), this.Ke(i.concat(this.He.get(t) || [])));
  }
  onAction(t) {
    var r, n = ((r = this._instance) == null || (r = r.persistence) == null ? void 0 : r.props[Is]) || [];
    this.We.has(t) && this.Ke(n.concat(this.We.get(t) || []));
  }
  Ke(t) {
    var r;
    (r = this._instance) == null || (r = r.persistence) == null || r.register({ [Is]: [...new Set(t)] });
  }
  getSurveys() {
    var t, r = (t = this._instance) == null || (t = t.persistence) == null ? void 0 : t.props[Is];
    return r || [];
  }
  getEventToSurveys() {
    return this.He;
  }
  Ye() {
    return this.Ve;
  }
}
class m5 {
  constructor(t) {
    this.Xe = null, this.Qe = !1, this.Ze = !1, this.tr = [], this._instance = t, this._surveyEventReceiver = null;
  }
  onRemoteConfig(t) {
    var r = t.surveys;
    if (xe(r)) return Xe.warn("Decide not loaded yet. Not loading surveys.");
    var n = Fe(r);
    this.ir = n ? r.length > 0 : r, Xe.info("decide response received, hasSurveys: " + this.ir), this.ir && this.loadIfEnabled();
  }
  reset() {
    localStorage.removeItem("lastSeenSurveyDate");
    for (var t = [], r = 0; r < localStorage.length; r++) {
      var n = localStorage.key(r);
      (n != null && n.startsWith(ju) || n != null && n.startsWith("inProgressSurvey_")) && t.push(n);
    }
    t.forEach((i) => localStorage.removeItem(i));
  }
  loadIfEnabled() {
    if (!this.Xe) if (this.Ze) Xe.info("Already initializing surveys, skipping...");
    else if (this._instance.config.disable_surveys) Xe.info("Disabled. Not loading surveys.");
    else if (this.ir) {
      var t = pe == null ? void 0 : pe.__PosthogExtensions__;
      if (t) {
        this.Ze = !0;
        try {
          var r = t.generateSurveys;
          if (r) return void this.er(r);
          var n = t.loadExternalDependency;
          if (!n) return void this.rr("PostHog loadExternalDependency extension not found.");
          n(this._instance, "surveys", (i) => {
            i || !t.generateSurveys ? this.rr("Could not load surveys script", i) : this.er(t.generateSurveys);
          });
        } catch (i) {
          throw this.rr("Error initializing surveys", i), i;
        } finally {
          this.Ze = !1;
        }
      } else Xe.error("PostHog Extensions not found.");
    } else Xe.info("No surveys to load.");
  }
  er(t) {
    this.Xe = t(this._instance), this._surveyEventReceiver = new g5(this._instance), Xe.info("Surveys loaded successfully"), this.sr({ isLoaded: !0 });
  }
  rr(t, r) {
    Xe.error(t, r), this.sr({ isLoaded: !1, error: t });
  }
  onSurveysLoaded(t) {
    return this.tr.push(t), this.Xe && this.sr({ isLoaded: !0 }), () => {
      this.tr = this.tr.filter((r) => r !== t);
    };
  }
  getSurveys(t, r) {
    if (r === void 0 && (r = !1), this._instance.config.disable_surveys) return Xe.info("Disabled. Not loading surveys."), t([]);
    var n = this._instance.get_property(Iu);
    if (n && !r) return t(n, { isLoaded: !0 });
    if (this.Qe) return t([], { isLoaded: !1, error: "Surveys are already being loaded" });
    try {
      this.Qe = !0, this._instance.me({ url: this._instance.requestRouter.endpointFor("api", "/api/surveys/?token=" + this._instance.config.token), method: "GET", timeout: this._instance.config.surveys_request_timeout_ms, callback: (i) => {
        var o;
        this.Qe = !1;
        var s = i.statusCode;
        if (s !== 200 || !i.json) {
          var a = "Surveys API could not be loaded, status: " + s;
          return Xe.error(a), t([], { isLoaded: !1, error: a });
        }
        var l, c = i.json.surveys || [], u = c.filter((f) => function(d) {
          return !(!d.start_date || d.end_date);
        }(f) && (function(d) {
          var p;
          return !((p = d.conditions) == null || (p = p.events) == null || (p = p.values) == null || !p.length);
        }(f) || function(d) {
          var p;
          return !((p = d.conditions) == null || (p = p.actions) == null || (p = p.values) == null || !p.length);
        }(f)));
        return u.length > 0 && ((l = this._surveyEventReceiver) == null || l.register(u)), (o = this._instance.persistence) == null || o.register({ [Iu]: c }), t(c, { isLoaded: !0 });
      } });
    } catch (i) {
      throw this.Qe = !1, i;
    }
  }
  sr(t) {
    for (var r of this.tr) try {
      t.isLoaded ? this.getSurveys(r) : r([], t);
    } catch (n) {
      Xe.error("Error in survey callback", n);
    }
  }
  getActiveMatchingSurveys(t, r) {
    if (r === void 0 && (r = !1), !xe(this.Xe)) return this.Xe.getActiveMatchingSurveys(t, r);
    Xe.warn("init was not called");
  }
  nr(t) {
    var r = null;
    return this.getSurveys((n) => {
      var i;
      r = (i = n.find((o) => o.id === t)) !== null && i !== void 0 ? i : null;
    }), r;
  }
  ar(t) {
    if (xe(this.Xe)) return { eligible: !1, reason: "SDK is not enabled or survey functionality is not yet loaded" };
    var r = typeof t == "string" ? this.nr(t) : t;
    return r ? this.Xe.checkSurveyEligibility(r) : { eligible: !1, reason: "Survey not found" };
  }
  canRenderSurvey(t) {
    if (xe(this.Xe)) return Xe.warn("init was not called"), { visible: !1, disabledReason: "SDK is not enabled or survey functionality is not yet loaded" };
    var r = this.ar(t);
    return { visible: r.eligible, disabledReason: r.reason };
  }
  canRenderSurveyAsync(t, r) {
    return xe(this.Xe) ? (Xe.warn("init was not called"), Promise.resolve({ visible: !1, disabledReason: "SDK is not enabled or survey functionality is not yet loaded" })) : new Promise((n) => {
      this.getSurveys((i) => {
        var o, s = (o = i.find((l) => l.id === t)) !== null && o !== void 0 ? o : null;
        if (s) {
          var a = this.ar(s);
          n({ visible: a.eligible, disabledReason: a.reason });
        } else n({ visible: !1, disabledReason: "Survey not found" });
      }, r);
    });
  }
  renderSurvey(t, r) {
    if (xe(this.Xe)) Xe.warn("init was not called");
    else {
      var n = this.nr(t), i = te == null ? void 0 : te.querySelector(r);
      n ? i ? this.Xe.renderSurvey(n, i) : Xe.warn("Survey element not found") : Xe.warn("Survey not found");
    }
  }
}
(function(e) {
  return e.Button = "button", e.Tab = "tab", e.Selector = "selector", e;
})({});
(function(e) {
  return e.TopLeft = "top_left", e.TopRight = "top_right", e.TopCenter = "top_center", e.MiddleLeft = "middle_left", e.MiddleRight = "middle_right", e.MiddleCenter = "middle_center", e.Left = "left", e.Center = "center", e.Right = "right", e.NextToTrigger = "next_to_trigger", e;
})({});
(function(e) {
  return e.Popover = "popover", e.API = "api", e.Widget = "widget", e;
})({});
(function(e) {
  return e.Open = "open", e.MultipleChoice = "multiple_choice", e.SingleChoice = "single_choice", e.Rating = "rating", e.Link = "link", e;
})({});
(function(e) {
  return e.NextQuestion = "next_question", e.End = "end", e.ResponseBased = "response_based", e.SpecificQuestion = "specific_question", e;
})({});
(function(e) {
  return e.Once = "once", e.Recurring = "recurring", e.Always = "always", e;
})({});
var Sc = function(e) {
  return e.SHOWN = "survey shown", e.DISMISSED = "survey dismissed", e.SENT = "survey sent", e;
}({}), Og = function(e) {
  return e.SURVEY_ID = "$survey_id", e.SURVEY_NAME = "$survey_name", e.SURVEY_RESPONSE = "$survey_response", e.SURVEY_ITERATION = "$survey_iteration", e.SURVEY_ITERATION_START_DATE = "$survey_iteration_start_date", e.SURVEY_PARTIALLY_COMPLETED = "$survey_partially_completed", e.SURVEY_SUBMISSION_ID = "$survey_submission_id", e.SURVEY_QUESTIONS = "$survey_questions", e.SURVEY_COMPLETED = "$survey_completed", e;
}({}), Pg = ut("[RateLimiter]");
class v5 {
  constructor(t) {
    var r, n;
    this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (i) => {
      var o = i.text;
      if (o && o.length) try {
        (JSON.parse(o).quota_limited || []).forEach((s) => {
          Pg.info((s || "events") + " is quota limited."), this.serverLimits[s] = (/* @__PURE__ */ new Date()).getTime() + 6e4;
        });
      } catch (s) {
        return void Pg.warn('could not rate limit - continuing. Error: "' + (s == null ? void 0 : s.message) + '"', { text: o });
      }
    }, this.instance = t, this.captureEventsPerSecond = ((r = t.config.rate_limiting) == null ? void 0 : r.events_per_second) || 10, this.captureEventsBurstLimit = Math.max(((n = t.config.rate_limiting) == null ? void 0 : n.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond), this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
  }
  clientRateLimitContext(t) {
    var r, n, i;
    t === void 0 && (t = !1);
    var o = (/* @__PURE__ */ new Date()).getTime(), s = (r = (n = this.instance.persistence) == null ? void 0 : n.get_property(Pu)) !== null && r !== void 0 ? r : { tokens: this.captureEventsBurstLimit, last: o };
    s.tokens += (o - s.last) / 1e3 * this.captureEventsPerSecond, s.last = o, s.tokens > this.captureEventsBurstLimit && (s.tokens = this.captureEventsBurstLimit);
    var a = s.tokens < 1;
    return a || t || (s.tokens = Math.max(0, s.tokens - 1)), !a || this.lastEventRateLimited || t || this.instance.capture("$$client_ingestion_warning", { $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to " + this.captureEventsPerSecond + " events per second and " + this.captureEventsBurstLimit + " events burst limit." }, { skip_client_rate_limiting: !0 }), this.lastEventRateLimited = a, (i = this.instance.persistence) == null || i.set_property(Pu, s), { isRateLimited: a, remainingTokens: s.tokens };
  }
  isServerRateLimited(t) {
    var r = this.serverLimits[t || "events"] || !1;
    return r !== !1 && (/* @__PURE__ */ new Date()).getTime() < r;
  }
}
var On = ut("[RemoteConfig]");
class b5 {
  constructor(t) {
    this._instance = t;
  }
  get remoteConfig() {
    var t;
    return (t = pe._POSTHOG_REMOTE_CONFIG) == null || (t = t[this._instance.config.token]) == null ? void 0 : t.config;
  }
  lr(t) {
    var r, n;
    (r = pe.__PosthogExtensions__) != null && r.loadExternalDependency ? (n = pe.__PosthogExtensions__) == null || n.loadExternalDependency == null || n.loadExternalDependency(this._instance, "remote-config", () => t(this.remoteConfig)) : (On.error("PostHog Extensions not found. Cannot load remote config."), t());
  }
  ur(t) {
    this._instance.me({ method: "GET", url: this._instance.requestRouter.endpointFor("assets", "/array/" + this._instance.config.token + "/config"), callback: (r) => {
      t(r.json);
    } });
  }
  load() {
    try {
      if (this.remoteConfig) return On.info("Using preloaded remote config", this.remoteConfig), void this.be(this.remoteConfig);
      if (this._instance.config.advanced_disable_decide) return void On.warn("Remote config is disabled. Falling back to local config.");
      this.lr((t) => {
        if (!t) return On.info("No config found after loading remote JS config. Falling back to JSON."), void this.ur((r) => {
          this.be(r);
        });
        this.be(t);
      });
    } catch (t) {
      On.error("Error loading remote config", t);
    }
  }
  be(t) {
    t ? this._instance.config.__preview_remote_config ? (this._instance.be(t), t.hasFeatureFlags !== !1 && this._instance.featureFlags.ensureFlagsLoaded()) : On.info("__preview_remote_config is disabled. Logging config instead", t) : On.error("Failed to fetch remote config from PostHog.");
  }
}
var Uu = 3e3;
class y5 {
  constructor(t, r) {
    this.hr = !0, this.dr = [], this.vr = Kt((r == null ? void 0 : r.flush_interval_ms) || Uu, 250, 5e3, "flush interval", Uu), this.cr = t;
  }
  enqueue(t) {
    this.dr.push(t), this.pr || this._r();
  }
  unload() {
    this.gr();
    var t = this.dr.length > 0 ? this.mr() : {}, r = Object.values(t);
    [...r.filter((n) => n.url.indexOf("/e") === 0), ...r.filter((n) => n.url.indexOf("/e") !== 0)].map((n) => {
      this.cr(ee({}, n, { transport: "sendBeacon" }));
    });
  }
  enable() {
    this.hr = !1, this._r();
  }
  _r() {
    var t = this;
    this.hr || (this.pr = setTimeout(() => {
      if (this.gr(), this.dr.length > 0) {
        var r = this.mr(), n = function() {
          var o = r[i], s = (/* @__PURE__ */ new Date()).getTime();
          o.data && Fe(o.data) && Oe(o.data, (a) => {
            a.offset = Math.abs(a.timestamp - s), delete a.timestamp;
          }), t.cr(o);
        };
        for (var i in r) n();
      }
    }, this.vr));
  }
  gr() {
    clearTimeout(this.pr), this.pr = void 0;
  }
  mr() {
    var t = {};
    return Oe(this.dr, (r) => {
      var n, i = r, o = (i ? i.batchKey : null) || i.url;
      J(t[o]) && (t[o] = ee({}, i, { data: [] })), (n = t[o].data) == null || n.push(i.data);
    }), this.dr = [], t;
  }
}
var x5 = ["retriesPerformedSoFar"];
class _5 {
  constructor(t) {
    this.br = !1, this.yr = 3e3, this.dr = [], this._instance = t, this.dr = [], this.wr = !0, !J(A) && "onLine" in A.navigator && (this.wr = A.navigator.onLine, Ve(A, "online", () => {
      this.wr = !0, this.Yi();
    }), Ve(A, "offline", () => {
      this.wr = !1;
    }));
  }
  get length() {
    return this.dr.length;
  }
  retriableRequest(t) {
    var { retriesPerformedSoFar: r } = t, n = Mx(t, x5);
    pt(r) && r > 0 && (n.url = Wa(n.url, { retry_count: r })), this._instance.me(ee({}, n, { callback: (i) => {
      i.statusCode !== 200 && (i.statusCode < 400 || i.statusCode >= 500) && (r != null ? r : 0) < 10 ? this.Sr(ee({ retriesPerformedSoFar: r }, n)) : n.callback == null || n.callback(i);
    } }));
  }
  Sr(t) {
    var r = t.retriesPerformedSoFar || 0;
    t.retriesPerformedSoFar = r + 1;
    var n = function(s) {
      var a = 3e3 * Math.pow(2, s), l = a / 2, c = Math.min(18e5, a), u = (Math.random() - 0.5) * (c - l);
      return Math.ceil(c + u);
    }(r), i = Date.now() + n;
    this.dr.push({ retryAt: i, requestOptions: t });
    var o = "Enqueued failed request for retry in " + n;
    navigator.onLine || (o += " (Browser is offline)"), re.warn(o), this.br || (this.br = !0, this.$r());
  }
  $r() {
    this.kr && clearTimeout(this.kr), this.kr = setTimeout(() => {
      this.wr && this.dr.length > 0 && this.Yi(), this.$r();
    }, this.yr);
  }
  Yi() {
    var t = Date.now(), r = [], n = this.dr.filter((o) => o.retryAt < t || (r.push(o), !1));
    if (this.dr = r, n.length > 0) for (var { requestOptions: i } of n) this.retriableRequest(i);
  }
  unload() {
    for (var { requestOptions: t } of (this.kr && (clearTimeout(this.kr), this.kr = void 0), this.dr)) try {
      this._instance.me(ee({}, t, { transport: "sendBeacon" }));
    } catch (r) {
      re.error(r);
    }
    this.dr = [];
  }
}
class w5 {
  constructor(t) {
    this.Er = () => {
      var r, n, i, o;
      this.Ir || (this.Ir = {});
      var s = this.scrollElement(), a = this.scrollY(), l = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, c = a + ((s == null ? void 0 : s.clientHeight) || 0), u = (s == null ? void 0 : s.scrollHeight) || 0;
      this.Ir.lastScrollY = Math.ceil(a), this.Ir.maxScrollY = Math.max(a, (r = this.Ir.maxScrollY) !== null && r !== void 0 ? r : 0), this.Ir.maxScrollHeight = Math.max(l, (n = this.Ir.maxScrollHeight) !== null && n !== void 0 ? n : 0), this.Ir.lastContentY = c, this.Ir.maxContentY = Math.max(c, (i = this.Ir.maxContentY) !== null && i !== void 0 ? i : 0), this.Ir.maxContentHeight = Math.max(u, (o = this.Ir.maxContentHeight) !== null && o !== void 0 ? o : 0);
    }, this._instance = t;
  }
  getContext() {
    return this.Ir;
  }
  resetContext() {
    var t = this.Ir;
    return setTimeout(this.Er, 0), t;
  }
  startMeasuringScrollPosition() {
    Ve(A, "scroll", this.Er, { capture: !0 }), Ve(A, "scrollend", this.Er, { capture: !0 }), Ve(A, "resize", this.Er);
  }
  scrollElement() {
    if (!this._instance.config.scroll_root_selector) return A == null ? void 0 : A.document.documentElement;
    var t = Fe(this._instance.config.scroll_root_selector) ? this._instance.config.scroll_root_selector : [this._instance.config.scroll_root_selector];
    for (var r of t) {
      var n = A == null ? void 0 : A.document.querySelector(r);
      if (n) return n;
    }
  }
  scrollY() {
    if (this._instance.config.scroll_root_selector) {
      var t = this.scrollElement();
      return t && t.scrollTop || 0;
    }
    return A && (A.scrollY || A.pageYOffset || A.document.documentElement.scrollTop) || 0;
  }
  scrollX() {
    if (this._instance.config.scroll_root_selector) {
      var t = this.scrollElement();
      return t && t.scrollLeft || 0;
    }
    return A && (A.scrollX || A.pageXOffset || A.document.documentElement.scrollLeft) || 0;
  }
}
var S5 = (e) => D_(e == null ? void 0 : e.config.mask_personal_data_properties, e == null ? void 0 : e.config.custom_personal_data_properties);
class E5 {
  constructor(t, r, n, i) {
    this.Pr = (o) => {
      var s = this.Rr();
      if (!s || s.sessionId !== o) {
        var a = { sessionId: o, props: this.Tr(this._instance) };
        this.Mr.register({ [Ou]: a });
      }
    }, this._instance = t, this.Cr = r, this.Mr = n, this.Tr = i || S5, this.Cr.onSessionId(this.Pr);
  }
  Rr() {
    return this.Mr.props[Ou];
  }
  getSetOnceProps() {
    var t, r = (t = this.Rr()) == null ? void 0 : t.props;
    return r ? "r" in r ? M_(r) : { $referring_domain: r.referringDomain, $pathname: r.initialPathName, utm_source: r.utm_source, utm_campaign: r.utm_campaign, utm_medium: r.utm_medium, utm_content: r.utm_content, utm_term: r.utm_term } : {};
  }
  getSessionProps() {
    var t = {};
    return Oe(Qd(this.getSetOnceProps()), (r, n) => {
      n === "$current_url" && (n = "url"), t["$session_entry_" + yu(n)] = r;
    }), t;
  }
}
var Tg = ut("[SessionId]");
class C5 {
  constructor(t, r, n) {
    var i;
    if (this.Or = [], !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
    if (t.config.__preview_experimental_cookieless_mode) throw new Error("SessionIdManager cannot be used with __preview_experimental_cookieless_mode");
    this.S = t.config, this.Mr = t.persistence, this.oi = void 0, this.kt = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.Fr = r || an, this.Ar = n || an;
    var o = this.S.persistence_name || this.S.token, s = this.S.session_idle_timeout_seconds || 1800;
    if (this._sessionTimeoutMs = 1e3 * Kt(s, 60, 36e3, "session_idle_timeout_seconds", 1800), t.register({ $configured_session_timeout_ms: this._sessionTimeoutMs }), this.Dr(), this.Lr = "ph_" + o + "_window_id", this.Nr = "ph_" + o + "_primary_window_exists", this.jr()) {
      var a = ot.D(this.Lr), l = ot.D(this.Nr);
      a && !l ? this.oi = a : ot.N(this.Lr), ot.L(this.Nr, !0);
    }
    if ((i = this.S.bootstrap) != null && i.sessionID) try {
      var c = ((u) => {
        var f = u.replace(/-/g, "");
        if (f.length !== 32) throw new Error("Not a valid UUID");
        if (f[12] !== "7") throw new Error("Not a UUIDv7");
        return parseInt(f.substring(0, 12), 16);
      })(this.S.bootstrap.sessionID);
      this.zr(this.S.bootstrap.sessionID, (/* @__PURE__ */ new Date()).getTime(), c);
    } catch (u) {
      Tg.error("Invalid sessionID in bootstrap", u);
    }
    this.Ur();
  }
  get sessionTimeoutMs() {
    return this._sessionTimeoutMs;
  }
  onSessionId(t) {
    return J(this.Or) && (this.Or = []), this.Or.push(t), this.kt && t(this.kt, this.oi), () => {
      this.Or = this.Or.filter((r) => r !== t);
    };
  }
  jr() {
    return this.S.persistence !== "memory" && !this.Mr.xe && ot.O();
  }
  qr(t) {
    t !== this.oi && (this.oi = t, this.jr() && ot.L(this.Lr, t));
  }
  Br() {
    return this.oi ? this.oi : this.jr() ? ot.D(this.Lr) : null;
  }
  zr(t, r, n) {
    t === this.kt && r === this._sessionActivityTimestamp && n === this._sessionStartTimestamp || (this._sessionStartTimestamp = n, this._sessionActivityTimestamp = r, this.kt = t, this.Mr.register({ [Ra]: [r, t, n] }));
  }
  Hr() {
    if (this.kt && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [this._sessionActivityTimestamp, this.kt, this._sessionStartTimestamp];
    var t = this.Mr.props[Ra];
    return Fe(t) && t.length === 2 && t.push(t[0]), t || [0, null, 0];
  }
  resetSessionId() {
    this.zr(null, null, null);
  }
  Ur() {
    Ve(A, "beforeunload", () => {
      this.jr() && ot.N(this.Nr);
    }, { capture: !1 });
  }
  checkAndGetSessionAndWindowId(t, r) {
    if (t === void 0 && (t = !1), r === void 0 && (r = null), this.S.__preview_experimental_cookieless_mode) throw new Error("checkAndGetSessionAndWindowId should not be called in __preview_experimental_cookieless_mode");
    var n = r || (/* @__PURE__ */ new Date()).getTime(), [i, o, s] = this.Hr(), a = this.Br(), l = pt(s) && s > 0 && Math.abs(n - s) > 864e5, c = !1, u = !o, f = !t && Math.abs(n - i) > this.sessionTimeoutMs;
    u || f || l ? (o = this.Fr(), a = this.Ar(), Tg.info("new session ID generated", { sessionId: o, windowId: a, changeReason: { noSessionId: u, activityTimeout: f, sessionPastMaximumLength: l } }), s = n, c = !0) : a || (a = this.Ar(), c = !0);
    var d = i === 0 || !t || l ? n : i, p = s === 0 ? (/* @__PURE__ */ new Date()).getTime() : s;
    return this.qr(a), this.zr(o, d, p), t || this.Dr(), c && this.Or.forEach((g) => g(o, a, c ? { noSessionId: u, activityTimeout: f, sessionPastMaximumLength: l } : void 0)), { sessionId: o, windowId: a, sessionStartTimestamp: p, changeReason: c ? { noSessionId: u, activityTimeout: f, sessionPastMaximumLength: l } : void 0, lastActivityTimestamp: i };
  }
  Dr() {
    clearTimeout(this.Wr), this.Wr = setTimeout(() => {
      this.resetSessionId();
    }, 1.1 * this.sessionTimeoutMs);
  }
}
var k5 = ["$set_once", "$set"], en = ut("[SiteApps]");
class I5 {
  constructor(t) {
    this._instance = t, this.Gr = [], this.apps = {};
  }
  get isEnabled() {
    return !!this._instance.config.opt_in_site_apps;
  }
  Jr(t, r) {
    if (r) {
      var n = this.globalsForEvent(r);
      this.Gr.push(n), this.Gr.length > 1e3 && (this.Gr = this.Gr.slice(10));
    }
  }
  get siteAppLoaders() {
    var t;
    return (t = pe._POSTHOG_REMOTE_CONFIG) == null || (t = t[this._instance.config.token]) == null ? void 0 : t.siteApps;
  }
  init() {
    if (this.isEnabled) {
      var t = this._instance.Ne(this.Jr.bind(this));
      this.Vr = () => {
        t(), this.Gr = [], this.Vr = void 0;
      };
    }
  }
  globalsForEvent(t) {
    var r, n, i, o, s, a, l;
    if (!t) throw new Error("Event payload is required");
    var c = {}, u = this._instance.get_property("$groups") || [], f = this._instance.get_property("$stored_group_properties") || {};
    for (var [d, p] of Object.entries(f)) c[d] = { id: u[d], type: d, properties: p };
    var { $set_once: g, $set: h } = t;
    return { event: ee({}, Mx(t, k5), { properties: ee({}, t.properties, h ? { $set: ee({}, (r = (n = t.properties) == null ? void 0 : n.$set) !== null && r !== void 0 ? r : {}, h) } : {}, g ? { $set_once: ee({}, (i = (o = t.properties) == null ? void 0 : o.$set_once) !== null && i !== void 0 ? i : {}, g) } : {}), elements_chain: (s = (a = t.properties) == null ? void 0 : a.$elements_chain) !== null && s !== void 0 ? s : "", distinct_id: (l = t.properties) == null ? void 0 : l.distinct_id }), person: { properties: this._instance.get_property("$stored_person_properties") }, groups: c };
  }
  setupSiteApp(t) {
    var r = this.apps[t.id], n = () => {
      var a;
      !r.errored && this.Gr.length && (en.info("Processing " + this.Gr.length + " events for site app with id " + t.id), this.Gr.forEach((l) => r.processEvent == null ? void 0 : r.processEvent(l)), r.processedBuffer = !0), Object.values(this.apps).every((l) => l.processedBuffer || l.errored) && ((a = this.Vr) == null || a.call(this));
    }, i = !1, o = (a) => {
      r.errored = !a, r.loaded = !0, en.info("Site app with id " + t.id + " " + (a ? "loaded" : "errored")), i && n();
    };
    try {
      var { processEvent: s } = t.init({ posthog: this._instance, callback: (a) => {
        o(a);
      } });
      s && (r.processEvent = s), i = !0;
    } catch (a) {
      en.error("Error while initializing PostHog app with config id " + t.id, a), o(!1);
    }
    if (i && r.loaded) try {
      n();
    } catch (a) {
      en.error("Error while processing buffered events PostHog app with config id " + t.id, a), r.errored = !0;
    }
  }
  Kr() {
    var t = this.siteAppLoaders || [];
    for (var r of t) this.apps[r.id] = { id: r.id, loaded: !1, errored: !1, processedBuffer: !1 };
    for (var n of t) this.setupSiteApp(n);
  }
  Yr(t) {
    if (Object.keys(this.apps).length !== 0) {
      var r = this.globalsForEvent(t);
      for (var n of Object.values(this.apps)) try {
        n.processEvent == null || n.processEvent(r);
      } catch (i) {
        en.error("Error while processing event " + t.event + " for site app " + n.id, i);
      }
    }
  }
  onRemoteConfig(t) {
    var r, n, i, o = this;
    if ((r = this.siteAppLoaders) != null && r.length) return this.isEnabled ? (this.Kr(), void this._instance.on("eventCaptured", (c) => this.Yr(c))) : void en.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
    if ((n = this.Vr) == null || n.call(this), (i = t.siteApps) != null && i.length) if (this.isEnabled) {
      var s = function(c) {
        var u;
        pe["__$$ph_site_app_" + c] = o._instance, (u = pe.__PosthogExtensions__) == null || u.loadSiteApp == null || u.loadSiteApp(o._instance, l, (f) => {
          if (f) return en.error("Error while initializing PostHog app with config id " + c, f);
        });
      };
      for (var { id: a, url: l } of t.siteApps) s(a);
    } else en.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
  }
}
var O5 = ["amazonbot", "amazonproductbot", "app.hypefactors.com", "applebot", "archive.org_bot", "awariobot", "backlinksextendedbot", "baiduspider", "bingbot", "bingpreview", "chrome-lighthouse", "dataforseobot", "deepscan", "duckduckbot", "facebookexternal", "facebookcatalog", "http://yandex.com/bots", "hubspot", "ia_archiver", "leikibot", "linkedinbot", "meta-externalagent", "mj12bot", "msnbot", "nessus", "petalbot", "pinterest", "prerender", "rogerbot", "screaming frog", "sebot-wa", "sitebulb", "slackbot", "slurp", "trendictionbot", "turnitin", "twitterbot", "vercelbot", "yahoo! slurp", "yandexbot", "zoombot", "bot.htm", "bot.php", "(bot;", "bot/", "crawler", "ahrefsbot", "ahrefssiteaudit", "semrushbot", "siteauditbot", "splitsignalbot", "gptbot", "oai-searchbot", "chatgpt-user", "perplexitybot", "better uptime bot", "sentryuptimebot", "uptimerobot", "headlesschrome", "cypress", "google-hoteladsverifier", "adsbot-google", "apis-google", "duplexweb-google", "feedfetcher-google", "google favicon", "google web preview", "google-read-aloud", "googlebot", "googleother", "google-cloudvertexbot", "googleweblight", "mediapartners-google", "storebot-google", "google-inspectiontool", "bytespider"], Rg = function(e, t) {
  if (!e) return !1;
  var r = e.toLowerCase();
  return O5.concat(t || []).some((n) => {
    var i = n.toLowerCase();
    return r.indexOf(i) !== -1;
  });
}, H_ = function(e, t) {
  if (!e) return !1;
  var r = e.userAgent;
  if (r && Rg(r, t)) return !0;
  try {
    var n = e == null ? void 0 : e.userAgentData;
    if (n != null && n.brands && n.brands.some((i) => Rg(i == null ? void 0 : i.brand, t))) return !0;
  } catch (i) {
  }
  return !!e.webdriver;
}, ko = function(e) {
  return e.US = "us", e.EU = "eu", e.CUSTOM = "custom", e;
}({}), Ag = "i.posthog.com";
class P5 {
  constructor(t) {
    this.Xr = {}, this.instance = t;
  }
  get apiHost() {
    var t = this.instance.config.api_host.trim().replace(/\/$/, "");
    return t === "https://app.posthog.com" ? "https://us.i.posthog.com" : t;
  }
  get uiHost() {
    var t, r = (t = this.instance.config.ui_host) == null ? void 0 : t.replace(/\/$/, "");
    return r || (r = this.apiHost.replace("." + Ag, ".posthog.com")), r === "https://app.posthog.com" ? "https://us.posthog.com" : r;
  }
  get region() {
    return this.Xr[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.Xr[this.apiHost] = ko.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.Xr[this.apiHost] = ko.EU : this.Xr[this.apiHost] = ko.CUSTOM), this.Xr[this.apiHost];
  }
  endpointFor(t, r) {
    if (r === void 0 && (r = ""), r && (r = r[0] === "/" ? r : "/" + r), t === "ui") return this.uiHost + r;
    if (this.region === ko.CUSTOM) return this.apiHost + r;
    var n = Ag + r;
    switch (t) {
      case "assets":
        return "https://" + this.region + "-assets." + n;
      case "api":
        return "https://" + this.region + "." + n;
    }
  }
}
var T5 = { icontains: (e, t) => !!A && t.href.toLowerCase().indexOf(e.toLowerCase()) > -1, not_icontains: (e, t) => !!A && t.href.toLowerCase().indexOf(e.toLowerCase()) === -1, regex: (e, t) => !!A && Pi(t.href, e), not_regex: (e, t) => !!A && !Pi(t.href, e), exact: (e, t) => t.href === e, is_not: (e, t) => t.href !== e };
class ht {
  constructor(t) {
    var r = this;
    this.getWebExperimentsAndEvaluateDisplayLogic = function(n) {
      n === void 0 && (n = !1), r.getWebExperiments((i) => {
        ht.Qr("retrieved web experiments from the server"), r.Zr = /* @__PURE__ */ new Map(), i.forEach((o) => {
          if (o.feature_flag_key) {
            var s;
            r.Zr && (ht.Qr("setting flag key ", o.feature_flag_key, " to web experiment ", o), (s = r.Zr) == null || s.set(o.feature_flag_key, o));
            var a = r._instance.getFeatureFlag(o.feature_flag_key);
            Me(a) && o.variants[a] && r.ts(o.name, a, o.variants[a].transforms);
          } else if (o.variants) for (var l in o.variants) {
            var c = o.variants[l];
            ht.es(c) && r.ts(o.name, l, c.transforms);
          }
        });
      }, n);
    }, this._instance = t, this._instance.onFeatureFlags((n) => {
      this.onFeatureFlags(n);
    });
  }
  onFeatureFlags(t) {
    if (this._is_bot()) ht.Qr("Refusing to render web experiment since the viewer is a likely bot");
    else if (!this._instance.config.disable_web_experiments) {
      if (xe(this.Zr)) return this.Zr = /* @__PURE__ */ new Map(), this.loadIfEnabled(), void this.previewWebExperiment();
      ht.Qr("applying feature flags", t), t.forEach((r) => {
        var n;
        if (this.Zr && (n = this.Zr) != null && n.has(r)) {
          var i, o = this._instance.getFeatureFlag(r), s = (i = this.Zr) == null ? void 0 : i.get(r);
          o && s != null && s.variants[o] && this.ts(s.name, o, s.variants[o].transforms);
        }
      });
    }
  }
  previewWebExperiment() {
    var t = ht.getWindowLocation();
    if (t != null && t.search) {
      var r = La(t == null ? void 0 : t.search, "__experiment_id"), n = La(t == null ? void 0 : t.search, "__experiment_variant");
      r && n && (ht.Qr("previewing web experiments " + r + " && " + n), this.getWebExperiments((i) => {
        this.rs(parseInt(r), n, i);
      }, !1, !0));
    }
  }
  loadIfEnabled() {
    this._instance.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
  }
  getWebExperiments(t, r, n) {
    if (this._instance.config.disable_web_experiments && !n) return t([]);
    var i = this._instance.get_property("$web_experiments");
    if (i && !r) return t(i);
    this._instance.me({ url: this._instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this._instance.config.token), method: "GET", callback: (o) => {
      if (o.statusCode !== 200 || !o.json) return t([]);
      var s = o.json.experiments || [];
      return t(s);
    } });
  }
  rs(t, r, n) {
    var i = n.filter((o) => o.id === t);
    i && i.length > 0 && (ht.Qr("Previewing web experiment [" + i[0].name + "] with variant [" + r + "]"), this.ts(i[0].name, r, i[0].variants[r].transforms));
  }
  static es(t) {
    return !xe(t.conditions) && ht.ss(t) && ht.ns(t);
  }
  static ss(t) {
    var r;
    if (xe(t.conditions) || xe((r = t.conditions) == null ? void 0 : r.url)) return !0;
    var n, i, o, s = ht.getWindowLocation();
    return !!s && ((n = t.conditions) == null || !n.url || T5[(i = (o = t.conditions) == null ? void 0 : o.urlMatchType) !== null && i !== void 0 ? i : "icontains"](t.conditions.url, s));
  }
  static getWindowLocation() {
    return A == null ? void 0 : A.location;
  }
  static ns(t) {
    var r;
    if (xe(t.conditions) || xe((r = t.conditions) == null ? void 0 : r.utm)) return !0;
    var n = $_();
    if (n.utm_source) {
      var i, o, s, a, l, c, u, f, d = (i = t.conditions) == null || (i = i.utm) == null || !i.utm_campaign || ((o = t.conditions) == null || (o = o.utm) == null ? void 0 : o.utm_campaign) == n.utm_campaign, p = (s = t.conditions) == null || (s = s.utm) == null || !s.utm_source || ((a = t.conditions) == null || (a = a.utm) == null ? void 0 : a.utm_source) == n.utm_source, g = (l = t.conditions) == null || (l = l.utm) == null || !l.utm_medium || ((c = t.conditions) == null || (c = c.utm) == null ? void 0 : c.utm_medium) == n.utm_medium, h = (u = t.conditions) == null || (u = u.utm) == null || !u.utm_term || ((f = t.conditions) == null || (f = f.utm) == null ? void 0 : f.utm_term) == n.utm_term;
      return d && g && h && p;
    }
    return !1;
  }
  static Qr(t) {
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) n[i - 1] = arguments[i];
    re.info("[WebExperiments] " + t, n);
  }
  ts(t, r, n) {
    this._is_bot() ? ht.Qr("Refusing to render web experiment since the viewer is a likely bot") : r !== "control" ? n.forEach((i) => {
      if (i.selector) {
        var o;
        ht.Qr("applying transform of variant " + r + " for experiment " + t + " ", i);
        var s = (o = document) == null ? void 0 : o.querySelectorAll(i.selector);
        s == null || s.forEach((a) => {
          var l = a;
          i.html && (l.innerHTML = i.html), i.css && l.setAttribute("style", i.css);
        });
      }
    }) : ht.Qr("Control variants leave the page unmodified.");
  }
  _is_bot() {
    return Vt && this._instance ? H_(Vt, this._instance.config.custom_blocked_useragents) : void 0;
  }
}
var No = {}, Gu = () => {
}, di = "posthog", j_ = !qL && (_t == null ? void 0 : _t.indexOf("MSIE")) === -1 && (_t == null ? void 0 : _t.indexOf("Mozilla")) === -1, Ng = (e) => {
  var t;
  return { api_host: "https://us.i.posthog.com", ui_host: null, token: "", autocapture: !0, rageclick: !0, cross_subdomain_cookie: C$(te == null ? void 0 : te.location), persistence: "localStorage+cookie", persistence_name: "", loaded: Gu, save_campaign_params: !0, custom_campaign_params: [], custom_blocked_useragents: [], save_referrer: !0, capture_pageview: e !== "2025-05-24" || "history_change", capture_pageleave: "if_capture_pageview", defaults: e != null ? e : "unset", debug: wt && Me(wt == null ? void 0 : wt.search) && wt.search.indexOf("__posthog_debug=true") !== -1 || !1, cookie_expiration: 365, upgrade: !1, disable_session_recording: !1, disable_persistence: !1, disable_web_experiments: !0, disable_surveys: !1, disable_external_dependency_loading: !1, enable_recording_console_log: void 0, secure_cookie: (A == null || (t = A.location) == null ? void 0 : t.protocol) === "https:", ip: !0, opt_out_capturing_by_default: !1, opt_out_persistence_by_default: !1, opt_out_useragent_filter: !1, opt_out_capturing_persistence_type: "localStorage", opt_out_capturing_cookie_prefix: null, opt_in_site_apps: !1, property_denylist: [], respect_dnt: !1, sanitize_properties: null, request_headers: {}, request_batching: !0, properties_string_max_length: 65535, session_recording: {}, mask_all_element_attributes: !1, mask_all_text: !1, mask_personal_data_properties: !1, custom_personal_data_properties: [], advanced_disable_decide: !1, advanced_disable_feature_flags: !1, advanced_disable_feature_flags_on_first_load: !1, advanced_only_evaluate_survey_feature_flags: !1, advanced_disable_toolbar_metrics: !1, feature_flag_request_timeout_ms: 3e3, surveys_request_timeout_ms: 1e4, on_request_error: (r) => {
    var n = "Bad HTTP status: " + r.statusCode + " " + r.text;
    re.error(n);
  }, get_device_id: (r) => r, capture_performance: void 0, name: "posthog", bootstrap: {}, disable_compression: !1, session_idle_timeout_seconds: 1800, person_profiles: "identified_only", before_send: void 0, request_queue_config: { flush_interval_ms: Uu }, _onCapture: Gu };
}, Fg = (e) => {
  var t = {};
  J(e.process_person) || (t.person_profiles = e.process_person), J(e.xhr_headers) || (t.request_headers = e.xhr_headers), J(e.cookie_name) || (t.persistence_name = e.cookie_name), J(e.disable_cookie) || (t.disable_persistence = e.disable_cookie), J(e.store_google) || (t.save_campaign_params = e.store_google), J(e.verbose) || (t.debug = e.verbose);
  var r = Ue({}, t, e);
  return Fe(e.property_blacklist) && (J(e.property_denylist) ? r.property_denylist = e.property_blacklist : Fe(e.property_denylist) ? r.property_denylist = [...e.property_blacklist, ...e.property_denylist] : re.error("Invalid value for property_denylist config: " + e.property_denylist)), r;
};
class R5 {
  constructor() {
    this.__forceAllowLocalhost = !1;
  }
  get os() {
    return this.__forceAllowLocalhost;
  }
  set os(t) {
    re.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
  }
}
class kl {
  get decideEndpointWasHit() {
    var t, r;
    return (t = (r = this.featureFlags) == null ? void 0 : r.hasLoadedFlags) !== null && t !== void 0 && t;
  }
  constructor() {
    this.webPerformance = new R5(), this.ls = !1, this.version = Dr.LIB_VERSION, this.us = new W_(), this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = Ng(), this.SentryIntegration = VL, this.sentryIntegration = (t) => function(r, n) {
      var i = b_(r, n);
      return { name: v_, processEvent: (o) => i(o) };
    }(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.hs = !1, this.ds = null, this.vs = null, this.cs = null, this.featureFlags = new f5(this), this.toolbar = new DL(this), this.scrollManager = new w5(this), this.pageViewManager = new UL(this), this.surveys = new m5(this), this.experiments = new ht(this), this.exceptions = new XL(this), this.rateLimiter = new v5(this), this.requestRouter = new P5(this), this.consent = new q$(this), this.people = { set: (t, r, n) => {
      var i = Me(t) ? { [t]: r } : t;
      this.setPersonProperties(i), n == null || n({});
    }, set_once: (t, r, n) => {
      var i = Me(t) ? { [t]: r } : t;
      this.setPersonProperties(void 0, i), n == null || n({});
    } }, this.on("eventCaptured", (t) => re.info('send "' + (t == null ? void 0 : t.event) + '"', t));
  }
  init(t, r, n) {
    if (n && n !== di) {
      var i, o = (i = No[n]) !== null && i !== void 0 ? i : new kl();
      return o._init(t, r, n), No[n] = o, No[di][n] = o, o;
    }
    return this._init(t, r, n);
  }
  _init(t, r, n) {
    var i, o;
    if (r === void 0 && (r = {}), J(t) || xu(t)) return re.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
    if (this.__loaded) return re.warn("You have already initialized PostHog! Re-initializing is a no-op"), this;
    this.__loaded = !0, this.config = {}, this.fs = [], r.person_profiles && (this.vs = r.person_profiles), this.set_config(Ue({}, Ng(r.defaults), Fg(r), { name: n, token: t })), this.config.on_xhr_error && re.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = r.disable_compression ? void 0 : Mr.GZipJS, this.persistence = new wc(this.config), this.sessionPersistence = this.config.persistence === "sessionStorage" || this.config.persistence === "memory" ? this.persistence : new wc(ee({}, this.config, { persistence: "sessionStorage" }));
    var s = ee({}, this.persistence.props), a = ee({}, this.sessionPersistence.props);
    if (this.ps = new y5((v) => this._s(v), this.config.request_queue_config), this.gs = new _5(this), this.__request_queue = [], this.config.__preview_experimental_cookieless_mode || (this.sessionManager = new C5(this), this.sessionPropsManager = new E5(this, this.sessionManager, this.persistence)), new BL(this).startIfEnabledOrStop(), this.siteApps = new I5(this), (i = this.siteApps) == null || i.init(), this.config.__preview_experimental_cookieless_mode || (this.sessionRecording = new $L(this), this.sessionRecording.startIfEnabledOrStop()), this.config.disable_scroll_properties || this.scrollManager.startMeasuringScrollPosition(), this.autocapture = new D$(this), this.autocapture.startIfEnabled(), this.surveys.loadIfEnabled(), this.heatmaps = new jL(this), this.heatmaps.startIfEnabled(), this.webVitalsAutocapture = new WL(this), this.exceptionObserver = new X$(this), this.exceptionObserver.startIfEnabled(), this.deadClicksAutocapture = new n_(this, Y$), this.deadClicksAutocapture.startIfEnabled(), this.historyAutocapture = new uL(this), this.historyAutocapture.startIfEnabled(), Dr.DEBUG = Dr.DEBUG || this.config.debug, Dr.DEBUG && re.info("Starting in debug mode", { this: this, config: r, thisC: ee({}, this.config), p: s, s: a }), this.bs(), ((o = r.bootstrap) == null ? void 0 : o.distinctID) !== void 0) {
      var l, c, u = this.config.get_device_id(an()), f = (l = r.bootstrap) != null && l.isIdentifiedID ? u : r.bootstrap.distinctID;
      this.persistence.set_property(Vr, (c = r.bootstrap) != null && c.isIdentifiedID ? "identified" : "anonymous"), this.register({ distinct_id: r.bootstrap.distinctID, $device_id: f });
    }
    if (this.ys()) {
      var d, p, g = Object.keys(((d = r.bootstrap) == null ? void 0 : d.featureFlags) || {}).filter((v) => {
        var y;
        return !((y = r.bootstrap) == null || (y = y.featureFlags) == null || !y[v]);
      }).reduce((v, y) => {
        var x;
        return v[y] = ((x = r.bootstrap) == null || (x = x.featureFlags) == null ? void 0 : x[y]) || !1, v;
      }, {}), h = Object.keys(((p = r.bootstrap) == null ? void 0 : p.featureFlagPayloads) || {}).filter((v) => g[v]).reduce((v, y) => {
        var x, S;
        return (x = r.bootstrap) != null && (x = x.featureFlagPayloads) != null && x[y] && (v[y] = (S = r.bootstrap) == null || (S = S.featureFlagPayloads) == null ? void 0 : S[y]), v;
      }, {});
      this.featureFlags.receivedFeatureFlags({ featureFlags: g, featureFlagPayloads: h });
    }
    if (this.config.__preview_experimental_cookieless_mode) this.register_once({ distinct_id: Kp, $device_id: null }, "");
    else if (!this.get_distinct_id()) {
      var m = this.config.get_device_id(an());
      this.register_once({ distinct_id: m, $device_id: m }, ""), this.persistence.set_property(Vr, "anonymous");
    }
    return Ve(A, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), { passive: !1 }), this.toolbar.maybeLoadToolbar(), r.segment ? LL(this, () => this.ws()) : this.ws(), Xt(this.config._onCapture) && this.config._onCapture !== Gu && (re.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (v) => this.config._onCapture(v.event, v))), this;
  }
  be(t) {
    var r, n, i, o, s, a, l, c;
    if (!te || !te.body) return re.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(() => {
      this.be(t);
    }, 500);
    this.compression = void 0, t.supportedCompression && !this.config.disable_compression && (this.compression = ve(t.supportedCompression, Mr.GZipJS) ? Mr.GZipJS : ve(t.supportedCompression, Mr.Base64) ? Mr.Base64 : void 0), (r = t.analytics) != null && r.endpoint && (this.analyticsDefaultEndpoint = t.analytics.endpoint), this.set_config({ person_profiles: this.vs ? this.vs : "identified_only" }), (n = this.siteApps) == null || n.onRemoteConfig(t), (i = this.sessionRecording) == null || i.onRemoteConfig(t), (o = this.autocapture) == null || o.onRemoteConfig(t), (s = this.heatmaps) == null || s.onRemoteConfig(t), this.surveys.onRemoteConfig(t), (a = this.webVitalsAutocapture) == null || a.onRemoteConfig(t), (l = this.exceptionObserver) == null || l.onRemoteConfig(t), this.exceptions.onRemoteConfig(t), (c = this.deadClicksAutocapture) == null || c.onRemoteConfig(t);
  }
  ws() {
    try {
      this.config.loaded(this);
    } catch (t) {
      re.critical("`loaded` function failed", t);
    }
    this.Ss(), this.config.capture_pageview && setTimeout(() => {
      this.consent.isOptedIn() && this.$s();
    }, 1), new b5(this).load(), this.featureFlags.decide();
  }
  Ss() {
    var t;
    this.has_opted_out_capturing() || this.config.request_batching && ((t = this.ps) == null || t.enable());
  }
  _dom_loaded() {
    this.has_opted_out_capturing() || un(this.__request_queue, (t) => this._s(t)), this.__request_queue = [], this.Ss();
  }
  _handle_unload() {
    var t, r;
    this.config.request_batching ? (this.ks() && this.capture("$pageleave"), (t = this.ps) == null || t.unload(), (r = this.gs) == null || r.unload()) : this.ks() && this.capture("$pageleave", null, { transport: "sendBeacon" });
  }
  me(t) {
    this.__loaded && (j_ ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) || (t.transport = t.transport || this.config.api_transport, t.url = Wa(t.url, { ip: this.config.ip ? 1 : 0 }), t.headers = ee({}, this.config.request_headers), t.compression = t.compression === "best-available" ? this.compression : t.compression, t.fetchOptions = t.fetchOptions || this.config.fetch_options, ((r) => {
      var n, i, o, s = ee({}, r);
      s.timeout = s.timeout || 6e4, s.url = Wa(s.url, { _: (/* @__PURE__ */ new Date()).getTime().toString(), ver: Dr.LIB_VERSION, compression: s.compression });
      var a = (n = s.transport) !== null && n !== void 0 ? n : "fetch", l = (i = (o = Bx(Ao, (c) => c.transport === a)) == null ? void 0 : o.method) !== null && i !== void 0 ? i : Ao[0].method;
      if (!l) throw new Error("No available transport method");
      l(s);
    })(ee({}, t, { callback: (r) => {
      var n, i;
      this.rateLimiter.checkForLimiting(r), r.statusCode >= 400 && ((n = (i = this.config).on_request_error) == null || n.call(i, r)), t.callback == null || t.callback(r);
    } }))));
  }
  _s(t) {
    this.gs ? this.gs.retriableRequest(t) : this.me(t);
  }
  _execute_array(t) {
    var r, n = [], i = [], o = [];
    un(t, (a) => {
      a && (r = a[0], Fe(r) ? o.push(a) : Xt(a) ? a.call(this) : Fe(a) && r === "alias" ? n.push(a) : Fe(a) && r.indexOf("capture") !== -1 && Xt(this[r]) ? o.push(a) : i.push(a));
    });
    var s = function(a, l) {
      un(a, function(c) {
        if (Fe(c[0])) {
          var u = l;
          Oe(c, function(f) {
            u = u[f[0]].apply(u, f.slice(1));
          });
        } else this[c[0]].apply(this, c.slice(1));
      }, l);
    };
    s(n, this), s(i, this), s(o, this);
  }
  ys() {
    var t, r;
    return ((t = this.config.bootstrap) == null ? void 0 : t.featureFlags) && Object.keys((r = this.config.bootstrap) == null ? void 0 : r.featureFlags).length > 0 || !1;
  }
  push(t) {
    this._execute_array([t]);
  }
  capture(t, r, n) {
    var i;
    if (this.__loaded && this.persistence && this.sessionPersistence && this.ps) {
      if (!this.consent.isOptedOut()) if (!J(t) && Me(t)) {
        if (this.config.opt_out_useragent_filter || !this._is_bot()) {
          var o = n != null && n.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
          if (o == null || !o.isRateLimited) {
            r != null && r.$current_url && !Me(r == null ? void 0 : r.$current_url) && (re.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), r == null || delete r.$current_url), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
            var s = /* @__PURE__ */ new Date(), a = (n == null ? void 0 : n.timestamp) || s, l = an(), c = { uuid: l, event: t, properties: this.calculateEventProperties(t, r || {}, a, l) };
            o && (c.properties.$lib_rate_limit_remaining_tokens = o.remainingTokens), n != null && n.$set && (c.$set = n == null ? void 0 : n.$set);
            var u, f, d = this.xs(n == null ? void 0 : n.$set_once);
            if (d && (c.$set_once = d), (c = S$(c, n != null && n._noTruncate ? null : this.config.properties_string_max_length)).timestamp = a, J(n == null ? void 0 : n.timestamp) || (c.properties.$event_time_override_provided = !0, c.properties.$event_time_override_system_time = s), t === Sc.DISMISSED || t === Sc.SENT) {
              var p = r == null ? void 0 : r[Og.SURVEY_ID], g = r == null ? void 0 : r[Og.SURVEY_ITERATION];
              localStorage.setItem((f = "" + ju + (u = { id: p, current_iteration: g }).id, u.current_iteration && u.current_iteration > 0 && (f = "" + ju + u.id + "_" + u.current_iteration), f), "true"), c.$set = ee({}, c.$set, { [p5({ id: p, current_iteration: g }, t === Sc.SENT ? "responded" : "dismissed")]: !0 });
            }
            var h = ee({}, c.properties.$set, c.$set);
            if (pi(h) || this.setPersonPropertiesForFlags(h), !xe(this.config.before_send)) {
              var m = this.Es(c);
              if (!m) return;
              c = m;
            }
            this.us.emit("eventCaptured", c);
            var v = { method: "POST", url: (i = n == null ? void 0 : n._url) !== null && i !== void 0 ? i : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint), data: c, compression: "best-available", batchKey: n == null ? void 0 : n._batchKey };
            return !this.config.request_batching || n && (n == null || !n._batchKey) || n != null && n.send_instantly ? this._s(v) : this.ps.enqueue(v), c;
          }
          re.critical("This capture call is ignored due to client rate limiting.");
        }
      } else re.error("No event name provided to posthog.capture");
    } else re.uninitializedWarning("posthog.capture");
  }
  Ne(t) {
    return this.on("eventCaptured", (r) => t(r.event, r));
  }
  calculateEventProperties(t, r, n, i, o) {
    if (n = n || /* @__PURE__ */ new Date(), !this.persistence || !this.sessionPersistence) return r;
    var s = o ? void 0 : this.persistence.remove_event_timer(t), a = ee({}, r);
    if (a.token = this.config.token, a.$config_defaults = this.config.defaults, this.config.__preview_experimental_cookieless_mode && (a.$cookieless_mode = !0), t === "$snapshot") {
      var l = ee({}, this.persistence.properties(), this.sessionPersistence.properties());
      return a.distinct_id = l.distinct_id, (!Me(a.distinct_id) && !pt(a.distinct_id) || xu(a.distinct_id)) && re.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), a;
    }
    var c, u = c5(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties);
    if (this.sessionManager) {
      var { sessionId: f, windowId: d } = this.sessionManager.checkAndGetSessionAndWindowId(o, n.getTime());
      a.$session_id = f, a.$window_id = d;
    }
    this.sessionPropsManager && Ue(a, this.sessionPropsManager.getSessionProps());
    try {
      var p;
      this.sessionRecording && Ue(a, this.sessionRecording.sdkDebugProperties), a.$sdk_debug_retry_queue_size = (p = this.gs) == null ? void 0 : p.length;
    } catch (v) {
      a.$sdk_debug_error_capturing_properties = String(v);
    }
    if (this.requestRouter.region === ko.CUSTOM && (a.$lib_custom_api_host = this.config.api_host), c = t !== "$pageview" || o ? t !== "$pageleave" || o ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(n) : this.pageViewManager.doPageView(n, i), a = Ue(a, c), t === "$pageview" && te && (a.title = te.title), !J(s)) {
      var g = n.getTime() - s;
      a.$duration = parseFloat((g / 1e3).toFixed(3));
    }
    _t && this.config.opt_out_useragent_filter && (a.$browser_type = this._is_bot() ? "bot" : "browser"), (a = Ue({}, u, this.persistence.properties(), this.sessionPersistence.properties(), a)).$is_identified = this._isIdentified(), Fe(this.config.property_denylist) ? Oe(this.config.property_denylist, function(v) {
      delete a[v];
    }) : re.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
    var h = this.config.sanitize_properties;
    h && (re.error("sanitize_properties is deprecated. Use before_send instead"), a = h(a, t));
    var m = this.Is();
    return a.$process_person_profile = m, m && !o && this.Ps("_calculate_event_properties"), a;
  }
  xs(t) {
    var r;
    if (!this.persistence || !this.Is() || this.ls) return t;
    var n = this.persistence.get_initial_props(), i = (r = this.sessionPropsManager) == null ? void 0 : r.getSetOnceProps(), o = Ue({}, n, i || {}, t || {}), s = this.config.sanitize_properties;
    return s && (re.error("sanitize_properties is deprecated. Use before_send instead"), o = s(o, "$set_once")), this.ls = !0, pi(o) ? void 0 : o;
  }
  register(t, r) {
    var n;
    (n = this.persistence) == null || n.register(t, r);
  }
  register_once(t, r, n) {
    var i;
    (i = this.persistence) == null || i.register_once(t, r, n);
  }
  register_for_session(t) {
    var r;
    (r = this.sessionPersistence) == null || r.register(t);
  }
  unregister(t) {
    var r;
    (r = this.persistence) == null || r.unregister(t);
  }
  unregister_for_session(t) {
    var r;
    (r = this.sessionPersistence) == null || r.unregister(t);
  }
  Rs(t, r) {
    this.register({ [t]: r });
  }
  getFeatureFlag(t, r) {
    return this.featureFlags.getFeatureFlag(t, r);
  }
  getFeatureFlagPayload(t) {
    var r = this.featureFlags.getFeatureFlagPayload(t);
    try {
      return JSON.parse(r);
    } catch (n) {
      return r;
    }
  }
  isFeatureEnabled(t, r) {
    return this.featureFlags.isFeatureEnabled(t, r);
  }
  reloadFeatureFlags() {
    this.featureFlags.reloadFeatureFlags();
  }
  updateEarlyAccessFeatureEnrollment(t, r) {
    this.featureFlags.updateEarlyAccessFeatureEnrollment(t, r);
  }
  getEarlyAccessFeatures(t, r, n) {
    return r === void 0 && (r = !1), this.featureFlags.getEarlyAccessFeatures(t, r, n);
  }
  on(t, r) {
    return this.us.on(t, r);
  }
  onFeatureFlags(t) {
    return this.featureFlags.onFeatureFlags(t);
  }
  onSurveysLoaded(t) {
    return this.surveys.onSurveysLoaded(t);
  }
  onSessionId(t) {
    var r, n;
    return (r = (n = this.sessionManager) == null ? void 0 : n.onSessionId(t)) !== null && r !== void 0 ? r : () => {
    };
  }
  getSurveys(t, r) {
    r === void 0 && (r = !1), this.surveys.getSurveys(t, r);
  }
  getActiveMatchingSurveys(t, r) {
    r === void 0 && (r = !1), this.surveys.getActiveMatchingSurveys(t, r);
  }
  renderSurvey(t, r) {
    this.surveys.renderSurvey(t, r);
  }
  canRenderSurvey(t) {
    return this.surveys.canRenderSurvey(t);
  }
  canRenderSurveyAsync(t, r) {
    return r === void 0 && (r = !1), this.surveys.canRenderSurveyAsync(t, r);
  }
  identify(t, r, n) {
    if (!this.__loaded || !this.persistence) return re.uninitializedWarning("posthog.identify");
    if (pt(t) && (t = t.toString(), re.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), t) {
      if (["distinct_id", "distinctid"].includes(t.toLowerCase())) re.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.');
      else if (this.Ps("posthog.identify")) {
        var i = this.get_distinct_id();
        if (this.register({ $user_id: t }), !this.get_property("$device_id")) {
          var o = i;
          this.register_once({ $had_persisted_distinct_id: !0, $device_id: o }, "");
        }
        t !== i && t !== this.get_property(yo) && (this.unregister(yo), this.register({ distinct_id: t }));
        var s = (this.persistence.get_property(Vr) || "anonymous") === "anonymous";
        t !== i && s ? (this.persistence.set_property(Vr, "identified"), this.setPersonPropertiesForFlags(ee({}, n || {}, r || {}), !1), this.capture("$identify", { distinct_id: t, $anon_distinct_id: i }, { $set: r || {}, $set_once: n || {} }), this.cs = xg(t, r, n), this.featureFlags.setAnonymousDistinctId(i)) : (r || n) && this.setPersonProperties(r, n), t !== i && (this.reloadFeatureFlags(), this.unregister(Aa));
      }
    } else re.error("Unique user id has not been set in posthog.identify");
  }
  setPersonProperties(t, r) {
    if ((t || r) && this.Ps("posthog.setPersonProperties")) {
      var n = xg(this.get_distinct_id(), t, r);
      this.cs !== n ? (this.setPersonPropertiesForFlags(ee({}, r || {}, t || {})), this.capture("$set", { $set: t || {}, $set_once: r || {} }), this.cs = n) : re.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
    }
  }
  group(t, r, n) {
    if (t && r) {
      if (this.Ps("posthog.group")) {
        var i = this.getGroups();
        i[t] !== r && this.resetGroupPropertiesForFlags(t), this.register({ $groups: ee({}, i, { [t]: r }) }), n && (this.capture("$groupidentify", { $group_type: t, $group_key: r, $group_set: n }), this.setGroupPropertiesForFlags({ [t]: n })), i[t] === r || n || this.reloadFeatureFlags();
      }
    } else re.error("posthog.group requires a group type and group key");
  }
  resetGroups() {
    this.register({ $groups: {} }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
  }
  setPersonPropertiesForFlags(t, r) {
    r === void 0 && (r = !0), this.featureFlags.setPersonPropertiesForFlags(t, r);
  }
  resetPersonPropertiesForFlags() {
    this.featureFlags.resetPersonPropertiesForFlags();
  }
  setGroupPropertiesForFlags(t, r) {
    r === void 0 && (r = !0), this.Ps("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(t, r);
  }
  resetGroupPropertiesForFlags(t) {
    this.featureFlags.resetGroupPropertiesForFlags(t);
  }
  reset(t) {
    var r, n, i, o;
    if (re.info("reset"), !this.__loaded) return re.uninitializedWarning("posthog.reset");
    var s = this.get_property("$device_id");
    if (this.consent.reset(), (r = this.persistence) == null || r.clear(), (n = this.sessionPersistence) == null || n.clear(), this.surveys.reset(), (i = this.persistence) == null || i.set_property(Vr, "anonymous"), (o = this.sessionManager) == null || o.resetSessionId(), this.cs = null, this.config.__preview_experimental_cookieless_mode) this.register_once({ distinct_id: Kp, $device_id: null }, "");
    else {
      var a = this.config.get_device_id(an());
      this.register_once({ distinct_id: a, $device_id: t ? a : s }, "");
    }
    this.register({ $last_posthog_reset: (/* @__PURE__ */ new Date()).toISOString() }, 1);
  }
  get_distinct_id() {
    return this.get_property("distinct_id");
  }
  getGroups() {
    return this.get_property("$groups") || {};
  }
  get_session_id() {
    var t, r;
    return (t = (r = this.sessionManager) == null ? void 0 : r.checkAndGetSessionAndWindowId(!0).sessionId) !== null && t !== void 0 ? t : "";
  }
  get_session_replay_url(t) {
    if (!this.sessionManager) return "";
    var { sessionId: r, sessionStartTimestamp: n } = this.sessionManager.checkAndGetSessionAndWindowId(!0), i = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + r);
    if (t != null && t.withTimestamp && n) {
      var o, s = (o = t.timestampLookBack) !== null && o !== void 0 ? o : 10;
      if (!n) return i;
      i += "?t=" + Math.max(Math.floor(((/* @__PURE__ */ new Date()).getTime() - n) / 1e3) - s, 0);
    }
    return i;
  }
  alias(t, r) {
    return t === this.get_property(Wx) ? (re.critical("Attempting to create alias for existing People user - aborting."), -2) : this.Ps("posthog.alias") ? (J(r) && (r = this.get_distinct_id()), t !== r ? (this.Rs(yo, t), this.capture("$create_alias", { alias: t, distinct_id: r })) : (re.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
  }
  set_config(t) {
    var r, n, i, o, s = ee({}, this.config);
    De(t) && (Ue(this.config, Fg(t)), (r = this.persistence) == null || r.update_config(this.config, s), this.sessionPersistence = this.config.persistence === "sessionStorage" || this.config.persistence === "memory" ? this.persistence : new wc(ee({}, this.config, { persistence: "sessionStorage" })), Je.O() && Je.A("ph_debug") === "true" && (this.config.debug = !0), this.config.debug && (Dr.DEBUG = !0, re.info("set_config", JSON.stringify({ config: t, oldConfig: s, newConfig: ee({}, this.config) }, null, 2))), (n = this.sessionRecording) == null || n.startIfEnabledOrStop(), (i = this.autocapture) == null || i.startIfEnabled(), (o = this.heatmaps) == null || o.startIfEnabled(), this.surveys.loadIfEnabled(), this.bs());
  }
  startSessionRecording(t) {
    var r = t === !0, n = { sampling: r || !(t == null || !t.sampling), linked_flag: r || !(t == null || !t.linked_flag), url_trigger: r || !(t == null || !t.url_trigger), event_trigger: r || !(t == null || !t.event_trigger) };
    if (Object.values(n).some(Boolean)) {
      var i, o, s, a, l;
      (i = this.sessionManager) == null || i.checkAndGetSessionAndWindowId(), n.sampling && ((o = this.sessionRecording) == null || o.overrideSampling()), n.linked_flag && ((s = this.sessionRecording) == null || s.overrideLinkedFlag()), n.url_trigger && ((a = this.sessionRecording) == null || a.overrideTrigger("url")), n.event_trigger && ((l = this.sessionRecording) == null || l.overrideTrigger("event"));
    }
    this.set_config({ disable_session_recording: !1 });
  }
  stopSessionRecording() {
    this.set_config({ disable_session_recording: !0 });
  }
  sessionRecordingStarted() {
    var t;
    return !((t = this.sessionRecording) == null || !t.started);
  }
  captureException(t, r) {
    var n = new Error("PostHog syntheticException");
    this.exceptions.sendExceptionEvent(ee({}, cL(((i) => i instanceof Error)(t) ? { error: t, event: t.message } : { event: t }, { syntheticException: n }), r));
  }
  loadToolbar(t) {
    return this.toolbar.loadToolbar(t);
  }
  get_property(t) {
    var r;
    return (r = this.persistence) == null ? void 0 : r.props[t];
  }
  getSessionProperty(t) {
    var r;
    return (r = this.sessionPersistence) == null ? void 0 : r.props[t];
  }
  toString() {
    var t, r = (t = this.config.name) !== null && t !== void 0 ? t : di;
    return r !== di && (r = di + "." + r), r;
  }
  _isIdentified() {
    var t, r;
    return ((t = this.persistence) == null ? void 0 : t.get_property(Vr)) === "identified" || ((r = this.sessionPersistence) == null ? void 0 : r.get_property(Vr)) === "identified";
  }
  Is() {
    var t, r;
    return !(this.config.person_profiles === "never" || this.config.person_profiles === "identified_only" && !this._isIdentified() && pi(this.getGroups()) && ((t = this.persistence) == null || (t = t.props) == null || !t[yo]) && ((r = this.persistence) == null || (r = r.props) == null || !r[Fa]));
  }
  ks() {
    return this.config.capture_pageleave === !0 || this.config.capture_pageleave === "if_capture_pageview" && (this.config.capture_pageview === !0 || this.config.capture_pageview === "history_change");
  }
  createPersonProfile() {
    this.Is() || this.Ps("posthog.createPersonProfile") && this.setPersonProperties({}, {});
  }
  Ps(t) {
    return this.config.person_profiles === "never" ? (re.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.Rs(Fa, !0), !0);
  }
  bs() {
    var t, r, n, i, o = this.consent.isOptedOut(), s = this.config.opt_out_persistence_by_default, a = this.config.disable_persistence || o && !!s;
    ((t = this.persistence) == null ? void 0 : t.xe) !== a && ((n = this.persistence) == null || n.set_disabled(a)), ((r = this.sessionPersistence) == null ? void 0 : r.xe) !== a && ((i = this.sessionPersistence) == null || i.set_disabled(a));
  }
  opt_in_capturing(t) {
    var r;
    this.consent.optInOut(!0), this.bs(), (J(t == null ? void 0 : t.captureEventName) || t != null && t.captureEventName) && this.capture((r = t == null ? void 0 : t.captureEventName) !== null && r !== void 0 ? r : "$opt_in", t == null ? void 0 : t.captureProperties, { send_instantly: !0 }), this.config.capture_pageview && this.$s();
  }
  opt_out_capturing() {
    this.consent.optInOut(!1), this.bs();
  }
  has_opted_in_capturing() {
    return this.consent.isOptedIn();
  }
  has_opted_out_capturing() {
    return this.consent.isOptedOut();
  }
  clear_opt_in_out_capturing() {
    this.consent.reset(), this.bs();
  }
  _is_bot() {
    return Vt ? H_(Vt, this.config.custom_blocked_useragents) : void 0;
  }
  $s() {
    te && (te.visibilityState === "visible" ? this.hs || (this.hs = !0, this.capture("$pageview", { title: te.title }, { send_instantly: !0 }), this.ds && (te.removeEventListener("visibilitychange", this.ds), this.ds = null)) : this.ds || (this.ds = this.$s.bind(this), Ve(te, "visibilitychange", this.ds)));
  }
  debug(t) {
    t === !1 ? (A == null || A.console.log("You've disabled debug mode."), localStorage && localStorage.removeItem("ph_debug"), this.set_config({ debug: !1 })) : (A == null || A.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), localStorage && localStorage.setItem("ph_debug", "true"), this.set_config({ debug: !0 }));
  }
  Es(t) {
    if (xe(this.config.before_send)) return t;
    var r = Fe(this.config.before_send) ? this.config.before_send : [this.config.before_send], n = t;
    for (var i of r) {
      if (n = i(n), xe(n)) {
        var o = "Event '" + t.event + "' was rejected in beforeSend function";
        return x$(t.event) ? re.warn(o + ". This can cause unexpected behavior.") : re.info(o), null;
      }
      n.properties && !pi(n.properties) || re.warn("Event '" + t.event + "' has no properties after beforeSend function, this is likely an error.");
    }
    return n;
  }
  getPageViewId() {
    var t;
    return (t = this.pageViewManager.ne) == null ? void 0 : t.pageViewId;
  }
  captureTraceFeedback(t, r) {
    this.capture("$ai_feedback", { $ai_trace_id: String(t), $ai_feedback_text: r });
  }
  captureTraceMetric(t, r, n) {
    this.capture("$ai_metric", { $ai_trace_id: String(t), $ai_metric_name: r, $ai_metric_value: String(n) });
  }
}
(function(e, t) {
  for (var r = 0; r < t.length; r++) e.prototype[t[r]] = w$(e.prototype[t[r]]);
})(kl, ["identify"]);
var $g, A5 = ($g = No[di] = new kl(), function() {
  function e() {
    e.done || (e.done = !0, j_ = !1, Oe(No, function(t) {
      t._dom_loaded();
    }));
  }
  te != null && te.addEventListener ? te.readyState === "complete" ? e() : Ve(te, "DOMContentLoaded", e, { capture: !1 }) : A && re.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
}(), $g), Ls = {};
const N5 = /* @__PURE__ */ tb(_1), F5 = /* @__PURE__ */ tb(GS);
var Vs = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ec, Lg;
function $5() {
  if (Lg) return Ec;
  Lg = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch (u) {
      return !1;
    }
  }
  return Ec = i() ? Object.assign : function(o, s) {
    for (var a, l = n(o), c, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var f in a)
        t.call(a, f) && (l[f] = a[f]);
      if (e) {
        c = e(a);
        for (var d = 0; d < c.length; d++)
          r.call(a, c[d]) && (l[c[d]] = a[c[d]]);
      }
    }
    return l;
  }, Ec;
}
var Cc, Vg;
function pf() {
  if (Vg) return Cc;
  Vg = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Cc = e, Cc;
}
var kc, zg;
function U_() {
  return zg || (zg = 1, kc = Function.call.bind(Object.prototype.hasOwnProperty)), kc;
}
var Ic, Dg;
function L5() {
  if (Dg) return Ic;
  Dg = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ pf(), r = {}, n = /* @__PURE__ */ U_();
    e = function(o) {
      var s = "Warning: " + o;
      typeof console != "undefined" && console.error(s);
      try {
        throw new Error(s);
      } catch (a) {
      }
    };
  }
  function i(o, s, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in o)
        if (n(o, u)) {
          var f;
          try {
            if (typeof o[u] != "function") {
              var d = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = o[u](s, u, l, a, null, t);
          } catch (g) {
            f = g;
          }
          if (f && !(f instanceof Error) && e(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + a + " type: " + f.message + (p != null ? p : "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Ic = i, Ic;
}
var Oc, Mg;
function V5() {
  if (Mg) return Oc;
  Mg = 1;
  var e = cd(), t = $5(), r = /* @__PURE__ */ pf(), n = /* @__PURE__ */ U_(), i = /* @__PURE__ */ L5(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(a) {
    var l = "Warning: " + a;
    typeof console != "undefined" && console.error(l);
    try {
      throw new Error(l);
    } catch (c) {
    }
  });
  function s() {
    return null;
  }
  return Oc = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function f(P) {
      var C = P && (c && P[c] || P[u]);
      if (typeof C == "function")
        return C;
    }
    var d = "<<anonymous>>", p = {
      array: v("array"),
      bigint: v("bigint"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: y(),
      arrayOf: x,
      element: S(),
      elementType: _(),
      instanceOf: I,
      node: T(),
      objectOf: w,
      oneOf: O,
      oneOfType: E,
      shape: k,
      exact: j
    };
    function g(P, C) {
      return P === C ? P !== 0 || 1 / P === 1 / C : P !== P && C !== C;
    }
    function h(P, C) {
      this.message = P, this.data = C && typeof C == "object" ? C : {}, this.stack = "";
    }
    h.prototype = Error.prototype;
    function m(P) {
      if (process.env.NODE_ENV !== "production")
        var C = {}, W = 0;
      function H(Q, X, ne, R, M, z, Y) {
        if (R = R || d, z = z || ne, Y !== r) {
          if (l) {
            var U = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw U.name = "Invariant Violation", U;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var se = R + ":" + ne;
            !C[se] && // Avoid spamming the console because they are often not actionable except for lib authors
            W < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + z + "` prop on `" + R + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), C[se] = !0, W++);
          }
        }
        return X[ne] == null ? Q ? X[ne] === null ? new h("The " + M + " `" + z + "` is marked as required " + ("in `" + R + "`, but its value is `null`.")) : new h("The " + M + " `" + z + "` is marked as required in " + ("`" + R + "`, but its value is `undefined`.")) : null : P(X, ne, R, M, z);
      }
      var V = H.bind(null, !1);
      return V.isRequired = H.bind(null, !0), V;
    }
    function v(P) {
      function C(W, H, V, Q, X, ne) {
        var R = W[H], M = D(R);
        if (M !== P) {
          var z = N(R);
          return new h(
            "Invalid " + Q + " `" + X + "` of type " + ("`" + z + "` supplied to `" + V + "`, expected ") + ("`" + P + "`."),
            { expectedType: P }
          );
        }
        return null;
      }
      return m(C);
    }
    function y() {
      return m(s);
    }
    function x(P) {
      function C(W, H, V, Q, X) {
        if (typeof P != "function")
          return new h("Property `" + X + "` of component `" + V + "` has invalid PropType notation inside arrayOf.");
        var ne = W[H];
        if (!Array.isArray(ne)) {
          var R = D(ne);
          return new h("Invalid " + Q + " `" + X + "` of type " + ("`" + R + "` supplied to `" + V + "`, expected an array."));
        }
        for (var M = 0; M < ne.length; M++) {
          var z = P(ne, M, V, Q, X + "[" + M + "]", r);
          if (z instanceof Error)
            return z;
        }
        return null;
      }
      return m(C);
    }
    function S() {
      function P(C, W, H, V, Q) {
        var X = C[W];
        if (!a(X)) {
          var ne = D(X);
          return new h("Invalid " + V + " `" + Q + "` of type " + ("`" + ne + "` supplied to `" + H + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(P);
    }
    function _() {
      function P(C, W, H, V, Q) {
        var X = C[W];
        if (!e.isValidElementType(X)) {
          var ne = D(X);
          return new h("Invalid " + V + " `" + Q + "` of type " + ("`" + ne + "` supplied to `" + H + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(P);
    }
    function I(P) {
      function C(W, H, V, Q, X) {
        if (!(W[H] instanceof P)) {
          var ne = P.name || d, R = q(W[H]);
          return new h("Invalid " + Q + " `" + X + "` of type " + ("`" + R + "` supplied to `" + V + "`, expected ") + ("instance of `" + ne + "`."));
        }
        return null;
      }
      return m(C);
    }
    function O(P) {
      if (!Array.isArray(P))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function C(W, H, V, Q, X) {
        for (var ne = W[H], R = 0; R < P.length; R++)
          if (g(ne, P[R]))
            return null;
        var M = JSON.stringify(P, function(Y, U) {
          var se = N(U);
          return se === "symbol" ? String(U) : U;
        });
        return new h("Invalid " + Q + " `" + X + "` of value `" + String(ne) + "` " + ("supplied to `" + V + "`, expected one of " + M + "."));
      }
      return m(C);
    }
    function w(P) {
      function C(W, H, V, Q, X) {
        if (typeof P != "function")
          return new h("Property `" + X + "` of component `" + V + "` has invalid PropType notation inside objectOf.");
        var ne = W[H], R = D(ne);
        if (R !== "object")
          return new h("Invalid " + Q + " `" + X + "` of type " + ("`" + R + "` supplied to `" + V + "`, expected an object."));
        for (var M in ne)
          if (n(ne, M)) {
            var z = P(ne, M, V, Q, X + "." + M, r);
            if (z instanceof Error)
              return z;
          }
        return null;
      }
      return m(C);
    }
    function E(P) {
      if (!Array.isArray(P))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var C = 0; C < P.length; C++) {
        var W = P[C];
        if (typeof W != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + B(W) + " at index " + C + "."
          ), s;
      }
      function H(V, Q, X, ne, R) {
        for (var M = [], z = 0; z < P.length; z++) {
          var Y = P[z], U = Y(V, Q, X, ne, R, r);
          if (U == null)
            return null;
          U.data && n(U.data, "expectedType") && M.push(U.data.expectedType);
        }
        var se = M.length > 0 ? ", expected one of type [" + M.join(", ") + "]" : "";
        return new h("Invalid " + ne + " `" + R + "` supplied to " + ("`" + X + "`" + se + "."));
      }
      return m(H);
    }
    function T() {
      function P(C, W, H, V, Q) {
        return F(C[W]) ? null : new h("Invalid " + V + " `" + Q + "` supplied to " + ("`" + H + "`, expected a ReactNode."));
      }
      return m(P);
    }
    function G(P, C, W, H, V) {
      return new h(
        (P || "React class") + ": " + C + " type `" + W + "." + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + V + "`."
      );
    }
    function k(P) {
      function C(W, H, V, Q, X) {
        var ne = W[H], R = D(ne);
        if (R !== "object")
          return new h("Invalid " + Q + " `" + X + "` of type `" + R + "` " + ("supplied to `" + V + "`, expected `object`."));
        for (var M in P) {
          var z = P[M];
          if (typeof z != "function")
            return G(V, Q, X, M, N(z));
          var Y = z(ne, M, V, Q, X + "." + M, r);
          if (Y)
            return Y;
        }
        return null;
      }
      return m(C);
    }
    function j(P) {
      function C(W, H, V, Q, X) {
        var ne = W[H], R = D(ne);
        if (R !== "object")
          return new h("Invalid " + Q + " `" + X + "` of type `" + R + "` " + ("supplied to `" + V + "`, expected `object`."));
        var M = t({}, W[H], P);
        for (var z in M) {
          var Y = P[z];
          if (n(P, z) && typeof Y != "function")
            return G(V, Q, X, z, N(Y));
          if (!Y)
            return new h(
              "Invalid " + Q + " `" + X + "` key `" + z + "` supplied to `" + V + "`.\nBad object: " + JSON.stringify(W[H], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(P), null, "  ")
            );
          var U = Y(ne, z, V, Q, X + "." + z, r);
          if (U)
            return U;
        }
        return null;
      }
      return m(C);
    }
    function F(P) {
      switch (typeof P) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !P;
        case "object":
          if (Array.isArray(P))
            return P.every(F);
          if (P === null || a(P))
            return !0;
          var C = f(P);
          if (C) {
            var W = C.call(P), H;
            if (C !== P.entries) {
              for (; !(H = W.next()).done; )
                if (!F(H.value))
                  return !1;
            } else
              for (; !(H = W.next()).done; ) {
                var V = H.value;
                if (V && !F(V[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function L(P, C) {
      return P === "symbol" ? !0 : C ? C["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && C instanceof Symbol : !1;
    }
    function D(P) {
      var C = typeof P;
      return Array.isArray(P) ? "array" : P instanceof RegExp ? "object" : L(C, P) ? "symbol" : C;
    }
    function N(P) {
      if (typeof P == "undefined" || P === null)
        return "" + P;
      var C = D(P);
      if (C === "object") {
        if (P instanceof Date)
          return "date";
        if (P instanceof RegExp)
          return "regexp";
      }
      return C;
    }
    function B(P) {
      var C = N(P);
      switch (C) {
        case "array":
        case "object":
          return "an " + C;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + C;
        default:
          return C;
      }
    }
    function q(P) {
      return !P.constructor || !P.constructor.name ? d : P.constructor.name;
    }
    return p.checkPropTypes = i, p.resetWarningCache = i.resetWarningCache, p.PropTypes = p, p;
  }, Oc;
}
var Pc, Bg;
function z5() {
  if (Bg) return Pc;
  Bg = 1;
  var e = /* @__PURE__ */ pf();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Pc = function() {
    function n(s, a, l, c, u, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var o = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Pc;
}
var Wg;
function D5() {
  if (Wg) return Vs.exports;
  if (Wg = 1, process.env.NODE_ENV !== "production") {
    var e = cd(), t = !0;
    Vs.exports = /* @__PURE__ */ V5()(e.isElement, t);
  } else
    Vs.exports = /* @__PURE__ */ z5()();
  return Vs.exports;
}
var Hg;
function M5() {
  if (Hg) return Ls;
  Hg = 1, Object.defineProperty(Ls, "__esModule", { value: !0 });
  var e = xr, t = N5, r = F5, n = aS, i = cS, o = /* @__PURE__ */ D5();
  function s(F) {
    return F && typeof F == "object" && "default" in F ? F : { default: F };
  }
  var a = s(e), l = s(r), c = s(o), u = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof Wf != "undefined" ? Wf : typeof self != "undefined" ? self : {};
  function f(F, L) {
    return F(L = { exports: {} }, L.exports), L.exports;
  }
  var d = f(function(F) {
    (function(L) {
      var D = function(z, Y, U) {
        if (!W(Y) || V(Y) || Q(Y) || X(Y) || C(Y)) return Y;
        var se, we = 0, ze = 0;
        if (H(Y)) for (se = [], ze = Y.length; we < ze; we++) se.push(D(z, Y[we], U));
        else for (var Ye in se = {}, Y) Object.prototype.hasOwnProperty.call(Y, Ye) && (se[z(Ye, U)] = D(z, Y[Ye], U));
        return se;
      }, N = function(z) {
        return ne(z) ? z : (z = z.replace(/[\-_\s]+(.)?/g, function(Y, U) {
          return U ? U.toUpperCase() : "";
        })).substr(0, 1).toLowerCase() + z.substr(1);
      }, B = function(z) {
        var Y = N(z);
        return Y.substr(0, 1).toUpperCase() + Y.substr(1);
      }, q = function(z, Y) {
        return function(U, se) {
          var we = (se = se || {}).separator || "_", ze = se.split || /(?=[A-Z])/;
          return U.split(ze).join(we);
        }(z, Y).toLowerCase();
      }, P = Object.prototype.toString, C = function(z) {
        return typeof z == "function";
      }, W = function(z) {
        return z === Object(z);
      }, H = function(z) {
        return P.call(z) == "[object Array]";
      }, V = function(z) {
        return P.call(z) == "[object Date]";
      }, Q = function(z) {
        return P.call(z) == "[object RegExp]";
      }, X = function(z) {
        return P.call(z) == "[object Boolean]";
      }, ne = function(z) {
        return (z -= 0) == z;
      }, R = function(z, Y) {
        var U = Y && "process" in Y ? Y.process : Y;
        return typeof U != "function" ? z : function(se, we) {
          return U(se, z, we);
        };
      }, M = { camelize: N, decamelize: q, pascalize: B, depascalize: q, camelizeKeys: function(z, Y) {
        return D(R(N, Y), z);
      }, decamelizeKeys: function(z, Y) {
        return D(R(q, Y), z, Y);
      }, pascalizeKeys: function(z, Y) {
        return D(R(B, Y), z);
      }, depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      } };
      F.exports ? F.exports = M : L.humps = M;
    })(u);
  }).decamelize, p = function(F) {
    if (Array.isArray(F)) return F;
  }, g = function(F, L) {
    if (typeof Symbol != "undefined" && Symbol.iterator in Object(F)) {
      var D = [], N = !0, B = !1, q = void 0;
      try {
        for (var P, C = F[Symbol.iterator](); !(N = (P = C.next()).done) && (D.push(P.value), !L || D.length !== L); N = !0) ;
      } catch (W) {
        B = !0, q = W;
      } finally {
        try {
          N || C.return == null || C.return();
        } finally {
          if (B) throw q;
        }
      }
      return D;
    }
  }, h = function(F, L) {
    (L == null || L > F.length) && (L = F.length);
    for (var D = 0, N = new Array(L); D < L; D++) N[D] = F[D];
    return N;
  }, m = function(F, L) {
    if (F) {
      if (typeof F == "string") return h(F, L);
      var D = Object.prototype.toString.call(F).slice(8, -1);
      return D === "Object" && F.constructor && (D = F.constructor.name), D === "Map" || D === "Set" ? Array.from(F) : D === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(D) ? h(F, L) : void 0;
    }
  }, v = function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }, y = function(F, L) {
    return p(F) || g(F, L) || m(F, L) || v();
  }, x = f(function(F) {
    function L() {
      return F.exports = L = Object.assign || function(D) {
        for (var N = 1; N < arguments.length; N++) {
          var B = arguments[N];
          for (var q in B) Object.prototype.hasOwnProperty.call(B, q) && (D[q] = B[q]);
        }
        return D;
      }, L.apply(this, arguments);
    }
    F.exports = L;
  }), S = function(F, L) {
    if (F == null) return {};
    var D, N, B = {}, q = Object.keys(F);
    for (N = 0; N < q.length; N++) D = q[N], L.indexOf(D) >= 0 || (B[D] = F[D]);
    return B;
  }, _ = function(F, L) {
    if (F == null) return {};
    var D, N, B = S(F, L);
    if (Object.getOwnPropertySymbols) {
      var q = Object.getOwnPropertySymbols(F);
      for (N = 0; N < q.length; N++) D = q[N], L.indexOf(D) >= 0 || Object.prototype.propertyIsEnumerable.call(F, D) && (B[D] = F[D]);
    }
    return B;
  }, I = e.createContext(null);
  function O(F) {
    var L = F.children, D = L === void 0 ? "" : L, N = _(F, ["children"]);
    return typeof D != "string" && (D = i.renderToString(D)), a.default.createElement("template", x({}, N, { dangerouslySetInnerHTML: { __html: D } }));
  }
  function w(F) {
    var L = F.root, D = F.children, N = D === void 0 ? null : D;
    return n.createPortal(N, L);
  }
  function E(F) {
    var L = e.forwardRef(function(D, N) {
      var B, q, P = D.mode, C = P === void 0 ? "open" : P, W = D.delegatesFocus, H = W !== void 0 && W, V = D.styleSheets, Q = V === void 0 ? [] : V, X = D.ssr, ne = X !== void 0 && X, R = D.children, M = _(D, ["mode", "delegatesFocus", "styleSheets", "ssr", "children"]), z = (B = N, q = e.useRef(B && B.current), e.useEffect(function() {
        B && (B.current = q.current);
      }, [B]), q), Y = e.useState(null), U = y(Y, 2), se = U[0], we = U[1], ze = "node_".concat(C).concat(H);
      return e.useLayoutEffect(function() {
        if (z.current) try {
          if (typeof N == "function" && N(z.current), ne) {
            var Ye = z.current.shadowRoot;
            return void we(Ye);
          }
          var At = z.current.attachShadow({ mode: C, delegatesFocus: H });
          Q.length > 0 && (At.adoptedStyleSheets = Q), we(At);
        } catch (Jr) {
          (function(lr) {
            var Tr = lr.error, Yn = lr.styleSheets, Zr = lr.root;
            switch (Tr.name) {
              case "NotSupportedError":
                Yn.length > 0 && (Zr.adoptedStyleSheets = Yn);
                break;
              default:
                throw Tr;
            }
          })({ error: Jr, styleSheets: Q, root: se });
        }
      }, [N, z, Q]), a.default.createElement(a.default.Fragment, null, a.default.createElement(F.tag, x({ key: ze, ref: z }, M), (se || ne) && a.default.createElement(I.Provider, { value: se }, ne ? a.default.createElement(O, { shadowroot: C, shadowrootmode: C }, F.render({ root: se, ssr: ne, children: R })) : a.default.createElement(w, { root: se }, F.render({ root: se, ssr: ne, children: R })))));
    });
    return L.propTypes = { mode: c.default.oneOf(["open", "closed"]), delegatesFocus: c.default.bool, styleSheets: c.default.arrayOf(c.default.instanceOf(globalThis.CSSStyleSheet)), ssr: c.default.bool, children: c.default.node }, L;
  }
  O.propTypes = { children: c.default.oneOfType([c.default.string, c.default.node]) }, w.propTypes = { root: c.default.object.isRequired, children: c.default.node };
  var T = /* @__PURE__ */ new Map();
  function G() {
    var F = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "core", D = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(N) {
      return N.children;
    };
    return new Proxy(F, { get: function(N, B) {
      var q = d(B, { separator: "-" }), P = "".concat(L, "-").concat(q);
      return T.has(P) || T.set(P, E({ tag: q, render: D })), T.get(P);
    } });
  }
  G();
  var k = /* @__PURE__ */ new WeakMap(), j = G({}, "emotion", function(F) {
    var L = F.root, D = F.children, N = k.get(L) || function() {
      var B = l.default({ container: L, key: "react-shadow" });
      return k.set(L, B), B;
    }();
    return a.default.createElement(t.CacheProvider, { value: N }, a.default.createElement(a.default.Fragment, null, D));
  });
  return Ls.default = j, Ls;
}
var B5 = M5();
const W5 = /* @__PURE__ */ ld(B5);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H5 = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), G_ = (...e) => e.filter((t, r, n) => !!t && t.trim() !== "" && n.indexOf(t) === r).join(" ").trim();
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var j5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U5 = Z(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: i = "",
    children: o,
    iconNode: s,
    ...a
  }, l) => $n(
    "svg",
    {
      ref: l,
      ...j5,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: n ? Number(r) * 24 / Number(t) : r,
      className: G_("lucide", i),
      ...a
    },
    [
      ...s.map(([c, u]) => $n(c, u)),
      ...Array.isArray(o) ? o : [o]
    ]
  )
);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pr = (e, t) => {
  const r = Z(
    ({ className: n, ...i }, o) => $n(U5, {
      ref: o,
      iconNode: t,
      className: G_(`lucide-${H5(e)}`, n),
      ...i
    })
  );
  return r.displayName = `${e}`, r;
};
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G5 = Pr("ArrowDown", [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q5 = Pr("ChevronsRight", [
  ["path", { d: "m6 17 5-5-5-5", key: "xnjwq" }],
  ["path", { d: "m13 17 5-5-5-5", key: "17xmmf" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K5 = Pr("CircleCheck", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y5 = Pr("CircleX", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X5 = Pr("ExternalLink", [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J5 = Pr("Fuel", [
  ["line", { x1: "3", x2: "15", y1: "22", y2: "22", key: "xegly4" }],
  ["line", { x1: "4", x2: "14", y1: "9", y2: "9", key: "xcnuvu" }],
  ["path", { d: "M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18", key: "16j0yd" }],
  [
    "path",
    {
      d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5",
      key: "7cu91f"
    }
  ]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z5 = Pr("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q5 = Pr("Settings", [
  [
    "path",
    {
      d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
      key: "1qme2f"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eV = Pr("ShieldAlert", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q_ = Pr("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
function gf(e, { strict: t = !0 } = {}) {
  return !e || typeof e != "string" ? !1 : t ? /^0x[0-9a-fA-F]*$/.test(e) : e.startsWith("0x");
}
function jg(e) {
  return gf(e, { strict: !1 }) ? Math.ceil((e.length - 2) / 2) : e.length;
}
const K_ = "2.29.4";
let co = {
  getDocsUrl: ({ docsBaseUrl: e, docsPath: t = "", docsSlug: r }) => t ? `${e != null ? e : "https://viem.sh"}${t}${r ? `#${r}` : ""}` : void 0,
  version: `viem@${K_}`
};
class mn extends Error {
  constructor(t, r = {}) {
    var a, l;
    const n = (() => {
      var c;
      return r.cause instanceof mn ? r.cause.details : (c = r.cause) != null && c.message ? r.cause.message : r.details;
    })(), i = r.cause instanceof mn && r.cause.docsPath || r.docsPath, o = (a = co.getDocsUrl) == null ? void 0 : a.call(co, { ...r, docsPath: i }), s = [
      t || "An error occurred.",
      "",
      ...r.metaMessages ? [...r.metaMessages, ""] : [],
      ...o ? [`Docs: ${o}`] : [],
      ...n ? [`Details: ${n}`] : [],
      ...co.version ? [`Version: ${co.version}`] : []
    ].join(`
`);
    super(s, r.cause ? { cause: r.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), this.details = n, this.docsPath = i, this.metaMessages = r.metaMessages, this.name = (l = r.name) != null ? l : this.name, this.shortMessage = t, this.version = K_;
  }
  walk(t) {
    return Y_(this, t);
  }
}
function Y_(e, t) {
  return t != null && t(e) ? e : e && typeof e == "object" && "cause" in e && e.cause !== void 0 ? Y_(e.cause, t) : t ? null : e;
}
class X_ extends mn {
  constructor({ size: t, targetSize: r, type: n }) {
    super(`${n.charAt(0).toUpperCase()}${n.slice(1).toLowerCase()} size (${t}) exceeds padding size (${r}).`, { name: "SizeExceedsPaddingSizeError" });
  }
}
function Il(e, { dir: t, size: r = 32 } = {}) {
  return typeof e == "string" ? tV(e, { dir: t, size: r }) : rV(e, { dir: t, size: r });
}
function tV(e, { dir: t, size: r = 32 } = {}) {
  if (r === null)
    return e;
  const n = e.replace("0x", "");
  if (n.length > r * 2)
    throw new X_({
      size: Math.ceil(n.length / 2),
      targetSize: r,
      type: "hex"
    });
  return `0x${n[t === "right" ? "padEnd" : "padStart"](r * 2, "0")}`;
}
function rV(e, { dir: t, size: r = 32 } = {}) {
  if (r === null)
    return e;
  if (e.length > r)
    throw new X_({
      size: e.length,
      targetSize: r,
      type: "bytes"
    });
  const n = new Uint8Array(r);
  for (let i = 0; i < r; i++) {
    const o = t === "right";
    n[o ? i : r - i - 1] = e[o ? i : e.length - i - 1];
  }
  return n;
}
class nV extends mn {
  constructor({ max: t, min: r, signed: n, size: i, value: o }) {
    super(`Number "${o}" is not in safe ${i ? `${i * 8}-bit ${n ? "signed" : "unsigned"} ` : ""}integer range ${t ? `(${r} to ${t})` : `(above ${r})`}`, { name: "IntegerOutOfRangeError" });
  }
}
class iV extends mn {
  constructor({ givenSize: t, maxSize: r }) {
    super(`Size cannot exceed ${r} bytes. Given size: ${t} bytes.`, { name: "SizeOverflowError" });
  }
}
function mf(e, { size: t }) {
  if (jg(e) > t)
    throw new iV({
      givenSize: jg(e),
      maxSize: t
    });
}
function oV(e, t = {}) {
  const { signed: r, size: n } = t, i = BigInt(e);
  let o;
  n ? r ? o = (/* @__PURE__ */ BigInt(1) << BigInt(n) * /* @__PURE__ */ BigInt(8) - /* @__PURE__ */ BigInt(1)) - /* @__PURE__ */ BigInt(1) : o = /* @__PURE__ */ BigInt(2) ** (BigInt(n) * /* @__PURE__ */ BigInt(8)) - /* @__PURE__ */ BigInt(1) : typeof e == "number" && (o = BigInt(Number.MAX_SAFE_INTEGER));
  const s = typeof o == "bigint" && r ? -o - /* @__PURE__ */ BigInt(1) : 0;
  if (o && i > o || i < s) {
    const l = typeof e == "bigint" ? "n" : "";
    throw new nV({
      max: o ? `${o}${l}` : void 0,
      min: `${s}${l}`,
      signed: r,
      size: n,
      value: `${e}${l}`
    });
  }
  const a = `0x${(r && i < 0 ? (/* @__PURE__ */ BigInt(1) << BigInt(n * 8)) + BigInt(i) : i).toString(16)}`;
  return n ? Il(a, { size: n }) : a;
}
const sV = /* @__PURE__ */ new TextEncoder();
function aV(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? cV(e, t) : typeof e == "boolean" ? lV(e, t) : gf(e) ? J_(e, t) : Z_(e, t);
}
function lV(e, t = {}) {
  const r = new Uint8Array(1);
  return r[0] = Number(e), typeof t.size == "number" ? (mf(r, { size: t.size }), Il(r, { size: t.size })) : r;
}
const Fr = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function Ug(e) {
  if (e >= Fr.zero && e <= Fr.nine)
    return e - Fr.zero;
  if (e >= Fr.A && e <= Fr.F)
    return e - (Fr.A - 10);
  if (e >= Fr.a && e <= Fr.f)
    return e - (Fr.a - 10);
}
function J_(e, t = {}) {
  let r = e;
  t.size && (mf(r, { size: t.size }), r = Il(r, { dir: "right", size: t.size }));
  let n = r.slice(2);
  n.length % 2 && (n = `0${n}`);
  const i = n.length / 2, o = new Uint8Array(i);
  for (let s = 0, a = 0; s < i; s++) {
    const l = Ug(n.charCodeAt(a++)), c = Ug(n.charCodeAt(a++));
    if (l === void 0 || c === void 0)
      throw new mn(`Invalid byte sequence ("${n[a - 2]}${n[a - 1]}" in "${n}").`);
    o[s] = l * 16 + c;
  }
  return o;
}
function cV(e, t) {
  const r = oV(e, t);
  return J_(r);
}
function Z_(e, t = {}) {
  const r = sV.encode(e);
  return typeof t.size == "number" ? (mf(r, { size: t.size }), Il(r, { dir: "right", size: t.size })) : r;
}
function Gg(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error("positive integer expected, got " + e);
}
function uV(e) {
  return e instanceof Uint8Array || ArrayBuffer.isView(e) && e.constructor.name === "Uint8Array";
}
function vf(e, ...t) {
  if (!uV(e))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error("Uint8Array expected of length " + t + ", got length=" + e.length);
}
function qg(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function dV(e, t) {
  vf(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error("digestInto() expects output buffer of length at least " + r);
}
const zs = /* @__PURE__ */ BigInt(2 ** 32 - 1), Kg = /* @__PURE__ */ BigInt(32);
function fV(e, t = !1) {
  return t ? { h: Number(e & zs), l: Number(e >> Kg & zs) } : { h: Number(e >> Kg & zs) | 0, l: Number(e & zs) | 0 };
}
function hV(e, t = !1) {
  let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
  for (let i = 0; i < e.length; i++) {
    const { h: o, l: s } = fV(e[i], t);
    [r[i], n[i]] = [o, s];
  }
  return [r, n];
}
const pV = (e, t, r) => e << r | t >>> 32 - r, gV = (e, t, r) => t << r | e >>> 32 - r, mV = (e, t, r) => t << r - 32 | e >>> 64 - r, vV = (e, t, r) => e << r - 32 | t >>> 64 - r;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function bV(e) {
  return new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4));
}
const Yg = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
function yV(e) {
  return e << 24 & 4278190080 | e << 8 & 16711680 | e >>> 8 & 65280 | e >>> 24 & 255;
}
function Xg(e) {
  for (let t = 0; t < e.length; t++)
    e[t] = yV(e[t]);
}
typeof Uint8Array.from([]).toHex == "function" && Uint8Array.fromHex;
function xV(e) {
  if (typeof e != "string")
    throw new Error("utf8ToBytes expected string, got " + typeof e);
  return new Uint8Array(new TextEncoder().encode(e));
}
function Q_(e) {
  return typeof e == "string" && (e = xV(e)), vf(e), e;
}
class _V {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function wV(e) {
  const t = (n) => e().update(Q_(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
const ew = [], tw = [], rw = [], SV = /* @__PURE__ */ BigInt(0), uo = /* @__PURE__ */ BigInt(1), EV = /* @__PURE__ */ BigInt(2), CV = /* @__PURE__ */ BigInt(7), kV = /* @__PURE__ */ BigInt(256), IV = /* @__PURE__ */ BigInt(113);
for (let e = 0, t = uo, r = 1, n = 0; e < 24; e++) {
  [r, n] = [n, (2 * r + 3 * n) % 5], ew.push(2 * (5 * n + r)), tw.push((e + 1) * (e + 2) / 2 % 64);
  let i = SV;
  for (let o = 0; o < 7; o++)
    t = (t << uo ^ (t >> CV) * IV) % kV, t & EV && (i ^= uo << (uo << /* @__PURE__ */ BigInt(o)) - uo);
  rw.push(i);
}
const [OV, PV] = /* @__PURE__ */ hV(rw, !0), Jg = (e, t, r) => r > 32 ? mV(e, t, r) : pV(e, t, r), Zg = (e, t, r) => r > 32 ? vV(e, t, r) : gV(e, t, r);
function TV(e, t = 24) {
  const r = new Uint32Array(10);
  for (let n = 24 - t; n < 24; n++) {
    for (let s = 0; s < 10; s++)
      r[s] = e[s] ^ e[s + 10] ^ e[s + 20] ^ e[s + 30] ^ e[s + 40];
    for (let s = 0; s < 10; s += 2) {
      const a = (s + 8) % 10, l = (s + 2) % 10, c = r[l], u = r[l + 1], f = Jg(c, u, 1) ^ r[a], d = Zg(c, u, 1) ^ r[a + 1];
      for (let p = 0; p < 50; p += 10)
        e[s + p] ^= f, e[s + p + 1] ^= d;
    }
    let i = e[2], o = e[3];
    for (let s = 0; s < 24; s++) {
      const a = tw[s], l = Jg(i, o, a), c = Zg(i, o, a), u = ew[s];
      i = e[u], o = e[u + 1], e[u] = l, e[u + 1] = c;
    }
    for (let s = 0; s < 50; s += 10) {
      for (let a = 0; a < 10; a++)
        r[a] = e[s + a];
      for (let a = 0; a < 10; a++)
        e[s + a] ^= ~r[(a + 2) % 10] & r[(a + 4) % 10];
    }
    e[0] ^= OV[n], e[1] ^= PV[n];
  }
  r.fill(0);
}
class bf extends _V {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, r, n, i = !1, o = 24) {
    if (super(), this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, this.enableXOF = !1, this.blockLen = t, this.suffix = r, this.outputLen = n, this.enableXOF = i, this.rounds = o, Gg(n), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = bV(this.state);
  }
  keccak() {
    Yg || Xg(this.state32), TV(this.state32, this.rounds), Yg || Xg(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    qg(this);
    const { blockLen: r, state: n } = this;
    t = Q_(t);
    const i = t.length;
    for (let o = 0; o < i; ) {
      const s = Math.min(r - this.pos, i - o);
      for (let a = 0; a < s; a++)
        n[this.pos++] ^= t[o++];
      this.pos === r && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: r, pos: n, blockLen: i } = this;
    t[n] ^= r, (r & 128) !== 0 && n === i - 1 && this.keccak(), t[i - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    qg(this, !1), vf(t), this.finish();
    const r = this.state, { blockLen: n } = this;
    for (let i = 0, o = t.length; i < o; ) {
      this.posOut >= n && this.keccak();
      const s = Math.min(n - this.posOut, o - i);
      t.set(r.subarray(this.posOut, this.posOut + s), i), this.posOut += s, i += s;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return Gg(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (dV(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: r, suffix: n, outputLen: i, rounds: o, enableXOF: s } = this;
    return t || (t = new bf(r, n, i, s, o)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = o, t.suffix = n, t.outputLen = i, t.enableXOF = s, t.destroyed = this.destroyed, t;
  }
}
const RV = (e, t, r) => wV(() => new bf(t, e, r)), AV = /* @__PURE__ */ RV(1, 136, 256 / 8);
function NV(e, t) {
  return AV(gf(e, { strict: !1 }) ? aV(e) : e);
}
class nw extends Map {
  constructor(t) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = t;
  }
  get(t) {
    const r = super.get(t);
    return super.has(t) && r !== void 0 && (this.delete(t), super.set(t, r)), r;
  }
  set(t, r) {
    if (super.set(t, r), this.maxSize && this.size > this.maxSize) {
      const n = this.keys().next().value;
      n && this.delete(n);
    }
    return this;
  }
}
const Tc = /* @__PURE__ */ new nw(8192);
function FV(e, t) {
  if (Tc.has(`${e}.${t}`))
    return Tc.get(`${e}.${t}`);
  const r = e.substring(2).toLowerCase(), n = NV(Z_(r)), i = r.split("");
  for (let s = 0; s < 40; s += 2)
    n[s >> 1] >> 4 >= 8 && i[s] && (i[s] = i[s].toUpperCase()), (n[s >> 1] & 15) >= 8 && i[s + 1] && (i[s + 1] = i[s + 1].toUpperCase());
  const o = `0x${i.join("")}`;
  return Tc.set(`${e}.${t}`, o), o;
}
const $V = /^0x[a-fA-F0-9]{40}$/, Rc = /* @__PURE__ */ new nw(8192);
function Ze(e, t) {
  const { strict: r = !0 } = {}, n = `${e}.${r}`;
  if (Rc.has(n))
    return Rc.get(n);
  const i = $V.test(e) ? e.toLowerCase() === e ? !0 : r ? FV(e) === e : !0 : !1;
  return Rc.set(n, i), i;
}
function LV(e, t) {
  let r = e.toString();
  const n = r.startsWith("-");
  n && (r = r.slice(1)), r = r.padStart(t, "0");
  let [i, o] = [
    r.slice(0, r.length - t),
    r.slice(r.length - t)
  ];
  return o = o.replace(/(0+)$/, ""), `${n ? "-" : ""}${i || "0"}${o ? `.${o}` : ""}`;
}
function VV(e) {
  return {
    formatters: void 0,
    fees: void 0,
    serializers: void 0,
    ...e
  };
}
class zV extends mn {
  constructor({ value: t }) {
    super(`Number \`${t}\` is not a valid decimal number.`, {
      name: "InvalidDecimalNumberError"
    });
  }
}
function DV(e, t) {
  if (!/^(-?)([0-9]*)\.?([0-9]*)$/.test(e))
    throw new zV({ value: e });
  let [r, n = "0"] = e.split(".");
  const i = r.startsWith("-");
  if (i && (r = r.slice(1)), n = n.replace(/(0+)$/, ""), t === 0)
    Math.round(+`.${n}`) === 1 && (r = `${BigInt(r) + /* @__PURE__ */ BigInt(1)}`), n = "";
  else if (n.length > t) {
    const [o, s, a] = [
      n.slice(0, t - 1),
      n.slice(t - 1, t),
      n.slice(t)
    ], l = Math.round(+`${s}.${a}`);
    l > 9 ? n = `${BigInt(o) + BigInt(1)}0`.padStart(o.length + 1, "0") : n = `${o}${l}`, n.length > t && (n = n.slice(1), r = `${BigInt(r) + /* @__PURE__ */ BigInt(1)}`), n = n.slice(0, t);
  } else
    n = n.padEnd(t, "0");
  return BigInt(`${i ? "-" : ""}${r}${n}`);
}
const MV = "0x0000000000000000000000000000000000000000", BV = /* @__PURE__ */ VV({
  id: 1,
  name: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://eth.merkle.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://etherscan.io",
      apiUrl: "https://api.etherscan.io/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
      blockCreated: 19258213
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), tr = lR({
  placement: "bottom-end",
  pauseOnPageIdle: !0
}), WV = ({
  portalRef: e,
  placement: t
}) => (Ce(() => {
  t && (tr.attrs.placement = t);
}, [t]), /* @__PURE__ */ b(gl, { container: e, children: /* @__PURE__ */ b(r$, { toaster: tr, insetInline: { mdDown: "4" }, children: (r) => {
  var n;
  return /* @__PURE__ */ K(n$, { width: { md: "md" }, height: "fit-content", children: [
    r.type === "loading" ? /* @__PURE__ */ b(Oa, { size: "sm", color: "blue.solid" }) : /* @__PURE__ */ b(c$, {}),
    /* @__PURE__ */ K(ls, { gap: "1", flex: "1", maxWidth: "100%", children: [
      r.title && /* @__PURE__ */ b(o$, { children: r.title }),
      r.description && /* @__PURE__ */ b(s$, { children: r.description })
    ] }),
    r.action && /* @__PURE__ */ b(a$, { children: r.action.label }),
    ((n = r.meta) == null ? void 0 : n.closable) && /* @__PURE__ */ b(i$, {})
  ] });
} }) }));
function iw(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: HV } = Object.prototype, { getPrototypeOf: yf } = Object, { iterator: Ol, toStringTag: ow } = Symbol, Pl = /* @__PURE__ */ ((e) => (t) => {
  const r = HV.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ar = (e) => (e = e.toLowerCase(), (t) => Pl(t) === e), Tl = (e) => (t) => typeof t === e, { isArray: ji } = Array, Ko = Tl("undefined");
function jV(e) {
  return e !== null && !Ko(e) && e.constructor !== null && !Ko(e.constructor) && Ot(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const sw = ar("ArrayBuffer");
function UV(e) {
  let t;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && sw(e.buffer), t;
}
const GV = Tl("string"), Ot = Tl("function"), aw = Tl("number"), Rl = (e) => e !== null && typeof e == "object", qV = (e) => e === !0 || e === !1, sa = (e) => {
  if (Pl(e) !== "object")
    return !1;
  const t = yf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(ow in e) && !(Ol in e);
}, KV = ar("Date"), YV = ar("File"), XV = ar("Blob"), JV = ar("FileList"), ZV = (e) => Rl(e) && Ot(e.pipe), QV = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Ot(e.append) && ((t = Pl(e)) === "formdata" || // detect form-data instance
  t === "object" && Ot(e.toString) && e.toString() === "[object FormData]"));
}, ez = ar("URLSearchParams"), [tz, rz, nz, iz] = ["ReadableStream", "Request", "Response", "Headers"].map(ar), oz = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ds(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e == "undefined")
    return;
  let n, i;
  if (typeof e != "object" && (e = [e]), ji(e))
    for (n = 0, i = e.length; n < i; n++)
      t.call(null, e[n], n, e);
  else {
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let a;
    for (n = 0; n < s; n++)
      a = o[n], t.call(null, e[a], a, e);
  }
}
function lw(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, i;
  for (; n-- > 0; )
    if (i = r[n], t === i.toLowerCase())
      return i;
  return null;
}
const Fn = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : global, cw = (e) => !Ko(e) && e !== Fn;
function qu() {
  const { caseless: e } = cw(this) && this || {}, t = {}, r = (n, i) => {
    const o = e && lw(t, i) || i;
    sa(t[o]) && sa(n) ? t[o] = qu(t[o], n) : sa(n) ? t[o] = qu({}, n) : ji(n) ? t[o] = n.slice() : t[o] = n;
  };
  for (let n = 0, i = arguments.length; n < i; n++)
    arguments[n] && ds(arguments[n], r);
  return t;
}
const sz = (e, t, r, { allOwnKeys: n } = {}) => (ds(t, (i, o) => {
  r && Ot(i) ? e[o] = iw(i, r) : e[o] = i;
}, { allOwnKeys: n }), e), az = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), lz = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, cz = (e, t, r, n) => {
  let i, o, s;
  const a = {};
  if (t = t || {}, e == null) return t;
  do {
    for (i = Object.getOwnPropertyNames(e), o = i.length; o-- > 0; )
      s = i[o], (!n || n(s, e, t)) && !a[s] && (t[s] = e[s], a[s] = !0);
    e = r !== !1 && yf(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, uz = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, dz = (e) => {
  if (!e) return null;
  if (ji(e)) return e;
  let t = e.length;
  if (!aw(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, fz = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array != "undefined" && yf(Uint8Array)), hz = (e, t) => {
  const n = (e && e[Ol]).call(e);
  let i;
  for (; (i = n.next()) && !i.done; ) {
    const o = i.value;
    t.call(e, o[0], o[1]);
  }
}, pz = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, gz = ar("HTMLFormElement"), mz = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, i) {
    return n.toUpperCase() + i;
  }
), Qg = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), vz = ar("RegExp"), uw = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  ds(r, (i, o) => {
    let s;
    (s = t(i, o, e)) !== !1 && (n[o] = s || i);
  }), Object.defineProperties(e, n);
}, bz = (e) => {
  uw(e, (t, r) => {
    if (Ot(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (Ot(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, yz = (e, t) => {
  const r = {}, n = (i) => {
    i.forEach((o) => {
      r[o] = !0;
    });
  };
  return ji(e) ? n(e) : n(String(e).split(t)), r;
}, xz = () => {
}, _z = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function wz(e) {
  return !!(e && Ot(e.append) && e[ow] === "FormData" && e[Ol]);
}
const Sz = (e) => {
  const t = new Array(10), r = (n, i) => {
    if (Rl(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[i] = n;
        const o = ji(n) ? [] : {};
        return ds(n, (s, a) => {
          const l = r(s, i + 1);
          !Ko(l) && (o[a] = l);
        }), t[i] = void 0, o;
      }
    }
    return n;
  };
  return r(e, 0);
}, Ez = ar("AsyncFunction"), Cz = (e) => e && (Rl(e) || Ot(e)) && Ot(e.then) && Ot(e.catch), dw = ((e, t) => e ? setImmediate : t ? ((r, n) => (Fn.addEventListener("message", ({ source: i, data: o }) => {
  i === Fn && o === r && n.length && n.shift()();
}, !1), (i) => {
  n.push(i), Fn.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  Ot(Fn.postMessage)
), kz = typeof queueMicrotask != "undefined" ? queueMicrotask.bind(Fn) : typeof process != "undefined" && process.nextTick || dw, Iz = (e) => e != null && Ot(e[Ol]), $ = {
  isArray: ji,
  isArrayBuffer: sw,
  isBuffer: jV,
  isFormData: QV,
  isArrayBufferView: UV,
  isString: GV,
  isNumber: aw,
  isBoolean: qV,
  isObject: Rl,
  isPlainObject: sa,
  isReadableStream: tz,
  isRequest: rz,
  isResponse: nz,
  isHeaders: iz,
  isUndefined: Ko,
  isDate: KV,
  isFile: YV,
  isBlob: XV,
  isRegExp: vz,
  isFunction: Ot,
  isStream: ZV,
  isURLSearchParams: ez,
  isTypedArray: fz,
  isFileList: JV,
  forEach: ds,
  merge: qu,
  extend: sz,
  trim: oz,
  stripBOM: az,
  inherits: lz,
  toFlatObject: cz,
  kindOf: Pl,
  kindOfTest: ar,
  endsWith: uz,
  toArray: dz,
  forEachEntry: hz,
  matchAll: pz,
  isHTMLForm: gz,
  hasOwnProperty: Qg,
  hasOwnProp: Qg,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: uw,
  freezeMethods: bz,
  toObjectSet: yz,
  toCamelCase: mz,
  noop: xz,
  toFiniteNumber: _z,
  findKey: lw,
  global: Fn,
  isContextDefined: cw,
  isSpecCompliantForm: wz,
  toJSONObject: Sz,
  isAsyncFn: Ez,
  isThenable: Cz,
  setImmediate: dw,
  asap: kz,
  isIterable: Iz
};
function fe(e, t, r, n, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), i && (this.response = i, this.status = i.status ? i.status : null);
}
$.inherits(fe, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: $.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const fw = fe.prototype, hw = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  hw[e] = { value: e };
});
Object.defineProperties(fe, hw);
Object.defineProperty(fw, "isAxiosError", { value: !0 });
fe.from = (e, t, r, n, i, o) => {
  const s = Object.create(fw);
  return $.toFlatObject(e, s, function(l) {
    return l !== Error.prototype;
  }, (a) => a !== "isAxiosError"), fe.call(s, e.message, t, r, n, i), s.cause = e, s.name = e.name, o && Object.assign(s, o), s;
};
const Oz = null;
function Ku(e) {
  return $.isPlainObject(e) || $.isArray(e);
}
function pw(e) {
  return $.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function em(e, t, r) {
  return e ? e.concat(t).map(function(i, o) {
    return i = pw(i), !r && o ? "[" + i + "]" : i;
  }).join(r ? "." : "") : t;
}
function Pz(e) {
  return $.isArray(e) && !e.some(Ku);
}
const Tz = $.toFlatObject($, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Al(e, t, r) {
  if (!$.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = $.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, m) {
    return !$.isUndefined(m[h]);
  });
  const n = r.metaTokens, i = r.visitor || u, o = r.dots, s = r.indexes, l = (r.Blob || typeof Blob != "undefined" && Blob) && $.isSpecCompliantForm(t);
  if (!$.isFunction(i))
    throw new TypeError("visitor must be a function");
  function c(g) {
    if (g === null) return "";
    if ($.isDate(g))
      return g.toISOString();
    if (!l && $.isBlob(g))
      throw new fe("Blob is not supported. Use a Buffer instead.");
    return $.isArrayBuffer(g) || $.isTypedArray(g) ? l && typeof Blob == "function" ? new Blob([g]) : Buffer.from(g) : g;
  }
  function u(g, h, m) {
    let v = g;
    if (g && !m && typeof g == "object") {
      if ($.endsWith(h, "{}"))
        h = n ? h : h.slice(0, -2), g = JSON.stringify(g);
      else if ($.isArray(g) && Pz(g) || ($.isFileList(g) || $.endsWith(h, "[]")) && (v = $.toArray(g)))
        return h = pw(h), v.forEach(function(x, S) {
          !($.isUndefined(x) || x === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? em([h], S, o) : s === null ? h : h + "[]",
            c(x)
          );
        }), !1;
    }
    return Ku(g) ? !0 : (t.append(em(m, h, o), c(g)), !1);
  }
  const f = [], d = Object.assign(Tz, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: Ku
  });
  function p(g, h) {
    if (!$.isUndefined(g)) {
      if (f.indexOf(g) !== -1)
        throw Error("Circular reference detected in " + h.join("."));
      f.push(g), $.forEach(g, function(v, y) {
        (!($.isUndefined(v) || v === null) && i.call(
          t,
          v,
          $.isString(y) ? y.trim() : y,
          h,
          d
        )) === !0 && p(v, h ? h.concat(y) : [y]);
      }), f.pop();
    }
  }
  if (!$.isObject(e))
    throw new TypeError("data must be an object");
  return p(e), t;
}
function tm(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function xf(e, t) {
  this._pairs = [], e && Al(e, this, t);
}
const gw = xf.prototype;
gw.append = function(t, r) {
  this._pairs.push([t, r]);
};
gw.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, tm);
  } : tm;
  return this._pairs.map(function(i) {
    return r(i[0]) + "=" + r(i[1]);
  }, "").join("&");
};
function Rz(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function mw(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || Rz;
  $.isFunction(r) && (r = {
    serialize: r
  });
  const i = r && r.serialize;
  let o;
  if (i ? o = i(t, r) : o = $.isURLSearchParams(t) ? t.toString() : new xf(t, r).toString(n), o) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class rm {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    $.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const vw = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Az = typeof URLSearchParams != "undefined" ? URLSearchParams : xf, Nz = typeof FormData != "undefined" ? FormData : null, Fz = typeof Blob != "undefined" ? Blob : null, $z = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Az,
    FormData: Nz,
    Blob: Fz
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, _f = typeof window != "undefined" && typeof document != "undefined", Yu = typeof navigator == "object" && navigator || void 0, Lz = _f && (!Yu || ["ReactNative", "NativeScript", "NS"].indexOf(Yu.product) < 0), Vz = typeof WorkerGlobalScope != "undefined" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", zz = _f && window.location.href || "http://localhost", Dz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: _f,
  hasStandardBrowserEnv: Lz,
  hasStandardBrowserWebWorkerEnv: Vz,
  navigator: Yu,
  origin: zz
}, Symbol.toStringTag, { value: "Module" })), gt = {
  ...Dz,
  ...$z
};
function Mz(e, t) {
  return Al(e, new gt.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, i, o) {
      return gt.isNode && $.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Bz(e) {
  return $.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Wz(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const i = r.length;
  let o;
  for (n = 0; n < i; n++)
    o = r[n], t[o] = e[o];
  return t;
}
function bw(e) {
  function t(r, n, i, o) {
    let s = r[o++];
    if (s === "__proto__") return !0;
    const a = Number.isFinite(+s), l = o >= r.length;
    return s = !s && $.isArray(i) ? i.length : s, l ? ($.hasOwnProp(i, s) ? i[s] = [i[s], n] : i[s] = n, !a) : ((!i[s] || !$.isObject(i[s])) && (i[s] = []), t(r, n, i[s], o) && $.isArray(i[s]) && (i[s] = Wz(i[s])), !a);
  }
  if ($.isFormData(e) && $.isFunction(e.entries)) {
    const r = {};
    return $.forEachEntry(e, (n, i) => {
      t(Bz(n), i, r, 0);
    }), r;
  }
  return null;
}
function Hz(e, t, r) {
  if ($.isString(e))
    try {
      return (t || JSON.parse)(e), $.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const fs = {
  transitional: vw,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", i = n.indexOf("application/json") > -1, o = $.isObject(t);
    if (o && $.isHTMLForm(t) && (t = new FormData(t)), $.isFormData(t))
      return i ? JSON.stringify(bw(t)) : t;
    if ($.isArrayBuffer(t) || $.isBuffer(t) || $.isStream(t) || $.isFile(t) || $.isBlob(t) || $.isReadableStream(t))
      return t;
    if ($.isArrayBufferView(t))
      return t.buffer;
    if ($.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (o) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Mz(t, this.formSerializer).toString();
      if ((a = $.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Al(
          a ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return o || i ? (r.setContentType("application/json", !1), Hz(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || fs.transitional, n = r && r.forcedJSONParsing, i = this.responseType === "json";
    if ($.isResponse(t) || $.isReadableStream(t))
      return t;
    if (t && $.isString(t) && (n && !this.responseType || i)) {
      const s = !(r && r.silentJSONParsing) && i;
      try {
        return JSON.parse(t);
      } catch (a) {
        if (s)
          throw a.name === "SyntaxError" ? fe.from(a, fe.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: gt.classes.FormData,
    Blob: gt.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
$.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  fs.headers[e] = {};
});
const jz = $.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Uz = (e) => {
  const t = {};
  let r, n, i;
  return e && e.split(`
`).forEach(function(s) {
    i = s.indexOf(":"), r = s.substring(0, i).trim().toLowerCase(), n = s.substring(i + 1).trim(), !(!r || t[r] && jz[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, nm = Symbol("internals");
function fo(e) {
  return e && String(e).trim().toLowerCase();
}
function aa(e) {
  return e === !1 || e == null ? e : $.isArray(e) ? e.map(aa) : String(e);
}
function Gz(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const qz = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Ac(e, t, r, n, i) {
  if ($.isFunction(n))
    return n.call(this, t, r);
  if (i && (t = r), !!$.isString(t)) {
    if ($.isString(n))
      return t.indexOf(n) !== -1;
    if ($.isRegExp(n))
      return n.test(t);
  }
}
function Kz(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function Yz(e, t) {
  const r = $.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(i, o, s) {
        return this[n].call(this, t, i, o, s);
      },
      configurable: !0
    });
  });
}
let Pt = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const i = this;
    function o(a, l, c) {
      const u = fo(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = $.findKey(i, u);
      (!f || i[f] === void 0 || c === !0 || c === void 0 && i[f] !== !1) && (i[f || l] = aa(a));
    }
    const s = (a, l) => $.forEach(a, (c, u) => o(c, u, l));
    if ($.isPlainObject(t) || t instanceof this.constructor)
      s(t, r);
    else if ($.isString(t) && (t = t.trim()) && !qz(t))
      s(Uz(t), r);
    else if ($.isObject(t) && $.isIterable(t)) {
      let a = {}, l, c;
      for (const u of t) {
        if (!$.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        a[c = u[0]] = (l = a[c]) ? $.isArray(l) ? [...l, u[1]] : [l, u[1]] : u[1];
      }
      s(a, r);
    } else
      t != null && o(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = fo(t), t) {
      const n = $.findKey(this, t);
      if (n) {
        const i = this[n];
        if (!r)
          return i;
        if (r === !0)
          return Gz(i);
        if ($.isFunction(r))
          return r.call(this, i, n);
        if ($.isRegExp(r))
          return r.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = fo(t), t) {
      const n = $.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || Ac(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let i = !1;
    function o(s) {
      if (s = fo(s), s) {
        const a = $.findKey(n, s);
        a && (!r || Ac(n, n[a], a, r)) && (delete n[a], i = !0);
      }
    }
    return $.isArray(t) ? t.forEach(o) : o(t), i;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, i = !1;
    for (; n--; ) {
      const o = r[n];
      (!t || Ac(this, this[o], o, t, !0)) && (delete this[o], i = !0);
    }
    return i;
  }
  normalize(t) {
    const r = this, n = {};
    return $.forEach(this, (i, o) => {
      const s = $.findKey(n, o);
      if (s) {
        r[s] = aa(i), delete r[o];
        return;
      }
      const a = t ? Kz(o) : String(o).trim();
      a !== o && delete r[o], r[a] = aa(i), n[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return $.forEach(this, (n, i) => {
      n != null && n !== !1 && (r[i] = t && $.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((i) => n.set(i)), n;
  }
  static accessor(t) {
    const n = (this[nm] = this[nm] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function o(s) {
      const a = fo(s);
      n[a] || (Yz(i, s), n[a] = !0);
    }
    return $.isArray(t) ? t.forEach(o) : o(t), this;
  }
};
Pt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
$.reduceDescriptors(Pt.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
$.freezeMethods(Pt);
function Nc(e, t) {
  const r = this || fs, n = t || r, i = Pt.from(n.headers);
  let o = n.data;
  return $.forEach(e, function(a) {
    o = a.call(r, o, i.normalize(), t ? t.status : void 0);
  }), i.normalize(), o;
}
function yw(e) {
  return !!(e && e.__CANCEL__);
}
function Ui(e, t, r) {
  fe.call(this, e == null ? "canceled" : e, fe.ERR_CANCELED, t, r), this.name = "CanceledError";
}
$.inherits(Ui, fe, {
  __CANCEL__: !0
});
function xw(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new fe(
    "Request failed with status code " + r.status,
    [fe.ERR_BAD_REQUEST, fe.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function Xz(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Jz(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let i = 0, o = 0, s;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), u = n[o];
    s || (s = c), r[i] = l, n[i] = c;
    let f = o, d = 0;
    for (; f !== i; )
      d += r[f++], f = f % e;
    if (i = (i + 1) % e, i === o && (o = (o + 1) % e), c - s < t)
      return;
    const p = u && c - u;
    return p ? Math.round(d * 1e3 / p) : void 0;
  };
}
function Zz(e, t) {
  let r = 0, n = 1e3 / t, i, o;
  const s = (c, u = Date.now()) => {
    r = u, i = null, o && (clearTimeout(o), o = null), e.apply(null, c);
  };
  return [(...c) => {
    const u = Date.now(), f = u - r;
    f >= n ? s(c, u) : (i = c, o || (o = setTimeout(() => {
      o = null, s(i);
    }, n - f)));
  }, () => i && s(i)];
}
const ja = (e, t, r = 3) => {
  let n = 0;
  const i = Jz(50, 250);
  return Zz((o) => {
    const s = o.loaded, a = o.lengthComputable ? o.total : void 0, l = s - n, c = i(l), u = s <= a;
    n = s;
    const f = {
      loaded: s,
      total: a,
      progress: a ? s / a : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && a && u ? (a - s) / c : void 0,
      event: o,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, im = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, om = (e) => (...t) => $.asap(() => e(...t)), Qz = gt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, gt.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(gt.origin),
  gt.navigator && /(msie|trident)/i.test(gt.navigator.userAgent)
) : () => !0, eD = gt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, i, o) {
      const s = [e + "=" + encodeURIComponent(t)];
      $.isNumber(r) && s.push("expires=" + new Date(r).toGMTString()), $.isString(n) && s.push("path=" + n), $.isString(i) && s.push("domain=" + i), o === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function tD(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function rD(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function _w(e, t, r) {
  let n = !tD(t);
  return e && (n || r == !1) ? rD(e, t) : t;
}
const sm = (e) => e instanceof Pt ? { ...e } : e;
function Wn(e, t) {
  t = t || {};
  const r = {};
  function n(c, u, f, d) {
    return $.isPlainObject(c) && $.isPlainObject(u) ? $.merge.call({ caseless: d }, c, u) : $.isPlainObject(u) ? $.merge({}, u) : $.isArray(u) ? u.slice() : u;
  }
  function i(c, u, f, d) {
    if ($.isUndefined(u)) {
      if (!$.isUndefined(c))
        return n(void 0, c, f, d);
    } else return n(c, u, f, d);
  }
  function o(c, u) {
    if (!$.isUndefined(u))
      return n(void 0, u);
  }
  function s(c, u) {
    if ($.isUndefined(u)) {
      if (!$.isUndefined(c))
        return n(void 0, c);
    } else return n(void 0, u);
  }
  function a(c, u, f) {
    if (f in t)
      return n(c, u);
    if (f in e)
      return n(void 0, c);
  }
  const l = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: a,
    headers: (c, u, f) => i(sm(c), sm(u), f, !0)
  };
  return $.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const f = l[u] || i, d = f(e[u], t[u], u);
    $.isUndefined(d) && f !== a || (r[u] = d);
  }), r;
}
const ww = (e) => {
  const t = Wn({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: i, xsrfCookieName: o, headers: s, auth: a } = t;
  t.headers = s = Pt.from(s), t.url = mw(_w(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), a && s.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let l;
  if ($.isFormData(r)) {
    if (gt.hasStandardBrowserEnv || gt.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if ((l = s.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((f) => f.trim()).filter(Boolean) : [];
      s.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (gt.hasStandardBrowserEnv && (n && $.isFunction(n) && (n = n(t)), n || n !== !1 && Qz(t.url))) {
    const c = i && o && eD.read(o);
    c && s.set(i, c);
  }
  return t;
}, nD = typeof XMLHttpRequest != "undefined", iD = nD && function(e) {
  return new Promise(function(r, n) {
    const i = ww(e);
    let o = i.data;
    const s = Pt.from(i.headers).normalize();
    let { responseType: a, onUploadProgress: l, onDownloadProgress: c } = i, u, f, d, p, g;
    function h() {
      p && p(), g && g(), i.cancelToken && i.cancelToken.unsubscribe(u), i.signal && i.signal.removeEventListener("abort", u);
    }
    let m = new XMLHttpRequest();
    m.open(i.method.toUpperCase(), i.url, !0), m.timeout = i.timeout;
    function v() {
      if (!m)
        return;
      const x = Pt.from(
        "getAllResponseHeaders" in m && m.getAllResponseHeaders()
      ), _ = {
        data: !a || a === "text" || a === "json" ? m.responseText : m.response,
        status: m.status,
        statusText: m.statusText,
        headers: x,
        config: e,
        request: m
      };
      xw(function(O) {
        r(O), h();
      }, function(O) {
        n(O), h();
      }, _), m = null;
    }
    "onloadend" in m ? m.onloadend = v : m.onreadystatechange = function() {
      !m || m.readyState !== 4 || m.status === 0 && !(m.responseURL && m.responseURL.indexOf("file:") === 0) || setTimeout(v);
    }, m.onabort = function() {
      m && (n(new fe("Request aborted", fe.ECONNABORTED, e, m)), m = null);
    }, m.onerror = function() {
      n(new fe("Network Error", fe.ERR_NETWORK, e, m)), m = null;
    }, m.ontimeout = function() {
      let S = i.timeout ? "timeout of " + i.timeout + "ms exceeded" : "timeout exceeded";
      const _ = i.transitional || vw;
      i.timeoutErrorMessage && (S = i.timeoutErrorMessage), n(new fe(
        S,
        _.clarifyTimeoutError ? fe.ETIMEDOUT : fe.ECONNABORTED,
        e,
        m
      )), m = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in m && $.forEach(s.toJSON(), function(S, _) {
      m.setRequestHeader(_, S);
    }), $.isUndefined(i.withCredentials) || (m.withCredentials = !!i.withCredentials), a && a !== "json" && (m.responseType = i.responseType), c && ([d, g] = ja(c, !0), m.addEventListener("progress", d)), l && m.upload && ([f, p] = ja(l), m.upload.addEventListener("progress", f), m.upload.addEventListener("loadend", p)), (i.cancelToken || i.signal) && (u = (x) => {
      m && (n(!x || x.type ? new Ui(null, e, m) : x), m.abort(), m = null);
    }, i.cancelToken && i.cancelToken.subscribe(u), i.signal && (i.signal.aborted ? u() : i.signal.addEventListener("abort", u)));
    const y = Xz(i.url);
    if (y && gt.protocols.indexOf(y) === -1) {
      n(new fe("Unsupported protocol " + y + ":", fe.ERR_BAD_REQUEST, e));
      return;
    }
    m.send(o || null);
  });
}, oD = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), i;
    const o = function(c) {
      if (!i) {
        i = !0, a();
        const u = c instanceof Error ? c : this.reason;
        n.abort(u instanceof fe ? u : new Ui(u instanceof Error ? u.message : u));
      }
    };
    let s = t && setTimeout(() => {
      s = null, o(new fe(`timeout ${t} of ms exceeded`, fe.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(o) : c.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", o));
    const { signal: l } = n;
    return l.unsubscribe = () => $.asap(a), l;
  }
}, sD = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, i;
  for (; n < r; )
    i = n + t, yield e.slice(n, i), n = i;
}, aD = async function* (e, t) {
  for await (const r of lD(e))
    yield* sD(r, t);
}, lD = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, am = (e, t, r, n) => {
  const i = aD(e, t);
  let o = 0, s, a = (l) => {
    s || (s = !0, n && n(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await i.next();
        if (c) {
          a(), l.close();
          return;
        }
        let f = u.byteLength;
        if (r) {
          let d = o += f;
          r(d);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw a(c), c;
      }
    },
    cancel(l) {
      return a(l), i.return();
    }
  }, {
    highWaterMark: 2
  });
}, Nl = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Sw = Nl && typeof ReadableStream == "function", cD = Nl && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Ew = (e, ...t) => {
  try {
    return !!e(...t);
  } catch (r) {
    return !1;
  }
}, uD = Sw && Ew(() => {
  let e = !1;
  const t = new Request(gt.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), lm = 64 * 1024, Xu = Sw && Ew(() => $.isReadableStream(new Response("").body)), Ua = {
  stream: Xu && ((e) => e.body)
};
Nl && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Ua[t] && (Ua[t] = $.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new fe(`Response type '${t}' is not supported`, fe.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const dD = async (e) => {
  if (e == null)
    return 0;
  if ($.isBlob(e))
    return e.size;
  if ($.isSpecCompliantForm(e))
    return (await new Request(gt.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if ($.isArrayBufferView(e) || $.isArrayBuffer(e))
    return e.byteLength;
  if ($.isURLSearchParams(e) && (e = e + ""), $.isString(e))
    return (await cD(e)).byteLength;
}, fD = async (e, t) => {
  const r = $.toFiniteNumber(e.getContentLength());
  return r == null ? dD(t) : r;
}, hD = Nl && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: i,
    cancelToken: o,
    timeout: s,
    onDownloadProgress: a,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: f = "same-origin",
    fetchOptions: d
  } = ww(e);
  c = c ? (c + "").toLowerCase() : "text";
  let p = oD([i, o && o.toAbortSignal()], s), g;
  const h = p && p.unsubscribe && (() => {
    p.unsubscribe();
  });
  let m;
  try {
    if (l && uD && r !== "get" && r !== "head" && (m = await fD(u, n)) !== 0) {
      let _ = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), I;
      if ($.isFormData(n) && (I = _.headers.get("content-type")) && u.setContentType(I), _.body) {
        const [O, w] = im(
          m,
          ja(om(l))
        );
        n = am(_.body, lm, O, w);
      }
    }
    $.isString(f) || (f = f ? "include" : "omit");
    const v = "credentials" in Request.prototype;
    g = new Request(t, {
      ...d,
      signal: p,
      method: r.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: v ? f : void 0
    });
    let y = await fetch(g);
    const x = Xu && (c === "stream" || c === "response");
    if (Xu && (a || x && h)) {
      const _ = {};
      ["status", "statusText", "headers"].forEach((E) => {
        _[E] = y[E];
      });
      const I = $.toFiniteNumber(y.headers.get("content-length")), [O, w] = a && im(
        I,
        ja(om(a), !0)
      ) || [];
      y = new Response(
        am(y.body, lm, O, () => {
          w && w(), h && h();
        }),
        _
      );
    }
    c = c || "text";
    let S = await Ua[$.findKey(Ua, c) || "text"](y, e);
    return !x && h && h(), await new Promise((_, I) => {
      xw(_, I, {
        data: S,
        headers: Pt.from(y.headers),
        status: y.status,
        statusText: y.statusText,
        config: e,
        request: g
      });
    });
  } catch (v) {
    throw h && h(), v && v.name === "TypeError" && /Load failed|fetch/i.test(v.message) ? Object.assign(
      new fe("Network Error", fe.ERR_NETWORK, e, g),
      {
        cause: v.cause || v
      }
    ) : fe.from(v, v && v.code, e, g);
  }
}), Ju = {
  http: Oz,
  xhr: iD,
  fetch: hD
};
$.forEach(Ju, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch (r) {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const cm = (e) => `- ${e}`, pD = (e) => $.isFunction(e) || e === null || e === !1, Cw = {
  getAdapter: (e) => {
    e = $.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const i = {};
    for (let o = 0; o < t; o++) {
      r = e[o];
      let s;
      if (n = r, !pD(r) && (n = Ju[(s = String(r)).toLowerCase()], n === void 0))
        throw new fe(`Unknown adapter '${s}'`);
      if (n)
        break;
      i[s || "#" + o] = n;
    }
    if (!n) {
      const o = Object.entries(i).map(
        ([a, l]) => `adapter ${a} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = t ? o.length > 1 ? `since :
` + o.map(cm).join(`
`) : " " + cm(o[0]) : "as no adapter specified";
      throw new fe(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: Ju
};
function Fc(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Ui(null, e);
}
function um(e) {
  return Fc(e), e.headers = Pt.from(e.headers), e.data = Nc.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Cw.getAdapter(e.adapter || fs.adapter)(e).then(function(n) {
    return Fc(e), n.data = Nc.call(
      e,
      e.transformResponse,
      n
    ), n.headers = Pt.from(n.headers), n;
  }, function(n) {
    return yw(n) || (Fc(e), n && n.response && (n.response.data = Nc.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = Pt.from(n.response.headers))), Promise.reject(n);
  });
}
const kw = "1.9.0", Fl = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Fl[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const dm = {};
Fl.transitional = function(t, r, n) {
  function i(o, s) {
    return "[Axios v" + kw + "] Transitional option '" + o + "'" + s + (n ? ". " + n : "");
  }
  return (o, s, a) => {
    if (t === !1)
      throw new fe(
        i(s, " has been removed" + (r ? " in " + r : "")),
        fe.ERR_DEPRECATED
      );
    return r && !dm[s] && (dm[s] = !0, console.warn(
      i(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(o, s, a) : !0;
  };
};
Fl.spelling = function(t) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
function gD(e, t, r) {
  if (typeof e != "object")
    throw new fe("options must be an object", fe.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let i = n.length;
  for (; i-- > 0; ) {
    const o = n[i], s = t[o];
    if (s) {
      const a = e[o], l = a === void 0 || s(a, o, e);
      if (l !== !0)
        throw new fe("option " + o + " must be " + l, fe.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new fe("Unknown option " + o, fe.ERR_BAD_OPTION);
  }
}
const la = {
  assertOptions: gD,
  validators: Fl
}, dr = la.validators;
let Ln = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new rm(),
      response: new rm()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let i = {};
        Error.captureStackTrace ? Error.captureStackTrace(i) : i = new Error();
        const o = i.stack ? i.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? o && !String(n.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + o) : n.stack = o;
        } catch (s) {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = Wn(this.defaults, r);
    const { transitional: n, paramsSerializer: i, headers: o } = r;
    n !== void 0 && la.assertOptions(n, {
      silentJSONParsing: dr.transitional(dr.boolean),
      forcedJSONParsing: dr.transitional(dr.boolean),
      clarifyTimeoutError: dr.transitional(dr.boolean)
    }, !1), i != null && ($.isFunction(i) ? r.paramsSerializer = {
      serialize: i
    } : la.assertOptions(i, {
      encode: dr.function,
      serialize: dr.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), la.assertOptions(r, {
      baseUrl: dr.spelling("baseURL"),
      withXsrfToken: dr.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && $.merge(
      o.common,
      o[r.method]
    );
    o && $.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (g) => {
        delete o[g];
      }
    ), r.headers = Pt.concat(s, o);
    const a = [];
    let l = !0;
    this.interceptors.request.forEach(function(h) {
      typeof h.runWhen == "function" && h.runWhen(r) === !1 || (l = l && h.synchronous, a.unshift(h.fulfilled, h.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(h) {
      c.push(h.fulfilled, h.rejected);
    });
    let u, f = 0, d;
    if (!l) {
      const g = [um.bind(this), void 0];
      for (g.unshift.apply(g, a), g.push.apply(g, c), d = g.length, u = Promise.resolve(r); f < d; )
        u = u.then(g[f++], g[f++]);
      return u;
    }
    d = a.length;
    let p = r;
    for (f = 0; f < d; ) {
      const g = a[f++], h = a[f++];
      try {
        p = g(p);
      } catch (m) {
        h.call(this, m);
        break;
      }
    }
    try {
      u = um.call(this, p);
    } catch (g) {
      return Promise.reject(g);
    }
    for (f = 0, d = c.length; f < d; )
      u = u.then(c[f++], c[f++]);
    return u;
  }
  getUri(t) {
    t = Wn(this.defaults, t);
    const r = _w(t.baseURL, t.url, t.allowAbsoluteUrls);
    return mw(r, t.params, t.paramsSerializer);
  }
};
$.forEach(["delete", "get", "head", "options"], function(t) {
  Ln.prototype[t] = function(r, n) {
    return this.request(Wn(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
$.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(o, s, a) {
      return this.request(Wn(a || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: s
      }));
    };
  }
  Ln.prototype[t] = r(), Ln.prototype[t + "Form"] = r(!0);
});
let mD = class Iw {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const n = this;
    this.promise.then((i) => {
      if (!n._listeners) return;
      let o = n._listeners.length;
      for (; o-- > 0; )
        n._listeners[o](i);
      n._listeners = null;
    }), this.promise.then = (i) => {
      let o;
      const s = new Promise((a) => {
        n.subscribe(a), o = a;
      }).then(i);
      return s.cancel = function() {
        n.unsubscribe(o);
      }, s;
    }, t(function(o, s, a) {
      n.reason || (n.reason = new Ui(o, s, a), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Iw(function(i) {
        t = i;
      }),
      cancel: t
    };
  }
};
function vD(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function bD(e) {
  return $.isObject(e) && e.isAxiosError === !0;
}
const Zu = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Zu).forEach(([e, t]) => {
  Zu[t] = e;
});
function Ow(e) {
  const t = new Ln(e), r = iw(Ln.prototype.request, t);
  return $.extend(r, Ln.prototype, t, { allOwnKeys: !0 }), $.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(i) {
    return Ow(Wn(e, i));
  }, r;
}
const He = Ow(fs);
He.Axios = Ln;
He.CanceledError = Ui;
He.CancelToken = mD;
He.isCancel = yw;
He.VERSION = kw;
He.toFormData = Al;
He.AxiosError = fe;
He.Cancel = He.CanceledError;
He.all = function(t) {
  return Promise.all(t);
};
He.spread = vD;
He.isAxiosError = bD;
He.mergeConfig = Wn;
He.AxiosHeaders = Pt;
He.formToJSON = (e) => bw($.isHTMLForm(e) ? new FormData(e) : e);
He.getAdapter = Cw.getAdapter;
He.HttpStatusCode = Zu;
He.default = He;
const {
  Axios: P3,
  AxiosError: T3,
  CanceledError: R3,
  isCancel: A3,
  CancelToken: N3,
  VERSION: F3,
  all: $3,
  Cancel: L3,
  isAxiosError: V3,
  spread: z3,
  toFormData: D3,
  AxiosHeaders: M3,
  HttpStatusCode: B3,
  formToJSON: W3,
  getAdapter: H3,
  mergeConfig: j3
} = He;
var yD = "https://api.enso.finance/api/v1", xD = class {
  constructor({
    baseURL: e = yD,
    apiKey: t
  }) {
    this.client = He.create({
      baseURL: e,
      headers: {
        Authorization: `Bearer ${t}`
      }
    });
  }
  async request(e) {
    try {
      return (await this.client.request(e)).data;
    } catch (t) {
      throw new Error(`API Request failed: ${t.message}`);
    }
  }
  // Method to get approval data to spend a token
  async getApprovalData(e) {
    const t = "/wallet/approve";
    return e.routingStrategy || (e.routingStrategy = "router"), this.request({
      url: t,
      method: "GET",
      params: e
    });
  }
  // Method to get execution data for best route from a token to another
  async getRouterData(e) {
    const t = "/shortcuts/route";
    return e.routingStrategy || (e.routingStrategy = "router"), this.request({
      method: "GET",
      url: t,
      params: e
    });
  }
  // Method to quote swap from a token to another even if the user doesn't have the token or approve
  async getQuoteData(e) {
    return this.request({
      method: "GET",
      url: "/shortcuts/quote",
      params: e
    });
  }
  // Method to get wallet balances per chain
  async getBalances(e) {
    const t = "/wallet/balances";
    return typeof e.useEoa == "undefined" && (e.useEoa = !0), this.request({
      method: "GET",
      url: t,
      params: e
    });
  }
  // Method to get token data by address
  async getTokenData(e) {
    const t = "/tokens";
    return e.page = 1, this.request({
      method: "GET",
      url: t,
      params: e
    });
  }
  // Method to get token price data
  async getPriceData(e) {
    const t = `/prices/${e.chainId}/${e.address}`;
    return this.request({
      method: "GET",
      url: t
    });
  }
  // Method to get protocol data
  async getProtocolData(e) {
    return this.request({
      method: "GET",
      url: "/protocols",
      params: e
    });
  }
  // Method to construct bundled transaction data
  async getBundleData(e, t) {
    const r = "/shortcuts/bundle";
    return e.routingStrategy || (e.routingStrategy = "router"), this.request({
      method: "POST",
      url: r,
      params: e,
      data: t
    });
  }
};
const _D = "Swap not found for a required underlying of defi route, please make sure your amount is within an acceptable range", wD = "0xd8da6bf26964af9d7eed9e03e53415d37aa96045", Be = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", fr = {
  address: Be,
  name: "Ethereum",
  symbol: "ETH",
  decimals: 18,
  logoURI: "https://assets.coingecko.com/coins/images/279/large/ethereum.png"
}, SD = {
  address: Be,
  name: "Binance Coin",
  symbol: "BNB",
  decimals: 18,
  logoURI: "https://assets.coingecko.com/coins/images/825/large/binance-coin-logo.png"
}, ED = {
  address: Be,
  name: "Avalanche",
  symbol: "AVAX",
  decimals: 18,
  logoURI: "https://assets.coingecko.com/coins/images/12559/large/coin-round-red.png"
}, CD = {
  address: Be,
  name: "Polygon",
  symbol: "MATIC",
  decimals: 18,
  logoURI: "https://assets.coingecko.com/coins/images/4713/large/matic___polygon.jpg"
}, kD = {
  address: Be,
  name: "BeraChain",
  symbol: "BERA",
  decimals: 18,
  logoURI: "https://assets.coingecko.com/coins/images/25235/large/BERA.png?1738822008"
}, ID = {
  address: Be,
  name: "Gnosis XDAI",
  symbol: "XDAI",
  decimals: 18,
  logoURI: "https://assets.coingecko.com/coins/images/11062/large/Identity-Primary-DarkBG.png"
}, OD = {
  address: Be,
  name: "Sonic",
  symbol: "S",
  decimals: 18,
  logoURI: "https://assets.coingecko.com/coins/images/38108/standard/200x200_Sonic_Logo.png"
}, PD = {
  address: Be,
  name: "Plume",
  symbol: "PLUME",
  decimals: 18,
  logoURI: "https://assets.coingecko.com/coins/images/53623/standard/plume-token.png?1736896935"
}, TD = {
  address: Be,
  name: "Hyperliquid",
  symbol: "HYPE",
  decimals: 18,
  logoURI: "https://assets.coingecko.com/asset_platforms/images/243/large/hyperliquid.png"
};
var Qt = /* @__PURE__ */ ((e) => (e[e.MAINNET = 1] = "MAINNET", e[e.ARBITRUM_ONE = 42161] = "ARBITRUM_ONE", e[e.OPTIMISM = 10] = "OPTIMISM", e[e.POLYGON = 137] = "POLYGON", e[e.BSC = 56] = "BSC", e[e.BASE = 8453] = "BASE", e[e.LINEA = 59144] = "LINEA", e[e.ZKSYNC = 324] = "ZKSYNC", e[e.GNOSIS = 100] = "GNOSIS", e[e.AVALANCHE = 43114] = "AVALANCHE", e[e.BERACHAIN = 80094] = "BERACHAIN", e[e.SONIC = 146] = "SONIC", e[e.UNICHAIN = 130] = "UNICHAIN", e[e.INK = 57073] = "INK", e[e.SONEIUM = 1868] = "SONEIUM", e[e.PLUME = 98866] = "PLUME", e[e.HYPERLIQUID = 999] = "HYPERLIQUID", e[e.KATANA = 747474] = "KATANA", e))(Qt || {});
const Pw = {
  1: "ethereum",
  42161: "arbitrum-one",
  10: "optimistic-ethereum",
  137: "polygon-pos",
  // [SupportedChainId.BOBA]: "boba",
  8453: "base",
  56: "binance-smart-chain",
  // [SupportedChainId.BLAST]: "blast",
  // [SupportedChainId.SCROLL]: "scroll",
  59144: "linea",
  324: "zksync",
  100: "xdai",
  43114: "avalanche",
  80094: "berachain",
  146: "sonic",
  130: "unichain",
  57073: "ink",
  1868: "soneium",
  98866: "plume",
  999: "hyperevm",
  747474: "katana"
}, Tw = {
  1: "ethereum",
  8453: "base",
  137: "polygon",
  56: "bsc",
  59144: "linea",
  324: "zksync",
  100: "gnosis",
  43114: "avalanche",
  80094: "bera",
  146: "sonic",
  42161: "arbitrum",
  10: "optimism",
  130: "unichain",
  57073: "ink",
  1868: "soneium",
  98866: "plumephoenix",
  999: "hyperliquid",
  747474: "katana"
}, RD = "https://assets.coingecko.com/coins/images/12504/small/uniswap-uni.png", AD = {
  10: "https://optimistic.etherscan.io",
  1: "https://etherscan.io",
  42161: "https://arbiscan.io",
  137: "https://polygonscan.com",
  56: "https://bscscan.com",
  // [SupportedChainId.BOBA]: "https://bobascan.com",
  8453: "https://basescan.org",
  // [SupportedChainId.BLAST]: "https://blastscan.io",
  // [SupportedChainId.SCROLL]: "https://scrollscan.com",
  59144: "https://lineascan.build",
  324: "https://explorer.zksync.io/",
  100: "https://gnosisscan.io/",
  43114: "https://cchain.explorer.avax.network",
  80094: "https://berascan.com",
  146: "https://sonicscan.io",
  130: "https://uniscan.xyz",
  57073: "https://explorer.inkonchain.com",
  1868: "https://soneium.blockscout.com/",
  98866: "https://explorer.plume.org/",
  999: "https://www.hyperscan.com/",
  747474: "https://explorer-katana.t.conduit.xyz/"
}, Rw = {
  1: fr,
  42161: fr,
  10: fr,
  8453: fr,
  59144: fr,
  324: fr,
  1868: fr,
  130: fr,
  57073: fr,
  56: SD,
  43114: ED,
  137: CD,
  80094: kD,
  100: ID,
  146: OD,
  98866: PD,
  999: TD,
  747474: fr
}, fm = {
  "0x09def5abc67e967d54e8233a4b5ebbc1b3fbe34b": 1e5
  // WABTC limit
}, ND = [
  "0x09def5abc67e967d54e8233a4b5ebbc1b3fbe34b"
  // WABTC
], hm = {
  "0x42a094364bbdca0efac8af2cf7d6b9ec885ee554": "https://app.uniswap.org/positions/create/v2?currencyA=0x09DEF5aBc67e967d54E8233A4b5EBBc1B3fbE34b&currencyB=0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599&chain=ethereum"
  // WABTC
}, pm = [
  "0xcf21354360fdae8edad02c0529e55cb3e71c36c9",
  "0x99d8a9c45b2eca8864373a26d1459e3dff1e17f3"
], FD = 200, $D = 25, LD = [
  "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
  // WETH
  "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
  // USDC
  "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
  // WBTC
  "0xdac17f958d2ee523a2206206994597c13d831ec7",
  // USDT
  "0x97ad75064b20fb2b2447fed4fa953bf7f007a706",
  // beraSTONE
  "0x6982508145454ce325ddbe47a25d4ec3d2311933",
  // PEPE
  "0x6b175474e89094c44da98b954eedeac495271d0f",
  // DAI
  "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
  // UNI
  "0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf",
  // cbBTC
  "0x514910771af9ca656af840dff83e8264ecf986ca",
  // LINK
  "0x8236a87084f8b84306f72007f36f2618a5634494",
  // LBTC
  "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0",
  // wstETH
  "0xae78736cd615f374d3085123a210448e74fc6393",
  // rETH
  "0x4c9edd5852cd905f086c759e8383e09bff1e68b3",
  // USDe
  Be
], gm = (e) => {
  let t;
  const r = /* @__PURE__ */ new Set(), n = (c, u) => {
    const f = typeof c == "function" ? c(t) : c;
    if (!Object.is(f, t)) {
      const d = t;
      t = (u != null ? u : typeof f != "object" || f === null) ? f : Object.assign({}, t, f), r.forEach((p) => p(t, d));
    }
  }, i = () => t, a = { setState: n, getState: i, getInitialState: () => l, subscribe: (c) => (r.add(c), () => r.delete(c)) }, l = t = e(n, i, a);
  return a;
}, VD = (e) => e ? gm(e) : gm, zD = (e) => e;
function DD(e, t = zD) {
  const r = xr.useSyncExternalStore(
    e.subscribe,
    () => t(e.getState()),
    () => t(e.getInitialState())
  );
  return xr.useDebugValue(r), r;
}
const mm = (e) => {
  const t = VD(e), r = (n) => DD(t, n);
  return Object.assign(r, t), r;
}, Aw = (e) => e ? mm(e) : mm, rr = Aw((e) => ({
  // used if parent app has chain id context
  obligatedChainId: void 0,
  setObligatedChainId: (t) => e({ obligatedChainId: t }),
  tokenOutChainId: void 0,
  setTokenOutChainId: (t) => e({ tokenOutChainId: t }),
  tokenOutAddress: void 0,
  setTokenOutAddress: (t) => e({ tokenOutAddress: t }),
  // notification
  notification: void 0,
  setNotification: (t) => e({ notification: t })
})), Ds = (e) => fetch(`https://tokens.coingecko.com/${Pw[e]}/all.json`).then((t) => t.json()).then((t) => t == null ? void 0 : t.tokens).then((t) => [Rw[e], ...t]), MD = () => fetch(
  "https://mainnet.internal.oogabooga.io/token-list/tokens?chainId=80094&client=SWAP"
).then((e) => e.json()).then(
  (e) => e.map((t) => ({
    ...t,
    logoURI: t.tokenURI,
    address: t.address === MV ? Be : t.address.toLowerCase()
  }))
), BD = () => fetch("https://api.rooster-protocol.xyz/api/tokens").then((e) => e.json()).then(({ tokens: e }) => e), WD = () => fetch(
  "https://raw.githubusercontent.com/katana-network/tokenlist/refs/heads/main/tokenlist.json"
).then((e) => e.json()).then(({ tokens: e }) => e), HD = (e) => fetch("https://tokens.1inch.io/v1.2/" + e).then((t) => t.json()).then((t) => Object.values(t)), jD = (e) => ({
  [Rw[e].symbol]: 5,
  USDC: 4,
  DAI: 4,
  USDT: 4,
  WBTC: 4,
  WETH: 3,
  LINK: 3,
  UNI: 3,
  SUSHI: 3,
  AAVE: 3,
  USDCE: 2
}), UD = (
  // TODO: remove after it comes in list for sonic
  new Promise(
    (e) => e([
      {
        address: "0x6047828dc181963ba44974801ff68e538da5eaf9",
        name: "Tether USD",
        symbol: "USDT",
        decimals: 6,
        logoURI: "https://assets.coingecko.com/coins/images/325/large/Tether.png"
      }
    ])
  )
), GD = (
  // Additional tokens for Plume network
  new Promise(
    (e) => e([
      {
        address: Be,
        // Native token address
        name: "Plume",
        symbol: "PLUME",
        decimals: 18,
        logoURI: "https://assets.coingecko.com/coins/images/53623/standard/plume-token.png?1736896935"
      },
      {
        address: "0x78adD880A697070c1e765Ac44D65323a0DcCE913",
        name: "USD Coin.e",
        symbol: "USDC.e",
        decimals: 6,
        logoURI: "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png"
      },
      {
        address: "0xEa237441c92CAe6FC17Caaf9a7acB3f953be4bd1",
        name: "Wrapped Plume",
        symbol: "wPlume",
        decimals: 18,
        logoURI: "https://assets.coingecko.com/coins/images/53623/standard/plume-token.png?1736896935"
      },
      {
        address: "0xca59cA09E5602fAe8B629DeE83FfA819741f14be",
        name: "Wrapped Ether",
        symbol: "WETH",
        decimals: 18,
        logoURI: "https://assets.coingecko.com/coins/images/2518/large/weth.png"
      }
    ])
  )
), qD = (e) => {
  let t = [];
  switch (e) {
    case Qt.BERACHAIN:
      t = [MD()];
      break;
    case Qt.SONIC:
      t = [Ds(e), UD];
      break;
    case Qt.PLUME:
      t = [GD, BD()];
      break;
    case Qt.KATANA:
      t = [Ds(e), WD()];
      break;
    case Qt.INK:
    case Qt.UNICHAIN:
    case Qt.SONEIUM:
    case Qt.HYPERLIQUID:
    case Qt.KATANA:
      t = [Ds(e)];
      break;
    default:
      t = [HD(e), Ds(e)];
  }
  return Promise.allSettled(t).then((r) => {
    var a, l, c;
    const n = r.filter(
      (u) => u.status === "fulfilled"
    ).map((u) => u.value), i = n[0];
    if (n.length > 1) {
      const u = new Set(
        (l = (a = n[0]) == null ? void 0 : a.map((d) => d.address)) != null ? l : []
      ), f = n[0];
      for (let d = 1; d < n.length; d++) {
        const p = (c = n[d]) == null ? void 0 : c.filter(
          (g) => !u.has(g.address)
        );
        p && (f.push(...p), p.forEach((g) => u.add(g.address)));
      }
    }
    const o = jD(e);
    return [...i].sort((u, f) => {
      var d, p;
      return (p = (d = o[f.symbol]) != null ? d : 0 - o[u.symbol]) != null ? p : 0;
    }).map((u) => ({
      ...u,
      address: u.address.toLowerCase()
    }));
  });
}, Nw = (e) => {
  const t = jt(e);
  return vn({
    queryKey: ["tokenList", t],
    queryFn: () => qD(t),
    enabled: !!t
  });
}, wf = (e, t) => {
  const { data: r } = Nw(t);
  return (Array.isArray(e) ? e : [e]).map(
    (i) => r == null ? void 0 : r.find((o) => o.address == i)
  );
}, KD = () => {
  const e = rr((r) => r.tokenOutChainId), t = jt();
  return e != null ? e : t;
}, jt = (e) => {
  var n;
  const t = rr((i) => i.obligatedChainId), { chainId: r = 1 } = Kr();
  return (n = e != null ? e : t) != null ? n : r;
}, YD = ({
  hash: e,
  chainId: t,
  type: r = "/tx"
}) => {
  const n = AD[t];
  if (e) return `${n}${r}/${e}`;
}, XD = (e) => e.charAt(0).toUpperCase() + e.slice(1), JD = (e) => {
  const t = Pw[e];
  return XD(t).split("-")[0];
}, Sf = [
  {
    constant: !0,
    inputs: [],
    name: "name",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "_spender",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "_from",
        type: "address"
      },
      {
        name: "_to",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "decimals",
    outputs: [
      {
        name: "",
        type: "uint8"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        name: "_owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        name: "balance",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "symbol",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "_to",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        name: "_owner",
        type: "address"
      },
      {
        name: "_spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    payable: !0,
    stateMutability: "payable",
    type: "fallback"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        name: "spender",
        type: "address"
      },
      {
        indexed: !1,
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  }
], ZD = (e, t = 0) => DV(e, t).toString(), Wr = (e = "0", t = 0) => {
  try {
    return LV(BigInt(e), t);
  } catch (r) {
    return console.error(r), "0";
  }
}, Ga = (e, t) => !!(e && t && (e == null ? void 0 : e.toLowerCase()) === (t == null ? void 0 : t.toLowerCase())), QD = Intl.NumberFormat("en", {
  maximumFractionDigits: 4
}), eM = Intl.NumberFormat("en", {
  maximumFractionDigits: 6
}), tM = Intl.NumberFormat("en", {
  style: "currency",
  currency: "USD"
}), Gi = (e, t) => {
  const r = t ? eM : QD;
  return isNaN(+e) ? "0.0" : r.format(+e);
}, Ef = (e) => tM.format(+e), rM = (e) => {
  const t = typeof e == "string" ? parseFloat(e) : e;
  return isNaN(t) ? "0" : Intl.NumberFormat("en", {
    notation: "compact",
    maximumFractionDigits: 2
  }).format(t);
}, $l = Aw((e) => ({
  txs: [],
  addTx: (t) => e((r) => ({ txs: [...r.txs, t] })),
  removeTx: (t) => e((r) => ({ txs: r.txs.filter((n) => n.hash !== t) }))
})), nM = () => {
  const { txs: e } = $l();
  return /* @__PURE__ */ b(wi, { children: e.map((t) => /* @__PURE__ */ b(lM, { ...t }, t.hash)) });
}, Fw = () => {
  const { addTx: e } = $l();
  return { track: lt((r) => {
    r.hash && e(r);
  }, []) };
}, iM = (e, t) => {
  const [r, n] = We(), { data: i } = vn({
    queryKey: ["layerZeroUrl", e || "none", !!t],
    queryFn: async () => e ? fetch(`https://scan.layerzero-api.com/v1/messages/tx/${e}`).then((o) => o.json()).then((o) => o.data[0]) : null,
    refetchInterval: 2e3,
    enabled: !!(t && e)
  });
  Ce(() => {
    var s, a, l, c;
    if (!e) return;
    const o = {
      label: "View on Explorer",
      onClick: () => window.open(`https://layerzeroscan.com/tx/${e}`, "_blank")
    };
    r ? (s = i == null ? void 0 : i.source) != null && s.status && i.source.status !== "SUCCEEDED" ? tr.update(r, {
      title: "Pending (1/4)",
      description: "Waiting for funds to be sent on destination"
    }) : ((a = i == null ? void 0 : i.status) == null ? void 0 : a.name) === "DELIVERED" ? (t == null || t(), tr.update(r, {
      title: "Success (4/4) ",
      description: "Bridging is complete",
      type: "success",
      action: o
    }), n(void 0)) : ((l = i == null ? void 0 : i.status) == null ? void 0 : l.name) === "CONFIRMING" ? tr.update(r, {
      title: "Pending (3/4)",
      description: "Waiting for destination execution"
    }) : ((c = i == null ? void 0 : i.status) == null ? void 0 : c.name) === "INFLIGHT" && tr.update(r, {
      title: "Pending (2/4)",
      description: "Waiting for funds to be delivered on destination"
    }) : (n(e), tr.create({
      id: e,
      title: "Pending (0/4)",
      description: "Waiting for source transaction completion",
      type: "loading",
      action: o
    }));
  }, [i, e]);
}, oM = (e, t, r, n, i) => {
  const [o, s] = We(), a = YD({ hash: e, chainId: t });
  Ce(() => {
    i && (n.error ? tr.update(e, {
      title: "Error",
      description: n.error.message,
      type: "error",
      action: a ? {
        label: "View on Explorer",
        onClick: () => window.open(a, "_blank")
      } : void 0
    }) : n.data ? (s(void 0), i == null || i(), tr.update(o, {
      title: "Success",
      description: r,
      type: "success",
      action: a ? {
        label: "View on Explorer",
        onClick: () => window.open(a, "_blank")
      } : void 0
    })) : n.isLoading && (o || (tr.create({
      id: e,
      title: "Transaction Pending",
      description: r,
      type: "loading",
      action: a ? {
        label: "View on Explorer",
        onClick: () => window.open(a, "_blank")
      } : void 0
    }), s(e))));
  }, [
    n.data,
    n.error,
    n.isLoading,
    r,
    a,
    i
  ]);
}, sM = ({
  hash: e,
  chainId: t,
  message: r = "Transaction confirmed",
  onConfirmed: n
}) => {
  const { removeTx: i } = $l(), o = Hv({
    hash: e,
    chainId: t
  });
  return Ce(() => {
    o.data && (n == null || n(o.data));
  }, [o.data, n]), oM(
    e,
    t,
    r,
    o,
    () => i(e)
  ), null;
}, aM = ({
  hash: e,
  chainId: t,
  onConfirmed: r
}) => {
  const { removeTx: n } = $l(), i = Hv({
    hash: e,
    chainId: t
  }), o = () => n(e);
  return Ce(() => {
    i.data && (r == null || r(i.data));
  }, [i.data, r]), iM(i.data ? e : void 0, o), null;
}, lM = (e) => e.crosschain ? /* @__PURE__ */ b(aM, { ...e }) : /* @__PURE__ */ b(sM, { ...e }), cM = (e, t) => {
  const r = lt(e, []);
  Ce(() => {
    const n = setInterval(r, t);
    return () => clearInterval(n);
  }, [t, r]);
}, $w = () => {
  const [e, t] = We(0);
  return cM(() => {
    t(e + 1);
  }, 1e4), e;
}, uM = (e, t) => {
  const { address: r } = Kr(), n = jt(t);
  return jv({
    chainId: n,
    address: e,
    abi: Sf,
    functionName: "balanceOf",
    args: [r],
    query: {
      enabled: Ze(r) && Ze(e) && !Ga(e, Be)
    }
  });
}, Lw = (e, t) => {
  var f;
  const { address: r } = Kr(), n = jt(t), i = $w(), o = Gv(), { data: s, queryKey: a } = uM(
    e,
    t
  ), { data: l, queryKey: c } = nS({
    address: r,
    chainId: n,
    query: {
      enabled: Ga(e, Be)
    }
  });
  Ce(() => {
    o.invalidateQueries({ queryKey: a }), o.invalidateQueries({ queryKey: c });
  }, [i, o, a, c]);
  const u = Ga(e, Be) ? l == null ? void 0 : l.value : s;
  return (f = u == null ? void 0 : u.toString()) != null ? f : "0";
}, dM = (e, t) => {
  var l;
  const { address: r } = Kr(), n = jt(), i = $w(), o = Gv(), { data: s, queryKey: a } = jv({
    chainId: n,
    address: e,
    abi: Sf,
    functionName: "allowance",
    args: [r, t],
    query: {
      enabled: Ze(r) && Ze(e) && !Ga(e, Be)
    }
  });
  return Ce(() => {
    o.invalidateQueries({ queryKey: a });
  }, [i, o, a]), (l = s == null ? void 0 : s.toString()) != null ? l : "0";
}, fM = (e, t, r) => {
  const [n] = wf(e), i = jt();
  return {
    title: `Approve ${Gi(Wr(r, n == null ? void 0 : n.decimals))} of ${n == null ? void 0 : n.symbol} for spending`,
    args: {
      chainId: i,
      address: e,
      abi: Sf,
      functionName: "approve",
      args: [t, r]
    }
  };
}, hM = ({
  args: e,
  onSuccess: t
}) => {
  const r = iS(), n = lt(() => {
    r.sendTransaction(e, {
      onError: (i) => {
        var o;
        tr.create({
          title: "Error",
          // @ts-ignore
          description: ((o = i == null ? void 0 : i.cause) == null ? void 0 : o.shortMessage) || i.message,
          type: "error"
        }), console.error(i);
      },
      onSuccess: t
    });
  }, [r, e, t]);
  return {
    ...r,
    sendTransaction: n
  };
}, pM = (e, t, r) => {
  const n = dM(e, t), i = fM(e, t, r), { track: o } = Fw(), s = jt(), a = lt(
    (u) => {
      o({
        hash: u,
        chainId: s,
        crosschain: !1,
        message: i.title,
        onConfirmed: () => {
        }
      });
    },
    [i.title]
  ), l = rS(), c = lt(() => {
    l.writeContract(i.args, {
      onSuccess: a
    });
  }, [l, i.args, a]);
  if (e !== Be)
    return +n < +r ? { ...l, write: c } : void 0;
};
let Kn = null;
const gM = (e) => {
  Kn = new xD({
    // baseURL: "http://localhost:3000/api/v1",
    // baseURL: "https://shortcuts-backend-dynamic-int.herokuapp.com/api/v1",
    // baseURL: "https://shortcuts-backend-dynamic-dev.herokuapp.com/api/v1",
    baseURL: "https://api.enso.finance/api/v1",
    apiKey: e
  });
}, mM = (e, t) => {
  const { address: r } = Kr(), n = jt();
  return vn({
    queryKey: ["enso-approval", e, n, r, t],
    queryFn: () => Kn.getApprovalData({
      fromAddress: r,
      tokenAddress: e,
      chainId: n,
      amount: t
    }),
    enabled: +t > 0 && Ze(r) && Ze(e)
  });
}, vM = (e, t = !0) => vn({
  queryKey: [
    "enso-router",
    e.chainId,
    e.destinationChainId,
    e.fromAddress,
    e.tokenIn,
    e.tokenOut,
    e.amountIn
  ],
  queryFn: () => Kn.getRouterData(e),
  refetchInterval: 30 * 1e3,
  enabled: t && +e.amountIn > 0 && Ze(e.fromAddress) && Ze(e.tokenIn) && Ze(e.tokenOut) && (e.tokenIn !== e.tokenOut || e.destinationChainId && e.chainId !== e.destinationChainId),
  retry: 2
}), bM = (e, t, r, n, i, o) => {
  var y;
  const { address: s = wD } = Kr(), a = jt(), l = KD(), c = {
    referralCode: i,
    amountIn: e,
    tokenIn: t,
    tokenOut: r,
    slippage: n,
    fromAddress: s,
    receiver: s,
    spender: s,
    routingStrategy: "router",
    chainId: a
  };
  (pm.includes(t) || pm.includes(r)) && (c.ignoreAggregators = "0x,paraswap,openocean,odos,kyberswap,native,barter");
  let u = l !== a;
  u && (c.destinationChainId = l);
  const {
    tokens: [f]
  } = ir({
    address: c.tokenOut,
    enabled: Ze(c.tokenOut)
  }), {
    tokens: [d]
  } = ir({
    address: c.tokenIn,
    enabled: Ze(c.tokenIn)
  }), p = `Purchase ${Gi(
    Wr(c.amountIn, d == null ? void 0 : d.decimals)
  )} ${d == null ? void 0 : d.symbol} of ${f == null ? void 0 : f.symbol}`, g = vM(c, !0), { track: h } = Fw(), m = lt(
    (x) => {
      h({
        hash: x,
        chainId: a,
        crosschain: u,
        message: p,
        onConfirmed: () => {
        }
      });
      const S = {
        amountIn: e,
        tokenIn: d,
        tokenOut: f,
        slippage: n,
        routerData: g.data
      };
      o == null || o(x, S);
    },
    [
      p,
      a,
      g.data,
      f == null ? void 0 : f.address,
      d == null ? void 0 : d.address
    ]
  ), v = hM({
    args: (y = g.data) == null ? void 0 : y.tx,
    onSuccess: m
  });
  return {
    ...g,
    sendTransaction: v
  };
}, Ms = "projectId", yM = (e) => {
  const { address: t } = Kr(), r = jt(e);
  return vn({
    queryKey: ["enso-balances", r, t],
    queryFn: () => Kn.getBalances({ useEoa: !0, chainId: r, eoaAddress: t }),
    enabled: Ze(t)
  });
}, xM = ({
  address: e,
  priorityChainId: t,
  project: r,
  protocolSlug: n,
  enabled: i = !0
}) => {
  const o = jt(t);
  return vn({
    queryKey: ["enso-token-details", e, o, n, r],
    queryFn: () => Kn.getTokenData({
      project: r,
      protocolSlug: n,
      address: e,
      chainId: o,
      includeMetadata: !0
    }),
    enabled: i
  });
}, ir = ({
  address: e,
  priorityChainId: t,
  project: r,
  protocolSlug: n,
  enabled: i
}) => {
  const { data: o, isLoading: s } = xM({
    address: e,
    priorityChainId: t,
    project: r,
    protocolSlug: n,
    enabled: i
  }), a = wf(e, t);
  return { tokens: _e(() => {
    var c, u;
    return !((c = o == null ? void 0 : o.data) != null && c.length) || !((u = o == null ? void 0 : o.data[0]) != null && u.decimals) || !i ? [] : o.data.map((f) => {
      var d, p, g;
      return {
        ...f,
        address: f == null ? void 0 : f.address.toLowerCase(),
        logoURI: (p = (d = a == null ? void 0 : a.find((h) => (h == null ? void 0 : h.address) == (f == null ? void 0 : f.address))) == null ? void 0 : d.logoURI) != null ? p : f == null ? void 0 : f.logosUri[0],
        underlyingTokens: (g = f == null ? void 0 : f.underlyingTokens) == null ? void 0 : g.map((h) => ({
          ...h,
          address: h == null ? void 0 : h.address.toLowerCase(),
          logoURI: h == null ? void 0 : h.logosUri[0]
        }))
      };
    });
  }, [o, a]), isLoading: s };
}, Qu = (e, t) => {
  const r = jt(t);
  return vn({
    queryKey: ["enso-token-price", e, r],
    queryFn: () => Kn.getPriceData({ address: e, chainId: r }),
    staleTime: 1e3 * 30,
    refetchInterval: 1e3 * 30,
    enabled: r && Ze(e)
  });
}, _M = () => vn({
  queryKey: ["enso-protocols"],
  queryFn: () => Kn.getProtocolData()
}), wM = (e) => {
  const { data: t } = _M();
  return t == null ? void 0 : t.filter(
    (r) => r.chains.some((n) => n.id === e) && // @ts-ignore
    r[Ms] !== "permit2" && // @ts-ignore
    r[Ms] !== "erc4626" && // @ts-ignore
    r[Ms] !== "wrapped-native"
  ).reduce((r, n) => (r.set(n[Ms], n), r), /* @__PURE__ */ new Map()).values().toArray();
};
function SM(e, t) {
  const [r, n] = ie.useState(e);
  return ie.useEffect(() => {
    const i = setTimeout(() => {
      n(e);
    }, t);
    return () => {
      clearTimeout(i);
    };
  }, [e, t]), r;
}
function vm(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ed(e, t) {
  return ed = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, ed(e, t);
}
function EM(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, ed(e, t);
}
var bm = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function CM(e, t) {
  return !!(e === t || bm(e) && bm(t));
}
function kM(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!CM(e[r], t[r]))
      return !1;
  return !0;
}
function $c(e, t) {
  t === void 0 && (t = kM);
  var r, n = [], i, o = !1;
  function s() {
    for (var a = [], l = 0; l < arguments.length; l++)
      a[l] = arguments[l];
    return o && r === this && t(a, n) || (i = e.apply(this, a), o = !0, r = this, n = a), i;
  }
  return s;
}
var IM = typeof performance == "object" && typeof performance.now == "function", ym = IM ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function xm(e) {
  cancelAnimationFrame(e.id);
}
function OM(e, t) {
  var r = ym();
  function n() {
    ym() - r >= t ? e.call(null) : i.id = requestAnimationFrame(n);
  }
  var i = {
    id: requestAnimationFrame(n)
  };
  return i;
}
var Lc = -1;
function _m(e) {
  if (e === void 0 && (e = !1), Lc === -1 || e) {
    var t = document.createElement("div"), r = t.style;
    r.width = "50px", r.height = "50px", r.overflow = "scroll", document.body.appendChild(t), Lc = t.offsetWidth - t.clientWidth, document.body.removeChild(t);
  }
  return Lc;
}
var si = null;
function wm(e) {
  if (e === void 0 && (e = !1), si === null || e) {
    var t = document.createElement("div"), r = t.style;
    r.width = "50px", r.height = "50px", r.overflow = "scroll", r.direction = "rtl";
    var n = document.createElement("div"), i = n.style;
    return i.width = "100px", i.height = "100px", t.appendChild(n), document.body.appendChild(t), t.scrollLeft > 0 ? si = "positive-descending" : (t.scrollLeft = 1, t.scrollLeft === 0 ? si = "negative" : si = "positive-ascending"), document.body.removeChild(t), si;
  }
  return si;
}
process.env.NODE_ENV;
var PM = 150, TM = function(t, r) {
  return t;
}, ca = null, ua = null;
process.env.NODE_ENV !== "production" && typeof window != "undefined" && typeof window.WeakSet != "undefined" && (ca = /* @__PURE__ */ new WeakSet(), ua = /* @__PURE__ */ new WeakSet());
function RM(e) {
  var t, r = e.getItemOffset, n = e.getEstimatedTotalSize, i = e.getItemSize, o = e.getOffsetForIndexAndAlignment, s = e.getStartIndexForOffset, a = e.getStopIndexForStartIndex, l = e.initInstanceProps, c = e.shouldResetStyleCacheOnItemSizeChange, u = e.validateProps;
  return t = /* @__PURE__ */ function(f) {
    EM(d, f);
    function d(g) {
      var h;
      return h = f.call(this, g) || this, h._instanceProps = l(h.props, vm(h)), h._outerRef = void 0, h._resetIsScrollingTimeoutId = null, h.state = {
        instance: vm(h),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof h.props.initialScrollOffset == "number" ? h.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, h._callOnItemsRendered = void 0, h._callOnItemsRendered = $c(function(m, v, y, x) {
        return h.props.onItemsRendered({
          overscanStartIndex: m,
          overscanStopIndex: v,
          visibleStartIndex: y,
          visibleStopIndex: x
        });
      }), h._callOnScroll = void 0, h._callOnScroll = $c(function(m, v, y) {
        return h.props.onScroll({
          scrollDirection: m,
          scrollOffset: v,
          scrollUpdateWasRequested: y
        });
      }), h._getItemStyle = void 0, h._getItemStyle = function(m) {
        var v = h.props, y = v.direction, x = v.itemSize, S = v.layout, _ = h._getItemStyleCache(c && x, c && S, c && y), I;
        if (_.hasOwnProperty(m))
          I = _[m];
        else {
          var O = r(h.props, m, h._instanceProps), w = i(h.props, m, h._instanceProps), E = y === "horizontal" || S === "horizontal", T = y === "rtl", G = E ? O : 0;
          _[m] = I = {
            position: "absolute",
            left: T ? void 0 : G,
            right: T ? G : void 0,
            top: E ? 0 : O,
            height: E ? "100%" : w,
            width: E ? w : "100%"
          };
        }
        return I;
      }, h._getItemStyleCache = void 0, h._getItemStyleCache = $c(function(m, v, y) {
        return {};
      }), h._onScrollHorizontal = function(m) {
        var v = m.currentTarget, y = v.clientWidth, x = v.scrollLeft, S = v.scrollWidth;
        h.setState(function(_) {
          if (_.scrollOffset === x)
            return null;
          var I = h.props.direction, O = x;
          if (I === "rtl")
            switch (wm()) {
              case "negative":
                O = -x;
                break;
              case "positive-descending":
                O = S - y - x;
                break;
            }
          return O = Math.max(0, Math.min(O, S - y)), {
            isScrolling: !0,
            scrollDirection: _.scrollOffset < O ? "forward" : "backward",
            scrollOffset: O,
            scrollUpdateWasRequested: !1
          };
        }, h._resetIsScrollingDebounced);
      }, h._onScrollVertical = function(m) {
        var v = m.currentTarget, y = v.clientHeight, x = v.scrollHeight, S = v.scrollTop;
        h.setState(function(_) {
          if (_.scrollOffset === S)
            return null;
          var I = Math.max(0, Math.min(S, x - y));
          return {
            isScrolling: !0,
            scrollDirection: _.scrollOffset < I ? "forward" : "backward",
            scrollOffset: I,
            scrollUpdateWasRequested: !1
          };
        }, h._resetIsScrollingDebounced);
      }, h._outerRefSetter = function(m) {
        var v = h.props.outerRef;
        h._outerRef = m, typeof v == "function" ? v(m) : v != null && typeof v == "object" && v.hasOwnProperty("current") && (v.current = m);
      }, h._resetIsScrollingDebounced = function() {
        h._resetIsScrollingTimeoutId !== null && xm(h._resetIsScrollingTimeoutId), h._resetIsScrollingTimeoutId = OM(h._resetIsScrolling, PM);
      }, h._resetIsScrolling = function() {
        h._resetIsScrollingTimeoutId = null, h.setState({
          isScrolling: !1
        }, function() {
          h._getItemStyleCache(-1, null);
        });
      }, h;
    }
    d.getDerivedStateFromProps = function(h, m) {
      return AM(h, m), u(h), null;
    };
    var p = d.prototype;
    return p.scrollTo = function(h) {
      h = Math.max(0, h), this.setState(function(m) {
        return m.scrollOffset === h ? null : {
          scrollDirection: m.scrollOffset < h ? "forward" : "backward",
          scrollOffset: h,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, p.scrollToItem = function(h, m) {
      m === void 0 && (m = "auto");
      var v = this.props, y = v.itemCount, x = v.layout, S = this.state.scrollOffset;
      h = Math.max(0, Math.min(h, y - 1));
      var _ = 0;
      if (this._outerRef) {
        var I = this._outerRef;
        x === "vertical" ? _ = I.scrollWidth > I.clientWidth ? _m() : 0 : _ = I.scrollHeight > I.clientHeight ? _m() : 0;
      }
      this.scrollTo(o(this.props, h, m, S, this._instanceProps, _));
    }, p.componentDidMount = function() {
      var h = this.props, m = h.direction, v = h.initialScrollOffset, y = h.layout;
      if (typeof v == "number" && this._outerRef != null) {
        var x = this._outerRef;
        m === "horizontal" || y === "horizontal" ? x.scrollLeft = v : x.scrollTop = v;
      }
      this._callPropsCallbacks();
    }, p.componentDidUpdate = function() {
      var h = this.props, m = h.direction, v = h.layout, y = this.state, x = y.scrollOffset, S = y.scrollUpdateWasRequested;
      if (S && this._outerRef != null) {
        var _ = this._outerRef;
        if (m === "horizontal" || v === "horizontal")
          if (m === "rtl")
            switch (wm()) {
              case "negative":
                _.scrollLeft = -x;
                break;
              case "positive-ascending":
                _.scrollLeft = x;
                break;
              default:
                var I = _.clientWidth, O = _.scrollWidth;
                _.scrollLeft = O - I - x;
                break;
            }
          else
            _.scrollLeft = x;
        else
          _.scrollTop = x;
      }
      this._callPropsCallbacks();
    }, p.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && xm(this._resetIsScrollingTimeoutId);
    }, p.render = function() {
      var h = this.props, m = h.children, v = h.className, y = h.direction, x = h.height, S = h.innerRef, _ = h.innerElementType, I = h.innerTagName, O = h.itemCount, w = h.itemData, E = h.itemKey, T = E === void 0 ? TM : E, G = h.layout, k = h.outerElementType, j = h.outerTagName, F = h.style, L = h.useIsScrolling, D = h.width, N = this.state.isScrolling, B = y === "horizontal" || G === "horizontal", q = B ? this._onScrollHorizontal : this._onScrollVertical, P = this._getRangeToRender(), C = P[0], W = P[1], H = [];
      if (O > 0)
        for (var V = C; V <= W; V++)
          H.push($n(m, {
            data: w,
            key: T(V, w),
            index: V,
            isScrolling: L ? N : void 0,
            style: this._getItemStyle(V)
          }));
      var Q = n(this.props, this._instanceProps);
      return $n(k || j || "div", {
        className: v,
        onScroll: q,
        ref: this._outerRefSetter,
        style: Vo({
          position: "relative",
          height: x,
          width: D,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: y
        }, F)
      }, $n(_ || I || "div", {
        children: H,
        ref: S,
        style: {
          height: B ? "100%" : Q,
          pointerEvents: N ? "none" : void 0,
          width: B ? Q : "100%"
        }
      }));
    }, p._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var h = this.props.itemCount;
        if (h > 0) {
          var m = this._getRangeToRender(), v = m[0], y = m[1], x = m[2], S = m[3];
          this._callOnItemsRendered(v, y, x, S);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var _ = this.state, I = _.scrollDirection, O = _.scrollOffset, w = _.scrollUpdateWasRequested;
        this._callOnScroll(I, O, w);
      }
    }, p._getRangeToRender = function() {
      var h = this.props, m = h.itemCount, v = h.overscanCount, y = this.state, x = y.isScrolling, S = y.scrollDirection, _ = y.scrollOffset;
      if (m === 0)
        return [0, 0, 0, 0];
      var I = s(this.props, _, this._instanceProps), O = a(this.props, I, _, this._instanceProps), w = !x || S === "backward" ? Math.max(1, v) : 1, E = !x || S === "forward" ? Math.max(1, v) : 1;
      return [Math.max(0, I - w), Math.max(0, Math.min(m - 1, O + E)), I, O];
    }, d;
  }(tS), t.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, t;
}
var AM = function(t, r) {
  var n = t.children, i = t.direction, o = t.height, s = t.layout, a = t.innerTagName, l = t.outerTagName, c = t.width, u = r.instance;
  if (process.env.NODE_ENV !== "production") {
    (a != null || l != null) && ua && !ua.has(u) && (ua.add(u), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead."));
    var f = i === "horizontal" || s === "horizontal";
    switch (i) {
      case "horizontal":
      case "vertical":
        ca && !ca.has(u) && (ca.add(u), console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.'));
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + i + '" was specified.'));
    }
    switch (s) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + s + '" was specified.'));
    }
    if (n == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (n === null ? "null" : typeof n) + '" was specified.'));
    if (f && typeof c != "number")
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (c === null ? "null" : typeof c) + '" was specified.'));
    if (!f && typeof o != "number")
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (o === null ? "null" : typeof o) + '" was specified.'));
  }
}, NM = /* @__PURE__ */ RM({
  getItemOffset: function(t, r) {
    var n = t.itemSize;
    return r * n;
  },
  getItemSize: function(t, r) {
    var n = t.itemSize;
    return n;
  },
  getEstimatedTotalSize: function(t) {
    var r = t.itemCount, n = t.itemSize;
    return n * r;
  },
  getOffsetForIndexAndAlignment: function(t, r, n, i, o, s) {
    var a = t.direction, l = t.height, c = t.itemCount, u = t.itemSize, f = t.layout, d = t.width, p = a === "horizontal" || f === "horizontal", g = p ? d : l, h = Math.max(0, c * u - g), m = Math.min(h, r * u), v = Math.max(0, r * u - g + u + s);
    switch (n === "smart" && (i >= v - g && i <= m + g ? n = "auto" : n = "center"), n) {
      case "start":
        return m;
      case "end":
        return v;
      case "center": {
        var y = Math.round(v + (m - v) / 2);
        return y < Math.ceil(g / 2) ? 0 : y > h + Math.floor(g / 2) ? h : y;
      }
      case "auto":
      default:
        return i >= v && i <= m ? i : i < v ? v : m;
    }
  },
  getStartIndexForOffset: function(t, r) {
    var n = t.itemCount, i = t.itemSize;
    return Math.max(0, Math.min(n - 1, Math.floor(r / i)));
  },
  getStopIndexForStartIndex: function(t, r, n) {
    var i = t.direction, o = t.height, s = t.itemCount, a = t.itemSize, l = t.layout, c = t.width, u = i === "horizontal" || l === "horizontal", f = r * a, d = u ? c : o, p = Math.ceil((d + n - f) / a);
    return Math.max(0, Math.min(
      s - 1,
      r + p - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function(t) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function(t) {
    var r = t.itemSize;
    if (process.env.NODE_ENV !== "production" && typeof r != "number")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a number. ' + ('"' + (r === null ? "null" : typeof r) + '" was specified.'));
  }
});
const Cf = ie.forwardRef(function(t, r) {
  return /* @__PURE__ */ b(
    jF,
    {
      ...t,
      cursor: "pointer",
      _hover: {
        background: "bg.subtle",
        borderColor: "border.emphasized"
      },
      opacity: "1 !important",
      ref: r,
      children: t.children
    }
  );
}), Vw = ie.forwardRef(function(t, r) {
  const { portalled: n = !0, portalRef: i, ...o } = t;
  return /* @__PURE__ */ b(gl, { disabled: !n, container: i, children: /* @__PURE__ */ b(Px, { ...o, ref: r }) });
}), kf = ie.forwardRef(function(t, r) {
  const { item: n, children: i, ...o } = t;
  return /* @__PURE__ */ K(
    YF,
    {
      item: n,
      ...o,
      ref: r,
      borderRadius: "lg",
      children: [
        i,
        /* @__PURE__ */ b(XF, {})
      ]
    },
    n.value
  );
}), If = ie.forwardRef(function(t, r) {
  const { children: n, ...i } = t;
  return /* @__PURE__ */ b(
    UF,
    {
      ...i,
      ref: r,
      maxWidth: "100%",
      minH: "40px",
      display: "flex",
      alignItems: "center",
      children: /* @__PURE__ */ b(JF, { children: (o) => {
        const s = o.selectedItems;
        return s.length === 0 ? t.placeholder : n ? n(s) : s.length === 1 ? o.collection.stringifyItem(s[0]) : `${s.length} selected`;
      } })
    }
  );
}), Of = ie.forwardRef(function(t, r) {
  return /* @__PURE__ */ b(
    HF,
    {
      ...t,
      ref: r,
      positioning: { sameWidth: !0, ...t.positioning },
      children: t.asChild ? t.children : /* @__PURE__ */ K(wi, { children: [
        /* @__PURE__ */ b(ZF, {}),
        t.children
      ] })
    }
  );
});
ie.forwardRef(function(t, r) {
  const { children: n, label: i, ...o } = t;
  return /* @__PURE__ */ K(qF, { ...o, ref: r, children: [
    /* @__PURE__ */ b(KF, { children: i }),
    n
  ] });
});
const FM = "coingecko", $M = (e) => e.includes(FM) ? e.replace("/thumb/", "/large/") : e, da = ({
  token: e,
  chainId: t
}) => /* @__PURE__ */ K(Pe, { position: "relative", borderRadius: "50%", minW: "28px", minH: "28px", children: [
  /* @__PURE__ */ b(
    Pe,
    {
      borderRadius: "50%",
      overflow: "hidden",
      width: "28px",
      height: "28px",
      children: /* @__PURE__ */ b(
        "img",
        {
          src: e != null && e.logoURI ? $M(e == null ? void 0 : e.logoURI) : RD,
          title: e == null ? void 0 : e.symbol,
          alt: e == null ? void 0 : e.symbol,
          width: "28px",
          height: "28px"
        }
      )
    }
  ),
  t && /* @__PURE__ */ b(
    Pe,
    {
      position: "absolute",
      bottom: "0",
      right: "-2px",
      width: "14px",
      height: "14px",
      borderRadius: "50%",
      overflow: "hidden",
      border: "1px solid white",
      zIndex: "1",
      children: /* @__PURE__ */ b(
        "img",
        {
          src: `https://icons-ckg.pages.dev/stargate-light/networks/${Tw[t]}.svg`,
          alt: `Chain ${t}`,
          width: "100%",
          height: "100%"
        }
      )
    }
  )
] }), zw = ({
  token: e,
  chainId: t,
  ...r
}) => {
  var n;
  return /* @__PURE__ */ K(ge, { align: "center", gap: 2, ...r, justifyContent: "space-between", children: [
    (e == null ? void 0 : e.symbol) === "UNI-V2" && e.underlyingTokens ? /* @__PURE__ */ K(Pe, { position: "relative", width: "28px", height: "28px", children: [
      /* @__PURE__ */ b(
        Pe,
        {
          position: "absolute",
          width: "100%",
          height: "100%",
          overflow: "hidden",
          clipPath: "polygon(0 0, 46% 0, 46% 100%, 0% 100%)",
          children: /* @__PURE__ */ b(da, { token: e.underlyingTokens[0], chainId: t })
        }
      ),
      /* @__PURE__ */ b(
        Pe,
        {
          position: "absolute",
          width: "100%",
          height: "100%",
          overflow: "hidden",
          clipPath: "polygon(54% 0, 100% 0, 100% 100%, 54% 100%)",
          children: /* @__PURE__ */ b(da, { token: e.underlyingTokens[1], chainId: t })
        }
      )
    ] }) : /* @__PURE__ */ b(da, { token: e, chainId: t }),
    /* @__PURE__ */ K(ge, { flexDirection: "column", maxW: "100px", children: [
      /* @__PURE__ */ b(Le, { whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", children: t ? e == null ? void 0 : e.symbol : e == null ? void 0 : e.name }),
      ((n = e.underlyingTokens) == null ? void 0 : n.length) > 0 && /* @__PURE__ */ b(
        Le,
        {
          fontSize: "xs",
          color: "gray.500",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden",
          children: e.underlyingTokens.map((i) => i.symbol).join("/")
        }
      )
    ] }),
    e.type === "defi" && /* @__PURE__ */ K(ge, { direction: "column", ml: 2, children: [
      e.apy && /* @__PURE__ */ K(Pe, { fontSize: "xs", fontWeight: "medium", whiteSpace: "nowrap", children: [
        "APY",
        " ",
        /* @__PURE__ */ K(Le, { as: "span", fontWeight: "bold", children: [
          e.apy.toFixed(2),
          "%"
        ] })
      ] }),
      e.tvl && /* @__PURE__ */ K(Pe, { fontSize: "xs", fontWeight: "medium", whiteSpace: "nowrap", children: [
        "TVL",
        " ",
        /* @__PURE__ */ b(Le, { as: "span", fontWeight: "bold", children: rM(e.tvl) })
      ] })
    ] })
  ] });
}, LM = ({ chainId: e }) => {
  const r = Uv().find((i) => i.id === e), n = `https://icons-ckg.pages.dev/stargate-light/networks/${Tw[e]}.svg`;
  return /* @__PURE__ */ b(Pe, { borderRadius: "50%", overflow: "hidden", minW: "28px", minH: "28px", children: /* @__PURE__ */ b(
    "img",
    {
      src: n,
      title: (r == null ? void 0 : r.name) || "Unknown Chain",
      alt: (r == null ? void 0 : r.name) || "Unknown Chain",
      width: "28px",
      height: "28px"
    }
  ) });
}, Sm = Z(
  ({ chain: e }, t) => /* @__PURE__ */ K(ge, { align: "center", gap: 2, mr: 8, ref: t, borderRadius: "lg", children: [
    /* @__PURE__ */ b(LM, { chainId: e.id }),
    /* @__PURE__ */ b(Le, { fontWeight: "medium", whiteSpace: "nowrap", children: (e == null ? void 0 : e.name) || "Unknown Chain" })
  ] })
), VM = ({
  value: e,
  onChange: t,
  disabled: r
}) => {
  const n = Uv(), i = _e(() => {
    const o = n.filter(
      (s) => Object.values(Qt).includes(s.id)
    ).map((s) => ({
      id: s.id,
      name: s.name
    }));
    return Md({
      items: o,
      itemToValue: (s) => s.id.toString(),
      itemToString: (s) => s.name
    });
  }, [n]);
  return /* @__PURE__ */ K(
    Of,
    {
      variant: "outline",
      borderRadius: "xl",
      transition: "all 0.2s ease-in-out",
      disabled: r,
      collection: i,
      value: [e == null ? void 0 : e.toString()],
      onValueChange: ({ value: o }) => t(Number(o[0])),
      size: "md",
      w: "fit-content",
      minWidth: "180px",
      children: [
        /* @__PURE__ */ K(Ax, { children: [
          /* @__PURE__ */ b(Cf, { borderRadius: "xl", children: /* @__PURE__ */ b(If, { children: (o) => o[0] ? /* @__PURE__ */ b(Sm, { chain: o[0] }) : /* @__PURE__ */ b(Le, { whiteSpace: "nowrap", children: "Select chain" }) }) }),
          /* @__PURE__ */ b(Tx, { children: /* @__PURE__ */ b(Rx, {}) })
        ] }),
        /* @__PURE__ */ b(Ox, { children: /* @__PURE__ */ b(Px, { borderWidth: 1, borderRadius: "xl", bg: "bg", children: i.items.map((o) => /* @__PURE__ */ b(kf, { item: o, children: /* @__PURE__ */ b(Sm, { chain: o }) }, o.id.toString())) }) })
      ]
    }
  );
}, Vc = (e) => (e == null ? void 0 : e.slice(0, 1).toUpperCase()) + (e == null ? void 0 : e.slice(1)), Em = ({ logoUri: e }) => /* @__PURE__ */ b(
  Pe,
  {
    borderRadius: "50%",
    overflow: "hidden",
    width: "28px",
    height: "28px",
    minWidth: "28px",
    marginRight: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "gray.50",
    children: e && /* @__PURE__ */ b("img", { src: e, alt: "", width: "28px", height: "28px" })
  }
), zM = ({
  value: e,
  onChange: t,
  chainId: r,
  disabled: n,
  projectsFilter: i
}) => {
  const o = wM(r), s = _e(() => {
    var c, u;
    let a = o;
    ((c = i == null ? void 0 : i.include) == null ? void 0 : c.length) > 0 && (a = a == null ? void 0 : a.filter(
      (f) => i.include.includes(f.projectId)
    )), ((u = i == null ? void 0 : i.exclude) == null ? void 0 : u.length) > 0 && (a = a == null ? void 0 : a.filter(
      (f) => !i.exclude.includes(f.projectId)
    ));
    const l = a == null ? void 0 : a.sort(
      (f, d) => {
        var p;
        return (p = f.projectId) == null ? void 0 : p.localeCompare(d.projectId);
      }
    );
    return Md({
      items: l || [],
      itemToValue: (f) => f.projectId,
      itemToString: (f) => Vc(f.projectId)
    });
  }, [o, i]);
  return /* @__PURE__ */ K(
    Of,
    {
      variant: "outline",
      disabled: n,
      value: [e],
      onValueChange: ({ value: a }) => t(a[0]),
      size: "md",
      w: "fit-content",
      minWidth: "180px",
      transition: "all 0.2s ease-in-out",
      collection: s,
      children: [
        /* @__PURE__ */ K(Ax, { children: [
          /* @__PURE__ */ b(Cf, { maxWidth: "100%", borderRadius: "xl", children: /* @__PURE__ */ b(If, { placeholder: "Protocol (opt.)", children: ([a]) => {
            var l;
            return a ? /* @__PURE__ */ K(ge, { alignItems: "center", children: [
              /* @__PURE__ */ b(Em, { logoUri: (l = a == null ? void 0 : a.logosUri) == null ? void 0 : l[0] }),
              /* @__PURE__ */ b(Le, { whiteSpace: "nowrap", children: Vc(a == null ? void 0 : a.projectId) })
            ] }) : /* @__PURE__ */ b(ge, { alignItems: "center", children: /* @__PURE__ */ b(Le, { whiteSpace: "nowrap", children: "Select protocol (opt.)" }) });
          } }) }),
          /* @__PURE__ */ K(Tx, { children: [
            e && !n && /* @__PURE__ */ b(GF, {}),
            /* @__PURE__ */ b(Rx, {})
          ] })
        ] }),
        /* @__PURE__ */ b(Ox, { children: /* @__PURE__ */ b(
          Vw,
          {
            portalled: !1,
            borderWidth: 1,
            borderRadius: "xl",
            bg: "bg",
            children: s.items.map((a) => {
              var l;
              return /* @__PURE__ */ b(kf, { item: a, children: /* @__PURE__ */ K(ge, { alignItems: "center", children: [
                /* @__PURE__ */ b(Em, { logoUri: (l = a.logosUri) == null ? void 0 : l[0] }),
                Vc(a.projectId)
              ] }) }, a.slug);
            })
          }
        ) })
      ]
    }
  );
}, DM = () => /* @__PURE__ */ K(ge, { align: "center", gap: 2, children: [
  /* @__PURE__ */ b(vr, { height: "28px", width: "28px", borderRadius: "full" }),
  /* @__PURE__ */ b(ge, { flexDirection: "column", children: /* @__PURE__ */ b(vr, { height: "22px", width: "50px", mb: "2px" }) })
] }), MM = ({ token: e }) => /* @__PURE__ */ K(ge, { align: "center", w: "full", justifyContent: "space-between", children: [
  /* @__PURE__ */ b(zw, { token: e }),
  /* @__PURE__ */ K(ge, { flexDirection: "column", alignItems: "flex-end", children: [
    /* @__PURE__ */ b(
      Le,
      {
        color: "gray.400",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        maxWidth: "150px",
        title: e.symbol,
        children: `${e.balance ? Gi(Wr(e.balance, e.decimals)) : ""} ${e.symbol}`
      }
    ),
    /* @__PURE__ */ b(Le, { ml: 2, fontSize: "md", children: e.costUsd ? `$${e.costUsd.toFixed(2)}` : "" })
  ] })
] }), Cm = (e, t) => e.findIndex(
  (r) => {
    var n;
    return ((n = r.address) == null ? void 0 : n.toLocaleLowerCase()) === (t == null ? void 0 : t.toLocaleLowerCase());
  }
), km = (e, t, r) => {
  const n = new Set(t.map((i) => i.toLowerCase()));
  return e.filter((i) => {
    const o = n.has(i.address.toLowerCase());
    return r ? o : !o;
  });
}, BM = ({
  value: e,
  onChange: t,
  portalRef: r,
  obligatedToken: n,
  limitTokens: i,
  excludeTokens: o,
  chainId: s,
  setChainId: a,
  project: l,
  projectsFilter: c
}) => {
  const [u, f] = We(""), [d, p] = We(s), [g, h] = We(l), { data: m, isLoading: v } = yM(d), {
    data: y,
    isLoading: x,
    isFetched: S
  } = Nw(d), { tokens: _, isLoading: I } = ir({
    priorityChainId: d,
    project: g,
    enabled: !!g
  });
  Ce(() => {
    p(s);
  }, [s]);
  const O = _e(
    () => m == null ? void 0 : m.filter(
      (C) => !(y != null && y.find(
        (W) => W.address === C.token
      )) && +C.price > 0
    ).map((C) => C.token),
    [y, m]
  ), { tokens: w } = ir({
    address: O,
    priorityChainId: d,
    enabled: (O == null ? void 0 : O.length) > 0
  }), E = _e(
    () => g ? _ : [...w != null ? w : [], ...y != null ? y : []],
    [g, _, y, w]
  ), T = E != null && E.length && Cm(E, u) === -1 && !i ? u : void 0, {
    tokens: [G],
    isLoading: k
  } = ir({
    address: T,
    priorityChainId: d,
    enabled: Ze(T)
  }), {
    tokens: [j],
    isLoading: F
  } = ir({
    address: e,
    priorityChainId: d,
    enabled: Ze(e)
  });
  Ce(() => {
    h(l);
  }, [l, d]);
  const L = _e(() => {
    let C = E ? E.slice() : [];
    if (G && (C = [...C, G]), j) {
      const H = Cm(C, j.address);
      H !== -1 && C.splice(H, 1), C.unshift(j);
    }
    i && (C = km(C, i, !0)), o && (C = km(C, o, !1));
    const W = C.map((H) => {
      var X;
      let V = (X = m == null ? void 0 : m.find) == null ? void 0 : X.call(m, (ne) => ne.token === H.address);
      const Q = Number(V == null ? void 0 : V.amount).toLocaleString("fullwide", {
        useGrouping: !1
      });
      return V ? {
        ...H,
        balance: Q,
        costUsd: +Wr(Q, V == null ? void 0 : V.decimals) * +(V == null ? void 0 : V.price)
      } : H;
    });
    return W.sort((H, V) => {
      var Q, X;
      return ((Q = V.costUsd) != null ? Q : 0) - ((X = H.costUsd) != null ? X : 0);
    }), W;
  }, [
    m,
    w,
    E,
    G,
    j,
    i,
    o
  ]), D = _e(() => {
    let C = L;
    if (u) {
      const W = u.toLocaleLowerCase();
      C = L.filter(
        (H) => [H.symbol, H.name, H.address].some(
          (V) => V == null ? void 0 : V.toLocaleLowerCase().includes(W)
        )
      );
    }
    return Md({
      items: C,
      itemToValue: (W) => W.address,
      itemToString: (W) => W.symbol
    });
  }, [L, u]), N = lt(
    ({ value: C }) => {
      t(C[0]), a(d), p(d);
    },
    [t, d, a]
  ), B = _e(
    () => s === d ? [e] : [],
    [e, s, d]
  ), q = lt(
    ({ open: C }) => {
      (C || n || G) && f(""), p(s);
    },
    [n, G, f, s]
  ), P = I || x || k || F || !S;
  return /* @__PURE__ */ K(
    Of,
    {
      variant: "outline",
      disabled: !!n,
      collection: D,
      value: B,
      onValueChange: N,
      size: "md",
      w: "fit-content",
      onOpenChange: q,
      borderRadius: "xl",
      children: [
        /* @__PURE__ */ b(
          Cf,
          {
            borderRadius: "xl",
            w: "fit-content",
            maxWidth: "100%",
            transition: "all 0.2s ease-in-out",
            opacity: 1,
            css: {
              "& > button": {
                opacity: "1 !important"
              }
            },
            children: e ? /* @__PURE__ */ b(
              If,
              {
                placeholder: "Select token",
                width: "fit-content",
                maxWidth: "100%",
                children: (C) => P ? /* @__PURE__ */ b(DM, {}) : C[0] ? /* @__PURE__ */ b(
                  zw,
                  {
                    chainId: d,
                    token: C[0] || void 0
                  }
                ) : /* @__PURE__ */ b(Le, { whiteSpace: "nowrap", children: "Select token" })
              }
            ) : /* @__PURE__ */ b(Le, { whiteSpace: "nowrap", children: "Select Token" })
          }
        ),
        /* @__PURE__ */ b(
          Vw,
          {
            portalRef: r,
            w: "100%",
            minWidth: "300px",
            minHeight: "400px",
            borderWidth: 1,
            borderRadius: "xl",
            bg: "bg",
            children: /* @__PURE__ */ K(
              ge,
              {
                height: "100%",
                flexDirection: "column",
                gap: 2,
                p: 2,
                width: "100%",
                children: [
                  /* @__PURE__ */ K(ge, { justifyContent: "space-between", gap: 2, children: [
                    /* @__PURE__ */ b(
                      VM,
                      {
                        disabled: !!l,
                        value: d,
                        onChange: lt(
                          (C) => {
                            p(C);
                          },
                          [p]
                        )
                      }
                    ),
                    /* @__PURE__ */ b(
                      zM,
                      {
                        disabled: !!l,
                        value: g,
                        onChange: h,
                        chainId: d,
                        projectsFilter: c
                      }
                    )
                  ] }),
                  /* @__PURE__ */ b(Pe, { height: "36px", children: /* @__PURE__ */ b(
                    Zd,
                    {
                      paddingX: 2,
                      autoFocus: !0,
                      placeholder: "Search by name or paste address",
                      value: u,
                      onChange: (C) => n || f(C.target.value),
                      size: "sm",
                      borderRadius: "md"
                    }
                  ) }),
                  P && /* @__PURE__ */ b(ls, { gap: 3, width: "100%", padding: 2, children: [...Array(6)].map((C, W) => /* @__PURE__ */ K(
                    ge,
                    {
                      align: "center",
                      w: "full",
                      justifyContent: "space-between",
                      children: [
                        /* @__PURE__ */ K(ge, { align: "center", children: [
                          /* @__PURE__ */ b(
                            vr,
                            {
                              height: "24px",
                              width: "24px",
                              borderRadius: "full",
                              mr: 2
                            }
                          ),
                          /* @__PURE__ */ b(vr, { height: "20px", width: "80px" })
                        ] }),
                        /* @__PURE__ */ K(ge, { flexDirection: "column", alignItems: "flex-end", children: [
                          /* @__PURE__ */ b(vr, { height: "16px", width: "100px" }),
                          /* @__PURE__ */ b(vr, { height: "16px", width: "60px", mt: 1 })
                        ] })
                      ]
                    },
                    W
                  )) }),
                  /* @__PURE__ */ b(
                    NM,
                    {
                      height: 350,
                      itemCount: D.items.length,
                      itemSize: 48,
                      width: "100%",
                      children: ({ index: C, style: W }) => {
                        const H = D.items[C];
                        return /* @__PURE__ */ b(
                          kf,
                          {
                            item: H,
                            style: W,
                            borderRadius: "md",
                            children: /* @__PURE__ */ b(MM, { token: H })
                          },
                          H.address
                        );
                      }
                    }
                  )
                ]
              }
            )
          }
        )
      ]
    }
  );
}, Im = ({
  chainId: e,
  setChainId: t,
  tokenValue: r,
  tokenOnChange: n,
  inputValue: i,
  inputOnChange: o,
  usdValue: s,
  loading: a,
  disabled: l,
  portalRef: c,
  obligatedToken: u,
  limitTokens: f,
  excludeTokens: d,
  project: p,
  projects: g
}) => {
  var I;
  const { address: h } = Kr(), m = Lw(r, e), {
    tokens: [v]
  } = ir({
    address: r,
    enabled: !!Ze(r),
    priorityChainId: e
  }), [y, x] = We(""), S = SM(y, 400);
  Ce(() => {
    o(S);
  }, [S]), Ce(() => {
    x(i);
  }, [i]);
  const _ = Wr(m, (I = v == null ? void 0 : v.decimals) != null ? I : 18);
  return /* @__PURE__ */ b(
    ge,
    {
      bg: l ? void 0 : "bg.subtle",
      borderRadius: "xl",
      border: "solid 1px",
      borderColor: "border.subtle",
      p: 2,
      align: "center",
      w: "full",
      children: /* @__PURE__ */ K(Pe, { w: "full", children: [
        /* @__PURE__ */ b(ge, { w: "full", children: /* @__PURE__ */ b(Le, { fontSize: "sm", color: "fg.muted", height: "20px", children: (v == null ? void 0 : v.name) || " " }) }),
        /* @__PURE__ */ K(ge, { w: "full", children: [
          /* @__PURE__ */ b(
            BM,
            {
              project: p,
              projectsFilter: g,
              setChainId: t,
              chainId: e,
              limitTokens: f,
              excludeTokens: d,
              obligatedToken: u,
              portalRef: c,
              value: r,
              onChange: n
            }
          ),
          /* @__PURE__ */ b(
            ge,
            {
              alignItems: "center",
              justifyContent: "flex-end",
              w: "100%",
              h: "100%",
              children: a ? /* @__PURE__ */ b(vr, { h: "30px", w: 130, ml: 5 }) : /* @__PURE__ */ b(
                qe.input,
                {
                  css: {
                    "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
                      WebkitAppearance: "none"
                    }
                  },
                  h: "36px",
                  lineHeight: "100%",
                  type: "number",
                  disabled: l,
                  width: "full",
                  minWidth: "120px",
                  fontSize: "xl",
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  placeholder: "0.0",
                  ml: 1,
                  textAlign: "right",
                  value: y,
                  onChange: (O) => x(O.target.value)
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ K(ge, { justifyContent: "space-between", fontSize: "sm", children: [
          /* @__PURE__ */ K(
            ge,
            {
              gap: 1,
              alignItems: "center",
              visibility: h ? "visible" : "hidden",
              children: [
                /* @__PURE__ */ K(Le, { fontSize: "sm", color: "fg.muted", whiteSpace: "nowrap", children: [
                  "Balance: ",
                  Gi(_)
                ] }),
                /* @__PURE__ */ b(
                  cn,
                  {
                    _hover: {
                      bg: "bg.subtle",
                      borderColor: "border.emphasized"
                    },
                    size: "xs",
                    color: "fg.muted",
                    ml: 1,
                    px: 2,
                    h: "18px",
                    fontSize: "xs",
                    variant: "outline",
                    display: h && !l ? void 0 : "none",
                    onClick: () => o(
                      Wr(m, v == null ? void 0 : v.decimals).toString()
                    ),
                    children: "Max"
                  }
                )
              ]
            }
          ),
          s ? /* @__PURE__ */ K(Le, { color: "gray.500", children: [
            "~",
            Ef(s)
          ] }) : null
        ] })
      ] })
    }
  );
};
var Dw = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Om = xr.createContext && /* @__PURE__ */ xr.createContext(Dw), WM = ["attr", "size", "title"];
function HM(e, t) {
  if (e == null) return {};
  var r = jM(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function jM(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function qa() {
  return qa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, qa.apply(this, arguments);
}
function Pm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ka(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pm(Object(r), !0).forEach(function(n) {
      UM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Pm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function UM(e, t, r) {
  return t = GM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function GM(e) {
  var t = qM(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function qM(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Mw(e) {
  return e && e.map((t, r) => /* @__PURE__ */ xr.createElement(t.tag, Ka({
    key: r
  }, t.attr), Mw(t.child)));
}
function Ll(e) {
  return (t) => /* @__PURE__ */ xr.createElement(KM, qa({
    attr: Ka({}, e.attr)
  }, t), Mw(e.child));
}
function KM(e) {
  var t = (r) => {
    var {
      attr: n,
      size: i,
      title: o
    } = e, s = HM(e, WM), a = i || r.size || "1em", l;
    return r.className && (l = r.className), e.className && (l = (l ? l + " " : "") + e.className), /* @__PURE__ */ xr.createElement("svg", qa({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, r.attr, n, s, {
      className: l,
      style: Ka(Ka({
        color: e.color || r.color
      }, r.style), e.style),
      height: a,
      width: a,
      xmlns: "http://www.w3.org/2000/svg"
    }), o && /* @__PURE__ */ xr.createElement("title", null, o), e.children);
  };
  return Om !== void 0 ? /* @__PURE__ */ xr.createElement(Om.Consumer, null, (r) => t(r)) : t(Dw);
}
function YM(e) {
  return Ll({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M20 6 9 17l-5-5" }, child: [] }] })(e);
}
function XM(e) {
  return Ll({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "rect", attr: { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }, child: [] }, { tag: "path", attr: { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }, child: [] }] })(e);
}
function JM(e) {
  return Ll({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }, child: [] }, { tag: "path", attr: { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" }, child: [] }] })(e);
}
function ZM(e) {
  return Ll({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M18 6 6 18" }, child: [] }, { tag: "path", attr: { d: "m6 6 12 12" }, child: [] }] })(e);
}
const Bw = ie.forwardRef(function(t, r) {
  var n;
  return /* @__PURE__ */ b(Yd, { variant: "ghost", "aria-label": "Close", ref: r, ...t, children: (n = t.children) != null ? n : /* @__PURE__ */ b(ZM, {}) });
}), QM = ie.forwardRef(
  function(t, r) {
    const { loading: n, disabled: i, loadingText: o, children: s, ...a } = t;
    return /* @__PURE__ */ b(cn, { disabled: n || i, ref: r, ...a, children: n && !o ? /* @__PURE__ */ K(wi, { children: [
      /* @__PURE__ */ b(vl, { display: "inline-flex", children: /* @__PURE__ */ b(Oa, { size: "inherit", color: "inherit" }) }),
      /* @__PURE__ */ b(bo, { opacity: 0, children: s })
    ] }) : n && o ? /* @__PURE__ */ K(wi, { children: [
      /* @__PURE__ */ b(Oa, { size: "inherit", color: "inherit" }),
      o
    ] }) : s });
  }
), e3 = ie.forwardRef(function(t, r) {
  const { trackColor: n, cap: i, color: o, ...s } = t;
  return /* @__PURE__ */ K(DF, { ...s, ref: r, children: [
    /* @__PURE__ */ b(MF, { stroke: n }),
    /* @__PURE__ */ b(BF, { stroke: o, strokeLinecap: i })
  ] });
});
ie.forwardRef(function(t, r) {
  return /* @__PURE__ */ b(vl, { children: /* @__PURE__ */ b(WF, { ...t, ref: r }) });
});
const t3 = zF;
var rt = /* @__PURE__ */ ((e) => (e.Success = "success", e.Error = "error", e.Info = "info", e.Loading = "loading", e.Warning = "warning", e.Blocked = "blocked", e))(rt || {}), Tn = /* @__PURE__ */ ((e) => (e[e.TokenIn = 0] = "TokenIn", e[e.TokenOut = 1] = "TokenOut", e))(Tn || {});
const r3 = {
  [rt.Success]: "green.500",
  [rt.Error]: "red.400",
  [rt.Info]: "blue.400",
  [rt.Loading]: "blue.400",
  [rt.Warning]: "yellow.400"
}, n3 = {
  [rt.Success]: K5,
  [rt.Error]: Y5,
  [rt.Info]: Z5,
  [rt.Warning]: q_,
  [rt.Blocked]: eV
}, i3 = (e) => {
  if (e === rt.Loading)
    return /* @__PURE__ */ b(bl, { w: "96px", h: "96px", children: /* @__PURE__ */ b(t3, { value: null, size: "xl", colorPalette: "blue", children: /* @__PURE__ */ b(e3, {}) }) });
  const t = n3[e];
  return /* @__PURE__ */ b(Pe, { color: r3[e], children: /* @__PURE__ */ b(t, { size: 96 }) });
}, o3 = () => {
  const e = rr((n) => n.notification), t = rr((n) => n.setNotification);
  if (!e) return null;
  const r = () => t(void 0);
  return /* @__PURE__ */ b(bl, { w: "full", h: "full", children: /* @__PURE__ */ K(
    ge,
    {
      width: "95%",
      height: "95%",
      p: 5,
      boxShadow: "lg",
      zIndex: 1e3,
      flexDirection: "column",
      bg: "bg.subtle",
      children: [
        e.variant !== rt.Blocked && /* @__PURE__ */ b(
          Bw,
          {
            position: "absolute",
            top: 10,
            right: 5,
            onClick: r,
            mr: 5
          }
        ),
        /* @__PURE__ */ K(
          ge,
          {
            flexDirection: "column",
            width: "full",
            height: "full",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            children: [
              i3(e.variant),
              /* @__PURE__ */ b(
                Le,
                {
                  fontSize: e.variant === rt.Warning ? "lg" : "xl",
                  children: e.message
                }
              ),
              e.variant !== rt.Blocked && /* @__PURE__ */ b(QM, { mt: 5, w: 200, colorPalette: "black", onClick: r, children: "Close" }),
              e.link && /* @__PURE__ */ K(mu, { href: e.link, target: "_blank", color: "fg.muted", children: [
                "View details",
                /* @__PURE__ */ b(X5, { size: 14 })
              ] })
            ]
          }
        )
      ]
    }
  ) });
}, Ww = ie.forwardRef(function(t, r) {
  return /* @__PURE__ */ b(Jd, { copied: /* @__PURE__ */ b(YM, {}), ...t, ref: r, children: /* @__PURE__ */ b(XM, {}) });
}), Pf = ie.forwardRef(function(t, r) {
  return /* @__PURE__ */ b(Jd, { copied: "Copied", ...t, ref: r, children: "Share" });
});
ie.forwardRef(function(t, r) {
  return /* @__PURE__ */ b(
    kF,
    {
      textStyle: "sm",
      fontWeight: "medium",
      display: "inline-block",
      mb: "1",
      ...t,
      ref: r
    }
  );
});
ie.forwardRef(
  function(t, r) {
    return /* @__PURE__ */ b(Xd, { asChild: !0, children: /* @__PURE__ */ K(cn, { ref: r, size: "sm", variant: "surface", ...t, children: [
      /* @__PURE__ */ b(Ww, {}),
      /* @__PURE__ */ b(Pf, {})
    ] }) });
  }
);
const s3 = ie.forwardRef(
  function(t, r) {
    return /* @__PURE__ */ b(Xd, { asChild: !0, children: /* @__PURE__ */ K(
      cn,
      {
        unstyled: !0,
        variant: "plain",
        size: "xs",
        display: "inline-flex",
        alignItems: "center",
        gap: "2",
        ref: r,
        ...t,
        children: [
          /* @__PURE__ */ b(JM, {}),
          /* @__PURE__ */ b(Pf, {})
        ]
      }
    ) });
  }
);
ie.forwardRef(function(t, r) {
  return /* @__PURE__ */ b(Xd, { asChild: !0, children: /* @__PURE__ */ K(Yd, { ref: r, size: "xs", variant: "subtle", ...t, children: [
    /* @__PURE__ */ b(Ww, {}),
    /* @__PURE__ */ b(Pf, { srOnly: !0 })
  ] }) });
});
ie.forwardRef(
  function(t, r) {
    return /* @__PURE__ */ b(CF, { asChild: !0, children: /* @__PURE__ */ b(Zd, { ref: r, ...t }) });
  }
);
const a3 = EF, Hw = ({
  address: e,
  chainId: t
}) => {
  var s;
  const [r] = wf(e), {
    tokens: [n]
  } = ir({
    address: e,
    enabled: !!Ze(e),
    priorityChainId: t
  }), i = (s = n == null ? void 0 : n.symbol) != null ? s : r == null ? void 0 : r.symbol, o = n == null ? void 0 : n.logoURI;
  return /* @__PURE__ */ b(
    Pe,
    {
      p: 0.5,
      borderRadius: "full",
      transition: "all 0.2s",
      _hover: { transform: "scale(1.05)" },
      children: /* @__PURE__ */ b(da, { token: { logoURI: o, symbol: i }, chainId: t })
    }
  );
}, Tm = ({ step: e }) => /* @__PURE__ */ K(Nx, { gap: 0, children: [
  /* @__PURE__ */ K(Pa, { minW: "50px", maxW: "100px", gap: 0, children: [
    /* @__PURE__ */ b(
      vF,
      {
        colorPalette: e.action === "bridge" ? "purple" : "blue",
        px: 1,
        py: 0.5,
        borderRadius: "md",
        fontSize: "2xs",
        fontWeight: "medium",
        textTransform: "capitalize",
        children: e.protocol
      }
    ),
    /* @__PURE__ */ b(
      Le,
      {
        color: "fg.muted",
        fontSize: "2xs",
        fontWeight: "normal",
        cursor: "default",
        children: e.action
      }
    ),
    /* @__PURE__ */ b(
      Pe,
      {
        color: e.action === "bridge" ? "purple.400" : "fg.muted",
        p: 0.5,
        borderRadius: "sm",
        bg: "bg.subtle",
        transition: "all 0.2s",
        _hover: { color: "fg", bg: "bg.emphasized" },
        children: /* @__PURE__ */ b(q5, { size: 10 })
      }
    )
  ] }),
  /* @__PURE__ */ b(Pa, { gap: 0, children: e.tokenOut.map((t, r) => /* @__PURE__ */ b(
    Hw,
    {
      address: t,
      chainId: e.action === "bridge" ? e.destinationChainId : e.chainId
    },
    r
  )) })
] }), l3 = ({
  route: e,
  loading: t
}) => /* @__PURE__ */ b(ge, { w: "full", justifyContent: "center", minHeight: "75px", py: 1, children: t ? /* @__PURE__ */ b(vr, { h: "full", w: "150px", borderRadius: "lg" }) : (e == null ? void 0 : e.length) > 0 && /* @__PURE__ */ b(
  Pe,
  {
    border: "1px solid",
    borderColor: "border.emphasized",
    borderRadius: "lg",
    bg: "bg.surface",
    p: 2,
    _hover: { shadow: "sm" },
    transition: "all 0.3s",
    maxW: "full",
    overflow: "auto",
    children: /* @__PURE__ */ b(Nx, { alignItems: "center", flexWrap: "nowrap", gap: 0, children: e.reduce((r, n, i) => {
      var o, s;
      return i === 0 && r.push(
        /* @__PURE__ */ b(Pa, { gap: 0, children: (o = n.tokenIn) == null ? void 0 : o.map((a, l) => /* @__PURE__ */ b(
          Hw,
          {
            address: a,
            chainId: n.chainId
          },
          l
        )) })
      ), r.push(
        /* @__PURE__ */ b(Pe, { children: n.action === "split" ? /* @__PURE__ */ b(Pa, { children: (s = n.internalRoutes) == null ? void 0 : s.map(([a], l) => /* @__PURE__ */ b(
          Tm,
          {
            step: {
              ...a,
              chainId: n.chainId,
              tokenOut: n.internalRoutes.length === 1 && n.tokenOut || a.tokenOut
            }
          },
          l
        )) }) : /* @__PURE__ */ b(Tm, { step: n }) }, `route-segment-${i}`)
      ), r;
    }, []) })
  }
) }), Rm = ie.forwardRef(
  function(t, r) {
    const {
      showArrow: n,
      children: i,
      disabled: o,
      portalled: s,
      content: a,
      contentProps: l,
      portalRef: c,
      ...u
    } = t;
    return o ? i : /* @__PURE__ */ K(u$, { ...u, children: [
      /* @__PURE__ */ b(d$, { asChild: !0, children: i }),
      /* @__PURE__ */ b(gl, { disabled: !s, container: c, children: /* @__PURE__ */ b(f$, { children: /* @__PURE__ */ K(h$, { ref: r, ...l, children: [
        n && /* @__PURE__ */ b(p$, { children: /* @__PURE__ */ b($x, {}) }),
        a
      ] }) }) })
    ] });
  }
), c3 = ie.forwardRef(function(t, r) {
  const { portalled: n = !0, portalRef: i, ...o } = t;
  return /* @__PURE__ */ b(gl, { disabled: !n, container: i, children: /* @__PURE__ */ b(NF, { children: /* @__PURE__ */ b(FF, { ref: r, ...o }) }) });
}), u3 = ie.forwardRef(function(t, r) {
  return /* @__PURE__ */ b($F, { ...t, ref: r, children: /* @__PURE__ */ b(Cx, {}) });
});
ie.forwardRef(function(t, r) {
  return /* @__PURE__ */ b(
    LF,
    {
      position: "absolute",
      top: "1",
      insetEnd: "1",
      ...t,
      asChild: !0,
      ref: r,
      children: /* @__PURE__ */ b(Bw, { size: "sm" })
    }
  );
});
const d3 = RF, f3 = VF, h3 = AF, p3 = ie.forwardRef(
  function(t, r) {
    const {
      startElement: n,
      startElementProps: i,
      endElement: o,
      endElementProps: s,
      children: a,
      startOffset: l = "6px",
      endOffset: c = "6px",
      ...u
    } = t, f = ie.Children.only(a);
    return /* @__PURE__ */ K(gF, { ref: r, ...u, children: [
      n && /* @__PURE__ */ b(Rp, { pointerEvents: "none", ...i, children: n }),
      ie.cloneElement(f, {
        ...n && {
          ps: `calc(var(--input-height) - ${l})`
        },
        ...o && { pe: `calc(var(--input-height) - ${c})` },
        ...a.props
      }),
      o && /* @__PURE__ */ b(Rp, { placement: "end", ...s, children: o })
    ] });
  }
), g3 = ({
  slippage: e,
  setSlippage: t
}) => {
  const [r, n] = We(""), i = _e(() => {
    const a = parseFloat(r);
    if (!isNaN(a) && a > 0 && a <= 100) return a;
  }, [r]);
  Ce(() => {
    i && t(Math.round(i * 100));
  }, [i]);
  const o = (a) => {
    const l = a.replace(/[^\d.]/g, "");
    n(l);
  }, s = (a) => {
    t(a), n("");
  };
  return /* @__PURE__ */ K(d3, { children: [
    /* @__PURE__ */ b(h3, { asChild: !0, children: /* @__PURE__ */ K(
      ge,
      {
        gap: 1,
        alignItems: "center",
        cursor: "pointer",
        w: "170px",
        _hover: {
          textDecoration: "underline"
        },
        children: [
          /* @__PURE__ */ K(Pe, { color: "gray.500", fontSize: "xs", children: [
            "Slippage tolerance: ",
            e / 100,
            "%"
          ] }),
          /* @__PURE__ */ b(Q5, { size: 10 })
        ]
      }
    ) }),
    /* @__PURE__ */ K(c3, { bg: "bg.subtle", children: [
      /* @__PURE__ */ b(u3, {}),
      /* @__PURE__ */ K(f3, { p: 2, children: [
        /* @__PURE__ */ b(ge, { gap: 1, children: [
          { value: 10, label: "0.1%" },
          { value: 25, label: "0.25%" },
          { value: 50, label: "0.5%" },
          { value: 100, label: "1%" }
        ].map(({ value: a, label: l }) => /* @__PURE__ */ b(
          Pe,
          {
            onClick: () => s(a),
            padding: 2,
            flex: 1,
            border: "1px solid",
            borderColor: "border.emphasized",
            backgroundColor: e === a ? "bg" : "transparent",
            borderRadius: "lg",
            cursor: "pointer",
            children: l
          },
          a
        )) }),
        /* @__PURE__ */ K(Pe, { mt: 3, children: [
          /* @__PURE__ */ b(p3, { endElement: "%", children: /* @__PURE__ */ b(
            Zd,
            {
              borderColor: !i && r ? "red.500" : "inherit",
              value: r,
              onChange: (a) => o(a.target.value),
              placeholder: "Custom"
            }
          ) }),
          i && i > 1 && /* @__PURE__ */ b(Pe, { color: "orange.500", fontSize: "xs", mt: 1, children: "Slippage tolerance above 1% could lead to an unfavorable rate." })
        ] })
      ] })
    ] })
  ] });
}, m3 = ({
  gasValue: e,
  chainId: t
}) => {
  var o;
  const { data: r } = Qu(Be, t), {
    tokens: [n]
  } = ir({
    address: Be,
    priorityChainId: t,
    enabled: !!t
  }), i = +e * +((o = r == null ? void 0 : r.price) != null ? o : 0);
  return /* @__PURE__ */ K(
    Le,
    {
      title: "Bridging fee",
      cursor: "default",
      display: "flex",
      alignItems: "center",
      gap: 1,
      color: "gray.500",
      fontSize: "xs",
      children: [
        /* @__PURE__ */ b(J5, { size: 12 }),
        Gi(e, !0),
        " ",
        n == null ? void 0 : n.symbol,
        ",",
        " ",
        Ef(i)
      ]
    }
  );
}, v3 = ({
  tokenOut: e,
  tokenIn: t,
  obligateSelection: r,
  enableShare: n,
  indicateRoute: i,
  adaptive: o,
  rotateObligated: s,
  outProject: a,
  outProjects: l,
  inProjects: c,
  outTokens: u,
  inTokens: f,
  onChange: d,
  notificationPlacement: p,
  onSuccess: g,
  referralCode: h
}) => {
  var Nf, Ff, $f, Lf, Vf;
  const [m, v] = We(), [y, x] = We(""), [S, _] = We(!1), [I, O] = We(), [w, E] = We($D), [T, G] = We(
    r && (s != null ? s : Tn.TokenOut)
  ), k = jt(), { chainId: j, address: F } = Kr(), L = rr((Te) => Te.setTokenOutChainId), D = rr((Te) => {
    var Nt;
    return (Nt = Te.tokenOutChainId) != null ? Nt : k;
  }), N = rr((Te) => Te.obligatedChainId), { switchChain: B } = oS(), { open: q, onToggle: P } = JC({
    defaultOpen: !0
  }), C = rr((Te) => Te.setNotification), W = rr((Te) => Te.setObligatedChainId), {
    tokens: [H]
  } = ir({
    address: m,
    enabled: Ze(m)
  }), {
    tokens: [V]
  } = ir({
    address: I,
    priorityChainId: D,
    enabled: Ze(I)
  }), Q = lt(
    (Te) => {
      W(Te), k === j && B({ chainId: Te }), I || L(Te);
    },
    [j, k, B, I]
  );
  Ce(() => {
    d == null || d({
      tokenIn: m,
      tokenOut: I,
      chainId: k,
      outChainId: D
    });
  }, [m, I, k, D]), Ce(() => {
    var Te;
    t ? v(t) : !m && !((Te = f == null ? void 0 : f.exclude) != null && Te.includes(Be)) && v(Be);
  }, [t]), Ce(() => {
    e && O(e);
  }, [e]), Ce(() => {
    _(!1);
  }, [m, I]), Ce(() => {
    N && N !== k && k === j && B({ chainId: N });
  }, [N, k, j, B]);
  const X = ZD(y, H == null ? void 0 : H.decimals), ne = lt((Te, Nt) => {
    g == null || g(Te, Nt), x("");
  }, []), {
    data: R,
    isLoading: M,
    isFetching: z,
    sendTransaction: Y,
    error: U
  } = bM(
    X,
    m,
    I,
    w,
    h,
    ne
  ), se = Wr(
    R == null ? void 0 : R.amountOut.toString(),
    V == null ? void 0 : V.decimals
  ), we = mM(m, X), ze = pM(
    m,
    (Nf = we.data) == null ? void 0 : Nf.spender,
    X
  ), Ye = Lw(m, k), At = +X <= +(Ye != null ? Ye : 0), Jr = !!(ze && m) && At, lr = k && +j != +k, Tr = at(null), Yn = +se / +y, { data: Zr } = Qu(m), { data: Xn } = Qu(I, D), cr = +((Ff = Zr == null ? void 0 : Zr.price) != null ? Ff : 0) * +y, hs = +(($f = Xn == null ? void 0 : Xn.price) != null ? $f : 0) * +Wr((Lf = R == null ? void 0 : R.amountOut) == null ? void 0 : Lf.toString(), V == null ? void 0 : V.decimals), qi = _e(() => {
    const Te = R == null ? void 0 : R.priceImpact;
    if (typeof Te == "number")
      return Te;
    if (cr > 0 && hs >= 0 && (R != null && R.amountOut)) {
      let Nt = (cr - hs) / cr * 1e4;
      return Nt = Math.max(0, Nt), Nt;
    }
  }, [R, cr, hs]);
  Ce(() => {
    ND.includes(e) ? C({
      variant: rt.Blocked,
      message: "Go direct to Uniswap interface",
      link: "https://app.uniswap.org/swap?outputCurrency=" + e
    }) : hm[e] && C({
      variant: rt.Blocked,
      message: "Go direct to Uniswap interface",
      link: hm[e]
    });
  }, [e, C]);
  const ps = typeof qi == "number" && qi >= FD, jw = ps && !S, Vl = cr > fm[I], Tf = !!ze || lr || !(+(R == null ? void 0 : R.amountOut) > 0) || Vl || !At, Rf = _e(() => Vl ? `Due to insufficient underlying liquidity, trade sizes are restricted to ${Ef(fm[I])}.  You can do multiple transactions of this size.` : At ? lr ? "Please switch to the correct chain" : Jr ? "Please approve the token first" : "" : "Balance is not enough to perform transaction", [
    Vl,
    At,
    lr,
    Jr,
    Tf,
    I
  ]), Af = qi ? (-qi / 100).toFixed(2) : "0.00", zl = ps ? `High price impact (${Af}%). Due to the amount of ${V == null ? void 0 : V.symbol} liquidity currently available, the more ${H == null ? void 0 : H.symbol} you try to swap, the less ${V == null ? void 0 : V.symbol} you will receive.` : "", Uw = lt(() => {
    C({
      message: zl,
      variant: rt.Warning
    }), _(!0);
  }, [zl, C]), Gw = k === BV.id && (V == null ? void 0 : V.symbol) === "UNI-V2", qw = !r || s || typeof s == "number", Kw = _e(() => {
    var Nt;
    let Te = +((Nt = R == null ? void 0 : R.tx.value) != null ? Nt : 0);
    return m === Be && (Te -= +X), Wr(Math.max(0, Te).toString(), 18);
  }, [(Vf = R == null ? void 0 : R.tx) == null ? void 0 : Vf.value, m, X]), Yw = !!(k !== D && D);
  return /* @__PURE__ */ K(
    Pe,
    {
      position: "relative",
      width: o ? { base: "100%", md: "450px" } : "100%",
      children: [
        /* @__PURE__ */ b(
          ge,
          {
            ref: Tr,
            position: "absolute",
            css: {
              '&:has(> div:not([data-state="closed"]))': {
                zIndex: 1e3
              },
              zIndex: -1,
              top: 0,
              bottom: 0,
              margin: "auto",
              left: 0,
              right: 0
            },
            children: /* @__PURE__ */ b(o3, {})
          }
        ),
        /* @__PURE__ */ K(ge, { flexDirection: "column", p: 3, overflow: "hidden", gap: 1, children: [
          /* @__PURE__ */ b(
            Im,
            {
              chainId: k,
              projects: c,
              setChainId: Q,
              limitTokens: Gw && LD,
              excludeTokens: f == null ? void 0 : f.exclude,
              obligatedToken: T === Tn.TokenIn,
              portalRef: Tr,
              tokenValue: m,
              tokenOnChange: v,
              inputValue: y,
              inputOnChange: x,
              usdValue: cr
            }
          ),
          qw && /* @__PURE__ */ b(ge, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ b(
            Yd,
            {
              bg: "bg.muted",
              _hover: { bg: "bg.subtle" },
              color: "fg.muted",
              borderRadius: "full",
              marginY: -5,
              zIndex: 1,
              boxShadow: "xs",
              size: "xs",
              onClick: () => {
                const Te = m;
                r && G(
                  (Xw) => Xw === Tn.TokenIn ? Tn.TokenOut : Tn.TokenIn
                );
                const Nt = k;
                W(D), L(Nt), v(I), O(Te), x(se);
              },
              children: /* @__PURE__ */ b(G5, {})
            }
          ) }),
          /* @__PURE__ */ b(
            Im,
            {
              disabled: !0,
              project: a,
              projects: l,
              chainId: D,
              setChainId: L,
              limitTokens: u == null ? void 0 : u.include,
              excludeTokens: u == null ? void 0 : u.exclude,
              obligatedToken: T === Tn.TokenOut,
              loading: M || z,
              portalRef: Tr,
              tokenValue: I,
              tokenOnChange: O,
              inputValue: se == null ? void 0 : se.toString(),
              inputOnChange: () => {
              },
              usdValue: hs
            }
          ),
          /* @__PURE__ */ b(Pe, { children: /* @__PURE__ */ K(ge, { justify: "space-between", alignItems: "center", children: [
            /* @__PURE__ */ K(ge, { flexDirection: "column", justify: "start", children: [
              /* @__PURE__ */ K(
                Le,
                {
                  color: "gray.500",
                  fontSize: "xs",
                  whiteSpace: "nowrap",
                  w: "fit-content",
                  children: [
                    "1 ",
                    H == null ? void 0 : H.symbol,
                    " = ",
                    Gi(Yn, !0),
                    " ",
                    V == null ? void 0 : V.symbol
                  ]
                }
              ),
              Yw && /* @__PURE__ */ b(m3, { gasValue: Kw, chainId: k }),
              /* @__PURE__ */ b(g3, { slippage: w, setSlippage: E })
            ] }),
            typeof qi == "number" && /* @__PURE__ */ b(ge, { children: /* @__PURE__ */ K(
              ge,
              {
                color: ps ? "orange.400" : "gray.500",
                fontSize: "sm",
                gap: 1,
                alignItems: "center",
                cursor: "default",
                children: [
                  "Price impact: ",
                  Af,
                  "%",
                  ps && /* @__PURE__ */ b(Rm, { openDelay: 0, content: zl, children: /* @__PURE__ */ b(q_, { size: 16 }) })
                ]
              }
            ) })
          ] }) }),
          F ? /* @__PURE__ */ K(ge, { w: "full", gap: 4, children: [
            lr ? /* @__PURE__ */ K(
              cn,
              {
                size: "lg",
                borderRadius: "lg",
                colorPalette: "blue",
                onClick: () => B({ chainId: k }),
                children: [
                  "Switch to ",
                  JD(k)
                ]
              }
            ) : Jr && /* @__PURE__ */ b(
              cn,
              {
                size: "lg",
                borderRadius: "lg",
                colorPalette: "blue",
                flex: 1,
                loading: ze.isPending,
                onClick: ze.write,
                children: "Approve"
              }
            ),
            /* @__PURE__ */ b(Rm, { content: Rf, disabled: !Rf, children: /* @__PURE__ */ b(
              cn,
              {
                size: "lg",
                borderRadius: "lg",
                colorPalette: "blue",
                flex: 1,
                disabled: Tf,
                loading: Y.isPending || M || z,
                onClick: jw ? Uw : Y.sendTransaction,
                children: k === D ? "Swap" : "Bridge"
              }
            ) })
          ] }) : /* @__PURE__ */ b(ge, { justifyContent: "center", alignItems: "center", w: "full", mt: 2, children: /* @__PURE__ */ b(Le, { color: "gray.500", fontSize: "xs", mt: 1, children: "Please connect your wallet" }) }),
          U && /* @__PURE__ */ b(Le, { color: "red.500", fontSize: "xs", mt: 1, children: !!U.message && _D }),
          i && /* @__PURE__ */ K(Pe, { children: [
            /* @__PURE__ */ b(ge, { color: "gray.500", children: /* @__PURE__ */ K(
              Le,
              {
                textDecoration: "dotted",
                _hover: { textDecoration: "underline" },
                cursor: "pointer",
                fontSize: "xs",
                onClick: P,
                whiteSpace: "nowrap",
                children: [
                  q ? "Hide" : "Show",
                  " route"
                ]
              }
            ) }),
            q && /* @__PURE__ */ b(
              l3,
              {
                route: R == null ? void 0 : R.route,
                loading: M
              }
            )
          ] }),
          /* @__PURE__ */ K(ge, { w: "100%", children: [
            n && /* @__PURE__ */ b(Pe, { color: "gray.500", children: /* @__PURE__ */ b(a3, { value: window.location.href, position: "absolute", children: /* @__PURE__ */ b(s3, { textStyle: "xs", cursor: "pointer" }) }) }),
            /* @__PURE__ */ b(bl, { w: "full", children: /* @__PURE__ */ K(Le, { color: "gray.500", fontSize: "sm", children: [
              "Powered by",
              " ",
              /* @__PURE__ */ b(
                mu,
                {
                  target: "_blank",
                  href: "https://www.enso.build/",
                  color: "fg.muted",
                  children: "Enso"
                }
              ),
              " ",
              "and",
              " ",
              /* @__PURE__ */ b(
                mu,
                {
                  target: "_blank",
                  href: "https://stargate.finance/",
                  color: "fg.muted",
                  children: "Stargate"
                }
              )
            ] }) })
          ] })
        ] }),
        /* @__PURE__ */ b(WV, { placement: p })
      ]
    }
  );
}, Bs = ":host", U3 = ({
  apiKey: e,
  tokenOut: t,
  tokenIn: r,
  chainId: n,
  outChainId: i,
  themeConfig: o,
  enableShare: s,
  obligateSelection: a,
  indicateRoute: l,
  adaptive: c,
  rotateObligated: u,
  outProject: f,
  outProjects: d,
  inProjects: p,
  outTokens: g,
  inTokens: h,
  onChange: m,
  onSuccess: v,
  notificationPlacement: y,
  referralCode: x
}) => {
  const [S, _] = We(null), [I, O] = We(
    null
  ), w = Yo(sS);
  Ce(() => {
    w || console.error(
      "Wagmi context is not available. Ensure you are using the EVMProvider."
    );
  }, [w]), Ce(() => {
    if (!(S != null && S.shadowRoot) || I) return;
    const k = ad({
      key: "root",
      container: S.shadowRoot
    });
    O(k);
  }, [S, I]);
  const E = rr((k) => k.setObligatedChainId), T = rr((k) => k.setTokenOutChainId), G = _e(
    () => {
      var k;
      return vx(gu, o || {}, {
        cssVarsRoot: Bs,
        preflight: { scope: Bs },
        conditions: {
          light: `${Bs} &, .light &`
        },
        globalCss: {
          [Bs]: {
            ...(k = gu.globalCss) == null ? void 0 : k.html,
            borderRadius: "xl",
            shadow: "sm",
            border: "none"
          }
        }
      });
    },
    [o]
  );
  return Ce(() => {
    n && E(n);
  }, [n, E]), Ce(() => {
    i && T(i);
  }, [i, T]), Ce(() => {
    A5.init("phc_w7nnXuFCFpuhrXLAAHrOrlr7Z0AAFHE79JybZ4bUabk", {
      api_host: "https://eu.i.posthog.com",
      person_profiles: "always"
      // or 'always' to create profiles for anonymous users as well
    }), e ? gM(e) : alert("Provide Enso API key to the widget");
  }, []), /* @__PURE__ */ b(W5.div, { ref: _, children: S && I && /* @__PURE__ */ b(hP, { value: () => {
    var k;
    return (k = S.shadowRoot) != null ? k : document;
  }, children: /* @__PURE__ */ b(ib, { value: I, children: /* @__PURE__ */ K(I1, { value: G, children: [
    /* @__PURE__ */ b(nM, {}),
    /* @__PURE__ */ b(
      v3,
      {
        onSuccess: v,
        notificationPlacement: y,
        outProject: f,
        rotateObligated: u,
        indicateRoute: l,
        obligateSelection: a,
        tokenIn: r == null ? void 0 : r.toLowerCase(),
        tokenOut: t == null ? void 0 : t.toLowerCase(),
        enableShare: s,
        adaptive: c,
        outProjects: d,
        inProjects: p,
        outTokens: g,
        inTokens: h,
        onChange: m,
        referralCode: x
      }
    )
  ] }) }) }) });
};
export {
  U3 as Widget,
  U3 as default
};
//# sourceMappingURL=shortcuts-widget.es.js.map
